import { jsx as g, jsxs as F, Fragment as Ht } from "react/jsx-runtime";
import { c as W, a as oe, b as ae } from "./utils-B9z9WPG8.js";
import * as x from "react";
import Be, { useId as Xt, useState as tt, useEffect as _t, createContext as go, use as mn, useRef as ut, createElement as y1, useLayoutEffect as Po, Children as ql, isValidElement as Zl, useContext as ag, cloneElement as Hc, useCallback as In, useMemo as gl, Fragment as q4 } from "react";
import * as an from "react-dom";
import { createPortal as Z4 } from "react-dom";
function X4({ defaultTagName: t, props: e, render: n, state: o = {}, stateAttributesMapping: r }) {
  let i = zc(Q4(o, r), e);
  if (!n) return x.createElement(t, i);
  if (typeof n == "function") return n(i, o);
  if (!x.isValidElement(n)) return null;
  let s = n.props, l = { ...zc(i, s), ref: Ji(i.ref, s.ref) };
  return x.cloneElement(n, l);
}
function zc(...t) {
  let e = {};
  for (let n of t) {
    if (!n) continue;
    let o = n;
    for (let r of Object.keys(o)) {
      let i = o[r];
      if (i === void 0) continue;
      let s = e[r];
      r === "className" ? e[r] = [s, i].filter(Boolean).join(" ") : r === "style" ? e[r] = { ...s, ...i } : r === "ref" ? e[r] = Ji(s, i) : e3(r) && typeof s == "function" && typeof i == "function" ? e[r] = J4(i, s) : e[r] = i;
    }
  }
  return e;
}
function Q4(t, e) {
  let n = {};
  for (let o of Object.keys(t)) {
    let r = t[o], i = e?.[o]?.(r);
    if (i) {
      Object.assign(n, i);
      continue;
    }
    if (o === "slot") {
      n["data-slot"] = r;
      continue;
    }
    let s = `data-${String(o).replace(/[A-Z]/g, (l) => `-${l.toLowerCase()}`)}`;
    typeof r == "boolean" ? n[s] = r ? "" : void 0 : r != null && (n[s] = String(r));
  }
  return n;
}
function J4(t, e) {
  return function(n) {
    t(n), n.defaultPrevented || e(n);
  };
}
function e3(t) {
  return /^on[A-Z]/.test(t);
}
function Ji(...t) {
  let e = t.filter(Boolean);
  if (e.length !== 0) return (n) => {
    for (let o of e) typeof o == "function" ? o(n) : o && (o.current = n);
  };
}
var t3 = 8, n3 = 64, o3 = 0, Nl = 0.5, r3 = 180, i3 = /* @__PURE__ */ new Set(["ArrowDown", "ArrowUp", "End", "Home", "PageDown", "PageUp", " "]), cg = { start: !1, end: !1 }, s3 = [], kl = { currentAnchorId: null, visibleMessageIds: s3 };
function l3({ content: t, scrollEdgeThreshold: e, spacer: n, viewport: o }) {
  if (!o || !t) return cg;
  let r = Cu({ content: t, spacer: n, viewport: o });
  return { start: o.scrollTop > e, end: r - o.scrollTop - o.clientHeight > e };
}
function a3({ content: t, scrollMargin: e, scrollPreviousItemPeek: n, spacer: o, viewport: r, visibleMessageIds: i }) {
  if (!t || !r) return kl;
  let s = r.getBoundingClientRect(), l = s.top + e + n, a = typeof IntersectionObserver > "u", c = [], u = null;
  for (let d of $i(t, o)) {
    let f = d.dataset.messageId;
    if (!f) continue;
    let p = d.dataset.scrollAnchor === "true", m = p || a ? d.getBoundingClientRect() : null;
    (a && m ? m.bottom > l && m.top < s.bottom : i.has(f)) && c.push(f), p && m && m.top <= l + Nl && (u = f);
  }
  return c.length === 0 && u === null ? kl : { currentAnchorId: u, visibleMessageIds: c };
}
function $i(t, e) {
  return Array.from(t.children).filter((n) => n instanceof HTMLElement && n !== e);
}
function c3(t, e) {
  for (let n = e; n < t.length; n++) {
    let o = t[n];
    if (o?.dataset.scrollAnchor === "true") return o;
  }
  return null;
}
function u3(t, e) {
  for (let n of t) if (n.dataset.scrollAnchor === "true" && !e.has(n)) return n;
  return null;
}
function d3(t, e) {
  let n = 0;
  for (let o = e; o < t.length; o++) if (t[o]?.dataset.scrollAnchor === "true" && (n += 1, n > 1)) return !0;
  return !1;
}
function f3(t) {
  for (let e = t.length - 1; e >= 0; e--) {
    let n = t[e];
    if (n?.dataset.scrollAnchor === "true") return n;
  }
  return null;
}
function p3({ content: t, spacer: e, viewport: n }) {
  let o = n.getBoundingClientRect();
  for (let r of $i(t, e)) {
    if (!r.dataset.messageId) continue;
    let i = r.getBoundingClientRect();
    if (i.bottom > o.top && i.top < o.bottom) return r;
  }
  return null;
}
function m3({ align: t, element: e, scrollMargin: n, spacer: o, viewport: r }) {
  let i = ug(e, r), s = e.getBoundingClientRect().height, l = b3(o);
  if (t === "center") {
    let a = Math.max(0, r.clientHeight - l.start - l.end);
    return i - l.start - (a - s) / 2 - n;
  }
  if (t === "end") return i - r.clientHeight + s + l.end + n;
  if (t === "nearest") {
    let a = i + s, c = r.scrollTop + l.start, u = r.scrollTop + r.clientHeight - l.end;
    return i >= c && a <= u ? r.scrollTop : i < c ? i - l.start - n : a - r.clientHeight + l.end + n;
  }
  return i - l.start - n;
}
function ug(t, e) {
  let n = t.getBoundingClientRect(), o = e.getBoundingClientRect();
  return n.top - o.top + e.scrollTop;
}
function hl(t, e) {
  return t.getBoundingClientRect().top - e.getBoundingClientRect().top;
}
function g3({ content: t, scrollTop: e, spacer: n, viewport: o }) {
  let r = Cu({ content: t, spacer: n, viewport: o });
  return e + o.clientHeight - r;
}
function Cu({ content: t, spacer: e, viewport: n }) {
  let o = $i(t, e), r = dg(t), i = n.getBoundingClientRect(), s = n.scrollTop, l = r.start + r.end;
  for (let a of o) {
    let c = a.getBoundingClientRect();
    l = Math.max(l, c.bottom - i.top + s + r.end);
  }
  return l;
}
function h3(t) {
  return Math.max(0, t.scrollHeight - t.clientHeight);
}
function dg(t) {
  let e = window.getComputedStyle(t);
  return { end: Bc(e.paddingBlockEnd || e.paddingBottom), start: Bc(e.paddingBlockStart || e.paddingTop) };
}
function b3(t) {
  let e = t?.parentElement;
  return e ? dg(e) : { end: 0, start: 0 };
}
function v3(t) {
  if (!t) return 0;
  let e = window.getComputedStyle(t), n = e.rowGap === "normal" ? e.gap : e.rowGap;
  return Bc(n);
}
function Bc(t) {
  if (!t) return 0;
  let e = Number.parseFloat(t);
  return Number.isFinite(e) ? e : 0;
}
function y3({ refs: t, commitScrollState: e, scheduleStateCommit: n, scheduleVisibilitySync: o }) {
  let { streamingTurnRef: r, autoScrollRef: i, autoscrollingRef: s, autoscrollingTimeoutRef: l, contentRef: a, defaultScrollPositionAppliedRef: c, itemCountRef: u, messageElementsRef: d, modeRef: f, pendingScrollToMessageRef: p, prependRestoreRef: m, scrollMarginRef: h, scrollPreviousItemPeekRef: b, spacerGapRef: v, spacerHeightRef: C, spacerRef: y, viewportRef: w } = t, R = x.useCallback((M) => {
    l.current !== null && (window.clearTimeout(l.current), l.current = null), s.current !== M && (s.current = M, e()), M && (l.current = window.setTimeout(() => {
      l.current = null, s.current = !1, e();
    }, r3));
  }, [e]), S = x.useCallback((M) => {
    let D = y.current;
    if (!D) return;
    let O = Math.max(0, Math.ceil(M));
    C.current !== O && (C.current = O, D.hidden = O === 0, D.style.height = `${O}px`, D.style.marginTop = O > 0 ? `${-v.current}px` : "");
  }, []), E = x.useCallback((M, { behavior: D = "auto", autoscrolling: O = !1 } = {}) => {
    let _ = w.current;
    if (!_) return;
    let V = Math.max(0, M);
    if (Math.abs(_.scrollTop - V) <= Nl) {
      _.scrollTop = V, e();
      return;
    }
    O && R(!0), _.scrollTo({ top: V, behavior: D }), n();
  }, [e, n, R]), N = x.useCallback(({ behavior: M = "auto" } = {}) => w.current ? (S(0), r.current = null, f.current = "free-scrolling", E(0, { behavior: M }), o(), !0) : !1, [o, E, S]), I = x.useCallback(({ behavior: M = "auto" } = {}) => {
    let D = w.current;
    return D ? (S(0), r.current = null, f.current = i.current ? "following-bottom" : "free-scrolling", E(h3(D), { autoscrolling: !0, behavior: M }), o(), !0) : !1;
  }, [o, E, S]), T = x.useCallback((M, { align: D = "start", behavior: O = "auto", scrollMargin: _ = h.current } = {}, { keepPreviousPeek: V = !1 } = {}) => {
    let A = a.current, L = w.current;
    if (!A || !L || !A.contains(M)) return !1;
    let $ = m3({ align: D, element: M, scrollMargin: V ? _ + b.current : _, spacer: y.current, viewport: L }), Y = g3({ content: A, scrollTop: $, spacer: y.current, viewport: L });
    return S(Y), m.current = { element: M, viewportTop: hl(M, L) }, f.current = V ? "anchored-to-message" : "settling-jump", r.current = V ? M : null, E($, { behavior: O }), o(), !0;
  }, [o, E, S]), k = x.useCallback(() => {
    let M = r.current;
    return !M || !M.isConnected || f.current !== "anchored-to-message" ? !1 : T(M, { align: "start" }, { keepPreviousPeek: !0 });
  }, [T]), P = x.useCallback((M, D) => {
    let O = d.current.get(M);
    return O ? (c.current = !0, T(O, D) ? (p.current = null, !0) : (p.current = { messageId: M, options: D }, !0)) : u.current === 0 ? (p.current = { messageId: M, options: D }, c.current = !0, !0) : !1;
  }, [T]);
  return { flushPendingScrollToMessage: x.useCallback(() => {
    let M = p.current;
    if (!M) return !1;
    let D = d.current.get(M.messageId);
    return !D || !T(D, M.options) ? !1 : (p.current = null, c.current = !0, !0);
  }, [T]), reanchorToAnchoredMessage: k, scrollToElement: T, scrollToEnd: I, scrollToMessage: P, scrollToStart: N };
}
function fg(t, e) {
  let n = t, o = /* @__PURE__ */ new Set();
  return { getSnapshot: () => n, hasListeners: () => o.size > 0, setSnapshot: (r) => {
    e(n, r) || (n = r, o.forEach((i) => i()));
  }, subscribe: (r, i, s) => {
    let l = o.size === 0;
    return o.add(r), l && i?.(), () => {
      o.delete(r), o.size === 0 && s?.();
    };
  } };
}
function x3(t, e) {
  return fg(t, e);
}
function C3() {
  return fg(kl, S3);
}
function w3(t, e) {
  return t.start === e.start && t.end === e.end;
}
function S3(t, e) {
  return t.currentAnchorId !== e.currentAnchorId || t.visibleMessageIds.length !== e.visibleMessageIds.length ? !1 : t.visibleMessageIds.every((n, o) => n === e.visibleMessageIds[o]);
}
function R3({ autoScroll: t, scrollEdgeThreshold: e, scrollMargin: n, scrollPreviousItemPeek: o }) {
  let r = x.useRef(t), i = x.useRef(!1), s = x.useRef(null), l = x.useRef(!1), a = x.useRef(e), c = x.useRef(0), u = x.useRef(null), d = x.useRef(0), f = x.useRef(t ? "following-bottom" : "free-scrolling"), p = x.useRef(/* @__PURE__ */ new Map()), m = x.useRef(null), h = x.useRef(null), b = x.useRef(null), v = x.useRef(o), C = x.useRef(!0), y = x.useRef(null), w = x.useRef(n), R = x.useRef(null), S = x.useRef(0), E = x.useRef(0), N = x.useRef(null), I = x.useRef(null), T = x.useRef(null), k = x.useRef(null), P = x.useRef(null), M = x.useRef(null), D = x.useRef(null), O = x.useRef(null), _ = x.useRef(/* @__PURE__ */ new Set()), V = x.useRef(/* @__PURE__ */ new WeakSet());
  return T.current === null && (T.current = x3(cg, w3)), O.current === null && (O.current = C3()), r.current = t, a.current = e, w.current = n, v.current = o, { autoScrollRef: r, autoscrollingRef: i, autoscrollingTimeoutRef: k, streamingTurnRef: b, contentRef: s, defaultScrollPositionAppliedRef: l, firstItemRef: u, itemCountRef: c, lastScrollTopRef: d, messageElementsRef: p, modeRef: f, pendingScrollFrameRef: R, pendingScrollToMessageRef: m, prependRestoreRef: h, preserveScrollOnPrependRef: C, rootRef: y, scrollEdgeThresholdRef: a, scrollMarginRef: w, scrollPreviousItemPeekRef: v, spacerGapRef: S, spacerHeightRef: E, spacerRef: N, stateFrameRef: I, stateStore: T.current, viewportRef: P, visibilityFrameRef: M, visibilityObserverRef: D, visibilityStore: O.current, visibleMessageIdsRef: _, handledScrollAnchorsRef: V };
}
function x1(t, e) {
  return x.useCallback((n) => {
    t.current = n, n && e();
  }, [t, e]);
}
function E3({ autoScroll: t = !1, defaultScrollPosition: e = "end", scrollEdgeThreshold: n = t3, scrollPreviousItemPeek: o = n3, scrollMargin: r = o3 }) {
  let i = R3({ autoScroll: t, scrollEdgeThreshold: n, scrollMargin: r, scrollPreviousItemPeek: o }), { streamingTurnRef: s, autoScrollRef: l, autoscrollingRef: a, autoscrollingTimeoutRef: c, contentRef: u, defaultScrollPositionAppliedRef: d, firstItemRef: f, itemCountRef: p, lastScrollTopRef: m, messageElementsRef: h, modeRef: b, pendingScrollFrameRef: v, pendingScrollToMessageRef: C, prependRestoreRef: y, preserveScrollOnPrependRef: w, rootRef: R, scrollEdgeThresholdRef: S, scrollMarginRef: E, scrollPreviousItemPeekRef: N, spacerGapRef: I, spacerHeightRef: T, spacerRef: k, stateFrameRef: P, stateStore: M, viewportRef: D, visibilityFrameRef: O, visibilityObserverRef: _, visibilityStore: V, visibleMessageIdsRef: A, handledScrollAnchorsRef: L } = i, $ = x.useRef(e);
  $.current !== e && ($.current = e, d.current = !1);
  let Y = x.useCallback((ve) => {
    let de = R.current, me = D.current, Re = [ve.start && "start", ve.end && "end"].filter(Boolean).join(" "), Ie = a.current;
    for (let Pe of [de, me]) Pe && (Re ? Pe.setAttribute("data-scrollable", Re) : Pe.removeAttribute("data-scrollable"), Pe.toggleAttribute("data-autoscrolling", Ie));
  }, []), G = x.useCallback((ve) => {
    let de = D.current?.scrollTop ?? 0, me = de < m.current - Nl;
    m.current = de, l.current && !ve.end && b.current !== "settling-jump" && b.current !== "anchored-to-message" ? b.current = "following-bottom" : b.current === "following-bottom" && ve.end && me && !a.current && (b.current = "free-scrolling");
  }, []), j = x.useCallback(() => {
    let ve = l3({ content: u.current, scrollEdgeThreshold: S.current, spacer: k.current, viewport: D.current });
    G(ve);
    let de = b.current === "following-bottom" ? { ...ve, end: !1 } : ve;
    Y(de), M.setSnapshot(de);
  }, [G, M, Y]), Z = x.useCallback(() => {
    P.current === null && (P.current = window.requestAnimationFrame(() => {
      P.current = null, j();
    }));
  }, [j]), U = x.useCallback(() => {
    V.hasListeners() && O.current === null && (O.current = window.requestAnimationFrame(() => {
      O.current = null, V.hasListeners() && V.setSnapshot(a3({ content: u.current, scrollMargin: E.current, scrollPreviousItemPeek: N.current, spacer: k.current, viewport: D.current, visibleMessageIds: A.current }));
    }));
  }, [V]), { flushPendingScrollToMessage: q, reanchorToAnchoredMessage: te, scrollToElement: H, scrollToEnd: X, scrollToMessage: ee, scrollToStart: le } = y3({ refs: i, commitScrollState: j, scheduleStateCommit: Z, scheduleVisibilitySync: U }), Q = x.useCallback(() => {
    let ve = y.current, de = D.current;
    if (!ve || !de || !ve.element.isConnected) return !1;
    let me = hl(ve.element, de) - ve.viewportTop;
    return Math.abs(me) <= Nl ? !1 : (de.scrollTop += me, ve.viewportTop = hl(ve.element, de), Z(), U(), !0);
  }, [Z, U]), re = x.useCallback(() => {
    let ve = u.current, de = D.current;
    if (!ve || !de) {
      y.current = null;
      return;
    }
    let me = p3({ content: ve, spacer: k.current, viewport: de });
    y.current = me ? { element: me, viewportTop: hl(me, de) } : null;
  }, []), fe = x.useCallback(() => {
    v.current === null && (v.current = window.requestAnimationFrame(() => {
      v.current = null, q() && re();
    }));
  }, [re, q]), ne = x.useCallback(() => {
    if (!e || d.current || p.current === 0) return !1;
    let ve = !1;
    if (e === "last-anchor") {
      let de = u.current, me = D.current, Re = de && me ? f3($i(de, k.current)) : null;
      if (!de || !me || !Re) ve = X({ behavior: "auto" });
      else {
        let Ie = ug(Re, me);
        ve = Cu({ content: de, spacer: k.current, viewport: me }) - Ie <= me.clientHeight ? X({ behavior: "auto" }) : H(Re, { align: "start" }, { keepPreviousPeek: !0 });
      }
    } else ve = e === "end" ? X({ behavior: "auto" }) : le({ behavior: "auto" });
    return ve ? (d.current = !0, !0) : !1;
  }, [e, H, X, le]), se = x.useCallback(() => {
    let ve = u.current;
    if (!ve) return;
    let de = $i(ve, k.current), me = p.current, Re = f.current;
    p.current = de.length, f.current = de[0] ?? null, (() => {
      if (q()) return;
      if (me === 0) {
        if (ne() || de.length > 0 && l.current && X({ behavior: "auto" })) return;
        j(), U();
        return;
      }
      let Ie = Re ? de.indexOf(Re) : -1;
      if (w.current && Ie > 0) {
        Q();
        return;
      }
      if (de.length > me) {
        let Pe = c3(de, me);
        if (Pe) {
          if (l.current && b.current === "following-bottom" && d3(de, me)) {
            X({ behavior: "auto" });
            return;
          }
          H(Pe, { align: "start" }, { keepPreviousPeek: !0 }), L.current.add(Pe);
          return;
        }
      }
      if (de.length === me) {
        let Pe = u3(de, L.current);
        if (Pe) {
          H(Pe, { align: "start" }, { keepPreviousPeek: !0 }), L.current.add(Pe);
          return;
        }
      }
      b.current === "following-bottom" && l.current ? X({ behavior: "auto" }) : (j(), U());
    })(), re();
  }, [ne, re, j, q, Q, U, H, X]), pe = x.useCallback(() => {
    if (b.current === "following-bottom" && l.current) {
      X({ behavior: "auto" });
      return;
    }
    let ve = T.current;
    if (te()) {
      l.current && ve > 0 && T.current === 0 && X({ behavior: "auto" });
      return;
    }
    Z(), U();
  }, [te, Z, U, X]), xe = x.useCallback(() => {
    let ve = D.current;
    if (!(!ve || !V.hasListeners())) {
      if (typeof IntersectionObserver > "u") {
        U();
        return;
      }
      _.current || (_.current = new IntersectionObserver((de) => {
        for (let me of de) {
          let Re = me.target.dataset.messageId;
          Re && (me.isIntersecting ? A.current.add(Re) : A.current.delete(Re));
        }
        U();
      }, { root: ve, rootMargin: `${-(E.current + N.current)}px 0px 0px 0px`, threshold: [0, 0.01, 0.5, 1] })), h.current.forEach((de) => {
        _.current?.observe(de);
      }), U();
    }
  }, [U, V]), ce = x.useCallback(() => {
    O.current !== null && (window.cancelAnimationFrame(O.current), O.current = null), _.current?.disconnect(), _.current = null, A.current.clear(), V.setSnapshot(kl);
  }, [V]), he = x.useCallback((ve, de, me) => {
    if (de) {
      h.current.set(ve, de), _.current?.observe(de), U(), C.current?.messageId === ve && fe();
      return;
    }
    me && h.current.get(ve) === me && (h.current.delete(ve), A.current.delete(ve), _.current?.unobserve(me), U());
  }, [fe, U]), z = x.useCallback(() => {
    (b.current === "following-bottom" || b.current === "anchored-to-message" || b.current === "settling-jump") && (s.current = null, b.current = "free-scrolling");
  }, []), J = x.useCallback(() => Y(M.getSnapshot()), [M, Y]), B = x1(R, J), K = x1(D, J), ie = x.useCallback((ve) => {
    u.current = ve;
  }, []), ge = x.useCallback((ve) => {
    k.current = ve, I.current = v3(ve?.parentElement ?? null);
  }, []), ue = x.useCallback(() => {
    j(), U(), re();
  }, [re, j, U]), Se = x.useMemo(() => ({ handleContentChange: se, handleResize: pe, observeVisibility: xe, preserveScrollOnPrependRef: w, scrollToEnd: X, scrollToMessage: ee, scrollToStart: le, setContentElement: ie, setRootElement: B, setSpacerElement: ge, setViewportElement: K, stateStore: M, syncAfterScroll: ue, unobserveVisibility: ce, userScrollIntent: z, viewportRef: D, visibilityStore: V }), [se, pe, xe, X, ee, le, ie, B, ge, K, M, ue, ce, z, V]);
  return x.useLayoutEffect(() => {
    ne();
  }, [ne]), x.useEffect(() => () => {
    P.current !== null && (window.cancelAnimationFrame(P.current), P.current = null), O.current !== null && (window.cancelAnimationFrame(O.current), O.current = null), c.current !== null && (window.clearTimeout(c.current), c.current = null), v.current !== null && (window.cancelAnimationFrame(v.current), v.current = null), _.current?.disconnect(), _.current = null;
  }, []), x.useLayoutEffect(() => {
    if (t && b.current === "following-bottom" && p.current > 0) {
      X({ behavior: "auto" });
      return;
    }
    j();
  }, [t, j, X]), { context: Se, registerMessage: he };
}
function N3(t) {
  let e = x.useRef(t);
  return e.current = t, e;
}
var pg = x.createContext(null), mg = x.createContext(null);
function es() {
  let t = x.useContext(pg);
  if (!t) throw new Error("useMessageScroller must be used within a MessageScroller.");
  return t;
}
function k3() {
  let t = x.useContext(mg);
  if (!t) throw new Error("MessageScrollerItem must be used within a MessageScroller.");
  return t;
}
function gg() {
  let { scrollToEnd: t, scrollToMessage: e, scrollToStart: n } = es();
  return x.useMemo(() => ({ scrollToEnd: t, scrollToMessage: e, scrollToStart: n }), [t, e, n]);
}
function M3({ autoScroll: t = !1, children: e, defaultScrollPosition: n = "end", scrollEdgeThreshold: o, scrollPreviousItemPeek: r, scrollMargin: i }) {
  let { context: s, registerMessage: l } = E3({ autoScroll: t, defaultScrollPosition: n, scrollEdgeThreshold: o, scrollPreviousItemPeek: r, scrollMargin: i });
  return g(pg.Provider, { value: s, children: g(mg.Provider, { value: l, children: e }) });
}
function P3({ children: t, ...e }) {
  let { setRootElement: n } = es();
  return g("div", { ref: n, ...e, children: t });
}
function I3({ "aria-label": t, children: e, onKeyDown: n, onScroll: o, onTouchMove: r, onWheel: i, preserveScrollOnPrepend: s = !0, ref: l, role: a, tabIndex: c, ...u }) {
  let { handleResize: d, preserveScrollOnPrependRef: f, setViewportElement: p, syncAfterScroll: m, userScrollIntent: h, viewportRef: b } = es();
  f.current = s;
  let v = x.useCallback((S) => {
    p(S), Ji(l)?.(S);
  }, [l, p]);
  function C(S) {
    m(), o?.(S);
  }
  function y(S) {
    h(), i?.(S);
  }
  function w(S) {
    h(), r?.(S);
  }
  function R(S) {
    i3.has(S.key) && h(), n?.(S);
  }
  return x.useEffect(() => {
    let S = b.current;
    if (!S || typeof ResizeObserver > "u") return;
    let E = 0, N = new ResizeObserver(() => {
      window.cancelAnimationFrame(E), E = window.requestAnimationFrame(d);
    });
    return N.observe(S), () => {
      window.cancelAnimationFrame(E), N.disconnect();
    };
  }, [d, b]), g("div", { ref: v, role: a ?? "region", "aria-label": t ?? "Messages", tabIndex: c ?? 0, onKeyDown: R, onScroll: C, onTouchMove: w, onWheel: y, ...u, children: e });
}
function T3({ "aria-relevant": t, children: e, ref: n, role: o, spacerClassName: r, ...i }) {
  let { handleContentChange: s, handleResize: l, setContentElement: a, setSpacerElement: c } = es(), u = x.useRef(null), d = x.useCallback((f) => {
    u.current = f, a(f), Ji(n)?.(f);
  }, [n, a]);
  return x.useLayoutEffect(() => {
    let f = u.current;
    if (!f || (s(), typeof MutationObserver > "u")) return;
    let p = new MutationObserver(() => {
      s();
    });
    return p.observe(f, { childList: !0 }), () => p.disconnect();
  }, [s]), x.useEffect(() => {
    let f = u.current;
    if (!f || typeof ResizeObserver > "u") return;
    let p = 0, m = new ResizeObserver(() => {
      window.cancelAnimationFrame(p), p = window.requestAnimationFrame(l);
    });
    return m.observe(f), () => {
      window.cancelAnimationFrame(p), m.disconnect();
    };
  }, [l]), F("div", { ref: d, role: o ?? "log", "aria-relevant": t ?? "additions", ...i, children: [e, g("div", { ref: c, "aria-hidden": "true", "data-message-scroller-spacer": "", hidden: !0, className: r })] });
}
function O3({ messageId: t, ref: e, scrollAnchor: n = !1, ...o }) {
  let r = k3(), i = x.useRef(null), s = x.useCallback((l) => {
    let a = i.current;
    i.current = l, t && r(t, l, a), Ji(e)?.(l);
  }, [t, e, r]);
  return g("div", { ref: s, "data-message-id": t, "data-scroll-anchor": n ? "true" : "false", ...o });
}
function D3({ behavior: t = "smooth", children: e, direction: n = "end", onClick: o, render: r, tabIndex: i, type: s = "button", ...l }) {
  let { scrollToEnd: a, scrollToStart: c, stateStore: u } = es(), d = N3(o), f = x.useCallback((b) => u.subscribe(b), [u]), p = x.useCallback(() => {
    let b = u.getSnapshot();
    return n === "start" ? b.start : b.end;
  }, [n, u]), m = x.useSyncExternalStore(f, p, p), h = x.useCallback((b) => {
    m && (d.current?.(b), b.defaultPrevented || (b.currentTarget.blur(), n === "start" ? c({ behavior: t }) : a({ behavior: t })));
  }, [t, n, m, d, a, c]);
  return X4({ defaultTagName: "button", props: zc({ type: s, inert: !m, tabIndex: m ? i : -1, children: e ?? F("span", { children: ["Scroll to ", n] }), onClick: h }, l), render: r, state: { active: m, direction: n }, stateAttributesMapping: { active: (b) => ({ "data-active": b ? "true" : "false" }) } });
}
var Wr = { Provider: M3, Root: P3, Viewport: I3, Content: T3, Item: O3, Button: D3 };
const hg = {
  xs: "var(--icon-xs)",
  sm: "var(--icon-sm)",
  md: "var(--icon-md)",
  lg: "var(--icon-lg)",
  xl: "var(--icon-xl)",
  xxl: "var(--icon-xxl)"
};
function wu(t) {
  const e = W.c(18);
  let n, o;
  e[0] !== t ? ({
    size: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? "md" : o, i = Xt();
  let s;
  if (e[3] !== i) {
    let v;
    e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /:/g, e[5] = v) : v = e[5], s = i.replace(v, ""), e[3] = i, e[4] = s;
  } else
    s = e[4];
  const a = `ai-sparkles-gradient-${s}`, c = hg[r];
  let u, d, f;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g("stop", { offset: "13%", stopColor: "hsl(var(--primary-primary-container))" }), d = /* @__PURE__ */ g("stop", { offset: "44%", stopColor: "hsl(var(--primary-primary))" }), f = /* @__PURE__ */ g("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))" }), e[6] = u, e[7] = d, e[8] = f) : (u = e[6], d = e[7], f = e[8]);
  let p;
  e[9] !== a ? (p = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ F("linearGradient", { id: a, x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [
    u,
    d,
    f
  ] }) }), e[9] = a, e[10] = p) : p = e[10];
  const m = `url(#${a})`;
  let h;
  e[11] !== m ? (h = /* @__PURE__ */ g("path", { d: "M 16.024 4.395 C 15.855 4.4587 15.743 4.62 15.743 4.8 C 15.743 4.98 15.855 5.1412 16.024 5.205 L 18.143 6 L 18.938 8.1187 C 19.002 8.2875 19.163 8.4 19.343 8.4 C 19.523 8.4 19.684 8.2875 19.748 8.1187 L 20.543 6 L 22.662 5.205 C 22.83 5.1412 22.943 4.98 22.943 4.8 C 22.943 4.62 22.83 4.4587 22.662 4.395 L 20.543 3.6 L 19.748 1.4812 C 19.684 1.3125 19.523 1.2 19.343 1.2 C 19.163 1.2 19.002 1.3125 18.938 1.4812 L 18.143 3.6 L 16.024 4.395 Z M 7.639 10.2187 L 8.543 8.265 L 9.447 10.2187 C 9.627 10.6087 9.938 10.92 10.328 11.1 L 12.282 12.0037 L 10.328 12.9075 C 9.938 13.0875 9.627 13.3987 9.447 13.7887 L 8.543 15.7425 L 7.639 13.7887 C 7.459 13.3987 7.148 13.0875 6.758 12.9075 L 4.804 12 L 6.762 11.0962 C 7.152 10.9162 7.463 10.605 7.643 10.215 L 7.639 10.2187 Z M 7.553 6.1162 L 6.008 9.465 L 2.659 11.01 L 2.637 11.0212 C 2.49 11.0887 2.175 11.235 1.692 11.4562 C 1.478 11.5537 1.343 11.7675 1.343 12 C 1.343 12.2325 1.478 12.4462 1.692 12.5437 C 2.175 12.765 2.487 12.9112 2.637 12.9787 L 2.659 12.99 L 6.008 14.535 L 7.553 17.8837 L 7.564 17.9062 C 7.632 18.0525 7.778 18.3675 7.999 18.8512 C 8.097 19.065 8.31 19.2 8.543 19.2 C 8.775 19.2 8.989 19.065 9.087 18.8512 C 9.627 17.685 9.653 17.625 11.078 14.5387 L 14.427 12.9937 L 14.449 12.9825 C 14.595 12.915 14.91 12.7687 15.394 12.5475 C 15.608 12.45 15.743 12.2362 15.743 12.0037 C 15.743 11.7712 15.608 11.5575 15.394 11.46 C 14.228 10.92 14.168 10.8937 11.082 9.4687 L 9.537 6.12 L 9.525 6.0975 C 9.458 5.9512 9.312 5.6362 9.09 5.1525 C 8.993 4.9387 8.779 4.8037 8.547 4.8037 C 8.314 4.8037 8.1 4.9387 8.003 5.1525 C 7.485 6.27 7.572 6.09 7.557 6.12 L 7.553 6.1162 Z M 16.943 18 L 14.824 18.795 C 14.655 18.8587 14.543 19.02 14.543 19.2 C 14.543 19.38 14.655 19.5412 14.824 19.605 L 16.943 20.4 L 17.738 22.5187 C 17.802 22.6875 17.963 22.8 18.143 22.8 C 18.323 22.8 18.484 22.6875 18.548 22.5187 L 19.343 20.4 L 21.462 19.605 C 21.63 19.5412 21.743 19.38 21.743 19.2 C 21.743 19.02 21.63 18.8587 21.462 18.795 L 19.343 18 L 18.548 15.8812 C 18.484 15.7125 18.323 15.6 18.143 15.6 C 17.963 15.6 17.802 15.7125 17.738 15.8812 L 16.943 18 Z", fill: m }), e[11] = m, e[12] = h) : h = e[12];
  let b;
  return e[13] !== c || e[14] !== n || e[15] !== p || e[16] !== h ? (b = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", width: c, height: c, "aria-hidden": "true", focusable: "false", ...n, children: [
    p,
    h
  ] }), e[13] = c, e[14] = n, e[15] = p, e[16] = h, e[17] = b) : b = e[17], b;
}
function _3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 12 7 C 12.52 7 12.938 7.418 12.938 7.9375 V 12.3125 C 12.938 12.832 12.52 13.25 12 13.25 C 11.48 13.25 11.062 12.832 11.062 12.3125 V 7.9375 C 11.062 7.418 11.48 7 12 7 Z M 10.75 15.75 C 10.75 15.4185 10.882 15.1005 11.116 14.8661 C 11.351 14.6317 11.668 14.5 12 14.5 C 12.332 14.5 12.649 14.6317 12.884 14.8661 C 13.118 15.1005 13.25 15.4185 13.25 15.75 C 13.25 16.0815 13.118 16.3995 12.884 16.6339 C 12.649 16.8683 12.332 17 12 17 C 11.668 17 11.351 16.8683 11.116 16.6339 C 10.882 16.3995 10.75 16.0815 10.75 15.75 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function V3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 4.32 6.96 C 4.32 6.561 4.641 6.24 5.04 6.24 C 5.439 6.24 5.76 6.561 5.76 6.96 V 17.04 C 5.76 17.439 5.439 17.76 5.04 17.76 C 4.641 17.76 4.32 17.439 4.32 17.04 V 6.96 Z M 8.37 12.51 C 8.088 12.228 8.088 11.772 8.37 11.493 L 12.45 7.41 C 12.732 7.128 13.188 7.128 13.467 7.41 C 13.746 7.692 13.749 8.148 13.467 8.427 L 10.617 11.277 H 18.96 C 19.359 11.277 19.68 11.598 19.68 11.997 C 19.68 12.396 19.359 12.717 18.96 12.717 H 10.617 L 13.467 15.567 C 13.749 15.849 13.749 16.305 13.467 16.584 C 13.185 16.863 12.729 16.866 12.45 16.584 L 8.37 12.51 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function A3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 2.275 10.8332 C 1.908 11.2004 1.908 11.7942 2.275 12.1575 L 8.837 18.7246 C 9.204 19.0918 9.798 19.0918 10.161 18.7246 C 10.525 18.3574 10.528 17.7636 10.161 17.4002 L 5.201 12.4349 H 21.063 C 21.582 12.4349 22 12.0169 22 11.4973 C 22 10.9777 21.582 10.5597 21.063 10.5597 H 5.201 L 10.165 5.5983 C 10.532 5.2311 10.532 4.6373 10.165 4.274 C 9.798 3.9106 9.204 3.9067 8.841 4.274 L 2.275 10.8332 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function L3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 5.76 6.96 C 5.76 6.561 5.439 6.24 5.04 6.24 C 4.641 6.24 4.32 6.561 4.32 6.96 V 17.04 C 4.32 17.439 4.641 17.76 5.04 17.76 C 5.439 17.76 5.76 17.439 5.76 17.04 V 6.96 Z M 19.47 12.51 C 19.752 12.228 19.752 11.772 19.47 11.493 L 15.39 7.41 C 15.108 7.128 14.652 7.128 14.373 7.41 C 14.094 7.692 14.091 8.148 14.373 8.427 L 17.223 11.277 H 8.88 C 8.481 11.277 8.16 11.598 8.16 11.997 C 8.16 12.396 8.481 12.717 8.88 12.717 H 17.223 L 14.373 15.567 C 14.091 15.849 14.091 16.305 14.373 16.584 C 14.655 16.863 15.111 16.866 15.39 16.584 L 19.47 12.51 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function F3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 19 4 C 19.554 4 20 4.4459 20 5.0001 V 15.0014 C 20 15.5557 19.554 16.0016 19 16.0016 C 18.446 16.0016 18 15.5557 18 15.0014 V 7.4129 L 5.706 19.7062 C 5.314 20.0979 4.68 20.0979 4.293 19.7062 C 3.905 19.3145 3.901 18.6852 4.289 18.2935 L 16.583 6.0003 H 8.994 C 8.439 6.0003 7.993 5.5544 7.993 5.0001 C 7.993 4.4459 8.439 4 8.994 4 H 18.996 H 19 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function $3(t) {
  const e = W.c(4);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: "clip1_9481_7123", children: /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.4)" }) }) }), e[0] = n) : n = e[0];
  let o;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("g", { clipPath: "url(#clip1_9481_7123)", children: /* @__PURE__ */ g("path", { d: "M 11.414 4.0871 C 11.582 3.9894 11.784 3.9894 11.953 4.0871 L 17.339 7.1983 L 11.683 10.4646 L 6.027 7.1983 L 11.414 4.0871 Z M 5.218 8.6006 L 10.874 11.8669 V 18.3995 L 5.488 15.2882 C 5.319 15.1905 5.218 15.0152 5.218 14.8197 V 8.5972 V 8.6006 Z M 12.492 18.3995 V 11.8669 L 18.148 8.6006 V 14.8231 C 18.148 15.0152 18.047 15.1938 17.879 15.2916 L 12.492 18.3995 Z M 12.762 2.6882 C 12.094 2.304 11.272 2.304 10.605 2.6882 L 4.679 6.1062 C 4.011 6.4905 3.6 7.2051 3.6 7.9736 V 14.8163 C 3.6 15.5882 4.011 16.2995 4.679 16.6837 L 10.605 20.1118 C 11.272 20.4961 12.094 20.4961 12.762 20.1118 L 18.691 16.6905 C 19.359 16.3062 19.77 15.5916 19.77 14.8231 V 7.9804 C 19.77 7.2085 19.359 6.4972 18.691 6.1129 L 12.762 2.6849 V 2.6882 Z", fill: "currentColor" }) }), e[1] = o) : o = e[1];
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function H3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 6 4.8 C 6 4.1362 6.536 3.6 7.2 3.6 H 8.4 C 9.064 3.6 9.6 4.1362 9.6 4.8 V 5.4 H 6 V 4.8 Z M 4.635 8.325 C 4.815 7.3275 5.685 6.6 6.701 6.6 H 9.9 C 10.399 6.6 10.8 7.0012 10.8 7.5 V 8.4 H 13.2 V 7.5 C 13.2 7.0012 13.601 6.6 14.1 6.6 H 17.299 C 18.315 6.6 19.185 7.3275 19.365 8.325 L 19.552 9.3487 C 19.687 10.095 19.957 10.8112 20.347 11.4637 L 20.445 11.6287 C 21.199 12.8887 21.6 14.3287 21.6 15.795 V 18.3 C 21.6 19.4587 20.659 20.4 19.5 20.4 H 15.3 C 14.141 20.4 13.2 19.4587 13.2 18.3 V 13.2 H 10.8 V 18.3 C 10.8 19.4587 9.859 20.4 8.7 20.4 H 4.5 C 3.341 20.4 2.4 19.4587 2.4 18.3 V 15.795 C 2.4 14.325 2.797 12.885 3.555 11.625 L 3.652 11.46 C 4.042 10.8075 4.312 10.0912 4.447 9.345 L 4.635 8.3212 V 8.325 Z M 6.701 8.4 C 6.555 8.4 6.431 8.505 6.405 8.6475 L 6.217 9.6712 C 6.045 10.6312 5.7 11.55 5.197 12.39 L 5.1 12.555 C 4.511 13.5337 4.2 14.6512 4.2 15.795 V 18.3 C 4.2 18.465 4.335 18.6 4.5 18.6 H 8.7 C 8.865 18.6 9 18.465 9 18.3 V 8.4 H 6.701 Z M 17.299 8.4 H 15 V 18.3 C 15 18.465 15.135 18.6 15.3 18.6 H 19.5 C 19.665 18.6 19.8 18.465 19.8 18.3 V 15.795 C 19.8 14.655 19.489 13.5337 18.904 12.555 L 18.806 12.39 C 18.304 11.5537 17.959 10.6312 17.782 9.6712 L 17.595 8.6475 C 17.569 8.505 17.445 8.4 17.299 8.4 Z M 15.6 3.6 H 16.8 C 17.464 3.6 18 4.1362 18 4.8 V 5.4 H 14.4 V 4.8 C 14.4 4.1362 14.936 3.6 15.6 3.6 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function z3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 20.66 17 C 21.512 15.5312 22 13.8203 22 12 C 22 6.4766 17.523 2 12 2 V 3.875 C 16.488 3.875 20.125 7.5117 20.125 12 C 20.125 13.4805 19.73 14.8672 19.039 16.0625 L 20.664 17 H 20.66 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function B3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 7.357 2 C 7.951 2 8.429 2.4681 8.429 3.05 V 4.8 H 15.571 V 3.05 C 15.571 2.4681 16.049 2 16.643 2 C 17.237 2 17.714 2.4681 17.714 3.05 V 4.8 H 19.143 C 20.719 4.8 22 6.0556 22 7.6 V 20.2 C 22 21.7444 20.719 23 19.143 23 H 4.857 C 3.281 23 2 21.7444 2 20.2 V 7.6 C 2 6.0556 3.281 4.8 4.857 4.8 H 6.286 V 3.05 C 6.286 2.4681 6.763 2 7.357 2 Z M 7.357 6.9 H 4.857 C 4.464 6.9 4.143 7.215 4.143 7.6 V 9.7 H 19.857 V 7.6 C 19.857 7.215 19.536 6.9 19.143 6.9 H 7.357 Z M 4.143 11.8 V 20.2 C 4.143 20.585 4.464 20.9 4.857 20.9 H 19.143 C 19.536 20.9 19.857 20.585 19.857 20.2 V 11.8 H 4.143 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function W3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M1.82142 0.910712V0H0V16.9999H19.4285V15.1785H1.82142V0.910712ZM17.9486 5.19865L18.5937 4.55356L17.3073 3.26718L16.6622 3.91227L12.1466 8.42788C9.756 6.03726 8.54172 4.82298 8.50377 4.78503L7.85868 5.43012L3.91227 9.37653L3.26718 10.0216L4.55356 11.308L5.19865 10.6629L8.49998 7.36159L11.4977 10.3593L12.1428 11.0044L12.7879 10.3593L17.9486 5.19865Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function U3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 8.17 16.6234 L 3.194 11.648 L 1.5 13.3303 L 8.17 20 L 22.487 5.6823 L 20.805 4 L 8.17 16.6234 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function G3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M7.45739 5.45213C7.75425 5.03285 7.6527 4.4597 7.22692 4.16736C6.80115 3.87502 6.21914 3.97503 5.92227 4.39431L4.37153 6.56764L3.60201 5.80601C3.23484 5.44828 2.6411 5.44828 2.27392 5.80601C1.90674 6.16375 1.91065 6.75228 2.27392 7.11386L3.83638 8.6525C4.03169 8.84483 4.30512 8.94485 4.58246 8.91792C4.8598 8.89099 5.10979 8.75252 5.26994 8.52941L7.45739 5.45213ZM7.45739 11.6067C7.75425 11.1874 7.6527 10.6143 7.22692 10.3219C6.80115 10.0296 6.21914 10.1296 5.92227 10.5489L4.37153 12.7222L3.60201 11.9606C3.23484 11.599 2.6411 11.599 2.27783 11.9606C1.91455 12.3222 1.91065 12.9069 2.27392 13.2684L3.83638 14.8071C4.03169 14.9994 4.30512 15.0994 4.58246 15.0725C4.8598 15.0456 5.10979 14.9071 5.26994 14.684L7.45739 11.6067ZM9.50031 6.45994C9.50031 6.97154 9.91826 7.38312 10.4378 7.38312H21.0625C21.582 7.38312 22 6.97154 22 6.45994C22 5.94834 21.582 5.53675 21.0625 5.53675H10.4378C9.91826 5.53675 9.50031 5.94834 9.50031 6.45994ZM9.50031 12.6145C9.50031 13.1261 9.91826 13.5377 10.4378 13.5377H21.0625C21.582 13.5377 22 13.1261 22 12.6145C22 12.1029 21.582 11.6913 21.0625 11.6913H10.4378C9.91826 11.6913 9.50031 12.1029 9.50031 12.6145ZM8.25034 18.7691C8.25034 19.2807 8.6683 19.6923 9.18781 19.6923H21.0625C21.582 19.6923 22 19.2807 22 18.7691C22 18.2575 21.582 17.8459 21.0625 17.8459H9.18781C8.6683 17.8459 8.25034 18.2575 8.25034 18.7691ZM5.7504 18.7691C5.7504 18.4426 5.61871 18.1295 5.38429 17.8987C5.14988 17.6679 4.83194 17.5382 4.50043 17.5382C4.16892 17.5382 3.85098 17.6679 3.61657 17.8987C3.38215 18.1295 3.25046 18.4426 3.25046 18.7691C3.25046 19.0955 3.38215 19.4086 3.61657 19.6395C3.85098 19.8703 4.16892 20 4.50043 20C4.83194 20 5.14988 19.8703 5.38429 19.6395C5.61871 19.4086 5.7504 19.0955 5.7504 18.7691Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Y3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.505 16.5898 C 11.787 16.8718 12.243 16.8718 12.522 16.5898 L 18.522 10.5898 C 18.804 10.3078 18.804 9.8518 18.522 9.5728 C 18.24 9.2938 17.784 9.2908 17.505 9.5728 L 12.015 15.0628 L 6.525 9.5728 C 6.243 9.2908 5.787 9.2908 5.508 9.5728 C 5.229 9.8548 5.226 10.3108 5.508 10.5898 L 11.508 16.5898 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function j3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 7.313 11.778 C 6.896 12.1768 6.896 12.8216 7.313 13.2162 L 16.184 21.7009 C 16.601 22.0997 17.275 22.0997 17.687 21.7009 C 18.1 21.3021 18.104 20.6573 17.687 20.2627 L 9.57 12.4992 L 17.687 4.7357 C 18.104 4.3369 18.104 3.692 17.687 3.2975 C 17.27 2.903 16.596 2.8987 16.184 3.2975 L 7.313 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function K3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 17.687 11.778 C 18.104 12.1768 18.104 12.8216 17.687 13.2162 L 8.816 21.7009 C 8.399 22.0997 7.725 22.0997 7.313 21.7009 C 6.9 21.3021 6.896 20.6573 7.313 20.2627 L 15.43 12.4992 L 7.313 4.7357 C 6.896 4.3369 6.896 3.692 7.313 3.2975 C 7.73 2.903 8.404 2.8987 8.816 3.2975 L 17.687 11.7822 V 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function q3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.505 7.41 C 11.787 7.128 12.243 7.128 12.522 7.41 L 18.522 13.41 C 18.804 13.692 18.804 14.148 18.522 14.427 C 18.24 14.706 17.784 14.709 17.505 14.427 L 12.015 8.937 L 6.525 14.427 C 6.243 14.709 5.787 14.709 5.508 14.427 C 5.229 14.145 5.226 13.689 5.508 13.41 L 11.508 7.41 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Z3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 21.6 C 6.697 21.6 2.4 17.3025 2.4 12 C 2.4 6.6975 6.697 2.4 12 2.4 C 17.302 2.4 21.6 6.6975 21.6 12 C 21.6 17.3025 17.302 21.6 12 21.6 Z M 12 4.2 C 7.691 4.2 4.2 7.6913 4.2 12 C 4.2 16.3088 7.691 19.8 12 19.8 C 16.309 19.8 19.8 16.3088 19.8 12 C 19.8 7.6913 16.309 4.2 12 4.2 Z M 14.651 8.7713 C 14.944 8.37 15.506 8.28 15.907 8.5725 C 16.309 8.865 16.399 9.4275 16.106 9.8288 L 11.527 16.1288 C 11.374 16.3425 11.134 16.4775 10.871 16.4963 C 10.609 16.515 10.35 16.4213 10.166 16.2375 L 8.07 14.1413 C 7.717 13.7888 7.717 13.2188 8.07 12.87 C 8.422 12.5213 8.992 12.5175 9.341 12.87 L 10.691 14.22 L 14.651 8.775 V 8.7713 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function X3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 3.875 C 14.155 3.875 16.222 4.731 17.745 6.2548 C 19.269 7.7785 20.125 9.8451 20.125 12 C 20.125 14.1549 19.269 16.2215 17.745 17.7452 C 16.222 19.269 14.155 20.125 12 20.125 C 9.845 20.125 7.778 19.269 6.255 17.7452 C 4.731 16.2215 3.875 14.1549 3.875 12 C 3.875 9.8451 4.731 7.7785 6.255 6.2548 C 7.778 4.731 9.845 3.875 12 3.875 Z M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 12 7 C 11.48 7 11.062 7.418 11.062 7.9375 V 12.3125 C 11.062 12.832 11.48 13.25 12 13.25 C 12.52 13.25 12.938 12.832 12.938 12.3125 V 7.9375 C 12.938 7.418 12.52 7 12 7 Z M 13.25 15.75 C 13.25 15.4185 13.118 15.1005 12.884 14.8661 C 12.649 14.6317 12.332 14.5 12 14.5 C 11.668 14.5 11.351 14.6317 11.116 14.8661 C 10.882 15.1005 10.75 15.4185 10.75 15.75 C 10.75 16.0815 10.882 16.3995 11.116 16.6339 C 11.351 16.8683 11.668 17 12 17 C 12.332 17 12.649 16.8683 12.884 16.6339 C 13.118 16.3995 13.25 16.0815 13.25 15.75 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Q3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 10.9 6.5 H 13.1 V 8.7 H 10.9 V 6.5 Z M 10.9 10.9 H 13.1 V 17.5 H 10.9 V 10.9 Z M 12 1 C 5.928 1 1 5.928 1 12 C 1 18.072 5.928 23 12 23 C 18.072 23 23 18.072 23 12 C 23 5.928 18.072 1 12 1 Z M 12 20.8 C 7.149 20.8 3.2 16.851 3.2 12 C 3.2 7.149 7.149 3.2 12 3.2 C 16.851 3.2 20.8 7.149 20.8 12 C 20.8 16.851 16.851 20.8 12 20.8 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function J3(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 19.672 11.75 C 19.672 13.851 18.837 15.866 17.352 17.3516 C 15.866 18.8373 13.851 19.6719 11.75 19.6719 C 9.649 19.6719 7.634 18.8373 6.148 17.3516 C 4.663 15.866 3.828 13.851 3.828 11.75 C 3.828 9.649 4.663 7.634 6.148 6.1484 C 7.634 4.6627 9.649 3.8281 11.75 3.8281 C 13.851 3.8281 15.866 4.6627 17.352 6.1484 C 18.837 7.634 19.672 9.649 19.672 11.75 Z M 2 11.75 C 2 14.3359 3.027 16.8158 4.856 18.6443 C 6.684 20.4728 9.164 21.5 11.75 21.5 C 14.336 21.5 16.816 20.4728 18.644 18.6443 C 20.473 16.8158 21.5 14.3359 21.5 11.75 C 21.5 9.1641 20.473 6.6842 18.644 4.8557 C 16.816 3.0272 14.336 2 11.75 2 C 9.164 2 6.684 3.0272 4.856 4.8557 C 3.027 6.6842 2 9.1641 2 11.75 Z M 10.836 6.5703 V 8.7298 L 10.074 7.5872 C 9.792 7.1683 9.225 7.054 8.806 7.332 C 8.387 7.6101 8.273 8.1813 8.551 8.6003 L 10.988 12.2565 C 11.213 12.5917 11.628 12.7402 12.013 12.626 C 12.397 12.5117 12.66 12.1537 12.66 11.75 V 6.5703 C 12.66 6.0638 12.253 5.6562 11.746 5.6562 C 11.24 5.6562 10.832 6.0638 10.832 6.5703 H 10.836 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function e5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M9 5.31034C9.47739 5.31034 9.93523 5.1069 10.2728 4.74476C10.6104 4.38262 10.8 3.89145 10.8 3.37931C10.8 2.86717 10.6104 2.376 10.2728 2.01386C9.93523 1.65172 9.47739 1.44828 9 1.44828C8.52261 1.44828 8.06477 1.65172 7.72721 2.01386C7.38964 2.376 7.2 2.86717 7.2 3.37931C7.2 3.89145 7.38964 4.38262 7.72721 4.74476C8.06477 5.1069 8.52261 5.31034 9 5.31034ZM9 0C9.83543 0 10.6366 0.356033 11.2274 0.989777C11.8181 1.62352 12.15 2.48306 12.15 3.37931C12.15 4.27556 11.8181 5.1351 11.2274 5.76884C10.6366 6.40259 9.83543 6.75862 9 6.75862C8.16457 6.75862 7.36335 6.40259 6.77261 5.76884C6.18187 5.1351 5.85 4.27556 5.85 3.37931C5.85 2.48306 6.18187 1.62352 6.77261 0.989777C7.36335 0.356033 8.16457 0 9 0ZM8.325 9.65517C6.71062 9.65517 5.4 11.0612 5.4 12.7931V13.2759C5.4 13.6772 5.09906 14 4.725 14C4.35094 14 4.05 13.6772 4.05 13.2759V12.7931C4.05 10.2616 5.96531 8.2069 8.325 8.2069H9.675C12.0347 8.2069 13.95 10.2616 13.95 12.7931V13.2759C13.95 13.6772 13.6491 14 13.275 14C12.9009 14 12.6 13.6772 12.6 13.2759V12.7931C12.6 11.0612 11.2894 9.65517 9.675 9.65517H8.325ZM12.1331 6.8431C12.4622 6.50216 12.7406 6.1069 12.96 5.67241C13.1259 5.75086 13.3087 5.7931 13.5 5.7931C14.2453 5.7931 14.85 5.1444 14.85 4.34483C14.85 3.54526 14.2453 2.89655 13.5 2.89655H13.4775C13.4325 2.39569 13.3144 1.91897 13.1372 1.47543C13.2553 1.45733 13.3791 1.44828 13.5 1.44828C14.9906 1.44828 16.2 2.74569 16.2 4.34483C16.2 5.94397 14.9906 7.24138 13.5 7.24138C13.0022 7.24138 12.5353 7.09655 12.1331 6.8431ZM4.5 1.44828C4.62375 1.44828 4.74469 1.45733 4.86281 1.47543C4.68562 1.91897 4.5675 2.39871 4.5225 2.89655H4.5C3.75469 2.89655 3.15 3.54526 3.15 4.34483C3.15 5.1444 3.75469 5.7931 4.5 5.7931C4.69125 5.7931 4.87406 5.75086 5.04 5.67241C5.25937 6.1069 5.53781 6.50216 5.86688 6.8431C5.4675 7.09655 5.00062 7.24138 4.5 7.24138C3.00937 7.24138 1.8 5.94397 1.8 4.34483C1.8 2.74569 3.00937 1.44828 4.5 1.44828ZM4.19906 8.68966C3.77437 9.18147 3.42563 9.74569 3.1725 10.3672C2.10375 10.8349 1.35 11.9603 1.35 13.2759C1.35 13.6772 1.04906 14 0.675 14C0.300937 14 0 13.6772 0 13.2759C0 10.7685 1.87313 8.7319 4.19906 8.68966ZM14.8275 10.3672C14.5744 9.74569 14.2228 9.17845 13.8009 8.68966C16.1269 8.7319 18 10.7685 18 13.2759C18 13.6772 17.6991 14 17.325 14C16.9509 14 16.65 13.6772 16.65 13.2759C16.65 11.9603 15.8962 10.8349 14.8275 10.3672Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function t5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M11.875 3.875H7.5C7.15625 3.875 6.875 4.15625 6.875 4.5V19.5C6.875 19.8438 7.15625 20.125 7.5 20.125H17.5C17.8438 20.125 18.125 19.8438 18.125 19.5V10.125H14.6875C13.1328 10.125 11.875 8.86719 11.875 7.3125V3.875ZM17.3477 8.25L13.75 4.65234V7.3125C13.75 7.83203 14.168 8.25 14.6875 8.25H17.3477ZM5 4.5C5 3.12109 6.12109 2 7.5 2H12.7148C13.3789 2 14.0156 2.26172 14.4844 2.73047L19.2695 7.51953C19.7383 7.98828 20 8.625 20 9.28906V19.5C20 20.8789 18.8789 22 17.5 22H7.5C6.12109 22 5 20.8789 5 19.5V4.5Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function n5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M17.366 12.0832C16.2569 12.0832 15.3571 11.15 15.3571 9.99987C15.3571 8.84971 16.2569 7.91656 17.366 7.91656C18.4751 7.91656 19.3749 8.84971 19.3749 9.99987C19.3749 11.15 18.4751 12.0832 17.366 12.0832ZM10 7.91656C11.1091 7.91656 12.0089 8.84971 12.0089 9.99987C12.0089 11.15 11.1091 12.0832 10 12.0832C8.89092 12.0832 7.99109 11.15 7.99109 9.99987C7.99109 8.84971 8.89092 7.91656 10 7.91656ZM2.634 12.0832C1.52492 12.0832 0.625095 11.15 0.625095 9.99987C0.625095 8.84971 1.52492 7.91656 2.634 7.91656C3.74309 7.91656 4.64291 8.84971 4.64291 9.99987C4.64291 11.15 3.74309 12.0832 2.634 12.0832Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function o5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M12.0833 2.634C12.0833 3.74309 11.1502 4.64291 10 4.64291C8.84984 4.64291 7.91669 3.74309 7.91669 2.634C7.91669 1.52492 8.84984 0.625095 10 0.625095C11.1502 0.625095 12.0833 1.52492 12.0833 2.634ZM7.91669 10C7.91669 8.89092 8.84984 7.99109 10 7.99109C11.1502 7.99109 12.0833 8.89092 12.0833 10C12.0833 11.1091 11.1502 12.0089 10 12.0089C8.84984 12.0089 7.91669 11.1091 7.91669 10ZM12.0833 17.366C12.0833 18.4751 11.1502 19.3749 10 19.3749C8.84984 19.3749 7.91669 18.4751 7.91669 17.366C7.91669 16.2569 8.84984 15.3571 10 15.3571C11.1502 15.3571 12.0833 16.2569 12.0833 17.366Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function r5(t) {
  const e = W.c(4);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: "clip2_9481_7966", children: /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }) }) }), e[0] = n) : n = e[0];
  let o;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("g", { clipPath: "url(#clip2_9481_7966)", children: /* @__PURE__ */ g("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 14.3999 C 11.682 14.3999 11.376 14.5263 11.151 14.7514 C 10.926 14.9764 10.8 15.2816 10.8 15.5999 C 10.8 15.9182 10.926 16.2234 11.151 16.4484 C 11.376 16.6735 11.682 16.7999 12 16.7999 C 12.318 16.7999 12.623 16.6735 12.848 16.4484 C 13.073 16.2234 13.2 15.9182 13.2 15.5999 C 13.2 15.2816 13.073 14.9764 12.848 14.7514 C 12.623 14.5263 12.318 14.3999 12 14.3999 Z M 12 7.1999 C 11.317 7.1999 10.774 7.7812 10.822 8.4637 L 11.1 12.3637 C 11.134 12.8362 11.527 13.1999 11.996 13.1999 C 12.469 13.1999 12.859 12.8362 12.892 12.3637 L 13.17 8.4637 C 13.219 7.7812 12.679 7.1999 11.992 7.1999 H 12 Z", fill: "currentColor" }) }), e[1] = o) : o = e[1];
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function i5(t) {
  const e = W.c(4);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: "clip2_9481_7947", children: /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }) }) }), e[0] = n) : n = e[0];
  let o;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("g", { clipPath: "url(#clip2_9481_7947)", children: /* @__PURE__ */ g("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 4.1999 C 9.931 4.1999 7.947 5.0217 6.484 6.4845 C 5.022 7.9473 4.2 9.9312 4.2 11.9999 C 4.2 14.0686 5.022 16.0526 6.484 17.5153 C 7.947 18.9781 9.931 19.7999 12 19.7999 C 14.069 19.7999 16.053 18.9781 17.515 17.5153 C 18.978 16.0526 19.8 14.0686 19.8 11.9999 C 19.8 9.9312 18.978 7.9473 17.515 6.4845 C 16.053 5.0217 14.069 4.1999 12 4.1999 Z M 12 16.7999 C 11.682 16.7999 11.376 16.6735 11.151 16.4484 C 10.926 16.2234 10.8 15.9182 10.8 15.5999 C 10.8 15.2816 10.926 14.9764 11.151 14.7514 C 11.376 14.5263 11.682 14.3999 12 14.3999 C 12.318 14.3999 12.623 14.5263 12.848 14.7514 C 13.073 14.9764 13.2 15.2816 13.2 15.5999 C 13.2 15.9182 13.073 16.2234 12.848 16.4484 C 12.623 16.6735 12.318 16.7999 12 16.7999 Z M 12 7.1999 C 12.682 7.1999 13.226 7.7812 13.177 8.4637 L 12.9 12.3637 C 12.866 12.8362 12.472 13.1999 12.004 13.1999 C 11.531 13.1999 11.141 12.8362 11.107 12.3637 L 10.83 8.4637 C 10.774 7.7812 11.317 7.1999 12 7.1999 Z", fill: "currentColor" }) }), e[1] = o) : o = e[1];
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function s5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.998 5.3214 C 9.508 5.3214 7.461 6.4446 5.891 7.8904 C 4.421 9.2489 3.405 10.8616 2.886 12 C 3.405 13.1384 4.421 14.7511 5.888 16.1096 C 7.461 17.5554 9.508 18.6786 11.998 18.6786 C 14.488 18.6786 16.535 17.5554 18.105 16.1096 C 19.575 14.7511 20.591 13.1384 21.11 12 C 20.591 10.8616 19.575 9.2489 18.109 7.8904 C 16.535 6.4446 14.488 5.3214 11.998 5.3214 Z M 4.642 6.5585 C 6.441 4.8964 8.912 3.5 11.998 3.5 C 15.084 3.5 17.555 4.8964 19.354 6.5585 C 21.141 8.2092 22.336 10.1786 22.905 11.5333 C 23.032 11.833 23.032 12.167 22.905 12.4667 C 22.336 13.8214 21.141 15.7946 19.354 17.4415 C 17.555 19.1036 15.084 20.5 11.998 20.5 C 8.912 20.5 6.441 19.1036 4.642 17.4415 C 2.855 15.7946 1.66 13.8214 1.095 12.4667 C 0.968 12.167 0.968 11.833 1.095 11.5333 C 1.66 10.1786 2.855 8.2054 4.642 6.5585 Z M 11.998 15.0357 C 13.686 15.0357 15.053 13.6772 15.053 12 C 15.053 10.3228 13.686 8.9643 11.998 8.9643 C 11.971 8.9643 11.948 8.9643 11.922 8.9643 C 11.971 9.1578 11.998 9.3627 11.998 9.5714 C 11.998 10.9109 10.902 12 9.554 12 C 9.344 12 9.138 11.9734 8.943 11.9241 C 8.943 11.9507 8.943 11.9734 8.943 12 C 8.943 13.6772 10.31 15.0357 11.998 15.0357 Z M 11.998 7.1429 C 13.295 7.1429 14.538 7.6546 15.455 8.5655 C 16.372 9.4764 16.887 10.7118 16.887 12 C 16.887 13.2882 16.372 14.5236 15.455 15.4345 C 14.538 16.3454 13.295 16.8571 11.998 16.8571 C 10.702 16.8571 9.458 16.3454 8.541 15.4345 C 7.625 14.5236 7.11 13.2882 7.11 12 C 7.11 10.7118 7.625 9.4764 8.541 8.5655 C 9.458 7.6546 10.702 7.1429 11.998 7.1429 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function l5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M3.88889 2.25C3.88889 1.00898 4.88542 0 6.11111 0H13.8889C15.1146 0 16.1111 1.00898 16.1111 2.25V6.75H17.7778C19.0035 6.75 20 7.75898 20 9V15.75C20 16.991 19.0035 18 17.7778 18H2.22222C0.996528 18 0 16.991 0 15.75V5.625C0 4.38398 0.996528 3.375 2.22222 3.375H3.88889V2.25ZM6.11111 1.6875C5.80556 1.6875 5.55556 1.94062 5.55556 2.25V4.21875C5.55556 4.68633 5.18403 5.0625 4.72222 5.0625H2.22222C1.91667 5.0625 1.66667 5.31563 1.66667 5.625V15.75C1.66667 16.0594 1.91667 16.3125 2.22222 16.3125H8.33333V13.5C8.33333 12.8777 8.82986 12.375 9.44444 12.375H10.5556C11.1701 12.375 11.6667 12.8777 11.6667 13.5V16.3125H17.7778C18.0833 16.3125 18.3333 16.0594 18.3333 15.75V9C18.3333 8.69063 18.0833 8.4375 17.7778 8.4375H15.2778C14.816 8.4375 14.4444 8.06133 14.4444 7.59375V2.25C14.4444 1.94062 14.1944 1.6875 13.8889 1.6875H6.11111ZM10.5556 3.9375C10.5556 3.62812 10.8056 3.375 11.1111 3.375H12.2222C12.5278 3.375 12.7778 3.62812 12.7778 3.9375V5.0625C12.7778 5.37187 12.5278 5.625 12.2222 5.625H11.1111C10.8056 5.625 10.5556 5.37187 10.5556 5.0625V3.9375ZM7.77778 3.375H8.88889C9.19444 3.375 9.44444 3.62812 9.44444 3.9375V5.0625C9.44444 5.37187 9.19444 5.625 8.88889 5.625H7.77778C7.47222 5.625 7.22222 5.37187 7.22222 5.0625V3.9375C7.22222 3.62812 7.47222 3.375 7.77778 3.375ZM10.5556 7.3125C10.5556 7.00313 10.8056 6.75 11.1111 6.75H12.2222C12.5278 6.75 12.7778 7.00313 12.7778 7.3125V8.4375C12.7778 8.74687 12.5278 9 12.2222 9H11.1111C10.8056 9 10.5556 8.74687 10.5556 8.4375V7.3125ZM7.77778 6.75H8.88889C9.19444 6.75 9.44444 7.00313 9.44444 7.3125V8.4375C9.44444 8.74687 9.19444 9 8.88889 9H7.77778C7.47222 9 7.22222 8.74687 7.22222 8.4375V7.3125C7.22222 7.00313 7.47222 6.75 7.77778 6.75ZM3.33333 7.3125C3.33333 7.00313 3.58333 6.75 3.88889 6.75H5C5.30556 6.75 5.55556 7.00313 5.55556 7.3125V8.4375C5.55556 8.74687 5.30556 9 5 9H3.88889C3.58333 9 3.33333 8.74687 3.33333 8.4375V7.3125ZM3.88889 10.125H5C5.30556 10.125 5.55556 10.3781 5.55556 10.6875V11.8125C5.55556 12.1219 5.30556 12.375 5 12.375H3.88889C3.58333 12.375 3.33333 12.1219 3.33333 11.8125V10.6875C3.33333 10.3781 3.58333 10.125 3.88889 10.125ZM15 10.125H16.1111C16.4167 10.125 16.6667 10.3781 16.6667 10.6875V11.8125C16.6667 12.1219 16.4167 12.375 16.1111 12.375H15C14.6944 12.375 14.4444 12.1219 14.4444 11.8125V10.6875C14.4444 10.3781 14.6944 10.125 15 10.125Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function a5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 4.32 7.131 C 4.32 6.639 4.719 6.24 5.211 6.24 H 18.792 C 19.284 6.24 19.683 6.639 19.683 7.131 C 19.683 7.368 19.59 7.593 19.422 7.761 L 14.4 12.777 V 18.789 C 14.4 19.281 14.001 19.68 13.509 19.68 C 13.272 19.68 13.047 19.587 12.879 19.419 L 9.81 16.35 C 9.675 16.215 9.6 16.032 9.6 15.84 V 12.777 L 4.581 7.758 C 4.413 7.593 4.32 7.365 4.32 7.131 Z M 6.537 7.68 L 10.83 11.97 C 10.965 12.105 11.04 12.288 11.04 12.48 V 15.543 L 12.96 17.463 V 12.48 C 12.96 12.288 13.035 12.105 13.17 11.97 L 17.46 7.68 H 6.537 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function c5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M6.87493 0.937491C6.87493 0.417965 6.45697 0 5.93744 0C5.41791 0 4.99995 0.417965 4.99995 0.937491V2.49997C3.62106 2.49997 2.49997 3.62106 2.49997 4.99995H0.937491C0.417965 4.99995 0 5.41791 0 5.93744C0 6.45697 0.417965 6.87493 0.937491 6.87493H2.49997V9.06241H0.937491C0.417965 9.06241 0 9.48037 0 9.9999C0 10.5194 0.417965 10.9374 0.937491 10.9374H2.49997V13.1249H0.937491C0.417965 13.1249 0 13.5428 0 14.0624C0 14.5819 0.417965 14.9998 0.937491 14.9998H2.49997C2.49997 16.3787 3.62106 17.4998 4.99995 17.4998V19.0623C4.99995 19.5818 5.41791 19.9998 5.93744 19.9998C6.45697 19.9998 6.87493 19.5818 6.87493 19.0623V17.4998H9.06241V19.0623C9.06241 19.5818 9.48037 19.9998 9.9999 19.9998C10.5194 19.9998 10.9374 19.5818 10.9374 19.0623V17.4998H13.1249V19.0623C13.1249 19.5818 13.5428 19.9998 14.0624 19.9998C14.5819 19.9998 14.9998 19.5818 14.9998 19.0623V17.4998C16.3787 17.4998 17.4998 16.3787 17.4998 14.9998H19.0623C19.5818 14.9998 19.9998 14.5819 19.9998 14.0624C19.9998 13.5428 19.5818 13.1249 19.0623 13.1249H17.4998V10.9374H19.0623C19.5818 10.9374 19.9998 10.5194 19.9998 9.9999C19.9998 9.48037 19.5818 9.06241 19.0623 9.06241H17.4998V6.87493H19.0623C19.5818 6.87493 19.9998 6.45697 19.9998 5.93744C19.9998 5.41791 19.5818 4.99995 19.0623 4.99995H17.4998C17.4998 3.62106 16.3787 2.49997 14.9998 2.49997V0.937491C14.9998 0.417965 14.5819 0 14.0624 0C13.5428 0 13.1249 0.417965 13.1249 0.937491V2.49997H10.9374V0.937491C10.9374 0.417965 10.5194 0 9.9999 0C9.48037 0 9.06241 0.417965 9.06241 0.937491V2.49997H6.87493V0.937491ZM15.6248 4.99995V14.9998C15.6248 15.3436 15.3436 15.6248 14.9998 15.6248H4.99995C4.6562 15.6248 4.37496 15.3436 4.37496 14.9998V4.99995C4.37496 4.6562 4.6562 4.37496 4.99995 4.37496H14.9998C15.3436 4.37496 15.6248 4.6562 15.6248 4.99995ZM7.49992 6.24994C6.80852 6.24994 6.24994 6.80852 6.24994 7.49992V12.4999C6.24994 13.1913 6.80852 13.7499 7.49992 13.7499H12.4999C13.1913 13.7499 13.7499 13.1913 13.7499 12.4999V7.49992C13.7499 6.80852 13.1913 6.24994 12.4999 6.24994H7.49992ZM8.12492 8.12492H11.8749V11.8749H8.12492V8.12492Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function u5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.378 2.2403 C 11.734 1.9199 12.273 1.9199 12.628 2.2403 L 21.688 10.3661 C 22.075 10.7098 22.106 11.3036 21.759 11.6904 C 21.411 12.0772 20.821 12.1084 20.435 11.7607 L 20.122 11.4794 V 19.4998 C 20.122 20.8788 19.001 22 17.623 22 H 6.376 C 4.997 22 3.876 20.8788 3.876 19.4998 V 11.4794 L 3.564 11.7607 C 3.177 12.1045 2.588 12.0732 2.24 11.6904 C 1.893 11.3075 1.928 10.7137 2.31 10.3661 L 11.378 2.2403 Z M 12.003 4.1975 L 5.755 9.8035 V 19.5037 C 5.755 19.8474 6.036 20.1287 6.38 20.1287 H 8.254 V 16.0658 C 8.254 14.511 9.512 13.2531 11.066 13.2531 H 12.94 C 14.495 13.2531 15.752 14.511 15.752 16.0658 V 20.1287 H 17.627 C 17.97 20.1287 18.252 19.8474 18.252 19.5037 V 9.8035 L 12.003 4.2014 V 4.1975 Z M 10.129 20.1287 H 13.878 V 16.0658 C 13.878 15.5462 13.46 15.1282 12.94 15.1282 H 11.066 C 10.547 15.1282 10.129 15.5462 10.129 16.0658 V 20.1287 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function d5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 19.5 5.375 C 19.844 5.375 20.125 5.6562 20.125 6 V 18.4922 L 19.93 18.2383 L 14.617 11.3633 C 14.441 11.1328 14.164 11 13.875 11 C 13.586 11 13.312 11.1328 13.133 11.3633 L 9.891 15.5586 L 8.699 13.8906 C 8.523 13.6445 8.242 13.5 7.938 13.5 C 7.633 13.5 7.352 13.6445 7.176 13.8945 L 4.051 18.2695 L 3.875 18.5117 V 18.5 V 6 C 3.875 5.6562 4.156 5.375 4.5 5.375 H 19.5 Z M 4.5 3.5 C 3.121 3.5 2 4.6211 2 6 V 18.5 C 2 19.8789 3.121 21 4.5 21 H 19.5 C 20.879 21 22 19.8789 22 18.5 V 6 C 22 4.6211 20.879 3.5 19.5 3.5 H 4.5 Z M 7.625 11 C 7.871 11 8.115 10.9515 8.343 10.8573 C 8.57 10.763 8.777 10.6249 8.951 10.4508 C 9.125 10.2767 9.263 10.07 9.357 9.8425 C 9.452 9.615 9.5 9.3712 9.5 9.125 C 9.5 8.8788 9.452 8.635 9.357 8.4075 C 9.263 8.18 9.125 7.9733 8.951 7.7992 C 8.777 7.6251 8.57 7.487 8.343 7.3927 C 8.115 7.2985 7.871 7.25 7.625 7.25 C 7.379 7.25 7.135 7.2985 6.907 7.3927 C 6.68 7.487 6.473 7.6251 6.299 7.7992 C 6.125 7.9733 5.987 8.18 5.893 8.4075 C 5.798 8.635 5.75 8.8788 5.75 9.125 C 5.75 9.3712 5.798 9.615 5.893 9.8425 C 5.987 10.07 6.125 10.2767 6.299 10.4508 C 6.473 10.6249 6.68 10.763 6.907 10.8573 C 7.135 10.9515 7.379 11 7.625 11 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function f5(t) {
  const e = W.c(4);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: "clip2_9481_7782", children: /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }) }) }), e[0] = n) : n = e[0];
  let o;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("g", { clipPath: "url(#clip2_9481_7782)", children: /* @__PURE__ */ g("path", { d: "M 9.12 5.5198 C 9.519 5.5198 9.84 5.8408 9.84 6.2398 C 9.84 6.6388 9.519 6.9598 9.12 6.9598 C 8.721 6.9598 8.4 6.6388 8.4 6.2398 C 8.4 5.8408 8.721 5.5198 9.12 5.5198 Z M 9.12 8.1598 C 9.153 8.1598 9.186 8.1598 9.219 8.1568 L 10.026 9.8848 C 9.087 10.5358 8.415 11.5468 8.22 12.7198 H 6.102 C 5.817 12.0148 5.127 11.5198 4.323 11.5198 C 3.264 11.5198 2.403 12.3808 2.403 13.4398 C 2.403 14.4988 3.264 15.3598 4.323 15.3598 C 5.13 15.3598 5.82 14.8648 6.102 14.1598 H 8.22 C 8.562 16.2028 10.341 17.7598 12.48 17.7598 C 13.794 17.7598 14.97 17.1748 15.762 16.2478 L 17.784 17.4598 C 17.769 17.5558 17.76 17.6578 17.76 17.7568 C 17.76 18.8158 18.621 19.6768 19.68 19.6768 C 20.739 19.6768 21.6 18.8158 21.6 17.7568 C 21.6 16.6978 20.739 15.8368 19.68 15.8368 C 19.245 15.8368 18.846 15.9808 18.525 16.2238 L 16.506 15.0118 C 16.698 14.5228 16.803 13.9918 16.803 13.4368 C 16.803 12.7408 16.638 12.0808 16.344 11.4988 L 18.672 9.7918 C 18.966 9.9748 19.311 10.0798 19.683 10.0798 C 20.742 10.0798 21.603 9.2188 21.603 8.1598 C 21.603 7.1008 20.742 6.2398 19.683 6.2398 C 18.624 6.2398 17.763 7.1008 17.763 8.1598 C 17.763 8.3218 17.784 8.4808 17.82 8.6308 L 15.492 10.3378 C 14.715 9.5818 13.653 9.1168 12.483 9.1168 C 12.084 9.1168 11.7 9.1708 11.334 9.2728 L 10.527 7.5478 C 10.845 7.2058 11.04 6.7468 11.04 6.2398 C 11.04 5.1808 10.179 4.3198 9.12 4.3198 C 8.061 4.3198 7.2 5.1808 7.2 6.2398 C 7.2 7.2988 8.061 8.1598 9.12 8.1598 Z M 19.68 7.4398 C 20.079 7.4398 20.4 7.7608 20.4 8.1598 C 20.4 8.5588 20.079 8.8798 19.68 8.8798 C 19.281 8.8798 18.96 8.5588 18.96 8.1598 C 18.96 7.7608 19.281 7.4398 19.68 7.4398 Z M 18.96 17.7598 C 18.96 17.3608 19.281 17.0398 19.68 17.0398 C 20.079 17.0398 20.4 17.3608 20.4 17.7598 C 20.4 18.1588 20.079 18.4798 19.68 18.4798 C 19.281 18.4798 18.96 18.1588 18.96 17.7598 Z M 4.32 12.7198 C 4.719 12.7198 5.04 13.0408 5.04 13.4398 C 5.04 13.8388 4.719 14.1598 4.32 14.1598 C 3.921 14.1598 3.6 13.8388 3.6 13.4398 C 3.6 13.0408 3.921 12.7198 4.32 12.7198 Z M 12.48 10.5598 C 14.07 10.5598 15.36 11.8498 15.36 13.4398 C 15.36 15.0298 14.07 16.3198 12.48 16.3198 C 10.89 16.3198 9.6 15.0298 9.6 13.4398 C 9.6 11.8498 10.89 10.5598 12.48 10.5598 Z", fill: "currentColor" }) }), e[1] = o) : o = e[1];
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function p5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M0.91935 0C0.409877 0 0 0.409877 0 0.91935V2.75805C0 3.26752 0.409877 3.6774 0.91935 3.6774H2.75805C3.26752 3.6774 3.6774 3.26752 3.6774 2.75805V0.91935C3.6774 0.409877 3.26752 0 2.75805 0H0.91935ZM6.43545 0.91935C5.92598 0.91935 5.5161 1.32923 5.5161 1.8387C5.5161 2.34817 5.92598 2.75805 6.43545 2.75805H18.0806C18.59 2.75805 18.9999 2.34817 18.9999 1.8387C18.9999 1.32923 18.59 0.91935 18.0806 0.91935H6.43545ZM6.43545 7.04835C5.92598 7.04835 5.5161 7.45823 5.5161 7.9677C5.5161 8.47717 5.92598 8.88705 6.43545 8.88705H18.0806C18.59 8.88705 18.9999 8.47717 18.9999 7.9677C18.9999 7.45823 18.59 7.04835 18.0806 7.04835H6.43545ZM6.43545 13.1774C5.92598 13.1774 5.5161 13.5872 5.5161 14.0967C5.5161 14.6062 5.92598 15.0161 6.43545 15.0161H18.0806C18.59 15.0161 18.9999 14.6062 18.9999 14.0967C18.9999 13.5872 18.59 13.1774 18.0806 13.1774H6.43545ZM0 7.04835V8.88705C0 9.39652 0.409877 9.8064 0.91935 9.8064H2.75805C3.26752 9.8064 3.6774 9.39652 3.6774 8.88705V7.04835C3.6774 6.53888 3.26752 6.129 2.75805 6.129H0.91935C0.409877 6.129 0 6.53888 0 7.04835ZM0.91935 12.258C0.409877 12.258 0 12.6679 0 13.1774V15.0161C0 15.5255 0.409877 15.9354 0.91935 15.9354H2.75805C3.26752 15.9354 3.6774 15.5255 3.6774 15.0161V13.1774C3.6774 12.6679 3.26752 12.258 2.75805 12.258H0.91935Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 19 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function m5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 6.6 9.4725 C 6.6 10.5263 6.941 11.76 7.56 13.0913 C 8.171 14.4075 9 15.72 9.859 16.8975 C 10.62 17.9475 11.389 18.8663 12.004 19.5638 C 12.619 18.8663 13.384 17.9475 14.149 16.8975 C 15.007 15.72 15.836 14.4075 16.447 13.0913 C 17.062 11.76 17.407 10.5263 17.407 9.4725 C 17.407 6.5925 15.019 4.2 12.007 4.2 C 8.996 4.2 6.6 6.5888 6.6 9.4725 Z M 19.2 9.4725 C 19.2 13.6425 15.289 18.5775 13.234 20.8875 C 12.851 21.3188 12.532 21.6563 12.315 21.8813 C 12.116 22.0875 12 22.2 12 22.2 C 12 22.2 11.887 22.0875 11.685 21.8813 C 11.467 21.6563 11.149 21.315 10.766 20.8875 C 8.711 18.5775 4.8 13.6425 4.8 9.4725 C 4.8 5.565 8.025 2.4 12 2.4 C 15.975 2.4 19.2 5.565 19.2 9.4725 Z M 13.2 9.6 C 13.2 9.2818 13.073 8.9765 12.848 8.7515 C 12.623 8.5265 12.318 8.4 12 8.4 C 11.682 8.4 11.376 8.5265 11.151 8.7515 C 10.926 8.9765 10.8 9.2818 10.8 9.6 C 10.8 9.9183 10.926 10.2235 11.151 10.4486 C 11.376 10.6736 11.682 10.8 12 10.8 C 12.318 10.8 12.623 10.6736 12.848 10.4486 C 13.073 10.2235 13.2 9.9183 13.2 9.6 Z M 9 9.6 C 9 8.8044 9.316 8.0413 9.878 7.4787 C 10.441 6.9161 11.204 6.6 12 6.6 C 12.795 6.6 13.559 6.9161 14.121 7.4787 C 14.684 8.0413 15 8.8044 15 9.6 C 15 10.3957 14.684 11.1587 14.121 11.7213 C 13.559 12.284 12.795 12.6 12 12.6 C 11.204 12.6 10.441 12.284 9.878 11.7213 C 9.316 11.1587 9 10.3957 9 9.6 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function g5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 9.378 8.5091 C 9.378 5.1346 12.113 2.4 15.487 2.4 C 16.473 2.4 17.407 2.6328 18.233 3.0509 C 18.484 3.1782 18.658 3.4146 18.702 3.6909 C 18.745 3.9673 18.654 4.2473 18.458 4.4473 L 15.778 7.1273 V 8.2218 H 16.873 L 19.553 5.5418 C 19.749 5.3455 20.033 5.2546 20.309 5.2982 C 20.585 5.3418 20.825 5.5164 20.949 5.7673 C 21.364 6.5928 21.6 7.5273 21.6 8.5128 C 21.6 11.8873 18.865 14.6218 15.491 14.6218 C 14.887 14.6218 14.302 14.5346 13.749 14.3709 L 7.364 20.7491 C 6.229 21.8837 4.385 21.8837 3.251 20.7491 C 2.116 19.6146 2.116 17.7709 3.251 16.6364 L 9.629 10.2509 C 9.465 9.6982 9.378 9.1128 9.378 8.5091 Z M 15.487 4.1455 C 13.076 4.1455 11.124 6.0982 11.124 8.5091 C 11.124 9.0909 11.236 9.6473 11.444 10.1528 C 11.574 10.4764 11.502 10.8509 11.251 11.0982 L 4.48 17.8691 C 4.025 18.3237 4.025 19.0618 4.48 19.5164 C 4.934 19.9709 5.673 19.9709 6.127 19.5164 L 12.898 12.7455 C 13.145 12.4982 13.52 12.4218 13.844 12.5528 C 14.349 12.76 14.905 12.8728 15.487 12.8728 C 17.898 12.8728 19.851 10.92 19.851 8.5091 C 19.851 8.2582 19.829 8.0109 19.789 7.7709 L 17.851 9.7091 C 17.687 9.8728 17.465 9.9637 17.233 9.9637 H 14.905 C 14.422 9.9637 14.033 9.5746 14.033 9.0909 V 6.7637 C 14.033 6.5309 14.124 6.3091 14.287 6.1455 L 16.225 4.2073 C 15.985 4.1673 15.738 4.1455 15.487 4.1455 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function h5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 5.28 6.96 C 5.28 6.561 5.601 6.24 6 6.24 H 18 C 18.399 6.24 18.72 6.561 18.72 6.96 C 18.72 7.359 18.399 7.68 18 7.68 H 6 C 5.601 7.68 5.28 7.359 5.28 6.96 Z M 5.28 12 C 5.28 11.601 5.601 11.28 6 11.28 H 18 C 18.399 11.28 18.72 11.601 18.72 12 C 18.72 12.399 18.399 12.72 18 12.72 H 6 C 5.601 12.72 5.28 12.399 5.28 12 Z M 18.72 17.04 C 18.72 17.439 18.399 17.76 18 17.76 H 6 C 5.601 17.76 5.28 17.439 5.28 17.04 C 5.28 16.641 5.601 16.32 6 16.32 H 18 C 18.399 16.32 18.72 16.641 18.72 17.04 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function b5(t) {
  const e = W.c(4);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("defs", { children: /* @__PURE__ */ g("clipPath", { id: "clip2_9481_7085", children: /* @__PURE__ */ g("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.4)" }) }) }), e[0] = n) : n = e[0];
  let o;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("g", { clipPath: "url(#clip2_9481_7085)", children: /* @__PURE__ */ g("path", { d: "M 15.12 5.76 C 15.12 6.024 14.904 6.24 14.64 6.24 H 12.48 V 8.16 H 15.84 C 16.899 8.16 17.76 9.021 17.76 10.08 V 10.581 C 17.445 10.554 17.115 10.554 16.8 10.581 V 10.08 C 16.8 9.549 16.371 9.12 15.84 9.12 H 8.16 C 7.629 9.12 7.2 9.549 7.2 10.08 V 13.92 C 7.2 14.451 7.629 14.88 8.16 14.88 H 9.12 C 9.27 14.88 9.414 14.952 9.504 15.072 L 10.512 16.416 C 10.692 16.659 10.977 16.8 11.28 16.8 H 11.541 C 11.568 17.13 11.622 17.448 11.703 17.76 H 11.283 C 10.68 17.76 10.11 17.475 9.747 16.992 L 8.88 15.84 H 8.16 C 7.101 15.84 6.24 14.979 6.24 13.92 V 12.48 H 5.28 V 14.88 C 5.28 15.144 5.064 15.36 4.8 15.36 C 4.536 15.36 4.32 15.144 4.32 14.88 V 9.12 C 4.32 8.856 4.536 8.64 4.8 8.64 C 5.064 8.64 5.28 8.856 5.28 9.12 V 11.52 H 6.24 V 10.08 C 6.24 9.021 7.101 8.16 8.16 8.16 H 11.52 V 6.24 H 9.36 C 9.096 6.24 8.88 6.024 8.88 5.76 C 8.88 5.496 9.096 5.28 9.36 5.28 H 14.64 C 14.904 5.28 15.12 5.496 15.12 5.76 Z M 18.72 10.74 V 9.6 C 18.72 9.336 18.936 9.12 19.2 9.12 C 19.464 9.12 19.68 9.336 19.68 9.6 V 11.082 C 19.374 10.941 19.053 10.827 18.72 10.74 Z M 14.4 11.04 C 14.523 11.04 14.634 11.085 14.718 11.16 C 14.265 11.385 13.845 11.67 13.47 12 H 9.6 C 9.336 12 9.12 11.784 9.12 11.52 C 9.12 11.256 9.336 11.04 9.6 11.04 H 14.4 Z M 20.64 16.32 C 20.64 14.463 19.137 12.96 17.28 12.96 C 15.423 12.96 13.92 14.463 13.92 16.32 C 13.92 18.177 15.423 19.68 17.28 19.68 C 19.137 19.68 20.64 18.177 20.64 16.32 Z M 12.96 16.32 C 12.96 13.935 14.895 12 17.28 12 C 19.665 12 21.6 13.935 21.6 16.32 C 21.6 18.705 19.665 20.64 17.28 20.64 C 14.895 20.64 12.96 18.705 12.96 16.32 Z M 17.28 17.64 C 17.61 17.64 17.88 17.91 17.88 18.24 C 17.88 18.57 17.61 18.84 17.28 18.84 C 16.95 18.84 16.68 18.57 16.68 18.24 C 16.68 17.91 16.95 17.64 17.28 17.64 Z M 17.28 13.92 C 17.544 13.92 17.76 14.136 17.76 14.4 V 16.32 C 17.76 16.584 17.544 16.8 17.28 16.8 C 17.016 16.8 16.8 16.584 16.8 16.32 V 14.4 C 16.8 14.136 17.016 13.92 17.28 13.92 Z", fill: "currentColor" }) }), e[1] = o) : o = e[1];
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function v5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12 4.3199 C 11.601 4.3199 11.28 4.6409 11.28 5.0399 V 5.3309 C 8.838 5.6789 6.96 7.7819 6.96 10.3199 V 10.7549 C 6.96 11.8859 6.66 12.9959 6.09 13.9739 L 5.433 15.0959 C 5.334 15.2699 5.28 15.4649 5.28 15.6659 C 5.28 16.2929 5.787 16.7999 6.414 16.7999 H 17.586 C 18.213 16.7999 18.72 16.2929 18.72 15.6659 C 18.72 15.4649 18.666 15.2669 18.567 15.0959 L 17.91 13.9709 C 17.34 12.9929 17.04 11.8829 17.04 10.7519 V 10.3169 C 17.04 7.7789 15.162 5.6759 12.72 5.3279 V 5.0369 C 12.72 4.6379 12.399 4.3169 12 4.3169 V 4.3199 Z M 17.052 15.3599 H 6.945 L 7.332 14.6969 C 8.031 13.4999 8.4 12.1379 8.4 10.7549 V 10.3199 C 8.4 8.3309 10.011 6.7199 12 6.7199 C 13.989 6.7199 15.6 8.3309 15.6 10.3199 V 10.7549 C 15.6 12.1409 15.969 13.4999 16.665 14.6969 L 17.052 15.3599 Z M 9.963 18.2399 C 10.26 19.0799 11.061 19.6799 12 19.6799 C 12.939 19.6799 13.74 19.0799 14.037 18.2399 H 9.963 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function y5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 9.6 1 C 8.936 1 8.4 1.5462 8.4 2.2222 C 8.4 2.6729 8.64 3.0701 9 3.2802 V 7.9285 C 7.208 8.9865 6 10.9573 6 13.2222 V 19.6389 C 6 21.4951 7.478 23 9.3 23 H 14.7 C 16.523 23 18 21.4951 18 19.6389 V 13.2222 C 18 10.9573 16.793 8.9865 15 7.9285 V 3.2802 C 15.36 3.0701 15.6 2.6729 15.6 2.2222 C 15.6 1.5462 15.064 1 14.4 1 H 9.6 Z M 10.8 3.4444 H 13.2 V 8.4861 C 13.2 8.8451 13.406 9.1736 13.729 9.3226 C 15.188 9.9948 16.2 11.4882 16.2 13.2222 V 19.6389 C 16.2 20.483 15.529 21.1667 14.7 21.1667 H 9.3 C 8.471 21.1667 7.8 20.483 7.8 19.6389 V 13.2222 C 7.8 11.4882 8.812 9.9948 10.271 9.3226 C 10.594 9.1736 10.8 8.849 10.8 8.4861 V 3.4444 Z M 14.4 15.6667 C 14.4 14.8569 13.316 13.2031 12.604 12.2062 C 12.3 11.7823 11.696 11.7823 11.393 12.2062 C 10.68 13.2031 9.596 14.8569 9.596 15.6667 C 9.596 16.8736 10.673 18.1111 11.996 18.1111 C 13.32 18.1111 14.396 16.8736 14.396 15.6667 H 14.4 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function x5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 13.212 2.7115 C 13.212 2.0401 12.671 1.5 12 1.5 C 11.329 1.5 10.788 2.0401 10.788 2.7115 V 10.7885 H 2.712 C 2.04 10.7885 1.5 11.3286 1.5 12 C 1.5 12.6714 2.04 13.2115 2.712 13.2115 H 10.788 V 21.2885 C 10.788 21.9599 11.329 22.5 12 22.5 C 12.671 22.5 13.212 21.9599 13.212 21.2885 V 13.2115 H 21.288 C 21.96 13.2115 22.5 12.6714 22.5 12 C 22.5 11.3286 21.96 10.7885 21.288 10.7885 H 13.212 V 2.7115 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function C5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M7.19979 5.27982V4.31982H5.27979V19.6798H7.19979V15.0718L9.08079 14.5078C10.3378 14.1298 11.6938 14.2468 12.8668 14.8348C14.1478 15.4768 15.6418 15.5548 16.9828 15.0508L18.7198 14.3998V4.79982L17.0218 5.64882C15.6748 6.32382 14.0878 6.32382 12.7378 5.64882C11.6458 5.10282 10.3888 4.99482 9.22178 5.34582L7.19979 5.95182V5.27982Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function w5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 16.199 10.2018 C 16.199 6.8871 13.514 4.2024 10.199 4.2024 C 6.884 4.2024 4.2 6.8871 4.2 10.2018 C 4.2 13.5165 6.884 16.2012 10.199 16.2012 C 13.514 16.2012 16.199 13.5165 16.199 10.2018 Z M 15.04 16.3175 C 13.713 17.3711 12.029 18.0011 10.199 18.0011 C 5.891 18.0011 2.4 14.5102 2.4 10.2018 C 2.4 5.8935 5.891 2.4026 10.199 2.4026 C 14.507 2.4026 17.998 5.8935 17.998 10.2018 C 17.998 12.0316 17.368 13.7152 16.315 15.0426 L 21.336 20.0634 C 21.688 20.4158 21.688 20.9858 21.336 21.3345 C 20.983 21.6832 20.413 21.687 20.064 21.3345 L 15.04 16.3175 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function S5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 10.485 7.1008 L 10.896 5.2798 H 13.104 L 13.515 7.1008 C 13.566 7.3228 13.719 7.5088 13.929 7.6018 C 14.253 7.7458 14.559 7.9228 14.841 8.1298 C 15.024 8.2648 15.264 8.3068 15.483 8.2378 L 17.268 7.6828 L 18.372 9.5968 L 16.998 10.8658 C 16.83 11.0218 16.746 11.2468 16.77 11.4718 C 16.809 11.8168 16.809 12.1828 16.77 12.5278 C 16.746 12.7558 16.83 12.9808 16.998 13.1338 L 18.372 14.4028 L 17.268 16.3168 L 15.483 15.7618 C 15.264 15.6928 15.027 15.7348 14.841 15.8698 C 14.559 16.0768 14.253 16.2568 13.929 16.3978 C 13.719 16.4908 13.566 16.6768 13.515 16.8988 L 13.104 18.7198 H 10.896 L 10.485 16.8988 C 10.434 16.6768 10.281 16.4908 10.071 16.3978 C 9.747 16.2538 9.441 16.0768 9.159 15.8698 C 8.976 15.7348 8.736 15.6928 8.517 15.7618 L 6.732 16.3168 L 5.628 14.4028 L 7.002 13.1338 C 7.17 12.9778 7.254 12.7528 7.23 12.5278 C 7.191 12.1828 7.191 11.8168 7.23 11.4718 C 7.254 11.2438 7.17 11.0188 7.002 10.8658 L 5.628 9.5968 L 6.732 7.6828 L 8.517 8.2378 C 8.736 8.3068 8.973 8.2648 9.159 8.1298 C 9.441 7.9228 9.747 7.7428 10.071 7.6018 C 10.281 7.5088 10.434 7.3228 10.485 7.1008 Z M 10.704 3.8398 C 10.143 3.8398 9.657 4.2298 9.534 4.7758 L 9.156 6.4438 C 8.967 6.5398 8.787 6.6448 8.61 6.7588 L 6.978 6.2518 C 6.441 6.0838 5.862 6.3118 5.583 6.7978 L 4.287 9.0418 C 4.008 9.5278 4.101 10.1428 4.512 10.5238 L 5.769 11.6848 C 5.76 11.8918 5.76 12.1048 5.769 12.3148 L 4.512 13.4758 C 4.101 13.8568 4.005 14.4718 4.287 14.9578 L 5.583 17.2018 C 5.862 17.6878 6.444 17.9128 6.978 17.7478 L 8.613 17.2408 C 8.79 17.3548 8.97 17.4598 9.159 17.5558 L 9.537 19.2238 C 9.66 19.7698 10.146 20.1598 10.707 20.1598 H 13.299 C 13.86 20.1598 14.346 19.7698 14.469 19.2238 L 14.847 17.5558 C 15.036 17.4598 15.216 17.3548 15.393 17.2408 L 17.028 17.7478 C 17.565 17.9158 18.144 17.6878 18.423 17.2018 L 19.719 14.9578 C 19.998 14.4718 19.905 13.8568 19.494 13.4758 L 18.237 12.3148 C 18.246 12.1078 18.246 11.8948 18.237 11.6848 L 19.494 10.5238 C 19.905 10.1428 19.998 9.5278 19.719 9.0418 L 18.42 6.7978 C 18.138 6.3118 17.559 6.0868 17.025 6.2518 L 15.39 6.7588 C 15.213 6.6448 15.033 6.5398 14.844 6.4438 L 14.469 4.7758 C 14.343 4.2298 13.857 3.8398 13.296 3.8398 H 10.704 Z M 13.44 11.9998 C 13.44 12.7948 12.795 13.4398 12 13.4398 C 11.205 13.4398 10.56 12.7948 10.56 11.9998 C 10.56 11.2048 11.205 10.5598 12 10.5598 C 12.795 10.5598 13.44 11.2048 13.44 11.9998 Z M 12 9.1198 C 10.41 9.1198 9.12 10.4098 9.12 11.9998 C 9.12 13.5898 10.41 14.8798 12 14.8798 C 13.59 14.8798 14.88 13.5898 14.88 11.9998 C 14.88 10.4098 13.59 9.1198 12 9.1198 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function R5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 13.539 7.8393 C 13.187 8.1918 12.617 8.1918 12.268 7.8393 C 11.919 7.4868 11.916 6.9168 12.268 6.5681 L 16.164 2.6643 C 16.517 2.3118 17.087 2.3118 17.436 2.6643 L 21.336 6.5643 C 21.688 6.9168 21.688 7.4868 21.336 7.8356 C 20.983 8.1843 20.413 8.1881 20.064 7.8356 L 17.702 5.4731 V 20.7018 C 17.702 21.2006 17.301 21.6018 16.802 21.6018 C 16.303 21.6018 15.902 21.2006 15.902 20.7018 V 5.4731 L 13.539 7.8356 V 7.8393 Z M 3.939 16.1643 L 6.302 18.5268 V 3.2981 C 6.302 2.7993 6.703 2.3981 7.202 2.3981 C 7.701 2.3981 8.102 2.7993 8.102 3.2981 V 18.5268 L 10.464 16.1643 C 10.817 15.8118 11.387 15.8118 11.736 16.1643 C 12.084 16.5168 12.088 17.0868 11.736 17.4356 L 7.836 21.3356 C 7.483 21.6881 6.913 21.6881 6.564 21.3356 L 2.664 17.4393 C 2.312 17.0868 2.312 16.5168 2.664 16.1681 C 3.017 15.8193 3.587 15.8156 3.936 16.1681 L 3.939 16.1643 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function E5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 16.024 4.395 C 15.855 4.4587 15.743 4.62 15.743 4.8 C 15.743 4.98 15.855 5.1412 16.024 5.205 L 18.143 6 L 18.938 8.1187 C 19.002 8.2875 19.163 8.4 19.343 8.4 C 19.523 8.4 19.684 8.2875 19.748 8.1187 L 20.543 6 L 22.662 5.205 C 22.83 5.1412 22.943 4.98 22.943 4.8 C 22.943 4.62 22.83 4.4587 22.662 4.395 L 20.543 3.6 L 19.748 1.4812 C 19.684 1.3125 19.523 1.2 19.343 1.2 C 19.163 1.2 19.002 1.3125 18.938 1.4812 L 18.143 3.6 L 16.024 4.395 Z M 7.639 10.2187 L 8.543 8.265 L 9.447 10.2187 C 9.627 10.6087 9.938 10.92 10.328 11.1 L 12.282 12.0037 L 10.328 12.9075 C 9.938 13.0875 9.627 13.3987 9.447 13.7887 L 8.543 15.7425 L 7.639 13.7887 C 7.459 13.3987 7.148 13.0875 6.758 12.9075 L 4.804 12 L 6.762 11.0962 C 7.152 10.9162 7.463 10.605 7.643 10.215 L 7.639 10.2187 Z M 7.553 6.1162 L 6.008 9.465 L 2.659 11.01 L 2.637 11.0212 C 2.49 11.0887 2.175 11.235 1.692 11.4562 C 1.478 11.5537 1.343 11.7675 1.343 12 C 1.343 12.2325 1.478 12.4462 1.692 12.5437 C 2.175 12.765 2.487 12.9112 2.637 12.9787 L 2.659 12.99 L 6.008 14.535 L 7.553 17.8837 L 7.564 17.9062 C 7.632 18.0525 7.778 18.3675 7.999 18.8512 C 8.097 19.065 8.31 19.2 8.543 19.2 C 8.775 19.2 8.989 19.065 9.087 18.8512 C 9.627 17.685 9.653 17.625 11.078 14.5387 L 14.427 12.9937 L 14.449 12.9825 C 14.595 12.915 14.91 12.7687 15.394 12.5475 C 15.608 12.45 15.743 12.2362 15.743 12.0037 C 15.743 11.7712 15.608 11.5575 15.394 11.46 C 14.228 10.92 14.168 10.8937 11.082 9.4687 L 9.537 6.12 L 9.525 6.0975 C 9.458 5.9512 9.312 5.6362 9.09 5.1525 C 8.993 4.9387 8.779 4.8037 8.547 4.8037 C 8.314 4.8037 8.1 4.9387 8.003 5.1525 C 7.485 6.27 7.572 6.09 7.557 6.12 L 7.553 6.1162 Z M 16.943 18 L 14.824 18.795 C 14.655 18.8587 14.543 19.02 14.543 19.2 C 14.543 19.38 14.655 19.5412 14.824 19.605 L 16.943 20.4 L 17.738 22.5187 C 17.802 22.6875 17.963 22.8 18.143 22.8 C 18.323 22.8 18.484 22.6875 18.548 22.5187 L 19.343 20.4 L 21.462 19.605 C 21.63 19.5412 21.743 19.38 21.743 19.2 C 21.743 19.02 21.63 18.8587 21.462 18.795 L 19.343 18 L 18.548 15.8812 C 18.484 15.7125 18.323 15.6 18.143 15.6 C 17.963 15.6 17.802 15.7125 17.738 15.8812 L 16.943 18 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function N5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12.781 3.4736 C 12.632 3.1844 12.33 3 12.003 3 C 11.676 3 11.374 3.1844 11.225 3.4736 L 8.55 8.6862 L 2.737 9.6044 C 2.414 9.655 2.145 9.8828 2.043 10.1936 C 1.941 10.5045 2.025 10.8443 2.254 11.0757 L 6.412 15.2147 L 5.496 20.9949 C 5.445 21.3167 5.58 21.642 5.845 21.8336 C 6.111 22.0252 6.46 22.0541 6.754 21.9059 L 12.003 19.2526 L 17.249 21.9059 C 17.54 22.0541 17.892 22.0252 18.158 21.8336 C 18.423 21.642 18.558 21.3203 18.507 20.9949 L 17.587 15.2147 L 21.746 11.0757 C 21.978 10.8443 22.058 10.5045 21.957 10.1936 C 21.855 9.8828 21.589 9.655 21.262 9.6044 L 15.453 8.6862 L 12.781 3.4736 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function k5(t) {
  const e = W.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 19.199 11.3999 C 19.531 11.3998 19.799 11.6684 19.799 11.9997 L 19.8 15.9268 C 19.8 16.0859 19.737 16.2385 19.624 16.3511 C 19.512 16.4637 19.359 16.5269 19.2 16.5269 L 15.272 16.5268 C 14.941 16.5268 14.672 16.2581 14.672 15.9268 C 14.672 15.5954 14.941 15.3268 15.272 15.3268 L 18.6 15.3269 L 18.599 12 C 18.599 11.6686 18.868 11.4 19.199 11.3999 Z", fill: "currentColor" }), o = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 4.375 7.6474 C 4.61 7.4131 4.99 7.4131 5.224 7.6474 L 9.709 12.1324 L 12.557 9.2843 C 12.791 9.05 13.171 9.05 13.405 9.2843 L 19.624 15.502 C 19.858 15.7363 19.858 16.1162 19.624 16.3505 C 19.39 16.5848 19.01 16.5849 18.775 16.3506 L 12.981 10.5571 L 10.133 13.4052 C 9.899 13.6395 9.519 13.6395 9.285 13.4052 L 4.375 8.4959 C 4.141 8.2616 4.141 7.8817 4.375 7.6474 Z", fill: "currentColor" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function M5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M19.1454 10.5575C19.4514 10.2514 19.4514 9.75637 19.1454 9.45351L14.7188 5.02131C14.4128 4.71519 13.9181 4.71519 13.6154 5.02131C13.3127 5.32743 13.3094 5.82243 13.6154 6.12529L16.7075 9.21903H1.40627C0.973369 9.21903 0.625095 9.56749 0.625095 10.0006C0.625095 10.4337 0.973369 10.7822 1.40627 10.7822H16.7075L13.6154 13.8759C13.3094 14.1821 13.3094 14.677 13.6154 14.9799C13.9213 15.2828 14.4161 15.286 14.7188 14.9799L19.1454 10.5575Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function P5(t) {
  const e = W.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 14.673 8.0727 C 14.673 7.7413 14.941 7.4727 15.273 7.4727 H 19.2 C 19.531 7.4727 19.8 7.7413 19.8 8.0726 V 11.9996 C 19.8 12.3309 19.531 12.5996 19.2 12.5996 C 18.868 12.5996 18.6 12.3309 18.6 11.9996 V 8.6727 H 15.273 C 14.941 8.6727 14.673 8.404 14.673 8.0727 Z", fill: "currentColor" }), o = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 19.624 7.6474 C 19.858 7.8817 19.858 8.2616 19.624 8.4959 L 13.405 14.7144 C 13.293 14.8269 13.14 14.8901 12.981 14.8901 C 12.822 14.8901 12.669 14.8268 12.557 14.7144 L 9.709 11.8656 L 5.224 16.3505 C 4.99 16.5848 4.61 16.5848 4.375 16.3505 C 4.141 16.1162 4.141 15.7363 4.375 15.502 L 9.285 10.5928 C 9.397 10.4803 9.55 10.417 9.709 10.4171 C 9.868 10.4171 10.021 10.4803 10.133 10.5928 L 12.981 13.4416 L 18.775 7.6474 C 19.01 7.4131 19.39 7.4131 19.624 7.6474 Z", fill: "currentColor" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function I5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 12.72 14.1599 C 12.72 14.5589 12.399 14.8799 12 14.8799 C 11.601 14.8799 11.28 14.5589 11.28 14.1599 V 6.7769 L 9.39 8.6669 C 9.108 8.9489 8.652 8.9489 8.373 8.6669 C 8.094 8.3849 8.091 7.9289 8.373 7.6499 L 11.49 4.5299 C 11.772 4.2479 12.228 4.2479 12.507 4.5299 L 15.63 7.6499 C 15.912 7.9319 15.912 8.3879 15.63 8.6669 C 15.348 8.9459 14.892 8.9489 14.613 8.6669 L 12.723 6.7769 V 14.1599 H 12.72 Z M 9.84 13.9199 H 7.2 C 6.936 13.9199 6.72 14.1359 6.72 14.3999 V 16.7999 C 6.72 17.0639 6.936 17.2799 7.2 17.2799 H 16.8 C 17.064 17.2799 17.28 17.0639 17.28 16.7999 V 14.3999 C 17.28 14.1359 17.064 13.9199 16.8 13.9199 H 14.16 V 12.4799 H 16.8 C 17.859 12.4799 18.72 13.3409 18.72 14.3999 V 16.7999 C 18.72 17.8589 17.859 18.7199 16.8 18.7199 H 7.2 C 6.141 18.7199 5.28 17.8589 5.28 16.7999 V 14.3999 C 5.28 13.3409 6.141 12.4799 7.2 12.4799 H 9.84 V 13.9199 Z M 14.88 15.5999 C 14.88 15.2009 15.201 14.8799 15.6 14.8799 C 15.999 14.8799 16.32 15.2009 16.32 15.5999 C 16.32 15.9989 15.999 16.3199 15.6 16.3199 C 15.201 16.3199 14.88 15.9989 14.88 15.5999 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function T5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M5.78571 5C5.78571 4.1712 6.12436 3.37634 6.72716 2.79029C7.32995 2.20424 8.14752 1.875 9 1.875C9.85248 1.875 10.67 2.20424 11.2728 2.79029C11.8756 3.37634 12.2143 4.1712 12.2143 5C12.2143 5.8288 11.8756 6.62366 11.2728 7.20971C10.67 7.79576 9.85248 8.125 9 8.125C8.14752 8.125 7.32995 7.79576 6.72716 7.20971C6.12436 6.62366 5.78571 5.8288 5.78571 5ZM14.1429 5C14.1429 3.67392 13.601 2.40215 12.6365 1.46447C11.6721 0.526784 10.364 0 9 0C7.63603 0 6.32792 0.526784 5.36345 1.46447C4.39898 2.40215 3.85714 3.67392 3.85714 5C3.85714 6.32608 4.39898 7.59785 5.36345 8.53553C6.32792 9.47322 7.63603 10 9 10C10.364 10 11.6721 9.47322 12.6365 8.53553C13.601 7.59785 14.1429 6.32608 14.1429 5ZM1.92857 18.75C1.92857 15.9883 4.2308 13.75 7.07143 13.75H10.9286C13.7692 13.75 16.0714 15.9883 16.0714 18.75V19.0625C16.0714 19.582 16.5013 20 17.0357 20C17.5701 20 18 19.582 18 19.0625V18.75C18 14.9531 14.8339 11.875 10.9286 11.875H7.07143C3.16607 11.875 0 14.9531 0 18.75V19.0625C0 19.582 0.429911 20 0.964286 20C1.49866 20 1.92857 19.582 1.92857 19.0625V18.75Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function O5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 11.103 3.2971 C 15.44 3.2971 19.037 6.4723 19.697 10.6231 C 19.353 10.7931 19.047 11.0446 18.806 11.3778 L 18.167 12.2515 C 18.17 12.1665 18.174 12.0849 18.174 11.9999 C 18.174 8.0938 15.009 4.9289 11.103 4.9289 C 7.197 4.9289 4.032 8.0938 4.032 11.9999 C 4.032 15.9059 7.197 19.0709 11.103 19.0709 C 12.33 19.0709 13.482 18.7581 14.485 18.2108 L 15.542 19.3055 C 15.58 19.3428 15.621 19.3802 15.661 19.4142 C 14.336 20.2301 12.775 20.7027 11.103 20.7027 C 6.296 20.7027 2.4 16.8068 2.4 11.9999 C 2.4 7.193 6.296 3.2971 11.103 3.2971 Z M 20.125 12.3364 C 20.39 11.9727 20.9 11.8911 21.264 12.1563 C 21.628 12.4214 21.709 12.9314 21.444 13.2951 L 17.963 18.0816 C 17.82 18.2754 17.599 18.4012 17.361 18.4148 C 17.123 18.4284 16.885 18.34 16.719 18.1666 L 15.141 16.5348 C 14.829 16.2119 14.835 15.6952 15.162 15.3824 C 15.488 15.0697 16.001 15.0799 16.314 15.4028 L 17.215 16.3343 L 20.125 12.333 V 12.3364 Z M 11.103 16.3513 C 10.501 16.3513 10.015 15.8651 10.015 15.2634 C 10.015 14.6617 10.501 14.1756 11.103 14.1756 C 11.704 14.1756 12.191 14.6617 12.191 15.2634 C 12.191 15.8651 11.704 16.3513 11.103 16.3513 Z M 11.103 7.6485 C 11.721 7.6485 12.214 8.1754 12.17 8.7941 L 11.919 12.3296 C 11.888 12.758 11.531 13.0877 11.106 13.0877 C 10.678 13.0877 10.324 12.758 10.294 12.3296 L 10.042 8.7941 C 9.998 8.1754 10.487 7.6485 11.109 7.6485 H 11.103 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function D5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 2 5.2222 C 2 3.9965 2.997 3 4.222 3 H 13.111 C 14.337 3 15.333 3.9965 15.333 5.2222 V 9.8958 C 12.767 10.6215 10.889 12.9792 10.889 15.7778 C 10.889 17.8299 11.899 19.6424 13.448 20.7535 C 13.337 20.7708 13.226 20.7778 13.111 20.7778 H 4.222 C 2.997 20.7778 2 19.7812 2 18.5556 V 5.2222 Z M 4.222 8 C 4.222 8.3056 4.472 8.5556 4.778 8.5556 H 12.556 C 12.861 8.5556 13.111 8.3056 13.111 8 C 13.111 7.6944 12.861 7.4444 12.556 7.4444 H 4.778 C 4.472 7.4444 4.222 7.6944 4.222 8 Z M 4.778 10.7778 C 4.472 10.7778 4.222 11.0278 4.222 11.3333 C 4.222 11.6389 4.472 11.8889 4.778 11.8889 H 10.333 C 10.639 11.8889 10.889 11.6389 10.889 11.3333 C 10.889 11.0278 10.639 10.7778 10.333 10.7778 H 4.778 Z M 4.778 14.1111 C 4.472 14.1111 4.222 14.3611 4.222 14.6667 C 4.222 14.9722 4.472 15.2222 4.778 15.2222 H 8.111 C 8.417 15.2222 8.667 14.9722 8.667 14.6667 C 8.667 14.3611 8.417 14.1111 8.111 14.1111 H 4.778 Z M 17 10.7778 C 18.326 10.7778 19.598 11.3046 20.536 12.2422 C 21.473 13.1799 22 14.4517 22 15.7778 C 22 17.1039 21.473 18.3756 20.536 19.3133 C 19.598 20.251 18.326 20.7778 17 20.7778 C 15.674 20.7778 14.402 20.251 13.464 19.3133 C 12.527 18.3756 12 17.1039 12 15.7778 C 12 14.4517 12.527 13.1799 13.464 12.2422 C 14.402 11.3046 15.674 10.7778 17 10.7778 Z M 17 14.1111 C 17.221 14.1111 17.433 14.0233 17.589 13.867 C 17.746 13.7108 17.833 13.4988 17.833 13.2778 C 17.833 13.0568 17.746 12.8448 17.589 12.6885 C 17.433 12.5322 17.221 12.4444 17 12.4444 C 16.779 12.4444 16.567 12.5322 16.411 12.6885 C 16.254 12.8448 16.167 13.0568 16.167 13.2778 C 16.167 13.4988 16.254 13.7108 16.411 13.867 C 16.567 14.0233 16.779 14.1111 17 14.1111 Z M 15.889 15.7778 C 15.889 16.0833 16.139 16.3333 16.444 16.3333 V 18 C 16.139 18 15.889 18.25 15.889 18.5556 C 15.889 18.8611 16.139 19.1111 16.444 19.1111 H 17 H 17.556 C 17.861 19.1111 18.111 18.8611 18.111 18.5556 C 18.111 18.25 17.861 18 17.556 18 V 15.7778 C 17.556 15.4722 17.306 15.2222 17 15.2222 H 16.444 C 16.139 15.2222 15.889 15.4722 15.889 15.7778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function _5(t) {
  const e = W.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M 6.465 7.47 C 6.183 7.188 6.183 6.732 6.465 6.453 C 6.747 6.174 7.203 6.171 7.482 6.453 L 12.012 10.983 L 16.542 6.453 C 16.824 6.171 17.28 6.171 17.559 6.453 C 17.838 6.735 17.841 7.191 17.559 7.47 L 13.029 12 L 17.559 16.53 C 17.841 16.812 17.841 17.268 17.559 17.547 C 17.277 17.826 16.821 17.829 16.542 17.547 L 12.012 13.017 L 7.482 17.547 C 7.2 17.829 6.744 17.829 6.465 17.547 C 6.186 17.265 6.183 16.809 6.465 16.53 L 10.995 12 L 6.465 7.47 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ g("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
const bg = {
  alerts: _3,
  "arrow-left-shrink-sidebar": V3,
  "arrow-left": A3,
  "arrow-right-expand-sidebar": L3,
  "arrow-up-right": F3,
  asset: $3,
  binoculars: H3,
  "button-load-spinner": z3,
  calendar: B3,
  "chart-line": W3,
  "check-mark": U3,
  checklist: G3,
  "chevron-down": Y3,
  "chevron-left": j3,
  "chevron-right": K3,
  "chevron-up": q3,
  "circle-check": Z3,
  "circle-exclamation": X3,
  "circle-info": Q3,
  "clock-seven": J3,
  customers: e5,
  document: t5,
  "ellipsis-dots-horiz": n5,
  "ellipsis-dots": o5,
  "error-solid": r5,
  error: i5,
  "eye-watching": s5,
  facilities: l5,
  filter: a5,
  hardware: c5,
  home: u5,
  "image-regular": d5,
  integrations: f5,
  list: p5,
  "location-pin-solid": m5,
  maintenance: g5,
  "menu-hamburger": h5,
  "monitoring-point": b5,
  "notification-bell": v5,
  "oil-analysis-bottle": y5,
  "plus-regular": x5,
  priority: C5,
  search: w5,
  "settings-cog": S5,
  sort: R5,
  sparkles: E5,
  "star-recommended": N5,
  "trend-down": k5,
  "trend-no-change": M5,
  "trend-up": P5,
  upload: I5,
  user: T5,
  warning: O5,
  workorder: D5,
  "x-close": _5
}, V5 = {
  "add-photo": () => import("./add-photo-UE3i3aw7.js"),
  "add-plus": () => import("./add-plus-oFj-MK_p.js"),
  "advanced-readings": () => import("./advanced-readings-DE7-Y7MC.js"),
  "ai-filled": () => import("./ai-filled-1J1gMDKF.js"),
  ai: () => import("./ai-CruGGRMf.js"),
  "alert-exclamation": () => import("./alert-exclamation-C9YLD8Y5.js"),
  "alerts-outline": () => import("./alerts-outline-u0BE6BKG.js"),
  "angles-up-down-solid": () => import("./angles-up-down-solid-abyxkTyM.js"),
  api: () => import("./api-Cq21Vyn5.js"),
  "arrow-drop-down": () => import("./arrow-drop-down-CvUuwgsF.js"),
  "arrow-right-regular": () => import("./arrow-right-regular-ClIL3B0L.js"),
  "arrow-right": () => import("./arrow-right-BB9ZosBM.js"),
  "art-service": () => import("./art-service-D9k-QhdX.js"),
  "assign-link": () => import("./assign-link-Cz8DBNIP.js"),
  "barcode-scan-regular": () => import("./barcode-scan-regular-CRMPw43a.js"),
  "bars-filter-regular": () => import("./bars-filter-regular-rA10KAwS.js"),
  "bookmark-regular": () => import("./bookmark-regular-ErqXaTnq.js"),
  "bookmark-solid": () => import("./bookmark-solid-XxMmOSH8.js"),
  "calendar-solid": () => import("./calendar-solid-BKuAZoMG.js"),
  "camera-regular": () => import("./camera-regular-DCn5NMis.js"),
  "check-circle": () => import("./check-circle-pcTXVe3m.js"),
  "circle-check-regular": () => import("./circle-check-regular-D1RKE1A3.js"),
  "circle-minus-solid": () => import("./circle-minus-solid-DKh4s7Vy.js"),
  "circle-navigation": () => import("./circle-navigation-C_N1sdOv.js"),
  "circle-play-solid": () => import("./circle-play-solid-5RxV5EWv.js"),
  "circle-plus-regular": () => import("./circle-plus-regular-zl6C5_zW.js"),
  "circle-question": () => import("./circle-question-BInzI22Q.js"),
  "circle-stop-regular": () => import("./circle-stop-regular-C_JIeCcl.js"),
  "circle-xmark-solid": () => import("./circle-xmark-solid--KBWCnKI.js"),
  "cloud-slash-regular": () => import("./cloud-slash-regular-DoTIr8Oz.js"),
  collect: () => import("./collect-Co2HYlGr.js"),
  "collection-taken": () => import("./collection-taken-Cy4xrGCl.js"),
  "command-search": () => import("./command-search-C2xsNRgD.js"),
  component: () => import("./component-DPrBUJTp.js"),
  "configure-slider": () => import("./configure-slider-bFpbIHj4.js"),
  "copy-regular": () => import("./copy-regular-BuvekPFc.js"),
  "cost-savings-dollar": () => import("./cost-savings-dollar-WugkrpTl.js"),
  "document-upload": () => import("./document-upload-BGJdqBn4.js"),
  "dollar-sign": () => import("./dollar-sign-DrSDp3MT.js"),
  dot: () => import("./dot-Bsti8OLe.js"),
  download: () => import("./download-CnMNSBLT.js"),
  drag: () => import("./drag-BZplXPTC.js"),
  "edit-pen": () => import("./edit-pen-CxBiIwxm.js"),
  "email-envelope": () => import("./email-envelope-DiLoHzY9.js"),
  "expand-regular": () => import("./expand-regular-C05q6RBY.js"),
  expand: () => import("./expand-Ar2qxbi8.js"),
  "eye-slash-regular": () => import("./eye-slash-regular-BL-pt4ts.js"),
  "flash-auto": () => import("./flash-auto-COJnXXcG.js"),
  "flash-off": () => import("./flash-off-DxAJx4CC.js"),
  "flash-on": () => import("./flash-on-D41TNyqb.js"),
  "gauge-max-solid-full": () => import("./gauge-max-solid-full-DVsU73t4.js"),
  grid: () => import("./grid-BnvfXTkX.js"),
  "grip-drag": () => import("./grip-drag-T3n9XLV-.js"),
  hazardous: () => import("./hazardous-DMmCTvnj.js"),
  "hwe-sensor-triangle": () => import("./hwe-sensor-triangle-BwAq5IX-.js"),
  "invoke-reading-bolt-regular": () => import("./invoke-reading-bolt-regular-Cp5QGlzd.js"),
  "invoke-reading-bolt-solid": () => import("./invoke-reading-bolt-solid-B9yq2sii.js"),
  line: () => import("./line-bZnGeTu-.js"),
  "logout-exit": () => import("./logout-exit-CJdNt9zY.js"),
  marketplace: () => import("./marketplace-DjGN6iKj.js"),
  message: () => import("./message-CnKMpyxz.js"),
  "microphone-solid": () => import("./microphone-solid-BN1BAqyC.js"),
  minus: () => import("./minus-Ck_rUujj.js"),
  "new-message": () => import("./new-message-COl6FN29.js"),
  "new-nxt-step": () => import("./new-nxt-step-DdKIQhHf.js"),
  "note-regular": () => import("./note-regular-DtG3iBud.js"),
  "paper-plane-top": () => import("./paper-plane-top-UvtbOAeS.js"),
  partners: () => import("./partners-qveXf0qH.js"),
  phone: () => import("./phone-bdISCoGZ.js"),
  "qr-code-scan": () => import("./qr-code-scan-CRAz-Oyn.js"),
  "quarterly-collection": () => import("./quarterly-collection-CxUmYmn_.js"),
  "report-error-square-regular": () => import("./report-error-square-regular-BVmNOQPD.js"),
  rotate: () => import("./rotate-BZY99ywR.js"),
  save: () => import("./save-BMS6Tjxq.js"),
  send: () => import("./send-iYh4V9VL.js"),
  service: () => import("./service-D19lNwJd.js"),
  "settings-cog-solid": () => import("./settings-cog-solid-DzBAvMJm.js"),
  share: () => import("./share-DR74k9ao.js"),
  "signal-connection": () => import("./signal-connection-D2TXKNXS.js"),
  signal: () => import("./signal-ClsGNY50.js"),
  "sort-lines": () => import("./sort-lines-BqsmDERv.js"),
  "stacked-images-regular": () => import("./stacked-images-regular-C7r2AhI2.js"),
  sync: () => import("./sync-DCq2I0rc.js"),
  tag: () => import("./tag-C-1U0rZc.js"),
  "temperature-high-regular-full": () => import("./temperature-high-regular-full-CGdfPnlm.js"),
  "thumbs-down": () => import("./thumbs-down-CFpQbdTQ.js"),
  "thumbs-up": () => import("./thumbs-up-BA7gZye6.js"),
  "trash-delete-bin": () => import("./trash-delete-bin-BRaP7obb.js"),
  "triangle-exclamation-solid": () => import("./triangle-exclamation-solid-DFLVYwfr.js"),
  ultrasound: () => import("./ultrasound-CVhj4j7D.js"),
  "up-down": () => import("./up-down-BgbgwQHo.js"),
  vero: () => import("./vero-BgxkNmbD.js"),
  vibration: () => import("./vibration-DHXAEqfO.js"),
  watching: () => import("./watching-C6VbFi_c.js"),
  "wifi-exclamation-sharp-solid": () => import("./wifi-exclamation-sharp-solid-B2lRByzu.js"),
  wifi: () => import("./wifi-8GgIkdeE.js"),
  "zoom-in": () => import("./zoom-in-B26X0B3W.js"),
  "zoom-out": () => import("./zoom-out-5iqiIT_e.js")
}, A5 = {
  neutral: "text-icon-main",
  secondary: "text-icon-secondary",
  brand: "text-primary",
  warning: "text-accessibility-warning",
  negative: "text-negative",
  positive: "text-positive",
  informative: "text-informative",
  inherit: "text-current"
}, Ml = /* @__PURE__ */ new Map(), $s = /* @__PURE__ */ new Map();
function Wa(t) {
  return t in bg;
}
function L5(t) {
  const e = Ml.get(t);
  if (e)
    return Promise.resolve(e);
  const n = $s.get(t);
  if (n)
    return n;
  const o = V5[t], r = o().then((i) => (Ml.set(t, i.default), $s.delete(t), i.default)).catch((i) => {
    throw $s.delete(t), i;
  });
  return $s.set(t, r), r;
}
function Ge(t) {
  const e = W.c(31);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    name: r,
    size: l,
    tone: a,
    style: s,
    "aria-label": o,
    "aria-hidden": n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "md" : l, u = a === void 0 ? "neutral" : a, d = !o, f = hg[c];
  let p;
  e[8] !== r ? (p = () => {
    if (Wa(r))
      return;
    const I = Ml.get(r);
    return I ? {
      name: r,
      Component: I
    } : void 0;
  }, e[8] = r, e[9] = p) : p = e[9];
  const [m, h] = tt(p), b = A5[u];
  let v;
  e[10] !== f || e[11] !== s ? (v = {
    width: f,
    height: f,
    flexShrink: 0,
    ...s
  }, e[10] = f, e[11] = s, e[12] = v) : v = e[12];
  const C = n ?? (d ? !0 : void 0), y = d ? void 0 : "img";
  let w;
  e[13] !== o || e[14] !== i || e[15] !== b || e[16] !== v || e[17] !== C || e[18] !== y ? (w = {
    className: b,
    style: v,
    "aria-hidden": C,
    "aria-label": o,
    role: y,
    ...i
  }, e[13] = o, e[14] = i, e[15] = b, e[16] = v, e[17] = C, e[18] = y, e[19] = w) : w = e[19];
  const R = w;
  let S, E;
  if (e[20] !== r ? (E = () => {
    if (Wa(r)) {
      h(void 0);
      return;
    }
    let I = !0;
    const T = r, k = Ml.get(T);
    if (k) {
      h({
        name: T,
        Component: k
      });
      return;
    }
    return h(void 0), L5(T).then((P) => {
      I && h({
        name: T,
        Component: P
      });
    }).catch(() => {
      I && h(void 0);
    }), () => {
      I = !1;
    };
  }, S = [r], e[20] = r, e[21] = S, e[22] = E) : (S = e[21], E = e[22]), _t(E, S), Wa(r)) {
    const I = bg[r];
    let T;
    return e[23] !== I || e[24] !== R ? (T = /* @__PURE__ */ g(I, { ...R }), e[23] = I, e[24] = R, e[25] = T) : T = e[25], T;
  }
  if (m?.name === r) {
    const I = m.Component;
    let T;
    return e[26] !== I || e[27] !== R ? (T = /* @__PURE__ */ g(I, { ...R }), e[26] = I, e[27] = R, e[28] = T) : T = e[28], T;
  }
  let N;
  return e[29] !== R ? (N = /* @__PURE__ */ g("svg", { ...R }), e[29] = R, e[30] = N) : N = e[30], N;
}
const F5 = ae(["inline-flex", "items-center", "justify-center", "max-w-full", "gap-(--spacing-4)", "h-(--spacing-24)", "rounded-(--radius-sm)", "overflow-hidden", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-20)", "font-(--font-weight-medium)", "whitespace-nowrap"], {
  variants: {
    tone: {
      positive: ["bg-chip-positive-container", "text-chip-positive-label"],
      neutral: ["bg-chip-neutral-container", "text-chip-neutral-label"],
      negative: ["bg-chip-negative-container", "text-chip-negative-label"],
      warning: ["bg-chip-warning-container", "text-chip-warning-label"],
      informative: ["bg-chip-informative-container", "text-chip-informative-label"],
      brand: ["bg-chip-brand-container", "text-chip-brand-label"]
    },
    iconOnly: {
      true: ["px-(--spacing-4)", "py-(--spacing-4)"],
      false: ["px-(--spacing-6)", "py-(--spacing-4)"]
    }
  },
  defaultVariants: {
    tone: "neutral",
    iconOnly: !1
  }
}), $5 = {
  informative: "text-chip-informative-label-icon",
  positive: "text-chip-positive-label-icon",
  warning: "text-chip-warning-label-icon",
  negative: "text-chip-negative-label-icon"
};
function vg(t) {
  const e = W.c(22);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    tone: l,
    icon: o,
    label: r,
    children: n,
    truncate: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? !0 : s, c = o !== void 0 && r === void 0;
  let u;
  e[7] !== c || e[8] !== l ? (u = F5({
    tone: l,
    iconOnly: c
  }), e[7] = c, e[8] = l, e[9] = u) : u = e[9];
  let d;
  e[10] !== o || e[11] !== l ? (d = o && /* @__PURE__ */ g("span", { className: oe("inline-flex shrink-0 items-center", $5[l]), children: /* @__PURE__ */ g(Ge, { name: o, size: "xs", tone: "inherit" }) }), e[10] = o, e[11] = l, e[12] = d) : d = e[12];
  let f;
  e[13] !== r || e[14] !== a ? (f = r !== void 0 && /* @__PURE__ */ g("span", { className: a ? "min-w-0 flex-1 truncate" : void 0, children: String(r) }), e[13] = r, e[14] = a, e[15] = f) : f = e[15];
  let p;
  return e[16] !== n || e[17] !== i || e[18] !== u || e[19] !== d || e[20] !== f ? (p = /* @__PURE__ */ F("span", { className: u, ...i, children: [
    d,
    f,
    n
  ] }), e[16] = n, e[17] = i, e[18] = u, e[19] = d, e[20] = f, e[21] = p) : p = e[21], p;
}
function fo(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(vg, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function H5(t) {
  const e = W.c(15);
  let n, o, r, i;
  e[0] !== t ? ({
    label: n,
    onClose: o,
    removeAriaLabel: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = i ?? `Remove ${n}`;
  let l;
  e[5] !== o ? (l = (d) => {
    d.stopPropagation(), o();
  }, e[5] = o, e[6] = l) : l = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ g(Ge, { name: "x-close", size: "xs", tone: "inherit" }), e[7] = a) : a = e[7];
  let c;
  e[8] !== s || e[9] !== l ? (c = /* @__PURE__ */ g("button", { type: "button", "aria-label": s, className: "inline-flex shrink-0 cursor-pointer items-center text-icon-main rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", onClick: l, children: a }), e[8] = s, e[9] = l, e[10] = c) : c = e[10];
  let u;
  return e[11] !== n || e[12] !== r || e[13] !== c ? (u = /* @__PURE__ */ g(vg, { tone: "neutral", label: n, ...r, children: c }), e[11] = n, e[12] = r, e[13] = c, e[14] = u) : u = e[14], u;
}
const yg = go({
  activeId: void 0,
  orientation: "vertical",
  onActiveChange: void 0,
  startScrollLock: void 0,
  scrollRef: void 0
}), C1 = ae([
  // Layout
  "relative",
  "inline-flex",
  "items-center",
  "gap-(--spacing-4)",
  "px-(--spacing-6)",
  "rounded-(--radius-sm)",
  // Typography
  "font-(family-name:--font-family-label)",
  "text-(length:--font-size-label-large)",
  "leading-(--font-line-height-16)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "select-none",
  "outline-none",
  "cursor-pointer",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Default text color
  "text-informative",
  // Hover
  "hover:bg-surface-hover",
  // Pressed
  "active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-button-focus-ring"
], {
  variants: {
    orientation: {
      // Vertical: fixed 26px height, no extra vertical padding
      vertical: ["h-[26px]"],
      // Horizontal: fixed 26px height, no extra vertical padding
      horizontal: ["h-[26px]"]
    },
    selected: {
      true: [],
      false: []
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none", "cursor-default"]
    }
  },
  compoundVariants: [{
    orientation: "horizontal",
    selected: !0,
    className: "font-semibold"
  }]
}), z5 = ["flex", "items-center", "gap-(--spacing-16)", "h-[26px]", "w-full"].join(" "), w1 = ae(["shrink-0", "transition-colors", "duration-200", "ease-in-out"], {
  variants: {
    orientation: {
      vertical: ["shrink-0", "w-(--spacing-2)", "h-(--spacing-24)", "rounded-tr-(--radius-sm)", "rounded-br-(--radius-sm)"],
      horizontal: ["absolute", "bottom-0", "left-[14px]", "right-[14px]", "h-(--spacing-2)", "rounded-tl-(--radius-sm)", "rounded-tr-(--radius-sm)"]
    },
    selected: {
      true: "bg-informative",
      false: "bg-surface-container-highest"
    }
  }
});
function B5(t) {
  const e = W.c(59), {
    targetId: n,
    icon: o,
    chip: r,
    disabled: i,
    children: s
  } = t, l = i === void 0 ? !1 : i, {
    activeId: a,
    orientation: c,
    onActiveChange: u,
    startScrollLock: d,
    scrollRef: f
  } = mn(yg), p = a === n, m = !l && p;
  let h;
  e[0] !== l || e[1] !== u || e[2] !== f || e[3] !== d || e[4] !== n ? (h = function(k) {
    if (l) {
      k.preventDefault();
      return;
    }
    if (k.button !== 0 || k.metaKey || k.ctrlKey || k.shiftKey || k.altKey)
      return;
    k.preventDefault();
    const P = document.getElementById(n);
    if (P) {
      const M = window.matchMedia("(prefers-reduced-motion: reduce)").matches, D = M ? "instant" : "smooth", O = f?.current;
      M || d?.(), O ? O.scrollTo({
        top: P.offsetTop - O.offsetTop,
        behavior: D
      }) : P.scrollIntoView({
        behavior: D
      });
    }
    window.history.pushState(null, "", `#${n}`), u?.(n);
  }, e[0] = l, e[1] = u, e[2] = f, e[3] = d, e[4] = n, e[5] = h) : h = e[5];
  const b = h;
  if (c === "vertical") {
    const T = m || l && p;
    let k;
    e[6] !== c || e[7] !== T ? (k = w1({
      orientation: c,
      selected: T
    }), e[6] = c, e[7] = T, e[8] = k) : k = e[8];
    const P = l && p ? "opacity-50" : "";
    let M;
    e[9] !== k || e[10] !== P ? (M = [k, P].filter(Boolean), e[9] = k, e[10] = P, e[11] = M) : M = e[11];
    const D = M.join(" ");
    let O;
    e[12] !== D ? (O = /* @__PURE__ */ g("span", { "aria-hidden": !0, className: D }), e[12] = D, e[13] = O) : O = e[13];
    const _ = `#${n}`, V = m ? "true" : void 0, A = l ? "true" : void 0, L = l ? -1 : void 0;
    let $;
    e[14] !== l || e[15] !== m || e[16] !== c ? ($ = C1({
      selected: m,
      disabled: l,
      orientation: c
    }), e[14] = l, e[15] = m, e[16] = c, e[17] = $) : $ = e[17];
    let Y;
    e[18] !== o ? (Y = o && /* @__PURE__ */ g(Ge, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[18] = o, e[19] = Y) : Y = e[19];
    let G;
    e[20] !== r ? (G = r && /* @__PURE__ */ g(fo, { ...r }), e[20] = r, e[21] = G) : G = e[21];
    let j;
    e[22] !== s || e[23] !== b || e[24] !== V || e[25] !== A || e[26] !== L || e[27] !== $ || e[28] !== Y || e[29] !== G || e[30] !== _ ? (j = /* @__PURE__ */ F("a", { href: _, onClick: b, "aria-current": V, "aria-disabled": A, tabIndex: L, className: $, children: [
      Y,
      s,
      G
    ] }), e[22] = s, e[23] = b, e[24] = V, e[25] = A, e[26] = L, e[27] = $, e[28] = Y, e[29] = G, e[30] = _, e[31] = j) : j = e[31];
    let Z;
    return e[32] !== j || e[33] !== O ? (Z = /* @__PURE__ */ F("div", { className: z5, children: [
      O,
      j
    ] }), e[32] = j, e[33] = O, e[34] = Z) : Z = e[34], Z;
  }
  const v = `#${n}`, C = m ? "true" : void 0, y = l ? "true" : void 0, w = l ? -1 : void 0;
  let R;
  e[35] !== l || e[36] !== m || e[37] !== c ? (R = C1({
    selected: m,
    disabled: l,
    orientation: c
  }), e[35] = l, e[36] = m, e[37] = c, e[38] = R) : R = e[38];
  let S;
  e[39] !== o ? (S = o && /* @__PURE__ */ g(Ge, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[39] = o, e[40] = S) : S = e[40];
  let E;
  e[41] !== r ? (E = r && /* @__PURE__ */ g(fo, { ...r }), e[41] = r, e[42] = E) : E = e[42];
  let N;
  e[43] !== l || e[44] !== p || e[45] !== m || e[46] !== c ? (N = (m || l && p) && /* @__PURE__ */ g("span", { "aria-hidden": !0, className: [w1({
    orientation: c,
    selected: !0
  }), l && p ? "opacity-50" : ""].filter(Boolean).join(" ") }), e[43] = l, e[44] = p, e[45] = m, e[46] = c, e[47] = N) : N = e[47];
  let I;
  return e[48] !== s || e[49] !== b || e[50] !== N || e[51] !== v || e[52] !== C || e[53] !== y || e[54] !== w || e[55] !== R || e[56] !== S || e[57] !== E ? (I = /* @__PURE__ */ F("a", { href: v, onClick: b, "aria-current": C, "aria-disabled": y, tabIndex: w, className: R, children: [
    S,
    s,
    E,
    N
  ] }), e[48] = s, e[49] = b, e[50] = N, e[51] = v, e[52] = C, e[53] = y, e[54] = w, e[55] = R, e[56] = S, e[57] = E, e[58] = I) : I = e[58], I;
}
function W5(t) {
  const e = W.c(12), {
    orientation: n,
    activeId: o,
    onActiveChange: r,
    startScrollLock: i,
    scrollRef: s,
    children: l
  } = t, a = n === void 0 ? "vertical" : n;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== a || e[3] !== s || e[4] !== i ? (c = {
    activeId: o,
    orientation: a,
    onActiveChange: r,
    startScrollLock: i,
    scrollRef: s
  }, e[0] = o, e[1] = r, e[2] = a, e[3] = s, e[4] = i, e[5] = c) : c = e[5];
  const u = a === "vertical" ? "flex flex-col items-start gap-(--spacing-8)" : "flex flex-row flex-wrap gap-(--spacing-8)";
  let d;
  e[6] !== l || e[7] !== u ? (d = /* @__PURE__ */ g("nav", { "aria-label": "On this page", className: u, children: l }), e[6] = l, e[7] = u, e[8] = d) : d = e[8];
  let f;
  return e[9] !== c || e[10] !== d ? (f = /* @__PURE__ */ g(yg, { value: c, children: d }), e[9] = c, e[10] = d, e[11] = f) : f = e[11], f;
}
const S1 = 800;
function U5(t) {
  const e = ut(null), n = ut(!1), o = ut(null), r = ut(null), [i, s] = tt(t[0]), l = t.join(","), a = ut(() => {
  });
  _t(() => {
    const u = e.current, d = l.split(",");
    function f() {
      o.current !== null && (s(o.current), o.current = null), n.current = !1, r.current !== null && (clearTimeout(r.current), r.current = null);
    }
    a.current = f;
    const p = new IntersectionObserver((h) => {
      for (const b of h)
        b.isIntersecting && (n.current ? (o.current = b.target.id, r.current !== null && clearTimeout(r.current), r.current = setTimeout(f, S1)) : s(b.target.id));
    }, {
      root: u,
      rootMargin: "0px 0px -80% 0px",
      threshold: 0
    });
    for (const h of d) {
      const b = document.getElementById(h);
      b && p.observe(b);
    }
    const m = u ?? document;
    return m.addEventListener("scrollend", f), () => {
      p.disconnect(), m.removeEventListener("scrollend", f), r.current !== null && clearTimeout(r.current);
    };
  }, [l]);
  const c = ut(() => {
    n.current = !0, r.current !== null && clearTimeout(r.current), r.current = setTimeout(() => a.current(), S1);
  }).current;
  return {
    scrollRef: e,
    activeId: i,
    onActiveChange: s,
    startScrollLock: c
  };
}
function G5(t, e) {
  return function(o, ...r) {
    const i = new URL(t);
    return i.searchParams.set("code", o.toString()), r.forEach((s) => i.searchParams.append("args[]", s)), `${e} error #${o}; visit ${i} for the full message.`;
  };
}
const et = G5("https://base-ui.com/production-error", "Base UI"), R1 = {};
function It(t, e) {
  const n = x.useRef(R1);
  return n.current === R1 && (n.current = t(e)), n;
}
function fn(t, e, n, o) {
  const r = It(xg).current;
  return j5(r, t, e, n, o) && Cg(r, [t, e, n, o]), r.callback;
}
function Y5(t) {
  const e = It(xg).current;
  return K5(e, t) && Cg(e, t), e.callback;
}
function xg() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function j5(t, e, n, o, r) {
  return t.refs[0] !== e || t.refs[1] !== n || t.refs[2] !== o || t.refs[3] !== r;
}
function K5(t, e) {
  return t.refs.length !== e.length || t.refs.some((n, o) => n !== e[o]);
}
function Cg(t, e) {
  if (t.refs = e, e.every((n) => n == null)) {
    t.callback = null;
    return;
  }
  t.callback = (n) => {
    if (t.cleanup && (t.cleanup(), t.cleanup = null), n != null) {
      const o = Array(e.length).fill(null);
      for (let r = 0; r < e.length; r += 1) {
        const i = e[r];
        if (i != null)
          switch (typeof i) {
            case "function": {
              const s = i(n);
              typeof s == "function" && (o[r] = s);
              break;
            }
            case "object": {
              i.current = n;
              break;
            }
          }
      }
      t.cleanup = () => {
        for (let r = 0; r < e.length; r += 1) {
          const i = e[r];
          if (i != null)
            switch (typeof i) {
              case "function": {
                const s = o[r];
                typeof s == "function" ? s() : i(null);
                break;
              }
              case "object": {
                i.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const q5 = parseInt(x.version, 10);
function Su(t) {
  return q5 >= t;
}
function E1(t) {
  if (!/* @__PURE__ */ x.isValidElement(t))
    return null;
  const e = t, n = e.props;
  return (Su(19) ? n?.ref : e.ref) ?? null;
}
function Wc(t, e) {
  if (t && !e)
    return t;
  if (!t && e)
    return e;
  if (t || e)
    return {
      ...t,
      ...e
    };
}
let Uc;
process.env.NODE_ENV !== "production" && (Uc = /* @__PURE__ */ new Set());
function Xl(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    Uc.has(e) || (Uc.add(e), console.warn(`Base UI: ${e}`));
  }
}
function yt() {
}
const Dn = Object.freeze([]), St = Object.freeze({});
function Z5(t, e) {
  const n = {};
  for (const o in t) {
    const r = t[o];
    if (e?.hasOwnProperty(o)) {
      const i = e[o](r);
      i != null && Object.assign(n, i);
      continue;
    }
    r === !0 ? n[`data-${o.toLowerCase()}`] = "" : r && (n[`data-${o.toLowerCase()}`] = r.toString());
  }
  return n;
}
function X5(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Q5(t, e) {
  return typeof t == "function" ? t(e) : t;
}
const Ru = {};
function en(t, e, n, o, r) {
  if (!n && !o && !r && !t)
    return Pl(e);
  let i = Pl(t);
  return e && (i = Ii(i, e)), n && (i = Ii(i, n)), o && (i = Ii(i, o)), r && (i = Ii(i, r)), i;
}
function J5(t) {
  if (t.length === 0)
    return Ru;
  if (t.length === 1)
    return Pl(t[0]);
  let e = Pl(t[0]);
  for (let n = 1; n < t.length; n += 1)
    e = Ii(e, t[n]);
  return e;
}
function Pl(t) {
  return Eu(t) ? {
    ...Sg(t, Ru)
  } : ev(t);
}
function Ii(t, e) {
  return Eu(e) ? Sg(e, t) : tv(t, e);
}
function ev(t) {
  const e = {
    ...t
  };
  for (const n in e) {
    const o = e[n];
    wg(n, o) && (e[n] = Rg(o));
  }
  return e;
}
function tv(t, e) {
  if (!e)
    return t;
  for (const n in e) {
    const o = e[n];
    switch (n) {
      case "style": {
        t[n] = Wc(t.style, o);
        break;
      }
      case "className": {
        t[n] = Eg(t.className, o);
        break;
      }
      default:
        wg(n, o) ? t[n] = nv(t[n], o) : t[n] = o;
    }
  }
  return t;
}
function wg(t, e) {
  const n = t.charCodeAt(0), o = t.charCodeAt(1), r = t.charCodeAt(2);
  return n === 111 && o === 110 && r >= 65 && r <= 90 && (typeof e == "function" || typeof e > "u");
}
function Eu(t) {
  return typeof t == "function";
}
function Sg(t, e) {
  return Eu(t) ? t(e) : t ?? Ru;
}
function nv(t, e) {
  return e ? t ? (...n) => {
    const o = n[0];
    if (Ng(o)) {
      const i = o;
      Il(i);
      const s = e(...n);
      return i.baseUIHandlerPrevented || t?.(...n), s;
    }
    const r = e(...n);
    return t?.(...n), r;
  } : Rg(e) : t;
}
function Rg(t) {
  return t && ((...e) => {
    const n = e[0];
    return Ng(n) && Il(n), t(...e);
  });
}
function Il(t) {
  return t.preventBaseUIHandler = () => {
    t.baseUIHandlerPrevented = !0;
  }, t;
}
function Eg(t, e) {
  return e ? t ? e + " " + t : e : t;
}
function Ng(t) {
  return t != null && typeof t == "object" && "nativeEvent" in t;
}
function Le(t, e, n = {}) {
  const o = e.render, r = ov(e, n);
  if (n.enabled === !1)
    return null;
  const i = n.state ?? St;
  return av(t, o, r, i);
}
function ov(t, e = {}) {
  const {
    className: n,
    style: o,
    render: r
  } = t, {
    state: i = St,
    ref: s,
    props: l,
    stateAttributesMapping: a,
    enabled: c = !0
  } = e, u = c ? X5(n, i) : void 0, d = c ? Q5(o, i) : void 0, f = c ? Z5(i, a) : St, p = c && l ? rv(l) : void 0, m = c ? Wc(f, p) ?? {} : St;
  return typeof document < "u" && (c ? Array.isArray(s) ? m.ref = Y5([m.ref, E1(r), ...s]) : m.ref = fn(m.ref, E1(r), s) : fn(null, null)), c ? (u !== void 0 && (m.className = Eg(m.className, u)), d !== void 0 && (m.style = Wc(m.style, d)), m) : St;
}
function rv(t) {
  return Array.isArray(t) ? J5(t) : en(void 0, t);
}
const iv = /* @__PURE__ */ Symbol.for("react.lazy"), sv = /^[A-Z][A-Za-z0-9$]*$/, lv = /[a-z]/;
function av(t, e, n, o) {
  if (e) {
    if (typeof e == "function")
      return process.env.NODE_ENV !== "production" && cv(e), e(n, o);
    const r = en(n, e.props);
    r.ref = n.ref;
    let i = e;
    if (i?.$$typeof === iv && (i = x.Children.toArray(e)[0]), process.env.NODE_ENV !== "production" && !/* @__PURE__ */ x.isValidElement(i))
      throw new Error(["Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.", "A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.", "https://base-ui.com/r/invalid-render-prop"].join(`
`));
    return /* @__PURE__ */ x.cloneElement(i, r);
  }
  if (t && typeof t == "string")
    return uv(t, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : et(8));
}
function cv(t) {
  const e = t.name;
  e.length !== 0 && sv.test(e) && lv.test(e) && Xl(`The \`render\` prop received a function named \`${e}\` that starts with an uppercase letter.`, "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function uv(t, e) {
  return t === "button" ? /* @__PURE__ */ y1("button", {
    type: "button",
    ...e,
    key: e.key
  }) : t === "img" ? /* @__PURE__ */ y1("img", {
    alt: "",
    ...e,
    key: e.key
  }) : /* @__PURE__ */ x.createElement(t, e);
}
const Nu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Nu.displayName = "AvatarRootContext");
function kg() {
  const t = x.useContext(Nu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: AvatarRootContext is missing. Avatar parts must be placed within <Avatar.Root>." : et(13));
  return t;
}
const ku = {
  imageLoadingStatus: () => null
}, Gc = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, [l, a] = x.useState("idle"), c = {
    imageLoadingStatus: l
  }, u = x.useMemo(() => ({
    imageLoadingStatus: l,
    setImageLoadingStatus: a
  }), [l, a]), d = Le("span", e, {
    state: c,
    ref: n,
    props: s,
    stateAttributesMapping: ku
  });
  return /* @__PURE__ */ g(Nu.Provider, {
    value: u,
    children: d
  });
});
process.env.NODE_ENV !== "production" && (Gc.displayName = "AvatarRoot");
const Ua = x[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], dv = (
  // React 17 doesn't have useInsertionEffect.
  Ua && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  Ua !== x.useLayoutEffect ? Ua : (t) => t()
);
function Ce(t) {
  const e = It(fv).current;
  return e.next = t, dv(e.effect), e.trampoline;
}
function fv() {
  const t = {
    next: void 0,
    callback: pv,
    trampoline: (...e) => t.callback?.(...e),
    effect: () => {
      t.callback = t.next;
    }
  };
  return t;
}
function pv() {
  if (process.env.NODE_ENV !== "production")
    throw (
      /* minify-error-disabled */
      new Error("Base UI: Cannot call an event handler while rendering.")
    );
}
const mv = () => {
}, Ne = typeof document < "u" ? x.useLayoutEffect : mv, gv = [];
function Qr(t) {
  x.useEffect(t, gv);
}
const Hs = null;
let N1 = globalThis.requestAnimationFrame;
class hv {
  /* This implementation uses an array as a backing data-structure for frame callbacks.
   * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
   * never calls the native `cancelAnimationFrame` if there are no frames left. This can
   * be much more efficient if there is a call pattern that alterns as
   * "request-cancel-request-cancel-…".
   * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
   * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
  callbacks = [];
  callbacksCount = 0;
  nextId = 1;
  startId = 1;
  isScheduled = !1;
  tick = (e) => {
    this.isScheduled = !1;
    const n = this.callbacks, o = this.callbacksCount;
    if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, o > 0)
      for (let r = 0; r < n.length; r += 1)
        n[r]?.(e);
  };
  request(e) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1;
    const o = process.env.NODE_ENV !== "production" && N1 !== requestAnimationFrame && (N1 = requestAnimationFrame, !0);
    return (!this.isScheduled || o) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(e) {
    const n = e - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
const zs = new hv();
class Vt {
  static create() {
    return new Vt();
  }
  static request(e) {
    return zs.request(e);
  }
  static cancel(e) {
    return zs.cancel(e);
  }
  currentId = Hs;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(e) {
    this.cancel(), this.currentId = zs.request(() => {
      this.currentId = Hs, e();
    });
  }
  cancel = () => {
    this.currentId !== Hs && (zs.cancel(this.currentId), this.currentId = Hs);
  };
  disposeEffect = () => this.cancel;
}
function Jr() {
  const t = It(Vt.create).current;
  return Qr(t.disposeEffect), t;
}
function yo(t) {
  return t == null ? t : "current" in t ? t.current : t;
}
let Kn = /* @__PURE__ */ (function(t) {
  return t.startingStyle = "data-starting-style", t.endingStyle = "data-ending-style", t;
})({});
const bv = {
  [Kn.startingStyle]: ""
}, vv = {
  [Kn.endingStyle]: ""
}, zt = {
  transitionStatus(t) {
    return t === "starting" ? bv : t === "ending" ? vv : null;
  }
};
function Ql(t, e = !1, n = !0) {
  const o = Jr();
  return Ce((r, i = null) => {
    o.cancel();
    const s = yo(t);
    if (s == null)
      return;
    const l = s, a = () => {
      an.flushSync(r);
    };
    if (typeof l.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
      r();
      return;
    }
    function c() {
      Promise.all(l.getAnimations().map((u) => u.finished)).then(() => {
        i?.aborted || a();
      }).catch(() => {
        if (n) {
          i?.aborted || a();
          return;
        }
        const u = l.getAnimations();
        !i?.aborted && u.length > 0 && u.some((d) => d.pending || d.playState !== "finished") && c();
      });
    }
    if (e) {
      const u = Kn.startingStyle;
      if (!l.hasAttribute(u)) {
        o.request(c);
        return;
      }
      const d = new MutationObserver(() => {
        l.hasAttribute(u) || (d.disconnect(), c());
      });
      d.observe(l, {
        attributes: !0,
        attributeFilter: [u]
      }), i?.addEventListener("abort", () => d.disconnect(), {
        once: !0
      });
      return;
    }
    o.request(c);
  });
}
function Yt(t) {
  const {
    enabled: e = !0,
    open: n,
    ref: o,
    onComplete: r
  } = t, i = Ce(r), s = Ql(o, n, !1);
  x.useEffect(() => {
    if (!e)
      return;
    const l = new AbortController();
    return s(i, l.signal), () => {
      l.abort();
    };
  }, [e, n, i, s]);
}
function Zn(t, e = !1, n = !1) {
  const [o, r] = x.useState(t && e ? "idle" : void 0), [i, s] = x.useState(t);
  return t && !i && (s(!0), r("starting")), !t && i && o !== "ending" && !n && r("ending"), !t && !i && o === "ending" && r(void 0), Ne(() => {
    if (!t && i && o !== "ending" && n) {
      const l = Vt.request(() => {
        r("ending");
      });
      return () => {
        Vt.cancel(l);
      };
    }
  }, [t, i, o, n]), Ne(() => {
    if (!t || e)
      return;
    const l = Vt.request(() => {
      r(void 0);
    });
    return () => {
      Vt.cancel(l);
    };
  }, [e, t]), Ne(() => {
    if (!t || !e)
      return;
    t && i && o !== "idle" && r("starting");
    const l = Vt.request(() => {
      r("idle");
    });
    return () => {
      Vt.cancel(l);
    };
  }, [e, t, i, o]), {
    mounted: i,
    setMounted: s,
    transitionStatus: o
  };
}
function yv(t, {
  referrerPolicy: e,
  crossOrigin: n
}) {
  const [o, r] = x.useState("idle");
  return Ne(() => {
    if (!t)
      return r("error"), yt;
    let i = !0;
    const s = new window.Image(), l = (a) => () => {
      i && r(a);
    };
    return r("loading"), s.onload = l("loaded"), s.onerror = l("error"), e && (s.referrerPolicy = e), s.crossOrigin = n ?? null, s.src = t, s.complete && r(s.naturalWidth > 0 ? "loaded" : "error"), () => {
      i = !1;
    };
  }, [t, n, e]), o;
}
const xv = {
  ...ku,
  ...zt
}, Mg = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    onLoadingStatusChange: i,
    referrerPolicy: s,
    crossOrigin: l,
    style: a,
    ...c
  } = e, u = kg(), d = yv(e.src, {
    referrerPolicy: s,
    crossOrigin: l
  }), f = d === "loaded", {
    mounted: p,
    transitionStatus: m,
    setMounted: h
  } = Zn(f), b = x.useRef(null), v = Ce((w) => {
    i?.(w), u.setImageLoadingStatus(w);
  });
  Ne(() => {
    d !== "idle" && v(d);
  }, [d, v]);
  const C = {
    imageLoadingStatus: d,
    transitionStatus: m
  };
  Yt({
    open: f,
    ref: b,
    onComplete() {
      f || h(!1);
    }
  });
  const y = Le("img", e, {
    state: C,
    ref: [n, b],
    props: c,
    stateAttributesMapping: xv,
    enabled: p
  });
  return p ? y : null;
});
process.env.NODE_ENV !== "production" && (Mg.displayName = "AvatarImage");
const Ci = 0;
class xn {
  static create() {
    return new xn();
  }
  currentId = Ci;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(e, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = Ci, n();
    }, e);
  }
  isStarted() {
    return this.currentId !== Ci;
  }
  clear = () => {
    this.currentId !== Ci && (clearTimeout(this.currentId), this.currentId = Ci);
  };
  disposeEffect = () => this.clear;
}
function Dt() {
  const t = It(xn.create).current;
  return Qr(t.disposeEffect), t;
}
const Pg = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    delay: i,
    style: s,
    ...l
  } = e, {
    imageLoadingStatus: a
  } = kg(), [c, u] = x.useState(i === void 0), d = Dt();
  return x.useEffect(() => (i !== void 0 && d.start(i, () => u(!0)), d.clear), [d, i]), Le("span", e, {
    state: {
      imageLoadingStatus: a
    },
    ref: n,
    props: l,
    stateAttributesMapping: ku,
    enabled: a !== "loaded" && c
  });
});
process.env.NODE_ENV !== "production" && (Pg.displayName = "AvatarFallback");
const k1 = ae(["inline-flex", "shrink-0", "items-center", "justify-center", "overflow-hidden", "rounded-full", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "select-none"], {
  variants: {
    size: {
      md: ["size-(--spacing-40)", "text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"],
      xs: ["size-(--spacing-20)", "text-(length:--font-size-label-xs)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)"]
    },
    variant: {
      internal: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      external: ["bg-surface-container-highest", "text-surface-on-surface"],
      ai: ["bg-ai-avatar-background"]
    }
  }
});
function Ur(t) {
  const e = W.c(44);
  let n, o, r, i;
  e[0] !== t ? ({
    size: r,
    variant: i,
    "aria-label": n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "md" : r;
  if (i === "ai") {
    const S = s === "xs", E = S ? void 0 : "img", N = S ? void 0 : n ?? "AI", I = S || void 0;
    let T;
    e[5] !== s || e[6] !== i ? (T = k1({
      size: s,
      variant: i
    }), e[5] = s, e[6] = i, e[7] = T) : T = e[7];
    const k = s === "xs" ? "xs" : "sm", P = s === "xs" ? "size-[12px]" : void 0;
    let M;
    e[8] !== k || e[9] !== P ? (M = /* @__PURE__ */ g(wu, { size: k, className: P }), e[8] = k, e[9] = P, e[10] = M) : M = e[10];
    let D;
    return e[11] !== o || e[12] !== E || e[13] !== N || e[14] !== I || e[15] !== T || e[16] !== M ? (D = /* @__PURE__ */ g(Gc, { ...o, "data-slot": "avatar", "data-variant": "ai", role: E, "aria-label": N, "aria-hidden": I, className: T, children: M }), e[11] = o, e[12] = E, e[13] = N, e[14] = I, e[15] = T, e[16] = M, e[17] = D) : D = e[17], D;
  }
  const l = o;
  let a, c, u;
  e[18] !== l ? ({
    initials: a,
    src: u,
    ...c
  } = l, e[18] = l, e[19] = a, e[20] = c, e[21] = u) : (a = e[19], c = e[20], u = e[21]);
  const d = s === "xs", f = !u && !d ? n : void 0, p = u && !d ? n : void 0, m = f ? "img" : void 0, h = d || void 0;
  let b;
  e[22] !== s || e[23] !== i ? (b = k1({
    size: s,
    variant: i
  }), e[22] = s, e[23] = i, e[24] = b) : b = e[24];
  let v;
  e[25] !== n || e[26] !== d || e[27] !== u ? (v = u ? /* @__PURE__ */ g(Mg, { "data-slot": "avatar-image", src: u, alt: d ? "" : n ?? "", className: "h-full w-full object-cover" }) : null, e[25] = n, e[26] = d, e[27] = u, e[28] = v) : v = e[28];
  const C = p ? "img" : void 0;
  let y;
  e[29] !== a ? (y = /* @__PURE__ */ g("span", { "aria-hidden": "true", children: a }), e[29] = a, e[30] = y) : y = e[30];
  let w;
  e[31] !== p || e[32] !== C || e[33] !== y ? (w = /* @__PURE__ */ g(Pg, { "data-slot": "avatar-fallback", role: C, "aria-label": p, children: y }), e[31] = p, e[32] = C, e[33] = y, e[34] = w) : w = e[34];
  let R;
  return e[35] !== f || e[36] !== c || e[37] !== m || e[38] !== h || e[39] !== b || e[40] !== v || e[41] !== w || e[42] !== i ? (R = /* @__PURE__ */ F(Gc, { ...c, "data-slot": "avatar", "data-variant": i, role: m, "aria-label": f, "aria-hidden": h, className: b, children: [
    v,
    w
  ] }), e[35] = f, e[36] = c, e[37] = m, e[38] = h, e[39] = b, e[40] = v, e[41] = w, e[42] = i, e[43] = R) : R = e[43], R;
}
function Jl() {
  return typeof window < "u";
}
function cn(t) {
  return Mu(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function Ct(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ho(t) {
  var e;
  return (e = (Mu(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Mu(t) {
  return Jl() ? t instanceof Node || t instanceof Ct(t).Node : !1;
}
function pt(t) {
  return Jl() ? t instanceof Element || t instanceof Ct(t).Element : !1;
}
function xt(t) {
  return Jl() ? t instanceof HTMLElement || t instanceof Ct(t).HTMLElement : !1;
}
function Gr(t) {
  return !Jl() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof Ct(t).ShadowRoot;
}
function Qo(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = pn(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && r !== "inline" && r !== "contents";
}
function Cv(t) {
  return /^(table|td|th)$/.test(cn(t));
}
function ea(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const wv = /transform|translate|scale|rotate|perspective|filter/, Sv = /paint|layout|strict|content/, or = (t) => !!t && t !== "none";
let Ga;
function Pu(t) {
  const e = pt(t) ? pn(t) : t;
  return or(e.transform) || or(e.translate) || or(e.scale) || or(e.rotate) || or(e.perspective) || !ta() && (or(e.backdropFilter) || or(e.filter)) || wv.test(e.willChange || "") || Sv.test(e.contain || "");
}
function Rv(t) {
  let e = po(t);
  for (; xt(e) && !lo(e); ) {
    if (Pu(e))
      return e;
    if (ea(e))
      return null;
    e = po(e);
  }
  return null;
}
function ta() {
  return Ga == null && (Ga = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Ga;
}
function lo(t) {
  return /^(html|body|#document)$/.test(cn(t));
}
function pn(t) {
  return Ct(t).getComputedStyle(t);
}
function na(t) {
  return pt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function po(t) {
  if (cn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Gr(t) && t.host || // Fallback.
    ho(t)
  );
  return Gr(e) ? e.host : e;
}
function Ig(t) {
  const e = po(t);
  return lo(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : xt(e) && Qo(e) ? e : Ig(e);
}
function Hi(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = Ig(t), i = r === ((o = t.ownerDocument) == null ? void 0 : o.body), s = Ct(r);
  if (i) {
    const l = Yc(s);
    return e.concat(s, s.visualViewport || [], Qo(r) ? r : [], l && n ? Hi(l) : []);
  } else
    return e.concat(r, Hi(r, [], n));
}
function Yc(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
let jc;
process.env.NODE_ENV !== "production" && (jc = /* @__PURE__ */ new Set());
function jo(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    jc.has(e) || (jc.add(e), console.error(`Base UI: ${e}`));
  }
}
const pr = {
  ...x
}, Iu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Iu.displayName = "CompositeRootContext");
function Tu(t = !1) {
  const e = x.useContext(Iu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : et(16));
  return e;
}
function Ev(t) {
  const {
    focusableWhenDisabled: e,
    disabled: n,
    composite: o = !1,
    tabIndex: r = 0,
    isNativeButton: i
  } = t, s = o && e !== !1, l = o && e === !1;
  return {
    props: x.useMemo(() => {
      const c = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(u) {
          n && e && u.key !== "Tab" && u.preventDefault();
        }
      };
      return o || (c.tabIndex = r, !i && n && (c.tabIndex = e ? r : -1)), (i && (e || s) || !i && n) && (c["aria-disabled"] = n), i && (!e || l) && (c.disabled = n), c;
    }, [o, n, e, s, l, i, r])
  };
}
function Bt(t = {}) {
  const {
    disabled: e = !1,
    focusableWhenDisabled: n,
    tabIndex: o = 0,
    native: r = !0,
    composite: i
  } = t, s = x.useRef(null), l = Tu(!0), a = i ?? l !== void 0, {
    props: c
  } = Ev({
    focusableWhenDisabled: n,
    disabled: e,
    composite: a,
    tabIndex: o,
    isNativeButton: r
  });
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (!s.current)
      return;
    const p = Bs(s.current);
    if (r) {
      if (!p) {
        const m = pr.captureOwnerStack?.() || "";
        jo(`A component that acts as a button expected a native <button> because the \`nativeButton\` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the \`render\` prop, or set \`nativeButton\` to \`false\`.${m}`);
      }
    } else if (p) {
      const m = pr.captureOwnerStack?.() || "";
      jo(`A component that acts as a button expected a non-<button> because the \`nativeButton\` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as \`role\` or \`aria-disabled\`). Use a non-<button> in the \`render\` prop, or set \`nativeButton\` to \`true\`.${m}`);
    }
  }, [r]);
  const u = x.useCallback(() => {
    const p = s.current;
    Bs(p) && a && e && c.disabled === void 0 && p.disabled && (p.disabled = !1);
  }, [e, c.disabled, a]);
  Ne(u, [u]);
  const d = x.useCallback((p = {}) => {
    const {
      onClick: m,
      onMouseDown: h,
      onKeyUp: b,
      onKeyDown: v,
      onPointerDown: C,
      ...y
    } = p;
    return en({
      type: r ? "button" : void 0,
      onClick(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        m?.(R);
      },
      onMouseDown(R) {
        e || h?.(R);
      },
      onKeyDown(R) {
        if (e || (Il(R), v?.(R), R.baseUIHandlerPrevented))
          return;
        const S = R.target === R.currentTarget, E = R.currentTarget, N = Bs(E), I = !r && Nv(E), T = S && (r ? N : !I), k = R.key === "Enter", P = R.key === " ", M = E.getAttribute("role"), D = M?.startsWith("menuitem") || M === "option" || M === "gridcell";
        if (S && a && P) {
          if (R.defaultPrevented && D)
            return;
          R.preventDefault(), I || r && N ? (E.click(), R.preventBaseUIHandler()) : T && (m?.(R), R.preventBaseUIHandler());
          return;
        }
        T && (!r && (P || k) && R.preventDefault(), !r && k && m?.(R));
      },
      onKeyUp(R) {
        if (!e) {
          if (Il(R), b?.(R), R.target === R.currentTarget && r && a && Bs(R.currentTarget) && R.key === " ") {
            R.preventDefault();
            return;
          }
          R.baseUIHandlerPrevented || R.target === R.currentTarget && !r && !a && R.key === " " && m?.(R);
        }
      },
      onPointerDown(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        C?.(R);
      }
    }, r ? void 0 : {
      role: "button"
    }, c, y);
  }, [e, c, a, r]), f = Ce((p) => {
    s.current = p, u();
  });
  return {
    getButtonProps: d,
    buttonRef: f
  };
}
function Bs(t) {
  return xt(t) && t.tagName === "BUTTON";
}
function Nv(t) {
  return !!(t?.tagName === "A" && t?.href);
}
const Xn = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    focusableWhenDisabled: s = !1,
    nativeButton: l = !0,
    style: a,
    ...c
  } = e, {
    getButtonProps: u,
    buttonRef: d
  } = Bt({
    disabled: i,
    focusableWhenDisabled: s,
    native: l
  });
  return Le("button", e, {
    state: {
      disabled: i
    },
    ref: [n, d],
    props: [c, u]
  });
});
process.env.NODE_ENV !== "production" && (Xn.displayName = "Button");
function Ou(t) {
  const e = W.c(2), {
    size: n
  } = t, o = n === void 0 ? "sm" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ g("span", { className: "aw-spinner inline-flex", "aria-hidden": "true", children: /* @__PURE__ */ g(Ge, { name: "button-load-spinner", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
const kv = ae(["inline-flex", "items-center", "justify-center", "whitespace-nowrap", "shrink-0", "rounded-(--radius-sm)", "px-(--spacing-12)", "border", "border-solid", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "cursor-pointer", "select-none", "transition-[background,color,box-shadow]", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "conversation-ui": ["bg-button-primary-conversation-ui-background", "text-button-primary-conversation-ui-text", "border-button-primary-conversation-ui-background", "hover:bg-button-primary-conversation-ui-background", "hover:border-button-primary-conversation-ui-background", "active:bg-button-primary-conversation-ui-background", "active:border-button-primary-conversation-ui-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "ai-outline": ["aw-ai-button--outline", "bg-surface", "border-transparent", "text-text-default", "hover:bg-button-outline-hover-background", "active:bg-button-outline-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "ai-ghost": ["border-transparent", "bg-transparent", "text-text-default", "hover:bg-surface-hover", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["h-(--spacing-32)", "gap-(--spacing-8)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)"],
      md: ["h-(--spacing-40)", "gap-(--spacing-8)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"],
      lg: ["h-[44px]", "gap-(--spacing-8)", "px-(--spacing-16)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "sm",
    class: ["text-(length:--font-size-body-large)", "leading-(--font-line-height-20)"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "md",
    class: ["leading-(--font-line-height-20)"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "lg",
    class: ["px-(--spacing-12)", "leading-(--font-line-height-20)"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function Mv() {
  const t = W.c(44), e = Xt();
  let n;
  if (t[0] !== e) {
    let Y;
    t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = /:/g, t[2] = Y) : Y = t[2], n = e.replace(Y, ""), t[0] = e, t[1] = n;
  } else
    n = t[1];
  const o = n, r = `ai-button-gradient-${o}`, i = `ai-button-shimmer-${o}`, s = `ai-button-glow-${o}`;
  let l, a, c;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ g("stop", { offset: "13%", stopColor: "hsl(var(--primary-primary-container))" }), a = /* @__PURE__ */ g("stop", { offset: "44%", stopColor: "hsl(var(--primary-primary))" }), c = /* @__PURE__ */ g("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))" }), t[3] = l, t[4] = a, t[5] = c) : (l = t[3], a = t[4], c = t[5]);
  let u;
  t[6] !== r ? (u = /* @__PURE__ */ F("linearGradient", { id: r, x1: "0", y1: "0", x2: "1", y2: "0", gradientTransform: "rotate(-12 .5 .5)", children: [
    l,
    a,
    c
  ] }), t[6] = r, t[7] = u) : u = t[7];
  let d, f, p, m, h, b;
  t[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g("stop", { offset: "0%", stopColor: "hsl(var(--primary-primary))", stopOpacity: "0" }), m = /* @__PURE__ */ g("stop", { offset: "30%", stopColor: "hsl(var(--primary-primary-container))", stopOpacity: "0" }), h = /* @__PURE__ */ g("stop", { offset: "46%", stopColor: "hsl(var(--gradients-ai-gradient-01))", stopOpacity: "0.9" }), b = /* @__PURE__ */ g("stop", { offset: "70%", stopColor: "hsl(var(--tertiary-tertiary))", stopOpacity: "0" }), d = /* @__PURE__ */ g("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))", stopOpacity: "0" }), f = /* @__PURE__ */ g("animateTransform", { attributeName: "gradientTransform", type: "rotate", from: "-12 .5 .5", to: "348 .5 .5", dur: "3.25s", repeatCount: "indefinite" }), t[8] = d, t[9] = f, t[10] = p, t[11] = m, t[12] = h, t[13] = b) : (d = t[8], f = t[9], p = t[10], m = t[11], h = t[12], b = t[13]);
  let v;
  t[14] !== i ? (v = /* @__PURE__ */ F("linearGradient", { id: i, x1: "0", y1: "0", x2: "1", y2: "0", gradientTransform: "rotate(-12 .5 .5)", children: [
    p,
    m,
    h,
    b,
    d,
    f
  ] }), t[14] = i, t[15] = v) : v = t[15];
  let C, y, w, R;
  t[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ g("feGaussianBlur", { in: "SourceGraphic", stdDeviation: "0.8", result: "haloBlur" }), y = /* @__PURE__ */ g("feFlood", { floodColor: "hsl(var(--gradients-ai-gradient-01))", floodOpacity: "0.4", result: "haloColor" }), w = /* @__PURE__ */ g("feComposite", { in: "haloColor", in2: "haloBlur", operator: "in", result: "halo" }), R = /* @__PURE__ */ g("feMerge", { children: /* @__PURE__ */ g("feMergeNode", { in: "halo" }) }), t[16] = C, t[17] = y, t[18] = w, t[19] = R) : (C = t[16], y = t[17], w = t[18], R = t[19]);
  let S;
  t[20] !== s ? (S = /* @__PURE__ */ F("filter", { id: s, x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", filterUnits: "userSpaceOnUse", children: [
    C,
    y,
    w,
    R
  ] }), t[20] = s, t[21] = S) : S = t[21];
  const E = `${s}-outside`;
  let N, I;
  t[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ g("rect", { x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", fill: "white" }), I = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "black" }), t[22] = N, t[23] = I) : (N = t[22], I = t[23]);
  let T;
  t[24] !== E ? (T = /* @__PURE__ */ F("mask", { id: E, x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", maskUnits: "userSpaceOnUse", children: [
    N,
    I
  ] }), t[24] = E, t[25] = T) : T = t[25];
  let k;
  t[26] !== v || t[27] !== S || t[28] !== T || t[29] !== u ? (k = /* @__PURE__ */ F("defs", { children: [
    u,
    v,
    S,
    T
  ] }), t[26] = v, t[27] = S, t[28] = T, t[29] = u, t[30] = k) : k = t[30];
  const P = `url(#${s}-outside)`, M = `url(#${s})`;
  let D;
  t[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: "hsl(var(--gradients-ai-gradient-01))", strokeWidth: "4" }), t[31] = D) : D = t[31];
  let O;
  t[32] !== P || t[33] !== M ? (O = /* @__PURE__ */ g("g", { mask: P, filter: M, children: D }), t[32] = P, t[33] = M, t[34] = O) : O = t[34];
  const _ = `url(#${r})`;
  let V;
  t[35] !== _ ? (V = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: _, strokeWidth: "1" }), t[35] = _, t[36] = V) : V = t[36];
  const A = `url(#${i})`;
  let L;
  t[37] !== A ? (L = /* @__PURE__ */ g("rect", { className: "aw-ai-button__border aw-ai-button__highlight", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: A, strokeWidth: "1.5" }), t[37] = A, t[38] = L) : L = t[38];
  let $;
  return t[39] !== k || t[40] !== O || t[41] !== V || t[42] !== L ? ($ = /* @__PURE__ */ F("svg", { className: "pointer-events-none absolute inset-0 z-0 size-full overflow-visible", "aria-hidden": "true", focusable: "false", children: [
    k,
    O,
    V,
    L
  ] }), t[39] = k, t[40] = O, t[41] = V, t[42] = L, t[43] = $) : $ = t[43], $;
}
function Du(t) {
  const e = W.c(42);
  let n, o, r, i, s, l, a, c, u, d;
  e[0] !== t ? ({
    children: n,
    variant: d,
    intent: r,
    size: l,
    icon: o,
    loading: a,
    loadingText: i,
    fullWidth: c,
    disabled: u,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10]);
  const f = a === void 0 ? !1 : a, p = c === void 0 ? !1 : c, m = u === void 0 ? !1 : u, h = m || f, b = d === "ai-outline" || d === "ai-ghost", v = d === "ai-outline", y = f ? `${i ?? (b ? "Thinking" : "Loading")}...` : n;
  let w;
  e[11] !== o || e[12] !== b || e[13] !== f ? (w = f ? /* @__PURE__ */ g(Ou, { size: "sm" }) : b ? /* @__PURE__ */ g("span", { className: "inline-flex size-(--icon-sm) shrink-0 overflow-hidden", "aria-hidden": "true", children: /* @__PURE__ */ g(wu, { className: "block size-(--icon-sm) shrink-0", size: "sm" }) }) : o ? /* @__PURE__ */ g(Ge, { name: o, size: "sm", tone: "inherit" }) : null, e[11] = o, e[12] = b, e[13] = f, e[14] = w) : w = e[14];
  let R;
  e[15] !== y || e[16] !== w ? (R = /* @__PURE__ */ F(Ht, { children: [
    y,
    w
  ] }), e[15] = y, e[16] = w, e[17] = R) : R = e[17];
  const S = R;
  let E;
  e[18] !== m || e[19] !== p || e[20] !== r || e[21] !== h || e[22] !== f || e[23] !== l || e[24] !== d ? (E = oe(kv({
    variant: d,
    intent: r,
    size: l
  }), p && "w-full", h && "opacity-40 pointer-events-none", m && "cursor-not-allowed", f && !m && "cursor-default"), e[18] = m, e[19] = p, e[20] = r, e[21] = h, e[22] = f, e[23] = l, e[24] = d, e[25] = E) : E = e[25];
  const N = h || void 0, I = f || void 0, T = h ? -1 : void 0;
  let k;
  e[26] !== v ? (k = v ? /* @__PURE__ */ g(Mv, {}) : null, e[26] = v, e[27] = k) : k = e[27];
  let P;
  e[28] !== S || e[29] !== b ? (P = b ? /* @__PURE__ */ g("span", { className: "relative z-10 inline-flex items-center gap-(--spacing-8)", children: S }) : S, e[28] = S, e[29] = b, e[30] = P) : P = e[30];
  let M;
  return e[31] !== h || e[32] !== s || e[33] !== l || e[34] !== T || e[35] !== k || e[36] !== P || e[37] !== E || e[38] !== N || e[39] !== I || e[40] !== d ? (M = /* @__PURE__ */ F(Xn, { "data-slot": "button", "data-variant": d, "data-size": l, className: E, disabled: h, "aria-disabled": N, "aria-busy": I, tabIndex: T, ...s, children: [
    k,
    P
  ] }), e[31] = h, e[32] = s, e[33] = l, e[34] = T, e[35] = k, e[36] = P, e[37] = E, e[38] = N, e[39] = I, e[40] = d, e[41] = M) : M = e[41], M;
}
function An(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Du, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function M1(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Du, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Pv(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Du, { ...t, variant: "conversation-ui" }), e[0] = t, e[1] = n) : n = e[1], n;
}
const _u = go({
  align: "start"
}), Iv = ae(["flex", "w-full", "min-w-0", "gap-(--spacing-8)"], {
  variants: {
    align: {
      start: "justify-start",
      end: "justify-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), Tv = ae(["flex", "min-w-0", "w-full", "max-w-[520px]", "flex-col", "gap-(--spacing-4)"], {
  variants: {
    align: {
      start: "items-start",
      end: "items-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), Ov = ae(["flex", "items-center", "gap-(--spacing-6)", "px-(--spacing-2)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default"]), Dv = ae(["flex", "items-center", "min-w-0", "w-full", "gap-(--spacing-8)"]), _v = ae(["flex", "flex-col", "gap-(--spacing-8)"]), Vv = ae(["max-w-full", "break-words", "whitespace-pre-wrap", "rounded-(--radius-sm)", "p-(--spacing-16)", "shadow-elevation-1", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)"], {
  variants: {
    tone: {
      inbound: ["w-fit", "bg-surface-container", "text-text-default"],
      outbound: ["w-fit", "bg-surface-container", "text-text-default"],
      system: ["w-full", "bg-surface-container", "text-text-default"],
      informative: ["w-fit", "bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "inbound"
  }
}), Av = ae(["flex", "w-full", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "px-(--spacing-16)", "py-(--spacing-8)", "text-center", "font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "text-(length:--font-size-title-sm)", "leading-(--font-line-height-20)"], {
  variants: {
    tone: {
      default: ["border-informative-container", "bg-informative-container", "text-informative-on-container"],
      informative: ["border-informative-container", "bg-informative-container", "text-informative-on-container"],
      positive: ["border-positive-on-container", "bg-positive-container", "text-positive-on-container"],
      warning: ["border-warning-on-container", "bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["border-negative-on-container", "bg-negative-container", "text-negative-on-container"]
    }
  },
  defaultVariants: {
    tone: "default"
  }
});
function Kc(t) {
  const e = W.c(18);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    direction: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = o === "outbound" ? "end" : "start";
  let s;
  e[4] !== o || e[5] !== i ? (s = {
    align: i,
    direction: o
  }, e[4] = o, e[5] = i, e[6] = s) : s = e[6];
  let l;
  e[7] !== i ? (l = oe(Iv({
    align: i
  })), e[7] = i, e[8] = l) : l = e[8];
  let a;
  e[9] !== n || e[10] !== o || e[11] !== r || e[12] !== i || e[13] !== l ? (a = /* @__PURE__ */ g("article", { "data-slot": "chat-message", "data-align": i, "data-direction": o, className: l, ...r, children: n }), e[9] = n, e[10] = o, e[11] = r, e[12] = i, e[13] = l, e[14] = a) : a = e[14];
  let c;
  return e[15] !== s || e[16] !== a ? (c = /* @__PURE__ */ g(_u, { value: s, children: a }), e[15] = s, e[16] = a, e[17] = c) : c = e[17], c;
}
function Tg(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g("div", { "data-slot": "chat-message-avatar", className: "shrink-0", ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function qc(t) {
  const e = W.c(10);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    align: r
  } = mn(_u);
  let i;
  e[3] !== r ? (i = oe(Tv({
    align: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== r || e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ g("div", { "data-slot": "chat-message-content", "data-align": r, className: i, ...o, children: n }), e[5] = r, e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
function Og(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(Ov()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("header", { "data-slot": "chat-message-header", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function P1(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(Dv()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("footer", { "data-slot": "chat-message-footer", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Lv(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(_v()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { "data-slot": "chat-message-group", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Zc(t) {
  const e = W.c(11);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    tone: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const {
    direction: i
  } = mn(_u), s = r ?? i ?? "inbound";
  let l;
  e[4] !== s ? (l = oe(Vv({
    tone: s
  })), e[4] = s, e[5] = l) : l = e[5];
  let a;
  return e[6] !== n || e[7] !== o || e[8] !== s || e[9] !== l ? (a = /* @__PURE__ */ g("div", { "data-slot": "chat-bubble", "data-tone": s, className: l, ...o, children: n }), e[6] = n, e[7] = o, e[8] = s, e[9] = l, e[10] = a) : a = e[10], a;
}
function Fv(t) {
  const e = W.c(13);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    live: r,
    tone: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "polite" : r, l = i === void 0 ? "default" : i;
  let a;
  e[5] !== l ? (a = oe(Av({
    tone: l
  })), e[5] = l, e[6] = a) : a = e[6];
  let c;
  return e[7] !== n || e[8] !== s || e[9] !== o || e[10] !== a || e[11] !== l ? (c = /* @__PURE__ */ g("output", { "data-slot": "chat-status", "data-tone": l, "aria-live": s, className: a, ...o, children: n }), e[7] = n, e[8] = s, e[9] = o, e[10] = a, e[11] = l, e[12] = c) : c = e[12], c;
}
const $v = ae(["inline-flex", "items-center", "justify-center", "shrink-0", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["size-(--spacing-32)"],
      md: ["size-(--spacing-40)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function gt(t) {
  const e = W.c(28);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    icon: n,
    variant: a,
    intent: o,
    size: i,
    loading: s,
    disabled: l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? !1 : s, u = l === void 0 ? !1 : l, d = u || c;
  let f;
  e[8] !== u || e[9] !== o || e[10] !== d || e[11] !== c || e[12] !== i || e[13] !== a ? (f = oe($v({
    variant: a,
    intent: o,
    size: i
  }), d && "opacity-40 pointer-events-none", u && "cursor-not-allowed", c && !u && "cursor-default"), e[8] = u, e[9] = o, e[10] = d, e[11] = c, e[12] = i, e[13] = a, e[14] = f) : f = e[14];
  const p = d || void 0, m = c || void 0, h = d ? -1 : void 0;
  let b;
  e[15] !== n || e[16] !== c ? (b = c ? /* @__PURE__ */ g(Ou, { size: "sm" }) : /* @__PURE__ */ g(Ge, { name: n, size: "sm", tone: "inherit" }), e[15] = n, e[16] = c, e[17] = b) : b = e[17];
  let v;
  return e[18] !== d || e[19] !== r || e[20] !== i || e[21] !== f || e[22] !== p || e[23] !== m || e[24] !== h || e[25] !== b || e[26] !== a ? (v = /* @__PURE__ */ g(Xn, { "data-slot": "icon-button", "data-variant": a, "data-size": i, className: f, disabled: d, "aria-disabled": p, "aria-busy": m, tabIndex: h, ...r, children: b }), e[18] = d, e[19] = r, e[20] = i, e[21] = f, e[22] = p, e[23] = m, e[24] = h, e[25] = b, e[26] = a, e[27] = v) : v = e[27], v;
}
const Hv = ae(["aw-chat-scroller", "group", "relative", "flex", "h-full", "min-h-0", "min-w-0", "flex-1", "flex-col"]), zv = ae(["min-h-0", "min-w-0", "flex-1", "overflow-x-hidden", "overflow-y-auto", "px-(--spacing-12)", "py-(--spacing-12)", "outline-none", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-button-focus-ring"]), Bv = ae(["flex", "flex-col", "min-w-0", "gap-(--spacing-20)"]), Wv = ae(["min-w-0"]), Uv = ae(["absolute", "bottom-(--spacing-16)", "left-1/2", "z-10", "-translate-x-1/2", "hidden", "group-data-[scrollable~='end']:block"]);
function Dg(t) {
  const e = W.c(19);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    children: n,
    autoScroll: l,
    defaultScrollPosition: a,
    scrollEdgeThreshold: r,
    scrollPreviousItemPeek: s,
    scrollMargin: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? !0 : l, u = a === void 0 ? "end" : a;
  let d;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = oe(Hv()), e[8] = d) : d = e[8];
  let f;
  e[9] !== n || e[10] !== o ? (f = /* @__PURE__ */ g(Wr.Root, { "data-slot": "chat-scroller", className: d, ...o, children: n }), e[9] = n, e[10] = o, e[11] = f) : f = e[11];
  let p;
  return e[12] !== c || e[13] !== u || e[14] !== r || e[15] !== i || e[16] !== s || e[17] !== f ? (p = /* @__PURE__ */ g(Wr.Provider, { autoScroll: c, defaultScrollPosition: u, scrollEdgeThreshold: r, scrollPreviousItemPeek: s, scrollMargin: i, children: f }), e[12] = c, e[13] = u, e[14] = r, e[15] = i, e[16] = s, e[17] = f, e[18] = p) : p = e[18], p;
}
function _g(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(zv()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g(Wr.Viewport, { "data-slot": "chat-scroller-viewport", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Vg(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(Bv()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g(Wr.Content, { "data-slot": "chat-scroller-content", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function bl(t) {
  const e = W.c(9);
  let n, o, r;
  e[0] !== t ? ({
    messageId: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = oe(Wv()), e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== r ? (s = /* @__PURE__ */ g(Wr.Item, { "data-slot": "chat-scroller-item", messageId: o, className: i, ...r, children: n }), e[5] = n, e[6] = o, e[7] = r, e[8] = s) : s = e[8], s;
}
function Ag(t) {
  const e = W.c(9);
  let n, o;
  e[0] !== t ? ({
    "aria-label": o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? "Jump to latest message" : o;
  let i;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = oe(Uv()), e[3] = i) : i = e[3];
  let s;
  e[4] !== r ? (s = /* @__PURE__ */ g(gt, { icon: "chevron-down", "aria-label": r, variant: "outline", size: "sm" }), e[4] = r, e[5] = s) : s = e[5];
  let l;
  return e[6] !== n || e[7] !== s ? (l = /* @__PURE__ */ g("div", { "data-slot": "chat-scroller-jump-to-latest", className: i, children: /* @__PURE__ */ g(Wr.Button, { direction: "end", render: s, ...n }) }), e[6] = n, e[7] = s, e[8] = l) : l = e[8], l;
}
const Gv = {
  default: "border-outline-subtle",
  high: "border-outline opacity-60"
}, Yv = {
  horizontal: {
    "full-width": "",
    inset: "pl-(--spacing-16)",
    "middle-inset": "px-(--spacing-16)"
  },
  vertical: {
    "full-width": "",
    inset: "pt-(--spacing-16)",
    "middle-inset": "py-(--spacing-16)"
  }
}, I1 = ae(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap"]);
function mr(t) {
  const e = W.c(52);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    orientation: i,
    variant: s,
    subheader: r,
    centeredText: n,
    emphasis: l,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "horizontal" : i, c = s === void 0 ? "full-width" : s, u = l === void 0 ? "default" : l, d = a === "vertical", f = Gv[u], p = d ? "border-l" : "border-t", m = Yv[a][c];
  if (!d && n) {
    let w;
    e[7] !== f || e[8] !== p ? (w = oe("grow", p, f), e[7] = f, e[8] = p, e[9] = w) : w = e[9];
    let R;
    e[10] !== w ? (R = /* @__PURE__ */ g("hr", { "aria-orientation": "horizontal", className: w }), e[10] = w, e[11] = R) : R = e[11];
    let S;
    e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = oe(I1(), "shrink-0", "text-(length:--font-size-body-small)"), e[12] = S) : S = e[12];
    let E;
    e[13] !== n || e[14] !== S ? (E = /* @__PURE__ */ g("span", { className: S, children: n }), e[13] = n, e[14] = S, e[15] = E) : E = e[15];
    let N;
    e[16] !== f || e[17] !== p ? (N = oe("grow", p, f), e[16] = f, e[17] = p, e[18] = N) : N = e[18];
    let I;
    e[19] !== N ? (I = /* @__PURE__ */ g("hr", { "aria-orientation": "horizontal", className: N }), e[19] = N, e[20] = I) : I = e[20];
    let T;
    return e[21] !== o || e[22] !== R || e[23] !== E || e[24] !== I ? (T = /* @__PURE__ */ F("div", { ...o, className: "flex items-center gap-(--spacing-6)", children: [
      R,
      E,
      I
    ] }), e[21] = o, e[22] = R, e[23] = E, e[24] = I, e[25] = T) : T = e[25], T;
  }
  if (!d && r) {
    let w;
    e[26] !== f || e[27] !== p ? (w = oe("w-full", p, f), e[26] = f, e[27] = p, e[28] = w) : w = e[28];
    let R;
    e[29] !== w ? (R = /* @__PURE__ */ g("hr", { "aria-orientation": "horizontal", className: w }), e[29] = w, e[30] = R) : R = e[30];
    let S;
    e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = oe(I1(), "shrink-0", "text-(length:--font-size-body-medium)"), e[31] = S) : S = e[31];
    let E;
    e[32] !== r || e[33] !== S ? (E = /* @__PURE__ */ g("span", { className: S, children: r }), e[32] = r, e[33] = S, e[34] = E) : E = e[34];
    let N;
    return e[35] !== o || e[36] !== R || e[37] !== E ? (N = /* @__PURE__ */ F("div", { ...o, className: "flex flex-col gap-(--spacing-4) px-(--spacing-16)", children: [
      R,
      E
    ] }), e[35] = o, e[36] = R, e[37] = E, e[38] = N) : N = e[38], N;
  }
  const h = d ? "flex-col" : "flex-row";
  let b;
  e[39] !== m || e[40] !== h ? (b = oe("flex", h, m), e[39] = m, e[40] = h, e[41] = b) : b = e[41];
  let v;
  e[42] !== f || e[43] !== p ? (v = oe("grow", p, f), e[42] = f, e[43] = p, e[44] = v) : v = e[44];
  let C;
  e[45] !== a || e[46] !== v ? (C = /* @__PURE__ */ g("hr", { "aria-orientation": a, className: v }), e[45] = a, e[46] = v, e[47] = C) : C = e[47];
  let y;
  return e[48] !== o || e[49] !== b || e[50] !== C ? (y = /* @__PURE__ */ g("div", { ...o, className: b, children: C }), e[48] = o, e[49] = b, e[50] = C, e[51] = y) : y = e[51], y;
}
function jv(t) {
  const e = W.c(7);
  let n, o, r, i, s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ g("path", { d: "M17.3918 80.2045L20.2608 86.5396H24.3507L14.0566 64.5386H10.2275L0 86.5396H3.86238L6.73141 80.2045H17.3918ZM16.1043 77.3364H7.98557L12.0089 68.333L16.0988 77.3364H16.1043ZM41.9423 75.356C41.5483 71.5949 39.0733 69.8474 34.2564 69.8474C29.4395 69.8474 26.5982 71.728 26.5982 74.8623C26.5982 76.5764 27.586 78.0299 29.1731 78.6567C30.2608 79.0839 31.0877 79.2836 34.2231 79.7773C36.4872 80.1286 37.8283 80.3931 38.2464 80.5706C38.8735 80.8369 39.2342 81.3971 39.2342 82.0573C39.2342 83.5773 37.5194 84.4316 34.4173 84.4316C31.3152 84.4316 29.434 83.3443 29.2009 81.264H25.8657C26.4928 85.2249 29.101 86.9723 34.3785 86.9723C39.6559 86.9723 42.5305 85.125 42.5305 81.7244C42.5305 80.271 41.97 79.1172 40.9489 78.3627C39.9945 77.6693 39.4007 77.5362 34.9778 76.8427C32.2697 76.4156 31.6759 76.3157 31.0155 76.0494C30.2886 75.7832 29.7947 75.1896 29.7947 74.5627C29.7947 73.2425 31.5094 72.3882 34.0844 72.3882C37.02 72.3882 38.4406 73.309 38.7014 75.356H41.9367H41.9423ZM61.5039 75.356C61.1099 71.5949 58.6349 69.8474 53.8124 69.8474C48.99 69.8474 46.1543 71.728 46.1543 74.8623C46.1543 76.5764 47.1421 78.0299 48.7292 78.6567C49.8169 79.0839 50.6437 79.2836 53.7791 79.7773C56.0433 80.1286 57.3844 80.3931 57.8024 80.5706C58.4295 80.8369 58.7902 81.3971 58.7902 82.0573C58.7902 83.5773 57.0755 84.4316 53.9734 84.4316C50.8713 84.4316 48.99 83.3443 48.7569 81.264H45.4218C46.0488 85.2249 48.6571 86.9723 53.9345 86.9723C59.212 86.9723 62.0866 85.125 62.0866 81.7244C62.0866 80.271 61.5261 79.1172 60.505 78.3627C59.5505 77.6693 58.9567 77.5362 54.5339 76.8427C51.8257 76.4156 51.232 76.3157 50.5716 76.0494C49.8446 75.7832 49.3507 75.1896 49.3507 74.5627C49.3507 73.2425 51.0655 72.3882 53.6404 72.3882C56.576 72.3882 57.9967 73.309 58.2575 75.356H61.4928H61.5039ZM83.1521 79.3502C83.1521 77.3364 82.919 76.0827 82.3585 74.7014C81.1043 71.667 77.9689 69.853 74.0732 69.853C68.6959 69.853 64.9667 73.3811 64.9667 78.4959C64.9667 83.6106 68.596 86.9723 74.0067 86.9723C78.3296 86.9723 81.232 85.1583 82.8524 81.4637H79.3896C78.5627 83.4441 76.8479 84.4316 74.3063 84.4316C70.7769 84.4316 68.4018 82.4844 68.0688 79.3502H83.1465H83.1521ZM68.1687 76.8427C68.929 73.9747 71.0377 72.3549 74.0455 72.3549C77.0533 72.3549 79.162 73.9692 79.8835 76.8427H68.1687ZM90.9822 65.759H87.7802V70.2801H85.6659V72.9207H87.7802V82.3901C87.7802 84.4704 87.9467 85.1916 88.6071 85.8184C89.3008 86.5119 90.5549 86.8724 92.1698 86.8724C92.9634 86.8724 93.5572 86.8059 94.778 86.6394V83.9656C94.0178 84.0987 93.6903 84.132 93.03 84.132C91.3818 84.132 90.9822 83.7714 90.9822 82.2847V72.9152H94.778V70.2746H90.9822V65.7535V65.759ZM123.069 86.5396L130.494 64.5386H127.031L121.226 82.6841L115.022 64.5386H111.193L105.022 82.6841L99.3785 64.5386H95.5494L102.941 86.5396H106.87L113.041 68.2664L119.345 86.5396H123.074H123.069ZM135.305 75.6556C135.538 73.248 136.92 72.3549 140.422 72.3549C143.391 72.3549 144.811 73.1482 144.811 74.8956C144.811 75.7221 144.417 76.2159 143.524 76.5099C142.697 76.7762 142.203 76.8427 139.301 77.1367C135.905 77.4973 135.178 77.6637 133.99 78.1907C132.469 78.8842 131.515 80.3986 131.515 82.1516C131.515 85.1527 133.923 87 137.852 87C140.788 87 142.836 86.2067 144.817 84.3262C145.444 86.1402 146.371 86.767 148.38 86.767C149.073 86.767 149.467 86.7005 150.061 86.5008V84.3262C149.795 84.3595 149.534 84.3928 149.334 84.3928C148.246 84.426 147.847 83.8657 147.847 82.2792V75.0565C147.847 73.076 147.386 71.9555 146.265 71.1955C144.911 70.269 142.963 69.8419 140.294 69.8419C136.926 69.8419 134.551 70.7017 133.23 72.3826C132.569 73.2092 132.275 74.0635 132.109 75.65H135.311L135.305 75.6556ZM144.806 79.744C144.806 81.2917 144.573 81.9186 143.651 82.8117C142.497 83.899 140.877 84.4593 138.735 84.4593C136.127 84.4593 134.806 83.5995 134.806 81.9519C134.806 80.4652 135.699 79.9049 138.568 79.6109C141.143 79.3446 143.024 78.984 144.806 78.4237V79.744ZM156.748 65.759H153.546V70.2801H151.432V72.9207H153.546V82.3901C153.546 84.4704 153.713 85.1916 154.373 85.8184C155.067 86.5119 156.321 86.8724 157.936 86.8724C158.729 86.8724 159.323 86.8059 160.544 86.6394V83.9656C159.784 84.0987 159.456 84.132 158.796 84.132C157.148 84.132 156.748 83.7714 156.748 82.2847V72.9152H160.544V70.2746H156.748V65.7535V65.759ZM176.759 80.6372C175.999 83.1779 174.351 84.4316 171.709 84.4316C168.08 84.4316 165.871 82.1571 165.871 78.3627C165.871 74.5683 168.019 72.3604 171.681 72.3604C174.223 72.3604 175.938 73.481 176.665 75.6278H179.767C178.94 71.9998 175.938 69.853 171.615 69.853C166.104 69.853 162.669 73.1537 162.669 78.4959C162.669 83.838 166.038 86.9723 171.615 86.9723C176.038 86.9723 179.04 84.6979 179.895 80.6372H176.759ZM183.862 86.5396H187.064V77.0702C187.064 74.596 189.639 72.549 192.775 72.549C193.962 72.549 194.95 72.8486 195.677 73.4422C196.537 74.1356 196.798 74.7957 196.798 76.41V86.5396H200V76.1826C200 73.775 199.573 72.5213 198.452 71.5339C197.231 70.4466 195.45 69.853 193.402 69.853C190.76 69.853 189.145 70.5464 187.064 72.5879V64.5386H183.862V86.5396Z" }), o = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M66.5202 30.3223L58.0352 45.2171H69.2338C71.0429 45.2171 72.8243 44.7344 74.3892 43.8247C75.9541 42.9149 77.2527 41.6001 78.1406 40.0247L83.6345 30.3223H66.5091H66.5202Z" }), r = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M78.0688 20.1038L89.3841 40.0356C90.2775 41.6111 91.5705 42.9203 93.1354 43.8301C94.7004 44.7398 96.4762 45.2225 98.2908 45.2169H109.501L83.757 0L78.0744 9.97979C77.1976 11.522 76.7314 13.2639 76.7314 15.039C76.7314 16.8142 77.192 18.5561 78.0688 20.0983V20.1038Z" }), i = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M109.5 0L103.818 9.97979C102.941 11.522 102.48 13.2639 102.48 15.039C102.48 16.8142 102.941 18.5561 103.818 20.0983L115.139 40.0301C116.032 41.6056 117.325 42.9092 118.89 43.8245C120.455 44.7343 122.231 45.2169 124.04 45.2169H135.25L109.5 0Z" }), s = /* @__PURE__ */ g("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M135.245 0L129.562 9.97979C128.685 11.522 128.225 13.2694 128.225 15.039C128.225 16.8086 128.685 18.5561 129.562 20.0983L135.245 30.078L143.807 15.0335L135.245 0Z" }), e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = s) : (n = e[0], o = e[1], r = e[2], i = e[3], s = e[4]);
  let l;
  return e[5] !== t ? (l = /* @__PURE__ */ F("svg", { width: "200", height: "87", viewBox: "0 0 200 87", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    n,
    o,
    r,
    i,
    s
  ] }), e[5] = t, e[6] = l) : l = e[6], l;
}
const T1 = {
  default: "fill-surface-inverse-surface",
  primary: "fill-primary"
}, Kv = {
  default: {
    width: 44,
    height: 23.21
  },
  compact: {
    width: 24.16,
    height: 12.74
  },
  display: {
    width: 90,
    height: 47.47
  },
  stacked: {
    width: 200,
    height: 87
  }
};
function qv(t) {
  const e = W.c(29);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    size: s,
    style: i,
    tone: l,
    "aria-label": o,
    "aria-hidden": n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? "default" : s, c = !o, u = Kv[a], d = l ?? "primary";
  if (a === "stacked") {
    const C = T1[d], y = n ?? (c ? !0 : void 0), w = c ? void 0 : "img";
    let R;
    e[7] !== i ? (R = {
      flexShrink: 0,
      ...i
    }, e[7] = i, e[8] = R) : R = e[8];
    let S;
    return e[9] !== o || e[10] !== r || e[11] !== C || e[12] !== y || e[13] !== w || e[14] !== R ? (S = /* @__PURE__ */ g(jv, { ...r, className: C, "aria-hidden": y, "aria-label": o, role: w, style: R }), e[9] = o, e[10] = r, e[11] = C, e[12] = y, e[13] = w, e[14] = R, e[15] = S) : S = e[15], S;
  }
  const f = n ?? (c ? !0 : void 0), p = c ? void 0 : "img";
  let m;
  e[16] !== i ? (m = {
    flexShrink: 0,
    ...i
  }, e[16] = i, e[17] = m) : m = e[17];
  const h = T1[d];
  let b;
  e[18] !== h ? (b = /* @__PURE__ */ g("path", { d: "M10.3174 20.54C9.85932 21.349 9.19472 22.0221 8.3916 22.4902C7.58855 22.9583 6.67561 23.2051 5.74609 23.2051H0L4.35254 15.5615H13.1367L10.3174 20.54ZM26.4014 23.2051H20.6514C19.7228 23.2052 18.8103 22.9593 18.0078 22.4922C17.2054 22.0251 16.5415 21.3532 16.083 20.5459L10.2764 10.3164C9.8266 9.52465 9.59036 8.62933 9.59082 7.71875C9.59128 6.80816 9.82872 5.91337 10.2793 5.12207L13.1934 0L26.4014 23.2051ZM39.6104 23.2021H33.8613C32.9331 23.2021 32.021 22.9562 31.2188 22.4893C30.4164 22.0221 29.7514 21.3504 29.293 20.543L23.4863 10.3135C23.0366 9.52227 22.7998 8.62785 22.7998 7.71777C22.7998 6.8077 23.0366 5.91328 23.4863 5.12207L26.4014 0L39.6104 23.2021ZM44 7.71973L39.6084 15.4395L36.6934 10.3174C36.243 9.52576 36.0068 8.63047 36.0068 7.71973C36.0068 6.80898 36.243 5.91369 36.6934 5.12207L39.6084 0L44 7.71973Z", className: h }), e[18] = h, e[19] = b) : b = e[19];
  let v;
  return e[20] !== o || e[21] !== u.height || e[22] !== u.width || e[23] !== r || e[24] !== f || e[25] !== p || e[26] !== m || e[27] !== b ? (v = /* @__PURE__ */ g("svg", { ...r, width: u.width, height: u.height, viewBox: "0 0 44 23.21", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": f, "aria-label": o, role: p, style: m, children: b }), e[20] = o, e[21] = u.height, e[22] = u.width, e[23] = r, e[24] = f, e[25] = p, e[26] = m, e[27] = b, e[28] = v) : v = e[28], v;
}
const Vu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Vu.displayName = "MenuPositionerContext");
function ts(t) {
  const e = x.useContext(Vu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : et(33));
  return e;
}
const Au = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Au.displayName = "MenuRootContext");
function Qn(t) {
  const e = x.useContext(Au);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRootContext is missing. Menu parts must be placed within <Menu.Root>." : et(36));
  return e;
}
let un = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = Kn.startingStyle] = "startingStyle", t[t.endingStyle = Kn.endingStyle] = "endingStyle", t.anchorHidden = "data-anchor-hidden", t.side = "data-side", t.align = "data-align", t;
})({}), Tl = /* @__PURE__ */ (function(t) {
  return t.popupOpen = "data-popup-open", t.pressed = "data-pressed", t;
})({});
const Zv = {
  [Tl.popupOpen]: ""
}, Xv = {
  [Tl.popupOpen]: "",
  [Tl.pressed]: ""
}, Qv = {
  [un.open]: ""
}, Jv = {
  [un.closed]: ""
}, e8 = {
  [un.anchorHidden]: ""
}, br = {
  open(t) {
    return t ? Zv : null;
  }
}, zi = {
  open(t) {
    return t ? Xv : null;
  }
}, kn = {
  open(t) {
    return t ? Qv : Jv;
  },
  anchorHidden(t) {
    return t ? e8 : null;
  }
}, Lg = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Lg.displayName = "ContextMenuRootContext");
function oa(t = !0) {
  const e = x.useContext(Lg);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>." : et(25));
  return e;
}
const Pt = "none", qn = "trigger-press", At = "trigger-hover", dr = "trigger-focus", ns = "outside-press", Wo = "item-press", Fg = "close-press", O1 = "clear-press", t8 = "chip-remove-press", _r = "input-change", Ho = "input-clear", $g = "input-press", Io = "focus-out", vr = "escape-key", n8 = "close-watcher", Fr = "list-navigation", o8 = "pointer", Hg = "cancel-open", Ti = "sibling-open", r8 = "disabled", os = "imperative-action", Ws = "swipe", i8 = "window-resize";
function dn({
  controlled: t,
  default: e,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = x.useRef(t !== void 0), [i, s] = x.useState(e), l = r ? t : i;
  if (process.env.NODE_ENV !== "production") {
    x.useEffect(() => {
      r !== (t !== void 0) && jo([`A component is changing the ${r ? "" : "un"}controlled ${o} state of ${n} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, t]);
    const {
      current: c
    } = x.useRef(e);
    x.useEffect(() => {
      !r && D1(c) !== D1(e) && jo([`A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [e]);
  }
  const a = x.useCallback((c) => {
    r || s(c);
  }, []);
  return [l, a];
}
function D1(t) {
  let e = 0;
  const n = /* @__PURE__ */ new WeakMap();
  try {
    return JSON.stringify(t, function(i, s) {
      if (!(i === "_owner" && this != null && typeof this == "object" && "$$typeof" in this)) {
        if (typeof s == "bigint")
          return `__bigint__:${s}`;
        if (s !== null && typeof s == "object") {
          const l = n.get(s);
          if (l !== void 0)
            return `__object__:${l}`;
          n.set(s, e), e += 1;
        }
        return s;
      }
    }) ?? `__top__:${typeof t}`;
  } catch {
    return "__unserializable__";
  }
}
const zg = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (zg.displayName = "MenuCheckboxItemContext");
const yr = typeof navigator < "u", Ya = s8(), Bg = a8(), Lu = l8(), Fu = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), $u = (
  // iPads can claim to be MacIntel
  Ya.platform === "MacIntel" && Ya.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(Ya.platform)
), _1 = yr && /firefox/i.test(Lu), Wg = yr && /apple/i.test(navigator.vendor), Bi = yr && /android/i.test(Bg) || /android/i.test(Lu), Ug = yr && Bg.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, Gg = Lu.includes("jsdom/");
function s8() {
  if (!yr)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const t = navigator.userAgentData;
  return t?.platform ? {
    platform: t.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function l8() {
  if (!yr)
    return "";
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map(({
    brand: e,
    version: n
  }) => `${e}/${n}`).join(" ") : navigator.userAgent;
}
function a8() {
  if (!yr)
    return "";
  const t = navigator.userAgentData;
  return t?.platform ? t.platform : navigator.platform ?? "";
}
function c8(t) {
  const {
    closeOnClick: e,
    highlighted: n,
    id: o,
    nodeId: r,
    store: i,
    typingRef: s,
    itemRef: l,
    itemMetadata: a
  } = t, {
    events: c
  } = i.useState("floatingTreeRoot"), u = oa(!0), d = u !== void 0;
  return x.useMemo(() => ({
    id: o,
    role: "menuitem",
    tabIndex: n ? 0 : -1,
    onKeyDown(f) {
      f.key === " " && s?.current && f.preventDefault();
    },
    onMouseMove(f) {
      r && c.emit("itemhover", {
        nodeId: r,
        target: f.currentTarget
      });
    },
    onClick(f) {
      e && c.emit("close", {
        domEvent: f,
        reason: Wo
      });
    },
    onMouseUp(f) {
      if (u) {
        const p = u.initialCursorPointRef.current;
        if (u.initialCursorPointRef.current = null, d && p && Math.abs(f.clientX - p.x) <= 1 && Math.abs(f.clientY - p.y) <= 1 || d && !Ug && f.button === 2)
          return;
      }
      l.current && i.context.allowMouseUpTriggerRef.current && (!d || f.button === 2) && (!a || a.type === "regular-item") && l.current.click();
    }
  }), [e, n, o, c, r, i, s, l, u, d, a]);
}
const Hu = {
  type: "regular-item"
};
function ra(t) {
  const {
    closeOnClick: e,
    disabled: n = !1,
    highlighted: o,
    id: r,
    store: i,
    typingRef: s = i.context.typingRef,
    nativeButton: l,
    itemMetadata: a,
    nodeId: c
  } = t, u = x.useRef(null), {
    getButtonProps: d,
    buttonRef: f
  } = Bt({
    disabled: n,
    focusableWhenDisabled: !0,
    native: l,
    composite: !0
  }), p = c8({
    closeOnClick: e,
    highlighted: o,
    id: r,
    nodeId: c,
    store: i,
    typingRef: s,
    itemRef: u,
    itemMetadata: a
  }), m = x.useCallback((b) => en(p, {
    onMouseEnter() {
      a.type === "submenu-trigger" && a.setActive();
    }
  }, b, d), [p, d, a]), h = fn(u, f);
  return x.useMemo(() => ({
    getItemProps: m,
    itemRef: h
  }), [m, h]);
}
const zu = /* @__PURE__ */ x.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (zu.displayName = "CompositeListContext");
function u8() {
  return x.useContext(zu);
}
let Bu = /* @__PURE__ */ (function(t) {
  return t[t.None = 0] = "None", t[t.GuessFromOrder = 1] = "GuessFromOrder", t;
})({});
function Oo(t = {}) {
  const {
    label: e,
    metadata: n,
    textRef: o,
    indexGuessBehavior: r,
    index: i
  } = t, {
    register: s,
    unregister: l,
    subscribeMapChange: a,
    elementsRef: c,
    labelsRef: u,
    nextIndexRef: d
  } = u8(), f = x.useRef(-1), [p, m] = x.useState(i ?? (r === Bu.GuessFromOrder ? () => {
    if (f.current === -1) {
      const v = d.current;
      d.current += 1, f.current = v;
    }
    return f.current;
  } : -1)), h = x.useRef(null), b = x.useCallback((v) => {
    if (h.current = v, p !== -1 && v !== null && (c.current[p] = v, u)) {
      const C = e !== void 0;
      u.current[p] = C ? e : o?.current?.textContent ?? v.textContent;
    }
  }, [p, c, u, e, o]);
  return Ne(() => {
    if (i != null)
      return;
    const v = h.current;
    if (v)
      return s(v, n), () => {
        l(v);
      };
  }, [i, s, l, n]), Ne(() => {
    if (i == null)
      return a((v) => {
        const C = h.current ? v.get(h.current)?.index : null;
        C != null && m(C);
      });
  }, [i, a, m]), x.useMemo(() => ({
    ref: b,
    index: p
  }), [p, b]);
}
let V1 = 0;
function d8(t, e = "mui") {
  const [n, o] = x.useState(t), r = t || n;
  return x.useEffect(() => {
    n == null && (V1 += 1, o(`${e}-${V1}`));
  }, [n, e]), r;
}
const A1 = pr.useId;
function Do(t, e) {
  if (A1 !== void 0) {
    const n = A1();
    return t ?? (e ? `${e}-${n}` : n);
  }
  return d8(t, e);
}
function kt(t) {
  return Do(t, "base-ui");
}
let L1 = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.highlighted = "data-highlighted", t;
})({});
const Wu = {
  checked(t) {
    return t ? {
      [L1.checked]: ""
    } : {
      [L1.unchecked]: ""
    };
  },
  ...zt
};
function De(t, e, n, o) {
  let r = !1, i = !1;
  const s = o ?? St;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    cancel() {
      r = !0;
    },
    allowPropagation() {
      i = !0;
    },
    get isCanceled() {
      return r;
    },
    get isPropagationAllowed() {
      return i;
    },
    trigger: n,
    ...s
  };
}
function wi(t, e, n) {
  const o = n ?? St;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    ...o
  };
}
const Yg = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !1,
    checked: u,
    defaultChecked: d,
    onCheckedChange: f,
    style: p,
    ...m
  } = e, h = Oo({
    label: s
  }), b = ts(!0), v = kt(i), {
    store: C
  } = Qn(), y = C.useState("isActive", h.index), w = C.useState("itemProps"), [R, S] = dn({
    controlled: u,
    default: d ?? !1,
    name: "MenuCheckboxItem",
    state: "checked"
  }), {
    getItemProps: E,
    itemRef: N
  } = ra({
    closeOnClick: c,
    disabled: a,
    highlighted: y,
    id: v,
    store: C,
    nativeButton: l,
    nodeId: b?.context.nodeId,
    itemMetadata: Hu
  }), I = x.useMemo(() => ({
    disabled: a,
    highlighted: y,
    checked: R
  }), [a, y, R]), T = Ce((P) => {
    const M = {
      ...De(Wo, P.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    f?.(!R, M), !M.isCanceled && S((D) => !D);
  }), k = Le("div", e, {
    state: I,
    stateAttributesMapping: Wu,
    props: [w, {
      role: "menuitemcheckbox",
      "aria-checked": R,
      onClick: T
    }, m, E],
    ref: [N, n, h.ref]
  });
  return /* @__PURE__ */ g(zg.Provider, {
    value: I,
    children: k
  });
});
process.env.NODE_ENV !== "production" && (Yg.displayName = "MenuCheckboxItem");
const jg = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !0,
    style: u,
    ...d
  } = e, f = Oo({
    label: s
  }), p = ts(!0), m = kt(i), {
    store: h
  } = Qn(), b = h.useState("isActive", f.index), v = h.useState("itemProps"), {
    getItemProps: C,
    itemRef: y
  } = ra({
    closeOnClick: c,
    disabled: a,
    highlighted: b,
    id: m,
    store: h,
    nativeButton: l,
    nodeId: p?.context.nodeId,
    itemMetadata: Hu
  });
  return Le("div", e, {
    state: {
      disabled: a,
      highlighted: b
    },
    props: [v, d, C],
    ref: [y, n, f.ref]
  });
});
process.env.NODE_ENV !== "production" && (jg.displayName = "MenuItem");
function Lt(t) {
  t.preventDefault(), t.stopPropagation();
}
function f8(t) {
  return "nativeEvent" in t;
}
function Kg(t) {
  return t.pointerType === "" && t.isTrusted ? !0 : Bi && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function qg(t) {
  return Gg ? !1 : !Bi && t.width === 0 && t.height === 0 || Bi && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function Yr(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
function Zg(t) {
  const e = t.type;
  return e === "click" || e === "mousedown" || e === "keydown" || e === "keyup";
}
function p8(t, e) {
  return e != null && !Yr(e) ? 0 : typeof t == "function" ? t() : t;
}
function Ol(t, e, n) {
  const o = p8(t, n);
  return typeof o == "number" ? o : o?.[e];
}
function F1(t) {
  return typeof t == "function" ? t() : t;
}
function Xg(t, e) {
  return e || t === "click" || t === "mousedown";
}
const Uu = /* @__PURE__ */ x.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new xn(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (Uu.displayName = "FloatingDelayGroupContext");
function m8(t) {
  const {
    children: e,
    delay: n,
    timeoutMs: o = 0
  } = t, r = x.useRef(n), i = x.useRef(n), s = x.useRef(null), l = x.useRef(null), a = Dt();
  return /* @__PURE__ */ g(Uu.Provider, {
    value: x.useMemo(() => ({
      hasProvider: !0,
      delayRef: r,
      initialDelayRef: i,
      currentIdRef: s,
      timeoutMs: o,
      currentContextRef: l,
      timeout: a
    }), [o, a]),
    children: e
  });
}
function g8(t, e = {
  open: !1
}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("floatingId"), {
    open: r
  } = e, i = x.useContext(Uu), {
    currentIdRef: s,
    delayRef: l,
    timeoutMs: a,
    initialDelayRef: c,
    currentContextRef: u,
    hasProvider: d,
    timeout: f
  } = i, [p, m] = x.useState(!1);
  return Ne(() => {
    function h() {
      m(!1), u.current?.setIsInstantPhase(!1), s.current = null, u.current = null, l.current = c.current;
    }
    if (s.current && !r && s.current === o) {
      if (m(!1), a) {
        const b = o;
        return f.start(a, () => {
          n.select("open") || s.current && s.current !== b || h();
        }), () => {
          f.clear();
        };
      }
      h();
    }
  }, [r, o, s, l, a, c, u, f, n]), Ne(() => {
    if (!r)
      return;
    const h = u.current, b = s.current;
    f.clear(), u.current = {
      onOpenChange: n.setOpen,
      setIsInstantPhase: m
    }, s.current = o, l.current = {
      open: 0,
      close: Ol(c.current, "close")
    }, b !== null && b !== o ? (m(!0), h?.setIsInstantPhase(!0), h?.onOpenChange(!1, De(Pt))) : (m(!1), h?.setIsInstantPhase(!1));
  }, [r, o, n, s, l, a, c, u, f]), Ne(() => () => {
    u.current = null;
  }, [u]), x.useMemo(() => ({
    hasProvider: d,
    delayRef: l,
    isInstantPhase: p
  }), [d, l, p]);
}
function at(t, e, n, o) {
  return t.addEventListener(e, n, o), () => {
    t.removeEventListener(e, n, o);
  };
}
function Yn(...t) {
  return () => {
    for (let e = 0; e < t.length; e += 1) {
      const n = t[e];
      n && n();
    }
  };
}
function Ft(t) {
  const e = It(h8, t).current;
  return e.next = t, Ne(e.effect), e;
}
function h8(t) {
  const e = {
    current: t,
    next: t,
    effect: () => {
      e.current = e.next;
    }
  };
  return e;
}
function Je(t) {
  return t?.ownerDocument || document;
}
const Qg = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, Jo = {
  ...Qg,
  position: "fixed",
  top: 0,
  left: 0
}, ei = {
  ...Qg,
  position: "absolute"
}, Vn = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const [o, r] = x.useState();
  return Ne(() => {
    Wg && r("button");
  }, []), /* @__PURE__ */ g("span", {
    ...e,
    ref: n,
    style: Jo,
    "aria-hidden": o ? void 0 : !0,
    ...{
      tabIndex: 0,
      // Role is only for VoiceOver
      role: o
    },
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (Vn.displayName = "FocusGuard");
const Xc = "data-base-ui-focusable", Jg = "active", eh = "selected", th = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", Uo = "ArrowLeft", Go = "ArrowRight", Gu = "ArrowUp", rs = "ArrowDown";
function Ut(t) {
  let e = t.activeElement;
  for (; e?.shadowRoot?.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
function Fe(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode?.();
  if (t.contains(e))
    return !0;
  if (n && Gr(n)) {
    let o = e;
    for (; o; ) {
      if (t === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function bt(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function Dl(t, e) {
  if (!pt(t))
    return !1;
  const n = t;
  if (e.hasElement(n))
    return !n.hasAttribute("data-trigger-disabled");
  for (const [, o] of e.entries())
    if (Fe(o, n))
      return !o.hasAttribute("data-trigger-disabled");
  return !1;
}
function zn(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
function b8(t) {
  return t.matches("html,body");
}
function ia(t) {
  return xt(t) && t.matches(th);
}
function nh(t) {
  return t?.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${th}`) != null;
}
function Qc(t) {
  return t ? t.getAttribute("role") === "combobox" && ia(t) : !1;
}
function _l(t) {
  if (!t || Gg)
    return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function Wi(t) {
  return t ? t.hasAttribute(Xc) ? t : t.querySelector(`[${Xc}]`) || t : null;
}
const v8 = ["top", "right", "bottom", "left"], jr = Math.min, Sn = Math.max, Vl = Math.round, ar = Math.floor, ao = (t) => ({
  x: t,
  y: t
}), y8 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Jc(t, e, n) {
  return Sn(t, jr(e, n));
}
function To(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function yn(t) {
  return t.split("-")[0];
}
function er(t) {
  return t.split("-")[1];
}
function Yu(t) {
  return t === "x" ? "y" : "x";
}
function ju(t) {
  return t === "y" ? "height" : "width";
}
function _n(t) {
  const e = t[0];
  return e === "t" || e === "b" ? "y" : "x";
}
function Ku(t) {
  return Yu(_n(t));
}
function x8(t, e, n) {
  n === void 0 && (n = !1);
  const o = er(t), r = Ku(t), i = ju(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = Al(s)), [s, Al(s)];
}
function C8(t) {
  const e = Al(t);
  return [eu(t), e, eu(e)];
}
function eu(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const $1 = ["left", "right"], H1 = ["right", "left"], w8 = ["top", "bottom"], S8 = ["bottom", "top"];
function R8(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? H1 : $1 : e ? $1 : H1;
    case "left":
    case "right":
      return e ? w8 : S8;
    default:
      return [];
  }
}
function E8(t, e, n, o) {
  const r = er(t);
  let i = R8(yn(t), n === "start", o);
  return r && (i = i.map((s) => s + "-" + r), e && (i = i.concat(i.map(eu)))), i;
}
function Al(t) {
  const e = yn(t);
  return y8[e] + t.slice(e.length);
}
function N8(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function oh(t) {
  return typeof t != "number" ? N8(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Ui(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function Us(t, e, n) {
  return Math.floor(t / e) !== n;
}
function Gi(t, e) {
  return e < 0 || e >= t.length;
}
function vl(t, e) {
  return rn(t.current, {
    disabledIndices: e
  });
}
function tu(t, e) {
  return rn(t.current, {
    decrement: !0,
    startingIndex: t.current.length,
    disabledIndices: e
  });
}
function rn(t, {
  startingIndex: e = -1,
  decrement: n = !1,
  disabledIndices: o,
  amount: r = 1
} = {}) {
  let i = e;
  do
    i += n ? -r : r;
  while (i >= 0 && i <= t.length - 1 && No(t, i, o));
  return i;
}
function rh(t, {
  event: e,
  orientation: n,
  loopFocus: o,
  onLoop: r,
  rtl: i,
  cols: s,
  disabledIndices: l,
  minIndex: a,
  maxIndex: c,
  prevIndex: u,
  stopEvent: d = !1
}) {
  let f = u, p;
  if (e.key === Gu ? p = "up" : e.key === rs && (p = "down"), p) {
    const m = [], h = [];
    let b = !1, v = 0;
    {
      let I = null, T = -1;
      t.forEach((k, P) => {
        if (k == null)
          return;
        v += 1;
        const M = k.closest('[role="row"]');
        M && (b = !0), (M !== I || T === -1) && (I = M, T += 1, m[T] = []), m[T].push(P), h[P] = T;
      });
    }
    let C = !1, y = 0;
    if (b)
      for (const I of m) {
        const T = I.length;
        T > y && (y = T), T !== s && (C = !0);
      }
    const w = C && v < t.length, R = y || s, S = (I) => {
      if (!C || u === -1)
        return;
      const T = h[u];
      if (T == null)
        return;
      const k = m[T].indexOf(u), P = I === "up" ? -1 : 1;
      for (let M = T + P, D = 0; D < m.length; D += 1, M += P) {
        if (M < 0 || M >= m.length) {
          if (!o || w)
            return;
          if (M = M < 0 ? m.length - 1 : 0, r) {
            const _ = Math.min(k, m[M].length - 1), V = m[M][_] ?? m[M][0], A = r(e, u, V);
            M = h[A] ?? M;
          }
        }
        const O = m[M];
        for (let _ = Math.min(k, O.length - 1); _ >= 0; _ -= 1) {
          const V = O[_];
          if (!No(t, V, l))
            return V;
        }
      }
    }, E = (I) => {
      if (!w || u === -1)
        return;
      const T = u % R, k = I === "up" ? -R : R, P = c - c % R, M = ar(c / R) + 1;
      for (let D = u - T + k, O = 0; O < M; O += 1, D += k) {
        if (D < 0 || D > c) {
          if (!o)
            return;
          D = D < 0 ? P : 0;
        }
        const _ = Math.min(D + R - 1, c);
        for (let V = Math.min(D + T, _); V >= D; V -= 1)
          if (!No(t, V, l))
            return V;
      }
    };
    d && Lt(e);
    const N = S(p) ?? E(p);
    if (N !== void 0)
      f = N;
    else if (u === -1)
      f = p === "up" ? c : a;
    else if (f = rn(t, {
      startingIndex: u,
      amount: R,
      decrement: p === "up",
      disabledIndices: l
    }), o) {
      if (p === "up" && (u - R < a || f < 0)) {
        const I = u % R, T = c % R, k = c - (T - I);
        T === I ? f = c : f = T > I ? k : k - R, r && (f = r(e, u, f));
      }
      p === "down" && u + R > c && (f = rn(t, {
        startingIndex: u % R - R,
        amount: R,
        disabledIndices: l
      }), r && (f = r(e, u, f)));
    }
    Gi(t, f) && (f = u);
  }
  if (n === "both") {
    const m = ar(u / s);
    e.key === (i ? Uo : Go) && (d && Lt(e), u % s !== s - 1 ? (f = rn(t, {
      startingIndex: u,
      disabledIndices: l
    }), o && Us(f, s, m) && (f = rn(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f)))) : o && (f = rn(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f))), Us(f, s, m) && (f = u)), e.key === (i ? Go : Uo) && (d && Lt(e), u % s !== 0 ? (f = rn(t, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: l
    }), o && Us(f, s, m) && (f = rn(t, {
      startingIndex: u + (s - u % s),
      decrement: !0,
      disabledIndices: l
    }), r && (f = r(e, u, f)))) : o && (f = rn(t, {
      startingIndex: u + (s - u % s),
      decrement: !0,
      disabledIndices: l
    }), r && (f = r(e, u, f))), Us(f, s, m) && (f = u));
    const h = ar(c / s) === m;
    Gi(t, f) && (o && h ? (f = e.key === (i ? Go : Uo) ? c : rn(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f))) : f = u);
  }
  return f;
}
function ih(t, e, n) {
  const o = [];
  let r = 0;
  return t.forEach(({
    width: i,
    height: s
  }, l) => {
    if (i > e && process.env.NODE_ENV !== "production")
      throw new Error(`[Floating UI]: Invalid grid - item width at index ${l} is greater than grid columns`);
    let a = !1;
    for (n && (r = 0); !a; ) {
      const c = [];
      for (let u = 0; u < i; u += 1)
        for (let d = 0; d < s; d += 1)
          c.push(r + u + d * e);
      r % e + i <= e && c.every((u) => o[u] == null) ? (c.forEach((u) => {
        o[u] = l;
      }), a = !0) : r += 1;
    }
  }), [...o];
}
function sh(t, e, n, o, r) {
  if (t === -1)
    return -1;
  const i = n.indexOf(t), s = e[t];
  switch (r) {
    case "tl":
      return i;
    case "tr":
      return s ? i + s.width - 1 : i;
    case "bl":
      return s ? i + (s.height - 1) * o : i;
    case "br":
      return n.lastIndexOf(t);
    default:
      return -1;
  }
}
function lh(t, e) {
  return e.flatMap((n, o) => t.includes(n) ? [o] : []);
}
function No(t, e, n) {
  if (typeof n == "function" ? n(e) : n?.includes(e) ?? !1)
    return !0;
  const r = t[e];
  return r ? sa(r) ? !n && (r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true") : !0 : !1;
}
function k8(t) {
  return t.visibility === "hidden" || t.visibility === "collapse";
}
function sa(t, e = t ? pn(t) : null) {
  return !t || !t.isConnected || !e || k8(e) ? !1 : typeof t.checkVisibility == "function" ? t.checkVisibility() : e.display !== "none" && e.display !== "contents";
}
const M8 = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function P8(t) {
  const e = t.assignedSlot;
  if (e)
    return e;
  if (t.parentElement)
    return t.parentElement;
  const n = t.getRootNode();
  return Gr(n) ? n.host : null;
}
function nu(t) {
  for (const e of Array.from(t.children))
    if (cn(e) === "summary")
      return e;
  return null;
}
function I8(t, e) {
  const n = nu(e);
  return !!n && (t === n || Fe(n, t));
}
function ah(t) {
  const e = t ? cn(t) : "";
  return t != null && t.matches(M8) && (e !== "summary" || t.parentElement != null && cn(t.parentElement) === "details" && nu(t.parentElement) === t) && (e !== "details" || nu(t) == null) && (e !== "input" || t.type !== "hidden");
}
function ch(t) {
  if (!ah(t) || !t.isConnected || t.matches(":disabled"))
    return !1;
  for (let e = t; e; e = P8(e)) {
    const n = e !== t, o = cn(e) === "slot";
    if (e.hasAttribute("inert") || n && cn(e) === "details" && !e.open && !I8(t, e) || e.hasAttribute("hidden") || !o && !T8(e, n))
      return !1;
  }
  return !0;
}
function T8(t, e) {
  const n = pn(t);
  return e ? n.display !== "none" : sa(t, n);
}
function uh(t) {
  const e = t.tabIndex;
  if (e < 0) {
    const n = cn(t);
    if (n === "details" || n === "audio" || n === "video" || xt(t) && t.isContentEditable)
      return 0;
  }
  return e;
}
function ja(t) {
  if (cn(t) !== "input")
    return null;
  const e = t;
  return e.type === "radio" && e.name !== "" ? e : null;
}
function O8(t, e) {
  const n = ja(t);
  if (!n)
    return !0;
  const o = e.find((r) => {
    const i = ja(r);
    return i?.name === n.name && i.form === n.form && i.checked;
  });
  return o ? o === n : e.find((r) => {
    const i = ja(r);
    return i?.name === n.name && i.form === n.form;
  }) === n;
}
function dh(t) {
  if (xt(t) && cn(t) === "slot") {
    const e = t.assignedElements({
      flatten: !0
    });
    if (e.length > 0)
      return e;
  }
  return xt(t) && t.shadowRoot ? Array.from(t.shadowRoot.children) : Array.from(t.children);
}
function fh(t, e) {
  dh(t).forEach((n) => {
    ah(n) && e.push(n), fh(n, e);
  });
}
function ph(t, e, n) {
  dh(t).forEach((o) => {
    xt(o) && o.matches(e) && n.push(o), ph(o, e, n);
  });
}
function qu(t) {
  return ch(t) && uh(t) >= 0;
}
function mh(t) {
  const e = [];
  return fh(t, e), e.filter(ch);
}
function is(t) {
  const e = mh(t);
  return e.filter((n) => uh(n) >= 0 && O8(n, e));
}
function gh(t, e) {
  const n = is(t), o = n.length;
  if (o === 0)
    return;
  const r = Ut(Je(t)), i = n.indexOf(r), s = i === -1 ? e === 1 ? 0 : o - 1 : i + e;
  return n[s];
}
function Zu(t) {
  return gh(Je(t).body, 1) || t;
}
function hh(t) {
  return gh(Je(t).body, -1) || t;
}
function bh(t, e) {
  if (!t)
    return null;
  const n = is(Je(t).body), o = n.length;
  if (o === 0)
    return null;
  const r = n.indexOf(t);
  if (r === -1)
    return null;
  const i = (r + e + o) % o;
  return n[i];
}
function D8(t) {
  return bh(t, 1);
}
function _8(t) {
  return bh(t, -1);
}
function $r(t, e) {
  const n = e || t.currentTarget, o = t.relatedTarget;
  return !o || !Fe(n, o);
}
function V8(t) {
  is(t).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function z1(t) {
  const e = [];
  ph(t, "[data-tabindex]", e), e.forEach((n) => {
    const o = n.dataset.tabindex;
    delete n.dataset.tabindex, o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  });
}
function co(t, e, n = !0) {
  return t.filter((r) => r.parentId === e).flatMap((r) => [...!n || r.context?.open ? [r] : [], ...co(t, r.id, n)]);
}
function B1(t, e) {
  let n = [], o = t.find((r) => r.id === e)?.parentId;
  for (; o; ) {
    const r = t.find((i) => i.id === o);
    o = r?.parentId, r && (n = n.concat(r));
  }
  return n;
}
function Yi(t) {
  return `data-base-ui-${t}`;
}
let Gs = 0;
function yl(t, e = {}) {
  const {
    preventScroll: n = !1,
    cancelPrevious: o = !0,
    sync: r = !1
  } = e;
  o && cancelAnimationFrame(Gs);
  const i = () => t?.focus({
    preventScroll: n
  });
  if (r)
    return i(), yt;
  const s = requestAnimationFrame(i);
  return Gs = s, () => {
    Gs === s && (cancelAnimationFrame(s), Gs = 0);
  };
}
const Ka = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap()
}, W1 = "data-base-ui-inert", ou = {
  inert: /* @__PURE__ */ new WeakSet(),
  "aria-hidden": /* @__PURE__ */ new WeakSet()
};
let Si = /* @__PURE__ */ new WeakMap(), qa = 0;
function A8(t) {
  return ou[t];
}
function vh(t) {
  return t ? Gr(t) ? t.host : vh(t.parentNode) : null;
}
const Za = (t, e) => e.map((n) => {
  if (t.contains(n))
    return n;
  const o = vh(n);
  return t.contains(o) ? o : null;
}).filter((n) => n != null), U1 = (t) => {
  const e = /* @__PURE__ */ new Set();
  return t.forEach((n) => {
    let o = n;
    for (; o && !e.has(o); )
      e.add(o), o = o.parentNode;
  }), e;
}, G1 = (t, e, n) => {
  const o = [], r = (i) => {
    !i || n.has(i) || Array.from(i.children).forEach((s) => {
      cn(s) !== "script" && (e.has(s) ? r(s) : o.push(s));
    });
  };
  return r(t), o;
};
function L8(t, e, n, o, {
  mark: r = !0,
  markerIgnoreElements: i = []
}) {
  const s = o ? "inert" : n ? "aria-hidden" : null;
  let l = null, a = null;
  const c = Za(e, t), u = r ? Za(e, i) : [], d = new Set(u), f = r ? G1(e, U1(c), new Set(c)).filter((h) => !d.has(h)) : [], p = [], m = [];
  if (s) {
    const h = Ka[s], b = A8(s);
    a = b, l = h;
    const v = Za(e, Array.from(e.querySelectorAll("[aria-live]"))), C = c.concat(v);
    G1(e, U1(C), new Set(C)).forEach((w) => {
      const R = w.getAttribute(s), S = R !== null && R !== "false", E = (h.get(w) || 0) + 1;
      h.set(w, E), p.push(w), E === 1 && S && b.add(w), S || w.setAttribute(s, s === "inert" ? "" : "true");
    });
  }
  return r && f.forEach((h) => {
    const b = (Si.get(h) || 0) + 1;
    Si.set(h, b), m.push(h), b === 1 && h.setAttribute(W1, "");
  }), qa += 1, () => {
    l && p.forEach((h) => {
      const v = (l.get(h) || 0) - 1;
      l.set(h, v), v || (!a?.has(h) && s && h.removeAttribute(s), a?.delete(h));
    }), r && m.forEach((h) => {
      const b = (Si.get(h) || 0) - 1;
      Si.set(h, b), b || h.removeAttribute(W1);
    }), qa -= 1, qa || (Ka.inert = /* @__PURE__ */ new WeakMap(), Ka["aria-hidden"] = /* @__PURE__ */ new WeakMap(), ou.inert = /* @__PURE__ */ new WeakSet(), ou["aria-hidden"] = /* @__PURE__ */ new WeakSet(), Si = /* @__PURE__ */ new WeakMap());
  };
}
function Y1(t, e = {}) {
  const {
    ariaHidden: n = !1,
    inert: o = !1,
    mark: r = !0,
    markerIgnoreElements: i = []
  } = e, s = Je(t[0]).body;
  return L8(t, s, n, o, {
    mark: r,
    markerIgnoreElements: i
  });
}
const F8 = 500, yh = 500, $8 = {
  style: {
    transition: "none"
  }
}, Xu = "data-base-ui-click-trigger", H8 = "data-base-ui-swipe-ignore", z8 = "data-swipe-ignore", xh = `[${H8}]`, B8 = `[${z8}]`, Qu = {
  fallbackAxisSide: "none"
}, la = {
  fallbackAxisSide: "end"
}, W8 = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
}, Ju = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Ju.displayName = "PortalContext");
const Ch = () => x.useContext(Ju), U8 = Yi("portal");
function wh(t = {}) {
  const {
    ref: e,
    container: n,
    componentProps: o = St,
    elementProps: r
  } = t, i = Do(), l = Ch()?.portalNode, [a, c] = x.useState(null), [u, d] = x.useState(null), f = Ce((b) => {
    b !== null && d(b);
  }), p = x.useRef(null);
  Ne(() => {
    if (n === null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    if (i == null)
      return;
    const b = (n && (Mu(n) ? n : n.current)) ?? l ?? document.body;
    if (b == null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    p.current !== b && (p.current = b, d(null), c(b));
  }, [n, l, i]);
  const m = Le("div", o, {
    ref: [e, f],
    props: [{
      id: i,
      [U8]: ""
    }, r]
  });
  return {
    portalNode: u,
    portalSubtree: a && m ? /* @__PURE__ */ an.createPortal(m, a) : null
  };
}
const ti = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: i,
    render: s,
    renderGuards: l,
    style: a,
    ...c
  } = e, {
    portalNode: u,
    portalSubtree: d
  } = wh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: c
  }), f = x.useRef(null), p = x.useRef(null), m = x.useRef(null), h = x.useRef(null), [b, v] = x.useState(null), C = x.useRef(!1), y = b?.modal, w = b?.open, R = typeof l == "boolean" ? l : !!b && !b.modal && b.open && !!u;
  x.useEffect(() => {
    if (!u || y)
      return;
    function E(N) {
      u && N.relatedTarget && $r(N) && (N.type === "focusin" ? C.current && (z1(u), C.current = !1) : (V8(u), C.current = !0));
    }
    return Yn(at(u, "focusin", E, !0), at(u, "focusout", E, !0));
  }, [u, y]), x.useEffect(() => {
    !u || w !== !1 || (z1(u), C.current = !1);
  }, [w, u]);
  const S = x.useMemo(() => ({
    beforeOutsideRef: f,
    afterOutsideRef: p,
    beforeInsideRef: m,
    afterInsideRef: h,
    portalNode: u,
    setFocusManagerState: v
  }), [u]);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [d, /* @__PURE__ */ F(Ju.Provider, {
      value: S,
      children: [R && u && /* @__PURE__ */ g(Vn, {
        "data-type": "outside",
        ref: f,
        onFocus: (E) => {
          if ($r(E, u))
            m.current?.focus();
          else {
            const N = b ? b.domReference : null;
            hh(N)?.focus();
          }
        }
      }), R && u && /* @__PURE__ */ g("span", {
        "aria-owns": u.id,
        style: W8
      }), u && /* @__PURE__ */ an.createPortal(o, u), R && u && /* @__PURE__ */ g(Vn, {
        "data-type": "outside",
        ref: p,
        onFocus: (E) => {
          if ($r(E, u))
            h.current?.focus();
          else {
            const N = b ? b.domReference : null;
            Zu(N)?.focus(), b?.closeOnFocusOut && b?.onOpenChange(!1, De(Io, E.nativeEvent));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (ti.displayName = "FloatingPortal");
function Sh() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      t.get(e)?.forEach((o) => o(n));
    },
    on(e, n) {
      t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n);
    },
    off(e, n) {
      t.get(e)?.delete(n);
    }
  };
}
class ed {
  nodesRef = {
    current: []
  };
  events = Sh();
  addNode(e) {
    this.nodesRef.current.push(e);
  }
  removeNode(e) {
    const n = this.nodesRef.current.findIndex((o) => o === e);
    n !== -1 && this.nodesRef.current.splice(n, 1);
  }
}
const td = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (td.displayName = "FloatingNodeContext");
const nd = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (nd.displayName = "FloatingTreeContext");
const bo = () => x.useContext(td)?.id || null, tr = (t) => {
  const e = x.useContext(nd);
  return t ?? e;
};
function aa(t) {
  const e = Do(), n = tr(t), o = bo();
  return Ne(() => {
    if (!e)
      return;
    const r = {
      id: e,
      parentId: o
    };
    return n?.addNode(r), () => {
      n?.removeNode(r);
    };
  }, [n, e, o]), e;
}
function od(t) {
  const {
    children: e,
    id: n
  } = t, o = bo();
  return /* @__PURE__ */ g(td.Provider, {
    value: x.useMemo(() => ({
      id: n,
      parentId: o
    }), [n, o]),
    children: e
  });
}
function rd(t) {
  const {
    children: e,
    externalTree: n
  } = t, o = It(() => n ?? new ed()).current;
  return /* @__PURE__ */ g(nd.Provider, {
    value: o,
    children: e
  });
}
function G8(t, e) {
  const n = Ct(bt(t));
  return t instanceof n.KeyboardEvent ? "keyboard" : t instanceof n.FocusEvent ? e || "keyboard" : "pointerType" in t ? t.pointerType || "keyboard" : "touches" in t ? "touch" : t instanceof n.MouseEvent ? e || (t.detail === 0 ? "keyboard" : "mouse") : "";
}
const j1 = 20;
let zo = [];
function id() {
  zo = zo.filter((t) => t.deref()?.isConnected);
}
function Y8(t) {
  id(), t && cn(t) !== "body" && (zo.push(new WeakRef(t)), zo.length > j1 && (zo = zo.slice(-j1)));
}
function Xa() {
  return id(), zo[zo.length - 1]?.deref();
}
function j8(t) {
  return t ? qu(t) ? t : is(t)[0] || t : null;
}
function K1(t, e) {
  if (t.hasAttribute("tabindex") && !t.hasAttribute("data-tabindex") || !e.current.includes("floating") && !t.getAttribute("role")?.includes("dialog"))
    return;
  const o = mh(t).filter((i) => {
    const s = i.getAttribute("data-tabindex") || "";
    return qu(i) || i.hasAttribute("data-tabindex") && !s.startsWith("-");
  }), r = t.getAttribute("tabindex");
  e.current.includes("floating") || o.length === 0 ? r !== "0" && t.setAttribute("tabindex", "0") : (r !== "-1" || t.hasAttribute("data-tabindex") && t.getAttribute("data-tabindex") !== "-1") && (t.setAttribute("tabindex", "-1"), t.setAttribute("data-tabindex", "-1"));
}
function ni(t) {
  const {
    context: e,
    children: n,
    disabled: o = !1,
    initialFocus: r = !0,
    returnFocus: i = !0,
    restoreFocus: s = !1,
    modal: l = !0,
    closeOnFocusOut: a = !0,
    openInteractionType: c = "",
    nextFocusableElement: u,
    previousFocusableElement: d,
    beforeContentFocusGuardRef: f,
    externalTree: p,
    getInsideElements: m
  } = t, h = "rootStore" in e ? e.rootStore : e, b = h.useState("open"), v = h.useState("domReferenceElement"), C = h.useState("floatingElement"), {
    events: y,
    dataRef: w
  } = h.context, R = Ce(() => w.current.floatingContext?.nodeId), S = r === !1, E = Qc(v) && S, N = x.useRef(["content"]), I = Ft(r), T = Ft(i), k = Ft(c), P = tr(p), M = Ch(), D = x.useRef(!1), O = x.useRef(!1), _ = x.useRef(!1), V = x.useRef(null), A = x.useRef(""), L = x.useRef(""), $ = x.useRef(null), Y = x.useRef(null), G = fn($, f, M?.beforeInsideRef), j = fn(Y, M?.afterInsideRef), Z = Dt(), U = Dt(), q = Jr(), te = M != null, H = Wi(C), X = Ce((Q = H) => Q ? is(Q) : []), ee = Ce(() => m?.().filter((Q) => Q != null) ?? []);
  x.useEffect(() => {
    if (o || !l)
      return;
    function Q(fe) {
      fe.key === "Tab" && Fe(H, Ut(Je(H))) && X().length === 0 && !E && Lt(fe);
    }
    const re = Je(H);
    return at(re, "keydown", Q);
  }, [o, v, H, l, N, E, X]), x.useEffect(() => {
    if (o || !b)
      return;
    const Q = Je(H);
    function re() {
      _.current = !1;
    }
    function fe(se) {
      const pe = bt(se), xe = ee(), ce = Fe(C, pe) || Fe(v, pe) || Fe(M?.portalNode, pe) || xe.some((he) => he === pe || Fe(he, pe));
      _.current = !ce, L.current = se.pointerType || "keyboard", pe?.closest(`[${Xu}]`) && (O.current = !0);
    }
    function ne() {
      L.current = "keyboard";
    }
    return Yn(at(Q, "pointerdown", fe, !0), at(Q, "pointerup", re, !0), at(Q, "pointercancel", re, !0), at(Q, "keydown", ne, !0));
  }, [o, C, v, H, b, M, ee]), x.useEffect(() => {
    if (o || !a)
      return;
    const Q = Je(H);
    function re() {
      O.current = !0, U.start(0, () => {
        O.current = !1;
      });
    }
    function fe(xe) {
      const ce = bt(xe);
      qu(ce) && (V.current = ce);
    }
    function ne(xe) {
      const ce = xe.relatedTarget, he = xe.currentTarget, z = bt(xe);
      queueMicrotask(() => {
        const J = R(), B = h.context.triggerElements, K = ee(), ie = ce?.hasAttribute(Yi("focus-guard")) && [$.current, Y.current, M?.beforeInsideRef.current, M?.afterInsideRef.current, M?.beforeOutsideRef.current, M?.afterOutsideRef.current, yo(d), yo(u)].includes(ce), ge = !(Fe(v, ce) || Fe(C, ce) || Fe(ce, C) || Fe(M?.portalNode, ce) || K.some((ue) => ue === ce || Fe(ue, ce)) || ce != null && B.hasElement(ce) || B.hasMatchingElement((ue) => Fe(ue, ce)) || ie || P && (co(P.nodesRef.current, J).find((ue) => Fe(ue.context?.elements.floating, ce) || Fe(ue.context?.elements.domReference, ce)) || B1(P.nodesRef.current, J).find((ue) => [ue.context?.elements.floating, Wi(ue.context?.elements.floating)].includes(ce) || ue.context?.elements.domReference === ce)));
        if (he === v && H && K1(H, N), s && he !== v && !sa(z) && Ut(Q) === Q.body) {
          if (xt(H) && (H.focus(), s === "popup")) {
            q.request(() => {
              H.focus();
            });
            return;
          }
          const ue = X(), Se = V.current, ve = (Se && ue.includes(Se) ? Se : null) || ue[ue.length - 1] || H;
          xt(ve) && ve.focus();
        }
        if (w.current.insideReactTree) {
          w.current.insideReactTree = !1;
          return;
        }
        (E || !l) && ce && ge && !O.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (E || ce !== Xa()) && (D.current = !0, h.setOpen(!1, De(Io, xe)));
      });
    }
    function se() {
      _.current || (w.current.insideReactTree = !0, Z.start(0, () => {
        w.current.insideReactTree = !1;
      }));
    }
    const pe = xt(v) ? v : null;
    if (!(!C && !pe))
      return Yn(pe && at(pe, "focusout", ne), pe && at(pe, "pointerdown", re), C && at(C, "focusin", fe), C && at(C, "focusout", ne), C && M && at(C, "focusout", se, !0));
  }, [o, v, C, H, l, P, M, h, a, s, X, E, R, N, w, Z, U, q, u, d, ee]), x.useEffect(() => {
    if (o || !C || !b)
      return;
    const Q = Array.from(M?.portalNode?.querySelectorAll(`[${Yi("portal")}]`) || []), fe = (P ? B1(P.nodesRef.current, R()) : []).find((he) => Qc(he.context?.elements.domReference || null))?.context?.elements.domReference, se = [...[C, ...Q, $.current, Y.current, M?.beforeOutsideRef.current, M?.afterOutsideRef.current, ...ee()], fe, yo(d), yo(u), E ? v : null].filter((he) => he != null), pe = Y1(se, {
      ariaHidden: l || E,
      mark: !1
    }), xe = [C, ...Q].filter((he) => he != null), ce = Y1(xe);
    return () => {
      ce(), pe();
    };
  }, [b, o, v, C, l, N, M, E, P, R, u, d, ee]), Ne(() => {
    if (!b || o || !xt(H))
      return;
    const Q = Je(H), re = Ut(Q);
    queueMicrotask(() => {
      const fe = I.current, ne = typeof fe == "function" ? fe(k.current || "") : fe;
      if (ne === void 0 || ne === !1 || Fe(H, re))
        return;
      let pe = null;
      const xe = () => (pe == null && (pe = X(H)), pe[0] || H);
      let ce;
      ne === !0 || ne === null ? ce = xe() : ce = yo(ne), ce = ce || xe(), yl(ce, {
        preventScroll: ce === H
      });
    });
  }, [o, b, H, S, X, I, k]), Ne(() => {
    if (o || !H)
      return;
    const Q = Je(H), re = Ut(Q);
    Y8(re);
    function fe(se) {
      if (se.open || (A.current = G8(se.nativeEvent, L.current)), se.reason === At && se.nativeEvent.type === "mouseleave" && (D.current = !0), se.reason === ns)
        if (se.nested)
          D.current = !1;
        else if (Kg(se.nativeEvent) || qg(se.nativeEvent))
          D.current = !1;
        else {
          let pe = !1;
          Je(H).createElement("div").focus({
            get preventScroll() {
              return pe = !0, !1;
            }
          }), pe ? D.current = !1 : D.current = !0;
        }
    }
    y.on("openchange", fe);
    function ne() {
      const se = T.current;
      let pe = typeof se == "function" ? se(A.current) : se;
      if (pe === void 0 || pe === !1)
        return null;
      if (pe === null && (pe = !0), typeof pe == "boolean") {
        const ce = v || Xa();
        return ce && ce.isConnected ? ce : null;
      }
      const xe = v || Xa();
      return yo(pe) || xe || null;
    }
    return () => {
      y.off("openchange", fe);
      const se = Ut(Q), pe = ee(), xe = Fe(C, se) || pe.some((z) => z === se || Fe(z, se)) || P && co(P.nodesRef.current, R(), !1).some((z) => Fe(z.context?.elements.floating, se)), ce = T.current, he = ne();
      queueMicrotask(() => {
        const z = j8(he), J = typeof ce != "boolean";
        ce && !D.current && xt(z) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!J && z !== se && se !== Q.body) || xe) && z.focus({
          preventScroll: !0
        }), D.current = !1;
      });
    };
  }, [o, C, H, T, w, y, P, v, R, ee]), Ne(() => {
    if (!Fu || b || !C)
      return;
    const Q = Ut(Je(C));
    !xt(Q) || !ia(Q) || Fe(C, Q) && Q.blur();
  }, [b, C]), Ne(() => {
    if (!(o || !M))
      return M.setFocusManagerState({
        modal: l,
        closeOnFocusOut: a,
        open: b,
        onOpenChange: h.setOpen,
        domReference: v
      }), () => {
        M.setFocusManagerState(null);
      };
  }, [o, M, l, b, h, a, v]), Ne(() => {
    if (!(o || !H))
      return K1(H, N), () => {
        queueMicrotask(id);
      };
  }, [o, H, N]);
  const le = !o && (l ? !E : !0) && (te || l);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [le && /* @__PURE__ */ g(Vn, {
      "data-type": "inside",
      ref: G,
      onFocus: (Q) => {
        if (l) {
          const re = X();
          yl(re[re.length - 1]);
        } else M?.portalNode && (D.current = !1, $r(Q, M.portalNode) ? Zu(v)?.focus() : yo(d ?? M.beforeOutsideRef)?.focus());
      }
    }), n, le && /* @__PURE__ */ g(Vn, {
      "data-type": "inside",
      ref: j,
      onFocus: (Q) => {
        l ? yl(X()[0]) : M?.portalNode && (a && (D.current = !0), $r(Q, M.portalNode) ? hh(v)?.focus() : yo(u ?? M.afterOutsideRef)?.focus());
      }
    })]
  });
}
function xr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, {
    enabled: r = !0,
    event: i = "click",
    toggle: s = !0,
    ignoreMouse: l = !1,
    stickIfOpen: a = !0,
    touchOpenDelay: c = 0,
    reason: u = qn
  } = e, d = x.useRef(void 0), f = Jr(), p = Dt(), m = x.useMemo(() => ({
    onPointerDown(h) {
      d.current = h.pointerType;
    },
    onMouseDown(h) {
      const b = d.current, v = h.nativeEvent, C = n.select("open");
      if (h.button !== 0 || i === "click" || Yr(b, !0) && l)
        return;
      const y = o.current.openEvent, w = y?.type, R = n.select("domReferenceElement") !== h.currentTarget, S = C && R || !(C && s && (!(y && a) || w === "click" || w === "mousedown")), E = bt(v);
      if (ia(E)) {
        const I = De(u, v, E);
        S && b === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, I);
        }) : n.setOpen(S, I);
        return;
      }
      const N = h.currentTarget;
      f.request(() => {
        const I = De(u, v, N);
        S && b === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, I);
        }) : n.setOpen(S, I);
      });
    },
    onClick(h) {
      if (i === "mousedown-only")
        return;
      const b = d.current;
      if (i === "mousedown" && b) {
        d.current = void 0;
        return;
      }
      if (Yr(b, !0) && l)
        return;
      const v = n.select("open"), C = o.current.openEvent, y = n.select("domReferenceElement") !== h.currentTarget, w = v && y || !(v && s && (!(C && a) || Zg(C))), R = De(u, h.nativeEvent, h.currentTarget);
      w && b === "touch" && c > 0 ? p.start(c, () => {
        n.setOpen(!0, R);
      }) : n.setOpen(w, R);
    },
    onKeyDown() {
      d.current = void 0;
    }
  }), [o, i, l, n, a, s, f, p, c, u]);
  return x.useMemo(() => r ? {
    reference: m
  } : St, [r, m]);
}
function K8(t, e) {
  let n = null, o = null, r = !1;
  return {
    contextElement: t || void 0,
    getBoundingClientRect() {
      const i = t?.getBoundingClientRect() || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, s = e.axis === "x" || e.axis === "both", l = e.axis === "y" || e.axis === "both", a = ["mouseenter", "mousemove"].includes(e.dataRef.current.openEvent?.type || "") && e.pointerType !== "touch";
      let c = i.width, u = i.height, d = i.x, f = i.y;
      return n == null && e.x && s && (n = i.x - e.x), o == null && e.y && l && (o = i.y - e.y), d -= n || 0, f -= o || 0, c = 0, u = 0, !r || a ? (c = e.axis === "y" ? i.width : 0, u = e.axis === "x" ? i.height : 0, d = s && e.x != null ? e.x : d, f = l && e.y != null ? e.y : f) : r && !a && (u = e.axis === "x" ? i.height : u, c = e.axis === "y" ? i.width : c), r = !0, {
        width: c,
        height: u,
        x: d,
        y: f,
        top: f,
        right: d + c,
        bottom: f + u,
        left: d
      };
    }
  };
}
function q1(t) {
  return t != null && t.clientX != null;
}
function q8(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    enabled: l = !0,
    axis: a = "both"
  } = e, c = x.useRef(!1), u = x.useRef(null), [d, f] = x.useState(), [p, m] = x.useState([]), h = Ce((w, R, S) => {
    c.current || s.current.openEvent && !q1(s.current.openEvent) || n.set("positionReference", K8(S ?? i, {
      x: w,
      y: R,
      axis: a,
      dataRef: s,
      pointerType: d
    }));
  }), b = Ce((w) => {
    o ? u.current || m([]) : h(w.clientX, w.clientY, w.currentTarget);
  }), v = Yr(d) ? r : o, C = x.useCallback(() => {
    if (!v || !l)
      return;
    const w = Ct(r);
    function R(S) {
      const E = bt(S);
      Fe(r, E) ? (u.current?.(), u.current = null) : h(S.clientX, S.clientY);
    }
    if (!s.current.openEvent || q1(s.current.openEvent)) {
      const S = () => {
        u.current?.(), u.current = null;
      };
      return u.current = at(w, "mousemove", R), S;
    }
    n.set("positionReference", i);
  }, [v, l, r, s, i, n, h]);
  x.useEffect(() => C(), [C, p]), x.useEffect(() => {
    l && !r && (c.current = !1);
  }, [l, r]), x.useEffect(() => {
    !l && o && (c.current = !0);
  }, [l, o]);
  const y = x.useMemo(() => {
    function w(R) {
      f(R.pointerType);
    }
    return {
      onPointerDown: w,
      onPointerEnter: w,
      onMouseMove: b,
      onMouseEnter: b
    };
  }, [b]);
  return x.useMemo(() => l ? {
    reference: y,
    trigger: y
  } : {}, [l, y]);
}
const Z8 = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function X8() {
  return !1;
}
function Q8(t) {
  return {
    escapeKey: typeof t == "boolean" ? t : t?.escapeKey ?? !1,
    outsidePress: typeof t == "boolean" ? t : t?.outsidePress ?? !0
  };
}
function Cr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), {
    dataRef: i
  } = n.context, {
    enabled: s = !0,
    escapeKey: l = !0,
    outsidePress: a = !0,
    outsidePressEvent: c = "sloppy",
    referencePress: u = X8,
    referencePressEvent: d = "sloppy",
    bubbles: f,
    externalTree: p
  } = e, m = tr(p), h = Ce(typeof a == "function" ? a : () => !1), b = typeof a == "function" ? h : a, v = b !== !1, C = Ce(() => c), y = x.useRef(!1), w = x.useRef(!1), R = x.useRef(!1), {
    escapeKey: S,
    outsidePress: E
  } = Q8(f), N = x.useRef(null), I = Dt(), T = Dt(), k = Ce(() => {
    T.clear(), i.current.insideReactTree = !1;
  }), P = x.useRef(!1), M = x.useRef(""), D = Ce(u), O = Ce((Y) => {
    if (!o || !s || !l || Y.key !== "Escape" || P.current)
      return;
    const G = i.current.floatingContext?.nodeId, j = m ? co(m.nodesRef.current, G) : [];
    if (!S && j.length > 0) {
      let q = !0;
      if (j.forEach((te) => {
        te.context?.open && !te.context.dataRef.current.__escapeKeyBubbles && (q = !1);
      }), !q)
        return;
    }
    const Z = f8(Y) ? Y.nativeEvent : Y, U = De(vr, Z);
    n.setOpen(!1, U), !S && !U.isPropagationAllowed && Y.stopPropagation();
  }), _ = Ce(() => {
    i.current.insideReactTree = !0, T.start(0, k);
  });
  x.useEffect(() => {
    if (!o || !s)
      return;
    i.current.__escapeKeyBubbles = S, i.current.__outsidePressBubbles = E;
    const Y = new xn(), G = new xn();
    function j() {
      Y.clear(), P.current = !0;
    }
    function Z() {
      Y.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        ta() ? 5 : 0,
        () => {
          P.current = !1;
        }
      );
    }
    function U() {
      R.current = !0, G.start(0, () => {
        R.current = !1;
      });
    }
    function q() {
      y.current = !1, w.current = !1;
    }
    function te() {
      const B = M.current, K = B === "pen" || !B ? "mouse" : B, ie = C(), ge = typeof ie == "function" ? ie() : ie;
      return typeof ge == "string" ? ge : ge[K];
    }
    function H(B) {
      const K = te();
      return K === "intentional" && B.type !== "click" || K === "sloppy" && B.type === "click";
    }
    function X(B) {
      const K = i.current.floatingContext?.nodeId, ie = m && co(m.nodesRef.current, K).some((ge) => zn(B, ge.context?.elements.floating));
      return zn(B, n.select("floatingElement")) || zn(B, n.select("domReferenceElement")) || ie;
    }
    function ee(B) {
      if (H(B)) {
        k();
        return;
      }
      if (i.current.insideReactTree) {
        k();
        return;
      }
      const K = bt(B), ie = `[${Yi("inert")}]`, ge = pt(K) ? K.getRootNode() : null, ue = Array.from((Gr(ge) ? ge : Je(n.select("floatingElement"))).querySelectorAll(ie)), Se = n.context.triggerElements;
      if (K && (Se.hasElement(K) || Se.hasMatchingElement((Re) => Fe(Re, K))))
        return;
      let ve = pt(K) ? K : null;
      for (; ve && !lo(ve); ) {
        const Re = po(ve);
        if (lo(Re) || !pt(Re))
          break;
        ve = Re;
      }
      if (ue.length && pt(K) && !b8(K) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
      !Fe(K, n.select("floatingElement")) && // If the target root element contains none of the markers, then the
      // element was injected after the floating element rendered.
      ue.every((Re) => !Fe(ve, Re)))
        return;
      if (xt(K) && !("touches" in B)) {
        const Re = lo(K), Ie = pn(K), Pe = /auto|scroll/, _e = Re || Pe.test(Ie.overflowX), Ye = Re || Pe.test(Ie.overflowY), qe = _e && K.clientWidth > 0 && K.scrollWidth > K.clientWidth, $e = Ye && K.clientHeight > 0 && K.scrollHeight > K.clientHeight, Ee = Ie.direction === "rtl", Ve = $e && (Ee ? B.offsetX <= K.offsetWidth - K.clientWidth : B.offsetX > K.clientWidth), Me = qe && B.offsetY > K.clientHeight;
        if (Ve || Me)
          return;
      }
      if (X(B))
        return;
      if (te() === "intentional" && R.current) {
        G.clear(), R.current = !1;
        return;
      }
      if (typeof b == "function" && !b(B))
        return;
      const de = i.current.floatingContext?.nodeId, me = m ? co(m.nodesRef.current, de) : [];
      if (me.length > 0) {
        let Re = !0;
        if (me.forEach((Ie) => {
          Ie.context?.open && !Ie.context.dataRef.current.__outsidePressBubbles && (Re = !1);
        }), !Re)
          return;
      }
      n.setOpen(!1, De(ns, B)), k();
    }
    function le(B) {
      te() !== "sloppy" || B.pointerType === "touch" || !n.select("open") || !s || zn(B, n.select("floatingElement")) || zn(B, n.select("domReferenceElement")) || ee(B);
    }
    function Q(B) {
      if (te() !== "sloppy" || !n.select("open") || !s || zn(B, n.select("floatingElement")) || zn(B, n.select("domReferenceElement")))
        return;
      const K = B.touches[0];
      K && (N.current = {
        startTime: Date.now(),
        startX: K.clientX,
        startY: K.clientY,
        dismissOnTouchEnd: !1,
        dismissOnMouseDown: !0
      }, I.start(1e3, () => {
        N.current && (N.current.dismissOnTouchEnd = !1, N.current.dismissOnMouseDown = !1);
      }));
    }
    function re(B, K) {
      const ie = bt(B);
      if (!ie)
        return;
      const ge = at(ie, B.type, () => {
        K(B), ge();
      });
    }
    function fe(B) {
      M.current = "touch", re(B, Q);
    }
    function ne(B) {
      I.clear(), B.type === "pointerdown" && (M.current = B.pointerType), !(B.type === "mousedown" && N.current && !N.current.dismissOnMouseDown) && re(B, (K) => {
        K.type === "pointerdown" ? le(K) : ee(K);
      });
    }
    function se(B) {
      if (!y.current)
        return;
      const K = w.current;
      if (q(), te() === "intentional") {
        if (B.type === "pointercancel") {
          K && U();
          return;
        }
        if (!X(B)) {
          if (K) {
            U();
            return;
          }
          typeof b == "function" && !b(B) || (G.clear(), R.current = !0, k());
        }
      }
    }
    function pe(B) {
      if (te() !== "sloppy" || !N.current || zn(B, n.select("floatingElement")) || zn(B, n.select("domReferenceElement")))
        return;
      const K = B.touches[0];
      if (!K)
        return;
      const ie = Math.abs(K.clientX - N.current.startX), ge = Math.abs(K.clientY - N.current.startY), ue = Math.sqrt(ie * ie + ge * ge);
      ue > 5 && (N.current.dismissOnTouchEnd = !0), ue > 10 && (ee(B), I.clear(), N.current = null);
    }
    function xe(B) {
      re(B, pe);
    }
    function ce(B) {
      te() !== "sloppy" || !N.current || zn(B, n.select("floatingElement")) || zn(B, n.select("domReferenceElement")) || (N.current.dismissOnTouchEnd && ee(B), I.clear(), N.current = null);
    }
    function he(B) {
      re(B, ce);
    }
    const z = Je(r), J = Yn(l && Yn(at(z, "keydown", O), at(z, "compositionstart", j), at(z, "compositionend", Z)), v && Yn(at(z, "click", ne, !0), at(z, "pointerdown", ne, !0), at(z, "pointerup", se, !0), at(z, "pointercancel", se, !0), at(z, "mousedown", ne, !0), at(z, "mouseup", se, !0), at(z, "touchstart", fe, !0), at(z, "touchmove", xe, !0), at(z, "touchend", he, !0)));
    return () => {
      J(), Y.clear(), G.clear(), q(), R.current = !1;
    };
  }, [i, r, l, v, b, o, s, S, E, O, k, C, m, n, I]), x.useEffect(k, [b, k]);
  const V = x.useMemo(() => ({
    onKeyDown: O,
    [Z8[d]]: (Y) => {
      D() && n.setOpen(!1, De(qn, Y.nativeEvent));
    },
    ...d !== "intentional" && {
      onClick(Y) {
        D() && n.setOpen(!1, De(qn, Y.nativeEvent));
      }
    }
  }), [O, n, d, D]), A = Ce((Y) => {
    if (!o || !s || Y.button !== 0)
      return;
    const G = bt(Y.nativeEvent);
    Fe(n.select("floatingElement"), G) && (y.current || (y.current = !0, w.current = !1));
  }), L = Ce((Y) => {
    !o || !s || (Y.defaultPrevented || Y.nativeEvent.defaultPrevented) && y.current && (w.current = !0);
  }), $ = x.useMemo(() => ({
    onKeyDown: O,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: L,
    onMouseDown: L,
    onClickCapture: _,
    onMouseDownCapture(Y) {
      _(), A(Y);
    },
    onPointerDownCapture(Y) {
      _(), A(Y);
    },
    onMouseUpCapture: _,
    onTouchEndCapture: _,
    onTouchMoveCapture: _
  }), [O, _, A, L]);
  return x.useMemo(() => s ? {
    reference: V,
    floating: $,
    trigger: V
  } : {}, [s, V, $]);
}
function Z1(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const i = _n(e), s = Ku(e), l = ju(s), a = yn(e), c = i === "y", u = o.x + o.width / 2 - r.width / 2, d = o.y + o.height / 2 - r.height / 2, f = o[l] / 2 - r[l] / 2;
  let p;
  switch (a) {
    case "top":
      p = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      p = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: o.x - r.width,
        y: d
      };
      break;
    default:
      p = {
        x: o.x,
        y: o.y
      };
  }
  switch (er(e)) {
    case "start":
      p[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      p[s] += f * (n && c ? -1 : 1);
      break;
  }
  return p;
}
async function J8(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: s,
    elements: l,
    strategy: a
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = To(e, t), m = oh(p), b = l[f ? d === "floating" ? "reference" : "floating" : d], v = Ui(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: a
  })), C = d === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, y = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), w = await (i.isElement == null ? void 0 : i.isElement(y)) ? await (i.getScale == null ? void 0 : i.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = Ui(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: C,
    offsetParent: y,
    strategy: a
  }) : C);
  return {
    top: (v.top - R.top + m.top) / w.y,
    bottom: (R.bottom - v.bottom + m.bottom) / w.y,
    left: (v.left - R.left + m.left) / w.x,
    right: (R.right - v.right + m.right) / w.x
  };
}
const e9 = 50, t9 = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s
  } = n, l = s.detectOverflow ? s : {
    ...s,
    detectOverflow: J8
  }, a = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: u,
    y: d
  } = Z1(c, o, a), f = o, p = 0;
  const m = {};
  for (let h = 0; h < i.length; h++) {
    const b = i[h];
    if (!b)
      continue;
    const {
      name: v,
      fn: C
    } = b, {
      x: y,
      y: w,
      data: R,
      reset: S
    } = await C({
      x: u,
      y: d,
      initialPlacement: o,
      placement: f,
      strategy: r,
      middlewareData: m,
      rects: c,
      platform: l,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = y ?? u, d = w ?? d, m[v] = {
      ...m[v],
      ...R
    }, S && p < e9 && (p++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : S.rects), {
      x: u,
      y: d
    } = Z1(c, f, a)), h = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: r,
    middlewareData: m
  };
}, n9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: i,
        rects: s,
        initialPlacement: l,
        platform: a,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...b
      } = To(t, e);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const v = yn(r), C = _n(l), y = yn(l) === l, w = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), R = f || (y || !h ? [Al(l)] : C8(l)), S = m !== "none";
      !f && S && R.push(...E8(l, h, m, w));
      const E = [l, ...R], N = await a.detectOverflow(e, b), I = [];
      let T = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (u && I.push(N[v]), d) {
        const D = x8(r, s, w);
        I.push(N[D[0]], N[D[1]]);
      }
      if (T = [...T, {
        placement: r,
        overflows: I
      }], !I.every((D) => D <= 0)) {
        var k, P;
        const D = (((k = i.flip) == null ? void 0 : k.index) || 0) + 1, O = E[D];
        if (O && (!(d === "alignment" ? C !== _n(O) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        T.every((A) => _n(A.placement) === C ? A.overflows[0] > 0 : !0)))
          return {
            data: {
              index: D,
              overflows: T
            },
            reset: {
              placement: O
            }
          };
        let _ = (P = T.filter((V) => V.overflows[0] <= 0).sort((V, A) => V.overflows[1] - A.overflows[1])[0]) == null ? void 0 : P.placement;
        if (!_)
          switch (p) {
            case "bestFit": {
              var M;
              const V = (M = T.filter((A) => {
                if (S) {
                  const L = _n(A.placement);
                  return L === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  L === "y";
                }
                return !0;
              }).map((A) => [A.placement, A.overflows.filter((L) => L > 0).reduce((L, $) => L + $, 0)]).sort((A, L) => A[1] - L[1])[0]) == null ? void 0 : M[0];
              V && (_ = V);
              break;
            }
            case "initialPlacement":
              _ = l;
              break;
          }
        if (r !== _)
          return {
            reset: {
              placement: _
            }
          };
      }
      return {};
    }
  };
};
function X1(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function Q1(t) {
  return v8.some((e) => t[e] >= 0);
}
const o9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n,
        platform: o
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = To(t, e);
      switch (r) {
        case "referenceHidden": {
          const s = await o.detectOverflow(e, {
            ...i,
            elementContext: "reference"
          }), l = X1(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: l,
              referenceHidden: Q1(l)
            }
          };
        }
        case "escaped": {
          const s = await o.detectOverflow(e, {
            ...i,
            altBoundary: !0
          }), l = X1(s, n.floating);
          return {
            data: {
              escapedOffsets: l,
              escaped: Q1(l)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Rh = /* @__PURE__ */ new Set(["left", "top"]);
async function r9(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = yn(n), l = er(n), a = _n(n) === "y", c = Rh.has(s) ? -1 : 1, u = i && a ? -1 : 1, d = To(e, t);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return l && typeof m == "number" && (p = l === "end" ? m * -1 : m), a ? {
    x: p * u,
    y: f * c
  } : {
    x: f * c,
    y: p * u
  };
}
const i9 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        middlewareData: l
      } = e, a = await r9(e, t);
      return s === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: r + a.x,
        y: i + a.y,
        data: {
          ...a,
          placement: s
        }
      };
    }
  };
}, s9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: i
      } = e, {
        mainAxis: s = !0,
        crossAxis: l = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: C,
              y
            } = v;
            return {
              x: C,
              y
            };
          }
        },
        ...c
      } = To(t, e), u = {
        x: n,
        y: o
      }, d = await i.detectOverflow(e, c), f = _n(yn(r)), p = Yu(f);
      let m = u[p], h = u[f];
      if (s) {
        const v = p === "y" ? "top" : "left", C = p === "y" ? "bottom" : "right", y = m + d[v], w = m - d[C];
        m = Jc(y, m, w);
      }
      if (l) {
        const v = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", y = h + d[v], w = h - d[C];
        h = Jc(y, h, w);
      }
      const b = a.fn({
        ...e,
        [p]: m,
        [f]: h
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - o,
          enabled: {
            [p]: s,
            [f]: l
          }
        }
      };
    }
  };
}, l9 = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: i,
        middlewareData: s
      } = e, {
        offset: l = 0,
        mainAxis: a = !0,
        crossAxis: c = !0
      } = To(t, e), u = {
        x: n,
        y: o
      }, d = _n(r), f = Yu(d);
      let p = u[f], m = u[d];
      const h = To(l, e), b = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (a) {
        const y = f === "y" ? "height" : "width", w = i.reference[f] - i.floating[y] + b.mainAxis, R = i.reference[f] + i.reference[y] - b.mainAxis;
        p < w ? p = w : p > R && (p = R);
      }
      if (c) {
        var v, C;
        const y = f === "y" ? "width" : "height", w = Rh.has(yn(r)), R = i.reference[d] - i.floating[y] + (w && ((v = s.offset) == null ? void 0 : v[d]) || 0) + (w ? 0 : b.crossAxis), S = i.reference[d] + i.reference[y] + (w ? 0 : ((C = s.offset) == null ? void 0 : C[d]) || 0) - (w ? b.crossAxis : 0);
        m < R ? m = R : m > S && (m = S);
      }
      return {
        [f]: p,
        [d]: m
      };
    }
  };
}, a9 = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        rects: i,
        platform: s,
        elements: l
      } = e, {
        apply: a = () => {
        },
        ...c
      } = To(t, e), u = await s.detectOverflow(e, c), d = yn(r), f = er(r), p = _n(r) === "y", {
        width: m,
        height: h
      } = i.floating;
      let b, v;
      d === "top" || d === "bottom" ? (b = d, v = f === (await (s.isRTL == null ? void 0 : s.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (v = d, b = f === "end" ? "top" : "bottom");
      const C = h - u.top - u.bottom, y = m - u.left - u.right, w = jr(h - u[b], C), R = jr(m - u[v], y), S = !e.middlewareData.shift;
      let E = w, N = R;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (N = y), (o = e.middlewareData.shift) != null && o.enabled.y && (E = C), S && !f) {
        const T = Sn(u.left, 0), k = Sn(u.right, 0), P = Sn(u.top, 0), M = Sn(u.bottom, 0);
        p ? N = m - 2 * (T !== 0 || k !== 0 ? T + k : Sn(u.left, u.right)) : E = h - 2 * (P !== 0 || M !== 0 ? P + M : Sn(u.top, u.bottom));
      }
      await a({
        ...e,
        availableWidth: N,
        availableHeight: E
      });
      const I = await s.getDimensions(l.floating);
      return m !== I.width || h !== I.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Eh(t) {
  const e = pn(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = xt(t), i = r ? t.offsetWidth : n, s = r ? t.offsetHeight : o, l = Vl(n) !== i || Vl(o) !== s;
  return l && (n = i, o = s), {
    width: n,
    height: o,
    $: l
  };
}
function sd(t) {
  return pt(t) ? t : t.contextElement;
}
function Hr(t) {
  const e = sd(t);
  if (!xt(e))
    return ao(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = Eh(e);
  let s = (i ? Vl(n.width) : n.width) / o, l = (i ? Vl(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const c9 = /* @__PURE__ */ ao(0);
function Nh(t) {
  const e = Ct(t);
  return !ta() || !e.visualViewport ? c9 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function u9(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== Ct(t) ? !1 : e;
}
function gr(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = sd(t);
  let s = ao(1);
  e && (o ? pt(o) && (s = Hr(o)) : s = Hr(t));
  const l = u9(i, n, o) ? Nh(i) : ao(0);
  let a = (r.left + l.x) / s.x, c = (r.top + l.y) / s.y, u = r.width / s.x, d = r.height / s.y;
  if (i) {
    const f = Ct(i), p = o && pt(o) ? Ct(o) : o;
    let m = f, h = Yc(m);
    for (; h && o && p !== m; ) {
      const b = Hr(h), v = h.getBoundingClientRect(), C = pn(h), y = v.left + (h.clientLeft + parseFloat(C.paddingLeft)) * b.x, w = v.top + (h.clientTop + parseFloat(C.paddingTop)) * b.y;
      a *= b.x, c *= b.y, u *= b.x, d *= b.y, a += y, c += w, m = Ct(h), h = Yc(m);
    }
  }
  return Ui({
    width: u,
    height: d,
    x: a,
    y: c
  });
}
function ca(t, e) {
  const n = na(t).scrollLeft;
  return e ? e.left + n : gr(ho(t)).left + n;
}
function kh(t, e) {
  const n = t.getBoundingClientRect(), o = n.left + e.scrollLeft - ca(t, n), r = n.top + e.scrollTop;
  return {
    x: o,
    y: r
  };
}
function d9(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const i = r === "fixed", s = ho(o), l = e ? ea(e.floating) : !1;
  if (o === s || l && i)
    return n;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = ao(1);
  const u = ao(0), d = xt(o);
  if ((d || !d && !i) && ((cn(o) !== "body" || Qo(s)) && (a = na(o)), d)) {
    const p = gr(o);
    c = Hr(o), u.x = p.x + o.clientLeft, u.y = p.y + o.clientTop;
  }
  const f = s && !d && !i ? kh(s, a) : ao(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - a.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - a.scrollTop * c.y + u.y + f.y
  };
}
function f9(t) {
  return Array.from(t.getClientRects());
}
function p9(t) {
  const e = ho(t), n = na(t), o = t.ownerDocument.body, r = Sn(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), i = Sn(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + ca(t);
  const l = -n.scrollTop;
  return pn(o).direction === "rtl" && (s += Sn(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: s,
    y: l
  };
}
const J1 = 25;
function m9(t, e) {
  const n = Ct(t), o = ho(t), r = n.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, l = 0, a = 0;
  if (r) {
    i = r.width, s = r.height;
    const u = ta();
    (!u || u && e === "fixed") && (l = r.offsetLeft, a = r.offsetTop);
  }
  const c = ca(o);
  if (c <= 0) {
    const u = o.ownerDocument, d = u.body, f = getComputedStyle(d), p = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, m = Math.abs(o.clientWidth - d.clientWidth - p);
    m <= J1 && (i -= m);
  } else c <= J1 && (i += c);
  return {
    width: i,
    height: s,
    x: l,
    y: a
  };
}
function g9(t, e) {
  const n = gr(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, i = xt(t) ? Hr(t) : ao(1), s = t.clientWidth * i.x, l = t.clientHeight * i.y, a = r * i.x, c = o * i.y;
  return {
    width: s,
    height: l,
    x: a,
    y: c
  };
}
function ep(t, e, n) {
  let o;
  if (e === "viewport")
    o = m9(t, n);
  else if (e === "document")
    o = p9(ho(t));
  else if (pt(e))
    o = g9(e, n);
  else {
    const r = Nh(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return Ui(o);
}
function Mh(t, e) {
  const n = po(t);
  return n === e || !pt(n) || lo(n) ? !1 : pn(n).position === "fixed" || Mh(n, e);
}
function h9(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = Hi(t, [], !1).filter((l) => pt(l) && cn(l) !== "body"), r = null;
  const i = pn(t).position === "fixed";
  let s = i ? po(t) : t;
  for (; pt(s) && !lo(s); ) {
    const l = pn(s), a = Pu(s);
    !a && l.position === "fixed" && (r = null), (i ? !a && !r : !a && l.position === "static" && !!r && (r.position === "absolute" || r.position === "fixed") || Qo(s) && !a && Mh(t, s)) ? o = o.filter((u) => u !== s) : r = l, s = po(s);
  }
  return e.set(t, o), o;
}
function b9(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const s = [...n === "clippingAncestors" ? ea(e) ? [] : h9(e, this._c) : [].concat(n), o], l = ep(e, s[0], r);
  let a = l.top, c = l.right, u = l.bottom, d = l.left;
  for (let f = 1; f < s.length; f++) {
    const p = ep(e, s[f], r);
    a = Sn(p.top, a), c = jr(p.right, c), u = jr(p.bottom, u), d = Sn(p.left, d);
  }
  return {
    width: c - d,
    height: u - a,
    x: d,
    y: a
  };
}
function v9(t) {
  const {
    width: e,
    height: n
  } = Eh(t);
  return {
    width: e,
    height: n
  };
}
function y9(t, e, n) {
  const o = xt(e), r = ho(e), i = n === "fixed", s = gr(t, !0, i, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = ao(0);
  function c() {
    a.x = ca(r);
  }
  if (o || !o && !i)
    if ((cn(e) !== "body" || Qo(r)) && (l = na(e)), o) {
      const p = gr(e, !0, i, e);
      a.x = p.x + e.clientLeft, a.y = p.y + e.clientTop;
    } else r && c();
  i && !o && r && c();
  const u = r && !o && !i ? kh(r, l) : ao(0), d = s.left + l.scrollLeft - a.x - u.x, f = s.top + l.scrollTop - a.y - u.y;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Qa(t) {
  return pn(t).position === "static";
}
function tp(t, e) {
  if (!xt(t) || pn(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return ho(t) === n && (n = n.ownerDocument.body), n;
}
function Ph(t, e) {
  const n = Ct(t);
  if (ea(t))
    return n;
  if (!xt(t)) {
    let r = po(t);
    for (; r && !lo(r); ) {
      if (pt(r) && !Qa(r))
        return r;
      r = po(r);
    }
    return n;
  }
  let o = tp(t, e);
  for (; o && Cv(o) && Qa(o); )
    o = tp(o, e);
  return o && lo(o) && Qa(o) && !Pu(o) ? n : o || Rv(t) || n;
}
const x9 = async function(t) {
  const e = this.getOffsetParent || Ph, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: y9(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function C9(t) {
  return pn(t).direction === "rtl";
}
const Ih = {
  convertOffsetParentRelativeRectToViewportRelativeRect: d9,
  getDocumentElement: ho,
  getClippingRect: b9,
  getOffsetParent: Ph,
  getElementRects: x9,
  getClientRects: f9,
  getDimensions: v9,
  getScale: Hr,
  isElement: pt,
  isRTL: C9
};
function Th(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function w9(t, e) {
  let n = null, o;
  const r = ho(t);
  function i() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function s(l, a) {
    l === void 0 && (l = !1), a === void 0 && (a = 1), i();
    const c = t.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: p
    } = c;
    if (l || e(), !f || !p)
      return;
    const m = ar(d), h = ar(r.clientWidth - (u + f)), b = ar(r.clientHeight - (d + p)), v = ar(u), y = {
      rootMargin: -m + "px " + -h + "px " + -b + "px " + -v + "px",
      threshold: Sn(0, jr(1, a)) || 1
    };
    let w = !0;
    function R(S) {
      const E = S[0].intersectionRatio;
      if (E !== a) {
        if (!w)
          return s();
        E ? s(!1, E) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !Th(c, t.getBoundingClientRect()) && s(), w = !1;
    }
    try {
      n = new IntersectionObserver(R, {
        ...y,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(R, y);
    }
    n.observe(t);
  }
  return s(!0), i;
}
function np(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = o, c = sd(t), u = r || i ? [...c ? Hi(c) : [], ...e ? Hi(e) : []] : [];
  u.forEach((v) => {
    r && v.addEventListener("scroll", n, {
      passive: !0
    }), i && v.addEventListener("resize", n);
  });
  const d = c && l ? w9(c, n) : null;
  let f = -1, p = null;
  s && (p = new ResizeObserver((v) => {
    let [C] = v;
    C && C.target === c && p && e && (p.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var y;
      (y = p) == null || y.observe(e);
    })), n();
  }), c && !a && p.observe(c), e && p.observe(e));
  let m, h = a ? gr(t) : null;
  a && b();
  function b() {
    const v = gr(t);
    h && !Th(h, v) && n(), h = v, m = requestAnimationFrame(b);
  }
  return n(), () => {
    var v;
    u.forEach((C) => {
      r && C.removeEventListener("scroll", n), i && C.removeEventListener("resize", n);
    }), d?.(), (v = p) == null || v.disconnect(), p = null, a && cancelAnimationFrame(m);
  };
}
const S9 = i9, R9 = s9, E9 = n9, N9 = a9, k9 = o9, M9 = l9, P9 = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Ih,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return t9(t, e, {
    ...r,
    platform: i
  });
};
var I9 = typeof document < "u", T9 = function() {
}, xl = I9 ? Po : T9;
function Ll(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Ll(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && t.$$typeof) && !Ll(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Oh(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function op(t, e) {
  const n = Oh(t);
  return Math.round(e * n) / n;
}
function Ja(t) {
  const e = x.useRef(t);
  return xl(() => {
    e.current = t;
  }), e;
}
function O9(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: l = !0,
    whileElementsMounted: a,
    open: c
  } = t, [u, d] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = x.useState(o);
  Ll(f, o) || p(o);
  const [m, h] = x.useState(null), [b, v] = x.useState(null), C = x.useCallback((A) => {
    A !== S.current && (S.current = A, h(A));
  }, []), y = x.useCallback((A) => {
    A !== E.current && (E.current = A, v(A));
  }, []), w = i || m, R = s || b, S = x.useRef(null), E = x.useRef(null), N = x.useRef(u), I = a != null, T = Ja(a), k = Ja(r), P = Ja(c), M = x.useCallback(() => {
    if (!S.current || !E.current)
      return;
    const A = {
      placement: e,
      strategy: n,
      middleware: f
    };
    k.current && (A.platform = k.current), P9(S.current, E.current, A).then((L) => {
      const $ = {
        ...L,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: P.current !== !1
      };
      D.current && !Ll(N.current, $) && (N.current = $, an.flushSync(() => {
        d($);
      }));
    });
  }, [f, e, n, k, P]);
  xl(() => {
    c === !1 && N.current.isPositioned && (N.current.isPositioned = !1, d((A) => ({
      ...A,
      isPositioned: !1
    })));
  }, [c]);
  const D = x.useRef(!1);
  xl(() => (D.current = !0, () => {
    D.current = !1;
  }), []), xl(() => {
    if (w && (S.current = w), R && (E.current = R), w && R) {
      if (T.current)
        return T.current(w, R, M);
      M();
    }
  }, [w, R, M, T, I]);
  const O = x.useMemo(() => ({
    reference: S,
    floating: E,
    setReference: C,
    setFloating: y
  }), [C, y]), _ = x.useMemo(() => ({
    reference: w,
    floating: R
  }), [w, R]), V = x.useMemo(() => {
    const A = {
      position: n,
      left: 0,
      top: 0
    };
    if (!_.floating)
      return A;
    const L = op(_.floating, u.x), $ = op(_.floating, u.y);
    return l ? {
      ...A,
      transform: "translate(" + L + "px, " + $ + "px)",
      ...Oh(_.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: L,
      top: $
    };
  }, [n, l, _.floating, u.x, u.y]);
  return x.useMemo(() => ({
    ...u,
    update: M,
    refs: O,
    elements: _,
    floatingStyles: V
  }), [u, M, O, _, V]);
}
const D9 = (t, e) => {
  const n = S9(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, _9 = (t, e) => {
  const n = R9(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, V9 = (t, e) => ({
  fn: M9(t).fn,
  options: [t, e]
}), A9 = (t, e) => {
  const n = E9(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, L9 = (t, e) => {
  const n = N9(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, F9 = (t, e) => {
  const n = k9(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, be = (t, e, n, o, r, i, ...s) => {
  if (s.length > 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of selectors" : et(1));
  let l;
  if (t && e)
    l = (a, c, u, d) => {
      const f = t(a, c, u, d);
      return e(f, c, u, d);
    };
  else if (t)
    l = t;
  else
    throw (
      /* minify-error-disabled */
      new Error("Missing arguments")
    );
  return l;
};
var $9 = (t, e, n) => {
  if (e.length === 1 && e[0] === n) {
    let o = !1;
    try {
      const r = {};
      t(r) === r && (o = !0);
    } catch {
    }
    if (o) {
      let r;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: r } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: r }
      );
    }
  }
}, H9 = (t, e, n) => {
  const { memoize: o, memoizeOptions: r } = e, { inputSelectorResults: i, inputSelectorResultsCopy: s } = t, l = o(() => ({}), ...r);
  if (!(l.apply(null, i) === l.apply(null, s))) {
    let c;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: c } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: i,
        secondInputs: s,
        stack: c
      }
    );
  }
}, z9 = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, Fl = /* @__PURE__ */ Symbol("NOT_FOUND");
function B9(t, e = `expected a function, instead received ${typeof t}`) {
  if (typeof t != "function")
    throw new TypeError(e);
}
function W9(t, e = `expected an object, instead received ${typeof t}`) {
  if (typeof t != "object")
    throw new TypeError(e);
}
function U9(t, e = "expected all items to be functions, instead received the following types: ") {
  if (!t.every((n) => typeof n == "function")) {
    const n = t.map(
      (o) => typeof o == "function" ? `function ${o.name || "unnamed"}()` : typeof o
    ).join(", ");
    throw new TypeError(`${e}[${n}]`);
  }
}
var rp = (t) => Array.isArray(t) ? t : [t];
function G9(t) {
  const e = Array.isArray(t[0]) ? t[0] : t;
  return U9(
    e,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), e;
}
function ip(t, e) {
  const n = [], { length: o } = t;
  for (let r = 0; r < o; r++)
    n.push(t[r].apply(null, e));
  return n;
}
var Y9 = (t, e) => {
  const { identityFunctionCheck: n, inputStabilityCheck: o } = {
    ...z9,
    ...e
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && t,
      run: $9
    },
    inputStabilityCheck: {
      shouldRun: o === "always" || o === "once" && t,
      run: H9
    }
  };
};
function j9(t) {
  let e;
  return {
    get(n) {
      return e && t(e.key, n) ? e.value : Fl;
    },
    put(n, o) {
      e = { key: n, value: o };
    },
    getEntries() {
      return e ? [e] : [];
    },
    clear() {
      e = void 0;
    }
  };
}
function K9(t, e) {
  let n = [];
  function o(l) {
    const a = n.findIndex((c) => e(l, c.key));
    if (a > -1) {
      const c = n[a];
      return a > 0 && (n.splice(a, 1), n.unshift(c)), c.value;
    }
    return Fl;
  }
  function r(l, a) {
    o(l) === Fl && (n.unshift({ key: l, value: a }), n.length > t && n.pop());
  }
  function i() {
    return n;
  }
  function s() {
    n = [];
  }
  return { get: o, put: r, getEntries: i, clear: s };
}
var q9 = (t, e) => t === e;
function Z9(t) {
  return function(n, o) {
    if (n === null || o === null || n.length !== o.length)
      return !1;
    const { length: r } = n;
    for (let i = 0; i < r; i++)
      if (!t(n[i], o[i]))
        return !1;
    return !0;
  };
}
function X9(t, e) {
  const n = typeof e == "object" ? e : { equalityCheck: e }, {
    equalityCheck: o = q9,
    maxSize: r = 1,
    resultEqualityCheck: i
  } = n, s = Z9(o);
  let l = 0;
  const a = r <= 1 ? j9(s) : K9(r, s);
  function c() {
    let u = a.get(arguments);
    if (u === Fl) {
      if (u = t.apply(null, arguments), l++, i) {
        const f = a.getEntries().find(
          (p) => i(p.value, u)
        );
        f && (u = f.value, l !== 0 && l--);
      }
      a.put(arguments, u);
    }
    return u;
  }
  return c.clearCache = () => {
    a.clear(), c.resetResultsCount();
  }, c.resultsCount = () => l, c.resetResultsCount = () => {
    l = 0;
  }, c;
}
var Q9 = class {
  constructor(t) {
    this.value = t;
  }
  deref() {
    return this.value;
  }
}, J9 = typeof WeakRef < "u" ? WeakRef : Q9, e6 = 0, sp = 1;
function Ys() {
  return {
    s: e6,
    v: void 0,
    o: null,
    p: null
  };
}
function Dh(t, e = {}) {
  let n = Ys();
  const { resultEqualityCheck: o } = e;
  let r, i = 0;
  function s() {
    let l = n;
    const { length: a } = arguments;
    for (let d = 0, f = a; d < f; d++) {
      const p = arguments[d];
      if (typeof p == "function" || typeof p == "object" && p !== null) {
        let m = l.o;
        m === null && (l.o = m = /* @__PURE__ */ new WeakMap());
        const h = m.get(p);
        h === void 0 ? (l = Ys(), m.set(p, l)) : l = h;
      } else {
        let m = l.p;
        m === null && (l.p = m = /* @__PURE__ */ new Map());
        const h = m.get(p);
        h === void 0 ? (l = Ys(), m.set(p, l)) : l = h;
      }
    }
    const c = l;
    let u;
    if (l.s === sp)
      u = l.v;
    else if (u = t.apply(null, arguments), i++, o) {
      const d = r?.deref?.() ?? r;
      d != null && o(d, u) && (u = d, i !== 0 && i--), r = typeof u == "object" && u !== null || typeof u == "function" ? new J9(u) : u;
    }
    return c.s = sp, c.v = u, u;
  }
  return s.clearCache = () => {
    n = Ys(), s.resetResultsCount();
  }, s.resultsCount = () => i, s.resetResultsCount = () => {
    i = 0;
  }, s;
}
function _h(t, ...e) {
  const n = typeof t == "function" ? {
    memoize: t,
    memoizeOptions: e
  } : t, o = (...r) => {
    let i = 0, s = 0, l, a = {}, c = r.pop();
    typeof c == "object" && (a = c, c = r.pop()), B9(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const u = {
      ...n,
      ...a
    }, {
      memoize: d,
      memoizeOptions: f = [],
      argsMemoize: p = Dh,
      argsMemoizeOptions: m = [],
      devModeChecks: h = {}
    } = u, b = rp(f), v = rp(m), C = G9(r), y = d(function() {
      return i++, c.apply(
        null,
        arguments
      );
    }, ...b);
    let w = !0;
    const R = p(function() {
      s++;
      const E = ip(
        C,
        arguments
      );
      if (l = y.apply(null, E), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: N, inputStabilityCheck: I } = Y9(w, h);
        if (N.shouldRun && N.run(
          c,
          E,
          l
        ), I.shouldRun) {
          const T = ip(
            C,
            arguments
          );
          I.run(
            { inputSelectorResults: E, inputSelectorResultsCopy: T },
            { memoize: d, memoizeOptions: b },
            arguments
          );
        }
        w && (w = !1);
      }
      return l;
    }, ...v);
    return Object.assign(R, {
      resultFunc: c,
      memoizedResultFunc: y,
      dependencies: C,
      dependencyRecomputations: () => s,
      resetDependencyRecomputations: () => {
        s = 0;
      },
      lastResult: () => l,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: d,
      argsMemoize: p
    });
  };
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var t6 = /* @__PURE__ */ _h(Dh), n6 = Object.assign(
  (t, e = t6) => {
    W9(
      t,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof t}`
    );
    const n = Object.keys(t), o = n.map(
      (i) => t[i]
    );
    return e(
      o,
      (...i) => i.reduce((s, l, a) => (s[n[a]] = l, s), {})
    );
  },
  { withTypes: () => n6 }
);
const o6 = _h({
  memoize: X9,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), r6 = (...t) => {
  const e = /* @__PURE__ */ new WeakMap();
  let n = 1;
  const o = t[t.length - 1], r = t.length - 1 || 1, i = o.length - r;
  if (i > 3)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : et(2));
  return (l, a, c, u) => {
    let d = l.__cacheKey__;
    d || (d = {
      id: n
    }, l.__cacheKey__ = d, n += 1);
    let f = e.get(d);
    if (!f) {
      let p = t;
      const m = [void 0, void 0, void 0];
      switch (i) {
        case 0:
          break;
        case 1: {
          p = [...t.slice(0, -1), () => m[0], o];
          break;
        }
        case 2: {
          p = [...t.slice(0, -1), () => m[0], () => m[1], o];
          break;
        }
        case 3: {
          p = [...t.slice(0, -1), () => m[0], () => m[1], () => m[2], o];
          break;
        }
        default:
          throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : et(2));
      }
      f = o6(...p), f.selectorArgs = m, e.set(d, f);
    }
    switch (f.selectorArgs[0] = a, f.selectorArgs[1] = c, f.selectorArgs[2] = u, i) {
      case 0:
        return f(l);
      case 1:
        return f(l, a);
      case 2:
        return f(l, a, c);
      case 3:
        return f(l, a, c, u);
      default:
        throw (
          /* minify-error-disabled */
          new Error("unreachable")
        );
    }
  };
};
var js = { exports: {} }, ec = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lp;
function i6() {
  if (lp) return ec;
  lp = 1;
  var t = Be;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, o = t.useState, r = t.useEffect, i = t.useLayoutEffect, s = t.useDebugValue;
  function l(d, f) {
    var p = f(), m = o({ inst: { value: p, getSnapshot: f } }), h = m[0].inst, b = m[1];
    return i(
      function() {
        h.value = p, h.getSnapshot = f, a(h) && b({ inst: h });
      },
      [d, p, f]
    ), r(
      function() {
        return a(h) && b({ inst: h }), d(function() {
          a(h) && b({ inst: h });
        });
      },
      [d]
    ), s(p), p;
  }
  function a(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var p = f();
      return !n(d, p);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : l;
  return ec.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, ec;
}
var tc = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ap;
function s6() {
  return ap || (ap = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(p, m) {
      return p === m && (p !== 0 || 1 / p === 1 / m) || p !== p && m !== m;
    }
    function e(p, m) {
      u || r.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var h = m();
      if (!d) {
        var b = m();
        i(h, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      b = s({
        inst: { value: h, getSnapshot: m }
      });
      var v = b[0].inst, C = b[1];
      return a(
        function() {
          v.value = h, v.getSnapshot = m, n(v) && C({ inst: v });
        },
        [p, h, m]
      ), l(
        function() {
          return n(v) && C({ inst: v }), p(function() {
            n(v) && C({ inst: v });
          });
        },
        [p]
      ), c(h), h;
    }
    function n(p) {
      var m = p.getSnapshot;
      p = p.value;
      try {
        var h = m();
        return !i(p, h);
      } catch {
        return !0;
      }
    }
    function o(p, m) {
      return m();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = Be, i = typeof Object.is == "function" ? Object.is : t, s = r.useState, l = r.useEffect, a = r.useLayoutEffect, c = r.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : e;
    tc.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), tc;
}
var cp;
function ld() {
  return cp || (cp = 1, process.env.NODE_ENV === "production" ? js.exports = i6() : js.exports = s6()), js.exports;
}
var ad = ld(), Ks = { exports: {} }, nc = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var up;
function l6() {
  if (up) return nc;
  up = 1;
  var t = Be, e = ld();
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = e.useSyncExternalStore, i = t.useRef, s = t.useEffect, l = t.useMemo, a = t.useDebugValue;
  return nc.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
    var m = i(null);
    if (m.current === null) {
      var h = { hasValue: !1, value: null };
      m.current = h;
    } else h = m.current;
    m = l(
      function() {
        function v(S) {
          if (!C) {
            if (C = !0, y = S, S = f(S), p !== void 0 && h.hasValue) {
              var E = h.value;
              if (p(E, S))
                return w = E;
            }
            return w = S;
          }
          if (E = w, o(y, S)) return E;
          var N = f(S);
          return p !== void 0 && p(E, N) ? (y = S, E) : (y = S, w = N);
        }
        var C = !1, y, w, R = d === void 0 ? null : d;
        return [
          function() {
            return v(u());
          },
          R === null ? void 0 : function() {
            return v(R());
          }
        ];
      },
      [u, d, f, p]
    );
    var b = r(c, m[0], m[1]);
    return s(
      function() {
        h.hasValue = !0, h.value = b;
      },
      [b]
    ), a(b), b;
  }, nc;
}
var oc = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dp;
function a6() {
  return dp || (dp = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = Be, n = ld(), o = typeof Object.is == "function" ? Object.is : t, r = n.useSyncExternalStore, i = e.useRef, s = e.useEffect, l = e.useMemo, a = e.useDebugValue;
    oc.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
      var m = i(null);
      if (m.current === null) {
        var h = { hasValue: !1, value: null };
        m.current = h;
      } else h = m.current;
      m = l(
        function() {
          function v(S) {
            if (!C) {
              if (C = !0, y = S, S = f(S), p !== void 0 && h.hasValue) {
                var E = h.value;
                if (p(E, S))
                  return w = E;
              }
              return w = S;
            }
            if (E = w, o(y, S))
              return E;
            var N = f(S);
            return p !== void 0 && p(E, N) ? (y = S, E) : (y = S, w = N);
          }
          var C = !1, y, w, R = d === void 0 ? null : d;
          return [
            function() {
              return v(u());
            },
            R === null ? void 0 : function() {
              return v(R());
            }
          ];
        },
        [u, d, f, p]
      );
      var b = r(c, m[0], m[1]);
      return s(
        function() {
          h.hasValue = !0, h.value = b;
        },
        [b]
      ), a(b), b;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), oc;
}
var fp;
function c6() {
  return fp || (fp = 1, process.env.NODE_ENV === "production" ? Ks.exports = l6() : Ks.exports = a6()), Ks.exports;
}
var u6 = c6();
const ru = [];
let iu;
function d6() {
  return iu;
}
function f6(t) {
  ru.push(t);
}
function cd(t) {
  const e = (n, o) => {
    const r = It(p6).current;
    let i;
    try {
      iu = r;
      for (const s of ru)
        s.before(r);
      i = t(n, o);
      for (const s of ru)
        s.after(r);
      r.didInitialize = !0;
    } finally {
      iu = void 0;
    }
    return i;
  };
  return e.displayName = t.displayName || t.name, e;
}
function Vh(t) {
  return /* @__PURE__ */ x.forwardRef(cd(t));
}
function p6() {
  return {
    didInitialize: !1
  };
}
const m6 = Su(19), g6 = m6 ? b6 : v6;
function ye(t, e, n, o, r) {
  return g6(t, e, n, o, r);
}
function h6(t, e, n, o, r) {
  const i = x.useCallback(() => e(t.getSnapshot(), n, o, r), [t, e, n, o, r]);
  return ad.useSyncExternalStore(t.subscribe, i, i);
}
f6({
  before(t) {
    t.syncIndex = 0, t.didInitialize || (t.syncTick = 1, t.syncHooks = [], t.didChangeStore = !0, t.getSnapshot = () => {
      let e = !1;
      for (let n = 0; n < t.syncHooks.length; n += 1) {
        const o = t.syncHooks[n], r = o.selector(o.store.state, o.a1, o.a2, o.a3);
        (o.didChange || !Object.is(o.value, r)) && (e = !0, o.value = r, o.didChange = !1);
      }
      return e && (t.syncTick += 1), t.syncTick;
    });
  },
  after(t) {
    t.syncHooks.length > 0 && (t.didChangeStore && (t.didChangeStore = !1, t.subscribe = (e) => {
      const n = /* @__PURE__ */ new Set();
      for (const r of t.syncHooks)
        n.add(r.store);
      const o = [];
      for (const r of n)
        o.push(r.subscribe(e));
      return () => {
        for (const r of o)
          r();
      };
    }), ad.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getSnapshot));
  }
});
function b6(t, e, n, o, r) {
  const i = d6();
  if (!i)
    return h6(t, e, n, o, r);
  const s = i.syncIndex;
  i.syncIndex += 1;
  let l;
  return i.didInitialize ? (l = i.syncHooks[s], (l.store !== t || l.selector !== e || !Object.is(l.a1, n) || !Object.is(l.a2, o) || !Object.is(l.a3, r)) && (l.store !== t && (i.didChangeStore = !0), l.store = t, l.selector = e, l.a1 = n, l.a2 = o, l.a3 = r, l.didChange = !0)) : (l = {
    store: t,
    selector: e,
    a1: n,
    a2: o,
    a3: r,
    value: e(t.getSnapshot(), n, o, r),
    didChange: !1
  }, i.syncHooks.push(l)), l.value;
}
function v6(t, e, n, o, r) {
  return u6.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getSnapshot, (i) => e(i, n, o, r));
}
class ud {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(e) {
    this.state = e, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Registers a listener that will be called whenever the store's state changes.
   *
   * @param fn The listener function to be called on state changes.
   * @returns A function to unsubscribe the listener.
   */
  subscribe = (e) => (this.listeners.add(e), () => {
    this.listeners.delete(e);
  });
  /**
   * Returns the current state of the store.
   */
  getSnapshot = () => this.state;
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(e) {
    if (this.state === e)
      return;
    this.state = e, this.updateTick += 1;
    const n = this.updateTick;
    for (const o of this.listeners) {
      if (n !== this.updateTick)
        return;
      o(e);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(e) {
    for (const n in e)
      if (!Object.is(this.state[n], e[n])) {
        this.setState({
          ...this.state,
          ...e
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(e, n) {
    Object.is(this.state[e], n) || this.setState({
      ...this.state,
      [e]: n
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const e = {
      ...this.state
    };
    this.setState(e);
  }
  use(e, n, o, r) {
    return ye(this, e, n, o, r);
  }
}
class wr extends ud {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(e, n = {}, o) {
    super(e), this.context = n, this.selectors = o;
  }
  /**
   * Non-reactive values such as refs, callbacks, etc.
   */
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(e, n) {
    x.useDebugValue(e), Ne(() => {
      this.state[e] !== n && this.set(e, n);
    }, [e, n]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(e, n) {
    const o = this;
    Ne(() => (o.state[e] !== n && o.set(e, n), () => {
      o.set(e, void 0);
    }), [o, e, n]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(e) {
    const n = this;
    if (process.env.NODE_ENV !== "production") {
      x.useDebugValue(e, (s) => Object.keys(s));
      const r = x.useRef(Object.keys(e)).current, i = Object.keys(e);
      (r.length !== i.length || r.some((s, l) => s !== i[l])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const o = Object.values(e);
    Ne(() => {
      n.update(e);
    }, [n, ...o]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */
  useControlledProp(e, n) {
    x.useDebugValue(e);
    const o = n !== void 0;
    if (Ne(() => {
      o && !Object.is(this.state[e], n) && super.setState({
        ...this.state,
        [e]: n
      });
    }, [e, n, o]), process.env.NODE_ENV !== "production") {
      const r = this.controlledValues ??= /* @__PURE__ */ new Map();
      r.has(e) || r.set(e, o);
      const i = r.get(e);
      i !== void 0 && i !== o && console.error(`A component is changing the ${o ? "" : "un"}controlled state of ${e.toString()} to be ${o ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
  }
  /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */
  select(e, n, o, r) {
    const i = this.selectors[e];
    return i(this.state, n, o, r);
  }
  /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */
  useState(e, n, o, r) {
    return x.useDebugValue(e), ye(this, this.selectors[e], n, o, r);
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(e, n) {
    x.useDebugValue(e);
    const o = Ce(n ?? yt);
    this.context[e] = o;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(e) {
    const n = x.useRef(void 0);
    return n.current === void 0 && (n.current = (o) => {
      this.set(e, o);
    }), n.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(e, n) {
    let o;
    typeof e == "function" ? o = e : o = this.selectors[e];
    let r = o(this.state);
    return n(r, r, this), this.subscribe((i) => {
      const s = o(i);
      if (!Object.is(r, s)) {
        const l = r;
        r = s, n(s, l, this);
      }
    });
  }
}
const y6 = {
  open: be((t) => t.open),
  transitionStatus: be((t) => t.transitionStatus),
  domReferenceElement: be((t) => t.domReferenceElement),
  referenceElement: be((t) => t.positionReference ?? t.referenceElement),
  floatingElement: be((t) => t.floatingElement),
  floatingId: be((t) => t.floatingId)
};
class dd extends wr {
  constructor(e) {
    const {
      syncOnly: n,
      nested: o,
      onOpenChange: r,
      triggerElements: i,
      ...s
    } = e;
    super({
      ...s,
      positionReference: s.referenceElement,
      domReferenceElement: s.referenceElement
    }, {
      onOpenChange: r,
      dataRef: {
        current: {}
      },
      events: Sh(),
      nested: o,
      triggerElements: i
    }, y6), this.syncOnly = n;
  }
  /**
   * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
   */
  syncOpenEvent = (e, n) => {
    (!e || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
    // click events to upgrade a hover-open.
    n != null && Zg(n)) && (this.context.dataRef.current.openEvent = e ? n : void 0);
  };
  /**
   * Runs the root-owned side effects for an open state change.
   */
  dispatchOpenChange = (e, n) => {
    this.syncOpenEvent(e, n.event);
    const o = {
      open: e,
      reason: n.reason,
      nativeEvent: n.event,
      nested: this.context.nested,
      triggerElement: n.trigger
    };
    this.context.events.emit("openchange", o);
  };
  /**
   * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
   *
   * @param newOpen The new open state.
   * @param eventDetails Details about the event that triggered the open state change.
   */
  setOpen = (e, n) => {
    if (this.syncOnly) {
      this.context.onOpenChange?.(e, n);
      return;
    }
    this.dispatchOpenChange(e, n), this.context.onOpenChange?.(e, n);
  };
}
function Ah(t, e) {
  const n = x.useRef(null), o = x.useRef(null);
  return x.useCallback((r) => {
    if (t !== void 0) {
      if (n.current !== null) {
        const i = n.current, s = o.current, l = e.context.triggerElements.getById(i);
        s && l === s && e.context.triggerElements.delete(i), n.current = null, o.current = null;
      }
      r !== null && (n.current = t, o.current = r, e.context.triggerElements.add(t, r));
    }
  }, [e, t]);
}
function ss(t, e, n, o) {
  const r = n.useState("isMountedByTrigger", t), i = Ah(t, n), s = Ce((l) => {
    if (i(l), !l || !n.select("open"))
      return;
    const a = n.select("activeTriggerId");
    if (a === t) {
      n.update({
        activeTriggerElement: l,
        ...o
      });
      return;
    }
    a == null && n.update({
      activeTriggerId: t,
      activeTriggerElement: l,
      ...o
    });
  });
  return Ne(() => {
    r && n.update({
      activeTriggerElement: e.current,
      ...o
    });
  }, [r, n, e, ...Object.values(o)]), {
    registerTrigger: s,
    isMountedByThisTrigger: r
  };
}
function ls(t) {
  const e = t.useState("open");
  Ne(() => {
    if (e && !t.select("activeTriggerId") && t.context.triggerElements.size === 1) {
      const n = t.context.triggerElements.entries().next();
      if (!n.done) {
        const [o, r] = n.value;
        t.update({
          activeTriggerId: o,
          activeTriggerElement: r
        });
      }
    }
  }, [e, t]);
}
function as(t, e, n) {
  const {
    mounted: o,
    setMounted: r,
    transitionStatus: i
  } = Zn(t);
  e.useSyncedValues({
    mounted: o,
    transitionStatus: i
  });
  const s = Ce(() => {
    r(!1), e.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1
    }), n?.(), e.context.onOpenChangeComplete?.(!1);
  }), l = e.useState("preventUnmountingOnClose");
  return Yt({
    enabled: !l,
    open: t,
    ref: e.context.popupRef,
    onComplete() {
      t || s();
    }
  }), {
    forceUnmount: s,
    transitionStatus: i
  };
}
class Sr {
  constructor() {
    this.elementsSet = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(e, n) {
    const o = this.idMap.get(e);
    if (o !== n && (o !== void 0 && this.elementsSet.delete(o), this.elementsSet.add(n), this.idMap.set(e, n), process.env.NODE_ENV !== "production" && this.elementsSet.size !== this.idMap.size))
      throw new Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(e) {
    const n = this.idMap.get(e);
    n && (this.elementsSet.delete(n), this.idMap.delete(e));
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(e) {
    return this.elementsSet.has(e);
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(e) {
    for (const n of this.elementsSet)
      if (e(n))
        return !0;
    return !1;
  }
  /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */
  getById(e) {
    return this.idMap.get(e);
  }
  /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */
  entries() {
    return this.idMap.entries();
  }
  /**
   * Returns an iterable of all registered trigger elements.
   */
  elements() {
    return this.elementsSet.values();
  }
  /**
   * Returns the number of registered trigger elements.
   */
  get size() {
    return this.idMap.size;
  }
}
function x6() {
  return new dd({
    open: !1,
    transitionStatus: void 0,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new Sr(),
    floatingId: "",
    syncOnly: !1,
    nested: !1,
    onOpenChange: void 0
  });
}
function cs() {
  return {
    open: !1,
    openProp: void 0,
    mounted: !1,
    transitionStatus: void 0,
    floatingRootContext: x6(),
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    triggerIdProp: void 0,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: St,
    inactiveTriggerProps: St,
    popupProps: St
  };
}
const qs = be((t) => t.triggerIdProp ?? t.activeTriggerId), us = {
  open: be((t) => t.openProp ?? t.open),
  mounted: be((t) => t.mounted),
  transitionStatus: be((t) => t.transitionStatus),
  floatingRootContext: be((t) => t.floatingRootContext),
  preventUnmountingOnClose: be((t) => t.preventUnmountingOnClose),
  payload: be((t) => t.payload),
  activeTriggerId: qs,
  activeTriggerElement: be((t) => t.mounted ? t.activeTriggerElement : null),
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: be((t, e) => e !== void 0 && qs(t) === e),
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: be((t, e) => e !== void 0 && qs(t) === e && t.open),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: be((t, e) => e !== void 0 && qs(t) === e && t.mounted),
  triggerProps: be((t, e) => e ? t.activeTriggerProps : t.inactiveTriggerProps),
  popupProps: be((t) => t.popupProps),
  popupElement: be((t) => t.popupElement),
  positionerElement: be((t) => t.positionerElement)
};
function fd(t) {
  const {
    open: e = !1,
    onOpenChange: n,
    elements: o = {}
  } = t, r = Do(), i = bo() != null;
  if (process.env.NODE_ENV !== "production") {
    const l = o.reference;
    l && !pt(l) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const s = It(() => new dd({
    open: e,
    transitionStatus: void 0,
    onOpenChange: n,
    referenceElement: o.reference ?? null,
    floatingElement: o.floating ?? null,
    triggerElements: new Sr(),
    floatingId: r,
    syncOnly: !1,
    nested: i
  })).current;
  return Ne(() => {
    const l = {
      open: e,
      floatingId: r
    };
    o.reference !== void 0 && (l.referenceElement = o.reference, l.domReferenceElement = pt(o.reference) ? o.reference : null), o.floating !== void 0 && (l.floatingElement = o.floating), s.update(l);
  }, [e, r, o.reference, o.floating, s]), s.context.onOpenChange = n, s.context.nested = i, s;
}
function C6(t = {}) {
  const {
    nodeId: e,
    externalTree: n
  } = t, o = fd(t), r = t.rootContext || o, i = {
    reference: r.useState("referenceElement"),
    floating: r.useState("floatingElement"),
    domReference: r.useState("domReferenceElement")
  }, [s, l] = x.useState(null), a = x.useRef(null), c = tr(n);
  Ne(() => {
    i.domReference && (a.current = i.domReference);
  }, [i.domReference]);
  const u = O9({
    ...t,
    elements: {
      ...i,
      ...s && {
        reference: s
      }
    }
  }), d = x.useCallback((N) => {
    const I = pt(N) ? {
      getBoundingClientRect: () => N.getBoundingClientRect(),
      getClientRects: () => N.getClientRects(),
      contextElement: N
    } : N;
    l(I), u.refs.setReference(I);
  }, [u.refs]), [f, p] = x.useState(void 0), [m, h] = x.useState(null);
  r.useSyncedValue("referenceElement", f ?? null);
  const b = pt(f) ? f : null;
  r.useSyncedValue("domReferenceElement", f === void 0 ? i.domReference : b), r.useSyncedValue("floatingElement", m);
  const v = x.useCallback((N) => {
    (pt(N) || N === null) && (a.current = N, p(N)), (pt(u.refs.reference.current) || u.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    N !== null && !pt(N)) && u.refs.setReference(N);
  }, [u.refs, p]), C = x.useCallback((N) => {
    h(N), u.refs.setFloating(N);
  }, [u.refs]), y = x.useMemo(() => ({
    ...u.refs,
    setReference: v,
    setFloating: C,
    setPositionReference: d,
    domReference: a
  }), [u.refs, v, C, d]), w = x.useMemo(() => ({
    ...u.elements,
    domReference: i.domReference
  }), [u.elements, i.domReference]), R = r.useState("open"), S = r.useState("floatingId"), E = x.useMemo(() => ({
    ...u,
    dataRef: r.context.dataRef,
    open: R,
    onOpenChange: r.setOpen,
    events: r.context.events,
    floatingId: S,
    refs: y,
    elements: w,
    nodeId: e,
    rootStore: r
  }), [u, y, w, e, r, R, S]);
  return Ne(() => {
    r.context.dataRef.current.floatingContext = E;
    const N = c?.nodesRef.current.find((I) => I.id === e);
    N && (N.context = E);
  }), x.useMemo(() => ({
    ...u,
    context: E,
    refs: y,
    elements: w,
    rootStore: r
  }), [u, y, w, E, r]);
}
function ds(t) {
  const {
    popupStore: e,
    treatPopupAsFloatingElement: n = !1,
    onOpenChange: o
  } = t, r = Do(), i = bo() != null, s = e.useState("open"), l = e.useState("activeTriggerElement"), a = e.useState(n ? "popupElement" : "positionerElement"), c = e.context.triggerElements, u = It(() => new dd({
    open: s,
    transitionStatus: void 0,
    referenceElement: l,
    floatingElement: a,
    triggerElements: c,
    onOpenChange: o,
    floatingId: r,
    syncOnly: !0,
    nested: i
  })).current;
  return Ne(() => {
    const d = {
      open: s,
      floatingId: r,
      referenceElement: l,
      floatingElement: a
    };
    pt(l) && (d.domReferenceElement = l), u.state.positionReference === u.state.referenceElement && (d.positionReference = l), u.update(d);
  }, [s, r, l, a, u]), u.context.onOpenChange = o, u.context.nested = i, u;
}
const rc = Ug && Wg;
function pd(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    events: o,
    dataRef: r
  } = n.context, {
    enabled: i = !0,
    delay: s
  } = e, l = x.useRef(!1), a = x.useRef(null), c = Dt(), u = x.useRef(!0);
  x.useEffect(() => {
    const f = n.select("domReferenceElement");
    if (!i)
      return;
    const p = Ct(f);
    function m() {
      const v = n.select("domReferenceElement");
      !n.select("open") && xt(v) && v === Ut(Je(v)) && (l.current = !0);
    }
    function h() {
      u.current = !0;
    }
    function b() {
      u.current = !1;
    }
    return Yn(at(p, "blur", m), rc && at(p, "keydown", h, !0), rc && at(p, "pointerdown", b, !0));
  }, [n, i]), x.useEffect(() => {
    if (!i)
      return;
    function f(p) {
      if (p.reason === qn || p.reason === vr) {
        const m = n.select("domReferenceElement");
        pt(m) && (a.current = m, l.current = !0);
      }
    }
    return o.on("openchange", f), () => {
      o.off("openchange", f);
    };
  }, [o, i, n]);
  const d = x.useMemo(() => ({
    onMouseLeave() {
      l.current = !1, a.current = null;
    },
    onFocus(f) {
      const p = f.currentTarget;
      if (l.current) {
        if (a.current === p)
          return;
        l.current = !1, a.current = null;
      }
      const m = bt(f.nativeEvent);
      if (pt(m)) {
        if (rc && !f.relatedTarget) {
          if (!u.current && !ia(m))
            return;
        } else if (!_l(m))
          return;
      }
      const h = Dl(f.relatedTarget, n.context.triggerElements), {
        nativeEvent: b,
        currentTarget: v
      } = f, C = typeof s == "function" ? s() : s;
      if (n.select("open") && h || C === 0 || C === void 0) {
        n.setOpen(!0, De(dr, b, v));
        return;
      }
      c.start(C, () => {
        l.current || n.setOpen(!0, De(dr, b, v));
      });
    },
    onBlur(f) {
      l.current = !1, a.current = null;
      const p = f.relatedTarget, m = f.nativeEvent, h = pt(p) && p.hasAttribute(Yi("focus-guard")) && p.getAttribute("data-type") === "outside";
      c.start(0, () => {
        const b = n.select("domReferenceElement"), v = Ut(Je(b));
        !p && v === b || Fe(r.current.floatingContext?.refs.floating.current, v) || Fe(b, v) || h || Dl(p ?? v, n.context.triggerElements) || n.setOpen(!1, De(dr, m));
      });
    }
  }), [r, n, c, s]);
  return x.useMemo(() => i ? {
    reference: d,
    trigger: d
  } : {}, [i, d]);
}
class md {
  constructor() {
    this.pointerType = void 0, this.interactedInside = !1, this.handler = void 0, this.blockMouseMove = !0, this.performedPointerEventsMutation = !1, this.pointerEventsScopeElement = null, this.pointerEventsReferenceElement = null, this.pointerEventsFloatingElement = null, this.restTimeoutPending = !1, this.openChangeTimeout = new xn(), this.restTimeout = new xn(), this.handleCloseOptions = void 0;
  }
  static create() {
    return new md();
  }
  dispose = () => {
    this.openChangeTimeout.clear(), this.restTimeout.clear();
  };
  disposeEffect = () => this.dispose;
}
const $l = /* @__PURE__ */ new WeakMap();
function Hl(t) {
  if (!t.performedPointerEventsMutation)
    return;
  const e = t.pointerEventsScopeElement;
  e && $l.get(e) === t && (t.pointerEventsScopeElement?.style.removeProperty("pointer-events"), t.pointerEventsReferenceElement?.style.removeProperty("pointer-events"), t.pointerEventsFloatingElement?.style.removeProperty("pointer-events"), $l.delete(e)), t.performedPointerEventsMutation = !1, t.pointerEventsScopeElement = null, t.pointerEventsReferenceElement = null, t.pointerEventsFloatingElement = null;
}
function Lh(t, e) {
  const {
    scopeElement: n,
    referenceElement: o,
    floatingElement: r
  } = e, i = $l.get(n);
  i && i !== t && Hl(i), Hl(t), t.performedPointerEventsMutation = !0, t.pointerEventsScopeElement = n, t.pointerEventsReferenceElement = o, t.pointerEventsFloatingElement = r, $l.set(n, t), n.style.pointerEvents = "none", o.style.pointerEvents = "auto", r.style.pointerEvents = "auto";
}
function Fh(t) {
  const e = It(md.create).current, n = t.context.dataRef.current;
  return n.hoverInteractionState || (n.hoverInteractionState = e), Qr(n.hoverInteractionState.disposeEffect), n.hoverInteractionState;
}
function ua(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), {
    dataRef: s
  } = n.context, {
    enabled: l = !0,
    closeDelay: a = 0,
    nodeId: c
  } = e, u = Fh(n), d = tr(), f = bo(), p = Ce(() => Xg(s.current.openEvent?.type, u.interactedInside)), m = Ce(() => {
    const w = s.current.openEvent?.type;
    return w?.includes("mouse") && w !== "mousedown";
  }), h = Ce((w) => Dl(w, n.context.triggerElements)), b = x.useCallback((w) => {
    const R = Ol(a, "close", u.pointerType), S = () => {
      n.setOpen(!1, De(At, w)), d?.events.emit("floating.closed", w);
    };
    R ? u.openChangeTimeout.start(R, S) : (u.openChangeTimeout.clear(), S());
  }, [a, n, u, d]), v = Ce(() => {
    Hl(u);
  }), C = Ce((w) => {
    const R = bt(w);
    if (!nh(R)) {
      u.interactedInside = !1;
      return;
    }
    u.interactedInside = R?.closest("[aria-haspopup]") != null;
  });
  Ne(() => {
    o || (u.pointerType = void 0, u.restTimeoutPending = !1, u.interactedInside = !1, v());
  }, [o, u, v]), x.useEffect(() => v, [v]), Ne(() => {
    if (l && o && u.handleCloseOptions?.blockPointerEvents && m() && pt(i) && r) {
      const w = i, R = r, S = Je(r), E = d?.nodesRef.current.find((I) => I.id === f)?.context?.elements.floating;
      E && (E.style.pointerEvents = "");
      const N = u.handleCloseOptions?.getScope?.() ?? u.pointerEventsScopeElement ?? E ?? w.closest("[data-rootownerid]") ?? S.body;
      return Lh(u, {
        scopeElement: N,
        referenceElement: w,
        floatingElement: R
      }), () => {
        v();
      };
    }
  }, [l, o, i, r, u, m, d, f, v]);
  const y = Dt();
  x.useEffect(() => {
    if (!l)
      return;
    function w() {
      u.openChangeTimeout.clear(), y.clear(), d?.events.off("floating.closed", S), v();
    }
    function R(N) {
      if (d && f && co(d.nodesRef.current, f).length > 0) {
        d.events.on("floating.closed", S);
        return;
      }
      if (h(N.relatedTarget))
        return;
      const I = s.current.floatingContext?.nodeId ?? c, T = N.relatedTarget;
      if (!(d && I && pt(T) && co(d.nodesRef.current, I, !1).some((P) => Fe(P.context?.elements.floating, T)))) {
        if (u.handler) {
          u.handler(N);
          return;
        }
        v(), p() || b(N);
      }
    }
    function S(N) {
      !d || !f || co(d.nodesRef.current, f).length > 0 || y.start(0, () => {
        d.events.off("floating.closed", S), n.setOpen(!1, De(At, N)), d.events.emit("floating.closed", N);
      });
    }
    const E = r;
    return Yn(E && at(E, "mouseenter", w), E && at(E, "mouseleave", R), E && at(E, "pointerdown", C, !0), () => {
      d?.events.off("floating.closed", S);
    });
  }, [l, r, n, s, c, p, h, b, v, C, u, d, f, y]);
}
const w6 = {
  current: null
};
function fs(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    dataRef: o,
    events: r
  } = n.context, {
    enabled: i = !0,
    delay: s = 0,
    handleClose: l = null,
    mouseOnly: a = !1,
    restMs: c = 0,
    move: u = !0,
    triggerElementRef: d = w6,
    externalTree: f,
    isActiveTrigger: p = !0,
    getHandleCloseContext: m,
    isClosing: h
  } = e, b = tr(f), v = Fh(n), C = x.useRef(!1), y = Ft(l), w = Ft(s), R = Ft(c), S = Ft(i), E = Ft(h);
  p && (v.handleCloseOptions = y.current?.__options);
  const N = Ce(() => Xg(o.current.openEvent?.type, v.interactedInside)), I = Ce((D) => Dl(D, n.context.triggerElements)), T = Ce((D, O, _) => {
    const V = n.context.triggerElements;
    if (V.hasElement(O))
      return !D || !Fe(D, O);
    if (!pt(_))
      return !1;
    const A = _;
    return V.hasMatchingElement((L) => Fe(L, A)) && (!D || !Fe(D, A));
  }), k = Ce((D, O = !0) => {
    const _ = Ol(w.current, "close", v.pointerType);
    _ ? v.openChangeTimeout.start(_, () => {
      n.setOpen(!1, De(At, D)), b?.events.emit("floating.closed", D);
    }) : O && (v.openChangeTimeout.clear(), n.setOpen(!1, De(At, D)), b?.events.emit("floating.closed", D));
  }), P = Ce(() => {
    if (!v.handler)
      return;
    Je(n.select("domReferenceElement")).removeEventListener("mousemove", v.handler), v.handler = void 0;
  }), M = Ce(() => {
    Hl(v);
  });
  return x.useEffect(() => P, [P]), x.useEffect(() => {
    if (!i)
      return;
    function D(O) {
      O.open ? C.current = !1 : (C.current = O.reason === At, P(), v.openChangeTimeout.clear(), v.restTimeout.clear(), v.blockMouseMove = !0, v.restTimeoutPending = !1);
    }
    return r.on("openchange", D), () => {
      r.off("openchange", D);
    };
  }, [i, r, v, P]), x.useEffect(() => {
    if (!i)
      return;
    const D = d.current ?? (p ? n.select("domReferenceElement") : null);
    if (!pt(D))
      return;
    function O(V) {
      if (v.openChangeTimeout.clear(), v.blockMouseMove = !1, a && !Yr(v.pointerType))
        return;
      const A = F1(R.current), L = Ol(w.current, "open", v.pointerType), $ = bt(V), Y = V.currentTarget ?? null, G = n.select("domReferenceElement");
      let j = Y;
      if (pt($) && !n.context.triggerElements.hasElement($)) {
        for (const Q of n.context.triggerElements.elements())
          if (Fe(Q, $)) {
            j = Q;
            break;
          }
      }
      pt(Y) && pt(G) && !n.context.triggerElements.hasElement(Y) && Fe(Y, G) && (j = G);
      const Z = j == null ? !1 : T(G, j, $), U = n.select("open"), q = E.current?.() ?? n.select("transitionStatus") === "ending", te = !U && q && C.current, H = !Z && pt(j) && pt(G) && Fe(G, j) && te, X = A > 0 && !L, ee = Z && (U || te) || H, le = !U || Z;
      if (ee) {
        n.setOpen(!0, De(At, V, j));
        return;
      }
      X || (L ? v.openChangeTimeout.start(L, () => {
        le && n.setOpen(!0, De(At, V, j));
      }) : le && n.setOpen(!0, De(At, V, j)));
    }
    function _(V) {
      if (N()) {
        M();
        return;
      }
      P();
      const A = n.select("domReferenceElement"), L = Je(A);
      v.restTimeout.clear(), v.restTimeoutPending = !1;
      const $ = o.current.floatingContext ?? m?.();
      if (I(V.relatedTarget))
        return;
      if (y.current && $) {
        n.select("open") || v.openChangeTimeout.clear();
        const j = d.current;
        v.handler = y.current({
          ...$,
          tree: b,
          x: V.clientX,
          y: V.clientY,
          onClose() {
            M(), P(), S.current && !N() && j === n.select("domReferenceElement") && k(V, !0);
          }
        }), L.addEventListener("mousemove", v.handler), v.handler(V);
        return;
      }
      (v.pointerType !== "touch" || !Fe(n.select("floatingElement"), V.relatedTarget)) && k(V);
    }
    return u ? Yn(at(D, "mousemove", O, {
      once: !0
    }), at(D, "mouseenter", O), at(D, "mouseleave", _)) : Yn(at(D, "mouseenter", O), at(D, "mouseleave", _));
  }, [P, M, o, w, k, n, i, y, v, p, T, N, I, a, u, R, d, b, S, m, E]), x.useMemo(() => {
    if (!i)
      return;
    function D(O) {
      v.pointerType = O.pointerType;
    }
    return {
      onPointerDown: D,
      onPointerEnter: D,
      onMouseMove(O) {
        const {
          nativeEvent: _
        } = O, V = O.currentTarget, A = n.select("domReferenceElement"), L = n.select("open"), $ = T(A, V, O.target);
        if (a && !Yr(v.pointerType))
          return;
        if (L && $ && v.handleCloseOptions?.blockPointerEvents) {
          const j = n.select("floatingElement");
          if (j) {
            const Z = v.handleCloseOptions?.getScope?.() ?? V.ownerDocument.body;
            Lh(v, {
              scopeElement: Z,
              referenceElement: V,
              floatingElement: j
            });
          }
        }
        const Y = F1(R.current);
        if (L && !$ || Y === 0 || !$ && v.restTimeoutPending && O.movementX ** 2 + O.movementY ** 2 < 2)
          return;
        v.restTimeout.clear();
        function G() {
          if (v.restTimeoutPending = !1, N())
            return;
          const j = n.select("open");
          !v.blockMouseMove && (!j || $) && n.setOpen(!0, De(At, _, V));
        }
        v.pointerType === "touch" ? an.flushSync(() => {
          G();
        }) : $ && L ? G() : (v.restTimeoutPending = !0, v.restTimeout.start(Y, G));
      }
    };
  }, [i, v, N, T, a, n, R]);
}
function Jn(t = []) {
  const e = t.map((c) => c?.reference), n = t.map((c) => c?.floating), o = t.map((c) => c?.item), r = t.map((c) => c?.trigger), i = x.useCallback(
    (c) => Zs(c, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), s = x.useCallback(
    (c) => Zs(c, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), l = x.useCallback(
    (c) => Zs(c, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  ), a = x.useCallback(
    (c) => Zs(c, t, "trigger"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return x.useMemo(() => ({
    getReferenceProps: i,
    getFloatingProps: s,
    getItemProps: l,
    getTriggerProps: a
  }), [i, s, l, a]);
}
function Zs(t, e, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item", i = {};
  n === "floating" && (i.tabIndex = -1, i[Xc] = "");
  for (const s in t)
    r && t && (s === Jg || s === eh) || (i[s] = t[s]);
  for (let s = 0; s < e.length; s += 1) {
    let l;
    const a = e[s]?.[n];
    typeof a == "function" ? l = t ? a(t) : null : l = a, l && pp(i, l, r, o);
  }
  return pp(i, t, r, o), i;
}
function pp(t, e, n, o) {
  for (const r in e) {
    const i = e[r];
    n && (r === Jg || r === eh) || (r.startsWith("on") ? (o.has(r) || o.set(r, []), typeof i == "function" && (o.get(r)?.push(i), t[r] = (...s) => o.get(r)?.map((l) => l(...s)).find((l) => l !== void 0))) : t[r] = i);
  }
}
const S6 = "Escape";
function da(t, e, n) {
  switch (t) {
    case "vertical":
      return e;
    case "horizontal":
      return n;
    default:
      return e || n;
  }
}
function Xs(t, e) {
  return da(e, t === Gu || t === rs, t === Uo || t === Go);
}
function ic(t, e, n) {
  return da(e, t === rs, n ? t === Uo : t === Go) || t === "Enter" || t === " " || t === "";
}
function R6(t, e, n) {
  return da(e, n ? t === Uo : t === Go, t === rs);
}
function E6(t, e, n, o) {
  const r = n ? t === Go : t === Uo, i = t === Gu;
  return e === "both" || e === "horizontal" && o && o > 1 ? t === S6 : da(e, r, i);
}
function gd(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    listRef: l,
    activeIndex: a,
    onNavigate: c = () => {
    },
    enabled: u = !0,
    selectedIndex: d = null,
    allowEscape: f = !1,
    loopFocus: p = !1,
    nested: m = !1,
    rtl: h = !1,
    virtual: b = !1,
    focusItemOnOpen: v = "auto",
    focusItemOnHover: C = !0,
    openOnArrowKeyDown: y = !0,
    disabledIndices: w = void 0,
    orientation: R = "vertical",
    parentOrientation: S,
    cols: E = 1,
    id: N,
    resetOnPointerLeave: I = !0,
    externalTree: T
  } = e;
  process.env.NODE_ENV !== "production" && (f && (p || console.warn("`useListNavigation` looping must be enabled to allow escaping."), b || console.warn("`useListNavigation` must be virtual to allow escaping.")), R === "vertical" && E > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const k = Wi(r), P = Ft(k), M = bo(), D = tr(T);
  Ne(() => {
    s.current.orientation = R;
  }, [s, R]);
  const O = Qc(i), _ = x.useRef(v), V = x.useRef(d ?? -1), A = x.useRef(null), L = x.useRef(!0), $ = Ce((z) => {
    c(V.current === -1 ? null : V.current, z);
  }), Y = x.useRef($), G = x.useRef(!!r), j = x.useRef(o), Z = x.useRef(!1), U = x.useRef(!1), q = x.useRef(null), te = Ft(w), H = Ft(o), X = Ft(d), ee = Ft(I), le = Ce(() => {
    function z(ie) {
      b ? D?.events.emit("virtualfocus", ie) : q.current = yl(ie, {
        sync: Z.current,
        preventScroll: !0
      });
    }
    const J = l.current[V.current], B = U.current;
    J && z(J), (Z.current ? (ie) => ie() : requestAnimationFrame)(() => {
      const ie = l.current[V.current] || J;
      if (!ie)
        return;
      J || z(ie), // eslint-disable-next-line @typescript-eslint/no-use-before-define
      fe && (B || !L.current) && ie.scrollIntoView?.({
        block: "nearest",
        inline: "nearest"
      });
    });
  });
  Ne(() => {
    u && (o && r ? (V.current = d ?? -1, _.current && d != null && (U.current = !0, $())) : G.current && (V.current = -1, Y.current()));
  }, [u, o, r, d, $]), Ne(() => {
    if (u) {
      if (!o) {
        Z.current = !1;
        return;
      }
      if (r)
        if (a == null) {
          if (Z.current = !1, X.current != null)
            return;
          if (G.current && (V.current = -1, le()), (!j.current || !G.current) && _.current && (A.current != null || _.current === !0 && A.current == null)) {
            let z = 0;
            const J = () => {
              l.current[0] == null ? (z < 2 && (z ? requestAnimationFrame : queueMicrotask)(J), z += 1) : (V.current = A.current == null || ic(A.current, R, h) || m ? vl(l) : tu(l), A.current = null, $());
            };
            J();
          }
        } else Gi(l.current, a) || (V.current = a, le(), U.current = !1);
    }
  }, [u, o, r, a, X, m, l, R, h, $, le, te]), Ne(() => {
    if (!u || r || !D || b || !G.current)
      return;
    const z = D.nodesRef.current, J = z.find((ie) => ie.id === M)?.context?.elements.floating, B = Ut(Je(r)), K = z.some((ie) => ie.context && Fe(ie.context.elements.floating, B));
    J && !K && L.current && J.focus({
      preventScroll: !0
    });
  }, [u, r, D, M, b]), Ne(() => {
    Y.current = $, j.current = o, G.current = !!r;
  }), Ne(() => {
    o || (A.current = null, _.current = v);
  }, [o, v]);
  const Q = a != null, re = Ce((z) => {
    if (!H.current)
      return;
    const J = l.current.indexOf(z.currentTarget);
    J !== -1 && (V.current !== J || a !== J) && (V.current = J, $(z));
  }), fe = x.useMemo(() => ({
    onFocus(J) {
      Z.current = !0, re(J);
    },
    onClick: ({
      currentTarget: J
    }) => J.focus({
      preventScroll: !0
    }),
    // Safari
    onMouseMove(J) {
      Z.current = !0, U.current = !1, C && re(J);
    },
    onPointerLeave(J) {
      if (!H.current || !L.current || J.pointerType === "touch")
        return;
      Z.current = !0;
      const B = J.relatedTarget;
      if (!(!C || l.current.includes(B)) && ee.current && (q.current?.(), q.current = null, V.current = -1, $(J), !b)) {
        const K = P.current, ie = Ut(Je(K));
        K && Fe(K, ie) && K.focus({
          preventScroll: !0
        });
      }
    }
  }), [re, H, P, C, l, $, ee, b]), ne = x.useCallback(() => S ?? D?.nodesRef.current.find((z) => z.id === M)?.context?.dataRef?.current.orientation, [M, D, S]), se = Ce((z) => {
    if (L.current = !1, Z.current = !0, z.which === 229 || !H.current && z.currentTarget === P.current)
      return;
    if (m && E6(z.key, R, h, E)) {
      Xs(z.key, ne()) || Lt(z), n.setOpen(!1, De(Fr, z.nativeEvent)), xt(i) && (b ? D?.events.emit("virtualfocus", i) : i.focus());
      return;
    }
    const J = V.current, B = vl(l, w), K = tu(l, w);
    if (O || (z.key === "Home" && (Lt(z), V.current = B, $(z)), z.key === "End" && (Lt(z), V.current = K, $(z))), E > 1) {
      const ie = Array.from({
        length: l.current.length
      }, () => ({
        width: 1,
        height: 1
      })), ge = ih(ie, E, !1), ue = ge.findIndex((de) => de != null && !No(l.current, de, w)), Se = ge.reduce((de, me, Re) => me != null && !No(l.current, me, w) ? Re : de, -1), ve = ge[rh(ge.map((de) => de != null ? l.current[de] : null), {
        event: z,
        orientation: R,
        loopFocus: p,
        rtl: h,
        cols: E,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: lh([...(typeof w != "function" ? w : null) || l.current.map((de, me) => No(l.current, me, w) ? me : void 0), void 0], ge),
        minIndex: ue,
        maxIndex: Se,
        prevIndex: sh(
          V.current > K ? B : V.current,
          ie,
          ge,
          E,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          // eslint-disable-next-line no-nested-ternary
          z.key === rs ? "bl" : z.key === (h ? Uo : Go) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (ve != null && (V.current = ve, $(z)), R === "both")
        return;
    }
    if (Xs(z.key, R)) {
      if (Lt(z), o && !b && Ut(z.currentTarget.ownerDocument) === z.currentTarget) {
        V.current = ic(z.key, R, h) ? B : K, $(z);
        return;
      }
      ic(z.key, R, h) ? p ? J >= K ? f && J !== l.current.length ? V.current = -1 : (Z.current = !1, V.current = B) : V.current = rn(l.current, {
        startingIndex: J,
        disabledIndices: w
      }) : V.current = Math.min(K, rn(l.current, {
        startingIndex: J,
        disabledIndices: w
      })) : p ? J <= B ? f && J !== -1 ? V.current = l.current.length : (Z.current = !1, V.current = K) : V.current = rn(l.current, {
        startingIndex: J,
        decrement: !0,
        disabledIndices: w
      }) : V.current = Math.max(B, rn(l.current, {
        startingIndex: J,
        decrement: !0,
        disabledIndices: w
      })), Gi(l.current, V.current) && (V.current = -1), $(z);
    }
  }), pe = x.useMemo(() => b && o && Q && {
    "aria-activedescendant": `${N}-${a}`
  }, [b, o, Q, N, a]), xe = x.useMemo(() => ({
    "aria-orientation": R === "both" ? void 0 : R,
    ...O ? {} : pe,
    onKeyDown(z) {
      if (z.key === "Tab" && z.shiftKey && o && !b) {
        const J = bt(z.nativeEvent);
        if (J && !Fe(P.current, J))
          return;
        Lt(z), n.setOpen(!1, De(Io, z.nativeEvent)), xt(i) && i.focus();
        return;
      }
      se(z);
    },
    onPointerMove() {
      L.current = !0;
    }
  }), [pe, se, P, R, O, n, o, b, i]), ce = x.useMemo(() => {
    function z(B) {
      v === "auto" && Kg(B.nativeEvent) && (_.current = !b);
    }
    function J(B) {
      _.current = v, v === "auto" && qg(B.nativeEvent) && (_.current = !0);
    }
    return {
      onKeyDown(B) {
        const K = n.select("open");
        L.current = !1;
        const ie = B.key.startsWith("Arrow"), ge = R6(B.key, ne(), h), ue = Xs(B.key, R), Se = (m ? ge : ue) || B.key === "Enter" || B.key.trim() === "";
        if (b && K)
          return se(B);
        if (!(!K && !y && ie)) {
          if (Se) {
            const ve = Xs(B.key, ne());
            A.current = m && ve ? null : B.key;
          }
          if (m) {
            ge && (Lt(B), K ? (V.current = vl(l, te.current), $(B)) : n.setOpen(!0, De(Fr, B.nativeEvent, B.currentTarget)));
            return;
          }
          ue && (X.current != null && (V.current = X.current), Lt(B), !K && y ? n.setOpen(!0, De(Fr, B.nativeEvent, B.currentTarget)) : se(B), K && $(B));
        }
      },
      onFocus(B) {
        n.select("open") && !b && (V.current = -1, $(B));
      },
      onPointerDown: J,
      onPointerEnter: J,
      onMouseDown: z,
      onClick: z
    };
  }, [se, te, v, l, m, $, n, y, R, ne, h, X, b]), he = x.useMemo(() => ({
    ...pe,
    ...ce
  }), [pe, ce]);
  return x.useMemo(() => u ? {
    reference: he,
    floating: xe,
    item: fe,
    trigger: ce
  } : {}, [u, he, xe, ce, fe]);
}
const N6 = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function hd(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingId"), i = n.useState("domReferenceElement"), s = n.useState("floatingElement"), {
    role: l = "dialog"
  } = e, a = Do(), c = i?.id || a, u = x.useMemo(() => Wi(s)?.id || r, [s, r]), d = N6.get(l) ?? l, p = bo() != null, m = x.useMemo(() => d === "tooltip" || l === "label" ? St : {
    "aria-haspopup": d === "alertdialog" ? "dialog" : d,
    "aria-expanded": "false",
    ...d === "listbox" && {
      role: "combobox"
    },
    ...d === "menu" && p && {
      role: "menuitem"
    },
    ...l === "select" && {
      "aria-autocomplete": "none"
    },
    ...l === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [d, p, l]), h = x.useMemo(() => d === "tooltip" || l === "label" ? {
    [`aria-${l === "label" ? "labelledby" : "describedby"}`]: o ? u : void 0
  } : {
    ...m,
    "aria-expanded": o ? "true" : "false",
    "aria-controls": o ? u : void 0,
    ...d === "menu" && {
      id: c
    }
  }, [d, u, o, c, l, m]), b = x.useMemo(() => {
    const C = {
      id: u,
      ...d && {
        role: d
      }
    };
    return d === "tooltip" || l === "label" ? C : {
      ...C,
      ...d === "menu" && {
        "aria-labelledby": c
      }
    };
  }, [d, u, c, l]), v = x.useCallback(({
    active: C,
    selected: y
  }) => {
    const w = {
      role: "option",
      ...C && {
        id: `${u}-fui-option`
      }
    };
    switch (l) {
      case "select":
      case "combobox":
        return {
          ...w,
          "aria-selected": y
        };
    }
    return {};
  }, [u, l]);
  return x.useMemo(() => ({
    reference: h,
    floating: b,
    item: v,
    trigger: m
  }), [h, b, m, v]);
}
function bd(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, r = n.useState("open"), {
    listRef: i,
    elementsRef: s,
    activeIndex: l,
    onMatch: a,
    onTypingChange: c,
    enabled: u = !0,
    resetMs: d = 750,
    selectedIndex: f = null
  } = e, p = Dt(), m = x.useRef(""), h = x.useRef(f ?? l ?? -1), b = x.useRef(null);
  Ne(() => {
    !r && f !== null || (p.clear(), b.current = null, m.current !== "" && (m.current = ""));
  }, [r, f, p]), Ne(() => {
    r && m.current === "" && (h.current = f ?? l ?? -1);
  }, [r, f, l]);
  const v = Ce((S) => {
    S ? o.current.typing || (o.current.typing = S, c?.(S)) : o.current.typing && (o.current.typing = S, c?.(S));
  }), C = Ce((S) => {
    function E(O) {
      const _ = s?.current[O];
      return !_ || sa(_);
    }
    function N(O, _, V = 0) {
      if (O.length === 0)
        return -1;
      const A = (V % O.length + O.length) % O.length, L = _.toLocaleLowerCase();
      for (let $ = 0; $ < O.length; $ += 1) {
        const Y = (A + $) % O.length;
        if (!(!O[Y]?.toLocaleLowerCase().startsWith(L) || !E(Y)))
          return Y;
      }
      return -1;
    }
    const I = i.current;
    if (m.current.length > 0 && S.key === " " && (Lt(S), v(!0)), m.current.length > 0 && m.current[0] !== " " && N(I, m.current) === -1 && S.key !== " " && v(!1), I == null || // Character key.
    S.key.length !== 1 || // Modifier key.
    S.ctrlKey || S.metaKey || S.altKey)
      return;
    r && S.key !== " " && (Lt(S), v(!0));
    const T = m.current === "";
    T && (h.current = f ?? l ?? -1), I.every((O) => O ? O[0]?.toLocaleLowerCase() !== O[1]?.toLocaleLowerCase() : !0) && m.current === S.key && (m.current = "", h.current = b.current), m.current += S.key, p.start(d, () => {
      m.current = "", h.current = b.current, v(!1);
    });
    const M = ((T ? f ?? l ?? -1 : h.current) ?? 0) + 1, D = N(I, m.current, M);
    D !== -1 ? (a?.(D), b.current = D) : S.key !== " " && (m.current = "", v(!1));
  }), y = Ce((S) => {
    const E = S.relatedTarget, N = n.select("domReferenceElement"), I = n.select("floatingElement"), T = Fe(N, E), k = Fe(I, E);
    T || k || (p.clear(), m.current = "", h.current = b.current, v(!1));
  }), w = x.useMemo(() => ({
    onKeyDown: C,
    onBlur: y
  }), [C, y]), R = x.useMemo(() => ({
    onKeyDown: C,
    onBlur: y
  }), [C, y]);
  return x.useMemo(() => u ? {
    reference: w,
    floating: R
  } : {}, [u, w, R]);
}
const mp = 0.1, k6 = mp * mp, Nt = 0.5;
function Qs(t, e, n, o, r, i) {
  return o >= e != i >= e && t <= (r - n) * (e - o) / (i - o) + n;
}
function Js(t, e, n, o, r, i, s, l, a, c) {
  let u = !1;
  return Qs(t, e, n, o, r, i) && (u = !u), Qs(t, e, r, i, s, l) && (u = !u), Qs(t, e, s, l, a, c) && (u = !u), Qs(t, e, a, c, n, o) && (u = !u), u;
}
function M6(t, e, n) {
  return t >= n.x && t <= n.x + n.width && e >= n.y && e <= n.y + n.height;
}
function el(t, e, n, o, r, i) {
  const s = Math.min(n, r), l = Math.max(n, r), a = Math.min(o, i), c = Math.max(o, i);
  return t >= s && t <= l && e >= a && e <= c;
}
function ps(t = {}) {
  const {
    blockPointerEvents: e = !1
  } = t, n = new xn(), o = ({
    x: r,
    y: i,
    placement: s,
    elements: l,
    onClose: a,
    nodeId: c,
    tree: u
  }) => {
    const d = s?.split("-")[0];
    let f = !1, p = null, m = null, h = typeof performance < "u" ? performance.now() : 0;
    function b(C, y) {
      const w = performance.now(), R = w - h;
      if (p === null || m === null || R === 0)
        return p = C, m = y, h = w, !1;
      const S = C - p, E = y - m, N = S * S + E * E, I = R * R * k6;
      return p = C, m = y, h = w, N < I;
    }
    function v() {
      n.clear(), a();
    }
    return function(y) {
      n.clear();
      const w = l.domReference, R = l.floating;
      if (!w || !R || d == null || r == null || i == null)
        return;
      const {
        clientX: S,
        clientY: E
      } = y, N = bt(y), I = y.type === "mouseleave", T = Fe(R, N), k = Fe(w, N);
      if (T && (f = !0, !I))
        return;
      if (k && (f = !1, !I)) {
        f = !0;
        return;
      }
      if (I && pt(y.relatedTarget) && Fe(R, y.relatedTarget))
        return;
      function P() {
        return !!(u && co(u.nodesRef.current, c).length > 0);
      }
      function M() {
        P() || v();
      }
      if (P())
        return;
      const D = w.getBoundingClientRect(), O = R.getBoundingClientRect(), _ = r > O.right - O.width / 2, V = i > O.bottom - O.height / 2, A = O.width > D.width, L = O.height > D.height, $ = (A ? D : O).left, Y = (A ? D : O).right, G = (L ? D : O).top, j = (L ? D : O).bottom;
      if (d === "top" && i >= D.bottom - 1 || d === "bottom" && i <= D.top + 1 || d === "left" && r >= D.right - 1 || d === "right" && r <= D.left + 1) {
        M();
        return;
      }
      let Z = !1;
      switch (d) {
        case "top":
          Z = el(S, E, $, D.top + 1, Y, O.bottom - 1);
          break;
        case "bottom":
          Z = el(S, E, $, O.top + 1, Y, D.bottom - 1);
          break;
        case "left":
          Z = el(S, E, O.right - 1, j, D.left + 1, G);
          break;
        case "right":
          Z = el(S, E, D.right - 1, j, O.left + 1, G);
          break;
      }
      if (Z)
        return;
      if (f && !M6(S, E, D)) {
        M();
        return;
      }
      if (!I && b(S, E)) {
        M();
        return;
      }
      let U = !1;
      switch (d) {
        case "top": {
          const q = A ? Nt / 2 : Nt * 4, te = A || _ ? r + q : r - q, H = A ? r - q : _ ? r + q : r - q, X = i + Nt + 1, ee = _ || A ? O.bottom - Nt : O.top, le = _ ? A ? O.bottom - Nt : O.top : O.bottom - Nt;
          U = Js(S, E, te, X, H, X, O.left, ee, O.right, le);
          break;
        }
        case "bottom": {
          const q = A ? Nt / 2 : Nt * 4, te = A || _ ? r + q : r - q, H = A ? r - q : _ ? r + q : r - q, X = i - Nt, ee = _ || A ? O.top + Nt : O.bottom, le = _ ? A ? O.top + Nt : O.bottom : O.top + Nt;
          U = Js(S, E, te, X, H, X, O.left, ee, O.right, le);
          break;
        }
        case "left": {
          const q = L ? Nt / 2 : Nt * 4, te = L || V ? i + q : i - q, H = L ? i - q : V ? i + q : i - q, X = r + Nt + 1, ee = V || L ? O.right - Nt : O.left, le = V ? L ? O.right - Nt : O.left : O.right - Nt;
          U = Js(S, E, ee, O.top, le, O.bottom, X, te, X, H);
          break;
        }
        case "right": {
          const q = L ? Nt / 2 : Nt * 4, te = L || V ? i + q : i - q, H = L ? i - q : V ? i + q : i - q, X = r - Nt, ee = V || L ? O.left + Nt : O.right, le = V ? L ? O.left + Nt : O.right : O.left + Nt;
          U = Js(S, E, X, te, X, H, ee, O.top, le, O.bottom);
          break;
        }
      }
      U ? f || n.start(40, M) : M();
    };
  };
  return o.__options = {
    ...t,
    blockPointerEvents: e
  }, o;
}
const $h = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && ($h.displayName = "ToolbarRootContext");
function vd(t) {
  return x.useContext($h);
}
const zr = "ArrowUp", cr = "ArrowDown", ji = "ArrowLeft", Br = "ArrowRight", ms = "Home", gs = "End", Hh = /* @__PURE__ */ new Set([ji, Br]), P6 = /* @__PURE__ */ new Set([ji, Br, ms, gs]), zh = /* @__PURE__ */ new Set([zr, cr]), I6 = /* @__PURE__ */ new Set([zr, cr, ms, gs]), Bh = /* @__PURE__ */ new Set([...Hh, ...zh]), T6 = /* @__PURE__ */ new Set([...Bh, ms, gs]), hs = /* @__PURE__ */ new Set([zr, cr, ji, Br, ms, gs]), Wh = "Shift", O6 = "Control", D6 = "Alt", _6 = "Meta", V6 = /* @__PURE__ */ new Set([Wh, O6, D6, _6]);
function A6(t) {
  return xt(t) && t.tagName === "INPUT";
}
function gp(t) {
  return !!(A6(t) && t.selectionStart != null || xt(t) && t.tagName === "TEXTAREA");
}
function hp(t, e, n, o) {
  if (!t || !e || !e.scrollTo)
    return;
  let r = t.scrollLeft, i = t.scrollTop;
  const s = t.clientWidth < t.scrollWidth, l = t.clientHeight < t.scrollHeight;
  if (s && o !== "vertical") {
    const a = bp(t, e, "left"), c = tl(t), u = tl(e);
    n === "ltr" && (a + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight ? r = a + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight : a - u.scrollMarginLeft < t.scrollLeft + c.scrollPaddingLeft && (r = a - u.scrollMarginLeft - c.scrollPaddingLeft)), n === "rtl" && (a - u.scrollMarginRight < t.scrollLeft + c.scrollPaddingLeft ? r = a - u.scrollMarginLeft - c.scrollPaddingLeft : a + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight && (r = a + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight));
  }
  if (l && o !== "horizontal") {
    const a = bp(t, e, "top"), c = tl(t), u = tl(e);
    a - u.scrollMarginTop < t.scrollTop + c.scrollPaddingTop ? i = a - u.scrollMarginTop - c.scrollPaddingTop : a + e.offsetHeight + u.scrollMarginBottom > t.scrollTop + t.clientHeight - c.scrollPaddingBottom && (i = a + e.offsetHeight + u.scrollMarginBottom - t.clientHeight + c.scrollPaddingBottom);
  }
  t.scrollTo({
    left: r,
    top: i,
    behavior: "auto"
  });
}
function bp(t, e, n) {
  const o = n === "left" ? "offsetLeft" : "offsetTop";
  let r = 0;
  for (; e.offsetParent && (r += e[o], e.offsetParent !== t); )
    e = e.offsetParent;
  return r;
}
function tl(t) {
  const e = getComputedStyle(t);
  return {
    scrollMarginTop: parseFloat(e.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(e.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(e.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(e.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(e.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(e.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(e.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(e.scrollPaddingLeft) || 0
  };
}
function Rr(t) {
  return t === "starting" ? $8 : St;
}
const L6 = {
  ...kn,
  ...zt
}, Uh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    finalFocus: s,
    ...l
  } = e, {
    store: a
  } = Qn(), {
    side: c,
    align: u
  } = ts(), d = vd() != null, f = a.useState("open"), p = a.useState("transitionStatus"), m = a.useState("popupProps"), h = a.useState("mounted"), b = a.useState("instantType"), v = a.useState("activeTriggerElement"), C = a.useState("parent"), y = a.useState("lastOpenChangeReason"), w = a.useState("rootId"), R = a.useState("floatingRootContext"), S = a.useState("floatingTreeRoot"), E = a.useState("closeDelay"), N = a.useState("activeTriggerElement"), I = C.type === "context-menu";
  Yt({
    open: f,
    ref: a.context.popupRef,
    onComplete() {
      f && a.context.onOpenChangeComplete?.(!0);
    }
  }), x.useEffect(() => {
    function _(V) {
      a.setOpen(!1, De(V.reason, V.domEvent));
    }
    return S.events.on("close", _), () => {
      S.events.off("close", _);
    };
  }, [S.events, a]);
  const T = a.useState("hoverEnabled"), k = a.useState("disabled");
  ua(R, {
    enabled: T && !k && !I && C.type !== "menubar",
    closeDelay: E
  });
  const P = {
    transitionStatus: p,
    side: c,
    align: u,
    open: f,
    nested: C.type === "menu",
    instant: b
  }, M = x.useCallback((_) => {
    a.set("popupElement", _);
  }, [a]), D = Le("div", e, {
    state: P,
    ref: [n, a.context.popupRef, M],
    stateAttributesMapping: L6,
    props: [m, {
      onKeyDown(_) {
        d && hs.has(_.key) && _.stopPropagation();
      }
    }, Rr(p), l, {
      "data-rootownerid": w
    }]
  });
  let O = C.type === void 0 || I;
  return (v || C.type === "menubar" && y !== ns) && (O = !0), /* @__PURE__ */ g(ni, {
    context: R,
    modal: I,
    disabled: !h,
    returnFocus: s === void 0 ? O : s,
    initialFocus: C.type !== "menu",
    restoreFocus: !0,
    externalTree: C.type !== "menubar" ? S : void 0,
    previousFocusableElement: N,
    nextFocusableElement: C.type === void 0 ? a.context.triggerFocusTargetRef : void 0,
    beforeContentFocusGuardRef: C.type === void 0 ? a.context.beforeContentFocusGuardRef : void 0,
    children: D
  });
});
process.env.NODE_ENV !== "production" && (Uh.displayName = "MenuPopup");
const yd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (yd.displayName = "MenuPortalContext");
function F6() {
  const t = x.useContext(yd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : et(32));
  return t;
}
const Gh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = Qn();
  return i.useState("mounted") || o ? /* @__PURE__ */ g(yd.Provider, {
    value: o,
    children: /* @__PURE__ */ g(ti, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Gh.displayName = "MenuPortal");
function Er(t) {
  return Su(19) ? t : t ? "true" : void 0;
}
const Yh = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Yh.displayName = "DirectionContext");
function bs() {
  return x.useContext(Yh)?.direction ?? "ltr";
}
const $6 = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: s,
      elements: l,
      middlewareData: a
    } = e, {
      element: c,
      padding: u = 0,
      offsetParent: d = "real"
    } = To(t, e) || {};
    if (c == null)
      return {};
    const f = oh(u), p = {
      x: n,
      y: o
    }, m = Ku(r), h = ju(m), b = await s.getDimensions(c), v = m === "y", C = v ? "top" : "left", y = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", R = i.reference[h] + i.reference[m] - p[m] - i.floating[h], S = p[m] - i.reference[m], E = d === "real" ? await s.getOffsetParent?.(c) : l.floating;
    let N = l.floating[w] || i.floating[h];
    (!N || !await s.isElement?.(E)) && (N = l.floating[w] || i.floating[h]);
    const I = R / 2 - S / 2, T = N / 2 - b[h] / 2 - 1, k = Math.min(f[C], T), P = Math.min(f[y], T), M = k, D = N - b[h] - P, O = N / 2 - b[h] / 2 + I, _ = Jc(M, O, D), V = !a.arrow && er(r) != null && O !== _ && i.reference[h] / 2 - (O < M ? k : P) - b[h] / 2 < 0, A = V ? O < M ? O - M : O - D : 0;
    return {
      [m]: p[m] + A,
      data: {
        [m]: _,
        centerOffset: O - _ - A,
        ...V && {
          alignmentOffset: A
        }
      },
      reset: V
    };
  }
}), H6 = (t, e) => ({
  ...$6(t),
  options: [t, e]
}), z6 = {
  name: "hide",
  async fn(t) {
    const {
      width: e,
      height: n,
      x: o,
      y: r
    } = t.rects.reference, i = e === 0 && n === 0 && o === 0 && r === 0;
    return {
      data: {
        referenceHidden: (await F9().fn(t)).data?.referenceHidden || i
      }
    };
  }
}, Cl = {
  sideX: "left",
  sideY: "top"
}, fa = {
  name: "adaptiveOrigin",
  async fn(t) {
    const {
      x: e,
      y: n,
      rects: {
        floating: o
      },
      elements: {
        floating: r
      },
      platform: i,
      strategy: s,
      placement: l
    } = t, a = Ct(r), c = a.getComputedStyle(r);
    if (!(c.transitionDuration !== "0s" && c.transitionDuration !== ""))
      return {
        x: e,
        y: n,
        data: Cl
      };
    const d = await i.getOffsetParent?.(r);
    let f = {
      width: 0,
      height: 0
    };
    if (s === "fixed" && a?.visualViewport)
      f = {
        width: a.visualViewport.width,
        height: a.visualViewport.height
      };
    else if (d === a) {
      const C = Je(r);
      f = {
        width: C.documentElement.clientWidth,
        height: C.documentElement.clientHeight
      };
    } else await i.isElement?.(d) && (f = await i.getDimensions(d));
    const p = yn(l);
    let m = e, h = n;
    p === "left" && (m = f.width - (e + o.width)), p === "top" && (h = f.height - (n + o.height));
    const b = p === "left" ? "right" : Cl.sideX, v = p === "top" ? "bottom" : Cl.sideY;
    return {
      x: m,
      y: h,
      data: {
        sideX: b,
        sideY: v
      }
    };
  }
};
function jh(t, e, n) {
  const o = t === "inline-start" || t === "inline-end";
  return {
    top: "top",
    right: o ? n ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: o ? n ? "inline-end" : "inline-start" : "left"
  }[e];
}
function vp(t, e, n) {
  const {
    rects: o,
    placement: r
  } = t;
  return {
    side: jh(e, yn(r), n),
    align: er(r) || "center",
    anchor: {
      width: o.reference.width,
      height: o.reference.height
    },
    positioner: {
      width: o.floating.width,
      height: o.floating.height
    }
  };
}
function oi(t) {
  const {
    // Public parameters
    anchor: e,
    positionMethod: n = "absolute",
    side: o = "bottom",
    sideOffset: r = 0,
    align: i = "center",
    alignOffset: s = 0,
    collisionBoundary: l,
    collisionPadding: a = 5,
    sticky: c = !1,
    arrowPadding: u = 5,
    disableAnchorTracking: d = !1,
    // Private parameters
    keepMounted: f = !1,
    floatingRootContext: p,
    mounted: m,
    collisionAvoidance: h,
    shiftCrossAxis: b = !1,
    nodeId: v,
    adaptiveOrigin: C,
    lazyFlip: y = !1,
    externalTree: w
  } = t, [R, S] = x.useState(null);
  !m && R !== null && S(null);
  const E = h.side || "flip", N = h.align || "flip", I = h.fallbackAxisSide || "end", T = typeof e == "function" ? e : void 0, k = Ce(T), P = T ? k : e, M = Ft(e), D = Ft(m), _ = bs() === "rtl", V = R || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": _ ? "left" : "right",
    "inline-start": _ ? "right" : "left"
  }[o], A = i === "center" ? V : `${V}-${i}`;
  let L = a;
  const $ = 1, Y = o === "bottom" ? $ : 0, G = o === "top" ? $ : 0, j = o === "right" ? $ : 0, Z = o === "left" ? $ : 0;
  typeof L == "number" ? L = {
    top: L + Y,
    right: L + Z,
    bottom: L + G,
    left: L + j
  } : L && (L = {
    top: (L.top || 0) + Y,
    right: (L.right || 0) + Z,
    bottom: (L.bottom || 0) + G,
    left: (L.left || 0) + j
  });
  const U = {
    boundary: l === "clipping-ancestors" ? "clippingAncestors" : l,
    padding: L
  }, q = x.useRef(null), te = Ft(r), H = Ft(s), le = [D9(($e) => {
    const Ee = vp($e, o, _), Ve = typeof te.current == "function" ? te.current(Ee) : te.current, Me = typeof H.current == "function" ? H.current(Ee) : H.current;
    return {
      mainAxis: Ve,
      crossAxis: Me,
      alignmentAxis: Me
    };
  }, [typeof r != "function" ? r : 0, typeof s != "function" ? s : 0, _, o])], Q = N === "none" && E !== "shift", re = !Q && (c || b || E === "shift"), fe = E === "none" ? null : A9({
    ...U,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: L.top + $,
      right: L.right + $,
      bottom: L.bottom + $,
      left: L.left + $
    },
    mainAxis: !b && E === "flip",
    crossAxis: N === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: I
  }), ne = Q ? null : _9(($e) => {
    const Ee = Je($e.elements.floating).documentElement;
    return {
      ...U,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: b ? {
        x: 0,
        y: 0,
        width: Ee.clientWidth,
        height: Ee.clientHeight
      } : void 0,
      mainAxis: N !== "none",
      crossAxis: re,
      limiter: c || b ? void 0 : V9((Ve) => {
        if (!q.current)
          return {};
        const {
          width: Me,
          height: He
        } = q.current.getBoundingClientRect(), ze = _n(yn(Ve.placement)), Oe = ze === "y" ? Me : He, wt = ze === "y" ? L.left + L.right : L.top + L.bottom;
        return {
          offset: Oe / 2 + wt / 2
        };
      })
    };
  }, [U, c, b, L, N]);
  E === "shift" || N === "shift" || i === "center" ? le.push(ne, fe) : le.push(fe, ne), le.push(L9({
    ...U,
    apply({
      elements: {
        floating: $e
      },
      availableWidth: Ee,
      availableHeight: Ve,
      rects: Me
    }) {
      if (!D.current)
        return;
      const He = $e.style;
      He.setProperty("--available-width", `${Ee}px`), He.setProperty("--available-height", `${Ve}px`);
      const ze = Ct($e).devicePixelRatio || 1, {
        x: Oe,
        y: wt,
        width: dt,
        height: we
      } = Me.reference, ke = (Math.round((Oe + dt) * ze) - Math.round(Oe * ze)) / ze, Ae = (Math.round((wt + we) * ze) - Math.round(wt * ze)) / ze;
      He.setProperty("--anchor-width", `${ke}px`), He.setProperty("--anchor-height", `${Ae}px`);
    }
  }), H6(() => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: q.current || Je(q.current).createElement("div"),
    padding: u,
    offsetParent: "floating"
  }), [u]), {
    name: "transformOrigin",
    fn($e) {
      const {
        elements: Ee,
        middlewareData: Ve,
        placement: Me,
        rects: He,
        y: ze
      } = $e, Oe = yn(Me), wt = _n(Oe), dt = q.current, we = Ve.arrow?.x || 0, ke = Ve.arrow?.y || 0, Ae = dt?.clientWidth || 0, We = dt?.clientHeight || 0, it = we + Ae / 2, je = ke + We / 2, ft = Math.abs(Ve.shift?.y || 0), Ze = He.reference.height / 2, Ke = typeof r == "function" ? r(vp($e, o, _)) : r, nt = ft > Ke, st = {
        top: `${it}px calc(100% + ${Ke}px)`,
        bottom: `${it}px ${-Ke}px`,
        left: `calc(100% + ${Ke}px) ${je}px`,
        right: `${-Ke}px ${je}px`
      }[Oe], mt = `${it}px ${He.reference.y + Ze - ze}px`;
      return Ee.floating.style.setProperty("--transform-origin", re && wt === "y" && nt ? mt : st), {};
    }
  }, z6, C), Ne(() => {
    !m && p && p.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null,
      positionReference: null
    });
  }, [m, p]);
  const se = x.useMemo(() => ({
    elementResize: !d && typeof ResizeObserver < "u",
    layoutShift: !d && typeof IntersectionObserver < "u"
  }), [d]), {
    refs: pe,
    elements: xe,
    x: ce,
    y: he,
    middlewareData: z,
    update: J,
    placement: B,
    context: K,
    isPositioned: ie,
    floatingStyles: ge
  } = C6({
    rootContext: p,
    open: f ? m : void 0,
    placement: A,
    middleware: le,
    strategy: n,
    whileElementsMounted: f ? void 0 : (...$e) => np(...$e, se),
    nodeId: v,
    externalTree: w
  }), {
    sideX: ue,
    sideY: Se
  } = z.adaptiveOrigin || Cl, ve = ie ? n : "fixed", de = x.useMemo(() => {
    const $e = C ? {
      position: ve,
      [ue]: ce,
      [Se]: he
    } : {
      position: ve,
      ...ge
    };
    return ie || ($e.opacity = 0), $e;
  }, [C, ve, ue, ce, Se, he, ge, ie]), me = x.useRef(null);
  Ne(() => {
    if (!m)
      return;
    const $e = M.current, Ee = typeof $e == "function" ? $e() : $e, Me = (yp(Ee) ? Ee.current : Ee) || null || null;
    Me !== me.current && (pe.setPositionReference(Me), me.current = Me);
  }, [m, pe, P, M]), x.useEffect(() => {
    if (!m)
      return;
    const $e = M.current;
    typeof $e != "function" && yp($e) && $e.current !== me.current && (pe.setPositionReference($e.current), me.current = $e.current);
  }, [m, pe, P, M]), x.useEffect(() => {
    if (f && m && xe.domReference && xe.floating)
      return np(xe.domReference, xe.floating, J, se);
  }, [f, m, xe, J, se]);
  const Re = yn(B), Ie = jh(o, Re, _), Pe = er(B) || "center", _e = !!z.hide?.referenceHidden;
  Ne(() => {
    y && m && ie && S(Re);
  }, [y, m, ie, Re]);
  const Ye = x.useMemo(() => ({
    position: "absolute",
    top: z.arrow?.y,
    left: z.arrow?.x
  }), [z.arrow]), qe = z.arrow?.centerOffset !== 0;
  return x.useMemo(() => ({
    positionerStyles: de,
    arrowStyles: Ye,
    arrowRef: q,
    arrowUncentered: qe,
    side: Ie,
    align: Pe,
    physicalSide: Re,
    anchorHidden: _e,
    refs: pe,
    context: K,
    isPositioned: ie,
    update: J
  }), [de, Ye, q, qe, Ie, Pe, Re, _e, pe, K, ie, J]);
}
function yp(t) {
  return t != null && "current" in t;
}
function ri(t) {
  const {
    children: e,
    elementsRef: n,
    labelsRef: o,
    onMapChange: r
  } = t, i = Ce(r), s = x.useRef(0), l = It(W6).current, a = It(B6).current, [c, u] = x.useState(0), d = x.useRef(c), f = Ce((v, C) => {
    a.set(v, C ?? null), d.current += 1, u(d.current);
  }), p = Ce((v) => {
    a.delete(v), d.current += 1, u(d.current);
  }), m = x.useMemo(() => {
    const v = /* @__PURE__ */ new Map();
    return Array.from(a.keys()).filter((y) => y.isConnected).sort(U6).forEach((y, w) => {
      const R = a.get(y) ?? {};
      v.set(y, {
        ...R,
        index: w
      });
    }), v;
  }, [a, c]);
  Ne(() => {
    if (typeof MutationObserver != "function" || m.size === 0)
      return;
    const v = new MutationObserver((C) => {
      const y = /* @__PURE__ */ new Set(), w = (R) => y.has(R) ? y.delete(R) : y.add(R);
      C.forEach((R) => {
        R.removedNodes.forEach(w), R.addedNodes.forEach(w);
      }), y.size === 0 && (d.current += 1, u(d.current));
    });
    return m.forEach((C, y) => {
      y.parentElement && v.observe(y.parentElement, {
        childList: !0
      });
    }), () => {
      v.disconnect();
    };
  }, [m]), Ne(() => {
    d.current === c && (n.current.length !== m.size && (n.current.length = m.size), o && o.current.length !== m.size && (o.current.length = m.size), s.current = m.size), i(m);
  }, [i, m, n, o, c]), Ne(() => () => {
    n.current = [];
  }, [n]), Ne(() => () => {
    o && (o.current = []);
  }, [o]);
  const h = Ce((v) => (l.add(v), () => {
    l.delete(v);
  }));
  Ne(() => {
    l.forEach((v) => v(m));
  }, [l, m]);
  const b = x.useMemo(() => ({
    register: f,
    unregister: p,
    subscribeMapChange: h,
    elementsRef: n,
    labelsRef: o,
    nextIndexRef: s
  }), [f, p, h, n, o, s]);
  return /* @__PURE__ */ g(zu.Provider, {
    value: b,
    children: e
  });
}
function B6() {
  return /* @__PURE__ */ new Map();
}
function W6() {
  return /* @__PURE__ */ new Set();
}
function U6(t, e) {
  const n = t.compareDocumentPosition(e);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const ii = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    cutout: o,
    ...r
  } = e;
  let i;
  if (o) {
    const s = o.getBoundingClientRect();
    i = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${s.left}px ${s.top}px,${s.left}px ${s.bottom}px,${s.right}px ${s.bottom}px,${s.right}px ${s.top}px,${s.left}px ${s.top}px)`;
  }
  return /* @__PURE__ */ g("div", {
    ref: n,
    role: "presentation",
    "data-base-ui-inert": "",
    ...r,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: i
    }
  });
});
process.env.NODE_ENV !== "production" && (ii.displayName = "InternalBackdrop");
function si(t, e, {
  styles: n,
  transitionStatus: o,
  props: r,
  refs: i,
  hidden: s,
  inert: l = !1
}) {
  const a = {
    ...n
  };
  return l && (a.pointerEvents = "none"), Le("div", t, {
    state: e,
    ref: i,
    props: [{
      role: "presentation",
      hidden: s,
      style: a
    }, Rr(o), r],
    stateAttributesMapping: kn
  });
}
let xp = {}, Cp = {}, wp = "";
function G6(t) {
  if (typeof document > "u")
    return !1;
  const e = Je(t);
  return Ct(e).innerWidth - e.documentElement.clientWidth > 0;
}
function Y6(t) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const n = Je(t), o = n.documentElement, r = n.body, i = Qo(o) ? o : r, s = i.style.overflowY, l = o.style.scrollbarGutter;
  o.style.scrollbarGutter = "stable", i.style.overflowY = "scroll";
  const a = i.offsetWidth;
  i.style.overflowY = "hidden";
  const c = i.offsetWidth;
  return i.style.overflowY = s, o.style.scrollbarGutter = l, a === c;
}
function j6(t) {
  const e = Je(t), n = e.documentElement, o = e.body, r = Qo(n) ? n : o, i = {
    overflowY: r.style.overflowY,
    overflowX: r.style.overflowX
  };
  return Object.assign(r.style, {
    overflowY: "hidden",
    overflowX: "hidden"
  }), () => {
    Object.assign(r.style, i);
  };
}
function K6(t) {
  const e = Je(t), n = e.documentElement, o = e.body, r = Ct(n);
  let i = 0, s = 0, l = !1;
  const a = Vt.create();
  if (Fu && (r.visualViewport?.scale ?? 1) !== 1)
    return () => {
    };
  function c() {
    const p = r.getComputedStyle(n), m = r.getComputedStyle(o), v = (p.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    i = n.scrollTop, s = n.scrollLeft, xp = {
      scrollbarGutter: n.style.scrollbarGutter,
      overflowY: n.style.overflowY,
      overflowX: n.style.overflowX
    }, wp = n.style.scrollBehavior, Cp = {
      position: o.style.position,
      height: o.style.height,
      width: o.style.width,
      boxSizing: o.style.boxSizing,
      overflowY: o.style.overflowY,
      overflowX: o.style.overflowX,
      scrollBehavior: o.style.scrollBehavior
    };
    const C = n.scrollHeight > n.clientHeight, y = n.scrollWidth > n.clientWidth, w = p.overflowY === "scroll" || m.overflowY === "scroll", R = p.overflowX === "scroll" || m.overflowX === "scroll", S = Math.max(0, r.innerWidth - o.clientWidth), E = Math.max(0, r.innerHeight - o.clientHeight), N = parseFloat(m.marginTop) + parseFloat(m.marginBottom), I = parseFloat(m.marginLeft) + parseFloat(m.marginRight), T = Qo(n) ? n : o;
    if (l = Y6(t), l) {
      n.style.scrollbarGutter = v, T.style.overflowY = "hidden", T.style.overflowX = "hidden";
      return;
    }
    Object.assign(n.style, {
      scrollbarGutter: v,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (C || w) && (n.style.overflowY = "scroll"), (y || R) && (n.style.overflowX = "scroll"), Object.assign(o.style, {
      position: "relative",
      height: N || E ? `calc(100dvh - ${N + E}px)` : "100dvh",
      width: I || S ? `calc(100vw - ${I + S}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), o.scrollTop = i, o.scrollLeft = s, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
  }
  function u() {
    Object.assign(n.style, xp), Object.assign(o.style, Cp), l || (n.scrollTop = i, n.scrollLeft = s, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = wp);
  }
  function d() {
    u(), a.request(c);
  }
  c();
  const f = at(r, "resize", d);
  return () => {
    a.cancel(), u(), typeof r.removeEventListener == "function" && f();
  };
}
class q6 {
  lockCount = 0;
  restore = null;
  timeoutLock = xn.create();
  timeoutUnlock = xn.create();
  acquire(e) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(e)), this.release;
  }
  release = () => {
    this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
  };
  unlock = () => {
    this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
  };
  lock(e) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const o = Je(e).documentElement, r = Ct(o).getComputedStyle(o).overflowY;
    if (r === "hidden" || r === "clip") {
      this.restore = yt;
      return;
    }
    const i = $u || !G6(e);
    this.restore = i ? j6(e) : K6(e);
  }
}
const Z6 = new q6();
function Kh(t = !0, e = null) {
  Ne(() => {
    if (t)
      return Z6.acquire(e);
  }, [t, e]);
}
const X6 = 20;
function pa(t, e, n, o) {
  const [r, i] = x.useState(!1);
  Ne(() => {
    if (!t || !e || n == null) {
      i(!1);
      return;
    }
    const s = Je(n).documentElement.clientWidth, l = n.offsetWidth;
    i(s > 0 && l > 0 && l >= s - X6);
  }, [t, e, n]), Kh(t && (!e || r), o);
}
const qh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: i,
    render: s,
    side: l,
    align: a,
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = Qu,
    style: v,
    ...C
  } = e, {
    store: y
  } = Qn(), w = F6(), R = oa(!0), S = y.useState("parent"), E = y.useState("floatingRootContext"), N = y.useState("floatingTreeRoot"), I = y.useState("mounted"), T = y.useState("open"), k = y.useState("modal"), P = y.useState("openMethod"), M = y.useState("activeTriggerElement"), D = y.useState("transitionStatus"), O = y.useState("positionerElement"), _ = y.useState("instantType"), V = y.useState("hasViewport"), A = y.useState("lastOpenChangeReason"), L = y.useState("floatingNodeId"), $ = y.useState("floatingParentNodeId"), Y = E.useState("domReferenceElement"), G = x.useRef(null), j = Ql(O, !1, !1);
  let Z = o, U = c, q = u, te = a, H = b;
  S.type === "context-menu" && (Z = o ?? S.context?.anchor, te = te ?? "start", !l && te !== "center" && (q = e.alignOffset ?? 2, U = e.sideOffset ?? -5));
  let X = l, ee = te;
  S.type === "menu" ? (X = X ?? "inline-end", ee = ee ?? "start", H = e.collisionAvoidance ?? la) : S.type === "menubar" && (X = X ?? "bottom", ee = ee ?? "start");
  const le = S.type === "context-menu", Q = oi({
    anchor: Z,
    floatingRootContext: E,
    positionMethod: R ? "fixed" : r,
    mounted: I,
    side: X,
    sideOffset: U,
    align: ee,
    alignOffset: q,
    arrowPadding: le ? 0 : p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    nodeId: L,
    keepMounted: w,
    disableAnchorTracking: h,
    collisionAvoidance: H,
    shiftCrossAxis: le && !("side" in H && H.side === "flip"),
    externalTree: N,
    adaptiveOrigin: V ? fa : void 0
  });
  x.useEffect(() => {
    function he(z) {
      z.open && (z.parentNodeId === L && y.set("hoverEnabled", !1), z.nodeId !== L && z.parentNodeId === y.select("floatingParentNodeId") && y.setOpen(!1, De(Ti)));
    }
    return N.events.on("menuopenchange", he), () => {
      N.events.off("menuopenchange", he);
    };
  }, [y, N.events, L]), x.useEffect(() => {
    if (y.select("floatingParentNodeId") == null)
      return;
    function he(z) {
      if (z.open || z.nodeId !== y.select("floatingParentNodeId"))
        return;
      const J = z.reason ?? Ti;
      y.setOpen(!1, De(J));
    }
    return N.events.on("menuopenchange", he), () => {
      N.events.off("menuopenchange", he);
    };
  }, [N.events, y]);
  const re = Dt();
  x.useEffect(() => {
    T || re.clear();
  }, [T, re]), x.useEffect(() => {
    function he(z) {
      if (!(!T || z.nodeId !== y.select("floatingParentNodeId")))
        if (z.target && M && M !== z.target) {
          const J = y.select("closeDelay");
          J > 0 ? re.isStarted() || re.start(J, () => {
            y.setOpen(!1, De(Ti));
          }) : y.setOpen(!1, De(Ti));
        } else
          re.clear();
    }
    return N.events.on("itemhover", he), () => {
      N.events.off("itemhover", he);
    };
  }, [N.events, T, M, y, re]), x.useEffect(() => {
    const he = {
      open: T,
      nodeId: L,
      parentNodeId: $,
      reason: y.select("lastOpenChangeReason")
    };
    N.events.emit("menuopenchange", he);
  }, [N.events, T, y, L, $]), Ne(() => {
    const he = Y, z = G.current;
    if (he && (G.current = he), z && he && he !== z) {
      y.set("instantType", void 0);
      const J = new AbortController();
      return j(() => {
        y.set("instantType", "trigger-change");
      }, J.signal), () => {
        J.abort();
      };
    }
  }, [Y, j, y]);
  const fe = {
    open: T,
    side: Q.side,
    align: Q.align,
    anchorHidden: Q.anchorHidden,
    nested: S.type === "menu",
    instant: _
  }, ne = S.type === "menubar" && S.context.modal;
  pa(T && (ne || k && A !== At), P === "touch", O, M);
  const pe = si(e, fe, {
    styles: Q.positionerStyles,
    transitionStatus: D,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !I,
    inert: !T
  }), xe = I && S.type !== "menu" && (S.type !== "menubar" && k && A !== At || S.type === "menubar" && S.context.modal);
  let ce = null;
  return S.type === "menubar" ? ce = S.context.contentElement : S.type === void 0 && (ce = M), /* @__PURE__ */ F(Vu.Provider, {
    value: Q,
    children: [xe && /* @__PURE__ */ g(ii, {
      ref: S.type === "context-menu" || S.type === "nested-context-menu" ? S.context.internalBackdropRef : null,
      inert: Er(!T),
      cutout: ce
    }), /* @__PURE__ */ g(od, {
      id: L,
      children: /* @__PURE__ */ g(ri, {
        elementsRef: y.context.itemDomElements,
        labelsRef: y.context.itemLabels,
        children: pe
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (qh.displayName = "MenuPositioner");
const xd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (xd.displayName = "MenuRadioGroupContext");
function Q6() {
  const t = x.useContext(xd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioGroupContext is missing. MenuRadioGroup parts must be placed within <Menu.RadioGroup>." : et(34));
  return t;
}
const Zh = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i,
    defaultValue: s,
    onValueChange: l,
    disabled: a = !1,
    style: c,
    ...u
  } = e, [d, f] = dn({
    controlled: i,
    default: s,
    name: "MenuRadioGroup"
  }), p = Ce(l), m = Ce((C, y) => {
    p?.(C, y), !y.isCanceled && f(C);
  }), b = Le("div", e, {
    state: {
      disabled: a
    },
    ref: n,
    props: {
      role: "group",
      "aria-disabled": a || void 0,
      ...u
    }
  }), v = x.useMemo(() => ({
    value: d,
    setValue: m,
    disabled: a
  }), [d, m, a]);
  return /* @__PURE__ */ g(xd.Provider, {
    value: v,
    children: b
  });
}));
process.env.NODE_ENV !== "production" && (Zh.displayName = "MenuRadioGroup");
const Cd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cd.displayName = "MenuRadioItemContext");
function J6() {
  const t = x.useContext(Cd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioItemContext is missing. MenuRadioItem parts must be placed within <Menu.RadioItem>." : et(35));
  return t;
}
const Xh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !1,
    value: u,
    style: d,
    ...f
  } = e, p = Oo({
    label: s
  }), m = ts(!0), h = kt(i), {
    store: b
  } = Qn(), v = b.useState("isActive", p.index), C = b.useState("itemProps"), {
    value: y,
    setValue: w,
    disabled: R
  } = Q6(), S = R || a, E = y === u, {
    getItemProps: N,
    itemRef: I
  } = ra({
    closeOnClick: c,
    disabled: S,
    highlighted: v,
    id: h,
    store: b,
    nativeButton: l,
    nodeId: m?.context.nodeId,
    itemMetadata: Hu
  }), T = x.useMemo(() => ({
    disabled: S,
    highlighted: v,
    checked: E
  }), [S, v, E]), k = Ce((M) => {
    const D = {
      ...De(Wo, M.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    w(u, D);
  }), P = Le("div", e, {
    state: T,
    stateAttributesMapping: Wu,
    props: [C, {
      role: "menuitemradio",
      "aria-checked": E,
      onClick: k
    }, f, N],
    ref: [I, n, p.ref]
  });
  return /* @__PURE__ */ g(Cd.Provider, {
    value: T,
    children: P
  });
});
process.env.NODE_ENV !== "production" && (Xh.displayName = "MenuRadioItem");
const Qh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    keepMounted: s = !1,
    ...l
  } = e, a = J6(), c = x.useRef(null), {
    transitionStatus: u,
    setMounted: d
  } = Zn(a.checked);
  Yt({
    open: a.checked,
    ref: c,
    onComplete() {
      a.checked || d(!1);
    }
  });
  const f = {
    checked: a.checked,
    disabled: a.disabled,
    highlighted: a.highlighted,
    transitionStatus: u
  };
  return Le("span", e, {
    state: f,
    stateAttributesMapping: Wu,
    ref: [n, c],
    props: {
      "aria-hidden": !0,
      ...l
    },
    enabled: s || a.checked
  });
});
process.env.NODE_ENV !== "production" && (Qh.displayName = "MenuRadioItemIndicator");
function Nr(t) {
  const e = x.useRef(!0);
  e.current && (e.current = !1, t());
}
const Jh = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Jh.displayName = "MenubarContext");
function e2(t) {
  return x.useContext(Jh);
}
function e7(t) {
  const e = x.useRef(""), n = x.useCallback((r) => {
    r.defaultPrevented || (e.current = r.pointerType, t(r, r.pointerType));
  }, [t]);
  return {
    onClick: x.useCallback((r) => {
      if (r.detail === 0) {
        t(r, "keyboard");
        return;
      }
      "pointerType" in r ? t(r, r.pointerType) : t(r, e.current), e.current = "";
    }, [t]),
    onPointerDown: n
  };
}
function wo(t, e) {
  const n = x.useRef(t), o = Ce(e);
  Ne(() => {
    n.current !== t && o(n.current);
  }, [t, o]), Ne(() => {
    n.current = t;
  }, [t]);
}
function vs(t) {
  const [e, n] = x.useState(null), o = Ce((s, l) => {
    t || n(l || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    ($u ? "touch" : ""));
  });
  wo(t, (s) => {
    s && !t && n(null);
  });
  const {
    onClick: r,
    onPointerDown: i
  } = e7(o);
  return x.useMemo(() => ({
    openMethod: e,
    triggerProps: {
      onClick: r,
      onPointerDown: i
    }
  }), [e, r, i]);
}
const t7 = {
  ...us,
  disabled: be((t) => t.parent.type === "menubar" && t.parent.context.disabled || t.disabled),
  modal: be((t) => (t.parent.type === void 0 || t.parent.type === "context-menu") && (t.modal ?? !0)),
  openMethod: be((t) => t.openMethod),
  allowMouseEnter: be((t) => t.allowMouseEnter),
  stickIfOpen: be((t) => t.stickIfOpen),
  parent: be((t) => t.parent),
  rootId: be((t) => t.parent.type === "menu" ? t.parent.store.select("rootId") : t.parent.type !== void 0 ? t.parent.context.rootId : t.rootId),
  activeIndex: be((t) => t.activeIndex),
  isActive: be((t, e) => t.activeIndex === e),
  hoverEnabled: be((t) => t.hoverEnabled),
  instantType: be((t) => t.instantType),
  lastOpenChangeReason: be((t) => t.openChangeReason),
  floatingTreeRoot: be((t) => t.parent.type === "menu" ? t.parent.store.select("floatingTreeRoot") : t.floatingTreeRoot),
  floatingNodeId: be((t) => t.floatingNodeId),
  floatingParentNodeId: be((t) => t.floatingParentNodeId),
  itemProps: be((t) => t.itemProps),
  closeDelay: be((t) => t.closeDelay),
  hasViewport: be((t) => t.hasViewport),
  keyboardEventRelay: be((t) => {
    if (t.keyboardEventRelay)
      return t.keyboardEventRelay;
    if (t.parent.type === "menu")
      return t.parent.store.select("keyboardEventRelay");
  })
};
class wd extends wr {
  constructor(e) {
    super({
      ...n7(),
      ...e
    }, {
      positionerRef: /* @__PURE__ */ x.createRef(),
      popupRef: /* @__PURE__ */ x.createRef(),
      typingRef: {
        current: !1
      },
      itemDomElements: {
        current: []
      },
      itemLabels: {
        current: []
      },
      allowMouseUpTriggerRef: {
        current: !1
      },
      triggerFocusTargetRef: /* @__PURE__ */ x.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ x.createRef(),
      onOpenChangeComplete: void 0,
      triggerElements: new Sr()
    }, t7), this.unsubscribeParentListener = this.observe("parent", (n) => {
      if (this.unsubscribeParentListener?.(), n.type === "menu") {
        let o = n.store.select("rootId"), r = n.store.select("floatingTreeRoot"), i = n.store.select("keyboardEventRelay");
        this.unsubscribeParentListener = n.store.subscribe(() => {
          const s = n.store.select("rootId"), l = n.store.select("floatingTreeRoot"), a = n.store.select("keyboardEventRelay");
          o === s && r === l && i === a || (o = s, r = l, i = a, this.notifyAll());
        }), this.context.allowMouseUpTriggerRef = n.store.context.allowMouseUpTriggerRef;
        return;
      }
      n.type !== void 0 && (this.context.allowMouseUpTriggerRef = n.context.allowMouseUpTriggerRef), this.unsubscribeParentListener = null;
    });
  }
  setOpen(e, n) {
    this.state.floatingRootContext.context.events.emit("setOpen", {
      open: e,
      eventDetails: n
    });
  }
  static useStore(e, n) {
    const o = It(() => new wd(n)).current;
    return e ?? o;
  }
  unsubscribeParentListener = null;
}
function n7() {
  return {
    ...cs(),
    disabled: !1,
    modal: !0,
    openMethod: null,
    allowMouseEnter: !1,
    stickIfOpen: !0,
    parent: {
      type: void 0
    },
    rootId: void 0,
    activeIndex: null,
    hoverEnabled: !0,
    instantType: void 0,
    openChangeReason: null,
    floatingTreeRoot: new ed(),
    floatingNodeId: void 0,
    floatingParentNodeId: null,
    itemProps: St,
    keyboardEventRelay: void 0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const Sd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Sd.displayName = "MenuSubmenuRootContext");
function t2() {
  return x.useContext(Sd);
}
const li = cd(function(e) {
  const {
    children: n,
    open: o,
    onOpenChange: r,
    onOpenChangeComplete: i,
    defaultOpen: s = !1,
    disabled: l = !1,
    modal: a,
    loopFocus: c = !0,
    orientation: u = "vertical",
    actionsRef: d,
    closeParentOnEsc: f = !1,
    handle: p,
    triggerId: m,
    defaultTriggerId: h = null,
    highlightItemOnHover: b = !0
  } = e, v = oa(!0), C = Qn(!0), y = e2(!0), w = t2(), R = x.useMemo(() => w && C ? {
    type: "menu",
    store: C.store
  } : y ? {
    type: "menubar",
    context: y
  } : v && !C ? {
    type: "context-menu",
    context: v
  } : {
    type: void 0
  }, [v, C, y, w]), S = wd.useStore(p?.store, {
    open: s,
    openProp: o,
    activeTriggerId: h,
    triggerIdProp: m,
    parent: R
  });
  Nr(() => {
    o === void 0 && S.state.open === !1 && s === !0 && S.update({
      open: !0,
      activeTriggerId: h
    });
  }), S.useControlledProp("openProp", o), S.useControlledProp("triggerIdProp", m), S.useContextCallback("onOpenChangeComplete", i);
  const E = S.useState("floatingTreeRoot"), N = aa(E), I = bo();
  Ne(() => {
    v && !C ? S.update({
      parent: {
        type: "context-menu",
        context: v
      },
      floatingNodeId: N,
      floatingParentNodeId: I
    }) : C && S.update({
      floatingNodeId: N,
      floatingParentNodeId: I
    });
  }, [v, C, N, I, S]);
  const T = S.useState("open"), k = S.useState("activeTriggerElement"), P = S.useState("positionerElement"), M = S.useState("hoverEnabled"), D = S.useState("disabled"), O = S.useState("lastOpenChangeReason"), _ = S.useState("parent"), V = S.useState("activeIndex"), A = S.useState("payload"), L = S.useState("floatingParentNodeId"), $ = x.useRef(null), Y = L != null;
  process.env.NODE_ENV !== "production" && _.type !== void 0 && a !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored.");
  const {
    openMethod: G,
    triggerProps: j
  } = vs(T);
  S.useSyncedValues({
    disabled: l,
    modal: _.type === void 0 ? a : void 0,
    openMethod: G,
    rootId: Do()
  }), ls(S);
  const {
    forceUnmount: Z
  } = as(T, S, () => {
    S.update({
      allowMouseEnter: !1,
      stickIfOpen: !0
    });
  }), U = x.useRef(_.type !== "context-menu"), q = Dt();
  x.useEffect(() => {
    if (T || ($.current = null), _.type === "context-menu") {
      if (!T) {
        q.clear(), U.current = !1;
        return;
      }
      q.start(500, () => {
        U.current = !0;
      });
    }
  }, [q, T, _.type]), Ne(() => {
    !T && !M && S.set("hoverEnabled", !0);
  }, [T, M, S]);
  const te = x.useRef(!0), H = Dt(), X = Ce((me, Re) => {
    const Ie = Re.reason;
    if (T === me && Re.trigger === k && O === Ie || (Re.preventUnmountOnClose = () => {
      S.set("preventUnmountingOnClose", !0);
    }, !me && Re.trigger == null && (Re.trigger = k ?? void 0), r?.(me, Re), Re.isCanceled))
      return;
    S.state.floatingRootContext.dispatchOpenChange(me, Re);
    const Pe = Re.event;
    if (me === !1 && Pe?.type === "click" && Pe.pointerType === "touch" && !te.current)
      return;
    if (!me && V !== null) {
      const Ee = S.context.itemDomElements.current[V];
      queueMicrotask(() => {
        Ee?.setAttribute("tabindex", "-1");
      });
    }
    me && Ie === dr ? (te.current = !1, H.start(300, () => {
      te.current = !0;
    })) : (te.current = !0, H.clear());
    const _e = (Ie === qn || Ie === Wo) && Pe.detail === 0 && Pe?.isTrusted, Ye = !me && (Ie === vr || Ie == null), qe = {
      open: me,
      openChangeReason: Ie
    };
    $.current = Re.event ?? null;
    const $e = Re.trigger?.id ?? null;
    ($e || me) && (qe.activeTriggerId = $e, qe.activeTriggerElement = Re.trigger ?? null), S.update(qe), _.type === "menubar" && (Ie === dr || Ie === Io || Ie === At || Ie === Fr || Ie === Ti) ? S.set("instantType", "group") : _e || Ye ? S.set("instantType", _e ? "click" : "dismiss") : S.set("instantType", void 0);
  }), ee = x.useCallback(() => {
    S.setOpen(!1, De(os));
  }, [S]);
  x.useImperativeHandle(d, () => ({
    unmount: Z,
    close: ee
  }), [Z, ee]);
  let le;
  _.type === "context-menu" && (le = _.context), x.useImperativeHandle(le?.positionerRef, () => P, [P]), x.useImperativeHandle(le?.actionsRef, () => ({
    setOpen: X
  }), [X]);
  const Q = ds({
    popupStore: S,
    onOpenChange: X
  }), re = Q.context.events;
  x.useEffect(() => {
    const me = ({
      open: Re,
      eventDetails: Ie
    }) => X(Re, Ie);
    return re.on("setOpen", me), () => {
      re?.off("setOpen", me);
    };
  }, [re, X]);
  const fe = Cr(Q, {
    enabled: !D,
    bubbles: {
      escapeKey: f && _.type === "menu"
    },
    outsidePress() {
      return _.type !== "context-menu" || $.current?.type === "contextmenu" ? !0 : U.current;
    },
    externalTree: Y ? E : void 0
  }), ne = hd(Q, {
    role: "menu"
  }), se = bs(), pe = x.useCallback((me) => {
    S.select("activeIndex") !== me && S.set("activeIndex", me);
  }, [S]), xe = gd(Q, {
    enabled: !D,
    listRef: S.context.itemDomElements,
    activeIndex: V,
    nested: _.type !== void 0,
    loopFocus: c,
    orientation: u,
    parentOrientation: _.type === "menubar" ? _.context.orientation : void 0,
    rtl: se === "rtl",
    disabledIndices: Dn,
    onNavigate: pe,
    openOnArrowKeyDown: _.type !== "context-menu",
    externalTree: Y ? E : void 0,
    focusItemOnHover: b
  }), ce = x.useCallback((me) => {
    S.context.typingRef.current = me;
  }, [S]), he = bd(Q, {
    listRef: S.context.itemLabels,
    elementsRef: S.context.itemDomElements,
    activeIndex: V,
    resetMs: F8,
    onMatch: (me) => {
      T && me !== V && S.set("activeIndex", me);
    },
    onTypingChange: ce
  }), {
    getReferenceProps: z,
    getFloatingProps: J,
    getItemProps: B,
    getTriggerProps: K
  } = Jn([fe, ne, xe, he]), ie = x.useMemo(() => {
    const me = en(z(), {
      onMouseMove() {
        S.set("allowMouseEnter", !0);
      }
    }, j);
    return delete me.role, me;
  }, [z, S, j]), ge = x.useMemo(() => {
    const me = K();
    if (!me)
      return me;
    const Re = en(me, j);
    return delete Re.role, delete Re["aria-controls"], Re;
  }, [K, j]), ue = x.useMemo(() => J({
    onMouseMove() {
      S.set("allowMouseEnter", !0), _.type === "menu" && S.set("hoverEnabled", !1);
    },
    onClick() {
      S.select("hoverEnabled") && S.set("hoverEnabled", !1);
    },
    onKeyDown(me) {
      const Re = S.select("keyboardEventRelay");
      Re && !me.isPropagationStopped() && Re(me);
    }
  }), [J, _.type, S]), Se = x.useMemo(() => B(), [B]);
  S.useSyncedValues({
    floatingRootContext: Q,
    activeTriggerProps: ie,
    inactiveTriggerProps: ge,
    popupProps: ue,
    itemProps: Se
  });
  const ve = x.useMemo(() => ({
    store: S,
    parent: R
  }), [S, R]), de = /* @__PURE__ */ g(Au.Provider, {
    value: ve,
    children: typeof n == "function" ? n({
      payload: A
    }) : n
  });
  return _.type === void 0 || _.type === "context-menu" ? /* @__PURE__ */ g(rd, {
    externalTree: E,
    children: de
  }) : de;
});
process.env.NODE_ENV !== "production" && (li.displayName = "MenuRoot");
function o7(t) {
  const e = Qn().store, n = x.useMemo(() => ({
    parentMenu: e
  }), [e]);
  return /* @__PURE__ */ g(Sd.Provider, {
    value: n,
    children: /* @__PURE__ */ g(li, {
      ...t
    })
  });
}
function Rd(t) {
  const e = t.getBoundingClientRect();
  if (process.env.NODE_ENV !== "production")
    return e;
  const n = Ct(t), o = n.getComputedStyle(t, "::before"), r = n.getComputedStyle(t, "::after");
  if (!(o.content !== "none" || r.content !== "none"))
    return e;
  const s = parseFloat(o.width) || 0, l = parseFloat(o.height) || 0, a = parseFloat(r.width) || 0, c = parseFloat(r.height) || 0, u = Math.max(e.width, s, a), d = Math.max(e.height, l, c), f = u - e.width, p = d - e.height;
  return {
    left: e.left - f / 2,
    right: e.right + f / 2,
    top: e.top - p / 2,
    bottom: e.bottom + p / 2
  };
}
function n2(t = {}) {
  const {
    highlightItemOnHover: e,
    highlightedIndex: n,
    onHighlightedIndexChange: o
  } = Tu(), {
    ref: r,
    index: i
  } = Oo(t), s = n === i, l = x.useRef(null), a = fn(r, l);
  return {
    compositeProps: x.useMemo(() => ({
      tabIndex: s ? 0 : -1,
      onFocus() {
        o(i);
      },
      onMouseMove() {
        const u = l.current;
        if (!e || !u)
          return;
        const d = u.hasAttribute("disabled") || u.ariaDisabled === "true";
        !s && !d && u.focus();
      }
    }), [s, o, i, e]),
    compositeRef: a,
    index: i
  };
}
function Ed(t) {
  const {
    render: e,
    className: n,
    style: o,
    state: r = St,
    props: i = Dn,
    refs: s = Dn,
    metadata: l,
    stateAttributesMapping: a,
    tag: c = "div",
    ...u
  } = t, {
    compositeProps: d,
    compositeRef: f
  } = n2({
    metadata: l
  });
  return Le(c, t, {
    state: r,
    ref: [...s, f],
    props: [d, ...i, u],
    stateAttributesMapping: a
  });
}
function o2(t) {
  if (xt(t) && t.hasAttribute("data-rootownerid"))
    return t.getAttribute("data-rootownerid") ?? void 0;
  if (!lo(t))
    return o2(po(t));
}
function r2(t, e) {
  const n = x.useRef(null), o = Ce((i) => {
    an.flushSync(() => {
      t.setOpen(!1, De(Io, i.nativeEvent, i.currentTarget));
    }), _8(n.current)?.focus();
  }), r = Ce((i) => {
    const s = t.select("positionerElement");
    if (s && $r(i, s))
      t.context.beforeContentFocusGuardRef.current?.focus();
    else {
      an.flushSync(() => {
        t.setOpen(!1, De(Io, i.nativeEvent, i.currentTarget));
      });
      let l = D8(t.context.triggerFocusTargetRef.current || e.current);
      for (; l !== null && Fe(s, l); ) {
        const a = l;
        if (l = Zu(l), l === a)
          break;
      }
      l?.focus();
    }
  });
  return {
    preFocusGuardRef: n,
    handlePreFocusGuardFocus: o,
    handleFocusTargetFocus: r
  };
}
function r7(t) {
  const {
    enabled: e = !0,
    mouseDownAction: n,
    open: o
  } = t, r = x.useRef(!1);
  return x.useMemo(() => e ? {
    onMouseDown: (i) => {
      (n === "open" && !o || n === "close" && o) && (r.current = !0, Je(i.currentTarget).addEventListener("click", () => {
        r.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (i) => {
      r.current && (r.current = !1, i.preventBaseUIHandler());
    }
  } : St, [e, n, o]);
}
const nl = 2, i2 = Vh(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    id: l,
    openOnHover: a,
    delay: c = 100,
    closeDelay: u = 0,
    handle: d,
    payload: f,
    style: p,
    ...m
  } = e, h = Qn(!0), b = d?.store ?? h?.store;
  if (!b)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Trigger> must be either used within a <Menu.Root> component or provided with a handle." : et(85));
  const v = kt(l), C = b.useState("isTriggerActive", v), y = b.useState("floatingRootContext"), w = b.useState("isOpenedByTrigger", v), R = x.useRef(null), S = s7(), E = Tu(!0), N = tr(), I = x.useMemo(() => N ?? new ed(), [N]), T = aa(I), k = bo(), {
    registerTrigger: P,
    isMountedByThisTrigger: M
  } = ss(v, R, b, {
    payload: f,
    closeDelay: u,
    parent: S,
    floatingTreeRoot: I,
    floatingNodeId: T,
    floatingParentNodeId: k,
    keyboardEventRelay: E?.relayKeyboardEvent
  }), D = S.type === "menubar", O = b.useState("disabled"), _ = i || O || D && S.context.disabled, {
    getButtonProps: V,
    buttonRef: A
  } = Bt({
    disabled: _,
    native: s
  });
  x.useEffect(() => {
    !w && S.type === void 0 && (b.context.allowMouseUpTriggerRef.current = !1);
  }, [b, w, S.type]);
  const L = x.useRef(null), $ = Dt(), Y = Ce((xe) => {
    if (!L.current)
      return;
    $.clear(), b.context.allowMouseUpTriggerRef.current = !1;
    const ce = xe.target;
    if (Fe(L.current, ce) || Fe(b.select("positionerElement"), ce) || ce === L.current || ce != null && o2(ce) === b.select("rootId"))
      return;
    const he = Rd(L.current);
    xe.clientX >= he.left - nl && xe.clientX <= he.right + nl && xe.clientY >= he.top - nl && xe.clientY <= he.bottom + nl || I.events.emit("close", {
      domEvent: xe,
      reason: Hg
    });
  });
  x.useEffect(() => {
    w && b.select("lastOpenChangeReason") === At && Je(L.current).addEventListener("mouseup", Y, {
      once: !0
    });
  }, [w, Y, b]);
  const G = D && S.context.hasSubmenuOpen, Z = fs(y, {
    enabled: (a ?? G) && !_ && S.type !== "context-menu" && (!D || G && !M),
    handleClose: ps({
      blockPointerEvents: !D
    }),
    mouseOnly: !0,
    move: !1,
    restMs: S.type === void 0 ? c : void 0,
    delay: {
      close: u
    },
    triggerElementRef: R,
    externalTree: I,
    isActiveTrigger: C,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), U = i7(w, b.select("lastOpenChangeReason")), q = xr(y, {
    enabled: !_ && S.type !== "context-menu",
    event: w && D ? "click" : "mousedown",
    toggle: !0,
    ignoreMouse: !1,
    stickIfOpen: S.type === void 0 ? U : !1
  }), te = pd(y, {
    enabled: !_ && G
  }), H = r7({
    open: w,
    enabled: D,
    mouseDownAction: "open"
  }), X = Jn([q, te]), ee = {
    disabled: _,
    open: w
  }, le = b.useState("triggerProps", M), Q = [L, n, A, P, R], re = [X.getReferenceProps(), Z ?? St, le, {
    "aria-haspopup": "menu",
    id: v,
    onMouseDown: (xe) => {
      if (b.select("open"))
        return;
      $.start(200, () => {
        b.context.allowMouseUpTriggerRef.current = !0;
      }), Je(xe.currentTarget).addEventListener("mouseup", Y, {
        once: !0
      });
    }
  }, D ? {
    role: "menuitem"
  } : {}, H, m, V], {
    preFocusGuardRef: fe,
    handlePreFocusGuardFocus: ne,
    handleFocusTargetFocus: se
  } = r2(b, R), pe = Le("button", e, {
    enabled: !D,
    stateAttributesMapping: zi,
    state: ee,
    ref: Q,
    props: re
  });
  return D ? /* @__PURE__ */ g(Ed, {
    tag: "button",
    render: o,
    className: r,
    style: p,
    state: ee,
    refs: Q,
    props: re,
    stateAttributesMapping: zi
  }) : w ? /* @__PURE__ */ F(x.Fragment, {
    children: [/* @__PURE__ */ g(Vn, {
      ref: fe,
      onFocus: ne
    }, `${v}-pre-focus-guard`), /* @__PURE__ */ g(x.Fragment, {
      children: pe
    }, v), /* @__PURE__ */ g(Vn, {
      ref: b.context.triggerFocusTargetRef,
      onFocus: se
    }, `${v}-post-focus-guard`)]
  }) : /* @__PURE__ */ g(x.Fragment, {
    children: pe
  }, v);
});
process.env.NODE_ENV !== "production" && (i2.displayName = "MenuTrigger");
function i7(t, e) {
  const n = Dt(), [o, r] = x.useState(!1);
  return Ne(() => {
    t && e === "trigger-hover" ? (r(!0), n.start(yh, () => {
      r(!1);
    })) : t || (n.clear(), r(!1));
  }, [t, e, n]), o;
}
function s7() {
  const t = oa(!0), e = Qn(!0), n = e2();
  return x.useMemo(() => n ? {
    type: "menubar",
    context: n
  } : t && !e ? {
    type: "context-menu",
    context: t
  } : {
    type: void 0
  }, [t, e, n]);
}
function l7(t) {
  const [e, n] = x.useState({
    current: t,
    previous: null
  });
  return t !== e.current && n({
    current: t,
    previous: e.current
  }), e.previous;
}
function s2(t) {
  return t == null || t.hasAttribute("disabled") || t.getAttribute("aria-disabled") === "true";
}
const l2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    label: i,
    id: s,
    nativeButton: l = !1,
    openOnHover: a = !0,
    delay: c = 100,
    closeDelay: u = 0,
    disabled: d = !1,
    style: f,
    ...p
  } = e, m = Oo(), h = ts(), {
    store: b
  } = Qn(), v = kt(s), C = b.useState("open"), y = b.useState("floatingRootContext"), w = b.useState("floatingTreeRoot"), R = Ah(v, b), S = x.useCallback((q) => {
    const te = R(q);
    return q !== null && b.select("open") && b.select("activeTriggerId") == null && b.update({
      activeTriggerId: v,
      activeTriggerElement: q,
      closeDelay: u
    }), te;
  }, [R, u, b, v]), E = x.useRef(null), N = x.useCallback((q) => {
    E.current = q, b.set("activeTriggerElement", q);
  }, [b]);
  process.env.NODE_ENV !== "production" && Ne(() => {
    const q = E.current;
    if (q && s2(q) && !d) {
      const te = pr.captureOwnerStack?.() || "";
      Xl(`A disabled element was detected on <Menu.SubmenuTrigger>. To properly disable the trigger, use the \`disabled\` prop on the component instead of setting it on the rendered element.${te}`);
    }
  });
  const I = t2();
  if (!I?.parentMenu)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.SubmenuTrigger> must be placed in <Menu.SubmenuRoot>." : et(37));
  b.useSyncedValue("closeDelay", u);
  const T = I.parentMenu, k = T.useState("itemProps"), P = T.useState("isActive", m.index), M = x.useMemo(() => ({
    type: "submenu-trigger",
    setActive() {
      T.set("activeIndex", m.index);
    }
  }), [T, m.index]), D = b.useState("disabled"), O = d || D, {
    getItemProps: _,
    itemRef: V
  } = ra({
    closeOnClick: !1,
    disabled: O,
    highlighted: P,
    id: v,
    store: b,
    typingRef: T.context.typingRef,
    nativeButton: l,
    itemMetadata: M,
    nodeId: h?.context.nodeId
  }), A = b.useState("hoverEnabled"), L = T.useState("allowMouseEnter"), $ = fs(y, {
    enabled: A && a && !O,
    handleClose: ps({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: !0,
    restMs: c,
    delay: L ? {
      open: c,
      close: u
    } : 0,
    triggerElementRef: E,
    externalTree: w,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), Y = xr(y, {
    enabled: !O,
    event: "mousedown",
    toggle: !a,
    ignoreMouse: a,
    stickIfOpen: !1
  }), G = Jn([Y]), j = b.useState("triggerProps", !0);
  return delete j.id, Le("div", e, {
    state: {
      disabled: O,
      highlighted: P,
      open: C
    },
    stateAttributesMapping: br,
    props: [G.getReferenceProps(), $, j, k, {
      tabIndex: C || P ? 0 : -1,
      onBlur() {
        P && T.set("activeIndex", null);
      }
    }, p, _],
    ref: [n, m.ref, V, S, N]
  });
});
process.env.NODE_ENV !== "production" && (l2.displayName = "MenuSubmenuTrigger");
const Nd = go({
  blockingLayerHost: null,
  portalHost: null
});
function Qt() {
  return mn(Nd).portalHost ?? void 0;
}
function a7() {
  return mn(Nd).blockingLayerHost ?? void 0;
}
function c7() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ g("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const u7 = ae(["rounded-(--radius-sm)", "border", "border-solid", "border-menu-default-outline", "bg-menu-default-background", "shadow-elevation-3", "p-(--spacing-4)", "flex", "flex-col", "max-h-[min(20rem,calc(100vh-2rem))]", "overflow-y-auto", "overscroll-contain", "outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out"], {
  variants: {
    size: {
      sm: "w-[180px]",
      md: "w-[296px]",
      lg: "w-[400px]",
      anchor: "w-[var(--anchor-width)]",
      trigger: "w-[max(180px,var(--anchor-width))] max-w-[calc(100vw-var(--spacing-16))]",
      auto: "w-auto min-w-[180px] max-w-[calc(100vw-var(--spacing-16))]"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), d7 = ae(["flex", "h-[36px]", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[selected]:bg-menu-item-selected", "data-[checked]:bg-menu-item-selected", "[&[data-highlighted]:active]:bg-menu-item-pressed", "[&[data-selected]:active]:bg-menu-item-pressed", "[&[data-checked]:active]:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "data-[disabled]:hover:bg-transparent"], {
  variants: {
    tone: {
      default: "",
      destructive: ["text-menu-text-destructive", "[&_svg]:text-menu-icon-destructive"]
    }
  },
  defaultVariants: {
    tone: "default"
  }
}), f7 = oe("flex", "h-(--spacing-24)", "w-full", "items-center", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-4)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle", "select-none", "data-[disabled]:text-menu-text-disabled-sub");
function ys({
  size: t,
  className: e
}) {
  return oe(u7({
    size: t
  }), e);
}
function Ki(t) {
  const e = W.c(19), {
    children: n,
    leadingIcon: o,
    endSection: r,
    checked: i,
    checkbox: s,
    submenu: l
  } = t;
  let a;
  e[0] !== s || e[1] !== i ? (a = s && /* @__PURE__ */ g(p7, { checked: i }), e[0] = s, e[1] = i, e[2] = a) : a = e[2];
  let c;
  e[3] !== o ? (c = o && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(Ge, { name: o, size: "xs", tone: "inherit" }) }), e[3] = o, e[4] = c) : c = e[4];
  let u;
  e[5] !== n ? (u = /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: n }), e[5] = n, e[6] = u) : u = e[6];
  let d;
  e[7] !== s || e[8] !== i ? (d = i && !s && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(Ge, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[7] = s, e[8] = i, e[9] = d) : d = e[9];
  let f;
  e[10] !== r || e[11] !== l ? (f = l ? /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(Ge, { name: "chevron-right", size: "xs", tone: "inherit" }) }) : r && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[10] = r, e[11] = l, e[12] = f) : f = e[12];
  let p;
  return e[13] !== a || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f ? (p = /* @__PURE__ */ F(Ht, { children: [
    a,
    c,
    u,
    d,
    f
  ] }), e[13] = a, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p) : p = e[18], p;
}
function p7(t) {
  const e = W.c(7), {
    checked: n
  } = t, o = n ? "" : void 0, r = n ? "" : void 0;
  let i;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = oe("inline-flex", "h-(--icon-xs)", "w-(--icon-xs)", "items-center", "justify-center", "rounded-(--radius-sm)", "border-[1.5px]", "border-checkbox-outline-default-border", "bg-surface-container-lowest", "text-transparent", "transition-colors", "duration-200", "ease-in-out", "data-[checked]:border-transparent", "data-[checked]:bg-checkbox-filled-default-background", "data-[checked]:text-surface-container-lowest", "[[data-disabled]_&]:border-transparent", "[[data-disabled]_&]:bg-checkbox-filled-disabled-background", "[[data-disabled]_&]:text-surface-container-lowest"), e[0] = i) : i = e[0];
  let s;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ g("span", { className: "h-[calc(var(--icon-xs)*0.8)] w-[calc(var(--icon-xs)*0.8)]", children: /* @__PURE__ */ g(c7, {}) }), e[1] = s) : s = e[1];
  let l;
  e[2] !== r ? (l = /* @__PURE__ */ g("span", { "data-checked": r, className: i, children: s }), e[2] = r, e[3] = l) : l = e[3];
  let a;
  return e[4] !== o || e[5] !== l ? (a = /* @__PURE__ */ g("span", { "aria-hidden": "true", "data-checked": o, className: "inline-flex h-(--icon-sm) w-(--icon-sm) shrink-0 items-center justify-center", children: l }), e[4] = o, e[5] = l, e[6] = a) : a = e[6], a;
}
function Ko({
  tone: t,
  className: e
}) {
  return oe(d7({
    tone: t
  }), e);
}
const m7 = 13;
function kd(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(li, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Yo(t) {
  const e = W.c(2), {
    render: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g(i2, { render: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function kr(t) {
  const e = W.c(27);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    children: n,
    side: l,
    align: a,
    sideOffset: c,
    alignOffset: u,
    size: s,
    className: o,
    positionerClassName: r,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = l === void 0 ? "bottom" : l, f = a === void 0 ? "start" : a, p = c === void 0 ? 4 : c, m = u === void 0 ? 0 : u, h = Qt();
  let b;
  e[10] !== o || e[11] !== s ? (b = ys({
    size: s,
    className: o
  }), e[10] = o, e[11] = s, e[12] = b) : b = e[12];
  let v;
  e[13] !== n || e[14] !== i || e[15] !== b ? (v = /* @__PURE__ */ g(Uh, { className: b, ...i, children: n }), e[13] = n, e[14] = i, e[15] = b, e[16] = v) : v = e[16];
  let C;
  e[17] !== f || e[18] !== m || e[19] !== r || e[20] !== d || e[21] !== p || e[22] !== v ? (C = /* @__PURE__ */ g(qh, { side: d, align: f, sideOffset: p, alignOffset: m, className: r, children: v }), e[17] = f, e[18] = m, e[19] = r, e[20] = d, e[21] = p, e[22] = v, e[23] = C) : C = e[23];
  let y;
  return e[24] !== h || e[25] !== C ? (y = /* @__PURE__ */ g(Gh, { container: h, children: C }), e[24] = h, e[25] = C, e[26] = y) : y = e[26], y;
}
function fr(t) {
  const e = W.c(36);
  let n, o, r, i, s, l, a;
  if (e[0] !== t ? ({
    children: n,
    leadingIcon: i,
    endSection: r,
    submenu: l,
    tone: a,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]), l != null) {
    let f;
    if (e[8] !== s) {
      const {
        closeOnClick: C,
        ...y
      } = s;
      f = y, e[8] = s, e[9] = f;
    } else
      f = e[9];
    let p;
    e[10] !== o || e[11] !== a ? (p = Ko({
      tone: a,
      className: o
    }), e[10] = o, e[11] = a, e[12] = p) : p = e[12];
    let m;
    e[13] !== n || e[14] !== i ? (m = /* @__PURE__ */ g(Ki, { leadingIcon: i, submenu: !0, children: n }), e[13] = n, e[14] = i, e[15] = m) : m = e[15];
    let h;
    e[16] !== p || e[17] !== m || e[18] !== f ? (h = /* @__PURE__ */ g(l2, { className: p, ...f, children: m }), e[16] = p, e[17] = m, e[18] = f, e[19] = h) : h = e[19];
    let b;
    e[20] !== l ? (b = /* @__PURE__ */ g(kr, { side: "right", align: "start", sideOffset: m7, alignOffset: -4, size: "sm", children: l }), e[20] = l, e[21] = b) : b = e[21];
    let v;
    return e[22] !== h || e[23] !== b ? (v = /* @__PURE__ */ F(o7, { children: [
      h,
      b
    ] }), e[22] = h, e[23] = b, e[24] = v) : v = e[24], v;
  }
  let c;
  e[25] !== o || e[26] !== a ? (c = Ko({
    tone: a,
    className: o
  }), e[25] = o, e[26] = a, e[27] = c) : c = e[27];
  let u;
  e[28] !== n || e[29] !== r || e[30] !== i ? (u = /* @__PURE__ */ g(Ki, { leadingIcon: i, endSection: r, children: n }), e[28] = n, e[29] = r, e[30] = i, e[31] = u) : u = e[31];
  let d;
  return e[32] !== s || e[33] !== c || e[34] !== u ? (d = /* @__PURE__ */ g(jg, { className: c, ...s, children: u }), e[32] = s, e[33] = c, e[34] = u, e[35] = d) : d = e[35], d;
}
function Md(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(Zh, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function Pd(t) {
  const e = W.c(21);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    leadingIcon: i,
    endSection: r,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  let l;
  e[6] !== o ? (l = Ko({
    className: o
  }), e[6] = o, e[7] = l) : l = e[7];
  let a;
  e[8] !== i ? (a = i && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(Ge, { name: i, size: "xs", tone: "inherit" }) }), e[8] = i, e[9] = a) : a = e[9];
  let c;
  e[10] !== n ? (c = /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: n }), e[10] = n, e[11] = c) : c = e[11];
  let u;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g(Qh, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(Ge, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[12] = u) : u = e[12];
  let d;
  e[13] !== r ? (d = r && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[13] = r, e[14] = d) : d = e[14];
  let f;
  return e[15] !== s || e[16] !== l || e[17] !== a || e[18] !== c || e[19] !== d ? (f = /* @__PURE__ */ F(Xh, { className: l, ...s, children: [
    a,
    c,
    u,
    d
  ] }), e[15] = s, e[16] = l, e[17] = a, e[18] = c, e[19] = d, e[20] = f) : f = e[20], f;
}
function g7(t) {
  const e = W.c(19);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    children: o,
    leadingIcon: s,
    endSection: i,
    checked: n,
    className: r,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  let a;
  e[7] !== r ? (a = Ko({
    className: r
  }), e[7] = r, e[8] = a) : a = e[8];
  let c;
  e[9] !== n || e[10] !== o || e[11] !== i || e[12] !== s ? (c = /* @__PURE__ */ g(Ki, { leadingIcon: s, endSection: i, checked: n, checkbox: !0, children: o }), e[9] = n, e[10] = o, e[11] = i, e[12] = s, e[13] = c) : c = e[13];
  let u;
  return e[14] !== n || e[15] !== l || e[16] !== a || e[17] !== c ? (u = /* @__PURE__ */ g(Yg, { checked: n, className: a, ...l, children: c }), e[14] = n, e[15] = l, e[16] = a, e[17] = c, e[18] = u) : u = e[18], u;
}
function su(t) {
  const e = W.c(13);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    disabled: r,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r ? "" : void 0, l = r || void 0;
  let a;
  e[5] !== o ? (a = oe(f7, o), e[5] = o, e[6] = a) : a = e[6];
  let c;
  return e[7] !== n || e[8] !== i || e[9] !== s || e[10] !== l || e[11] !== a ? (c = /* @__PURE__ */ g("div", { role: "presentation", "data-disabled": s, "aria-disabled": l, className: a, ...i, children: n }), e[7] = n, e[8] = i, e[9] = s, e[10] = l, e[11] = a, e[12] = c) : c = e[12], c;
}
const Id = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Id.displayName = "TooltipRootContext");
function xs(t) {
  const e = x.useContext(Id);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : et(72));
  return e;
}
const h7 = {
  ...us,
  disabled: be((t) => t.disabled),
  instantType: be((t) => t.instantType),
  isInstantPhase: be((t) => t.isInstantPhase),
  trackCursorAxis: be((t) => t.trackCursorAxis),
  disableHoverablePopup: be((t) => t.disableHoverablePopup),
  lastOpenChangeReason: be((t) => t.openChangeReason),
  closeOnClick: be((t) => t.closeOnClick),
  closeDelay: be((t) => t.closeDelay),
  hasViewport: be((t) => t.hasViewport)
};
class Td extends wr {
  constructor(e) {
    super({
      ...b7(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new Sr()
    }, h7);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === At, i = e && o === dr, s = !e && (o === qn || o === vr);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const l = () => {
      const a = {
        open: e,
        openChangeReason: o
      };
      i ? a.instantType = "focus" : s ? a.instantType = "dismiss" : o === At && (a.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (a.activeTriggerId = c, a.activeTriggerElement = n.trigger ?? null), this.update(a);
    };
    r ? an.flushSync(l) : l();
  };
  static useStore(e, n) {
    const o = It(() => new Td(n)).current, r = e ?? o, i = ds({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = i, r;
  }
}
function b7() {
  return {
    ...cs(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeOnClick: !0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const Od = cd(function(e) {
  const {
    disabled: n = !1,
    defaultOpen: o = !1,
    open: r,
    disableHoverablePopup: i = !1,
    trackCursorAxis: s = "none",
    actionsRef: l,
    onOpenChange: a,
    onOpenChangeComplete: c,
    handle: u,
    triggerId: d,
    defaultTriggerId: f = null,
    children: p
  } = e, m = Td.useStore(u?.store, {
    open: o,
    openProp: r,
    activeTriggerId: f,
    triggerIdProp: d
  });
  Nr(() => {
    r === void 0 && m.state.open === !1 && o === !0 && m.update({
      open: !0,
      activeTriggerId: f
    });
  }), m.useControlledProp("openProp", r), m.useControlledProp("triggerIdProp", d), m.useContextCallback("onOpenChange", a), m.useContextCallback("onOpenChangeComplete", c);
  const h = m.useState("open"), b = !n && h, v = m.useState("activeTriggerId"), C = m.useState("payload");
  m.useSyncedValues({
    trackCursorAxis: s,
    disableHoverablePopup: i
  }), Ne(() => {
    h && n && m.setOpen(!1, De(r8));
  }, [h, n, m]), m.useSyncedValue("disabled", n), ls(m);
  const {
    forceUnmount: y,
    transitionStatus: w
  } = as(b, m), R = m.select("floatingRootContext"), S = m.useState("isInstantPhase"), E = m.useState("instantType"), N = m.useState("lastOpenChangeReason"), I = x.useRef(null);
  Ne(() => {
    w === "ending" && N === Pt || w !== "ending" && S ? (E !== "delay" && (I.current = E), m.set("instantType", "delay")) : I.current !== null && (m.set("instantType", I.current), I.current = null);
  }, [w, S, N, E, m]), Ne(() => {
    b && v == null && m.set("payload", void 0);
  }, [m, v, b]);
  const T = x.useCallback(() => {
    m.setOpen(!1, De(os));
  }, [m]);
  x.useImperativeHandle(l, () => ({
    unmount: y,
    close: T
  }), [y, T]);
  const k = Cr(R, {
    enabled: !n,
    referencePress: () => m.select("closeOnClick")
  }), P = q8(R, {
    enabled: !n && s !== "none",
    axis: s === "none" ? void 0 : s
  }), {
    getReferenceProps: M,
    getFloatingProps: D,
    getTriggerProps: O
  } = Jn([k, P]), _ = x.useMemo(() => M(), [M]), V = x.useMemo(() => O(), [O]), A = x.useMemo(() => D(), [D]);
  return m.useSyncedValues({
    activeTriggerProps: _,
    inactiveTriggerProps: V,
    popupProps: A
  }), /* @__PURE__ */ g(Id.Provider, {
    value: m,
    children: typeof p == "function" ? p({
      payload: C
    }) : p
  });
});
process.env.NODE_ENV !== "production" && (Od.displayName = "TooltipRoot");
const Dd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Dd.displayName = "TooltipProviderContext");
function v7() {
  return x.useContext(Dd);
}
let y7 = (function(t) {
  return t[t.popupOpen = Tl.popupOpen] = "popupOpen", t.triggerDisabled = "data-trigger-disabled", t;
})({});
const x7 = 600, _d = Vh(function(e, n) {
  const {
    className: o,
    render: r,
    handle: i,
    payload: s,
    disabled: l,
    delay: a,
    closeOnClick: c = !0,
    closeDelay: u,
    id: d,
    style: f,
    ...p
  } = e, m = xs(!0), h = i?.store ?? m;
  if (!h)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : et(82));
  const b = kt(d), v = h.useState("isTriggerActive", b), C = h.useState("isOpenedByTrigger", b), y = h.useState("floatingRootContext"), w = x.useRef(null), R = a ?? x7, S = u ?? 0, {
    registerTrigger: E,
    isMountedByThisTrigger: N
  } = ss(b, w, h, {
    payload: s,
    closeOnClick: c,
    closeDelay: S
  }), I = v7(), {
    delayRef: T,
    isInstantPhase: k,
    hasProvider: P
  } = g8(y, {
    open: C
  });
  h.useSyncedValue("isInstantPhase", k);
  const M = h.useState("disabled"), D = l ?? M, O = h.useState("trackCursorAxis"), _ = h.useState("disableHoverablePopup"), V = fs(y, {
    enabled: !D,
    mouseOnly: !0,
    move: !1,
    handleClose: !_ && O !== "both" ? ps() : null,
    restMs() {
      const G = I?.delay, j = typeof T.current == "object" ? T.current.open : void 0;
      let Z = R;
      return P && (j !== 0 ? Z = a ?? G ?? R : Z = 0), Z;
    },
    delay() {
      const G = typeof T.current == "object" ? T.current.close : void 0;
      let j = S;
      return u == null && P && (j = G), {
        close: j
      };
    },
    triggerElementRef: w,
    isActiveTrigger: v,
    isClosing: () => h.select("transitionStatus") === "ending"
  }), A = pd(y, {
    enabled: !D
  }).reference, L = {
    open: C
  }, $ = h.useState("triggerProps", N);
  return Le("button", e, {
    state: L,
    ref: [n, E, w],
    props: [V, A, $, {
      onPointerDown() {
        h.set("closeOnClick", c);
      },
      id: b,
      [y7.triggerDisabled]: D ? "" : void 0
    }, p],
    stateAttributesMapping: br
  });
});
process.env.NODE_ENV !== "production" && (_d.displayName = "TooltipTrigger");
const Vd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Vd.displayName = "TooltipPortalContext");
function C7() {
  const t = x.useContext(Vd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : et(70));
  return t;
}
const ma = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: i,
    render: s,
    style: l,
    ...a
  } = e, {
    portalNode: c,
    portalSubtree: u
  } = wh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: a
  });
  return !u && !c ? null : /* @__PURE__ */ F(x.Fragment, {
    children: [u, c && /* @__PURE__ */ an.createPortal(o, c)]
  });
});
process.env.NODE_ENV !== "production" && (ma.displayName = "FloatingPortalLite");
const Ad = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return xs().useState("mounted") || o ? /* @__PURE__ */ g(Vd.Provider, {
    value: o,
    children: /* @__PURE__ */ g(ma, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Ad.displayName = "TooltipPortal");
const Ld = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ld.displayName = "TooltipPositionerContext");
function a2() {
  const t = x.useContext(Ld);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : et(71));
  return t;
}
const Fd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "top",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = la,
    style: v,
    ...C
  } = e, y = xs(), w = C7(), R = y.useState("open"), S = y.useState("mounted"), E = y.useState("trackCursorAxis"), N = y.useState("disableHoverablePopup"), I = y.useState("floatingRootContext"), T = y.useState("instantType"), k = y.useState("transitionStatus"), P = y.useState("hasViewport"), M = oi({
    anchor: i,
    positionMethod: s,
    floatingRootContext: I,
    mounted: S,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    arrowPadding: p,
    disableAnchorTracking: h,
    keepMounted: w,
    collisionAvoidance: b,
    adaptiveOrigin: P ? fa : void 0
  }), D = x.useMemo(() => ({
    open: R,
    side: M.side,
    align: M.align,
    anchorHidden: M.anchorHidden,
    instant: E !== "none" ? "tracking-cursor" : T
  }), [R, M.side, M.align, M.anchorHidden, E, T]), O = si(e, D, {
    styles: M.positionerStyles,
    transitionStatus: k,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !S,
    inert: !R || E === "both" || N
  });
  return /* @__PURE__ */ g(Ld.Provider, {
    value: M,
    children: O
  });
});
process.env.NODE_ENV !== "production" && (Fd.displayName = "TooltipPositioner");
const w7 = {
  ...kn,
  ...zt
}, $d = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = xs(), {
    side: a,
    align: c
  } = a2(), u = l.useState("open"), d = l.useState("instantType"), f = l.useState("transitionStatus"), p = l.useState("popupProps"), m = l.useState("floatingRootContext");
  Yt({
    open: u,
    ref: l.context.popupRef,
    onComplete() {
      u && l.context.onOpenChangeComplete?.(!0);
    }
  });
  const h = l.useState("disabled"), b = l.useState("closeDelay");
  return ua(m, {
    enabled: !h,
    closeDelay: b
  }), Le("div", e, {
    state: {
      open: u,
      side: a,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    props: [p, Rr(f), s],
    stateAttributesMapping: w7
  });
});
process.env.NODE_ENV !== "production" && ($d.displayName = "TooltipPopup");
const Hd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = xs(), a = l.useState("open"), c = l.useState("instantType"), {
    arrowRef: u,
    side: d,
    align: f,
    arrowUncentered: p,
    arrowStyles: m
  } = a2();
  return Le("div", e, {
    state: {
      open: a,
      side: d,
      align: f,
      uncentered: p,
      instant: c
    },
    ref: [n, u],
    props: [{
      style: m,
      "aria-hidden": !0
    }, s],
    stateAttributesMapping: kn
  });
});
process.env.NODE_ENV !== "production" && (Hd.displayName = "TooltipArrow");
const c2 = function(e) {
  const {
    delay: n,
    closeDelay: o,
    timeout: r = 400
  } = e, i = x.useMemo(() => ({
    delay: n,
    closeDelay: o
  }), [n, o]), s = x.useMemo(() => ({
    open: n,
    close: o
  }), [n, o]);
  return /* @__PURE__ */ g(Dd.Provider, {
    value: i,
    children: /* @__PURE__ */ g(m8, {
      delay: s,
      timeoutMs: r,
      children: e.children
    })
  });
};
process.env.NODE_ENV !== "production" && (c2.displayName = "TooltipProvider");
const u2 = "z-[var(--z-overlay-tooltip,200)]", d2 = 5, f2 = 9, p2 = oe("max-w-[240px]", "rounded-(--radius-sm)", "px-(--spacing-12) py-(--spacing-8)", "bg-surface-inverse-surface", "text-text-inverse", "shadow-elevation-2", "font-(family-name:--font-family-body)", "transition-opacity duration-150 ease-in-out", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:opacity-0"), m2 = oe("text-(length:--font-size-label-small)", "leading-(--font-line-height-16)"), g2 = oe("text-(length:--font-size-label-xs)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "mt-(--spacing-4)"), h2 = oe("bg-surface-inverse-surface", "[&[data-side=top]]:h-(--spacing-6) [&[data-side=top]]:w-(--spacing-12)", "[&[data-side=bottom]]:h-(--spacing-6) [&[data-side=bottom]]:w-(--spacing-12)", "[&[data-side=left]]:h-(--spacing-12) [&[data-side=left]]:w-(--spacing-6)", "[&[data-side=right]]:h-(--spacing-12) [&[data-side=right]]:w-(--spacing-6)", "[&[data-side=top]]:-bottom-(--spacing-4) [&[data-side=top]]:[clip-path:polygon(50%_100%,0%_0%,100%_0%)]", "[&[data-side=bottom]]:-top-(--spacing-4) [&[data-side=bottom]]:[clip-path:polygon(50%_0%,0%_100%,100%_100%)]", "[&[data-side=left]]:-right-(--spacing-4) [&[data-side=left]]:[clip-path:polygon(100%_50%,0%_0%,0%_100%)]", "[&[data-side=right]]:-left-(--spacing-4) [&[data-side=right]]:[clip-path:polygon(0%_50%,100%_0%,100%_100%)]");
function qo(t) {
  const e = W.c(30), {
    children: n,
    label: o,
    description: r,
    endSection: i,
    side: s,
    align: l,
    disabled: a,
    showArrow: c
  } = t, u = s === void 0 ? "top" : s, d = l === void 0 ? "center" : l, f = a === void 0 ? !1 : a, p = c === void 0 ? !0 : c, m = Qt();
  let h;
  e[0] !== n ? (h = /* @__PURE__ */ g(_d, { render: n }), e[0] = n, e[1] = h) : h = e[1];
  const b = p ? f2 : d2;
  let v;
  e[2] !== p ? (v = p && /* @__PURE__ */ g(Hd, { "data-slot": "tooltip-arrow", className: h2 }), e[2] = p, e[3] = v) : v = e[3];
  const C = r ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let y;
  e[4] !== C ? (y = oe(m2, C), e[4] = C, e[5] = y) : y = e[5];
  let w;
  e[6] !== o || e[7] !== y ? (w = /* @__PURE__ */ g("p", { className: y, children: o }), e[6] = o, e[7] = y, e[8] = w) : w = e[8];
  let R;
  e[9] !== i || e[10] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-between gap-(--spacing-8)", children: [
    w,
    i
  ] }), e[9] = i, e[10] = w, e[11] = R) : R = e[11];
  let S;
  e[12] !== r ? (S = r && /* @__PURE__ */ g("p", { className: g2, children: r }), e[12] = r, e[13] = S) : S = e[13];
  let E;
  e[14] !== R || e[15] !== S || e[16] !== v ? (E = /* @__PURE__ */ F($d, { className: p2, children: [
    v,
    R,
    S
  ] }), e[14] = R, e[15] = S, e[16] = v, e[17] = E) : E = e[17];
  let N;
  e[18] !== d || e[19] !== u || e[20] !== E || e[21] !== b ? (N = /* @__PURE__ */ g(Fd, { side: u, align: d, sideOffset: b, className: u2, children: E }), e[18] = d, e[19] = u, e[20] = E, e[21] = b, e[22] = N) : N = e[22];
  let I;
  e[23] !== m || e[24] !== N ? (I = /* @__PURE__ */ g(Ad, { container: m, children: N }), e[23] = m, e[24] = N, e[25] = I) : I = e[25];
  let T;
  return e[26] !== f || e[27] !== I || e[28] !== h ? (T = /* @__PURE__ */ F(Od, { disabled: f, children: [
    h,
    I
  ] }), e[26] = f, e[27] = I, e[28] = h, e[29] = T) : T = e[29], T;
}
function Cs() {
  const t = W.c(10), [e, n] = x.useState(!1);
  let o, r;
  t[0] !== e ? (o = () => {
    if (!e)
      return;
    const u = function() {
      n(!1);
    };
    return document.addEventListener("mouseup", u), document.addEventListener("dragend", u), window.addEventListener("blur", u), () => {
      document.removeEventListener("mouseup", u), document.removeEventListener("dragend", u), window.removeEventListener("blur", u);
    };
  }, r = [e], t[0] = e, t[1] = o, t[2] = r) : (o = t[1], r = t[2]), x.useEffect(o, r);
  const i = e ? "" : void 0;
  let s, l;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = (u) => {
    u.defaultPrevented || u.button !== 0 || n(!0);
  }, l = () => n(!1), t[3] = s, t[4] = l) : (s = t[3], l = t[4]);
  let a;
  t[5] !== i ? (a = {
    "data-mouse-down": i,
    onMouseDown: s,
    onMouseUp: l
  }, t[5] = i, t[6] = a) : a = t[6];
  let c;
  return t[7] !== e || t[8] !== a ? (c = {
    mouseDown: e,
    triggerMouseDownProps: a
  }, t[7] = e, t[8] = a, t[9] = c) : c = t[9], c;
}
function S7(t) {
  const e = W.c(17), {
    align: n,
    disabled: o,
    items: r,
    size: i,
    tooltip: s,
    variant: l,
    ...a
  } = t, c = n === void 0 ? "end" : n, u = o === void 0 ? !1 : o, d = i === void 0 ? "md" : i, f = l === void 0 ? "default" : l, [p, m] = x.useState(!1), {
    triggerMouseDownProps: h
  } = Cs();
  let b;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = function(k) {
    m(k);
  }, e[0] = b) : b = e[0];
  const v = b, C = N7({
    disabled: u,
    isOpen: p,
    props: a,
    size: d,
    tooltip: s,
    triggerMouseDownProps: h,
    variant: f
  }), y = f === "combo" && "gap-(--spacing-4)";
  let w;
  e[1] !== y ? (w = oe("inline-flex items-center", y), e[1] = y, e[2] = w) : w = e[2];
  let R;
  e[3] !== w || e[4] !== C ? (R = /* @__PURE__ */ g("div", { className: w, children: C }), e[3] = w, e[4] = C, e[5] = R) : R = e[5];
  const S = R;
  let E;
  e[6] !== r ? (E = r.map(R7), e[6] = r, e[7] = E) : E = e[7];
  let N;
  e[8] !== c || e[9] !== E ? (N = /* @__PURE__ */ g(kr, { align: c, sideOffset: 5, size: "trigger", children: E }), e[8] = c, e[9] = E, e[10] = N) : N = e[10];
  let I;
  return e[11] !== u || e[12] !== v || e[13] !== p || e[14] !== N || e[15] !== S ? (I = /* @__PURE__ */ F(kd, { open: p, onOpenChange: v, disabled: u, modal: !1, children: [
    S,
    N
  ] }), e[11] = u, e[12] = v, e[13] = p, e[14] = N, e[15] = S, e[16] = I) : I = e[16], I;
}
function R7(t) {
  return t.type === "subheader" ? /* @__PURE__ */ g(su, { disabled: t.disabled, children: t.label }, t.id) : E7(t);
}
function Sp(t) {
  return /* @__PURE__ */ g(fr, { disabled: t.disabled, endSection: t.endSection, leadingIcon: t.leadingIcon, onClick: t.onSelect, tone: t.tone, children: t.label }, t.id);
}
function E7(t) {
  return t.submenuItems ? /* @__PURE__ */ g(fr, { disabled: t.disabled, leadingIcon: t.leadingIcon, tone: t.tone, submenu: t.submenuItems.map(Sp), children: t.label }, t.id) : Sp(t);
}
function N7({
  disabled: t,
  isOpen: e,
  props: n,
  size: o,
  tooltip: r,
  triggerMouseDownProps: i,
  variant: s
}) {
  const l = o === "lg" ? "md" : o, a = o === "lg" ? {
    width: 44,
    height: 44
  } : void 0;
  if (s === "combo") {
    const {
      buttonVariant: p = "outline",
      label: m,
      onPrimaryAction: h
    } = n, b = /* @__PURE__ */ g(Yo, { render: /* @__PURE__ */ g(gt, { "aria-label": `${m} menu`, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: l, style: a, variant: p, ...i }) });
    return /* @__PURE__ */ F(Ht, { children: [
      /* @__PURE__ */ g(M1, { disabled: t, onClick: h, size: o, variant: p, children: m }),
      r ? /* @__PURE__ */ g(qo, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ g("span", { className: "inline-flex", children: b }) }) : b
    ] });
  }
  if (s === "overflow") {
    const {
      "aria-label": p
    } = n, m = /* @__PURE__ */ g(Yo, { render: /* @__PURE__ */ g(gt, { "aria-label": p, disabled: t, icon: "ellipsis-dots", size: l, style: a, variant: "outline", ...i }) });
    return r ? /* @__PURE__ */ g(qo, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ g("span", { className: "inline-flex", children: m }) }) : m;
  }
  const {
    "aria-label": c,
    label: u
  } = n, d = {};
  c && (d["aria-label"] = c);
  const f = /* @__PURE__ */ g(Yo, { render: /* @__PURE__ */ g(M1, { ...d, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: o, variant: "outline", ...i, children: u }) });
  return r ? k7(f, r) : f;
}
function k7(t, e) {
  return /* @__PURE__ */ g(qo, { label: e, side: "top", align: "end", showArrow: !0, children: t });
}
const M7 = {
  xs: "size-(--spacing-40)",
  sm: "size-[60px]",
  md: "size-(--spacing-80)",
  lg: "size-[104px]",
  xl: "size-[120px]"
}, P7 = {
  xs: 40,
  sm: 60,
  md: 80,
  lg: 104,
  xl: 120
}, I7 = {
  xs: "6 6",
  sm: "8 6",
  md: "8 6",
  lg: "8 6",
  xl: "8 6"
}, T7 = {
  xs: 4,
  sm: 4,
  md: 0,
  lg: 2,
  xl: 0
};
function b2(t) {
  const e = W.c(19), {
    size: n,
    src: o,
    alt: r,
    selected: i,
    onClick: s,
    "aria-label": l
  } = t, a = n === void 0 ? "md" : n, c = M7[a], u = a === "sm" ? "focus-visible:ring-offset-1" : "focus-visible:ring-offset-2", d = !!s, f = i !== void 0, p = i === !1 && "opacity-50", m = i && "outline-solid outline-2 outline-primary outline-offset-2";
  let h;
  e[0] !== u || e[1] !== d || e[2] !== p || e[3] !== m ? (h = oe("relative inline-flex items-center justify-center shrink-0 overflow-hidden", "rounded-(--radius-sm)", p, m, d && ["cursor-pointer", "focus-visible:outline-none", "focus-visible:ring-2", u, "focus-visible:ring-datavis-blue-30"]), e[0] = u, e[1] = d, e[2] = p, e[3] = m, e[4] = h) : h = e[4];
  const b = h;
  let v;
  e[5] !== r || e[6] !== a || e[7] !== c || e[8] !== o ? (v = o ? /* @__PURE__ */ g("img", { src: o, alt: r, className: oe(c, "object-cover") }) : /* @__PURE__ */ F("div", { "data-slot": "thumbnail-frame", className: oe(c, "relative flex items-center justify-center rounded-(--radius-sm) bg-surface-container-lowest text-icon-main"), children: [
    /* @__PURE__ */ g(O7, { size: a }),
    /* @__PURE__ */ g(Ge, { name: "image-regular", size: a, tone: "inherit" })
  ] }), e[5] = r, e[6] = a, e[7] = c, e[8] = o, e[9] = v) : v = e[9];
  const C = v;
  if (d) {
    const w = f ? i : void 0;
    let R;
    return e[10] !== l || e[11] !== s || e[12] !== b || e[13] !== w || e[14] !== C ? (R = /* @__PURE__ */ g(Xn, { type: "button", className: b, "aria-label": l, "aria-pressed": w, onClick: s, children: C }), e[10] = l, e[11] = s, e[12] = b, e[13] = w, e[14] = C, e[15] = R) : R = e[15], R;
  }
  let y;
  return e[16] !== b || e[17] !== C ? (y = /* @__PURE__ */ g("div", { className: b, children: C }), e[16] = b, e[17] = C, e[18] = y) : y = e[18], y;
}
function O7(t) {
  const e = W.c(12), {
    size: n
  } = t, o = P7[n], r = o - 0.5, i = r - 3.5, s = I7[n], l = T7[n], a = `M 4 ${0.5} H ${i} A ${3.5} ${3.5} 0 0 1 ${r} 4`, c = `M ${r} 4 V ${i} A ${3.5} ${3.5} 0 0 1 ${i} ${r}`, u = `M ${i} ${r} H 4 A ${3.5} ${3.5} 0 0 1 ${0.5} ${i}`, d = `M ${0.5} ${i} V 4 A ${3.5} ${3.5} 0 0 1 4 ${0.5}`;
  let f;
  e[0] !== a || e[1] !== c || e[2] !== u || e[3] !== d ? (f = [a, c, u, d], e[0] = a, e[1] = c, e[2] = u, e[3] = d, e[4] = f) : f = e[4];
  const p = f, m = `0 0 ${o} ${o}`;
  let h;
  e[5] !== s || e[6] !== l || e[7] !== p ? (h = p.map((v) => /* @__PURE__ */ g("path", { "data-slot": "thumbnail-empty-stroke", className: "stroke-outline-subtle", d: v, strokeDasharray: s, strokeDashoffset: l, strokeLinecap: "butt", strokeLinejoin: "miter", strokeWidth: "1" }, v)), e[5] = s, e[6] = l, e[7] = p, e[8] = h) : h = e[8];
  let b;
  return e[9] !== m || e[10] !== h ? (b = /* @__PURE__ */ g("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", viewBox: m, children: h }), e[9] = m, e[10] = h, e[11] = b) : b = e[11], b;
}
const ai = {
  default: "text-text-default",
  subtle: "text-text-subtle",
  subtext: "text-text-subtext",
  disabled: "text-text-disabled",
  inverse: "text-text-inverse",
  inherit: "text-inherit",
  negative: "text-negative",
  positive: "text-positive",
  warning: "text-text-warning",
  informative: "text-text-informative"
}, ci = {
  start: "text-start",
  center: "text-center",
  end: "text-end"
}, D7 = {
  ...ci,
  justify: "text-justify"
}, ui = {
  true: "truncate",
  false: ""
}, ko = {
  regular: "font-(number:--font-weight-regular)",
  medium: "font-(number:--font-weight-medium)",
  semibold: "font-(number:--font-weight-semibold)",
  bold: "font-(number:--font-weight-bold)"
}, v2 = {
  true: "italic",
  false: "not-italic"
}, _7 = {
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4"
}, V7 = ae(["font-(family-name:--font-family-body)", "text-(length:--font-size-body-small)", "leading-(--line-height-16)", "font-(number:--font-weight-regular)"], {
  variants: {
    tone: ai,
    align: ci,
    truncate: ui
  },
  defaultVariants: {
    tone: "default"
  }
});
function aO({
  tone: t,
  align: e,
  truncate: n,
  as: o = "span",
  ...r
}) {
  return x.createElement(o, {
    className: V7({
      tone: t,
      align: e,
      truncate: n
    }),
    ...r
  });
}
const A7 = ae("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-lg)", "leading-(--line-height-64)", "tracking-[-0.25px]"],
      md: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-md)", "leading-(--line-height-52)", "tracking-normal"],
      sm: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-sm)", "leading-(--line-height-44)", "tracking-normal"]
    },
    tone: ai,
    align: ci,
    truncate: ui,
    weight: ko
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), L7 = {
  lg: "h1",
  md: "h1",
  sm: "h2"
};
function cO({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? L7[t] : "h1", a = i || l;
  return x.createElement(a, {
    className: A7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const F7 = ae("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-lg)", "leading-(--line-height-40)", "tracking-normal"],
      md: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-md)", "leading-(--line-height-36)", "tracking-normal"],
      sm: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-sm)", "leading-(--line-height-32)", "tracking-normal"]
    },
    tone: ai,
    align: ci,
    truncate: ui,
    weight: {
      medium: ko.medium,
      semibold: ko.semibold,
      bold: ko.bold
    }
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), $7 = {
  lg: "h2",
  md: "h3",
  sm: "h4"
};
function uO({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? $7[t] : "h3", a = i || l;
  return x.createElement(a, {
    className: F7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const H7 = ae("font-(family-name:--font-family-label)", {
  variants: {
    size: {
      lg: ["text-(length:--font-size-label-lg)", "leading-(--line-height-20)"],
      md: ["text-(length:--font-size-label-md)", "leading-(--line-height-20)"],
      sm: ["text-(length:--font-size-label-sm)", "leading-(--line-height-16)"],
      xs: ["text-(length:--font-size-label-xs)", "leading-(--line-height-16)"]
    },
    tone: ai,
    align: ci,
    truncate: ui,
    weight: ko,
    italic: v2
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "semibold",
    italic: !1
  }
});
function uo({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "semibold",
  italic: i = !1,
  as: s = "span",
  ...l
}) {
  return x.createElement(s, {
    className: H7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r,
      italic: i
    }),
    ...l
  });
}
const z7 = ae("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-lg)", "leading-(--line-height-24)", "tracking-[0.5px]"],
      md: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-md)", "leading-(--line-height-20)", "tracking-[0.25px]"],
      sm: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-sm)", "leading-(--line-height-16)", "tracking-[0.4px]"]
    },
    tone: ai,
    align: D7,
    truncate: ui,
    lineClamp: _7,
    weight: ko,
    italic: v2
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "regular",
    italic: !1
  }
});
function ln({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  lineClamp: r,
  weight: i = "regular",
  italic: s = !1,
  as: l = "p",
  ...a
}) {
  return x.createElement(l, {
    className: z7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      lineClamp: r,
      weight: i,
      italic: s
    }),
    ...a
  });
}
const B7 = ae("", {
  variants: {
    size: {
      xl: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xl)", "tracking-normal"],
      lg: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "tracking-[0.15px]"],
      md: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-md)", "tracking-[0.15px]"],
      sm: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-sm)", "tracking-[0.1px]"],
      xs: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xs)", "leading-(--line-height-16)", "tracking-[0.1px]"]
    },
    tone: ai,
    align: ci,
    truncate: ui,
    weight: {
      medium: ko.medium,
      semibold: ko.semibold,
      bold: ko.bold
    }
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), W7 = {
  xl: "h4",
  lg: "h5",
  md: "h5",
  sm: "h6",
  xs: "h6"
};
function Rn({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? W7[t] : "h5", a = i || l;
  return x.createElement(a, {
    className: B7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const U7 = ae(["flex", "h-full", "min-h-0", "min-w-0", "w-full", "flex-col", "overflow-hidden", "bg-surface", "pb-(--spacing-20)", "pt-(--spacing-10)"]), G7 = ae(["flex", "min-h-0", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-16)", "px-(--spacing-10)"]), Y7 = ae(["flex", "shrink-0", "items-center", "justify-between", "gap-(--spacing-8)", "px-(--spacing-8)", "py-(--spacing-8)"]), j7 = ae(["flex", "min-h-0", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-20)"]), K7 = ae(["flex", "shrink-0", "items-start", "gap-(--spacing-20)", "px-(--spacing-10)"]), q7 = ae(["flex", "min-w-0", "flex-1", "flex-col", "items-start", "gap-(--spacing-10)"]), Z7 = ae(["flex", "w-full", "flex-wrap", "items-center", "gap-x-(--spacing-6)", "gap-y-(--spacing-2)"]), X7 = ae(["flex", "flex-1", "min-h-0", "min-w-0", "flex-col", "gap-(--spacing-12)", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface-low", "px-(--spacing-4)", "pb-(--spacing-4)"]), Q7 = ae(["flex", "w-full", "max-w-[580px]", "min-w-0", "self-center", "flex-col"]), J7 = ae(["flex", "w-full", "flex-col", "gap-(--spacing-20)", "py-(--spacing-10)"]), ey = ae(["flex", "min-w-0", "flex-col"], {
  variants: {
    informative: {
      true: "gap-(--spacing-12)",
      false: "gap-(--spacing-6)"
    }
  },
  defaultVariants: {
    informative: !1
  }
}), ty = ae(["flex", "h-full", "min-h-0", "w-(--spacing-40)", "shrink-0", "flex-col", "items-center"]), ny = ae(["w-(--spacing-2)", "flex-1", "bg-outline-variant"]);
function oy(t) {
  const e = W.c(24), {
    content: n,
    detail: o,
    actions: r
  } = t, i = "title" in n ? n.title : void 0, s = "body" in n ? n.body : void 0, l = n.type === "observation" || n.type === "next-step" || n.type === "recommended-procedure", a = l ? "informative" : void 0;
  let c;
  e[0] !== l ? (c = ey({
    informative: l
  }), e[0] = l, e[1] = c) : c = e[1];
  let u;
  e[2] !== i ? (u = i ? /* @__PURE__ */ g(Rn, { size: "md", children: i }) : null, e[2] = i, e[3] = u) : u = e[3];
  let d;
  e[4] !== s || e[5] !== n.steps || e[6] !== n.type ? (d = n.type === "recommended-procedure" ? /* @__PURE__ */ g("ol", { className: "m-0 w-full list-decimal pl-(--spacing-20) text-(length:--font-size-body-medium) leading-(--font-line-height-20)", children: n.steps.map(ry) }) : s ? /* @__PURE__ */ g(ln, { size: "md", children: s }) : null, e[4] = s, e[5] = n.steps, e[6] = n.type, e[7] = d) : d = e[7];
  let f;
  e[8] !== n ? (f = "completion" in n && n.completion ? /* @__PURE__ */ g(ln, { size: "md", weight: "semibold", children: n.completion }) : null, e[8] = n, e[9] = f) : f = e[9];
  let p;
  e[10] !== o ? (p = o ? /* @__PURE__ */ g("div", { children: o }) : null, e[10] = o, e[11] = p) : p = e[11];
  let m;
  e[12] !== r ? (m = r ? /* @__PURE__ */ g("div", { className: "flex w-full items-center", children: r }) : null, e[12] = r, e[13] = m) : m = e[13];
  let h;
  e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f || e[18] !== p || e[19] !== m ? (h = /* @__PURE__ */ F("div", { className: c, children: [
    u,
    d,
    f,
    p,
    m
  ] }), e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p, e[19] = m, e[20] = h) : h = e[20];
  let b;
  return e[21] !== a || e[22] !== h ? (b = /* @__PURE__ */ g(Zc, { tone: a, children: h }), e[21] = a, e[22] = h, e[23] = b) : b = e[23], b;
}
function ry(t) {
  return /* @__PURE__ */ g("li", { children: t.content }, t.id);
}
function iy(t) {
  const e = W.c(35), {
    alert: n,
    isCurrentUser: o,
    showConnector: r,
    renderAlertDetail: i,
    renderAlertActions: s
  } = t, l = o ? "outbound" : "inbound";
  let a;
  e[0] !== n.author.initials || e[1] !== n.author.name || e[2] !== n.author.type ? (a = /* @__PURE__ */ g(Ur, { variant: n.author.type, initials: n.author.initials, "aria-label": n.author.name }), e[0] = n.author.initials, e[1] = n.author.name, e[2] = n.author.type, e[3] = a) : a = e[3];
  const c = a;
  let u;
  e[4] !== c || e[5] !== o || e[6] !== r ? (u = o ? null : /* @__PURE__ */ g(Tg, { children: r ? /* @__PURE__ */ F("div", { className: ty(), children: [
    /* @__PURE__ */ g("div", { className: "-mb-(--spacing-16) flex w-full items-center pb-(--spacing-24)", children: c }),
    /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-slot": "asset-alert-chat-connector-divider", className: ny() })
  ] }) : /* @__PURE__ */ g("div", { className: "pb-(--spacing-24)", children: c }) }), e[4] = c, e[5] = o, e[6] = r, e[7] = u) : u = e[7];
  let d;
  e[8] !== n.author.name ? (d = /* @__PURE__ */ g(uo, { size: "lg", weight: "medium", children: n.author.name }), e[8] = n.author.name, e[9] = d) : d = e[9];
  let f;
  e[10] !== n.author.type ? (f = n.author.type === "internal" ? /* @__PURE__ */ g(qv, { size: "compact", "aria-hidden": "true", "data-slot": "asset-alert-chat-author-logo" }) : null, e[10] = n.author.type, e[11] = f) : f = e[11];
  let p;
  e[12] !== n.timestamp ? (p = n.timestamp ? /* @__PURE__ */ F(Ht, { children: [
    /* @__PURE__ */ g(uo, { size: "xs", tone: "subtle", weight: "semibold", children: "•" }),
    /* @__PURE__ */ g(uo, { size: "lg", tone: "subtle", weight: "medium", children: n.timestamp })
  ] }) : null, e[12] = n.timestamp, e[13] = p) : p = e[13];
  let m;
  e[14] !== d || e[15] !== f || e[16] !== p ? (m = /* @__PURE__ */ F(Og, { children: [
    d,
    f,
    p
  ] }), e[14] = d, e[15] = f, e[16] = p, e[17] = m) : m = e[17];
  let h;
  e[18] !== n || e[19] !== i ? (h = i?.(n), e[18] = n, e[19] = i, e[20] = h) : h = e[20];
  let b;
  e[21] !== n || e[22] !== s ? (b = s?.(n), e[21] = n, e[22] = s, e[23] = b) : b = e[23];
  let v;
  e[24] !== n.content || e[25] !== h || e[26] !== b ? (v = /* @__PURE__ */ g(Lv, { children: /* @__PURE__ */ g(oy, { content: n.content, detail: h, actions: b }) }), e[24] = n.content, e[25] = h, e[26] = b, e[27] = v) : v = e[27];
  let C;
  e[28] !== m || e[29] !== v ? (C = /* @__PURE__ */ F(qc, { children: [
    m,
    v
  ] }), e[28] = m, e[29] = v, e[30] = C) : C = e[30];
  let y;
  return e[31] !== l || e[32] !== C || e[33] !== u ? (y = /* @__PURE__ */ F(Kc, { direction: l, children: [
    u,
    C
  ] }), e[31] = l, e[32] = C, e[33] = u, e[34] = y) : y = e[34], y;
}
function sy(t, e) {
  return t.author.type === "internal" && e?.author.type === "internal" && t.author.id === e.author.id && !e.dateLabel;
}
function ly(t) {
  const e = W.c(4), {
    messageId: n
  } = t, {
    scrollToEnd: o
  } = gg(), r = ut(n);
  let i, s;
  return e[0] !== n || e[1] !== o ? (i = () => {
    n && r.current !== n && o(), r.current = n;
  }, s = [n, o], e[0] = n, e[1] = o, e[2] = i, e[3] = s) : (i = e[2], s = e[3]), _t(i, s), null;
}
function dO({
  title: t,
  titleAccessory: e,
  assetSummary: n,
  sections: o,
  alerts: r,
  currentUserId: i,
  activeSectionId: s,
  onSectionChange: l,
  headerMenuItems: a,
  onClose: c,
  renderAlertDetail: u,
  renderAlertActions: d,
  composer: f
}) {
  const p = Xt(), m = `asset-alert-${p}-details`, [h, b] = tt(!1), v = new Set(o.map((k) => k.id)), C = new Map(o.map((k) => [k.id, `asset-alert-${p}-${k.id}`])), y = /* @__PURE__ */ new Set(), w = r.map((k) => {
    const P = k.sectionId, M = P && v.has(P) && !y.has(P) ? C.get(P) : void 0;
    return P && M && y.add(P), {
      alert: k,
      anchorId: M
    };
  }), R = U5(o.filter((k) => y.has(k.id)).map((k) => C.get(k.id) ?? k.id)), S = ut(R.activeId), E = r.reduce((k, P) => P.author.id === i ? P.id : k, void 0), N = s === void 0 ? R.activeId : y.has(s) ? C.get(s) : void 0;
  function I(k) {
    R.scrollRef.current = k;
  }
  function T(k) {
    S.current = k, R.onActiveChange(k);
    const P = o.find((M) => C.get(M.id) === k);
    P && l?.(P.id);
  }
  return _t(() => {
    if (S.current === R.activeId)
      return;
    S.current = R.activeId;
    const k = o.find((P) => C.get(P.id) === R.activeId);
    k && l?.(k.id);
  }, [R.activeId, l, C, o]), /* @__PURE__ */ g("section", { "aria-label": typeof t == "string" ? t : "Asset alert chat", className: U7(), "data-slot": "asset-alert-chat", children: /* @__PURE__ */ F("div", { className: G7(), children: [
    /* @__PURE__ */ F("header", { className: Y7(), "data-slot": "asset-alert-chat-header", children: [
      /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 flex-wrap items-center gap-(--spacing-8)", children: [
        /* @__PURE__ */ g(Rn, { as: "h2", size: "lg", truncate: !0, children: t }),
        e
      ] }),
      /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-10)", children: [
        a?.length ? /* @__PURE__ */ g(S7, { label: "View", items: a, size: "sm" }) : null,
        c ? /* @__PURE__ */ g(gt, { icon: "x-close", variant: "ghost", size: "md", "aria-label": "Close asset chat", onClick: c }) : null
      ] })
    ] }),
    /* @__PURE__ */ F("div", { className: j7(), children: [
      n ? /* @__PURE__ */ F("div", { className: K7(), "data-slot": "asset-alert-chat-summary", children: [
        /* @__PURE__ */ g(b2, { ...n.thumbnail, size: h ? "xl" : "sm" }),
        /* @__PURE__ */ F("div", { className: q7(), children: [
          /* @__PURE__ */ g(Rn, { as: "h3", size: "sm", truncate: !0, children: n.name }),
          /* @__PURE__ */ g("div", { id: m, hidden: !h, className: "flex w-full flex-col items-start gap-(--spacing-10)", children: h ? /* @__PURE__ */ F(Ht, { children: [
            n.metrics.length > 0 ? /* @__PURE__ */ g("div", { className: Z7(), children: n.metrics.map((k, P) => /* @__PURE__ */ F("span", { className: "contents", children: [
              P > 0 ? /* @__PURE__ */ g("span", { className: "inline-flex h-(--spacing-16) w-(--spacing-2) shrink-0 items-stretch self-center", children: /* @__PURE__ */ g(mr, { orientation: "vertical" }) }) : null,
              /* @__PURE__ */ F("span", { className: "inline-flex h-(--spacing-24) min-w-0 items-center gap-(--spacing-4)", children: [
                /* @__PURE__ */ F(ln, { as: "span", size: "md", tone: "subtle", truncate: !0, children: [
                  k.label,
                  ":"
                ] }),
                /* @__PURE__ */ g("span", { children: /* @__PURE__ */ g(ln, { as: "span", size: "md", truncate: !0, children: k.value }) })
              ] })
            ] }, k.id)) }) : null,
            /* @__PURE__ */ g(fo, { ...n.status })
          ] }) : null }),
          /* @__PURE__ */ g(An, { variant: "ghost", size: "sm", icon: h ? "chevron-up" : "chevron-down", "aria-controls": m, "aria-expanded": h, onClick: () => b((k) => !k), children: h ? "Hide details" : "View details" })
        ] })
      ] }) : null,
      o.length > 0 ? /* @__PURE__ */ g(W5, { orientation: "horizontal", activeId: N, onActiveChange: T, scrollRef: R.scrollRef, startScrollLock: R.startScrollLock, children: o.map((k) => /* @__PURE__ */ g(B5, { targetId: C.get(k.id) ?? k.id, disabled: !y.has(k.id), children: k.label }, k.id)) }) : null,
      /* @__PURE__ */ F("div", { className: X7(), children: [
        /* @__PURE__ */ F(Dg, { defaultScrollPosition: "start", children: [
          /* @__PURE__ */ F(_g, { ref: I, "aria-label": "Asset alert transcript", children: [
            /* @__PURE__ */ g(Vg, { children: w.length === 0 ? /* @__PURE__ */ g("div", { className: "flex min-h-full items-center justify-center text-center", children: /* @__PURE__ */ g(ln, { tone: "subtle", children: "No alerts to display." }) }) : w.map(({
              alert: k,
              anchorId: P
            }, M) => {
              const D = w[M + 1]?.alert, O = /* @__PURE__ */ g(iy, { alert: k, isCurrentUser: k.author.id === i, showConnector: sy(k, D), renderAlertDetail: u, renderAlertActions: d });
              return /* @__PURE__ */ g(bl, { id: P, messageId: k.id, children: /* @__PURE__ */ g("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ F("div", { className: Q7(), "data-slot": "asset-alert-chat-alerts", children: [
                k.dateLabel ? /* @__PURE__ */ F("div", { className: J7(), children: [
                  /* @__PURE__ */ g(mr, { centeredText: k.dateLabel }),
                  O
                ] }) : null,
                k.dateLabel ? null : O
              ] }) }) }, k.id);
            }) }),
            /* @__PURE__ */ g(ly, { messageId: E })
          ] }),
          /* @__PURE__ */ g(Ag, {})
        ] }),
        f ? /* @__PURE__ */ g("div", { className: "px-(--spacing-4)", children: f }) : null
      ] })
    ] })
  ] }) });
}
function ws(t, e) {
  const n = typeof window < "u" && typeof window.matchMedia < "u";
  t = t.replace(/^@media( ?)/m, "");
  const {
    defaultMatches: o = !1,
    matchMedia: r = n ? window.matchMedia : null,
    ssrMatchMedia: i = null,
    noSsr: s = !1
  } = e, l = x.useCallback(() => o, [o]), a = x.useMemo(() => {
    if (s && r)
      return () => r(t).matches;
    if (i !== null) {
      const {
        matches: f
      } = i(t);
      return () => f;
    }
    return l;
  }, [l, t, i, s, r]), [c, u] = x.useMemo(() => {
    if (r === null)
      return [l, () => () => {
      }];
    const f = r(t);
    return [() => f.matches, (p) => at(f, "change", p)];
  }, [l, r, t]), d = ad.useSyncExternalStore(u, c, a);
  return process.env.NODE_ENV !== "production" && x.useDebugValue({
    query: t,
    match: d
  }), d;
}
const ay = ae(["inline-flex", "rounded-full"], {
  variants: {
    tone: {
      urgent: "bg-error",
      activity: "bg-primary",
      info: "bg-informative"
    },
    variant: {
      dot: "size-(--spacing-6)",
      pill: "items-center justify-center min-w-(--spacing-16) h-(--spacing-16) px-(--spacing-4) py-[3px]"
    }
  },
  defaultVariants: {
    tone: "urgent",
    variant: "dot"
  }
}), cy = ae(["font-(family-name:--font-family-body)", "font-normal", "text-(length:--font-size-body-small)", "leading-[11px]", "text-center"], {
  variants: {
    tone: {
      urgent: "text-error-on-error",
      activity: "text-primary-on-primary",
      info: "text-text-inverse"
    }
  },
  defaultVariants: {
    tone: "urgent"
  }
});
function lu(t) {
  const e = W.c(28);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    tone: l,
    count: r,
    visible: a,
    "aria-hidden": n,
    "aria-label": o,
    style: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "urgent" : l, u = a === void 0 ? !0 : a, d = r === void 0;
  let f;
  e[8] !== r || e[9] !== d ? (f = d ? void 0 : String(r).slice(0, 3), e[8] = r, e[9] = d, e[10] = f) : f = e[10];
  const p = f, m = !u || !o || n === !0 || n === "true" ? !0 : void 0, h = d ? "dot" : "pill";
  let b;
  e[11] !== h || e[12] !== c ? (b = ay({
    tone: c,
    variant: h
  }), e[11] = h, e[12] = c, e[13] = b) : b = e[13];
  let v;
  e[14] !== s || e[15] !== u ? (v = u ? s : {
    ...s,
    visibility: "hidden"
  }, e[14] = s, e[15] = u, e[16] = v) : v = e[16];
  let C;
  e[17] !== p || e[18] !== d || e[19] !== c ? (C = !d && /* @__PURE__ */ g("span", { className: cy({
    tone: c
  }), children: p }), e[17] = p, e[18] = d, e[19] = c, e[20] = C) : C = e[20];
  let y;
  return e[21] !== o || e[22] !== m || e[23] !== i || e[24] !== b || e[25] !== v || e[26] !== C ? (y = /* @__PURE__ */ g("span", { ...i, role: "img", "aria-hidden": m, "aria-label": o, className: b, style: v, children: C }), e[21] = o, e[22] = m, e[23] = i, e[24] = b, e[25] = v, e[26] = C, e[27] = y) : y = e[27], y;
}
const zd = go("none"), uy = ae(["grid", "h-full", "min-h-0", "min-w-0", "w-full", "overflow-hidden", "relative", "rounded-(--radius-md)", "after:pointer-events-none", "after:absolute", "after:inset-0", "after:z-10", "after:rounded-(--radius-md)", "after:border", "after:border-outline-subtle", "after:content-['']", "bg-surface", "shadow-elevation-4", "text-text-default", "max-[599px]:grid-cols-1"], {
  variants: {
    sidebar: {
      none: "grid-cols-[minmax(0,1fr)]",
      expanded: "grid-cols-[240px_minmax(0,1fr)]",
      collapsed: "grid-cols-[56px_minmax(0,1fr)]"
    }
  },
  defaultVariants: {
    sidebar: "none"
  }
}), dy = ae(["min-h-0", "min-w-0", "overflow-hidden", "relative", "after:pointer-events-none", "after:absolute", "after:inset-y-0", "after:right-0", "after:border-r", "after:border-outline-subtle", "after:content-['']", "bg-surface", "max-[599px]:hidden"], {
  variants: {
    sidebar: {
      expanded: "block",
      collapsed: "block",
      none: "hidden"
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), fy = ae([], {
  variants: {
    sidebar: {
      expanded: ["flex", "items-center", "justify-between"],
      collapsed: ["relative", "flex", "w-(--spacing-48)", "justify-center"]
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), py = ae([], {
  variants: {
    sidebar: {
      expanded: "shrink-0",
      collapsed: ["absolute", "-right-(--spacing-4)", "-top-(--spacing-4)"]
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), my = ae(["flex", "min-w-0", "min-h-0", "flex-col", "bg-surface"]), gy = ae(["flex", "shrink-0", "items-center", "gap-(--spacing-12)", "border-b", "border-outline-subtle", "bg-surface", "px-(--spacing-20)", "py-(--spacing-16)"]), hy = ae(["min-h-0", "flex-1", "overflow-hidden"]), by = ae(["shrink-0", "min-w-0", "bg-surface", "p-(--spacing-16)"]);
function Rp(t) {
  const e = W.c(14);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    sidebar: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r ?? "none";
  let s;
  e[4] !== i ? (s = oe(uy({
    sidebar: i
  })), e[4] = i, e[5] = s) : s = e[5];
  let l;
  e[6] !== n || e[7] !== o || e[8] !== i || e[9] !== s ? (l = /* @__PURE__ */ g("section", { "data-slot": "chat-panel", "data-sidebar": i, className: s, ...o, children: n }), e[6] = n, e[7] = o, e[8] = i, e[9] = s, e[10] = l) : l = e[10];
  let a;
  return e[11] !== i || e[12] !== l ? (a = /* @__PURE__ */ g(zd, { value: i, children: l }), e[11] = i, e[12] = l, e[13] = a) : a = e[13], a;
}
function vy(t) {
  const e = W.c(9);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = mn(zd);
  let i;
  e[3] !== r ? (i = oe(dy({
    sidebar: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== i ? (s = /* @__PURE__ */ g("aside", { "data-slot": "chat-panel-sidebar", className: i, ...o, children: n }), e[5] = n, e[6] = o, e[7] = i, e[8] = s) : s = e[8], s;
}
function Ep(t) {
  const e = W.c(16);
  let n, o, r, i;
  e[0] !== t ? ({
    badge: n,
    children: o,
    sidebar: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = mn(zd), l = i ?? (s === "collapsed" ? "collapsed" : "expanded");
  let a;
  e[5] !== l ? (a = oe(fy({
    sidebar: l
  })), e[5] = l, e[6] = a) : a = e[6];
  let c;
  e[7] !== n || e[8] !== l ? (c = n && /* @__PURE__ */ g("span", { className: oe(py({
    sidebar: l
  })), "data-slot": "chat-panel-sidebar-badge", children: /* @__PURE__ */ g(lu, { count: n.count, tone: n.tone, "aria-label": n.label }) }), e[7] = n, e[8] = l, e[9] = c) : c = e[9];
  let u;
  return e[10] !== o || e[11] !== r || e[12] !== l || e[13] !== a || e[14] !== c ? (u = /* @__PURE__ */ F("header", { "data-slot": "chat-panel-sidebar-header", "data-sidebar": l, className: a, ...r, children: [
    o,
    c
  ] }), e[10] = o, e[11] = r, e[12] = l, e[13] = a, e[14] = c, e[15] = u) : u = e[15], u;
}
function Np(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(my()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { "data-slot": "chat-panel-main", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function fO(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(gy()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("header", { "data-slot": "chat-panel-header", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function kp(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(hy()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { "data-slot": "chat-panel-body", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function yy(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(by()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("footer", { "data-slot": "chat-panel-footer", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function xy() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ F("output", { className: "inline-flex items-center gap-[5px] rounded-(--radius-xl) bg-surface-container px-[14px] py-(--spacing-10)", "aria-label": "AI is typing", children: [
    /* @__PURE__ */ g("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" }),
    /* @__PURE__ */ g("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" }),
    /* @__PURE__ */ g("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" })
  ] }), t[0] = e) : e = t[0], e;
}
const Cy = 4;
function Ri(t) {
  if (!t) return 0;
  const e = t.getBoundingClientRect().width;
  return e > 0 ? e : t.offsetWidth;
}
function wy(t) {
  const e = Number.parseFloat(getComputedStyle(t).columnGap);
  return Number.isFinite(e) ? e : Cy;
}
function Sy(t, e) {
  return t.reduce((o, r) => o + r, 0) + Math.max(0, t.length - 1) * e;
}
function Mp({
  itemWidths: t,
  reservedStartWidth: e,
  reservedEndWidth: n,
  overflowWidth: o
}) {
  return [...e > 0 ? [e] : [], ...t, ...o && o > 0 ? [o] : [], ...n > 0 ? [n] : []];
}
function Pp(t, e, n, o) {
  if (t.length === 0) return !0;
  if (o <= 1) return Sy(t, n) <= e;
  let r = 1, i = 0;
  for (const s of t) {
    const l = i === 0 ? s : i + n + s;
    if (l <= e || i === 0) {
      i = l;
      continue;
    }
    if (r += 1, i = s, r > o) return !1;
  }
  return !0;
}
function y2({
  items: t,
  maxRows: e = 1,
  minVisibleItems: n = t.length > 0 ? 1 : 0
}) {
  const o = ut(null), r = ut(null), i = ut(null), s = ut(null), l = ut([]), a = ut({}), c = ut(() => {
  }), [u, d] = tt(Number.POSITIVE_INFINITY), f = t.length === 0 ? 0 : Math.max(n, Math.min(u, t.length)), p = t.slice(0, f), m = t.length - p.length;
  return c.current = () => {
    const h = o.current;
    function b(E) {
      d((N) => N === E ? N : E);
    }
    if (!h || t.length <= n) {
      b(t.length);
      return;
    }
    const v = Ri(h), C = wy(h), y = Ri(i.current), w = Ri(s.current), R = t.map((E, N) => Ri(l.current[N])), S = Mp({
      itemWidths: R,
      reservedStartWidth: y,
      reservedEndWidth: w
    });
    if (Pp(S, v, C, e)) {
      b(t.length);
      return;
    }
    for (let E = t.length - 1; E >= n; E -= 1) {
      const N = t.length - E, I = Ri(a.current[N]), T = Mp({
        itemWidths: R.slice(0, E),
        reservedStartWidth: y,
        reservedEndWidth: w,
        overflowWidth: I
      });
      if (Pp(T, v, C, e)) {
        b(E);
        return;
      }
    }
    b(n);
  }, Po(() => {
    c.current();
  }), Po(() => {
    const h = o.current;
    if (typeof ResizeObserver > "u" || !h) return;
    const b = new ResizeObserver(() => {
      c.current();
    });
    return b.observe(h), r.current && b.observe(r.current), () => b.disconnect();
  }, []), {
    containerRef: o,
    measuringContainerRef: r,
    reservedStartRef: i,
    reservedEndRef: s,
    itemRefs: l,
    overflowRefs: a,
    visibleItems: p,
    overflowCount: m
  };
}
const Ry = ae([
  "inline-flex",
  "items-center",
  "justify-center",
  "gap-(--spacing-4)",
  "h-(--spacing-24)",
  "rounded-(--radius-sm)",
  "px-(--spacing-6)",
  "py-(--spacing-4)",
  "border",
  "border-solid",
  "whitespace-nowrap",
  "overflow-hidden",
  "text-ellipsis",
  "font-(family-name:--font-family-body)",
  "font-(number:--font-weight-medium)",
  "text-(length:--font-size-label-medium)",
  "leading-(--font-line-height-16)",
  "cursor-pointer",
  "select-none",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "[&_svg]:pointer-events-none",
  "[&_svg]:shrink-0",
  // Default state
  "bg-tag-default-background",
  "border-tag-default-outline",
  "text-tag-default-text",
  // Hover state
  "hover:bg-tag-hover-background",
  "hover:border-tag-hover-outline",
  // Pressed state
  "active:bg-tag-pressed-background",
  "active:border-tag-pressed-outline",
  // Focus state
  "focus-visible:ring-2",
  "focus-visible:ring-offset-1",
  "focus-visible:ring-offset-tag-default-background",
  "focus-visible:ring-tag-focus-ring"
]), Ey = {
  neutral: "text-tag-icon-default",
  brand: "text-tag-icon-brand",
  positive: "text-tag-icon-positive",
  warning: "text-tag-icon-warning",
  negative: "text-tag-icon-negative"
};
function au(t) {
  const e = W.c(20);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    icon: o,
    iconTone: i,
    disabled: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "neutral" : i, a = s === void 0 ? !1 : s, c = o ? l : void 0;
  let u;
  e[6] !== a ? (u = oe(Ry(), a && "opacity-50 pointer-events-none cursor-default"), e[6] = a, e[7] = u) : u = e[7];
  const d = a || void 0, f = a ? -1 : void 0;
  let p;
  e[8] !== o || e[9] !== l ? (p = o && /* @__PURE__ */ g("span", { className: oe("inline-flex items-center", Ey[l]), children: /* @__PURE__ */ g(Ge, { name: o, size: "xs", tone: "inherit" }) }), e[8] = o, e[9] = l, e[10] = p) : p = e[10];
  let m;
  return e[11] !== n || e[12] !== a || e[13] !== r || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f || e[18] !== p ? (m = /* @__PURE__ */ F(Xn, { "data-slot": "tag", "data-icon-tone": c, className: u, disabled: a, "aria-disabled": d, tabIndex: f, ...r, children: [
    p,
    n
  ] }), e[11] = n, e[12] = a, e[13] = r, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p, e[19] = m) : m = e[19], m;
}
const Ny = ae(["flex", "min-w-0", "w-full", "flex-col"]), ky = ae(["relative", "flex", "min-w-0", "flex-col", "gap-(--spacing-32)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:not([data-disabled=true]):focus-within]:border-input-active-outline", "[&_[data-slot=icon-button]]:text-icon-main"], {
  variants: {
    hasAlert: {
      true: ["rounded-t-none"],
      false: []
    },
    disabled: {
      true: ["opacity-50", "cursor-not-allowed", "[&_textarea]:cursor-not-allowed", "[&_[data-slot=button]:disabled]:opacity-100", "[&_[data-slot=icon-button]:disabled]:opacity-100"],
      false: []
    }
  },
  defaultVariants: {
    hasAlert: !1,
    disabled: !1
  }
}), My = ae(["[&>div]:rounded-b-none"]), Py = ae(["min-w-0", "w-full", "[field-sizing:content]", "max-h-(--spacing-128)", "outline-none", "bg-transparent", "resize-none", "overflow-y-auto", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder"]), Iy = ae(["flex", "min-w-0", "w-full", "flex-col", "gap-(--spacing-16)"]), Ty = ae(["relative", "flex", "flex-col", "gap-(--spacing-12)"]), Oy = ae(["inline-flex", "h-(--spacing-24)", "items-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-label-sm)", "leading-(--font-line-height-16)", "text-text-subtle", "uppercase"]), Dy = ae(["flex", "flex-wrap", "items-center", "gap-(--spacing-8)"]), _y = ae(["flex", "items-center", "gap-(--spacing-32)"], {
  variants: {
    showUpload: {
      true: "justify-between",
      false: "justify-end"
    }
  },
  defaultVariants: {
    showUpload: !0
  }
});
function Vy(t) {
  const e = W.c(59), {
    value: n,
    onChange: o,
    placeholder: r,
    "aria-label": i,
    disabled: s,
    onSend: l,
    clearOnSend: a,
    onUpload: c,
    showUpload: u,
    alert: d,
    suggestedUpdates: f
  } = t, p = i === void 0 ? "Message" : i, m = a === void 0 ? !0 : a, h = u === void 0 ? !0 : u;
  let b;
  e[0] !== f ? (b = f === void 0 ? [] : f, e[0] = f, e[1] = b) : b = e[1];
  const v = b, C = ut(null), [y, w] = tt(!1);
  let R;
  e[2] !== n ? (R = n.trim(), e[2] = n, e[3] = R) : R = e[3];
  const S = R.length > 0, E = s || !l || !S;
  let N;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = function(ne) {
    const se = C.current;
    if (!se)
      return;
    Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value")?.set?.call(se, ne), se.dispatchEvent(new Event("input", {
      bubbles: !0
    }));
  }, e[4] = N) : N = e[4];
  const I = N;
  let T;
  e[5] !== m || e[6] !== E || e[7] !== l ? (T = function() {
    E || (l?.(), m && I(""));
  }, e[5] = m, e[6] = E, e[7] = l, e[8] = T) : T = e[8];
  const k = T;
  let P;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = function(ne) {
    I(ne.value), C.current?.focus();
  }, e[9] = P) : P = e[9];
  const M = P;
  let D;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = function() {
    w(Ay);
  }, e[10] = D) : D = e[10];
  const O = D;
  let _;
  e[11] !== k || e[12] !== E || e[13] !== l ? (_ = function(ne) {
    if (ne.key === "Escape") {
      ne.currentTarget.blur();
      return;
    }
    if (ne.key === "Enter" && !ne.shiftKey && !ne.nativeEvent.isComposing && l) {
      if (ne.preventDefault(), E)
        return;
      k();
    }
  }, e[11] = k, e[12] = E, e[13] = l, e[14] = _) : _ = e[14];
  const V = _, A = !!d;
  let L;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (L = Ny(), e[15] = L) : L = e[15];
  let $;
  e[16] !== d || e[17] !== A ? ($ = A ? /* @__PURE__ */ g("div", { className: My(), children: d }) : null, e[16] = d, e[17] = A, e[18] = $) : $ = e[18];
  const Y = s || void 0;
  let G;
  e[19] !== s || e[20] !== A ? (G = ky({
    disabled: s,
    hasAlert: A
  }), e[19] = s, e[20] = A, e[21] = G) : G = e[21];
  let j;
  e[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (j = Iy(), e[22] = j) : j = e[22];
  let Z;
  e[23] !== s || e[24] !== v || e[25] !== y ? (Z = v.length > 0 && /* @__PURE__ */ g(Ly, { disabled: s, suggestedUpdates: v, suggestedUpdatesCollapsed: y, onToggleSuggestedUpdates: O, onSelectSuggestedUpdate: M }), e[23] = s, e[24] = v, e[25] = y, e[26] = Z) : Z = e[26];
  let U;
  e[27] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (U = Py(), e[27] = U) : U = e[27];
  let q;
  e[28] !== p || e[29] !== s || e[30] !== V || e[31] !== o || e[32] !== r || e[33] !== n ? (q = /* @__PURE__ */ g("textarea", { ref: C, rows: 1, value: n, onChange: o, onKeyDown: V, placeholder: r, disabled: s, "aria-label": p, className: U }), e[28] = p, e[29] = s, e[30] = V, e[31] = o, e[32] = r, e[33] = n, e[34] = q) : q = e[34];
  let te;
  e[35] !== Z || e[36] !== q ? (te = /* @__PURE__ */ F("div", { className: j, children: [
    Z,
    q
  ] }), e[35] = Z, e[36] = q, e[37] = te) : te = e[37];
  let H;
  e[38] !== h ? (H = _y({
    showUpload: h
  }), e[38] = h, e[39] = H) : H = e[39];
  let X;
  e[40] !== s || e[41] !== c || e[42] !== h ? (X = h && /* @__PURE__ */ g(gt, { icon: "upload", variant: "ghost", size: "sm", "aria-label": "Upload file", disabled: s, onClick: c }), e[40] = s, e[41] = c, e[42] = h, e[43] = X) : X = e[43];
  let ee;
  e[44] !== k || e[45] !== E ? (ee = /* @__PURE__ */ g(An, { type: "button", variant: "primary", size: "sm", icon: "send", disabled: E, onClick: k, children: "Send" }), e[44] = k, e[45] = E, e[46] = ee) : ee = e[46];
  let le;
  e[47] !== H || e[48] !== X || e[49] !== ee ? (le = /* @__PURE__ */ F("div", { className: H, children: [
    X,
    ee
  ] }), e[47] = H, e[48] = X, e[49] = ee, e[50] = le) : le = e[50];
  let Q;
  e[51] !== Y || e[52] !== G || e[53] !== te || e[54] !== le ? (Q = /* @__PURE__ */ F("div", { "data-disabled": Y, className: G, children: [
    te,
    le
  ] }), e[51] = Y, e[52] = G, e[53] = te, e[54] = le, e[55] = Q) : Q = e[55];
  let re;
  return e[56] !== $ || e[57] !== Q ? (re = /* @__PURE__ */ F("div", { className: L, children: [
    $,
    Q
  ] }), e[56] = $, e[57] = Q, e[58] = re) : re = e[58], re;
}
function Ay(t) {
  return !t;
}
function Ly(t) {
  const e = W.c(39), {
    disabled: n,
    suggestedUpdates: o,
    suggestedUpdatesCollapsed: r,
    onToggleSuggestedUpdates: i,
    onSelectSuggestedUpdate: s
  } = t;
  let l;
  e[0] !== o ? (l = {
    items: o,
    maxRows: 2,
    minVisibleItems: 0
  }, e[0] = o, e[1] = l) : l = e[1];
  const {
    containerRef: a,
    measuringContainerRef: c,
    reservedStartRef: u,
    reservedEndRef: d,
    itemRefs: f,
    visibleItems: p
  } = y2(l);
  let m;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = Ty(), e[2] = m) : m = e[2];
  let h;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = Dy(), e[3] = h) : h = e[3];
  let b;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = Oy(), e[4] = b) : b = e[4];
  let v;
  e[5] !== u ? (v = /* @__PURE__ */ g("span", { ref: u, className: b, children: "Suggested Updates" }), e[5] = u, e[6] = v) : v = e[6];
  let C;
  e[7] !== n || e[8] !== s || e[9] !== r || e[10] !== p ? (C = !r && p.map((D) => /* @__PURE__ */ g(au, { type: "button", disabled: n, onClick: () => s(D), children: D.label }, `${D.label}-${D.value}`)), e[7] = n, e[8] = s, e[9] = r, e[10] = p, e[11] = C) : C = e[11];
  const y = r ? "eye-watching" : "eye-slash-regular", w = r ? "Show suggested updates" : "Hide suggested updates", R = !r, S = r ? "Show" : "Hide";
  let E;
  e[12] !== n || e[13] !== i || e[14] !== S || e[15] !== y || e[16] !== w || e[17] !== R ? (E = /* @__PURE__ */ g(An, { type: "button", variant: "ghost", size: "sm", icon: y, "aria-label": w, "aria-expanded": R, disabled: n, onClick: i, children: S }), e[12] = n, e[13] = i, e[14] = S, e[15] = y, e[16] = w, e[17] = R, e[18] = E) : E = e[18];
  let N;
  e[19] !== d || e[20] !== E ? (N = /* @__PURE__ */ g("span", { ref: d, className: "inline-flex", children: E }), e[19] = d, e[20] = E, e[21] = N) : N = e[21];
  let I;
  e[22] !== a || e[23] !== N || e[24] !== v || e[25] !== C ? (I = /* @__PURE__ */ F("div", { ref: a, className: h, children: [
    v,
    C,
    N
  ] }), e[22] = a, e[23] = N, e[24] = v, e[25] = C, e[26] = I) : I = e[26];
  let T;
  if (e[27] !== f || e[28] !== o) {
    let D;
    e[30] !== f ? (D = (O, _) => /* @__PURE__ */ g("span", { ref: (V) => {
      f.current[_] = V;
    }, className: "inline-flex w-max", children: /* @__PURE__ */ g(au, { type: "button", disabled: !0, children: O.label }) }, `${O.label}-${O.value}`), e[30] = f, e[31] = D) : D = e[31], T = o.map(D), e[27] = f, e[28] = o, e[29] = T;
  } else
    T = e[29];
  let k;
  e[32] !== c || e[33] !== T ? (k = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ g("div", { ref: c, className: "inline-flex w-max items-center gap-(--spacing-8)", children: T }) }), e[32] = c, e[33] = T, e[34] = k) : k = e[34];
  let P;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ g(mr, {}), e[35] = P) : P = e[35];
  let M;
  return e[36] !== I || e[37] !== k ? (M = /* @__PURE__ */ F("div", { className: m, children: [
    I,
    k,
    P
  ] }), e[36] = I, e[37] = k, e[38] = M) : M = e[38], M;
}
let Ip = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const ga = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, Vr = {
  valid: null,
  touched: !1,
  dirty: !1,
  filled: !1,
  focused: !1
}, Fy = {
  disabled: !1,
  ...Vr
}, eo = {
  valid(t) {
    return t === null ? null : t ? {
      [Ip.valid]: ""
    } : {
      [Ip.invalid]: ""
    };
  }
}, Bd = /* @__PURE__ */ x.createContext({
  invalid: void 0,
  name: void 0,
  validityData: {
    state: ga,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: yt,
  disabled: void 0,
  touched: Vr.touched,
  setTouched: yt,
  dirty: Vr.dirty,
  setDirty: yt,
  filled: Vr.filled,
  setFilled: yt,
  focused: Vr.focused,
  setFocused: yt,
  validate: () => null,
  validationMode: "onSubmit",
  validationDebounceTime: 0,
  shouldValidateOnChange: () => !1,
  state: Fy,
  markedDirtyRef: {
    current: !1
  },
  registerFieldControl: yt,
  validation: {
    getValidationProps: (t = St) => t,
    getInputValidationProps: (t = St) => t,
    inputRef: {
      current: null
    },
    commit: async () => {
    }
  }
});
process.env.NODE_ENV !== "production" && (Bd.displayName = "FieldRootContext");
function tn(t = !0) {
  const e = x.useContext(Bd);
  if (e.setValidityData === yt && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : et(28));
  return e;
}
const x2 = /* @__PURE__ */ x.createContext({
  legendId: void 0,
  setLegendId: () => {
  },
  disabled: void 0
});
process.env.NODE_ENV !== "production" && (x2.displayName = "FieldsetRootContext");
function C2(t = !1) {
  const e = x.useContext(x2);
  if (!e && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldsetRootContext is missing. Fieldset parts must be placed within <Fieldset.Root>." : et(86));
  return e;
}
const w2 = /* @__PURE__ */ x.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: yt,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (w2.displayName = "FormContext");
function _o() {
  return x.useContext(w2);
}
const Wd = /* @__PURE__ */ x.createContext({
  controlId: void 0,
  registerControlId: yt,
  labelId: void 0,
  setLabelId: yt,
  messageIds: [],
  setMessageIds: yt,
  getDescriptionProps: (t) => t
});
process.env.NODE_ENV !== "production" && (Wd.displayName = "LabelableContext");
function gn() {
  return x.useContext(Wd);
}
const S2 = function(e) {
  const n = kt(), o = e.controlId === void 0 ? n : e.controlId, [r, i] = x.useState(o), [s, l] = x.useState(e.labelId), [a, c] = x.useState([]), u = It(() => /* @__PURE__ */ new Map()), {
    messageIds: d
  } = gn(), f = Ce((h, b) => {
    const v = u.current;
    if (b === void 0) {
      v.delete(h);
      return;
    }
    v.set(h, b), i((C) => {
      if (v.size === 0)
        return;
      let y;
      for (const w of v.values()) {
        if (C !== void 0 && w === C)
          return C;
        y === void 0 && (y = w);
      }
      return y;
    });
  }), p = x.useCallback((h) => en({
    "aria-describedby": d.concat(a).join(" ") || void 0
  }, h), [d, a]), m = x.useMemo(() => ({
    controlId: r,
    registerControlId: f,
    labelId: s,
    setLabelId: l,
    messageIds: a,
    setMessageIds: c,
    getDescriptionProps: p
  }), [r, f, s, l, a, c, p]);
  return /* @__PURE__ */ g(Wd.Provider, {
    value: m,
    children: e.children
  });
};
process.env.NODE_ENV !== "production" && (S2.displayName = "LabelableProvider");
function Ud(t, e, n, o = !0, r) {
  const [i, s] = x.useState(), l = kt(r ? `${r}-label` : void 0), a = t ?? e ?? i;
  return Ne(() => {
    const c = t || e || !o ? void 0 : $y(n.current, l);
    i !== c && s(c);
  }), a;
}
function $y(t, e) {
  const n = Hy(t);
  if (n)
    return !n.id && e && (n.id = e), n.id || void 0;
}
function Hy(t) {
  if (!t)
    return;
  const e = t.parentElement;
  if (e && e.tagName === "LABEL")
    return e;
  const n = t.id;
  if (n) {
    const r = t.nextElementSibling;
    if (r && r.htmlFor === n)
      return r;
  }
  const o = t.labels;
  return o && o[0];
}
function Mr(t = {}) {
  const {
    id: e,
    implicit: n = !1,
    controlRef: o
  } = t, {
    controlId: r,
    registerControlId: i
  } = gn(), s = kt(e), l = n ? r : void 0, a = It(() => /* @__PURE__ */ Symbol("labelable-control")), c = x.useRef(!1), u = x.useRef(e != null), d = Ce(() => {
    !c.current || i === yt || (c.current = !1, i(a.current, void 0));
  });
  return Ne(() => {
    if (i === yt)
      return;
    let f;
    if (n) {
      const p = o?.current;
      pt(p) && p.closest("label") != null ? f = e ?? null : f = l ?? s;
    } else if (e != null)
      u.current = !0, f = e;
    else if (u.current)
      f = s;
    else {
      d();
      return;
    }
    if (f === void 0) {
      d();
      return;
    }
    c.current = !0, i(a.current, f);
  }, [e, o, l, i, n, s, a, d]), x.useEffect(() => d, [d]), r ?? s;
}
function zy(t, e) {
  const n = kt(t);
  return Ne(() => (e(n), () => {
    e(void 0);
  }), [n, e]), n;
}
function By(t = {}) {
  const {
    id: e,
    fallbackControlId: n,
    native: o = !1,
    setLabelId: r,
    focusControl: i
  } = t, {
    controlId: s,
    setLabelId: l
  } = gn(), a = Ce((p) => {
    l(p), r?.(p);
  }), c = zy(e, a), u = s ?? n;
  function d(p) {
    if (i) {
      i(p, u);
      return;
    }
    if (!u)
      return;
    const m = Je(p.currentTarget).getElementById(u);
    xt(m) && Wy(m);
  }
  function f(p) {
    bt(p.nativeEvent)?.closest("button,input,select,textarea") || (!p.defaultPrevented && p.detail > 1 && p.preventDefault(), !o && d(p));
  }
  return o ? {
    id: c,
    htmlFor: u ?? void 0,
    onMouseDown: f
  } : {
    id: c,
    onClick: f,
    onPointerDown(p) {
      p.preventDefault();
    }
  };
}
function Wy(t) {
  t.focus({
    // Available from Chrome 144+ (January 2026).
    // Safari and Firefox already support it.
    focusVisible: !0
  });
}
function zl(t, e) {
  return {
    ...t,
    state: {
      ...t.state,
      valid: !e && t.state.valid
    }
  };
}
const wl = Object.keys(ga);
function Uy(t) {
  if (!t || t.valid || !t.valueMissing)
    return !1;
  let e = !1;
  for (const n of wl)
    n !== "valid" && (n === "valueMissing" && (e = t[n]), t[n] && (e = !1));
  return e;
}
function Gy(t) {
  const {
    formRef: e,
    clearErrors: n
  } = _o(), {
    setValidityData: o,
    validate: r,
    validityData: i,
    validationDebounceTime: s,
    invalid: l,
    markedDirtyRef: a,
    state: c,
    name: u,
    shouldValidateOnChange: d
  } = t, {
    controlId: f,
    getDescriptionProps: p
  } = gn(), m = Dt(), h = x.useRef(null), b = Ce(async (y, w = !1) => {
    const R = h.current;
    if (!R)
      return;
    if (w) {
      if (c.valid !== !1)
        return;
      const M = R.validity;
      if (!M.valueMissing) {
        const O = {
          value: y,
          state: {
            ...ga,
            valid: !0
          },
          error: "",
          errors: [],
          initialValue: i.initialValue
        };
        if (R.setCustomValidity(""), f) {
          const _ = e.current.fields.get(f);
          _ && e.current.fields.set(f, {
            ..._,
            ...zl(O, !1)
            // invalid = false
          });
        }
        o(O);
        return;
      }
      const D = wl.reduce((O, _) => (O[_] = M[_], O), {});
      if (!D.valid && !Uy(D))
        return;
    }
    function S(M) {
      const D = wl.reduce((_, V) => (_[V] = M.validity[V], _), {});
      let O = !1;
      for (const _ of wl)
        if (_ !== "valid") {
          if (_ === "valueMissing" && D[_])
            O = !0;
          else if (D[_])
            return D;
        }
      return O && !a.current && (D.valid = !0, D.valueMissing = !1), D;
    }
    m.clear();
    let E = null, N = [];
    const I = S(R);
    let T;
    const k = d();
    if (R.validationMessage && !k)
      T = R.validationMessage, N = [R.validationMessage];
    else {
      const M = Array.from(e.current.fields.values()).reduce((O, _) => (_.name && (O[_.name] = _.getValue()), O), {}), D = r(y, M);
      typeof D == "object" && D !== null && "then" in D ? E = await D : E = D, E !== null ? (I.valid = !1, I.customError = !0, Array.isArray(E) ? (N = E, R.setCustomValidity(E.join(`
`))) : E && (N = [E], R.setCustomValidity(E))) : k && (R.setCustomValidity(""), I.customError = !1, R.validationMessage ? (T = R.validationMessage, N = [R.validationMessage]) : R.validity.valid && !I.valid && (I.valid = !0));
    }
    const P = {
      value: y,
      state: I,
      error: T ?? (Array.isArray(E) ? E[0] : E ?? ""),
      errors: N,
      initialValue: i.initialValue
    };
    if (f) {
      const M = e.current.fields.get(f);
      M && e.current.fields.set(f, {
        ...M,
        // Keep Form-level errors part of overall field validity for submit blocking/focus logic.
        ...zl(P, l)
      });
    }
    o(P);
  }), v = x.useCallback((y = {}) => en(p, c.valid === !1 ? {
    "aria-invalid": !0
  } : St, y), [p, c.valid]), C = x.useCallback((y = {}) => en({
    onChange(w) {
      if (w.nativeEvent.defaultPrevented)
        return;
      if (n(u), !d()) {
        b(w.currentTarget.value, !0);
        return;
      }
      const R = w.currentTarget;
      if (R.value === "") {
        b(R.value);
        return;
      }
      m.clear(), s ? m.start(s, () => {
        b(R.value);
      }) : b(R.value);
    }
  }, v(y)), [v, n, u, m, b, s, d]);
  return x.useMemo(() => ({
    getValidationProps: v,
    getInputValidationProps: C,
    inputRef: h,
    commit: b
  }), [v, C, b]);
}
function Yy(t) {
  const {
    commit: e,
    invalid: n,
    markedDirtyRef: o,
    name: r,
    setValidityData: i,
    validityData: s
  } = t, {
    formRef: l
  } = _o(), a = x.useRef(null), c = x.useRef(null), u = x.useRef(null), d = Ce(() => {
    const b = c.current;
    if (b)
      return b.getValue ? b.getValue() : b.value;
  }), f = Ce((b = !0) => {
    const v = c.current;
    if (!v)
      return;
    let C = v.value;
    C === void 0 && (C = d()), o.current = !0, b ? an.flushSync(() => e(C)) : e(C);
  });
  function p() {
    const b = c.current;
    !b || !b.id || l.current.fields.set(b.id, {
      getValue: d,
      name: r,
      controlRef: b.controlRef ?? u,
      validityData: zl(s, n),
      validate: f
    });
  }
  function m(b = c.current?.id) {
    b && l.current.fields.delete(b);
  }
  function h() {
    const b = c.current;
    if (!b)
      return;
    let v = b.value;
    v === void 0 && (v = d()), s.initialValue === null && v !== null && i((C) => ({
      ...C,
      initialValue: v
    }));
  }
  return Ne(() => {
    const b = c.current;
    !b || !b.id || l.current.fields.set(b.id, {
      getValue: d,
      name: r,
      controlRef: b.controlRef ?? u,
      validityData: zl(s, n),
      validate: f
    });
  }, [l, d, n, r, f, s]), Ne(() => {
    const b = l.current.fields;
    return () => {
      const v = c.current?.id;
      v && b.delete(v);
    };
  }, [l]), Ce((b, v) => {
    if (!v) {
      a.current === b && (a.current = null, m(), c.current = null);
      return;
    }
    const C = c.current?.id;
    a.current = b, c.current = v, C && C !== v.id && m(C), h(), p();
  });
}
const R2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    errors: o,
    validationMode: r,
    submitAttemptedRef: i
  } = _o(), {
    render: s,
    className: l,
    validate: a,
    validationDebounceTime: c = 0,
    validationMode: u = r,
    name: d,
    disabled: f = !1,
    invalid: p,
    dirty: m,
    touched: h,
    actionsRef: b,
    style: v,
    ...C
  } = e, {
    disabled: y
  } = C2(), w = Ce(a || (() => null)), R = y || f, [S, E] = x.useState(!1), [N, I] = x.useState(!1), [T, k] = x.useState(!1), [P, M] = x.useState(!1), D = m ?? N, O = h ?? S, _ = x.useRef(!1), V = Ce((le) => {
    m === void 0 && (le && (_.current = !0), I(le));
  }), A = Ce((le) => {
    h === void 0 && E(le);
  }), L = Ce(() => u === "onChange" || u === "onSubmit" && i.current), $ = !!d && Object.hasOwn(o, d) && o[d] !== void 0, Y = p === !0 || $, [G, j] = x.useState({
    state: ga,
    error: "",
    errors: [],
    value: null,
    initialValue: null
  }), Z = !Y && G.state.valid, U = x.useMemo(() => ({
    disabled: R,
    touched: O,
    dirty: D,
    valid: Z,
    filled: T,
    focused: P
  }), [R, O, D, Z, T, P]), q = Gy({
    setValidityData: j,
    validate: w,
    validityData: G,
    validationDebounceTime: c,
    invalid: Y,
    markedDirtyRef: _,
    state: U,
    name: d,
    shouldValidateOnChange: L
  }), te = x.useCallback(() => {
    _.current = !0, q.commit(G.value);
  }, [q, G]), H = Yy({
    commit: q.commit,
    invalid: Y,
    markedDirtyRef: _,
    name: d,
    setValidityData: j,
    validityData: G
  });
  x.useImperativeHandle(b, () => ({
    validate: te
  }), [te]);
  const X = x.useMemo(() => ({
    invalid: Y,
    name: d,
    validityData: G,
    setValidityData: j,
    disabled: R,
    touched: O,
    setTouched: A,
    dirty: D,
    setDirty: V,
    filled: T,
    setFilled: k,
    focused: P,
    setFocused: M,
    validate: w,
    validationMode: u,
    validationDebounceTime: c,
    shouldValidateOnChange: L,
    state: U,
    markedDirtyRef: _,
    registerFieldControl: H,
    validation: q
  }), [Y, d, G, R, O, A, D, V, T, k, P, M, w, u, c, L, U, H, q]), ee = Le("div", e, {
    ref: n,
    state: U,
    props: C,
    stateAttributesMapping: eo
  });
  return /* @__PURE__ */ g(Bd.Provider, {
    value: X,
    children: ee
  });
});
process.env.NODE_ENV !== "production" && (R2.displayName = "FieldRootInner");
const Pr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  return /* @__PURE__ */ g(S2, {
    children: /* @__PURE__ */ g(R2, {
      ...e,
      ref: n
    })
  });
});
process.env.NODE_ENV !== "production" && (Pr.displayName = "FieldRoot");
const E2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    nativeLabel: l = !0,
    ...a
  } = e, c = tn(!1), {
    labelId: u
  } = gn(), d = x.useRef(null), f = By({
    id: u ?? s,
    native: l
  });
  return process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (!d.current)
      return;
    const m = d.current.tagName === "LABEL";
    if (l) {
      if (!m) {
        const h = pr.captureOwnerStack?.() || "";
        jo(`<Field.Label> expected a <label> element because the \`nativeLabel\` prop is true. Rendering a non-<label> disables native label association, so \`htmlFor\` will not work. Use a real <label> in the \`render\` prop, or set \`nativeLabel\` to \`false\`.${h}`);
      }
    } else if (m) {
      const h = pr.captureOwnerStack?.() || "";
      jo(`<Field.Label> expected a non-<label> element because the \`nativeLabel\` prop is false. Rendering a <label> assumes native label behavior while Base UI treats it as non-native, which can cause unexpected pointer behavior. Use a non-<label> in the \`render\` prop, or set \`nativeLabel\` to \`true\`.${h}`);
    }
  }, [l]), Le("label", e, {
    ref: [n, d],
    state: c.state,
    props: [f, a],
    stateAttributesMapping: eo
  });
});
process.env.NODE_ENV !== "production" && (E2.displayName = "FieldLabel");
const jy = {
  ...eo,
  ...zt
}, Ir = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: i,
    match: s,
    style: l,
    ...a
  } = e, c = kt(r), {
    validityData: u,
    state: d,
    name: f
  } = tn(!1), {
    setMessageIds: p
  } = gn(), {
    errors: m
  } = _o(), h = f ? m[f] : null, b = typeof s == "string";
  let v = !1;
  s === !0 ? v = !0 : b ? v = !!u.state[s] : v = !!h || u.state.valid === !1;
  const {
    mounted: C,
    transitionStatus: y,
    setMounted: w
  } = Zn(v);
  Ne(() => {
    if (!(!v || !c))
      return p((O) => O.concat(c)), () => {
        p((O) => O.filter((_) => _ !== c));
      };
  }, [v, c, p]);
  const R = x.useRef(null), [S, E] = x.useState(null), [N, I] = x.useState(null), T = u.errors.length > 1 ? /* @__PURE__ */ g("ul", {
    children: u.errors.map((O) => /* @__PURE__ */ g("li", {
      children: O
    }, O))
  }) : u.error, k = b ? T : h || T;
  let P = u.error;
  h != null ? P = Array.isArray(h) ? JSON.stringify(h) : h : u.errors.length > 1 && (P = JSON.stringify(u.errors)), v && P !== N && (I(P), E(k)), Yt({
    open: v,
    ref: R,
    onComplete() {
      v || w(!1);
    }
  });
  const M = {
    ...d,
    transitionStatus: y
  }, D = Le("div", e, {
    ref: [n, R],
    state: M,
    props: [{
      id: c,
      children: v ? k : S
    }, a],
    stateAttributesMapping: jy,
    enabled: C
  });
  return C ? D : null;
});
process.env.NODE_ENV !== "production" && (Ir.displayName = "FieldError");
const di = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: i,
    style: s,
    ...l
  } = e, a = kt(r), c = tn(!1), {
    setMessageIds: u
  } = gn();
  return Ne(() => {
    if (a)
      return u((f) => f.concat(a)), () => {
        u((f) => f.filter((p) => p !== a));
      };
  }, [a, u]), Le("p", e, {
    ref: n,
    state: c.state,
    props: [{
      id: a
    }, l],
    stateAttributesMapping: eo
  });
});
process.env.NODE_ENV !== "production" && (di.displayName = "FieldDescription");
function fi(t, e) {
  const {
    enabled: n = !0,
    getValue: o,
    id: r,
    value: i
  } = e, {
    registerFieldControl: s
  } = tn(), l = x.useRef(null);
  l.current || (l.current = /* @__PURE__ */ Symbol()), Ne(() => {
    const a = l.current;
    if (!(!a || !n))
      return s(a, {
        controlRef: t,
        getValue: o,
        id: r,
        value: i
      }), () => {
        s(a, void 0);
      };
  }, [t, n, o, r, s, i]);
}
const Gd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    name: s,
    value: l,
    disabled: a = !1,
    onValueChange: c,
    defaultValue: u,
    autoFocus: d = !1,
    style: f,
    ...p
  } = e, {
    state: m,
    name: h,
    disabled: b,
    setTouched: v,
    setDirty: C,
    validityData: y,
    setFocused: w,
    setFilled: R,
    validationMode: S,
    validation: E
  } = tn(), N = b || a, I = h ?? s, T = {
    ...m,
    disabled: N
  }, {
    labelId: k
  } = gn(), P = Mr({
    id: i
  });
  Ne(() => {
    const L = l != null;
    E.inputRef.current?.value || L && l !== "" ? R(!0) : L && l === "" && R(!1);
  }, [E.inputRef, R, l]);
  const M = x.useRef(null);
  Ne(() => {
    d && M.current === Ut(Je(M.current)) && w(!0);
  }, [d, w]);
  const [D] = dn({
    controlled: l,
    default: u,
    name: "FieldControl",
    state: "value"
  }), O = l !== void 0, _ = O ? D : void 0, V = Ce(() => E.inputRef.current?.value);
  return fi(E.inputRef, {
    id: P,
    value: _,
    getValue: V
  }), Le("input", e, {
    ref: [n, M],
    state: T,
    props: [{
      id: P,
      disabled: N,
      name: I,
      ref: E.inputRef,
      "aria-labelledby": k,
      autoFocus: d,
      ...O ? {
        value: _
      } : {
        defaultValue: u
      },
      onChange(L) {
        const $ = L.currentTarget.value;
        c?.($, De(Pt, L.nativeEvent)), C($ !== y.initialValue), R($ !== "");
      },
      onFocus() {
        w(!0);
      },
      onBlur(L) {
        v(!0), w(!1), S === "onBlur" && E.commit(L.currentTarget.value);
      },
      onKeyDown(L) {
        L.currentTarget.tagName === "INPUT" && L.key === "Enter" && (v(!0), E.commit(L.currentTarget.value));
      }
    }, E.getInputValidationProps(), p],
    stateAttributesMapping: eo
  });
});
process.env.NODE_ENV !== "production" && (Gd.displayName = "FieldControl");
const N2 = /* @__PURE__ */ x.createContext({
  disabled: !1
});
process.env.NODE_ENV !== "production" && (N2.displayName = "FieldItemContext");
function k2() {
  return x.useContext(N2);
}
const M2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (M2.displayName = "CheckboxGroupContext");
function Ky(t = !0) {
  const e = x.useContext(M2);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CheckboxGroupContext is missing. CheckboxGroup parts must be placed within <CheckboxGroup>." : et(3));
  return e;
}
function qy(t) {
  const e = W.c(46);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    label: o,
    description: n,
    icon: i,
    size: s,
    side: l,
    align: a,
    disabled: c,
    showArrow: u,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = i === void 0 ? "circle-info" : i, f = s === void 0 ? "sm" : s, p = l === void 0 ? "top" : l, m = a === void 0 ? "center" : a, h = c === void 0 ? !1 : c, b = u === void 0 ? !0 : u, v = Qt(), C = h ? -1 : 0, y = h && "opacity-40 pointer-events-none";
  let w;
  e[10] !== y ? (w = oe("inline-flex items-center justify-center", "cursor-default transition-colors duration-200", "rounded-(--radius-sm)", "text-icon-main", "hover:text-primary", "focus-visible:text-primary", "focus-visible:outline-none focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", y), e[10] = y, e[11] = w) : w = e[11];
  let R;
  e[12] !== d || e[13] !== f ? (R = /* @__PURE__ */ g(Ge, { name: d, size: f, tone: "inherit" }), e[12] = d, e[13] = f, e[14] = R) : R = e[14];
  let S;
  e[15] !== o || e[16] !== r || e[17] !== R || e[18] !== C || e[19] !== w ? (S = /* @__PURE__ */ g(_d, { render: /* @__PURE__ */ g("span", { role: "img", tabIndex: C, "aria-label": o, ...r, className: w, children: R }) }), e[15] = o, e[16] = r, e[17] = R, e[18] = C, e[19] = w, e[20] = S) : S = e[20];
  const E = b ? f2 : d2;
  let N;
  e[21] !== b ? (N = b && /* @__PURE__ */ g(Hd, { "data-slot": "tooltip-arrow", className: h2 }), e[21] = b, e[22] = N) : N = e[22];
  const I = n ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let T;
  e[23] !== I ? (T = oe(m2, I), e[23] = I, e[24] = T) : T = e[24];
  let k;
  e[25] !== o || e[26] !== T ? (k = /* @__PURE__ */ g("p", { className: T, children: o }), e[25] = o, e[26] = T, e[27] = k) : k = e[27];
  let P;
  e[28] !== n ? (P = n && /* @__PURE__ */ g("p", { className: g2, children: n }), e[28] = n, e[29] = P) : P = e[29];
  let M;
  e[30] !== N || e[31] !== k || e[32] !== P ? (M = /* @__PURE__ */ F($d, { className: p2, children: [
    N,
    k,
    P
  ] }), e[30] = N, e[31] = k, e[32] = P, e[33] = M) : M = e[33];
  let D;
  e[34] !== m || e[35] !== p || e[36] !== E || e[37] !== M ? (D = /* @__PURE__ */ g(Fd, { side: p, align: m, sideOffset: E, className: u2, children: M }), e[34] = m, e[35] = p, e[36] = E, e[37] = M, e[38] = D) : D = e[38];
  let O;
  e[39] !== v || e[40] !== D ? (O = /* @__PURE__ */ g(Ad, { container: v, children: D }), e[39] = v, e[40] = D, e[41] = O) : O = e[41];
  let _;
  return e[42] !== h || e[43] !== S || e[44] !== O ? (_ = /* @__PURE__ */ F(Od, { disabled: h, children: [
    S,
    O
  ] }), e[42] = h, e[43] = S, e[44] = O, e[45] = _) : _ = e[45], _;
}
function pi(t) {
  const e = W.c(11), {
    htmlFor: n,
    label: o,
    required: r,
    tooltip: i
  } = t;
  let s;
  e[0] !== r ? (s = r && /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "text-input-required", children: "*" }), e[0] = r, e[1] = s) : s = e[1];
  let l;
  e[2] !== n || e[3] !== o || e[4] !== s ? (l = /* @__PURE__ */ F(E2, { htmlFor: n, className: "flex items-center gap-(--spacing-2) text-(length:--font-size-body-medium) leading-(--font-line-height-20) font-(number:--font-weight-semibold) text-input-text-default", children: [
    o,
    s
  ] }), e[2] = n, e[3] = o, e[4] = s, e[5] = l) : l = e[5];
  let a;
  e[6] !== i ? (a = i && /* @__PURE__ */ g(qy, { label: i, size: "xs" }), e[6] = i, e[7] = a) : a = e[7];
  let c;
  return e[8] !== l || e[9] !== a ? (c = /* @__PURE__ */ F("div", { className: "flex items-center justify-between mb-(--spacing-4)", children: [
    l,
    a
  ] }), e[8] = l, e[9] = a, e[10] = c) : c = e[10], c;
}
const Zy = ae(["relative", "flex", "w-full", "min-h-[132px]", "overflow-hidden", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:not([data-disabled=true]):not(:focus-within):not(:has([readonly]))]:active:border-input-pressed-outline", "[&:not([data-disabled=true]):focus-within:not(:has([readonly]))]:border-input-active-outline"], {
  variants: {
    hasError: {
      true: ["border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    hasError: !1
  }
}), Xy = ae(["flex-1", "min-w-0", "w-full", "min-h-[98px]", "border-0", "outline-none", "bg-transparent", "resize-y", "overflow-auto", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed", "read-only:cursor-default", "read-only:resize-none"]);
function Tp(t) {
  return typeof t == "string" || typeof t == "number" ? String(t) : Array.isArray(t) ? t.join(",") : "";
}
function pO(t) {
  const e = W.c(81);
  let n, o, r, i, s, l, a, c, u, d, f, p, m, h, b, v, C, y;
  e[0] !== t ? ({
    id: a,
    label: c,
    error: l,
    tooltip: C,
    required: b,
    disabled: s,
    readOnly: h,
    maxLength: u,
    value: y,
    defaultValue: i,
    placeholder: p,
    tabIndex: v,
    onChange: d,
    onKeyDown: f,
    "aria-describedby": n,
    "aria-label": o,
    "aria-labelledby": r,
    ...m
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = m, e[14] = h, e[15] = b, e[16] = v, e[17] = C, e[18] = y) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13], h = e[14], b = e[15], v = e[16], C = e[17], y = e[18]);
  const w = Xt(), R = a ?? w;
  let S;
  e[19] !== i ? (S = () => Tp(i), e[19] = i, e[20] = S) : S = e[20];
  const [E, N] = tt(S), I = y !== void 0, T = !!l && !h, k = u !== void 0 && !h && !T, P = !h, M = `${R}-footer`;
  let D;
  e[21] !== n || e[22] !== M || e[23] !== T || e[24] !== k ? (D = [n, T || k ? M : void 0].filter(Boolean).join(" ") || void 0, e[21] = n, e[22] = M, e[23] = T, e[24] = k, e[25] = D) : D = e[25];
  const O = D, _ = c || r ? o : o ?? "Text area";
  let V;
  e[26] !== E || e[27] !== I || e[28] !== y ? (V = I ? Tp(y) : E, e[26] = E, e[27] = I, e[28] = y, e[29] = V) : V = e[29];
  const A = V;
  let L;
  e[30] !== I || e[31] !== d ? (L = function(pe) {
    I || N(pe.currentTarget.value), d?.(pe);
  }, e[30] = I, e[31] = d, e[32] = L) : L = e[32];
  const $ = L;
  let Y;
  e[33] !== f ? (Y = function(pe) {
    f?.(pe), !pe.defaultPrevented && pe.key === "Escape" && pe.currentTarget.blur();
  }, e[33] = f, e[34] = Y) : Y = e[34];
  const G = Y;
  let j;
  e[35] !== c || e[36] !== b || e[37] !== R || e[38] !== C ? (j = c && /* @__PURE__ */ g(pi, { htmlFor: R, label: c, required: b, tooltip: C }), e[35] = c, e[36] = b, e[37] = R, e[38] = C, e[39] = j) : j = e[39];
  const Z = s || void 0;
  let U;
  e[40] !== s || e[41] !== T ? (U = oe(Zy({
    hasError: T
  }), s && "opacity-50 cursor-not-allowed"), e[40] = s, e[41] = T, e[42] = U) : U = e[42];
  const q = h ? void 0 : p, te = h ? -1 : v, H = b || void 0, X = T || void 0, ee = h || void 0;
  let le;
  e[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (le = Xy(), e[43] = le) : le = e[43];
  let Q;
  e[44] !== _ || e[45] !== r || e[46] !== i || e[47] !== O || e[48] !== s || e[49] !== $ || e[50] !== G || e[51] !== u || e[52] !== m || e[53] !== h || e[54] !== b || e[55] !== te || e[56] !== H || e[57] !== X || e[58] !== ee || e[59] !== q || e[60] !== R || e[61] !== y ? (Q = /* @__PURE__ */ g(Gd, { render: /* @__PURE__ */ g("textarea", { ...m, id: R, value: y, defaultValue: i, placeholder: q, required: b, disabled: s, readOnly: h, maxLength: u, tabIndex: te, onChange: $, onKeyDown: G, "aria-label": _, "aria-labelledby": r, "aria-required": H, "aria-invalid": X, "aria-readonly": ee, "aria-describedby": O, className: le }) }), e[44] = _, e[45] = r, e[46] = i, e[47] = O, e[48] = s, e[49] = $, e[50] = G, e[51] = u, e[52] = m, e[53] = h, e[54] = b, e[55] = te, e[56] = H, e[57] = X, e[58] = ee, e[59] = q, e[60] = R, e[61] = y, e[62] = Q) : Q = e[62];
  let re;
  e[63] !== Q || e[64] !== Z || e[65] !== U ? (re = /* @__PURE__ */ g("div", { "data-disabled": Z, className: U, children: Q }), e[63] = Q, e[64] = Z, e[65] = U, e[66] = re) : re = e[66];
  let fe;
  e[67] !== l || e[68] !== M || e[69] !== T || e[70] !== u || e[71] !== k || e[72] !== P || e[73] !== A ? (fe = P && /* @__PURE__ */ F("div", { "data-testid": "textarea-footer", className: "flex justify-between items-center min-h-(--spacing-20) mt-(--spacing-4) gap-(--spacing-8)", children: [
    /* @__PURE__ */ g("div", { className: "flex-1 min-w-0", children: T && /* @__PURE__ */ g(Ir, { id: M, match: !0, className: "truncate text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-error-text", children: l }) }),
    k && /* @__PURE__ */ F("span", { id: M, "aria-live": "polite", className: "shrink-0 text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting whitespace-nowrap", children: [
      A.length,
      "/",
      u
    ] })
  ] }), e[67] = l, e[68] = M, e[69] = T, e[70] = u, e[71] = k, e[72] = P, e[73] = A, e[74] = fe) : fe = e[74];
  let ne;
  return e[75] !== s || e[76] !== T || e[77] !== re || e[78] !== fe || e[79] !== j ? (ne = /* @__PURE__ */ F(Pr, { invalid: T, disabled: s, className: "flex flex-col w-full", children: [
    j,
    re,
    fe
  ] }), e[75] = s, e[76] = T, e[77] = re, e[78] = fe, e[79] = j, e[80] = ne) : ne = e[80], ne;
}
function Qy({
  onSendMessage: t,
  value: e,
  onChange: n,
  disabled: o,
  placeholder: r = "Ask anything...",
  initialValue: i = ""
}) {
  const [s, l] = tt(i), a = e !== void 0, c = e ?? s, u = ut(0), d = ut(c), f = ut(/* @__PURE__ */ new Map());
  d.current = c, _t(() => () => {
    f.current.forEach(({
      controller: C
    }) => {
      C.abort();
    }), f.current.clear();
  }, []);
  function p(C) {
    a || l(C), n?.(C);
  }
  function m(C) {
    const y = C.target.value;
    u.current += 1, p(y);
  }
  function h(C, y) {
    f.current.get(C) === y && f.current.delete(C);
  }
  async function b(C, y, w) {
    try {
      await t(C, w.controller.signal), f.current.get(C) === w && u.current === y && d.current.trim() === C && p("");
    } catch {
    } finally {
      h(C, w);
    }
  }
  function v() {
    const C = c.trim();
    if (!C) {
      p("");
      return;
    }
    if (f.current.has(C)) return;
    const y = {
      controller: new AbortController()
    };
    f.current.set(C, y);
    const w = u.current;
    b(C, w, y);
  }
  return /* @__PURE__ */ g(Vy, { value: c, onChange: m, onSend: v, clearOnSend: !1, disabled: o, placeholder: r, showUpload: !1 });
}
const P2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  return /* @__PURE__ */ g(Gd, {
    ref: n,
    ...e
  });
});
process.env.NODE_ENV !== "production" && (P2.displayName = "Input");
const Jy = ae(["flex", "items-center", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    size: {
      xs: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Op = ae(["font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-input-text-default"], {
  variants: {
    size: {
      xs: ["text-(length:--font-size-body-small)", "leading-(--font-line-height-16)"],
      sm: ["text-(length:--font-size-body-medium)", "leading-(--font-line-height-24)"],
      md: ["text-(length:--font-size-body-medium)", "leading-(--font-line-height-24)"]
    },
    italic: {
      true: "italic",
      false: "not-italic"
    }
  },
  defaultVariants: {
    size: "md",
    italic: !1
  }
});
function ex(t) {
  const e = W.c(56);
  let n, o, r, i, s, l, a, c, u, d, f, p, m, h;
  e[0] !== t ? ({
    size: c,
    italic: u,
    label: i,
    leadingIcon: s,
    trailingIcon: m,
    trailingAction: p,
    unit: h,
    description: n,
    error: r,
    tooltip: f,
    reserveSubtextSpace: d,
    required: a,
    disabled: o,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = m, e[14] = h) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], m = e[13], h = e[14]);
  const b = c === void 0 ? "md" : c, v = u === void 0 ? !1 : u, C = d === void 0 ? !0 : d, y = !!r, w = s || p || h ? void 0 : m;
  let R;
  e[15] !== i || e[16] !== a || e[17] !== f ? (R = i && /* @__PURE__ */ g(pi, { label: i, required: a, tooltip: f }), e[15] = i, e[16] = a, e[17] = f, e[18] = R) : R = e[18];
  let S;
  e[19] !== o || e[20] !== y || e[21] !== b ? (S = oe(Jy({
    size: b
  }), o && "opacity-50", y && ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"]), e[19] = o, e[20] = y, e[21] = b, e[22] = S) : S = e[22];
  let E;
  e[23] !== s ? (E = s && /* @__PURE__ */ g(Ge, { name: s, size: "sm", tone: "inherit" }), e[23] = s, e[24] = E) : E = e[24];
  const N = a || void 0;
  let I;
  e[25] !== y || e[26] !== v || e[27] !== b ? (I = oe("flex-1", "min-w-0", "outline-none", Op({
    size: b,
    italic: v
  }), "placeholder:text-text-subtle", y && "text-input-error-text"), e[25] = y, e[26] = v, e[27] = b, e[28] = I) : I = e[28];
  let T;
  e[29] !== l || e[30] !== a || e[31] !== N || e[32] !== I ? (T = /* @__PURE__ */ g(P2, { required: a, "aria-required": N, className: I, ...l }), e[29] = l, e[30] = a, e[31] = N, e[32] = I, e[33] = T) : T = e[33];
  let k;
  e[34] !== o || e[35] !== w || e[36] !== b || e[37] !== p || e[38] !== h ? (k = p ? /* @__PURE__ */ g(gt, { ...p, disabled: o || p.disabled, size: "sm", type: "button", variant: "ghost" }) : h ? /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6) shrink-0", children: [
    /* @__PURE__ */ g("span", { "aria-hidden": "true", className: "text-input-default-outline select-none", children: "|" }),
    /* @__PURE__ */ g("span", { className: oe(Op({
      size: b,
      italic: !1
    }), "text-input-text-supporting whitespace-nowrap"), children: h })
  ] }) : w ? /* @__PURE__ */ g(Ge, { name: w, size: "sm", tone: "inherit" }) : null, e[34] = o, e[35] = w, e[36] = b, e[37] = p, e[38] = h, e[39] = k) : k = e[39];
  let P;
  e[40] !== k || e[41] !== S || e[42] !== E || e[43] !== T ? (P = /* @__PURE__ */ F("div", { className: S, children: [
    E,
    T,
    k
  ] }), e[40] = k, e[41] = S, e[42] = E, e[43] = T, e[44] = P) : P = e[44];
  let M;
  e[45] !== n || e[46] !== r || e[47] !== y || e[48] !== C ? (M = (C || y || n) && /* @__PURE__ */ g("div", { "data-testid": "input-subtext-row", className: oe("mt-(--spacing-4)", C && "min-h-(--spacing-20)"), children: y ? /* @__PURE__ */ g(Ir, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: r }) : n ? /* @__PURE__ */ g(di, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: n }) : null }), e[45] = n, e[46] = r, e[47] = y, e[48] = C, e[49] = M) : M = e[49];
  let D;
  return e[50] !== o || e[51] !== y || e[52] !== P || e[53] !== M || e[54] !== R ? (D = /* @__PURE__ */ F(Pr, { invalid: y, disabled: o, className: "flex flex-col w-full", children: [
    R,
    P,
    M
  ] }), e[50] = o, e[51] = y, e[52] = P, e[53] = M, e[54] = R, e[55] = D) : D = e[55], D;
}
const I2 = ae(["flex", "flex-col", "items-start", "min-w-0", "gap-(--spacing-10)", "rounded-(--radius-sm)", "px-(--spacing-8)", "py-(--spacing-10)", "w-full"]), tx = ["Wrong answer", "Slow response", "Incomplete", "Other"];
function T2(t, e) {
  const n = W.c(30), {
    rating: o,
    onSubmit: r,
    onRateResponse: i,
    defaultValue: s,
    submittedDuration: l,
    defaultSubmitted: a
  } = t, c = l === void 0 ? 4e3 : l, u = a === void 0 ? !1 : a, [d, f] = tt(o), [p, m] = tt(s), [h, b] = tt(""), [v, C] = tt(!1), [y, w] = tt(u ? "submitted" : "idle"), R = ut(c), S = ut(e);
  let E, N;
  n[0] !== u || n[1] !== s || n[2] !== o || n[3] !== e || n[4] !== c ? (E = () => {
    S.current !== e && (S.current = e, f(o), m(s), b(""), C(!1), w(u ? "submitted" : "idle"), R.current = c);
  }, N = [u, s, o, e, c], n[0] = u, n[1] = s, n[2] = o, n[3] = e, n[4] = c, n[5] = E, n[6] = N) : (E = n[5], N = n[6]), _t(E, N);
  let I, T;
  n[7] !== y ? (I = () => {
    if (y !== "submitted")
      return;
    const A = window.setTimeout(() => {
      w("dismissed");
    }, R.current);
    return () => window.clearTimeout(A);
  }, T = [y], n[7] = y, n[8] = I, n[9] = T) : (I = n[8], T = n[9]), _t(I, T);
  let k;
  n[10] !== i || n[11] !== r || n[12] !== y || n[13] !== c ? (k = function(L) {
    if (!(y !== "idle" || i === void 0 && r === void 0)) {
      if (f(L), i?.(L), L === -1 && r) {
        C(!0);
        return;
      }
      L === 1 && i === void 0 && r?.(L), R.current = c, w("submitted");
    }
  }, n[10] = i, n[11] = r, n[12] = y, n[13] = c, n[14] = k) : k = n[14];
  const P = k;
  let M;
  n[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = function(L) {
    L !== "Other" && b(""), m(L);
  }, n[15] = M) : M = n[15];
  const D = M;
  let O;
  n[16] !== h || n[17] !== r || n[18] !== p || n[19] !== d || n[20] !== c ? (O = function() {
    !r || p === void 0 || (R.current = c, r(d, p === "Other" && h.trim() || p), w("submitted"));
  }, n[16] = h, n[17] = r, n[18] = p, n[19] = d, n[20] = c, n[21] = O) : O = n[21];
  const _ = O;
  let V;
  return n[22] !== h || n[23] !== v || n[24] !== p || n[25] !== P || n[26] !== d || n[27] !== y || n[28] !== _ ? (V = {
    selectedRating: d,
    reason: p,
    feedbackText: h,
    isReasonsOpen: v,
    status: y,
    selectRating: P,
    selectReason: D,
    setFeedbackText: b,
    submitFeedback: _
  }, n[22] = h, n[23] = v, n[24] = p, n[25] = P, n[26] = d, n[27] = y, n[28] = _, n[29] = V) : V = n[29], V;
}
function O2(t) {
  const e = W.c(16), {
    feedbackState: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("legend", { className: "sr-only", children: "Response feedback" }), e[0] = o) : o = e[0];
  const r = n.selectedRating === 1, i = n.status !== "idle";
  let s;
  e[1] !== n ? (s = () => n.selectRating(1), e[1] = n, e[2] = s) : s = e[2];
  let l;
  e[3] !== r || e[4] !== i || e[5] !== s ? (l = /* @__PURE__ */ g(gt, { icon: "thumbs-up", variant: "ghost", size: "sm", "aria-label": "Helpful response", "aria-pressed": r, disabled: i, onClick: s }), e[3] = r, e[4] = i, e[5] = s, e[6] = l) : l = e[6];
  const a = n.selectedRating === -1, c = n.status !== "idle";
  let u;
  e[7] !== n ? (u = () => n.selectRating(-1), e[7] = n, e[8] = u) : u = e[8];
  let d;
  e[9] !== a || e[10] !== c || e[11] !== u ? (d = /* @__PURE__ */ g(gt, { icon: "thumbs-down", variant: "ghost", size: "sm", "aria-label": "Unhelpful response", "aria-pressed": a, disabled: c, onClick: u }), e[9] = a, e[10] = c, e[11] = u, e[12] = d) : d = e[12];
  let f;
  return e[13] !== l || e[14] !== d ? (f = /* @__PURE__ */ F("fieldset", { className: "m-0 flex items-center gap-(--spacing-4) border-0 p-0", children: [
    o,
    l,
    d
  ] }), e[13] = l, e[14] = d, e[15] = f) : f = e[15], f;
}
function nx(t) {
  const e = W.c(4), {
    children: n,
    selected: o,
    onClick: r
  } = t;
  let i;
  return e[0] !== n || e[1] !== r || e[2] !== o ? (i = /* @__PURE__ */ g("span", { "data-slot": "assistant-chat-feedback-reason", className: "contents [&_button[aria-pressed=true]]:bg-tag-pressed-background [&_button[aria-pressed=true]]:border-tag-pressed-outline", children: /* @__PURE__ */ g(au, { "aria-pressed": o, onClick: r, children: n }) }), e[0] = n, e[1] = r, e[2] = o, e[3] = i) : i = e[3], i;
}
function D2(t) {
  const e = W.c(19), {
    feedbackState: n,
    allowWrittenFeedback: o,
    submitDisabled: r,
    className: i
  } = t, s = r === void 0 ? !1 : r;
  let l;
  e[0] !== i ? (l = oe(I2(), i), e[0] = i, e[1] = l) : l = e[1];
  let a;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ g(uo, { size: "lg", children: "Share Feedback" }), e[2] = a) : a = e[2];
  let c;
  e[3] !== n ? (c = tx.map((m) => /* @__PURE__ */ g(nx, { selected: n.reason === m, onClick: () => n.selectReason(m), children: m }, m)), e[3] = n, e[4] = c) : c = e[4];
  let u;
  e[5] !== c ? (u = /* @__PURE__ */ F("div", { className: "flex w-full flex-col items-start gap-(--spacing-10)", children: [
    a,
    /* @__PURE__ */ g("div", { className: "flex w-full flex-wrap gap-(--spacing-4) min-[600px]:w-max", children: c })
  ] }), e[5] = c, e[6] = u) : u = e[6];
  let d;
  e[7] !== o || e[8] !== n ? (d = o && n.reason === "Other" ? /* @__PURE__ */ g("div", { className: "min-w-0 w-full [&_input]:truncate", children: /* @__PURE__ */ g(ex, { size: "sm", label: "Please provide details:", placeholder: "What was not helpful?", reserveSubtextSpace: !1, value: n.feedbackText, onChange: (m) => n.setFeedbackText(m.target.value) }) }) : null, e[7] = o, e[8] = n, e[9] = d) : d = e[9];
  let f;
  e[10] !== n.reason || e[11] !== n.submitFeedback || e[12] !== s ? (f = n.reason !== void 0 ? /* @__PURE__ */ g(An, { size: "sm", variant: "outline", disabled: s, onClick: n.submitFeedback, children: "Submit" }) : null, e[10] = n.reason, e[11] = n.submitFeedback, e[12] = s, e[13] = f) : f = e[13];
  let p;
  return e[14] !== l || e[15] !== u || e[16] !== d || e[17] !== f ? (p = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-feedback-details", className: l, children: [
    u,
    d,
    f
  ] }), e[14] = l, e[15] = u, e[16] = d, e[17] = f, e[18] = p) : p = e[18], p;
}
function _2(t) {
  const e = W.c(5), {
    className: n
  } = t;
  let o;
  e[0] !== n ? (o = oe(I2(), n), e[0] = n, e[1] = o) : o = e[1];
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ g(ln, { children: "Thanks! We’ve received your feedback." }), e[2] = r) : r = e[2];
  let i;
  return e[3] !== o ? (i = /* @__PURE__ */ g("output", { "data-slot": "assistant-chat-feedback", className: o, "aria-live": "polite", children: r }), e[3] = o, e[4] = i) : i = e[4], i;
}
function mO(t) {
  const e = W.c(13);
  let n, o;
  e[0] !== t ? ({
    allowWrittenFeedback: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? !0 : o, i = T2(n);
  if (i.status === "dismissed")
    return null;
  if (i.status === "submitted") {
    let c;
    return e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g(_2, {}), e[3] = c) : c = e[3], c;
  }
  let s;
  e[4] !== i ? (s = /* @__PURE__ */ g(O2, { feedbackState: i }), e[4] = i, e[5] = s) : s = e[5];
  let l;
  e[6] !== r || e[7] !== i || e[8] !== n ? (l = i.isReasonsOpen ? /* @__PURE__ */ g(D2, { feedbackState: i, allowWrittenFeedback: r, submitDisabled: n.onSubmit === void 0 }) : null, e[6] = r, e[7] = i, e[8] = n, e[9] = l) : l = e[9];
  let a;
  return e[10] !== s || e[11] !== l ? (a = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-feedback", className: "contents", children: [
    s,
    l
  ] }), e[10] = s, e[11] = l, e[12] = a) : a = e[12], a;
}
const ox = ae(["flex", "items-center", "justify-between", "gap-(--spacing-12)", "w-full", "px-(--spacing-12)", "max-[599px]:gap-(--spacing-8)", "max-[599px]:px-(--spacing-8)"], {
  variants: {
    minimized: {
      false: ["py-(--spacing-16)", "max-[599px]:py-(--spacing-12)", "bg-ai-panel-header-expanded", "relative", "after:pointer-events-none", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:border-b", "after:border-solid", "after:border-outline-subtle", "after:content-['']", "rounded-tl-(--radius-md)", "rounded-tr-(--radius-md)"],
      true: ["py-(--spacing-8)", "bg-ai-panel-header-minimized", "[background-origin:padding-box,border-box]", "[background-clip:padding-box,border-box]", "border", "border-solid", "border-transparent", "shadow-elevation-7", "rounded-tl-(--radius-md)", "rounded-tr-(--radius-md)"]
    }
  },
  defaultVariants: {
    minimized: !1
  }
});
function sc(t) {
  const e = W.c(49), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    minimized: i,
    onClose: s,
    onMinimize: l,
    onExpand: a,
    onNewConversation: c,
    onOpenHistory: u,
    onBack: d,
    mobileHistoryControlRef: f
  } = t, p = i === void 0 ? !1 : i;
  let m;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = {
    defaultMatches: !1
  }, e[0] = m) : m = e[0];
  const h = ws("(max-width: 599px)", m), b = p && !h;
  let v;
  e[1] !== b ? (v = oe(ox({
    minimized: b
  })), e[1] = b, e[2] = v) : v = e[2];
  const C = b ? "" : void 0;
  let y;
  e[3] !== b || e[4] !== o ? (y = o ?? /* @__PURE__ */ g("div", { className: oe("flex shrink-0 items-center justify-center rounded-(--radius-sm)", b ? "relative size-(--icon-md) overflow-clip" : "size-(--spacing-40) p-(--spacing-4)"), children: /* @__PURE__ */ g(wu, { size: b ? "md" : "lg" }) }), e[3] = b, e[4] = o, e[5] = y) : y = e[5];
  const w = b ? "sm" : "md";
  let R;
  e[6] !== w || e[7] !== n ? (R = /* @__PURE__ */ g("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ g(Rn, { as: "h2", size: w, truncate: !0, children: n }) }), e[6] = w, e[7] = n, e[8] = R) : R = e[8];
  let S;
  e[9] !== r ? (S = r ? /* @__PURE__ */ g("span", { className: "shrink-0", children: r }) : null, e[9] = r, e[10] = S) : S = e[10];
  let E;
  e[11] !== R || e[12] !== S ? (E = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
    R,
    S
  ] }), e[11] = R, e[12] = S, e[13] = E) : E = e[13];
  let N;
  e[14] !== y || e[15] !== E ? (N = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-12)", children: [
    y,
    E
  ] }), e[14] = y, e[15] = E, e[16] = N) : N = e[16];
  let I;
  e[17] !== b || e[18] !== f || e[19] !== d ? (I = !b && d && /* @__PURE__ */ g("span", { className: "min-[600px]:hidden", children: /* @__PURE__ */ g(gt, { ref: f, icon: "arrow-left", variant: "ghost", size: "sm", "aria-label": "Back to chat", onClick: d }) }), e[17] = b, e[18] = f, e[19] = d, e[20] = I) : I = e[20];
  let T;
  e[21] !== b || e[22] !== c ? (T = !b && c && /* @__PURE__ */ g("span", { className: "min-[600px]:hidden", children: /* @__PURE__ */ g(gt, { icon: "edit-pen", variant: "ghost", size: "sm", "aria-label": "New chat", onClick: c }) }), e[21] = b, e[22] = c, e[23] = T) : T = e[23];
  let k;
  e[24] !== b || e[25] !== f || e[26] !== d || e[27] !== u ? (k = !b && !d && u && /* @__PURE__ */ g("span", { className: "min-[600px]:hidden", children: /* @__PURE__ */ g(gt, { ref: f, icon: "clock-seven", variant: "ghost", size: "sm", "aria-label": "Open chat history", onClick: u }) }), e[24] = b, e[25] = f, e[26] = d, e[27] = u, e[28] = k) : k = e[28];
  let P;
  e[29] !== b || e[30] !== l ? (P = !b && /* @__PURE__ */ g("span", { className: "max-[599px]:hidden", children: /* @__PURE__ */ g(gt, { icon: "minus", variant: "ghost", size: "sm", "aria-label": "Minimize", onClick: l }) }), e[29] = b, e[30] = l, e[31] = P) : P = e[31];
  let M;
  e[32] !== b || e[33] !== a ? (M = b && /* @__PURE__ */ g("span", { className: "max-[599px]:hidden", children: /* @__PURE__ */ g(gt, { icon: "expand-regular", variant: "ghost", size: "sm", "aria-label": "Expand", onClick: a }) }), e[32] = b, e[33] = a, e[34] = M) : M = e[34];
  let D;
  e[35] !== s ? (D = /* @__PURE__ */ g(gt, { icon: "x-close", variant: "ghost", size: "sm", "aria-label": "Close", onClick: s }), e[35] = s, e[36] = D) : D = e[36];
  let O;
  e[37] !== I || e[38] !== T || e[39] !== k || e[40] !== P || e[41] !== M || e[42] !== D ? (O = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-4)", children: [
    I,
    T,
    k,
    P,
    M,
    D
  ] }), e[37] = I, e[38] = T, e[39] = k, e[40] = P, e[41] = M, e[42] = D, e[43] = O) : O = e[43];
  let _;
  return e[44] !== N || e[45] !== O || e[46] !== v || e[47] !== C ? (_ = /* @__PURE__ */ F("header", { className: v, "data-slot": "assistant-chat-header", "data-minimized": C, children: [
    N,
    O
  ] }), e[44] = N, e[45] = O, e[46] = v, e[47] = C, e[48] = _) : _ = e[48], _;
}
function V2(t) {
  const e = W.c(9), {
    size: n
  } = t, [o] = tt(rx), r = n === "fullPage" ? "size-[100px]" : "size-(--icon-xxl)";
  let i;
  e[0] !== r ? (i = oe("aw-loading-animation shrink-0", r), e[0] = r, e[1] = i) : i = e[1];
  const s = `${o}ms`;
  let l;
  e[2] !== s ? (l = {
    animationDelay: s
  }, e[2] = s, e[3] = l) : l = e[3];
  let a, c;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ g("path", { className: "fill-outline-subtle opacity-40", d: "M4.8 24c0 10.605 8.595 19.2 19.2 19.2 8.085 0 15-4.995 17.835-12.068-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.128-2.123 5.31-7.313 9.06-13.38 9.06-7.95 0-14.4-6.45-14.4-14.4 0-7.95 6.45-14.4 14.4-14.4.698 0 1.388.053 2.063.143-1.313-.188-2.22-1.403-2.033-2.715.188-1.29 1.365-2.198 2.655-2.048a19.262 19.262 0 0 0-2.685-.188C13.395 4.793 4.8 13.388 4.8 23.993V24Z" }), c = /* @__PURE__ */ g("path", { className: "fill-primary-fixed", d: "M24.023 7.027c.187-1.312 1.402-2.22 2.715-2.032C36.045 6.33 43.2 14.325 43.2 24c0 2.513-.488 4.92-1.365 7.133-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.12.66-1.65 1.028-3.45 1.028-5.348 0-7.253-5.363-13.253-12.338-14.258-1.313-.188-2.22-1.403-2.033-2.715h-.015Z" }), e[4] = a, e[5] = c) : (a = e[4], c = e[5]);
  let u;
  return e[6] !== i || e[7] !== l ? (u = /* @__PURE__ */ F("svg", { "aria-hidden": "true", className: i, "data-slot": "loading-animation", fill: "none", style: l, viewBox: "0 0 48 48", children: [
    a,
    c
  ] }), e[6] = i, e[7] = l, e[8] = u) : u = e[8], u;
}
function rx() {
  return -(Date.now() % 1e3);
}
function A2(t) {
  const e = W.c(6), {
    label: n
  } = t, o = n ?? "Loading";
  let r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ g(V2, { size: "blocking" }), e[0] = r) : r = e[0];
  let i;
  e[1] !== n ? (i = n && /* @__PURE__ */ g(uo, { align: "center", size: "xs", children: n }), e[1] = n, e[2] = i) : i = e[2];
  let s;
  return e[3] !== o || e[4] !== i ? (s = /* @__PURE__ */ F("output", { "aria-label": o, className: "flex flex-col items-center gap-(--spacing-8) rounded-(--radius-sm) bg-surface-container-lowest px-(--spacing-24) py-(--spacing-16)", "data-slot": "blocking-action-status", tabIndex: -1, children: [
    r,
    i
  ] }), e[3] = o, e[4] = i, e[5] = s) : s = e[5], s;
}
function gO(t) {
  const e = W.c(16);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    open: r,
    label: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r || void 0, l = r || void 0;
  let a;
  e[5] !== n || e[6] !== s || e[7] !== l ? (a = /* @__PURE__ */ g("div", { "aria-busy": s, inert: l, children: n }), e[5] = n, e[6] = s, e[7] = l, e[8] = a) : a = e[8];
  let c;
  e[9] !== o || e[10] !== r ? (c = r && /* @__PURE__ */ g("div", { className: "absolute inset-0 z-10 flex items-center justify-center bg-surface-scrim", "data-slot": "blocking-action-overlay-scrim", children: /* @__PURE__ */ g(A2, { label: o }) }), e[9] = o, e[10] = r, e[11] = c) : c = e[11];
  let u;
  return e[12] !== i || e[13] !== a || e[14] !== c ? (u = /* @__PURE__ */ F("div", { ...i, className: "relative", "data-slot": "blocking-action-overlay", children: [
    a,
    c
  ] }), e[12] = i, e[13] = a, e[14] = c, e[15] = u) : u = e[15], u;
}
function L2() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("output", { "aria-label": "Loading", tabIndex: -1, children: /* @__PURE__ */ g(V2, { size: "fullPage" }) }), t[0] = e) : e = t[0], e;
}
function hO(t) {
  const e = W.c(5);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g(L2, {}), e[2] = o) : o = e[2];
  let r;
  return e[3] !== n ? (r = /* @__PURE__ */ g("div", { ...n, "aria-busy": "true", className: "flex min-h-dvh items-center justify-center bg-surface-low p-(--spacing-24)", "data-slot": "full-page-loading", children: o }), e[3] = n, e[4] = r) : r = e[4], r;
}
const ix = ae("mx-auto w-full px-(--spacing-16)", {
  variants: {
    size: {
      sm: "max-w-[600px]",
      md: "max-w-[905px]",
      lg: "max-w-[1240px]",
      xl: "max-w-[1440px]",
      full: "max-w-none"
    }
  },
  defaultVariants: {
    size: "lg"
  }
});
function bO(t) {
  const e = W.c(10);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== r ? (i = oe(ix({
    size: r
  })), e[4] = r, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ g("div", { className: i, ...o, children: n }), e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
const F2 = {
  0: "gap-(--spacing-0)",
  2: "gap-(--spacing-2)",
  4: "gap-(--spacing-4)",
  6: "gap-(--spacing-6)",
  8: "gap-(--spacing-8)",
  10: "gap-(--spacing-10)",
  12: "gap-(--spacing-12)",
  16: "gap-(--spacing-16)",
  20: "gap-(--spacing-20)",
  24: "gap-(--spacing-24)",
  32: "gap-(--spacing-32)",
  40: "gap-(--spacing-40)",
  64: "gap-(--spacing-64)",
  80: "gap-(--spacing-80)"
}, $2 = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline"
}, sx = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly"
}, lx = {
  wrap: "flex-wrap",
  nowrap: "flex-nowrap",
  "wrap-reverse": "flex-wrap-reverse"
}, ax = ae("flex flex-row", {
  variants: {
    align: $2,
    justify: sx,
    gap: F2,
    wrap: lx
  },
  defaultVariants: {
    gap: 8,
    align: "center"
  }
});
function hr(t) {
  const e = W.c(18);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    gap: r,
    align: n,
    justify: i,
    wrap: a,
    grow: l,
    children: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? !1 : l;
  let u;
  e[8] !== n || e[9] !== r || e[10] !== c || e[11] !== i || e[12] !== a ? (u = oe(ax({
    gap: r,
    align: n,
    justify: i,
    wrap: a
  }), c && "[&>*]:flex-1"), e[8] = n, e[9] = r, e[10] = c, e[11] = i, e[12] = a, e[13] = u) : u = e[13];
  let d;
  return e[14] !== o || e[15] !== s || e[16] !== u ? (d = /* @__PURE__ */ g("div", { className: u, ...s, children: o }), e[14] = o, e[15] = s, e[16] = u, e[17] = d) : d = e[17], d;
}
const cx = ae("flex flex-col", {
  variants: {
    align: $2,
    gap: F2,
    fullWidth: {
      true: "w-full",
      false: null
    }
  },
  defaultVariants: {
    gap: 16,
    fullWidth: !1
  }
});
function Kr(t) {
  const e = W.c(14);
  let n, o, r, i, s;
  e[0] !== t ? ({
    gap: r,
    align: n,
    fullWidth: s,
    children: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = s === void 0 ? !1 : s;
  let a;
  e[6] !== n || e[7] !== l || e[8] !== r ? (a = oe(cx({
    gap: r,
    align: n,
    fullWidth: l
  })), e[6] = n, e[7] = l, e[8] = r, e[9] = a) : a = e[9];
  let c;
  return e[10] !== o || e[11] !== i || e[12] !== a ? (c = /* @__PURE__ */ g("div", { className: a, ...i, children: o }), e[10] = o, e[11] = i, e[12] = a, e[13] = c) : c = e[13], c;
}
const Yd = go(null);
function jd() {
  return mn(Yd);
}
function vO() {
  const t = mn(Yd);
  if (!t)
    throw new Error("useAppShell must be used within AppShell.");
  return t;
}
function H2(t) {
  const e = W.c(11);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    modifier: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = oe("inline-flex", "items-center", "justify-center", "gap-(--spacing-4)", "rounded-(--radius-sm)", "border-[0.5px]", "border-solid", "border-menu-hotkey-outline", "bg-menu-hotkey-background", "px-(--spacing-6)", "py-(--spacing-4)", "font-(family-name:--font-family-body)", "text-(length:--font-size-label-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-surface-on-surface-variant", "whitespace-nowrap", "not-italic", "select-none"), e[4] = i) : i = e[4];
  let s;
  e[5] !== o ? (s = o && /* @__PURE__ */ g("span", { children: o }), e[5] = o, e[6] = s) : s = e[6];
  let l;
  return e[7] !== n || e[8] !== r || e[9] !== s ? (l = /* @__PURE__ */ F("kbd", { "data-slot": "kbd", className: i, ...r, children: [
    s,
    n
  ] }), e[7] = n, e[8] = r, e[9] = s, e[10] = l) : l = e[10], l;
}
const ux = ae(["inline-flex", "h-(--spacing-40)", "w-full", "min-w-0", "items-center", "justify-between", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-10)", "py-(--spacing-12)", "text-left", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-24)", "tracking-(--font-letter-spacing-default)", "text-menu-icon-default", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "max-[599px]:hidden"]), dx = ae(["inline-flex", "size-(--spacing-40)", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-(--spacing-10)", "text-menu-icon-default", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring"]);
function cu(t) {
  const e = W.c(26);
  let n, o, r, i, s;
  e[0] !== t ? ({
    collapsed: n,
    onClick: o,
    onToggle: r,
    shortcut: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = n ? "Expand Panel" : "Collapse Panel";
  let a;
  e[6] !== o || e[7] !== r ? (a = function(b) {
    o?.(b), r();
  }, e[6] = o, e[7] = r, e[8] = a) : a = e[8];
  const c = a;
  if (!n) {
    let h;
    e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = ux(), e[9] = h) : h = e[9];
    let b;
    e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
      /* @__PURE__ */ g(Ge, { "aria-hidden": !0, name: "arrow-left-shrink-sidebar", size: "sm", tone: "inherit" }),
      /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: "Collapse Panel" })
    ] }), e[10] = b) : b = e[10];
    let v;
    return e[11] !== c || e[12] !== l || e[13] !== i ? (v = /* @__PURE__ */ g("button", { ...i, "aria-expanded": !0, "aria-label": l, className: h, onClick: c, type: "button", children: b }), e[11] = c, e[12] = l, e[13] = i, e[14] = v) : v = e[14], v;
  }
  let u;
  e[15] !== s ? (u = s ? /* @__PURE__ */ g(H2, { "aria-hidden": "true", children: s }) : void 0, e[15] = s, e[16] = u) : u = e[16];
  let d;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = dx(), e[17] = d) : d = e[17];
  let f;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /* @__PURE__ */ g(Ge, { "aria-hidden": !0, name: "arrow-right-expand-sidebar", size: "sm", tone: "inherit" }), e[18] = f) : f = e[18];
  let p;
  e[19] !== c || e[20] !== l || e[21] !== i ? (p = /* @__PURE__ */ g("button", { ...i, "aria-expanded": !1, "aria-label": l, className: d, onClick: c, type: "button", children: f }), e[19] = c, e[20] = l, e[21] = i, e[22] = p) : p = e[22];
  let m;
  return e[23] !== u || e[24] !== p ? (m = /* @__PURE__ */ g("span", { className: "max-[599px]:hidden", children: /* @__PURE__ */ g(qo, { align: "center", endSection: u, label: "Expand", showArrow: !1, side: "right", children: p }) }), e[23] = u, e[24] = p, e[25] = m) : m = e[25], m;
}
const fx = [
  "grid",
  "h-dvh",
  "min-h-0",
  "overflow-hidden",
  "bg-surface",
  "grid-rows-[auto_minmax(0,1fr)]",
  "transition-[grid-template-columns]",
  "duration-200",
  "ease-in-out",
  "[--app-shell-sidebar-expanded-width:260px]",
  "[--app-shell-sidebar-collapsed-width:72px]",
  "[--app-shell-sidebar-width:var(--app-shell-sidebar-expanded-width)]",
  "data-[sidebar-collapsed]:[--app-shell-sidebar-width:var(--app-shell-sidebar-collapsed-width)]",
  "grid-cols-[var(--app-shell-sidebar-width)_minmax(0,1fr)]",
  "[&>[data-slot=top-bar]]:col-span-2",
  // Keep the header brand region at the expanded width when the sidebar collapses.
  "[&_[data-slot=top-bar-leading]]:w-(--app-shell-sidebar-expanded-width)",
  "max-[599px]:grid-cols-1",
  "max-[599px]:[&>[data-slot=top-bar]]:col-span-1",
  "max-[599px]:[&_[data-slot=top-bar-leading]]:w-auto"
].join(" "), z2 = "[", B2 = "assetwatch:app-shell:sidebar-collapsed";
function px() {
  if (typeof window > "u") return !1;
  try {
    return window.localStorage.getItem(B2) === "true";
  } catch {
    return !1;
  }
}
function Dp(t) {
  try {
    window.localStorage.setItem(B2, String(t));
  } catch {
  }
}
function mx(t) {
  return t instanceof HTMLElement ? t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable : !1;
}
function yO({
  children: t,
  ...e
}) {
  const n = ws("(max-width: 599px)", {
    defaultMatches: !1
  }), [o, r] = tt(px), [i, s] = tt(!1), [l, a] = tt([]), c = ut(0), u = l.at(-1), d = Qt(), f = a7();
  function p(b) {
    r(b), Dp(b);
  }
  function m(b) {
    const v = c.current;
    return c.current += 1, a((C) => [...C, {
      ...b,
      id: v
    }]), () => {
      a((C) => C.filter((y) => y.id !== v));
    };
  }
  _t(() => {
    if (n) return;
    function b(v) {
      if (v.defaultPrevented || v.isComposing || v.metaKey || v.ctrlKey || v.altKey || v.shiftKey || mx(v.target) || v.key !== z2)
        return;
      v.preventDefault();
      const C = !o;
      r(C), Dp(C);
    }
    return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
  }, [o, n]), _t(() => {
    if (d)
      return d.inert = !!u, () => {
        d.inert = !1;
      };
  }, [u, d]);
  const h = u ? /* @__PURE__ */ g("div", { className: "fixed inset-0 z-[var(--z-overlay-blocking,500)] flex items-center justify-center bg-surface-scrim", "data-slot": "app-shell-blocking-overlay", children: /* @__PURE__ */ g(A2, { label: u.label }) }) : null;
  return /* @__PURE__ */ g(Yd, { value: {
    desktopSidebarCollapsed: o,
    beginBlockingAction: m,
    isMobile: n,
    mobileNavigationOpen: i,
    setDesktopSidebarCollapsed: p,
    setMobileNavigationOpen: s
  }, children: /* @__PURE__ */ F("div", { className: "relative h-dvh", children: [
    /* @__PURE__ */ g("div", { ...e, "aria-busy": u ? !0 : void 0, className: fx, "data-sidebar-collapsed": o ? "" : void 0, "data-slot": "app-shell", inert: u ? !0 : void 0, children: t }),
    h && (f ? Z4(h, f) : h)
  ] }) });
}
function xO(t) {
  const e = W.c(22);
  let n, o, r, i, s, l;
  if (e[0] !== t ? ({
    banner: n,
    pageHeader: r,
    pageHeaderTabs: i,
    children: o,
    pending: l,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]), l === void 0 ? !1 : l) {
    let p;
    e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g("main", { "aria-busy": "true", className: "flex min-h-0 min-w-0 items-center justify-center overflow-y-auto bg-surface-low p-(--spacing-24)", children: /* @__PURE__ */ g(L2, {}) }), e[7] = p) : p = e[7];
    let m;
    return e[8] !== s ? (m = /* @__PURE__ */ g("div", { ...s, className: "grid min-h-0 min-w-0 grid-rows-[minmax(0,1fr)] overflow-hidden bg-surface-low", "data-slot": "app-shell-content", children: p }), e[8] = s, e[9] = m) : m = e[9], m;
  }
  let c;
  e[10] !== n ? (c = n && /* @__PURE__ */ g(Kr, { "data-slot": "app-shell-banner", fullWidth: !0, gap: 0, children: n }), e[10] = n, e[11] = c) : c = e[11];
  let u;
  e[12] !== r || e[13] !== i ? (u = (r || i) && /* @__PURE__ */ F("header", { className: i ? "border-b border-outline-subtle bg-surface" : "border-b border-outline-subtle bg-surface p-(--spacing-24)", "data-slot": "app-shell-page-header", children: [
    r && (i ? /* @__PURE__ */ g("div", { className: "px-(--spacing-24) pt-(--spacing-24) pb-(--spacing-20)", children: r }) : r),
    i
  ] }), e[12] = r, e[13] = i, e[14] = u) : u = e[14];
  let d;
  e[15] !== o ? (d = /* @__PURE__ */ g("main", { className: "min-h-0 min-w-0 overflow-y-auto bg-surface-low p-(--spacing-24)", "data-slot": "app-shell-content-body", children: o }), e[15] = o, e[16] = d) : d = e[16];
  let f;
  return e[17] !== s || e[18] !== c || e[19] !== u || e[20] !== d ? (f = /* @__PURE__ */ F("div", { ...s, className: "relative z-0 grid min-h-0 min-w-0 grid-rows-[auto_auto_minmax(0,1fr)] overflow-hidden bg-surface-low", "data-slot": "app-shell-content", children: [
    c,
    u,
    d
  ] }), e[17] = s, e[18] = c, e[19] = u, e[20] = d, e[21] = f) : f = e[21], f;
}
function CO(t) {
  const e = W.c(7);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  const o = jd();
  if (!o)
    throw new Error("AppShellMobileNavigationTrigger must be rendered within AppShell.");
  if (!o.isMobile)
    return null;
  let r;
  e[2] !== o ? (r = () => o.setMobileNavigationOpen(!0), e[2] = o, e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== r ? (i = /* @__PURE__ */ g(gt, { ...n, "aria-label": "Open navigation", icon: "menu-hamburger", onClick: r, variant: "ghost" }), e[4] = n, e[5] = r, e[6] = i) : i = e[6], i;
}
function gx(t) {
  const e = W.c(11);
  let n, o;
  e[0] !== t ? ({
    onClick: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = jd();
  if (!r)
    throw new Error("AppShellSidebarToggle must be rendered within AppShell.");
  if (r.isMobile)
    return null;
  const {
    desktopSidebarCollapsed: i,
    setDesktopSidebarCollapsed: s
  } = r;
  let l;
  e[3] !== i || e[4] !== s ? (l = () => s(!i), e[3] = i, e[4] = s, e[5] = l) : l = e[5];
  let a;
  return e[6] !== i || e[7] !== n || e[8] !== o || e[9] !== l ? (a = /* @__PURE__ */ g(cu, { ...o, collapsed: i, onClick: n, onToggle: l, shortcut: z2 }), e[6] = i, e[7] = n, e[8] = o, e[9] = l, e[10] = a) : a = e[10], a;
}
function hx(t) {
  const {
    open: e,
    defaultOpen: n,
    onOpenChange: o,
    disabled: r
  } = t, i = e !== void 0, [s, l] = dn({
    controlled: e,
    default: n,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: a,
    setMounted: c,
    transitionStatus: u
  } = Zn(s, !0, !0), [d, f] = x.useState(s), [{
    height: p,
    width: m
  }, h] = x.useState({
    height: void 0,
    width: void 0
  }), b = kt(), [v, C] = x.useState(), y = v ?? b, [w, R] = x.useState(!1), [S, E] = x.useState(!1), N = x.useRef(null), I = x.useRef(null), T = x.useRef(null), k = x.useRef(null), P = Ql(k, !1), M = Ce((D) => {
    const O = !s, _ = De(qn, D.nativeEvent);
    if (o(O, _), _.isCanceled)
      return;
    const V = k.current;
    I.current === "css-animation" && V != null && V.style.removeProperty("animation-name"), !w && !S && (I.current != null && I.current !== "css-animation" && !a && O && c(!0), I.current === "css-animation" && (!d && O && f(!0), !a && O && c(!0))), l(O), I.current === "none" && a && !O && c(!1);
  });
  return Ne(() => {
    i && I.current === "none" && !s && c(!1);
  }, [i, s, e, c]), x.useMemo(() => ({
    abortControllerRef: N,
    animationTypeRef: I,
    disabled: r,
    handleTrigger: M,
    height: p,
    mounted: a,
    open: s,
    panelId: y,
    panelRef: k,
    runOnceAnimationsFinish: P,
    setDimensions: h,
    setHiddenUntilFound: R,
    setKeepMounted: E,
    setMounted: c,
    setOpen: l,
    setPanelIdState: C,
    setVisible: f,
    transitionDimensionRef: T,
    transitionStatus: u,
    visible: d,
    width: m
  }), [N, I, r, M, p, a, s, y, k, P, h, R, E, c, l, f, T, u, d, m]);
}
const Kd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Kd.displayName = "CollapsibleRootContext");
function W2() {
  const t = x.useContext(Kd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : et(15));
  return t;
}
let Ai = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = Kn.startingStyle] = "startingStyle", t[t.endingStyle = Kn.endingStyle] = "endingStyle", t;
})({}), bx = /* @__PURE__ */ (function(t) {
  return t.panelOpen = "data-panel-open", t;
})({});
const vx = {
  [Ai.open]: ""
}, yx = {
  [Ai.closed]: ""
}, xx = {
  open(t) {
    return t ? {
      [bx.panelOpen]: ""
    } : null;
  }
}, Cx = {
  open(t) {
    return t ? vx : yx;
  }
}, U2 = {
  ...Cx,
  ...zt
}, qd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    defaultOpen: i = !1,
    disabled: s = !1,
    onOpenChange: l,
    open: a,
    style: c,
    ...u
  } = e, d = Ce(l), f = hx({
    open: a,
    defaultOpen: i,
    onOpenChange: d,
    disabled: s
  }), p = x.useMemo(() => ({
    open: f.open,
    disabled: f.disabled,
    transitionStatus: f.transitionStatus
  }), [f.open, f.disabled, f.transitionStatus]), m = x.useMemo(() => ({
    ...f,
    onOpenChange: d,
    state: p
  }), [f, d, p]), h = Le("div", e, {
    state: p,
    ref: n,
    props: u,
    stateAttributesMapping: U2
  });
  return /* @__PURE__ */ g(Kd.Provider, {
    value: m,
    children: h
  });
});
process.env.NODE_ENV !== "production" && (qd.displayName = "CollapsibleRoot");
const wx = {
  ...xx,
  ...zt
}, Bl = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    panelId: o,
    open: r,
    handleTrigger: i,
    state: s,
    disabled: l
  } = W2(), {
    className: a,
    disabled: c = l,
    id: u,
    render: d,
    nativeButton: f = !0,
    style: p,
    ...m
  } = e, {
    getButtonProps: h,
    buttonRef: b
  } = Bt({
    disabled: c,
    focusableWhenDisabled: !0,
    native: f
  }), v = x.useMemo(() => ({
    "aria-controls": r ? o : void 0,
    "aria-expanded": r,
    onClick: i
  }), [o, r, i]);
  return Le("button", e, {
    state: s,
    ref: [n, b],
    props: [v, m, h],
    stateAttributesMapping: wx
  });
});
process.env.NODE_ENV !== "production" && (Bl.displayName = "CollapsibleTrigger");
let Sx = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.orientation = "data-orientation", t;
})({});
function Rx(t) {
  const {
    abortControllerRef: e,
    animationTypeRef: n,
    externalRef: o,
    height: r,
    hiddenUntilFound: i,
    keepMounted: s,
    id: l,
    mounted: a,
    onOpenChange: c,
    open: u,
    panelRef: d,
    runOnceAnimationsFinish: f,
    setDimensions: p,
    setMounted: m,
    setOpen: h,
    setVisible: b,
    transitionDimensionRef: v,
    visible: C,
    width: y
  } = t, w = x.useRef(!1), R = x.useRef(null), S = x.useRef(u), E = x.useRef(u), N = Jr(), I = x.useMemo(() => n.current === "css-animation" ? !C : !u && !a, [u, a, C, n]), T = Ce((P) => {
    if (!P)
      return;
    if (n.current == null || v.current == null) {
      const O = getComputedStyle(P), _ = O.animationName !== "none" && O.animationName !== "", V = O.transitionDuration !== "0s" && O.transitionDuration !== "";
      _ && V ? process.env.NODE_ENV !== "production" && Xl("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used.") : O.animationName === "none" && O.transitionDuration !== "0s" ? n.current = "css-transition" : O.animationName !== "none" && O.transitionDuration === "0s" ? n.current = "css-animation" : n.current = "none", P.getAttribute(Sx.orientation) === "horizontal" || O.transitionProperty.indexOf("width") > -1 ? v.current = "width" : v.current = "height";
    }
    if (n.current !== "css-transition")
      return;
    (r === void 0 || y === void 0) && (p({
      height: P.scrollHeight,
      width: P.scrollWidth
    }), E.current && P.style.setProperty("transition-duration", "0s"));
    let M = -1, D = -1;
    return M = Vt.request(() => {
      E.current = !1, D = Vt.request(() => {
        setTimeout(() => {
          P.style.removeProperty("transition-duration");
        });
      });
    }), () => {
      Vt.cancel(M), Vt.cancel(D);
    };
  }), k = fn(o, d, T);
  return Ne(() => {
    if (n.current !== "css-transition")
      return;
    const P = d.current;
    if (!P)
      return;
    let M = -1;
    if (e.current != null && (e.current.abort(), e.current = null), u) {
      const D = {
        "justify-content": P.style.justifyContent,
        "align-items": P.style.alignItems,
        "align-content": P.style.alignContent,
        "justify-items": P.style.justifyItems
      };
      Object.keys(D).forEach((O) => {
        P.style.setProperty(O, "initial", "important");
      }), !E.current && !s && P.setAttribute(Ai.startingStyle, ""), p({
        height: P.scrollHeight,
        width: P.scrollWidth
      }), M = Vt.request(() => {
        Object.entries(D).forEach(([O, _]) => {
          _ === "" ? P.style.removeProperty(O) : P.style.setProperty(O, _);
        });
      });
    } else {
      if (P.scrollHeight === 0 && P.scrollWidth === 0)
        return;
      p({
        height: P.scrollHeight,
        width: P.scrollWidth
      });
      const D = new AbortController();
      e.current = D;
      const O = D.signal;
      let _ = null;
      const V = Ai.endingStyle;
      return _ = new MutationObserver((A) => {
        A.some(($) => $.type === "attributes" && $.attributeName === V) && (_?.disconnect(), _ = null, f(() => {
          p({
            height: 0,
            width: 0
          }), P.style.removeProperty("content-visibility"), m(!1), e.current === D && (e.current = null);
        }, O));
      }), _.observe(P, {
        attributes: !0,
        attributeFilter: [V]
      }), () => {
        _?.disconnect(), N.cancel(), e.current === D && (D.abort(), e.current = null);
      };
    }
    return () => {
      Vt.cancel(M);
    };
  }, [e, n, N, i, s, a, u, d, f, p, m]), Ne(() => {
    if (n.current !== "css-animation")
      return;
    const P = d.current;
    P && (R.current = P.style.animationName || R.current, P.style.setProperty("animation-name", "none"), p({
      height: P.scrollHeight,
      width: P.scrollWidth
    }), !S.current && !w.current && P.style.removeProperty("animation-name"), u ? (e.current != null && (e.current.abort(), e.current = null), m(!0), b(!0)) : (e.current = new AbortController(), f(() => {
      m(!1), b(!1), e.current = null;
    }, e.current.signal)));
  }, [e, n, u, d, f, p, m, b, C]), Qr(() => {
    const P = Vt.request(() => {
      S.current = !1;
    });
    return () => Vt.cancel(P);
  }), Ne(() => {
    if (!i)
      return;
    const P = d.current;
    if (!P)
      return;
    let M = -1, D = -1;
    return u && w.current && (P.style.transitionDuration = "0s", p({
      height: P.scrollHeight,
      width: P.scrollWidth
    }), M = Vt.request(() => {
      w.current = !1, D = Vt.request(() => {
        setTimeout(() => {
          P.style.removeProperty("transition-duration");
        });
      });
    })), () => {
      Vt.cancel(M), Vt.cancel(D);
    };
  }, [i, u, d, p]), Ne(() => {
    const P = d.current;
    P && i && I && (P.setAttribute("hidden", "until-found"), n.current === "css-transition" && P.setAttribute(Ai.startingStyle, ""));
  }, [i, I, n, d]), x.useEffect(function() {
    const M = d.current;
    if (!M)
      return;
    function D(O) {
      w.current = !0, h(!0), c(!0, De(Pt, O));
    }
    return at(M, "beforematch", D);
  }, [c, d, h]), x.useMemo(() => ({
    props: {
      hidden: I,
      id: l,
      ref: k
    }
  }), [I, l, k]);
}
let _p = /* @__PURE__ */ (function(t) {
  return t.collapsiblePanelHeight = "--collapsible-panel-height", t.collapsiblePanelWidth = "--collapsible-panel-width", t;
})({});
const Zd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    hiddenUntilFound: r,
    keepMounted: i,
    render: s,
    id: l,
    style: a,
    ...c
  } = e;
  process.env.NODE_ENV !== "production" && Ne(() => {
    r && i === !1 && Xl("The `keepMounted={false}` prop on a Collapsible will be ignored when using `hiddenUntilFound` since it requires the Panel to remain mounted even when closed.");
  }, [r, i]);
  const {
    abortControllerRef: u,
    animationTypeRef: d,
    height: f,
    mounted: p,
    onOpenChange: m,
    open: h,
    panelId: b,
    panelRef: v,
    runOnceAnimationsFinish: C,
    setDimensions: y,
    setHiddenUntilFound: w,
    setKeepMounted: R,
    setMounted: S,
    setPanelIdState: E,
    setOpen: N,
    setVisible: I,
    state: T,
    transitionDimensionRef: k,
    visible: P,
    width: M,
    transitionStatus: D
  } = W2(), O = r ?? !1, _ = i ?? !1;
  Ne(() => {
    if (l)
      return E(l), () => {
        E(void 0);
      };
  }, [l, E]), Ne(() => {
    w(O);
  }, [w, O]), Ne(() => {
    R(_);
  }, [R, _]);
  const {
    props: V
  } = Rx({
    abortControllerRef: u,
    animationTypeRef: d,
    externalRef: n,
    height: f,
    hiddenUntilFound: O,
    id: b,
    keepMounted: _,
    mounted: p,
    onOpenChange: m,
    open: h,
    panelRef: v,
    runOnceAnimationsFinish: C,
    setDimensions: y,
    setMounted: S,
    setOpen: N,
    setVisible: I,
    transitionDimensionRef: k,
    visible: P,
    width: M
  });
  Yt({
    open: h && D === "idle",
    ref: v,
    onComplete() {
      h && y({
        height: void 0,
        width: void 0
      });
    }
  });
  const A = x.useMemo(() => ({
    ...T,
    transitionStatus: D
  }), [T, D]), L = Le("div", e, {
    state: A,
    ref: [n, v],
    props: [V, {
      style: {
        [_p.collapsiblePanelHeight]: f === void 0 ? "auto" : `${f}px`,
        [_p.collapsiblePanelWidth]: M === void 0 ? "auto" : `${M}px`
      }
    }, c],
    stateAttributesMapping: U2
  });
  return _ || O || p ? L : null;
});
process.env.NODE_ENV !== "production" && (Zd.displayName = "CollapsiblePanel");
function Xd(t) {
  return Le(t.defaultTagName ?? "div", t, t);
}
const Qd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qd.displayName = "DialogRootContext");
function hn(t) {
  const e = x.useContext(Qd);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>." : et(27));
  return e;
}
let Zt = /* @__PURE__ */ (function(t) {
  return t.nestedDrawers = "--nested-drawers", t.height = "--drawer-height", t.frontmostHeight = "--drawer-frontmost-height", t.swipeMovementX = "--drawer-swipe-movement-x", t.swipeMovementY = "--drawer-swipe-movement-y", t.snapPointOffset = "--drawer-snap-point-offset", t.swipeStrength = "--drawer-swipe-strength", t;
})({}), So = /* @__PURE__ */ (function(t) {
  return t.swipeProgress = "--drawer-swipe-progress", t;
})({});
const Ex = {
  ...kn,
  ...zt
}, G2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    forceRender: s = !1,
    ...l
  } = e, {
    store: a
  } = hn(), c = a.useState("open"), u = a.useState("nested"), d = a.useState("mounted"), f = a.useState("transitionStatus");
  return Le("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: Ex,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        pointerEvents: c ? void 0 : "none",
        userSelect: "none",
        WebkitUserSelect: "none",
        [So.swipeProgress]: "0",
        [Zt.swipeStrength]: "1"
      }
    }, l],
    enabled: s || !u
  });
});
process.env.NODE_ENV !== "production" && (G2.displayName = "DrawerBackdrop");
const qr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    style: l,
    ...a
  } = e, {
    store: c
  } = hn(), u = c.useState("open");
  function d(h) {
    u && c.setOpen(!1, De(Fg, h.nativeEvent));
  }
  const {
    getButtonProps: f,
    buttonRef: p
  } = Bt({
    disabled: i,
    native: s
  });
  return Le("button", e, {
    state: {
      disabled: i
    },
    ref: [n, p],
    props: [{
      onClick: d
    }, a, f]
  });
});
process.env.NODE_ENV !== "production" && (qr.displayName = "DialogClose");
const Y2 = qr, j2 = "data-drawer-content", K2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e;
  return hn(), Le("div", e, {
    ref: n,
    props: [{
      [j2]: ""
    }, s]
  });
});
process.env.NODE_ENV !== "production" && (K2.displayName = "DrawerContent");
const qi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    store: a
  } = hn(), c = kt(s);
  return a.useSyncedValueWithCleanup("descriptionElementId", c), Le("p", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (qi.displayName = "DialogDescription");
const Nx = qi, q2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (q2.displayName = "DrawerProviderContext");
function Z2(t) {
  return x.useContext(q2);
}
let Wn = (function(t) {
  return t[t.open = un.open] = "open", t[t.closed = un.closed] = "closed", t[t.startingStyle = un.startingStyle] = "startingStyle", t[t.endingStyle = un.endingStyle] = "endingStyle", t.expanded = "data-expanded", t.nestedDrawerOpen = "data-nested-drawer-open", t.nestedDrawerSwiping = "data-nested-drawer-swiping", t.swipeDismiss = "data-swipe-dismiss", t.swipeDirection = "data-swipe-direction", t.swiping = "data-swiping", t;
})({});
const Jd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Jd.displayName = "DialogPortalContext");
function ef() {
  const t = x.useContext(Jd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : et(26));
  return t;
}
const tf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (tf.displayName = "DrawerRootContext");
function ha(t) {
  const e = x.useContext(tf);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DrawerRootContext is missing. Drawer parts must be placed within <Drawer.Root>." : et(90));
  return e;
}
function Wt(t, e = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(e, Math.min(t, n));
}
function Vp(t, e, n) {
  if (!Number.isFinite(e) || e <= 0)
    return null;
  if (typeof t == "number")
    return Number.isFinite(t) ? t <= 1 ? Wt(t, 0, 1) * e : t : null;
  const o = t.trim();
  if (o.endsWith("px")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r : null;
  }
  if (o.endsWith("rem")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r * n : null;
  }
  return null;
}
function kx(t, e) {
  let n = null, o = 1 / 0;
  for (const r of e) {
    const i = Math.abs(r.height - t);
    i < o && (o = i, n = r);
  }
  return n;
}
function X2() {
  const {
    store: t
  } = hn(), {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r
  } = ha(), i = t.useState("viewportElement"), [s, l] = x.useState(0), [a, c] = x.useState(16), u = Ce(() => {
    const m = Je(i).documentElement;
    i && l(i.offsetHeight), i || l(m.clientHeight);
    const h = parseFloat(getComputedStyle(m).fontSize);
    Number.isFinite(h) && c(h);
  });
  Ne(() => {
    if (u(), !i || typeof ResizeObserver != "function")
      return;
    const p = new ResizeObserver(u);
    return p.observe(i), () => {
      p.disconnect();
    };
  }, [u, i]);
  const d = x.useMemo(() => {
    if (!e || e.length === 0 || s <= 0 || r <= 0)
      return [];
    const p = Math.min(r, s);
    if (!Number.isFinite(p) || p <= 0)
      return [];
    const m = e.map((v) => {
      const C = Vp(v, s, a);
      if (C === null || !Number.isFinite(C))
        return null;
      const y = Wt(C, 0, p);
      return {
        value: v,
        height: y,
        offset: Math.max(0, r - y)
      };
    }).filter((v) => !!v);
    if (m.length <= 1)
      return m;
    const h = [], b = [];
    for (let v = m.length - 1; v >= 0; v -= 1) {
      const C = m[v];
      b.some((w) => Math.abs(w - C.height) <= 1) || (b.push(C.height), h.push(C));
    }
    return h.reverse(), h;
  }, [r, a, e, s]), f = x.useMemo(() => {
    if (n === void 0)
      return d[0];
    if (n === null)
      return;
    const p = d.find((v) => Object.is(v.value, n));
    if (p)
      return p;
    const m = Math.min(r, s), h = Vp(n, s, a);
    if (h === null || !Number.isFinite(h))
      return;
    const b = Wt(h, 0, m);
    return kx(b, d) ?? void 0;
  }, [n, r, d, a, s]);
  return {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r,
    viewportHeight: s,
    resolvedSnapPoints: d,
    activeSnapPointOffset: f?.offset ?? null
  };
}
const nf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (nf.displayName = "DrawerViewportContext");
function Mx(t) {
  return x.useContext(nf);
}
let Ap = !1;
function Px() {
  Ap || (typeof CSS < "u" && "registerProperty" in CSS && ([Zt.swipeMovementX, Zt.swipeMovementY, Zt.snapPointOffset].forEach((t) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<length>",
        inherits: !1,
        initialValue: "0px"
      });
    } catch {
    }
  }), [{
    name: So.swipeProgress,
    initialValue: "0"
  }, {
    name: Zt.swipeStrength,
    initialValue: "1"
  }].forEach(({
    name: t,
    initialValue: e
  }) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<number>",
        inherits: !1,
        initialValue: e
      });
    } catch {
    }
  })), Ap = !0);
}
const Ix = {
  ...kn,
  ...zt,
  expanded(t) {
    return t ? {
      [Wn.expanded]: ""
    } : null;
  },
  nestedDrawerOpen(t) {
    return t ? {
      [Wn.nestedDrawerOpen]: ""
    } : null;
  },
  nestedDrawerSwiping(t) {
    return t ? {
      [Wn.nestedDrawerSwiping]: ""
    } : null;
  },
  swipeDirection(t) {
    return t ? {
      [Wn.swipeDirection]: t
    } : null;
  },
  swiping(t) {
    return t ? {
      [Wn.swiping]: ""
    } : null;
  }
}, Q2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: i,
    render: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = hn(), {
    swipeDirection: u,
    frontmostHeight: d,
    hasNestedDrawer: f,
    nestedSwiping: p,
    nestedSwipeProgressStore: m,
    onPopupHeightChange: h,
    notifyParentFrontmostHeight: b,
    notifyParentHasNestedDrawer: v
  } = ha(), C = c.useState("descriptionElementId"), y = c.useState("disablePointerDismissal"), w = c.useState("floatingRootContext"), R = c.useState("popupProps"), S = c.useState("modal"), E = c.useState("mounted"), N = c.useState("nested"), I = c.useState("nestedOpenDrawerCount"), T = c.useState("transitionStatus"), k = c.useState("open"), P = c.useState("openMethod"), M = c.useState("titleElementId"), D = c.useState("role"), O = I > 0, _ = Mx(), V = _?.swiping ?? !1, A = _?.swipeStrength ?? null, {
    snapPoints: L,
    activeSnapPoint: $,
    activeSnapPointOffset: Y
  } = X2();
  ef();
  const [G, j] = x.useState(0), Z = x.useRef(0);
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (_)
      return;
    const fe = pr.captureOwnerStack?.() || "";
    jo(`<Drawer.Popup> expected to be rendered within <Drawer.Viewport>. Omitting the viewport disables drawer swipe handling and touch scroll locking. Wrap <Drawer.Popup> in <Drawer.Viewport>.${fe}`);
  }, [_]);
  const U = Ce(() => {
    const fe = c.context.popupRef.current;
    if (!fe)
      return;
    const ne = fe.offsetHeight;
    if (Z.current > 0 && d > Z.current && ne > Z.current)
      return;
    if (Z.current > 0 && f) {
      const xe = Z.current;
      j(xe), h(xe);
      return;
    }
    const pe = ne;
    pe !== Z.current && (Z.current = pe, j(pe), h(pe));
  });
  Ne(() => {
    if (!E) {
      Z.current = 0, j(0), h(0);
      return;
    }
    const fe = c.context.popupRef.current;
    if (!fe || (Px(), U(), typeof ResizeObserver != "function"))
      return;
    const ne = new ResizeObserver(U);
    return ne.observe(fe), () => {
      ne.disconnect();
    };
  }, [U, E, O, h, c.context.popupRef]), Ne(() => {
    const fe = c.context.popupRef, ne = () => {
      const pe = fe.current;
      if (!pe)
        return;
      const xe = m.getSnapshot();
      xe > 0 ? pe.style.setProperty(So.swipeProgress, `${xe}`) : pe.style.setProperty(So.swipeProgress, "0");
    };
    ne();
    const se = m.subscribe(ne);
    return () => {
      se();
      const pe = fe.current;
      pe && pe.style.setProperty(So.swipeProgress, "0");
    };
  }, [m, c.context.popupRef]), x.useEffect(() => {
    if (k)
      return b?.(d), () => {
        b?.(0);
      };
  }, [d, k, b]), x.useEffect(() => v ? (v(k || T === "ending"), () => {
    v(!1);
  }) : void 0, [v, k, T]), Yt({
    open: k,
    ref: c.context.popupRef,
    onComplete() {
      k && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const q = i === void 0 ? c.context.popupRef : i, te = {
    open: k,
    nested: N,
    transitionStatus: T,
    expanded: $ === 1,
    nestedDrawerOpen: O,
    nestedDrawerSwiping: p,
    swipeDirection: u,
    swiping: V
  };
  let H;
  G && !(!f && T !== "ending") && (H = `${G}px`);
  const ee = L && L.length > 0 && (u === "down" || u === "up");
  let le = null;
  ee && Y !== null && (le = u === "up" ? -Y : Y);
  let Q = _ ? _.getDragStyles() : St;
  if (ee && u === "down") {
    const fe = Y ?? 0, ne = Number.parseFloat(String(Q[Zt.swipeMovementY] ?? 0)), se = Number.isFinite(ne) ? fe + ne : fe, pe = se < 0;
    if (V && pe && Number.isFinite(ne)) {
      const xe = Math.abs(se), he = -Math.sqrt(xe) - fe;
      Q = {
        ...Q,
        transform: void 0,
        [Zt.swipeMovementY]: `${he}px`
      };
    } else
      Q = {
        ...Q,
        transform: void 0
      };
  }
  const re = Le("div", e, {
    state: te,
    props: [R, {
      "aria-labelledby": M,
      "aria-describedby": C,
      role: D,
      tabIndex: -1,
      hidden: !E,
      onKeyDown(fe) {
        hs.has(fe.key) && fe.stopPropagation();
      },
      style: {
        ...Q,
        [So.swipeProgress]: "0",
        [Zt.nestedDrawers]: I,
        [Zt.height]: H,
        [Zt.snapPointOffset]: typeof le == "number" ? `${le}px` : "0px",
        [Zt.frontmostHeight]: d ? `${d}px` : void 0,
        [Zt.swipeStrength]: typeof A == "number" && Number.isFinite(A) && A > 0 ? `${A}` : "1"
      }
    }, a],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: Ix
  });
  return /* @__PURE__ */ g(ni, {
    context: w,
    openInteractionType: P,
    disabled: !E,
    closeOnFocusOut: !y,
    initialFocus: q,
    returnFocus: r,
    modal: S !== !1,
    restoreFocus: "popup",
    children: re
  });
});
process.env.NODE_ENV !== "production" && (Q2.displayName = "DrawerPopup");
const mi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = hn(), s = i.useState("mounted"), l = i.useState("modal"), a = i.useState("open");
  return s || o ? /* @__PURE__ */ g(Jd.Provider, {
    value: o,
    children: /* @__PURE__ */ F(ti, {
      ref: n,
      ...r,
      children: [s && l === !0 && /* @__PURE__ */ g(ii, {
        ref: i.context.internalBackdropRef,
        inert: Er(!a)
      }), e.children]
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (mi.displayName = "DialogPortal");
const Tx = mi, Ox = {
  ...kn,
  ...zt
}, Ss = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    forceRender: s = !1,
    ...l
  } = e, {
    store: a
  } = hn(), c = a.useState("open"), u = a.useState("nested"), d = a.useState("mounted"), f = a.useState("transitionStatus");
  return Le("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: Ox,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, l],
    enabled: s || !u
  });
});
process.env.NODE_ENV !== "production" && (Ss.displayName = "DialogBackdrop");
let Dx = /* @__PURE__ */ (function(t) {
  return t.nestedDialogs = "--nested-dialogs", t;
})({}), _x = (function(t) {
  return t[t.open = un.open] = "open", t[t.closed = un.closed] = "closed", t[t.startingStyle = un.startingStyle] = "startingStyle", t[t.endingStyle = un.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const Vx = {
  ...kn,
  ...zt,
  nestedDialogOpen(t) {
    return t ? {
      [_x.nestedDialogOpen]: ""
    } : null;
  }
}, Rs = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: i,
    render: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = hn(), u = c.useState("descriptionElementId"), d = c.useState("disablePointerDismissal"), f = c.useState("floatingRootContext"), p = c.useState("popupProps"), m = c.useState("modal"), h = c.useState("mounted"), b = c.useState("nested"), v = c.useState("nestedOpenDialogCount"), C = c.useState("open"), y = c.useState("openMethod"), w = c.useState("titleElementId"), R = c.useState("transitionStatus"), S = c.useState("role");
  ef(), Yt({
    open: C,
    ref: c.context.popupRef,
    onComplete() {
      C && c.context.onOpenChangeComplete?.(!0);
    }
  });
  function E(P) {
    return P === "touch" ? c.context.popupRef.current : !0;
  }
  const N = i === void 0 ? E : i, I = v > 0, k = Le("div", e, {
    state: {
      open: C,
      nested: b,
      transitionStatus: R,
      nestedDialogOpen: I
    },
    props: [p, {
      "aria-labelledby": w ?? void 0,
      "aria-describedby": u ?? void 0,
      role: S,
      tabIndex: -1,
      hidden: !h,
      onKeyDown(P) {
        hs.has(P.key) && P.stopPropagation();
      },
      style: {
        [Dx.nestedDialogs]: v
      }
    }, a],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: Vx
  });
  return /* @__PURE__ */ g(ni, {
    context: f,
    openInteractionType: y,
    disabled: !h,
    closeOnFocusOut: !d,
    initialFocus: N,
    returnFocus: r,
    modal: m !== !1,
    restoreFocus: "popup",
    children: k
  });
});
process.env.NODE_ENV !== "production" && (Rs.displayName = "DialogPopup");
function Ax(t) {
  const {
    store: e,
    parentContext: n,
    actionsRef: o,
    isDrawer: r
  } = t, i = e.useState("open"), s = e.useState("disablePointerDismissal"), l = e.useState("modal"), a = e.useState("popupElement"), {
    openMethod: c,
    triggerProps: u
  } = vs(i);
  ls(e);
  const {
    forceUnmount: d
  } = as(i, e), f = x.useCallback(() => {
    e.setOpen(!1, De(os));
  }, [e]);
  x.useImperativeHandle(o, () => ({
    unmount: d,
    close: f
  }), [d, f]);
  const p = ds({
    popupStore: e,
    onOpenChange: e.setOpen,
    treatPopupAsFloatingElement: !0
  }), [m, h] = x.useState(0), [b, v] = x.useState(0), C = m === 0, y = hd(p), w = Cr(p, {
    outsidePressEvent() {
      return e.context.internalBackdropRef.current || e.context.backdropRef.current ? "intentional" : {
        mouse: l === "trap-focus" ? "sloppy" : "intentional",
        touch: "sloppy"
      };
    },
    outsidePress(k) {
      if (!e.context.outsidePressEnabledRef.current || "button" in k && k.button !== 0 || "touches" in k && k.touches.length !== 1)
        return !1;
      const P = bt(k);
      if (C && !s) {
        const M = P;
        return l && (e.context.internalBackdropRef.current || e.context.backdropRef.current) ? e.context.internalBackdropRef.current === M || e.context.backdropRef.current === M || Fe(M, a) && !M?.hasAttribute("data-base-ui-portal") : !0;
      }
      return !1;
    },
    escapeKey: C
  });
  Kh(i && l === !0, a);
  const {
    getReferenceProps: R,
    getFloatingProps: S,
    getTriggerProps: E
  } = Jn([y, w]);
  e.useContextCallback("onNestedDialogOpen", (k, P) => {
    h(k), v(P);
  }), e.useContextCallback("onNestedDialogClose", () => {
    h(0), v(0);
  }), x.useEffect(() => (n?.onNestedDialogOpen && i && n.onNestedDialogOpen(m + 1, b + (r ? 1 : 0)), n?.onNestedDialogClose && !i && n.onNestedDialogClose(), () => {
    n?.onNestedDialogClose && i && n.onNestedDialogClose();
  }), [r, i, m, b, n]);
  const N = x.useMemo(() => R(u), [R, u]), I = x.useMemo(() => E(u), [E, u]), T = x.useMemo(() => S(), [S]);
  e.useSyncedValues({
    openMethod: c,
    activeTriggerProps: N,
    inactiveTriggerProps: I,
    popupProps: T,
    floatingRootContext: p,
    nestedOpenDialogCount: m,
    nestedOpenDrawerCount: b
  });
}
const Lx = {
  ...us,
  modal: be((t) => t.modal),
  nested: be((t) => t.nested),
  nestedOpenDialogCount: be((t) => t.nestedOpenDialogCount),
  nestedOpenDrawerCount: be((t) => t.nestedOpenDrawerCount),
  disablePointerDismissal: be((t) => t.disablePointerDismissal),
  openMethod: be((t) => t.openMethod),
  descriptionElementId: be((t) => t.descriptionElementId),
  titleElementId: be((t) => t.titleElementId),
  viewportElement: be((t) => t.viewportElement),
  role: be((t) => t.role)
};
class of extends wr {
  constructor(e) {
    super(Fx(e), {
      popupRef: /* @__PURE__ */ x.createRef(),
      backdropRef: /* @__PURE__ */ x.createRef(),
      internalBackdropRef: /* @__PURE__ */ x.createRef(),
      outsidePressEnabledRef: {
        current: !0
      },
      triggerElements: new Sr(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0
    }, Lx);
  }
  setOpen = (e, n) => {
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, !e && n.trigger == null && this.state.activeTriggerId != null && (n.trigger = this.state.activeTriggerElement ?? void 0), this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const o = {
      open: e
    }, r = n.trigger?.id ?? null;
    (r || e) && (o.activeTriggerId = r, o.activeTriggerElement = n.trigger ?? null), this.update(o);
  };
  static useStore(e, n) {
    const o = It(() => new of(n)).current;
    return e ?? o;
  }
}
function Fx(t = {}) {
  return {
    ...cs(),
    modal: !0,
    disablePointerDismissal: !1,
    popupElement: null,
    viewportElement: null,
    descriptionElementId: void 0,
    titleElementId: void 0,
    openMethod: null,
    nested: !1,
    nestedOpenDialogCount: 0,
    nestedOpenDrawerCount: 0,
    role: "dialog",
    ...t
  };
}
const Wl = /* @__PURE__ */ x.createContext(!1);
process.env.NODE_ENV !== "production" && (Wl.displayName = "IsDrawerContext");
function Es(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    disablePointerDismissal: s = !1,
    modal: l = !0,
    actionsRef: a,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null
  } = t, f = hn(!0), p = x.useContext(Wl), m = !!f, h = of.useStore(c?.store, {
    open: o,
    openProp: n,
    activeTriggerId: d,
    triggerIdProp: u,
    modal: l,
    disablePointerDismissal: s,
    nested: m
  });
  Nr(() => {
    n === void 0 && h.state.open === !1 && o === !0 && h.update({
      open: !0,
      activeTriggerId: d
    });
  }), h.useControlledProp("openProp", n), h.useControlledProp("triggerIdProp", u), h.useSyncedValues({
    disablePointerDismissal: s,
    nested: m,
    modal: l
  }), h.useContextCallback("onOpenChange", r), h.useContextCallback("onOpenChangeComplete", i);
  const b = h.useState("payload");
  Ax({
    store: h,
    actionsRef: a,
    parentContext: f?.store.context,
    isDrawer: p
  });
  const v = x.useMemo(() => ({
    store: h
  }), [h]);
  return /* @__PURE__ */ g(Wl.Provider, {
    value: !1,
    children: /* @__PURE__ */ g(Qd.Provider, {
      value: v,
      children: typeof e == "function" ? e({
        payload: b
      }) : e
    })
  });
}
let Lp = (function(t) {
  return t[t.open = un.open] = "open", t[t.closed = un.closed] = "closed", t[t.startingStyle = un.startingStyle] = "startingStyle", t[t.endingStyle = un.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const $x = {
  ...kn,
  ...zt,
  nested(t) {
    return t ? {
      [Lp.nested]: ""
    } : null;
  },
  nestedDialogOpen(t) {
    return t ? {
      [Lp.nestedDialogOpen]: ""
    } : null;
  }
}, gi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: i,
    style: s,
    ...l
  } = e, a = ef(), {
    store: c
  } = hn(), u = c.useState("open"), d = c.useState("nested"), f = c.useState("transitionStatus"), p = c.useState("nestedOpenDialogCount"), m = c.useState("mounted"), h = p > 0;
  return Le("div", e, {
    enabled: a || m,
    state: {
      open: u,
      nested: d,
      transitionStatus: f,
      nestedDialogOpen: h
    },
    ref: [n, c.useStateSetter("viewportElement")],
    stateAttributesMapping: $x,
    props: [{
      role: "presentation",
      hidden: !m,
      style: {
        pointerEvents: u ? void 0 : "none"
      },
      children: i
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (gi.displayName = "DialogViewport");
const Zi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    store: a
  } = hn(), c = kt(s);
  return a.useSyncedValueWithCleanup("titleElementId", c), Le("h2", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (Zi.displayName = "DialogTitle");
const J2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    id: l,
    payload: a,
    handle: c,
    style: u,
    ...d
  } = e, f = hn(!0), p = c?.store ?? f?.store;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Trigger> must be used within <Dialog.Root> or provided with a handle." : et(79));
  const m = kt(l), h = p.useState("floatingRootContext"), b = p.useState("isOpenedByTrigger", m), v = x.useRef(null), {
    registerTrigger: C,
    isMountedByThisTrigger: y
  } = ss(m, v, p, {
    payload: a
  }), {
    getButtonProps: w,
    buttonRef: R
  } = Bt({
    disabled: i,
    native: s
  }), S = xr(h, {
    enabled: h != null
  }), E = Jn([S]), N = {
    disabled: i,
    open: b
  }, I = p.useState("triggerProps", y);
  return Le("button", e, {
    state: N,
    ref: [R, n, C, v],
    props: [E.getReferenceProps(), I, {
      [Xu]: "",
      id: m
    }, d, w],
    stateAttributesMapping: br
  });
});
process.env.NODE_ENV !== "production" && (J2.displayName = "DialogTrigger");
var Fp, $p;
function Hx(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    disablePointerDismissal: s = !1,
    modal: l = !0,
    actionsRef: a,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null,
    swipeDirection: f = "down",
    snapToSequentialPoints: p = !1,
    snapPoints: m,
    snapPoint: h,
    defaultSnapPoint: b,
    onSnapPointChange: v
  } = t, C = Ce(v), y = ha(!0), w = y?.onNestedSwipeProgressChange, R = y?.onNestedFrontmostHeightChange, S = y?.onNestedSwipingChange, E = y?.onNestedDrawerPresenceChange, [N, I] = x.useState(0), [T, k] = x.useState(0), [P, M] = x.useState(!1), [D, O] = x.useState(!1), [_] = x.useState(zx), V = b !== void 0 ? b : m?.[0] ?? null, A = h !== void 0, [L, $] = dn({
    controlled: h,
    default: V,
    name: "Drawer",
    state: "snapPoint"
  }), Y = x.useRef(!1), G = Ce((Q, re) => {
    const fe = re ?? De(Pt);
    C?.(Q, fe), !fe.isCanceled && $(Q);
  }), j = x.useMemo(() => A || !m || m.length === 0 ? L : L === null || !m.some((Q) => Object.is(Q, L)) ? V : L, [L, A, V, m]), Z = Ce((Q) => {
    I(Q), !Y.current && Q > 0 && k(Q);
  }), U = Ce((Q) => {
    if (Q > 0) {
      Y.current = !0, k(Q);
      return;
    }
    Y.current = !1, N > 0 && k(N);
  }), q = Ce((Q) => {
    M(Q);
  }), te = Ce((Q) => {
    _.set(Q), w?.(Q);
  }), H = Ce((Q) => {
    O(Q), S?.(Q);
  }), X = Ce((Q, re) => {
    r?.(Q, re), !re.isCanceled && !Q && m && m.length > 0 && G(V, De(re.reason, re.event, re.trigger));
  }), ee = x.useMemo(() => ({
    swipeDirection: f,
    snapToSequentialPoints: p,
    snapPoints: m,
    activeSnapPoint: j,
    setActiveSnapPoint: G,
    frontmostHeight: T,
    popupHeight: N,
    hasNestedDrawer: P,
    nestedSwiping: D,
    nestedSwipeProgressStore: _,
    onNestedDrawerPresenceChange: q,
    onPopupHeightChange: Z,
    onNestedFrontmostHeightChange: U,
    onNestedSwipingChange: H,
    onNestedSwipeProgressChange: te,
    notifyParentFrontmostHeight: R,
    notifyParentSwipingChange: S,
    notifyParentSwipeProgressChange: w,
    notifyParentHasNestedDrawer: E
  }), [j, T, P, D, _, E, w, S, R, q, U, te, H, Z, N, G, m, p, f]), le = typeof e == "function" ? (Q) => /* @__PURE__ */ F(x.Fragment, {
    children: [Fp || (Fp = /* @__PURE__ */ g(Hp, {})), e(Q)]
  }) : /* @__PURE__ */ F(x.Fragment, {
    children: [$p || ($p = /* @__PURE__ */ g(Hp, {})), e]
  });
  return /* @__PURE__ */ g(tf.Provider, {
    value: ee,
    children: /* @__PURE__ */ g(Wl.Provider, {
      value: !0,
      children: /* @__PURE__ */ g(Es, {
        open: n,
        defaultOpen: o,
        onOpenChange: X,
        onOpenChangeComplete: i,
        disablePointerDismissal: s,
        modal: l,
        actionsRef: a,
        handle: c,
        triggerId: u,
        defaultTriggerId: d,
        children: le
      })
    })
  });
}
function zx() {
  let t = 0;
  const e = /* @__PURE__ */ new Set();
  return {
    getSnapshot: () => t,
    set(n) {
      const o = Number.isFinite(n) ? n : 0;
      o !== t && (t = o, e.forEach((r) => {
        r();
      }));
    },
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    }
  };
}
function Hp() {
  const t = Do(), e = Z2(), n = hn(!1), o = n.store.useState("open"), r = n.store.useState("nestedOpenDialogCount"), i = n.store.useState("popupElement"), s = r === 0;
  return x.useEffect(() => {
    if (!(!e || t == null))
      return () => {
        e.removeDrawer(t);
      };
  }, [t, e]), x.useEffect(() => {
    t != null && e?.setDrawerOpen(t, o);
  }, [t, o, e]), x.useEffect(() => {
    if (!o || !s || !Bi)
      return;
    const a = Ct(i).CloseWatcher;
    if (!a)
      return;
    function c(f) {
      n.store.select("open") && n.store.setOpen(!1, De(n8, f));
    }
    const u = new a(), d = at(u, "close", c);
    return () => {
      d(), u.destroy();
    };
  }, [n.store, s, o, i]), null;
}
function uu(t, e) {
  const n = pn(t);
  if (e === "vertical") {
    const r = n.overflowY;
    return (r === "auto" || r === "scroll") && t.scrollHeight > t.clientHeight;
  }
  const o = n.overflowX;
  return (o === "auto" || o === "scroll") && t.scrollWidth > t.clientWidth;
}
function Bx(t, e, n) {
  let o = t;
  for (; o && o !== e; ) {
    for (const r of n)
      if (uu(o, r))
        return !0;
    o = o.parentElement;
  }
  return !1;
}
function Ar(t, e, n = "vertical") {
  let o = xt(t) ? t : null;
  for (; o && o !== e; ) {
    if (uu(o, n))
      return o;
    o = o.parentElement;
  }
  return uu(e, n) ? e : null;
}
function Sl(t, e, n) {
  return typeof t?.elementFromPoint == "function" ? t.elementFromPoint(e, n) : null;
}
const Wx = 40, Ux = 10, Gx = 1, Yx = 50, zp = 16, jx = 80, Kx = 'button,a,input,select,textarea,label,[role="button"]';
function lc(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function qx(t) {
  const n = Ct(t).getComputedStyle(t).transform;
  let o = 0, r = 0, i = 1;
  if (n && n !== "none") {
    const s = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (s) {
      const l = s[1].split(", ").map(parseFloat);
      l.length === 6 ? (o = l[4], r = l[5], i = Math.sqrt(l[0] * l[0] + l[1] * l[1])) : l.length === 16 && (o = l[12], r = l[13], i = l[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: i
  };
}
function ol(t) {
  return Number.isFinite(t) && t > 0 ? t : null;
}
function Zx(t) {
  return t % 2 === 1;
}
function ac(t, e, n) {
  const o = t[n];
  if (typeof o == "function")
    try {
      o.call(t, e);
    } catch (r) {
      if (r && typeof r == "object" && "name" in r && r.name === "NotFoundError")
        return;
      throw r;
    }
}
function Xx(t) {
  const {
    enabled: e,
    directions: n,
    elementRef: o,
    movementCssVars: r,
    canStart: i,
    ignoreSelectorWhenTouch: s = !0,
    ignoreScrollableAncestors: l = !1,
    swipeThreshold: a,
    onDismiss: c,
    onProgress: u,
    onCancel: d,
    onSwipeStart: f,
    onRelease: p,
    onSwipingChange: m,
    trackDrag: h = !0
  } = t, b = Kx, v = n.length === 1 ? n[0] : void 0, C = Math.max(0, typeof a == "number" ? a : Wx), y = n.includes("left"), w = n.includes("right"), R = n.includes("up"), S = n.includes("down"), E = y || w, N = R || S, I = x.useMemo(() => {
    const we = [];
    return N && we.push("vertical"), E && we.push("horizontal"), we;
  }, [E, N]), [T, k] = x.useState(void 0), [P, M] = x.useState(!1), [D, O] = x.useState(!1), [_, V] = x.useState(!1), [A, L] = x.useState({
    x: 0,
    y: 0
  }), [$, Y] = x.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [G, j] = x.useState(null), Z = x.useRef({
    x: 0,
    y: 0
  }), U = x.useRef({
    x: 0,
    y: 0
  }), q = x.useRef(null), te = x.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), H = x.useRef(void 0), X = x.useRef(0), ee = x.useRef(!1), le = x.useRef({
    x: 0,
    y: 0
  }), Q = x.useRef(!1), re = x.useRef(!1), fe = x.useRef(null), ne = x.useRef(!1), se = x.useRef(!1), pe = x.useRef({
    width: 0,
    height: 0
  }), xe = x.useRef(0), ce = x.useRef(C), he = x.useRef(null), z = x.useRef(null), J = x.useRef({
    x: 0,
    y: 0
  }), B = x.useRef(null), K = x.useRef(!1), ie = Ce((we) => {
    K.current !== we && (K.current = we, M(we), m?.(we));
  });
  function ge(we) {
    if (!we)
      return;
    if (typeof a != "function") {
      ce.current = C;
      return;
    }
    const ke = o.current;
    if (!ke)
      return;
    const Ae = a({
      element: ke,
      direction: we
    });
    ce.current = Math.max(0, Ae);
  }
  const ue = Ce((we, ke) => {
    const Ae = Number.isFinite(we) ? Wt(we, 0, 1) : 0, We = Ae !== xe.current;
    let it = !1;
    if (ke) {
      const je = B.current;
      it = !je || je.deltaX !== ke.deltaX || je.deltaY !== ke.deltaY || je.direction !== ke.direction;
    }
    !We && !it || (xe.current = Ae, ke ? B.current = ke : We && (B.current = null), u?.(Ae, ke));
  });
  function Se(we, ke) {
    if (ke === null)
      return;
    const Ae = z.current;
    if (Ae && ke > Ae.time) {
      const We = Math.max(ke - Ae.time, zp);
      J.current = {
        x: (we.x - Ae.x) / We,
        y: (we.y - Ae.y) / We
      };
    }
    z.current = {
      x: we.x,
      y: we.y,
      time: ke
    };
  }
  const ve = x.useCallback(() => {
    k(void 0), ie(!1), O(!1), V(!1), L({
      x: 0,
      y: 0
    }), Y({
      x: 0,
      y: 0,
      scale: 1
    }), j(null), ue(0), ce.current = C, Z.current = {
      x: 0,
      y: 0
    }, U.current = {
      x: 0,
      y: 0
    }, te.current = {
      x: 0,
      y: 0,
      scale: 1
    }, H.current = void 0, X.current = 0, ee.current = !1, le.current = {
      x: 0,
      y: 0
    }, Q.current = !1, q.current = null, re.current = !1, fe.current = null, ne.current = !1, se.current = !1, pe.current = {
      width: 0,
      height: 0
    }, he.current = null, z.current = null, J.current = {
      x: 0,
      y: 0
    }, B.current = null;
  }, [ie, C, ue]);
  x.useEffect(() => {
    typeof a != "function" && (ce.current = C);
  }, [C, a]);
  function de(we) {
    if ("touches" in we) {
      const ke = we.touches[0];
      return ke ? {
        x: ke.clientX,
        y: ke.clientY
      } : null;
    }
    return {
      x: we.clientX,
      y: we.clientY
    };
  }
  function me(we) {
    return "touches" in we ? !0 : we.pointerType === "touch";
  }
  function Re(we, ke) {
    const Ae = Je(o.current);
    return Sl(Ae, we.x, we.y) ?? bt(ke);
  }
  function Ie(we, ke) {
    return E && !N ? Ar(we, ke, "horizontal") : N && !E ? Ar(we, ke, "vertical") : Ar(we, ke, "vertical") ?? Ar(we, ke, "horizontal");
  }
  function Pe(we, ke, Ae) {
    ne.current = !1;
    const We = me(we), it = Re(ke, we.nativeEvent), ft = Je(o.current).body, Ze = We && ft ? Ie(it, ft) : null, Ke = Ae?.ignoreScrollableTarget ?? !1;
    if (Ze && !Ke || (ne.current = !!(Ze && Ke), (it ? it.closest(b) : !1) && (!We || s)))
      return !1;
    const st = o.current;
    if (l && st && it && I.length > 0 && !(Ae?.ignoreScrollableAncestors ?? !1) && Bx(it, st, I))
      return !1;
    if (ee.current = !1, H.current = void 0, X.current = 0, Z.current = ke, he.current = ol(we.timeStamp), le.current = ke, q.current = ke, st) {
      pe.current = {
        width: st.offsetWidth,
        height: st.offsetHeight
      }, ge(v);
      const mt = qx(st);
      te.current = mt, U.current = {
        x: mt.x,
        y: mt.y
      }, Y(mt), L({
        x: mt.x,
        y: mt.y
      }), Se({
        x: mt.x,
        y: mt.y
      }, he.current), "touches" in we || ac(st, we.pointerId, "setPointerCapture");
    }
    return f?.(we.nativeEvent), ie(!0), O(!1), j(null), Q.current = !0, ue(0), !0;
  }
  function _e() {
    Ye(), ne.current = !1, q.current = null;
  }
  function Ye() {
    re.current = !1, fe.current = null;
  }
  function qe(we) {
    if (_e(), !K.current)
      return;
    ie(!1), O(!1), j(null);
    const ke = h ? $ : te.current;
    U.current = {
      x: ke.x,
      y: ke.y
    }, L({
      x: ke.x,
      y: ke.y
    }), k(void 0), se.current = !1;
    const Ae = o.current;
    Ae && ac(Ae, we.pointerId, "releasePointerCapture"), ue(0, {
      deltaX: 0,
      deltaY: 0,
      direction: void 0
    }), d?.(we.nativeEvent);
  }
  function $e(we, ke) {
    const Ae = (ft) => ft >= 0 ? ft ** 0.5 : -(Math.abs(ft) ** 0.5), We = (ft, Ze, Ke) => !Ze && ft < 0 || !Ke && ft > 0 ? Ae(ft) : ft, it = E ? We(we, y, w) : Ae(we), je = N ? We(ke, R, S) : Ae(ke);
    return {
      x: it,
      y: je
    };
  }
  function Ee(we, ke, Ae) {
    const We = Math.abs(ke), it = Math.abs(Ae);
    if (N && Ae !== 0 && (!E || it >= We)) {
      const Ze = Math.max(0, we.scrollHeight - we.clientHeight), Ke = we.scrollTop <= 0, nt = we.scrollTop >= Ze, st = Ae > 0, mt = Ae < 0;
      return st && Ke && S || mt && nt && R;
    }
    if (E && ke !== 0 && (!N || We > it)) {
      const Ze = Math.max(0, we.scrollWidth - we.clientWidth), Ke = we.scrollLeft <= 0, nt = we.scrollLeft >= Ze, st = ke > 0, mt = ke < 0;
      return st && Ke && w || mt && nt && y;
    }
    return null;
  }
  const Ve = Ce((we) => {
    if (!e || we.defaultPrevented || we.nativeEvent.defaultPrevented || !("touches" in we) && we.button !== 0)
      return;
    const ke = de(we);
    !ke || (re.current = !0, fe.current = ke, ne.current = !1, se.current = !1, !(i ? i(ke, {
      nativeEvent: we.nativeEvent,
      direction: v
    }) : !0)) || Pe(we, ke) && Ye();
  });
  function Me(we, ke, Ae) {
    if (!e || !K.current)
      return;
    const We = bt(we.nativeEvent);
    if (me(we) && !ne.current) {
      const Kt = we.currentTarget;
      if (Ie(We, Kt))
        return;
    }
    if ("touches" in we || we.preventDefault(), Q.current) {
      Z.current = ke;
      const Kt = ol(we.timeStamp);
      Kt !== null && (he.current = Kt), Q.current = !1;
    }
    const it = ke.x, je = ke.y, ft = Ae.x, Ze = Ae.y;
    (Ze < 0 && je > le.current.y || Ze > 0 && je < le.current.y) && (le.current = {
      x: le.current.x,
      y: je
    }), (ft < 0 && it > le.current.x || ft > 0 && it < le.current.x) && (le.current = {
      x: it,
      y: le.current.y
    });
    const Ke = it - Z.current.x, nt = je - Z.current.y, st = je - le.current.y, mt = it - le.current.x;
    if (!D && Math.sqrt(Ke * Ke + nt * nt) >= Gx && (O(!0), G === null && E && N)) {
      const Fn = Math.abs(Ke), yi = Math.abs(nt);
      j(Fn > yi ? "horizontal" : "vertical");
    }
    let ht;
    if (!H.current)
      G === "vertical" ? nt > 0 ? ht = "down" : nt < 0 && (ht = "up") : G === "horizontal" ? Ke > 0 ? ht = "right" : Ke < 0 && (ht = "left") : Math.abs(Ke) >= Math.abs(nt) ? ht = Ke > 0 ? "right" : "left" : ht = nt > 0 ? "down" : "up", ht && (ht === "left" && y || ht === "right" && w || ht === "up" && R || ht === "down" && S) && (H.current = ht, X.current = lc(ht, Ke, nt), k(ht), ge(ht));
    else {
      const Kt = H.current, Fn = lc(Kt, mt, st);
      Fn > ce.current ? (ee.current = !1, k(Kt)) : !(y && w) && !(R && S) && X.current - Fn >= Ux && (ee.current = !0);
    }
    const Tt = $e(Ke, nt);
    let lt = te.current.x, $t = te.current.y;
    G === "horizontal" ? E && (lt += Tt.x) : (G === "vertical" || E && (lt += Tt.x), N && ($t += Tt.y)), U.current = {
      x: lt,
      y: $t
    }, h && L({
      x: lt,
      y: $t
    }), Se({
      x: lt,
      y: $t
    }, ol(we.timeStamp));
    const to = lt - te.current.x, bn = $t - te.current.y, Ln = H.current, Mn = v ?? H.current;
    if (!Mn) {
      ue(0, {
        deltaX: to,
        deltaY: bn,
        direction: Ln
      });
      return;
    }
    const Pn = Mn === "left" || Mn === "right" ? pe.current.width : pe.current.height, nn = te.current.scale || 1;
    if (Pn <= 0 || nn <= 0) {
      ue(0, {
        deltaX: to,
        deltaY: bn,
        direction: Ln
      });
      return;
    }
    const no = lc(Mn, lt - te.current.x, $t - te.current.y);
    if (no <= 0) {
      ue(0, {
        deltaX: to,
        deltaY: bn,
        direction: Ln
      });
      return;
    }
    ue(no / (Pn * nn), {
      deltaX: to,
      deltaY: bn,
      direction: Ln
    });
  }
  const He = Ce((we) => {
    const ke = de(we);
    if (!ke)
      return;
    if (!("touches" in we)) {
      const it = Zx(we.buttons);
      it && (se.current = !0);
      const je = we.buttons === 0 && se.current;
      if (we.buttons !== 0 && !it || je) {
        qe(we);
        return;
      }
    }
    if (!P && re.current) {
      if (!me(we) && (we.defaultPrevented || we.nativeEvent.defaultPrevented)) {
        _e();
        return;
      }
      if (i ? i(ke, {
        nativeEvent: we.nativeEvent,
        direction: v
      }) : !0) {
        const je = fe.current;
        let ft = !1;
        if (me(we)) {
          const Ke = o.current;
          if (je && Ke) {
            const nt = Re(ke, we.nativeEvent), mt = Je(Ke).body, ht = mt ? Ie(nt, mt) : null;
            if (ht && (Fe(Ke, ht) || Fe(ht, Ke))) {
              const Tt = ke.x - je.x, lt = ke.y - je.y, $t = Ee(ht, Tt, lt);
              if ($t === !1)
                return;
              $t === !0 && (ft = !0);
            }
          }
        }
        Pe(we, ke, {
          ignoreScrollableTarget: ft,
          ignoreScrollableAncestors: ft
        }) && (je && ft ? (Ye(), Z.current = je, le.current = je, q.current = je, Q.current = !1) : (Ye(), ne.current = !1));
      }
    }
    const Ae = q.current, We = Ae === null ? {
      x: 0,
      y: 0
    } : {
      x: ke.x - Ae.x,
      y: ke.y - Ae.y
    };
    q.current = ke, Me(we, ke, We);
  }), ze = Ce((we) => {
    if (!e)
      return;
    const ke = U.current, Ae = te.current, We = ke.x - Ae.x, it = ke.y - Ae.y, je = {
      deltaX: We,
      deltaY: it,
      direction: T ?? H.current
    };
    if (!K.current) {
      _e(), ue(0, je);
      return;
    }
    ie(!1), O(!1), j(null), _e(), se.current = !1;
    const ft = o.current;
    ft && ("touches" in we || ac(ft, we.pointerId, "releasePointerCapture"));
    const Ze = We, Ke = it, nt = he.current, st = ol(we.timeStamp), mt = nt !== null && st !== null && st > nt ? st - nt : 0, ht = mt > 0 ? Math.max(mt, Yx) : 0, Tt = ht > 0 ? Ze / ht : 0, lt = ht > 0 ? Ke / ht : 0;
    let $t = J.current.x, to = J.current.y;
    const bn = z.current;
    if (bn && st !== null && st >= bn.time) {
      const no = st - bn.time;
      if (no <= jx) {
        const Kt = Math.max(no, zp), Fn = ke.x - bn.x, yi = ke.y - bn.y, vn = Fn / Kt, $n = yi / Kt;
        vn !== 0 && ($t = vn), $n !== 0 && (to = $n);
      } else
        $t = 0, to = 0;
    }
    const Ln = p?.({
      event: we.nativeEvent,
      direction: T ?? H.current,
      deltaX: Ze,
      deltaY: Ke,
      velocityX: Tt,
      velocityY: lt,
      releaseVelocityX: $t,
      releaseVelocityY: to
    }), Mn = typeof Ln == "boolean";
    if (ee.current && !Mn) {
      U.current = {
        x: Ae.x,
        y: Ae.y
      }, L({
        x: Ae.x,
        y: Ae.y
      }), k(void 0), ue(0, je);
      return;
    }
    let Pn = !1, nn;
    if (Mn)
      Pn = Ln, nn = T ?? H.current ?? v;
    else
      for (const no of n) {
        switch (no) {
          case "right":
            Ze > ce.current && (Pn = !0, nn = "right");
            break;
          case "left":
            Ze < -ce.current && (Pn = !0, nn = "left");
            break;
          case "down":
            Ke > ce.current && (Pn = !0, nn = "down");
            break;
          case "up":
            Ke < -ce.current && (Pn = !0, nn = "up");
            break;
        }
        if (Pn)
          break;
      }
    Pn && nn ? (k(nn), V(!0), c?.(we.nativeEvent, {
      direction: nn
    })) : (U.current = {
      x: Ae.x,
      y: Ae.y
    }, L({
      x: Ae.x,
      y: Ae.y
    }), k(void 0), ue(0, je));
  }), Oe = x.useCallback(() => {
    const we = h ? A : U.current, ke = h ? $ : te.current;
    if (!P && we.x === ke.x && we.y === ke.y && !_)
      return {
        [r.x]: "0px",
        [r.y]: "0px"
      };
    const Ae = we.x - ke.x, We = we.y - ke.y;
    return {
      transition: P ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: P ? `translateX(${we.x}px) translateY(${we.y}px) scale(${ke.scale})` : void 0,
      [r.x]: `${Ae}px`,
      [r.y]: `${We}px`
    };
  }, [_, A, $, P, r, h]), wt = x.useCallback(() => e ? {
    onPointerDown: Ve,
    onPointerMove: He,
    onPointerUp: ze,
    onPointerCancel: ze
  } : {}, [e, ze, He, Ve]), dt = x.useCallback(() => e ? {
    onTouchStart: Ve,
    onTouchMove: He,
    onTouchEnd: ze,
    onTouchCancel: ze
  } : {}, [e, ze, He, Ve]);
  return {
    swiping: P,
    swipeDirection: T,
    dragDismissed: _,
    getPointerProps: wt,
    getTouchProps: dt,
    getDragStyles: Oe,
    reset: ve
  };
}
const Qx = Zi, Jx = J2, du = 10, Bp = 0.5, Wp = 0.5, eC = 300, Up = 4, Gp = 0.2, tC = 4, cc = 80, Yp = 360, uc = 0.1, jp = 1, nC = `[${j2}]`, e0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    children: s,
    ...l
  } = e, {
    store: a
  } = hn(), {
    swipeDirection: c,
    notifyParentSwipingChange: u,
    notifyParentSwipeProgressChange: d,
    frontmostHeight: f,
    snapToSequentialPoints: p
  } = ha(), h = Z2()?.visualStateStore, b = a.useState("open"), v = a.useState("mounted"), C = a.useState("nested"), y = a.useState("nestedOpenDrawerCount"), w = a.useState("viewportElement"), R = a.useState("popupElement"), S = y > 0, E = c === "left" || c === "right" ? "horizontal" : "vertical", N = E === "vertical", I = N ? "horizontal" : "vertical", {
    snapPoints: T,
    resolvedSnapPoints: k,
    activeSnapPoint: P,
    activeSnapPointOffset: M,
    setActiveSnapPoint: D,
    popupHeight: O
  } = X2(), [_, V] = x.useState(null), A = x.useRef(void 0), L = x.useRef(null), $ = Jr(), Y = x.useRef(!1), G = x.useRef(""), j = x.useRef(!1), Z = x.useRef(!1), U = x.useRef(null), q = x.useMemo(() => {
    if (!T || T.length < 2 || c !== "down" && c !== "up" || k.length < 2)
      return null;
    const z = k.map((ge) => ge.offset).filter((ge) => Number.isFinite(ge)).sort((ge, ue) => ge - ue);
    if (z.length < 2)
      return null;
    const J = z[0], B = z[1], K = z[z.length - 1];
    let ie = B - J;
    if (!Number.isFinite(ie) || ie <= 0) {
      const ge = K - J;
      if (!Number.isFinite(ge) || ge <= 0)
        return null;
      ie = ge;
    }
    return {
      minOffset: J,
      range: ie
    };
  }, [k, T, c]), te = x.useMemo(() => !q || M === null ? null : Wt((M - q.minOffset) / q.range, 0, 1), [M, q]), H = x.useMemo(() => T && T.length > 0 && (c === "down" || c === "up") ? c === "down" ? ["down", "up"] : ["up", "down"] : [c], [T, c]), X = Ce((z) => {
    Kp(a.context.popupRef.current, a.context.backdropRef.current, z);
  }), ee = Ce(() => {
    X(!1), a.context.popupRef.current?.removeAttribute(Kn.endingStyle), V(null);
  }), le = Ce(() => {
    Y.current && (Y.current = !1, u?.(!1));
  }), Q = Ce(({
    resolvedProgress: z,
    shouldTrackProgress: J,
    notifyParent: B
  }) => {
    const K = b && !C && J, ie = K ? z : 0, ge = b && J ? z : 0;
    B && d && (d(ge), ge <= 0 && le()), h?.set({
      swipeProgress: ie,
      frontmostHeight: ie > 0 ? f : 0
    });
    const ue = a.context.backdropRef.current;
    if (ue) {
      if (!K || ie <= 0) {
        ue.style.setProperty(So.swipeProgress, "0"), ue.style.removeProperty(Zt.height);
        return;
      }
      ue.style.setProperty(So.swipeProgress, `${ie}`), f > 0 ? ue.style.setProperty(Zt.height, `${f}px`) : ue.style.removeProperty(Zt.height);
    }
  });
  function re({
    direction: z,
    deltaX: J,
    deltaY: B,
    velocityX: K,
    velocityY: ie,
    releaseVelocityX: ge,
    releaseVelocityY: ue
  }) {
    if (!z)
      return null;
    const Se = a.context.popupRef.current;
    if (!Se)
      return null;
    const ve = z === "left" || z === "right" ? Se.offsetWidth : Se.offsetHeight;
    if (!Number.isFinite(ve) || ve <= 0)
      return null;
    const de = z === "left" || z === "right" ? J : B, me = T && T.length > 0 ? M ?? 0 : 0;
    let Re = 0;
    z === "down" ? Re = me : z === "up" && (Re = -me);
    const Ie = Re + de, Pe = z === "left" || z === "up" ? -Ie : Ie, _e = Math.max(0, ve - Pe);
    if (!Number.isFinite(_e) || _e <= 0)
      return null;
    const Ye = z === "left" || z === "right" ? ge : ue, qe = z === "left" || z === "right" ? K : ie, $e = Math.abs(Ye) > 0 && Number.isFinite(Ye) ? Ye : qe, Ee = z === "left" || z === "up" ? -$e : $e;
    if (!Number.isFinite(Ee) || Ee <= Gp)
      return null;
    const Ve = Wt(Ee, Gp, tC), Me = Wt(_e / Ve, cc, Yp);
    if (!Number.isFinite(Me))
      return null;
    const He = (Me - cc) / (Yp - cc), ze = Wt(uc + He * (jp - uc), uc, jp);
    return !Number.isFinite(ze) || ze <= 0 ? null : ze;
  }
  function fe(z) {
    if (Y.current || !z)
      return;
    const J = z.direction ?? c, B = J === "left" || J === "right" ? z.deltaX : z.deltaY;
    !Number.isFinite(B) || Math.abs(B) < du || (Y.current = !0, u?.(!0));
  }
  const ne = Xx({
    enabled: v && !S,
    directions: H,
    elementRef: a.context.popupRef,
    ignoreSelectorWhenTouch: !1,
    ignoreScrollableAncestors: !0,
    movementCssVars: {
      x: Zt.swipeMovementX,
      y: Zt.swipeMovementY
    },
    onSwipeStart(z) {
      if ("touches" in z || "pointerType" in z && z.pointerType === "touch")
        return;
      const J = a.context.popupRef.current;
      if (!J)
        return;
      const K = Je(J).getSelection?.();
      if (!K || K.isCollapsed)
        return;
      const ie = pt(K.anchorNode) ? K.anchorNode : K.anchorNode?.parentElement, ge = pt(K.focusNode) ? K.focusNode : K.focusNode?.parentElement;
      !Fe(J, ie) && !Fe(J, ge) || K.removeAllRanges();
    },
    onSwipingChange(z) {
      qp(a.context.backdropRef.current, z), !z && !d && le();
    },
    swipeThreshold({
      element: z,
      direction: J
    }) {
      return Zp(z, J);
    },
    canStart(z, J) {
      const B = a.context.popupRef.current;
      if (!B)
        return !1;
      const K = B.ownerDocument, ie = Sl(K, z.x, z.y);
      if (!ie || !Fe(B, ie))
        return !1;
      const ge = J.nativeEvent;
      return !(("touches" in ge || "pointerType" in ge && ge.pointerType === "touch") && Qp(K, B) || ge.type === "touchstart" && dc(ie));
    },
    onProgress(z, J) {
      fe(J);
      const B = J?.direction ?? ne.swipeDirection, K = B === void 0 || B === c, ie = !!(T && T.length > 0), ue = ie && (c === "down" || c === "up") || !ie || c === "left" || c === "right" || K;
      let Se = z;
      if (q && O > 0) {
        if (J && Number.isFinite(J.deltaY)) {
          const ve = M ?? q.minOffset, de = Wt(ve + J.deltaY, 0, O);
          Se = Wt((de - q.minOffset) / q.range, 0, 1);
        } else if (te !== null)
          Se = te;
        else if (B === "down" || B === "up") {
          const ve = z * O, de = M ?? q.minOffset, me = B === "down" ? de + ve : de - ve;
          Se = Wt((me - q.minOffset) / q.range, 0, 1);
        }
      }
      Q({
        resolvedProgress: Se,
        shouldTrackProgress: ue,
        notifyParent: !0
      });
    },
    onRelease({
      event: z,
      deltaX: J,
      deltaY: B,
      direction: K,
      velocityX: ie,
      velocityY: ge,
      releaseVelocityX: ue,
      releaseVelocityY: Se
    }) {
      const ve = {
        deltaX: J,
        deltaY: B,
        velocityX: ie,
        velocityY: ge,
        releaseVelocityX: ue,
        releaseVelocityY: Se
      };
      function de(dt) {
        const we = a.context.popupRef.current;
        we && (le(), X(!0), we.style.removeProperty("transition"), we.setAttribute(Kn.endingStyle, ""), an.flushSync(() => {
          V(re({
            direction: dt,
            ...ve
          }));
        }));
      }
      if (!T || T.length === 0) {
        if (!K) {
          ee();
          return;
        }
        const dt = a.context.popupRef.current;
        if (!dt) {
          ee();
          return;
        }
        const we = Zp(dt, K), ke = K === "left" || K === "right" ? J : B;
        if (!Number.isFinite(ke)) {
          ee();
          return;
        }
        const Ae = K === "left" || K === "up" ? -ke : ke;
        if (Ae <= 0)
          return ee(), !1;
        const We = K === "left" || K === "right" ? ie : ge;
        if ((K === "left" || K === "up" ? -We : We) >= Bp && Ae > 0)
          return de(K), !0;
        const je = Ae > we;
        return je ? de(K) : ee(), je;
      }
      if (c !== "down" && c !== "up") {
        ee();
        return;
      }
      if (!O || k.length === 0) {
        ee();
        return;
      }
      const me = c === "down" ? B : -B;
      if (!Number.isFinite(me)) {
        ee();
        return;
      }
      const Re = Math.sign(me), Ie = c === "down" ? Se : -Se, Pe = c === "down" ? ge : -ge;
      let _e = Number.isFinite(Ie) ? Ie : Pe;
      if (Re !== 0 && Math.abs(me) >= du && Number.isFinite(_e)) {
        const dt = Math.sign(_e);
        dt !== 0 && dt !== Re && (_e = Pe);
      }
      const Ye = M ?? 0, qe = Wt(Ye + me, 0, O), $e = Number.isFinite(_e) && Math.abs(_e) >= Wp ? Wt(_e, -Up, Up) * eC : 0, Ee = p ? qe : Wt(qe + $e, 0, O), Ve = De(Ws, z), Me = () => (A.current = P, D?.(null, Ve), de(c), !0);
      if (p) {
        const dt = [...k].sort((nt, st) => nt.offset - st.offset);
        if (dt.length === 0)
          return ee(), !1;
        let we = 0, ke = Math.abs(Ye - dt[0].offset);
        for (let nt = 1; nt < dt.length; nt += 1) {
          const st = Math.abs(Ye - dt[nt].offset);
          st < ke && (ke = st, we = nt);
        }
        let Ae = dt[0];
        ke = Math.abs(Ee - Ae.offset);
        for (const nt of dt) {
          const st = Math.abs(Ee - nt.offset);
          st < ke && (ke = st, Ae = nt);
        }
        const We = Math.sign(_e), it = Re !== 0 && We !== 0 && We === Re && Math.abs(_e) >= Wp;
        let je = Ee;
        if (it) {
          const nt = Wt(we + Re, 0, dt.length - 1);
          if (nt !== we) {
            const st = dt[nt];
            (Re > 0 ? Ee < st.offset : Ee > st.offset) && (Ae = st, je = st.offset);
          } else if (Re > 0)
            return Me();
        }
        const Ze = Math.abs(je - O), Ke = Math.abs(je - Ae.offset);
        return Ze < Ke ? Me() : (D?.(Ae.value, Ve), ee(), !1);
      }
      if (_e >= Bp && me > 0)
        return Me();
      let He = k[0], ze = Math.abs(Ee - He.offset);
      for (const dt of k) {
        const we = Math.abs(Ee - dt.offset);
        we < ze && (ze = we, He = dt);
      }
      return Math.abs(Ee - O) < ze ? Me() : (D?.(He.value, Ve), ee(), !1);
    },
    onDismiss(z) {
      h?.set({
        swipeProgress: 0,
        frontmostHeight: 0
      });
      const J = a.context.backdropRef.current;
      J && (J.style.setProperty(So.swipeProgress, "0"), J.style.removeProperty(Zt.height));
      const B = De(Ws, z);
      if (a.setOpen(!1, B), B.isCanceled) {
        const K = A.current;
        K !== void 0 && D?.(K, De(Ws, z)), A.current = void 0, L.current?.(), ee();
        return;
      }
      if (a.select("open")) {
        const K = z;
        $.request(() => {
          if (a.select("open")) {
            const ie = A.current;
            ie !== void 0 && D?.(ie, De(Ws, K)), A.current = void 0, ee(), L.current?.();
          } else
            A.current = void 0;
        });
        return;
      }
      A.current = void 0, X(!0);
    }
  }), se = ne.getPointerProps(), pe = ne.getTouchProps(), xe = ne.reset;
  L.current = xe, x.useEffect(() => {
    const z = w ?? R;
    if (!z)
      return;
    const J = z, B = Je(J), K = Ct(B);
    function ie(ge) {
      if (Z.current)
        return;
      const ue = U.current, Se = ge.touches[0];
      if (!Se || !ue)
        return;
      const ve = N ? Se.clientY - ue.lastY : Se.clientX - ue.lastX;
      if (t0(ge, K)) {
        ue.allowSwipe = !1, rr(ue, Se);
        return;
      }
      if (ge.touches.length === 2) {
        rr(ue, Se);
        return;
      }
      if (Qp(B, J) || !b || !v || S) {
        rr(ue, Se);
        return;
      }
      if (sC(ue, Se, N)) {
        rr(ue, Se);
        return;
      }
      const me = ue.scrollTarget;
      if (!me || me === B.documentElement || me === B.body) {
        ge.cancelable && ge.preventDefault(), rr(ue, Se);
        return;
      }
      if (!lC(me, E)) {
        ge.cancelable && ge.preventDefault(), rr(ue, Se);
        return;
      }
      const Ie = ve;
      if (Ie !== 0) {
        const Pe = cC(me, E, c, Ie);
        ue.allowSwipe ? ge.cancelable && ge.preventDefault() : ge.cancelable && Pe ? (ue.allowSwipe = !0, ge.preventDefault()) : ue.allowSwipe = !1;
      }
      rr(ue, Se);
    }
    return at(B, "touchmove", ie, {
      passive: !1,
      capture: !0
    });
  }, [v, S, b, R, N, E, c, w]), x.useEffect(() => {
    if (!q || ne.swiping)
      return;
    Q({
      resolvedProgress: !b || C ? 0 : te ?? 0,
      shouldTrackProgress: !0,
      notifyParent: !1
    });
  }, [Q, f, C, d, b, te, q, ne.swiping, a, h]), x.useEffect(() => {
    if (d)
      return b || d(0), () => {
        d(0);
      };
  }, [d, b]), x.useEffect(() => {
    b && (xe(), ee());
  }, [ee, b, xe]), x.useEffect(() => () => {
    h?.set({
      swipeProgress: 0,
      frontmostHeight: 0
    }), qp(a.context.backdropRef.current, !1), le();
  }, [le, a, h]);
  const ce = x.useMemo(() => ({
    swiping: ne.swiping,
    getDragStyles: ne.getDragStyles,
    swipeStrength: _ ?? null,
    setSwipeDismissed(z) {
      Kp(a.context.popupRef.current, a.context.backdropRef.current, z);
    }
  }), [a, ne.getDragStyles, ne.swiping, _]);
  function he() {
    Z.current = !1, U.current = null, G.current = "", j.current = !1;
  }
  return /* @__PURE__ */ g(gi, {
    ref: n,
    className: o,
    render: r,
    ...en(l, {
      onPointerDown(z) {
        if (G.current = z.pointerType, j.current = z.pointerType === "pen", !b || !v || S)
          return;
        const J = Je(z.currentTarget), B = Sl(J, z.clientX, z.clientY);
        dc(B) || oC(B) || z.pointerType !== "touch" && se.onPointerDown?.(z);
      },
      onPointerMove(z) {
        z.pointerType !== "touch" && se.onPointerMove?.(z);
      },
      onPointerUp(z) {
        G.current === z.pointerType && (G.current = ""), z.pointerType !== "touch" && se.onPointerUp?.(z);
      },
      onPointerCancel(z) {
        G.current === z.pointerType && (G.current = ""), z.pointerType !== "touch" && se.onPointerCancel?.(z);
      },
      onTouchStart(z) {
        if (G.current === "pen" && j.current) {
          j.current = !1, Z.current = !1, U.current = null;
          return;
        }
        if (!b || !v || S) {
          Z.current = !1, U.current = null;
          return;
        }
        const B = z.touches[0];
        if (!B)
          return;
        if (Jp(z)) {
          Z.current = !1, U.current = null;
          return;
        }
        const K = Je(z.currentTarget), ie = Sl(K, B.clientX, B.clientY);
        if (Z.current = dc(ie), Z.current) {
          U.current = null;
          return;
        }
        const ge = w ?? R, ue = bt(z.nativeEvent), Se = pt(ue) ? ue : null;
        if (ge && Se && !Fe(ge, Se)) {
          Z.current = !0, U.current = null;
          return;
        }
        let ve = null, de = !1;
        ge && Se && (ve = Ar(Se, ge, E), de = Ar(Se, ge, I) != null);
        let me = null;
        ve && (me = aC(ve, E, c) ? null : !1), U.current = {
          startX: B.clientX,
          startY: B.clientY,
          lastX: B.clientX,
          lastY: B.clientY,
          scrollTarget: ve,
          hasCrossAxisScrollableContent: de,
          allowSwipe: me,
          preserveNativeCrossAxisScroll: !1
        }, pe.onTouchStart?.(z);
      },
      onTouchMove(z) {
        if (Z.current || Jp(z))
          return;
        const J = U.current;
        J?.preserveNativeCrossAxisScroll || J?.allowSwipe === !1 || J?.scrollTarget != null && !J.allowSwipe || pe.onTouchMove?.(z);
      },
      onTouchEnd(z) {
        he(), pe.onTouchEnd?.(z);
      },
      onTouchCancel(z) {
        he(), pe.onTouchCancel?.(z);
      },
      // Drawer popups use drawer-specific nested state attributes.
      // Suppress DialogViewport's generic nested dialog attribute.
      "data-nested-dialog-open": void 0
    }),
    children: /* @__PURE__ */ g(nf.Provider, {
      value: ce,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (e0.displayName = "DrawerViewport");
function Kp(t, e, n) {
  if (n) {
    t?.setAttribute(Wn.swipeDismiss, ""), e?.setAttribute(Wn.swipeDismiss, "");
    return;
  }
  t?.removeAttribute(Wn.swipeDismiss), e?.removeAttribute(Wn.swipeDismiss);
}
function qp(t, e) {
  if (t) {
    if (e) {
      t.setAttribute(Wn.swiping, "");
      return;
    }
    t.removeAttribute(Wn.swiping);
  }
}
function dc(t) {
  return !!t?.closest(xh);
}
function oC(t) {
  return !!t?.closest(nC);
}
function Zp(t, e) {
  const n = e === "left" || e === "right" ? t.offsetWidth : t.offsetHeight;
  return Math.max(n * 0.5, du);
}
function Xp(t, e) {
  return t instanceof e.HTMLInputElement && t.type === "range";
}
function rC(t) {
  return pt(t) ? t.tagName === "INPUT" || t.tagName === "TEXTAREA" : !1;
}
function iC(t, e) {
  const n = pt(t.anchorNode) ? t.anchorNode : t.anchorNode?.parentElement, o = pt(t.focusNode) ? t.focusNode : t.focusNode?.parentElement;
  return t.containsNode(e, !0) || Fe(e, n) || Fe(e, o);
}
function Qp(t, e) {
  const n = Ut(t);
  if (!!(n && Fe(e, n)) && rC(n)) {
    const {
      selectionStart: i,
      selectionEnd: s
    } = n;
    if (i != null && s != null && i < s)
      return !0;
  }
  const r = t.getSelection?.();
  return !r || r.isCollapsed ? !1 : iC(r, e);
}
function t0(t, e) {
  const n = t.composedPath();
  return n ? n.some((o) => Xp(o, e)) : Xp(bt(t), e);
}
function Jp(t) {
  return t0(t.nativeEvent, Ct(t.currentTarget));
}
function rr(t, e) {
  t.lastX = e.clientX, t.lastY = e.clientY;
}
function sC(t, e, n) {
  if (t.preserveNativeCrossAxisScroll)
    return !0;
  if (t.allowSwipe === !0 || !t.hasCrossAxisScrollableContent)
    return !1;
  const o = n ? e.clientY - t.startY : e.clientX - t.startX, r = n ? e.clientX - t.startX : e.clientY - t.startY, i = Math.abs(o), s = Math.abs(r);
  return s < 6 || s <= i + 2 ? !1 : (t.preserveNativeCrossAxisScroll = !0, !0);
}
function lC(t, e) {
  return e === "vertical" ? t.scrollHeight > t.clientHeight : t.scrollWidth > t.clientWidth;
}
function n0(t, e) {
  if (e === "vertical") {
    const o = Math.max(0, t.scrollHeight - t.clientHeight);
    return {
      offset: t.scrollTop,
      max: o
    };
  }
  const n = Math.max(0, t.scrollWidth - t.clientWidth);
  return {
    offset: t.scrollLeft,
    max: n
  };
}
function aC(t, e, n) {
  const {
    offset: o,
    max: r
  } = n0(t, e), i = o0(n, e);
  return i === null ? !1 : i ? o <= 0 : o >= r;
}
function cC(t, e, n, o) {
  const {
    offset: r,
    max: i
  } = n0(t, e), s = o0(n, e);
  return s === null || !(s ? o > 0 : o < 0) ? !1 : s ? r <= 0 : r >= i;
}
function o0(t, e) {
  return e === "vertical" ? t === "down" ? !0 : t === "up" ? !1 : null : t === "right" ? !0 : t === "left" ? !1 : null;
}
const r0 = go({
  responsive: !0,
  side: "right",
  isBottomSheet: !1
}), uC = ae(["fixed", "inset-0", "z-50", "bg-surface-scrim", "transition-opacity", "duration-200", "data-ending-style:opacity-0", "data-starting-style:opacity-0"]), dC = ae(["fixed", "inset-0", "z-50", "flex", "pointer-events-none"], {
  variants: {
    side: {
      left: "justify-start",
      right: "justify-end"
    },
    isBottomSheet: {
      false: null,
      true: "items-end justify-center"
    },
    responsive: {
      false: null,
      true: "max-[904px]:items-end max-[904px]:justify-center"
    }
  }
}), fC = ae(["pointer-events-auto", "flex", "h-dvh", "max-h-dvh", "min-w-0", "flex-col", "overflow-hidden", "border", "border-outline-subtle", "bg-surface", "text-text-default", "shadow-elevation-4", "outline-none", "transition-transform", "duration-200", "ease-out"], {
  variants: {
    size: {
      default: ["[--drawer-size:640px]", "w-[min(100vw,var(--drawer-size))]"],
      small: ["[--drawer-size:560px]", "w-[min(100vw,var(--drawer-size))]"]
    },
    side: {
      left: ["data-ending-style:-translate-x-full", "data-starting-style:-translate-x-full"],
      right: ["data-ending-style:translate-x-full", "data-starting-style:translate-x-full"]
    },
    contentVariant: {
      default: null,
      navigation: "border-0"
    },
    isBottomSheet: {
      false: null,
      true: ["h-auto", "min-h-[230px]", "max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "w-full", "rounded-t-(--radius-sm)", "data-ending-style:translate-x-0", "data-ending-style:translate-y-full", "data-starting-style:translate-x-0", "data-starting-style:translate-y-full"]
    },
    responsive: {
      false: null,
      true: ["max-[904px]:h-auto", "max-[904px]:min-h-[230px]", "max-[904px]:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-[904px]:w-full", "max-[904px]:rounded-t-(--radius-sm)", "max-[904px]:data-ending-style:translate-x-0", "max-[904px]:data-ending-style:translate-y-full", "max-[904px]:data-starting-style:translate-x-0", "max-[904px]:data-starting-style:translate-y-full"]
    }
  },
  defaultVariants: {
    size: "default"
  }
}), pC = ae(["flex", "min-h-0", "flex-1", "flex-col", "overflow-hidden", "bg-surface"], {
  variants: {
    variant: {
      default: ["gap-(--spacing-16)", "pt-(--spacing-10)"],
      navigation: ["gap-0", "pt-0"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), mC = ae(["flex", "shrink-0", "items-start", "justify-between", "gap-(--spacing-2)", "bg-surface", "mx-(--spacing-10)", "p-(--spacing-8)"]), gC = ae(["flex", "min-w-0", "flex-1", "items-start", "gap-(--spacing-8)"]), hC = ae(["flex", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-4)"]), bC = ae(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), vC = ae(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), yC = ae(["min-h-0", "flex-1", "overflow-y-auto", "px-(--spacing-20)", "max-[904px]:pb-[env(safe-area-inset-bottom)]"]), xC = ae(["flex", "flex-col"], {
  variants: {
    gap: {
      none: "gap-0",
      md: "gap-(--spacing-20)"
    }
  },
  defaultVariants: {
    gap: "md"
  }
}), CC = ae(["flex", "min-h-(--spacing-80)", "shrink-0", "items-center", "justify-end", "gap-(--spacing-10)", "border-t", "border-outline-subtle", "bg-surface", "px-(--spacing-20)", "py-(--spacing-16)", "max-[904px]:pb-[calc(var(--spacing-16)_+_env(safe-area-inset-bottom))]"]);
function wC(t) {
  const e = W.c(19);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r, i, s;
  e[3] !== o ? ({
    side: i,
    responsive: s,
    ...r
  } = o, e[3] = o, e[4] = r, e[5] = i, e[6] = s) : (r = e[4], i = e[5], s = e[6]);
  const l = i === void 0 ? "right" : i, a = s === void 0 ? !0 : s;
  let c;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = {
    defaultMatches: !1
  }, e[7] = c) : c = e[7];
  const u = ws("(max-width: 904px)", c), d = a && u;
  let f;
  e[8] !== d || e[9] !== a || e[10] !== l ? (f = {
    responsive: a,
    side: l,
    isBottomSheet: d
  }, e[8] = d, e[9] = a, e[10] = l, e[11] = f) : f = e[11];
  const p = d ? "down" : l === "left" ? "left" : "right";
  let m;
  e[12] !== n || e[13] !== r || e[14] !== p ? (m = /* @__PURE__ */ g(Hx, { modal: !0, swipeDirection: p, ...r, children: n }), e[12] = n, e[13] = r, e[14] = p, e[15] = m) : m = e[15];
  let h;
  return e[16] !== f || e[17] !== m ? (h = /* @__PURE__ */ g(r0, { value: f, children: m }), e[16] = f, e[17] = m, e[18] = h) : h = e[18], h;
}
function wO(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Jx, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function SC(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g(Y2, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function RC(t) {
  const e = W.c(33);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    size: r,
    contentVariant: i,
    initialFocus: s,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "default" : i, a = s === void 0 ? !0 : s, c = Qt(), {
    responsive: u,
    side: d,
    isBottomSheet: f
  } = mn(r0);
  let p;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g(G2, { className: oe(uC()) }), e[6] = p) : p = e[6];
  let m;
  e[7] !== f || e[8] !== u || e[9] !== d ? (m = oe(dC({
    responsive: u,
    side: d,
    isBottomSheet: f
  })), e[7] = f, e[8] = u, e[9] = d, e[10] = m) : m = e[10];
  let h;
  e[11] !== l || e[12] !== f || e[13] !== u || e[14] !== d || e[15] !== r ? (h = oe(fC({
    responsive: u,
    size: r,
    side: d,
    isBottomSheet: f,
    contentVariant: l
  })), e[11] = l, e[12] = f, e[13] = u, e[14] = d, e[15] = r, e[16] = h) : h = e[16];
  let b;
  e[17] !== l ? (b = oe(pC({
    variant: l
  })), e[17] = l, e[18] = b) : b = e[18];
  let v;
  e[19] !== n || e[20] !== b ? (v = /* @__PURE__ */ g(K2, { className: b, children: n }), e[19] = n, e[20] = b, e[21] = v) : v = e[21];
  let C;
  e[22] !== a || e[23] !== o || e[24] !== h || e[25] !== v ? (C = /* @__PURE__ */ g(Q2, { "aria-modal": "true", initialFocus: a, className: h, ...o, children: v }), e[22] = a, e[23] = o, e[24] = h, e[25] = v, e[26] = C) : C = e[26];
  let y;
  e[27] !== m || e[28] !== C ? (y = /* @__PURE__ */ g(e0, { className: m, children: C }), e[27] = m, e[28] = C, e[29] = y) : y = e[29];
  let w;
  return e[30] !== c || e[31] !== y ? (w = /* @__PURE__ */ F(Tx, { container: c, children: [
    p,
    y
  ] }), e[30] = c, e[31] = y, e[32] = w) : w = e[32], w;
}
function SO(t) {
  const e = W.c(36);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    title: a,
    subtitle: s,
    leadingIcon: r,
    accessory: n,
    actions: o,
    closeLabel: l,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "Close drawer" : l;
  let u;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = oe(mC()), e[8] = u) : u = e[8];
  let d;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = oe(gC()), e[9] = d) : d = e[9];
  let f;
  e[10] !== r ? (f = r && /* @__PURE__ */ g("span", { className: "mt-(--spacing-4) inline-flex shrink-0 text-icon-main", children: /* @__PURE__ */ g(Ge, { name: r, size: "sm", tone: "inherit" }) }), e[10] = r, e[11] = f) : f = e[11];
  let p;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = oe(hC()), e[12] = p) : p = e[12];
  let m;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = oe(bC()), e[13] = m) : m = e[13];
  let h;
  e[14] !== a ? (h = /* @__PURE__ */ g(Qx, { className: m, children: a }), e[14] = a, e[15] = h) : h = e[15];
  let b;
  e[16] !== n || e[17] !== h ? (b = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-8)", children: [
    h,
    n
  ] }), e[16] = n, e[17] = h, e[18] = b) : b = e[18];
  let v;
  e[19] !== s ? (v = s && /* @__PURE__ */ g(Nx, { className: oe(vC()), children: s }), e[19] = s, e[20] = v) : v = e[20];
  let C;
  e[21] !== b || e[22] !== v ? (C = /* @__PURE__ */ F("div", { className: p, children: [
    b,
    v
  ] }), e[21] = b, e[22] = v, e[23] = C) : C = e[23];
  let y;
  e[24] !== C || e[25] !== f ? (y = /* @__PURE__ */ F("div", { className: d, children: [
    f,
    C
  ] }), e[24] = C, e[25] = f, e[26] = y) : y = e[26];
  let w;
  e[27] !== c ? (w = /* @__PURE__ */ g(Y2, { render: /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": c, variant: "ghost", size: "md" }) }), e[27] = c, e[28] = w) : w = e[28];
  let R;
  e[29] !== o || e[30] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-8)", children: [
    o,
    w
  ] }), e[29] = o, e[30] = w, e[31] = R) : R = e[31];
  let S;
  return e[32] !== i || e[33] !== y || e[34] !== R ? (S = /* @__PURE__ */ F("div", { className: u, ...i, children: [
    y,
    R
  ] }), e[32] = i, e[33] = y, e[34] = R, e[35] = S) : S = e[35], S;
}
function RO(t) {
  const e = W.c(13);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    gap: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = oe(yC()), e[4] = i) : i = e[4];
  let s;
  e[5] !== o ? (s = oe(xC({
    gap: o
  })), e[5] = o, e[6] = s) : s = e[6];
  let l;
  e[7] !== n || e[8] !== s ? (l = /* @__PURE__ */ g("div", { className: s, children: n }), e[7] = n, e[8] = s, e[9] = l) : l = e[9];
  let a;
  return e[10] !== r || e[11] !== l ? (a = /* @__PURE__ */ g("div", { className: i, ...r, children: l }), e[10] = r, e[11] = l, e[12] = a) : a = e[12], a;
}
function EO(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = oe(CC()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
const Ns = go({
  collapsed: !1
});
function i0() {
  return mn(Ns);
}
const EC = ae(["flex", "h-full", "min-h-0", "flex-col", "bg-surface", "border-r", "border-outline-subtle", "text-menu-text-default", "transition-[width]", "duration-200", "ease-in-out", "overflow-hidden"], {
  variants: {
    collapsed: {
      false: null,
      true: null
    },
    inAppShell: {
      false: null,
      true: ["relative", "z-10", "w-(--app-shell-sidebar-width)", "data-[hover-expanded]:w-(--app-shell-sidebar-expanded-width)"]
    }
  },
  compoundVariants: [{
    collapsed: !1,
    inAppShell: !1,
    className: "w-[260px]"
  }, {
    collapsed: !0,
    inAppShell: !1,
    className: "w-[72px]"
  }]
}), NC = ae("sticky bottom-0 z-10 mt-auto flex shrink-0 bg-surface", {
  variants: {
    collapsed: {
      false: "w-full",
      true: "w-(--spacing-40) justify-center"
    }
  }
}), rf = ae(["group/sidebar-item", "relative", "inline-flex", "items-center", "border-0", "rounded-[var(--radius-sm)]", "text-left", "no-underline", "outline-none", "select-none", "cursor-pointer", "transition-colors", "duration-200", "ease-in-out", "font-[family-name:var(--font-family-label)]", "font-[number:var(--font-weight-medium)]", "text-[length:var(--font-size-label-large)]", "leading-[var(--font-line-height-24)]", "tracking-[var(--font-letter-spacing-default)]", "text-menu-icon-default", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "disabled:cursor-not-allowed", "disabled:opacity-50", "disabled:pointer-events-none"], {
  variants: {
    collapsed: {
      false: ["h-(--spacing-40)", "w-full", "min-w-0", "justify-between", "gap-[var(--spacing-8)]", "px-(--spacing-10)", "py-[var(--spacing-12)]"],
      true: ["size-(--spacing-40)", "justify-center", "p-(--spacing-10)"]
    },
    selected: {
      false: "bg-transparent",
      true: ["bg-menu-item-selected", "text-menu-text-default", "hover:bg-menu-item-selected"]
    },
    variant: {
      item: "",
      subItem: ""
    }
  },
  compoundVariants: [{
    selected: !0,
    variant: "item",
    className: ["before:absolute", "before:left-[-16px]", "before:top-1/2", "before:h-(--spacing-24)", "before:w-[2px]", "before:-translate-y-1/2", "before:bg-primary", "before:rounded-r-[2px]", "before:content-['']"]
  }]
}), kC = ae(["overflow-hidden", "h-(--collapsible-panel-height)", "[&[data-starting-style]]:h-0", "[&[data-ending-style]]:h-0", "opacity-100", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:opacity-0", "transition-[height,opacity]", "duration-200", "ease-out", "motion-reduce:transition-none"]), MC = "flex size-(--icon-sm) shrink-0 items-center justify-center", PC = ["pointer-events-none", "absolute", "left-[-16px]", "top-1/2", "h-(--spacing-24)", "w-[2px]", "-translate-y-1/2", "rounded-r-[2px]", "bg-primary"].join(" ");
function NO(t) {
  const e = W.c(64);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    collapsed: a,
    "aria-label": c,
    children: n,
    onMouseEnter: i,
    onMouseLeave: s,
    mobileHeaderLeading: r,
    mobileHeaderActions: o,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = a === void 0 ? !1 : a, d = c === void 0 ? "Main navigation" : c, f = jd(), [p, m] = tt(!1), h = ut(!1), b = ut(!1), v = f?.desktopSidebarCollapsed ?? u, C = ut(v), y = f?.isMobile ?? !1, w = !y && v && !p;
  let R, S;
  e[9] !== v ? (R = () => {
    v ? !C.current && v && h.current && (b.current = !0, m(!1)) : (m(!1), b.current = !1), C.current = v;
  }, S = [v], e[9] = v, e[10] = R, e[11] = S) : (R = e[10], S = e[11]), _t(R, S);
  let E;
  e[12] !== f || e[13] !== y ? (E = y ? () => f?.setMobileNavigationOpen(!1) : void 0, e[12] = f, e[13] = y, e[14] = E) : E = e[14];
  let N;
  e[15] !== w || e[16] !== E ? (N = {
    collapsed: w,
    closeMobileNavigation: E
  }, e[15] = w, e[16] = E, e[17] = N) : N = e[17];
  const I = w ? "" : void 0, T = p ? "" : void 0, k = !!f;
  let P;
  e[18] !== w || e[19] !== k ? (P = EC({
    collapsed: w,
    inAppShell: k
  }), e[18] = w, e[19] = k, e[20] = P) : P = e[20];
  const M = `${P}${y ? " w-full border-r-0" : ""}`;
  let D;
  e[21] !== i || e[22] !== v ? (D = (X) => {
    i?.(X), h.current = !0, v && !b.current && (!(X.relatedTarget instanceof Node) || !X.currentTarget.contains(X.relatedTarget)) && m(!0);
  }, e[21] = i, e[22] = v, e[23] = D) : D = e[23];
  let O;
  e[24] !== s || e[25] !== v ? (O = (X) => {
    s?.(X), h.current = !1;
    const ee = b.current;
    if (b.current = !1, v && (!(X.relatedTarget instanceof Node) || !X.currentTarget.contains(X.relatedTarget))) {
      if (ee) {
        m(!1);
        return;
      }
      m(!1);
    }
  }, e[24] = s, e[25] = v, e[26] = O) : O = e[26];
  let _;
  e[27] !== f || e[28] !== y ? (_ = f && !y && /* @__PURE__ */ g("div", { className: "shrink-0 px-(--spacing-16) pt-(--spacing-24)", children: /* @__PURE__ */ g(gx, {}) }), e[27] = f, e[28] = y, e[29] = _) : _ = e[29];
  let V;
  e[30] !== n ? (V = /* @__PURE__ */ g("div", { className: "min-h-0 flex-1 overflow-y-auto overscroll-contain", "data-slot": "sidebar-navigation", children: /* @__PURE__ */ g("div", { className: "flex min-h-full flex-col gap-(--spacing-8) px-(--spacing-16) py-(--spacing-16)", children: n }) }), e[30] = n, e[31] = V) : V = e[31];
  let A;
  e[32] !== d || e[33] !== l || e[34] !== M || e[35] !== D || e[36] !== O || e[37] !== _ || e[38] !== V || e[39] !== I || e[40] !== T ? (A = /* @__PURE__ */ F("nav", { ...l, "aria-label": d, "data-collapsed": I, "data-hover-expanded": T, className: M, "data-slot": "sidebar", onMouseEnter: D, onMouseLeave: O, children: [
    _,
    V
  ] }), e[32] = d, e[33] = l, e[34] = M, e[35] = D, e[36] = O, e[37] = _, e[38] = V, e[39] = I, e[40] = T, e[41] = A) : A = e[41];
  let L;
  e[42] !== A || e[43] !== N ? (L = /* @__PURE__ */ g(Ns, { value: N, children: A }), e[42] = A, e[43] = N, e[44] = L) : L = e[44];
  const $ = L;
  if (!y || !f)
    return $;
  let Y;
  e[45] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = {
    width: "75vw"
  }, e[45] = Y) : Y = e[45];
  let G;
  e[46] !== r ? (G = /* @__PURE__ */ g("div", { className: "min-w-0", children: r }), e[46] = r, e[47] = G) : G = e[47];
  let j;
  e[48] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (j = /* @__PURE__ */ g(SC, { render: /* @__PURE__ */ g(gt, { "aria-label": "Close navigation", icon: "x-close", variant: "outline" }) }), e[48] = j) : j = e[48];
  let Z;
  e[49] !== o ? (Z = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-12)", children: [
    o,
    j
  ] }), e[49] = o, e[50] = Z) : Z = e[50];
  let U;
  e[51] !== G || e[52] !== Z ? (U = /* @__PURE__ */ F("div", { className: "flex h-[68px] shrink-0 items-center justify-between gap-(--spacing-12) border-b border-outline-subtle bg-surface px-(--spacing-24)", children: [
    G,
    Z
  ] }), e[51] = G, e[52] = Z, e[53] = U) : U = e[53];
  let q;
  e[54] !== $ ? (q = /* @__PURE__ */ g("div", { className: "min-h-0 flex-1", children: $ }), e[54] = $, e[55] = q) : q = e[55];
  let te;
  e[56] !== d || e[57] !== U || e[58] !== q ? (te = /* @__PURE__ */ F(RC, { "aria-label": d, contentVariant: "navigation", style: Y, children: [
    U,
    q
  ] }), e[56] = d, e[57] = U, e[58] = q, e[59] = te) : te = e[59];
  let H;
  return e[60] !== f.mobileNavigationOpen || e[61] !== f.setMobileNavigationOpen || e[62] !== te ? (H = /* @__PURE__ */ g(wC, { open: f.mobileNavigationOpen, onOpenChange: f.setMobileNavigationOpen, responsive: !1, side: "left", children: te }), e[60] = f.mobileNavigationOpen, e[61] = f.setMobileNavigationOpen, e[62] = te, e[63] = H) : H = e[63], H;
}
function kO(t) {
  const e = W.c(9);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    collapsed: r
  } = mn(Ns);
  let i;
  e[3] !== r ? (i = NC({
    collapsed: r
  }), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== i ? (s = /* @__PURE__ */ g("div", { ...o, className: i, "data-slot": "sidebar-footer", children: n }), e[5] = n, e[6] = o, e[7] = i, e[8] = s) : s = e[8], s;
}
function IC(t) {
  const e = W.c(6), {
    leading: n
  } = t;
  if (!n)
    return null;
  if (n.type === "icon") {
    let i;
    return e[0] !== n.name ? (i = /* @__PURE__ */ g(Ge, { name: n.name, size: "sm", tone: "inherit", "aria-hidden": !0, "data-slot": "sidebar-item-icon" }), e[0] = n.name, e[1] = i) : i = e[1], i;
  }
  const o = n.variant ?? "external";
  let r;
  return e[2] !== n.initials || e[3] !== n.src || e[4] !== o ? (r = /* @__PURE__ */ g(Ur, { initials: n.initials, size: "xs", src: n.src, variant: o }), e[2] = n.initials, e[3] = n.src, e[4] = o, e[5] = r) : r = e[5], r;
}
function sf(t) {
  const e = W.c(21), {
    label: n,
    leading: o,
    badge: r,
    selected: i,
    variant: s,
    collapsed: l,
    trailing: a
  } = t, c = i === void 0 ? !1 : i, u = s === void 0 ? "item" : s;
  let d;
  e[0] !== o || e[1] !== c || e[2] !== u ? (d = u === "subItem" ? /* @__PURE__ */ g("span", { "aria-hidden": !0, className: MC, "data-slot": "sidebar-item-dot", children: /* @__PURE__ */ F("svg", { "aria-hidden": !0, className: "relative z-[2] size-(--icon-sm)", viewBox: "0 0 20 20", children: [
    /* @__PURE__ */ g("title", { children: "Sub-navigation item indicator" }),
    /* @__PURE__ */ g("circle", { className: c ? "fill-primary-on-container" : "fill-outline-subtle", cx: "10", cy: "10", "data-slot": "sidebar-item-dot-indicator", r: "2" })
  ] }) }) : /* @__PURE__ */ g(IC, { leading: o }), e[0] = o, e[1] = c, e[2] = u, e[3] = d) : d = e[3];
  let f;
  e[4] !== l || e[5] !== n ? (f = !l && /* @__PURE__ */ g("span", { className: "min-w-0 truncate", "data-slot": "sidebar-item-label", title: n, children: n }), e[4] = l, e[5] = n, e[6] = f) : f = e[6];
  let p;
  e[7] !== d || e[8] !== f ? (p = /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-[var(--spacing-8)]", children: [
    d,
    f
  ] }), e[7] = d, e[8] = f, e[9] = p) : p = e[9];
  let m;
  e[10] !== r || e[11] !== l ? (m = !l && r && /* @__PURE__ */ g("span", { className: "ml-auto shrink-0", "data-slot": "sidebar-item-badge", children: /* @__PURE__ */ g(lu, { count: r.count, tone: r.tone, "aria-label": r.label }) }), e[10] = r, e[11] = l, e[12] = m) : m = e[12];
  const h = !l && a;
  let b;
  e[13] !== r || e[14] !== l ? (b = l && r && /* @__PURE__ */ g("span", { className: "absolute right-(--spacing-2) top-(--spacing-2)", "data-slot": "sidebar-item-badge", children: /* @__PURE__ */ g(lu, { count: r.count, tone: r.tone, "aria-label": r.label }) }), e[13] = r, e[14] = l, e[15] = b) : b = e[15];
  let v;
  return e[16] !== p || e[17] !== m || e[18] !== h || e[19] !== b ? (v = /* @__PURE__ */ F(Ht, { children: [
    p,
    m,
    h,
    b
  ] }), e[16] = p, e[17] = m, e[18] = h, e[19] = b, e[20] = v) : v = e[20], v;
}
function Rl(t) {
  const e = W.c(24), {
    collapsed: n,
    closeMobileNavigation: o
  } = mn(Ns);
  let r, i, s, l, a, c, u;
  if (e[0] !== o || e[1] !== n || e[2] !== t) {
    const {
      itemId: h,
      label: b,
      leading: v,
      selected: C,
      badge: y,
      tooltip: w,
      variant: R,
      collapsed: S,
      ...E
    } = t;
    i = b, u = w;
    const N = C === void 0 ? !1 : C, I = R === void 0 ? "item" : R;
    r = S === void 0 ? n : S;
    const T = rf({
      collapsed: r,
      selected: N,
      variant: I
    });
    let k;
    e[10] !== y || e[11] !== r || e[12] !== i || e[13] !== v || e[14] !== N || e[15] !== I ? (k = /* @__PURE__ */ g(sf, { label: i, leading: v, badge: y, selected: N, variant: I, collapsed: r }), e[10] = y, e[11] = r, e[12] = i, e[13] = v, e[14] = N, e[15] = I, e[16] = k) : k = e[16];
    const P = k, {
      render: M,
      href: D,
      target: O,
      rel: _,
      onClick: V,
      ...A
    } = E;
    if (D === void 0 && M === void 0)
      throw new Error("SidebarItem requires either an href or render prop.");
    const L = O === "_blank" && !_ ? "noopener noreferrer" : _;
    c = Xd, s = "a", l = M, a = en(A, {
      ...D !== void 0 && {
        href: D
      },
      ...O !== void 0 && {
        target: O
      },
      ...L !== void 0 && {
        rel: L
      },
      onClick: ($) => {
        V?.($), o?.();
      },
      "data-sidebar-item": h,
      "aria-label": i,
      "aria-current": N ? "page" : void 0,
      className: T,
      children: P
    }), e[0] = o, e[1] = n, e[2] = t, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u;
  } else
    r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9];
  let d;
  e[17] !== s || e[18] !== l || e[19] !== a ? (d = {
    defaultTagName: s,
    render: l,
    props: a
  }, e[17] = s, e[18] = l, e[19] = a, e[20] = d) : d = e[20];
  const f = c(d);
  if (!r || u === !1)
    return f;
  const p = u ?? i;
  let m;
  return e[21] !== f || e[22] !== p ? (m = /* @__PURE__ */ g(qo, { label: p, side: "right", align: "center", children: f }), e[21] = f, e[22] = p, e[23] = m) : m = e[23], m;
}
function TC(t) {
  const e = W.c(34);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    label: i,
    leading: s,
    selected: c,
    badge: n,
    tooltip: u,
    collapsed: o,
    hasSelectedChild: r,
    open: l,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = c === void 0 ? !1 : c, f = d ? "page" : void 0;
  let p;
  e[10] !== o || e[11] !== d ? (p = rf({
    collapsed: o,
    selected: d,
    variant: "item"
  }), e[10] = o, e[11] = d, e[12] = p) : p = e[12];
  let m;
  e[13] !== r ? (m = r && /* @__PURE__ */ g("span", { "aria-hidden": !0, className: PC, "data-slot": "sidebar-group-current-indicator" }), e[13] = r, e[14] = m) : m = e[14];
  const h = l ? "chevron-up" : "chevron-down";
  let b;
  e[15] !== h ? (b = /* @__PURE__ */ g(Ge, { name: h, size: "xs", tone: "secondary", "aria-hidden": !0 }), e[15] = h, e[16] = b) : b = e[16];
  let v;
  e[17] !== n || e[18] !== o || e[19] !== i || e[20] !== s || e[21] !== d || e[22] !== b ? (v = /* @__PURE__ */ g(sf, { label: i, leading: s, badge: n, selected: d, collapsed: o, trailing: b }), e[17] = n, e[18] = o, e[19] = i, e[20] = s, e[21] = d, e[22] = b, e[23] = v) : v = e[23];
  let C;
  e[24] !== i || e[25] !== a || e[26] !== f || e[27] !== p || e[28] !== m || e[29] !== v ? (C = /* @__PURE__ */ F("button", { ...a, "aria-label": i, "aria-current": f, className: p, type: "button", children: [
    m,
    v
  ] }), e[24] = i, e[25] = a, e[26] = f, e[27] = p, e[28] = m, e[29] = v, e[30] = C) : C = e[30];
  const y = C;
  if (!o || u === !1)
    return y;
  const w = u ?? i;
  let R;
  return e[31] !== y || e[32] !== w ? (R = /* @__PURE__ */ g(qo, { label: w, side: "right", align: "center", children: y }), e[31] = y, e[32] = w, e[33] = R) : R = e[33], R;
}
function OC(t) {
  const e = W.c(3), {
    children: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("span", { "aria-hidden": !0, className: "pointer-events-none absolute top-[24px] bottom-[20px] left-(--spacing-10) z-[1] w-(--icon-sm)", "data-slot": "sidebar-group-connector", children: /* @__PURE__ */ F("svg", { "aria-hidden": !0, className: "size-full", preserveAspectRatio: "none", viewBox: "0 0 20 100", children: [
    /* @__PURE__ */ g("title", { children: "Sub-navigation connector" }),
    /* @__PURE__ */ g("line", { className: "stroke-outline-subtle", vectorEffect: "non-scaling-stroke", x1: "10", x2: "10", y1: "0", y2: "100" })
  ] }) }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ F("div", { className: "relative flex flex-col gap-[var(--spacing-4)] pt-[var(--spacing-4)]", "data-slot": "sidebar-group-items", children: [
    o,
    n
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}
function DC(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("div", { className: "flex flex-col gap-[var(--spacing-4)] pt-[var(--spacing-4)]", "data-slot": "sidebar-static-group-items", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function _C(t) {
  const e = W.c(13), {
    label: n,
    leading: o,
    badge: r,
    tooltip: i,
    collapsed: s
  } = t;
  let l;
  e[0] !== s ? (l = rf({
    collapsed: s,
    selected: !1,
    variant: "item"
  }), e[0] = s, e[1] = l) : l = e[1];
  const a = `${l} !cursor-default hover:bg-transparent active:bg-transparent`;
  let c;
  e[2] !== r || e[3] !== s || e[4] !== n || e[5] !== o ? (c = /* @__PURE__ */ g(sf, { label: n, leading: o, badge: r, collapsed: s }), e[2] = r, e[3] = s, e[4] = n, e[5] = o, e[6] = c) : c = e[6];
  let u;
  e[7] !== a || e[8] !== c ? (u = /* @__PURE__ */ g("div", { className: a, children: c }), e[7] = a, e[8] = c, e[9] = u) : u = e[9];
  const d = u;
  if (!s || i === !1)
    return d;
  const f = i ?? n;
  let p;
  return e[10] !== d || e[11] !== f ? (p = /* @__PURE__ */ g(qo, { label: f, side: "right", align: "center", children: d }), e[10] = d, e[11] = f, e[12] = p) : p = e[12], p;
}
function em(t) {
  const e = W.c(35), {
    itemId: n,
    label: o,
    leading: r,
    selected: i,
    hasSelectedChild: s,
    badge: l,
    tooltip: a,
    collapsed: c,
    collapsible: u,
    open: d,
    defaultOpen: f,
    onOpenChange: p,
    children: m
  } = t, h = i === void 0 ? !1 : i, b = s === void 0 ? !1 : s, v = u === void 0 ? !0 : u, C = f === void 0 ? !1 : f, {
    collapsed: y
  } = mn(Ns), w = c ?? y, [R, S] = tt(C), E = d !== void 0, N = E ? d : R;
  let I;
  e[0] !== E || e[1] !== p ? (I = function(A) {
    E || S(A), p?.(A);
  }, e[0] = E, e[1] = p, e[2] = I) : I = e[2];
  const T = I;
  let k;
  e[3] !== l || e[4] !== w || e[5] !== b || e[6] !== o || e[7] !== r || e[8] !== N || e[9] !== h || e[10] !== a ? (k = /* @__PURE__ */ g(TC, { label: o, leading: r, selected: h, hasSelectedChild: b, badge: l, tooltip: a, collapsed: w, open: N }), e[3] = l, e[4] = w, e[5] = b, e[6] = o, e[7] = r, e[8] = N, e[9] = h, e[10] = a, e[11] = k) : k = e[11];
  const P = k;
  if (!v) {
    let V;
    e[12] !== l || e[13] !== w || e[14] !== o || e[15] !== r || e[16] !== a ? (V = /* @__PURE__ */ g(_C, { label: o, leading: r, badge: l, tooltip: a, collapsed: w }), e[12] = l, e[13] = w, e[14] = o, e[15] = r, e[16] = a, e[17] = V) : V = e[17];
    let A;
    e[18] !== m ? (A = /* @__PURE__ */ g(DC, { children: m }), e[18] = m, e[19] = A) : A = e[19];
    let L;
    return e[20] !== n || e[21] !== V || e[22] !== A ? (L = /* @__PURE__ */ F("div", { "data-sidebar-group": n, children: [
      V,
      A
    ] }), e[20] = n, e[21] = V, e[22] = A, e[23] = L) : L = e[23], L;
  }
  let M;
  e[24] !== P ? (M = /* @__PURE__ */ g(Bl, { render: P }), e[24] = P, e[25] = M) : M = e[25];
  let D;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = kC(), e[26] = D) : D = e[26];
  let O;
  e[27] !== m ? (O = /* @__PURE__ */ g(Zd, { className: D, "data-slot": "sidebar-group-panel", children: /* @__PURE__ */ g(OC, { children: m }) }), e[27] = m, e[28] = O) : O = e[28];
  let _;
  return e[29] !== T || e[30] !== n || e[31] !== N || e[32] !== M || e[33] !== O ? (_ = /* @__PURE__ */ F(qd, { "data-sidebar-group": n, open: N, onOpenChange: T, children: [
    M,
    O
  ] }), e[29] = T, e[30] = n, e[31] = N, e[32] = M, e[33] = O, e[34] = _) : _ = e[34], _;
}
const VC = ["flex", "h-(--spacing-64)", "w-full", "items-center", "bg-surface", "border-b", "border-outline-subtle", "max-[599px]:h-[68px]"], AC = ["flex", "h-full", "min-w-0", "shrink-0", "transition-[width]", "duration-200", "ease-in-out", "items-center", "border-r", "border-outline-subtle", "px-(--spacing-16)", "max-[599px]:border-r-0", "max-[599px]:px-(--spacing-24)"], LC = ["hidden", "h-full", "min-w-0", "flex-1", "items-center", "overflow-hidden", "px-(--spacing-24)", "min-[600px]:flex"], FC = ["ml-auto", "flex", "h-full", "shrink-0", "items-center", "gap-(--spacing-12)", "pr-(--spacing-24)", "max-[599px]:gap-(--spacing-20)"];
function MO(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = VC.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("header", { ...o, className: r, "data-slot": "top-bar", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function PO(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = AC.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { ...o, className: r, "data-slot": "top-bar-leading", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function IO(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = LC.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { ...o, className: r, "data-slot": "top-bar-content", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function TO(t) {
  const e = W.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = FC.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ g("div", { ...o, className: r, "data-slot": "top-bar-actions", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
const $C = ae(["flex", "h-full", "min-h-0", "flex-col", "bg-surface"]), HC = ae(["flex", "w-full", "min-w-0", "flex-col", "gap-(--spacing-4)", "rounded-(--radius-sm)", "px-(--spacing-8)", "py-(--spacing-8)", "text-left", "cursor-pointer", "hover:bg-surface-hover", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring"], {
  variants: {
    active: {
      true: "bg-surface-container",
      false: null
    }
  },
  defaultVariants: {
    active: !1
  }
});
function s0(t) {
  const e = W.c(17), {
    conversations: n,
    activeConversationId: o,
    onSelectConversation: r
  } = t;
  let i, s, l, a, c;
  if (e[0] !== o || e[1] !== n || e[2] !== r) {
    const f = n.reduce(zC, {});
    l = "assistant-chat-sidebar-content", a = "flex h-full min-h-0 flex-1 flex-col", e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g("div", { className: "px-(--spacing-12)", children: /* @__PURE__ */ g(uo, { size: "lg", children: "Chat History" }) }), e[8] = c) : c = e[8], i = "min-h-0 flex-1 overflow-y-auto px-(--spacing-12) pt-(--spacing-16)", s = n.length === 0 ? /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center justify-center gap-(--spacing-12) px-(--spacing-12) text-center", children: [
      /* @__PURE__ */ g(Ge, { name: "message", size: "md", tone: "secondary", "aria-hidden": !0 }),
      /* @__PURE__ */ g(ln, { tone: "subtle", children: "Your chat history will appear here" })
    ] }) : Object.entries(f).map((p) => {
      const [m, h] = p;
      return /* @__PURE__ */ F("section", { className: "mb-(--spacing-16)", children: [
        /* @__PURE__ */ g("div", { className: "px-(--spacing-8)", children: /* @__PURE__ */ g(uo, { size: "sm", tone: "subtle", children: m }) }),
        /* @__PURE__ */ g("div", { className: "mt-(--spacing-10) flex flex-col gap-(--spacing-4) px-(--spacing-8)", children: h.map((b) => /* @__PURE__ */ F("button", { type: "button", "aria-current": b.id === o ? "page" : void 0, className: HC({
          active: b.id === o
        }), onClick: () => r(b.id), children: [
          /* @__PURE__ */ F("span", { className: "flex items-start justify-between gap-(--spacing-8)", children: [
            /* @__PURE__ */ g("span", { className: "[&>span]:block min-w-0 flex-1 [&>span]:leading-(--font-line-height-20)", children: /* @__PURE__ */ g(Rn, { as: "span", size: "sm", truncate: !0, children: b.title }) }),
            b.timestamp ? /* @__PURE__ */ g("span", { className: "shrink-0 whitespace-nowrap", children: /* @__PURE__ */ g(ln, { as: "span", size: "sm", tone: "subtle", children: b.timestamp }) }) : null
          ] }),
          b.preview ? /* @__PURE__ */ g(ln, { as: "span", size: "sm", tone: "subtle", truncate: !0, children: b.preview }) : null
        ] }, b.id)) })
      ] }, m);
    }), e[0] = o, e[1] = n, e[2] = r, e[3] = i, e[4] = s, e[5] = l, e[6] = a, e[7] = c;
  } else
    i = e[3], s = e[4], l = e[5], a = e[6], c = e[7];
  let u;
  e[9] !== i || e[10] !== s ? (u = /* @__PURE__ */ g("div", { className: i, children: s }), e[9] = i, e[10] = s, e[11] = u) : u = e[11];
  let d;
  return e[12] !== l || e[13] !== a || e[14] !== c || e[15] !== u ? (d = /* @__PURE__ */ F("div", { "data-slot": l, className: a, children: [
    c,
    u
  ] }), e[12] = l, e[13] = a, e[14] = c, e[15] = u, e[16] = d) : d = e[16], d;
}
function zC(t, e) {
  const n = e.groupLabel ?? "Conversations", o = t[n] ?? [];
  return o.push(e), t[n] = o, t;
}
function BC(t) {
  const e = W.c(17), {
    conversations: n,
    activeConversationId: o,
    collapsed: r,
    onNewConversation: i,
    onSelectConversation: s,
    onToggle: l,
    badge: a,
    newConversationLabel: c
  } = t, u = r === void 0 ? !1 : r, d = c === void 0 ? "New chat" : c;
  let f;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = $C(), e[0] = f) : f = e[0];
  let p;
  e[1] !== a || e[2] !== u || e[3] !== l ? (p = u ? null : /* @__PURE__ */ g("div", { className: "h-[72px] pb-(--spacing-8) pl-(--spacing-12) pt-(--spacing-24)", children: /* @__PURE__ */ g(Ep, { badge: a, sidebar: "expanded", children: /* @__PURE__ */ g(cu, { collapsed: !1, onToggle: l }) }) }), e[1] = a, e[2] = u, e[3] = l, e[4] = p) : p = e[4];
  let m;
  e[5] !== o || e[6] !== a || e[7] !== u || e[8] !== n || e[9] !== d || e[10] !== i || e[11] !== s || e[12] !== l ? (m = u ? /* @__PURE__ */ g("div", { className: "min-h-0 flex-1 overflow-y-auto px-(--spacing-4) py-(--spacing-12)", children: /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center justify-between", children: [
    /* @__PURE__ */ g(Ep, { badge: a, sidebar: "collapsed", children: /* @__PURE__ */ g(cu, { collapsed: !0, onToggle: l }) }),
    /* @__PURE__ */ g("div", { className: "flex size-(--spacing-48) items-center justify-center", children: /* @__PURE__ */ g(gt, { icon: "edit-pen", variant: "outline", size: "md", "aria-label": d, onClick: i }) })
  ] }) }) : /* @__PURE__ */ F(Ht, { children: [
    /* @__PURE__ */ g(s0, { conversations: n, activeConversationId: o, onSelectConversation: s }),
    /* @__PURE__ */ g("div", { className: "mt-auto px-(--spacing-12) pb-(--spacing-24) pt-(--spacing-12)", children: /* @__PURE__ */ g(An, { variant: "outline", size: "md", icon: "edit-pen", fullWidth: !0, onClick: i, children: d }) })
  ] }), e[5] = o, e[6] = a, e[7] = u, e[8] = n, e[9] = d, e[10] = i, e[11] = s, e[12] = l, e[13] = m) : m = e[13];
  let h;
  return e[14] !== p || e[15] !== m ? (h = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-sidebar", className: f, children: [
    p,
    m
  ] }), e[14] = p, e[15] = m, e[16] = h) : h = e[16], h;
}
const tm = oe("relative", "flex", "flex-col", "items-start", "w-full", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"), fc = {
  none: "p-0",
  compact: "p-(--spacing-12)",
  comfortable: "px-(--spacing-20) py-(--spacing-16)"
}, WC = oe("flex", "w-full", "items-stretch", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:rounded-r-none", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:rounded-none", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:last-child:not(:first-child)>[data-slot=card]]:rounded-l-none"), UC = oe("flex", "min-w-0", "flex-1", "[&>[data-slot=card]]:h-full"), GC = oe("cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "text-left", "hover:bg-surface-hover", "active:bg-surface-container-highest", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"), YC = oe("flex", "w-full", "flex-col", "items-start", "overflow-hidden", "rounded-(--radius-sm)"), jC = {
  brand: "bg-primary",
  positive: "bg-positive",
  warning: "bg-accessibility-warning",
  negative: "bg-negative",
  informative: "bg-informative"
};
function KC(t) {
  const e = W.c(4), {
    tone: n
  } = t, o = jC[n];
  let r;
  e[0] !== o ? (r = oe("pointer-events-none absolute -top-px -left-px -right-px z-10 h-(--spacing-8) rounded-tl-(--radius-sm) rounded-tr-(--radius-sm)", o), e[0] = o, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r ? (i = /* @__PURE__ */ g("div", { "data-slot": "card-border-fill", className: r }), e[2] = r, e[3] = i) : i = e[3], i;
}
function l0(t) {
  return Zl(t) && t.type === KC;
}
function OO(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("div", { "data-slot": "card-image-slot", className: "w-full shrink-0 overflow-hidden", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function DO(t) {
  const e = W.c(8);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ql.map(n, qC), e[3] = n, e[4] = r) : r = e[4];
  let i;
  return e[5] !== o || e[6] !== r ? (i = /* @__PURE__ */ g("div", { "data-slot": "card-group", className: WC, ...o, children: r }), e[5] = o, e[6] = r, e[7] = i) : i = e[7], i;
}
function qC(t) {
  return /* @__PURE__ */ g("div", { "data-slot": "card-group-item", className: UC, children: t });
}
function Zr(t) {
  const e = W.c(26);
  let n, o, r, i, s, l, a;
  if (e[0] !== t) {
    a = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      const {
        children: m,
        fillHeight: h,
        padding: b,
        ...v
      } = t;
      l = v;
      const C = h === void 0 ? !1 : h;
      s = b === void 0 ? "comfortable" : b;
      let y;
      if (e[8] !== m) {
        const S = ql.toArray(m);
        n = S.filter(l0), r = n.length > 0, y = S.filter(ZC), e[8] = m, e[9] = n, e[10] = r, e[11] = y;
      } else
        n = e[9], r = e[10], y = e[11];
      const w = y;
      let R;
      if (e[12] !== m || e[13] !== w || e[14] !== r || e[15] !== s ? (R = r ? /* @__PURE__ */ g("div", { "data-slot": "card-content", className: oe(YC, fc[s]), children: w }) : m, e[12] = m, e[13] = w, e[14] = r, e[15] = s, e[16] = R) : R = e[16], o = R, i = C ? "h-full" : null, "onClick" in l && l.onClick !== void 0) {
        const {
          onClick: S,
          disabled: E,
          ...N
        } = l;
        a = /* @__PURE__ */ F(Xn, { "data-slot": "card", className: oe(tm, r ? "overflow-visible" : "overflow-hidden", !r && fc[s], i, GC, E && "opacity-50 pointer-events-none"), onClick: S, disabled: E, "aria-disabled": E || void 0, ...N, children: [
          n,
          o
        ] });
        break e;
      }
    }
    e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7];
  if (a !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return a;
  const c = r ? "overflow-visible" : "overflow-hidden", u = !r && fc[s];
  let d;
  e[17] !== i || e[18] !== c || e[19] !== u ? (d = oe(tm, c, u, i), e[17] = i, e[18] = c, e[19] = u, e[20] = d) : d = e[20];
  const f = l;
  let p;
  return e[21] !== n || e[22] !== o || e[23] !== d || e[24] !== f ? (p = /* @__PURE__ */ F("div", { "data-slot": "card", className: d, ...f, children: [
    n,
    o
  ] }), e[21] = n, e[22] = o, e[23] = d, e[24] = f, e[25] = p) : p = e[25], p;
}
function ZC(t) {
  return !l0(t);
}
const XC = ae(["grid", "w-full", "grid-cols-2", "auto-rows-[114px]", "gap-(--spacing-12)"]);
function _O(t) {
  const e = W.c(18), {
    title: n,
    description: o,
    templates: r,
    onSelectTemplate: i
  } = t;
  let s;
  e[0] !== n ? (s = /* @__PURE__ */ g(Rn, { as: "h2", size: "xl", children: n }), e[0] = n, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = o ? /* @__PURE__ */ g(ln, { tone: "subtle", children: o }) : null, e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== s || e[5] !== l ? (a = /* @__PURE__ */ F("div", { className: "flex w-full flex-col items-center gap-(--spacing-8) pt-(--spacing-12) text-center [&>h2]:leading-(--font-line-height-28)", children: [
    s,
    l
  ] }), e[4] = s, e[5] = l, e[6] = a) : a = e[6];
  let c;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = XC(), e[7] = c) : c = e[7];
  let u;
  if (e[8] !== i || e[9] !== r) {
    let p;
    e[11] !== i ? (p = (m) => /* @__PURE__ */ g(Zr, { fillHeight: !0, "aria-label": m.title, onClick: () => i(m), children: m.content ?? /* @__PURE__ */ F("div", { className: "flex w-full flex-col gap-(--spacing-12)", children: [
      /* @__PURE__ */ F("div", { className: "flex w-full items-start justify-between gap-(--spacing-12)", children: [
        /* @__PURE__ */ g("span", { className: "text-icon-main", children: m.icon ?? /* @__PURE__ */ g(Ge, { name: "sparkles", size: "md" }) }),
        m.action ? /* @__PURE__ */ g("span", { className: "shrink-0", children: m.action }) : null
      ] }),
      /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-col gap-(--spacing-4)", children: [
        /* @__PURE__ */ g(Rn, { as: "h3", size: "xs", children: m.title }),
        m.description ? /* @__PURE__ */ g(ln, { size: "sm", tone: "subtle", children: m.description }) : null
      ] })
    ] }) }, m.id), e[11] = i, e[12] = p) : p = e[12], u = r.map(p), e[8] = i, e[9] = r, e[10] = u;
  } else
    u = e[10];
  let d;
  e[13] !== u ? (d = /* @__PURE__ */ g("div", { className: c, children: u }), e[13] = u, e[14] = d) : d = e[14];
  let f;
  return e[15] !== a || e[16] !== d ? (f = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-template-picker", className: "flex w-full max-w-[368px] flex-col items-center gap-(--spacing-20)", children: [
    a,
    d
  ] }), e[15] = a, e[16] = d, e[17] = f) : f = e[17], f;
}
function QC(t) {
  const e = W.c(53), {
    message: n,
    renderMessageContent: o,
    feedback: r,
    feedbackProps: i,
    feedbackResetKey: s
  } = t;
  let l;
  e[0] !== n || e[1] !== o ? (l = o ? o(n) : n.content, e[0] = n, e[1] = o, e[2] = l) : l = e[2];
  const a = l;
  let c;
  e[3] !== i ? (c = i ?? {}, e[3] = i, e[4] = c) : c = e[4];
  const u = T2(c, s), d = n.role === "assistant" && r === void 0 && i !== void 0;
  let f;
  e[5] !== u || e[6] !== d ? (f = d && u.status === "idle" ? /* @__PURE__ */ g(O2, { feedbackState: u }) : null, e[5] = u, e[6] = d, e[7] = f) : f = e[7];
  const p = f;
  let m;
  e[8] !== r || e[9] !== i || e[10] !== u || e[11] !== d ? (m = d ? u.status === "submitted" ? /* @__PURE__ */ g(_2, {}) : u.status === "idle" && u.isReasonsOpen ? /* @__PURE__ */ g(D2, { feedbackState: u, allowWrittenFeedback: i.allowWrittenFeedback ?? !0, submitDisabled: i.onSubmit === void 0 }) : null : r, e[8] = r, e[9] = i, e[10] = u, e[11] = d, e[12] = m) : m = e[12];
  const h = m, b = n.role === "user";
  if (n.role === "system") {
    const D = typeof a == "string" || typeof a == "number";
    let O;
    e[13] !== a || e[14] !== D || e[15] !== n.statusTone ? (O = D ? /* @__PURE__ */ g(Fv, { tone: n.statusTone ?? "informative", children: a }) : /* @__PURE__ */ g(Zc, { tone: "system", children: a }), e[13] = a, e[14] = D, e[15] = n.statusTone, e[16] = O) : O = e[16];
    let _;
    e[17] !== n.actions ? (_ = n.actions ? /* @__PURE__ */ g(P1, { children: n.actions }) : null, e[17] = n.actions, e[18] = _) : _ = e[18];
    let V;
    return e[19] !== O || e[20] !== _ ? (V = /* @__PURE__ */ g(Kc, { direction: "inbound", children: /* @__PURE__ */ F(qc, { children: [
      O,
      _
    ] }) }), e[19] = O, e[20] = _, e[21] = V) : V = e[21], V;
  }
  const v = b ? "outbound" : "inbound";
  let C;
  e[22] !== b || e[23] !== n.avatar ? (C = b ? null : /* @__PURE__ */ g(Tg, { children: n.avatar ?? /* @__PURE__ */ g(Ur, { variant: "ai", size: "md" }) }), e[22] = b, e[23] = n.avatar, e[24] = C) : C = e[24];
  const y = n.author ?? (b ? "You" : "Assistant");
  let w;
  e[25] !== y ? (w = /* @__PURE__ */ g(uo, { size: "lg", children: y }), e[25] = y, e[26] = w) : w = e[26];
  let R;
  e[27] !== n.timestamp ? (R = n.timestamp ? /* @__PURE__ */ F(Ht, { children: [
    /* @__PURE__ */ g(uo, { size: "xs", tone: "subtle", children: "•" }),
    /* @__PURE__ */ g(uo, { size: "lg", tone: "subtle", children: n.timestamp })
  ] }) : null, e[27] = n.timestamp, e[28] = R) : R = e[28];
  let S;
  e[29] !== w || e[30] !== R ? (S = /* @__PURE__ */ F(Og, { children: [
    w,
    R
  ] }), e[29] = w, e[30] = R, e[31] = S) : S = e[31];
  let E;
  e[32] !== a ? (E = /* @__PURE__ */ g(Zc, { children: a }), e[32] = a, e[33] = E) : E = e[33];
  let N;
  e[34] !== p || e[35] !== n.actions ? (N = n.actions || p ? /* @__PURE__ */ g(P1, { children: /* @__PURE__ */ F("div", { className: "flex items-start gap-(--spacing-4)", children: [
    n.actions,
    p
  ] }) }) : null, e[34] = p, e[35] = n.actions, e[36] = N) : N = e[36];
  let I;
  e[37] !== S || e[38] !== E || e[39] !== N ? (I = /* @__PURE__ */ F(qc, { children: [
    S,
    E,
    N
  ] }), e[37] = S, e[38] = E, e[39] = N, e[40] = I) : I = e[40];
  let T;
  e[41] !== b ? (T = b ? null : /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "w-[28px] shrink-0" }), e[41] = b, e[42] = T) : T = e[42];
  let k;
  e[43] !== I || e[44] !== T || e[45] !== v || e[46] !== C ? (k = /* @__PURE__ */ F(Kc, { direction: v, children: [
    C,
    I,
    T
  ] }), e[43] = I, e[44] = T, e[45] = v, e[46] = C, e[47] = k) : k = e[47];
  let P;
  e[48] !== h ? (P = h ? /* @__PURE__ */ g("div", { children: h }) : null, e[48] = h, e[49] = P) : P = e[49];
  let M;
  return e[50] !== k || e[51] !== P ? (M = /* @__PURE__ */ F("div", { className: "flex min-w-0 w-full flex-col gap-(--spacing-4)", children: [
    k,
    P
  ] }), e[50] = k, e[51] = P, e[52] = M) : M = e[52], M;
}
function JC(t) {
  const e = W.c(4), {
    messageId: n
  } = t, {
    scrollToEnd: o
  } = gg(), r = ut(n);
  let i, s;
  return e[0] !== n || e[1] !== o ? (i = () => {
    n && r.current !== n && o(), r.current = n;
  }, s = [n, o], e[0] = n, e[1] = o, e[2] = i, e[3] = s) : (i = e[2], s = e[3]), _t(i, s), null;
}
function VO(t) {
  const e = W.c(110), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    conversations: i,
    activeConversationId: s,
    messages: l,
    isResponding: a,
    sidebar: c,
    templatePicker: u,
    feedback: d,
    feedbackRating: f,
    feedbackResetKey: p,
    conversationDate: m,
    minimized: h,
    onClose: b,
    onExpand: v,
    onMinimize: C,
    onSidebarToggle: y,
    sidebarBadge: w,
    onNewConversation: R,
    onSelectConversation: S,
    onSendMessage: E,
    renderMessageContent: N,
    onSubmitFeedback: I,
    onRateResponse: T,
    composerProps: k
  } = t;
  let P;
  e[0] !== i ? (P = i === void 0 ? [] : i, e[0] = i, e[1] = P) : P = e[1];
  const M = P, D = a === void 0 ? !1 : a, O = h === void 0 ? !1 : h, _ = Xt();
  let V;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = {
    defaultMatches: !1
  }, e[2] = V) : V = e[2];
  const A = ws("(max-width: 599px)", V), L = O && !A, [$, Y] = tt(!1), [G, j] = tt(0);
  let Z;
  e[3] !== k?.initialValue ? (Z = () => k?.initialValue ?? "", e[3] = k?.initialValue, e[4] = Z) : Z = e[4];
  const [U, q] = tt(Z), te = ut(s), H = ut(null), X = ut(null), ee = `${_}-conversation-date`, le = `${_}-responding`;
  let Q;
  e[5] !== l ? (Q = [...l].reverse().find(nw)?.id, e[5] = l, e[6] = Q) : Q = e[6];
  const re = Q;
  let fe;
  e[7] !== l ? (fe = [...l].reverse().find(tw)?.id, e[7] = l, e[8] = fe) : fe = e[8];
  const ne = fe, se = p ?? `${s ?? "conversation"}:${re ?? "response"}`;
  let pe, xe;
  e[9] !== A || e[10] !== c ? (xe = () => {
    (!A || !c) && Y(!1);
  }, pe = [A, c], e[9] = A, e[10] = c, e[11] = pe, e[12] = xe) : (pe = e[11], xe = e[12]), _t(xe, pe);
  let ce, he;
  e[13] !== s ? (ce = () => {
    te.current !== s && (q(""), te.current = s);
  }, he = [s], e[13] = s, e[14] = ce, e[15] = he) : (ce = e[14], he = e[15]), _t(ce, he);
  let z;
  e[16] !== A ? (z = () => {
    !A || X.current === null || (H.current?.focus(), X.current = null);
  }, e[16] = A, e[17] = z) : z = e[17], Po(z);
  let J;
  e[18] !== f || e[19] !== T || e[20] !== I ? (J = I || T ? {
    rating: f,
    onRateResponse: T,
    onSubmit: I
  } : void 0, e[18] = f, e[19] = T, e[20] = I, e[21] = J) : J = e[21];
  const B = J;
  let K;
  e[22] !== A || e[23] !== $ || e[24] !== R ? (K = () => {
    A && $ && (X.current = "history"), Y(!1), q(""), j(ew), R?.();
  }, e[22] = A, e[23] = $, e[24] = R, e[25] = K) : K = e[25];
  const ie = K;
  let ge;
  e[26] !== A || e[27] !== $ || e[28] !== S ? (ge = (je) => {
    A && $ && (X.current = "history"), Y(!1), S?.(je);
  }, e[26] = A, e[27] = $, e[28] = S, e[29] = ge) : ge = e[29];
  const ue = ge;
  let Se;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Se = () => {
    X.current = "back", Y(!0);
  }, e[30] = Se) : Se = e[30];
  const ve = Se;
  let de;
  e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (de = () => {
    X.current = "history", Y(!1);
  }, e[31] = de) : de = e[31];
  const me = de;
  let Re;
  e[32] !== s || e[33] !== M || e[34] !== A || e[35] !== o || e[36] !== $ || e[37] !== b || e[38] !== v || e[39] !== C || e[40] !== ue || e[41] !== c || e[42] !== ie || e[43] !== n || e[44] !== r ? (Re = c && A ? /* @__PURE__ */ g("div", { className: "h-full w-full", hidden: !$, children: /* @__PURE__ */ g(Rp, { children: /* @__PURE__ */ F(Np, { children: [
    /* @__PURE__ */ g(sc, { title: n, leadingAccessory: o, titleAccessory: r, onClose: b, onMinimize: C, onExpand: v, onNewConversation: ie, onBack: me, mobileHistoryControlRef: $ ? H : void 0 }),
    /* @__PURE__ */ g(kp, { children: /* @__PURE__ */ g(s0, { conversations: M, activeConversationId: s, onSelectConversation: ue }) })
  ] }) }) }) : null, e[32] = s, e[33] = M, e[34] = A, e[35] = o, e[36] = $, e[37] = b, e[38] = v, e[39] = C, e[40] = ue, e[41] = c, e[42] = ie, e[43] = n, e[44] = r, e[45] = Re) : Re = e[45];
  const Ie = Re, Pe = L || !!(c && A && $);
  let _e;
  e[46] !== s || e[47] !== M || e[48] !== y || e[49] !== ue || e[50] !== c || e[51] !== w || e[52] !== ie ? (_e = c ? /* @__PURE__ */ g(vy, { children: /* @__PURE__ */ g(BC, { conversations: M, activeConversationId: s, collapsed: c === "collapsed", onNewConversation: ie, onSelectConversation: ue, onToggle: y, badge: w }) }) : null, e[46] = s, e[47] = M, e[48] = y, e[49] = ue, e[50] = c, e[51] = w, e[52] = ie, e[53] = _e) : _e = e[53];
  const Ye = c ? ie : void 0, qe = c ? ve : void 0, $e = $ ? void 0 : H;
  let Ee;
  e[54] !== o || e[55] !== b || e[56] !== v || e[57] !== C || e[58] !== Ye || e[59] !== qe || e[60] !== $e || e[61] !== n || e[62] !== r ? (Ee = /* @__PURE__ */ g(sc, { title: n, leadingAccessory: o, titleAccessory: r, onClose: b, onMinimize: C, onExpand: v, onNewConversation: Ye, onOpenHistory: qe, mobileHistoryControlRef: $e }), e[54] = o, e[55] = b, e[56] = v, e[57] = C, e[58] = Ye, e[59] = qe, e[60] = $e, e[61] = n, e[62] = r, e[63] = Ee) : Ee = e[63];
  let Ve;
  e[64] !== B || e[65] !== se || e[66] !== m || e[67] !== ee || e[68] !== d || e[69] !== D || e[70] !== re || e[71] !== ne || e[72] !== l || e[73] !== N || e[74] !== le || e[75] !== u ? (Ve = /* @__PURE__ */ g(kp, { children: !D && l.length === 0 && u ? /* @__PURE__ */ g("div", { className: "flex h-full min-h-0 justify-center overflow-y-auto px-(--spacing-12) py-(--spacing-12)", children: u }) : /* @__PURE__ */ F(Dg, { children: [
    /* @__PURE__ */ F(_g, { "aria-label": "Conversation", children: [
      /* @__PURE__ */ F(Vg, { children: [
        m ? /* @__PURE__ */ g(bl, { messageId: ee, children: /* @__PURE__ */ g("div", { className: "py-(--spacing-10)", children: /* @__PURE__ */ g(mr, { centeredText: m }) }) }) : null,
        l.map((je) => /* @__PURE__ */ g(bl, { messageId: je.id, children: /* @__PURE__ */ g(QC, { message: je, renderMessageContent: N, feedback: je.id === re ? d : void 0, feedbackProps: je.id === re ? B : void 0, feedbackResetKey: se }) }, je.id)),
        D ? /* @__PURE__ */ g(bl, { messageId: le, children: /* @__PURE__ */ g(xy, {}) }) : null
      ] }),
      /* @__PURE__ */ g(JC, { messageId: ne })
    ] }),
    /* @__PURE__ */ g(Ag, {})
  ] }) }), e[64] = B, e[65] = se, e[66] = m, e[67] = ee, e[68] = d, e[69] = D, e[70] = re, e[71] = ne, e[72] = l, e[73] = N, e[74] = le, e[75] = u, e[76] = Ve) : Ve = e[76];
  const Me = `${s ?? "conversation"}:${G}`;
  let He;
  e[77] !== k || e[78] !== U || e[79] !== E || e[80] !== Me ? (He = /* @__PURE__ */ g(yy, { children: /* @__PURE__ */ g("div", { className: "-mx-(--spacing-4) -mb-(--spacing-4)", children: /* @__PURE__ */ g(Qy, { ...k, value: U, onChange: q, onSendMessage: E }, Me) }) }), e[77] = k, e[78] = U, e[79] = E, e[80] = Me, e[81] = He) : He = e[81];
  let ze;
  e[82] !== Ee || e[83] !== Ve || e[84] !== He ? (ze = /* @__PURE__ */ F(Np, { children: [
    Ee,
    Ve,
    He
  ] }), e[82] = Ee, e[83] = Ve, e[84] = He, e[85] = ze) : ze = e[85];
  let Oe;
  e[86] !== c || e[87] !== _e || e[88] !== ze ? (Oe = /* @__PURE__ */ F(Rp, { sidebar: c, children: [
    _e,
    ze
  ] }), e[86] = c, e[87] = _e, e[88] = ze, e[89] = Oe) : Oe = e[89];
  let wt;
  e[90] !== Pe || e[91] !== Oe ? (wt = /* @__PURE__ */ g("div", { className: "h-full w-full", hidden: Pe, children: Oe }), e[90] = Pe, e[91] = Oe, e[92] = wt) : wt = e[92];
  const dt = wt;
  let we;
  e[93] !== dt || e[94] !== Ie ? (we = /* @__PURE__ */ F(Ht, { children: [
    Ie,
    dt
  ] }), e[93] = dt, e[94] = Ie, e[95] = we) : we = e[95];
  const ke = we;
  let Ae;
  e[96] !== ke || e[97] !== L ? (Ae = /* @__PURE__ */ g("div", { className: "contents", hidden: L, children: ke }), e[96] = ke, e[97] = L, e[98] = Ae) : Ae = e[98];
  let We;
  e[99] !== L || e[100] !== o || e[101] !== b || e[102] !== v || e[103] !== C || e[104] !== n || e[105] !== r ? (We = L ? /* @__PURE__ */ g(sc, { title: n, leadingAccessory: o, titleAccessory: r, minimized: !0, onClose: b, onMinimize: C, onExpand: v }) : null, e[99] = L, e[100] = o, e[101] = b, e[102] = v, e[103] = C, e[104] = n, e[105] = r, e[106] = We) : We = e[106];
  let it;
  return e[107] !== Ae || e[108] !== We ? (it = /* @__PURE__ */ F(Ht, { children: [
    Ae,
    We
  ] }), e[107] = Ae, e[108] = We, e[109] = it) : it = e[109], it;
}
function ew(t) {
  return t + 1;
}
function tw(t) {
  return t.role === "user";
}
function nw(t) {
  return t.role === "assistant";
}
const ow = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
};
function rw(t) {
  const e = W.c(2), {
    count: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("span", { className: "flex w-[60px] items-center justify-center rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-6) font-(family-name:--font-family-title) font-(number:--font-weight-bold) text-(length:--font-size-headline-xsmall) leading-(--font-line-height-24) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function AO(t) {
  const e = W.c(40);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    count: r,
    actionItemName: n,
    priority: s,
    priorityLabel: l,
    buttonLabel: o,
    onButtonClick: i,
    style: c,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  let u;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    defaultMatches: !1
  }, e[9] = u) : u = e[9];
  const d = ws("(max-width: 599px)", u);
  let f;
  e[10] !== c ? (f = {
    width: "100%",
    ...c
  }, e[10] = c, e[11] = f) : f = e[11];
  const p = f;
  let m;
  e[12] !== r ? (m = /* @__PURE__ */ g(rw, { count: r }), e[12] = r, e[13] = m) : m = e[13];
  let h;
  e[14] !== n ? (h = /* @__PURE__ */ g(Rn, { size: "md", as: "h3", children: n }), e[14] = n, e[15] = h) : h = e[15];
  const b = ow[s];
  let v;
  e[16] !== l || e[17] !== b ? (v = /* @__PURE__ */ g(fo, { tone: b, icon: "priority", label: l }), e[16] = l, e[17] = b, e[18] = v) : v = e[18];
  let C;
  e[19] !== m || e[20] !== h || e[21] !== v ? (C = /* @__PURE__ */ F(hr, { gap: 12, align: "center", wrap: "nowrap", children: [
    m,
    h,
    v
  ] }), e[19] = m, e[20] = h, e[21] = v, e[22] = C) : C = e[22];
  let y;
  e[23] !== o || e[24] !== d || e[25] !== i ? (y = !d && /* @__PURE__ */ g(An, { variant: "outline", size: "sm", onClick: i, children: o }), e[23] = o, e[24] = d, e[25] = i, e[26] = y) : y = e[26];
  let w;
  e[27] !== C || e[28] !== y ? (w = /* @__PURE__ */ g("div", { className: "w-full", children: /* @__PURE__ */ F(hr, { justify: "between", align: "center", wrap: "nowrap", children: [
    C,
    y
  ] }) }), e[27] = C, e[28] = y, e[29] = w) : w = e[29];
  const R = w;
  if (d) {
    const E = `${o} ${n}`;
    let N;
    return e[30] !== p || e[31] !== R || e[32] !== i || e[33] !== a || e[34] !== E ? (N = /* @__PURE__ */ g(Zr, { ...a, "aria-label": E, padding: "compact", style: p, onClick: i, children: R }), e[30] = p, e[31] = R, e[32] = i, e[33] = a, e[34] = E, e[35] = N) : N = e[35], N;
  }
  let S;
  return e[36] !== p || e[37] !== R || e[38] !== a ? (S = /* @__PURE__ */ g(Zr, { ...a, padding: "compact", style: p, children: R }), e[36] = p, e[37] = R, e[38] = a, e[39] = S) : S = e[39], S;
}
const iw = {
  positive: "text-positive",
  negative: "text-negative"
}, sw = "text-text-subtle";
function a0(t) {
  const e = W.c(16), {
    label: n,
    showIcon: o
  } = t, r = o === void 0 ? !0 : o, {
    value: i
  } = t, s = i === void 0, l = !s && (!("tone" in t) || t.tone === void 0), a = s || l;
  let c = sw, u = "trend-no-change", d = "sm";
  !a && t.tone && t.direction && (c = iw[t.tone], u = t.direction === "up" ? "trend-up" : "trend-down", d = "md");
  const f = `inline-flex items-center gap-(--spacing-4) ${c}`;
  let p;
  e[0] !== u || e[1] !== d || e[2] !== s || e[3] !== r ? (p = r ? s ? /* @__PURE__ */ g("span", { className: "inline-block w-(--icon-sm) text-center font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-xs) leading-(--font-line-height-20)", children: "--" }) : /* @__PURE__ */ g(Ge, { name: u, size: d, tone: "inherit" }) : null, e[0] = u, e[1] = d, e[2] = s, e[3] = r, e[4] = p) : p = e[4];
  let m;
  e[5] !== i ? (m = i ? /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-xs) leading-(--font-line-height-20)", children: i }) : null, e[5] = i, e[6] = m) : m = e[6];
  let h;
  e[7] !== f || e[8] !== p || e[9] !== m ? (h = /* @__PURE__ */ F("span", { className: f, children: [
    p,
    m
  ] }), e[7] = f, e[8] = p, e[9] = m, e[10] = h) : h = e[10];
  let b;
  e[11] !== n ? (b = /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-20) text-text-subtext", children: n }), e[11] = n, e[12] = b) : b = e[12];
  let v;
  return e[13] !== h || e[14] !== b ? (v = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-4)", children: [
    h,
    b
  ] }), e[13] = h, e[14] = b, e[15] = v) : v = e[15], v;
}
const lw = ae(["font-(family-name:--font-family-body)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-title-lg)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      warning: "text-accessibility-warning",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "positive"
  }
});
function aw(t) {
  const e = W.c(5), {
    value: n,
    tone: o
  } = t;
  let r;
  e[0] !== o ? (r = lw({
    tone: o
  }), e[0] = o, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r || e[3] !== n ? (i = /* @__PURE__ */ g("span", { className: r, children: n }), e[2] = r, e[3] = n, e[4] = i) : i = e[4], i;
}
function LO(t) {
  const e = W.c(26);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    label: o,
    value: l,
    tone: i,
    detail: n,
    trend: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  let a;
  e[7] !== n ? (a = n ? /* @__PURE__ */ F("span", { className: "font-(number:--font-weight-semibold) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-subtle", children: [
    " ",
    n
  ] }) : null, e[7] = n, e[8] = a) : a = e[8];
  let c;
  e[9] !== o || e[10] !== a ? (c = /* @__PURE__ */ F(Rn, { size: "sm", as: "h3", children: [
    o,
    a
  ] }), e[9] = o, e[10] = a, e[11] = c) : c = e[11];
  let u;
  e[12] !== i || e[13] !== l ? (u = /* @__PURE__ */ g(aw, { value: l, tone: i }), e[12] = i, e[13] = l, e[14] = u) : u = e[14];
  let d;
  e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ F(hr, { justify: "between", align: "center", wrap: "nowrap", children: [
    c,
    u
  ] }), e[15] = c, e[16] = u, e[17] = d) : d = e[17];
  let f;
  e[18] !== s ? (f = s ? /* @__PURE__ */ g(a0, { ...s }) : null, e[18] = s, e[19] = f) : f = e[19];
  let p;
  e[20] !== d || e[21] !== f ? (p = /* @__PURE__ */ g("div", { className: "w-full", children: /* @__PURE__ */ F(Kr, { gap: 8, children: [
    d,
    f
  ] }) }), e[20] = d, e[21] = f, e[22] = p) : p = e[22];
  let m;
  return e[23] !== r || e[24] !== p ? (m = /* @__PURE__ */ g(Zr, { ...r, padding: "compact", children: p }), e[23] = r, e[24] = p, e[25] = m) : m = e[25], m;
}
const cw = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
}, uw = ae(["font-(family-name:--font-family-headline)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-headline-large)", "leading-(--font-line-height-40)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function dw(t) {
  const e = W.c(5), {
    value: n,
    tone: o
  } = t, r = o === void 0 ? "neutral" : o;
  let i;
  e[0] !== r ? (i = uw({
    tone: r
  }), e[0] = r, e[1] = i) : i = e[1];
  let s;
  return e[2] !== i || e[3] !== n ? (s = /* @__PURE__ */ g("span", { className: i, children: n }), e[2] = i, e[3] = n, e[4] = s) : s = e[4], s;
}
function FO(t) {
  const e = W.c(43);
  let n, o, r, i, s, l, a, c, u, d, f;
  e[0] !== t ? ({
    label: r,
    value: f,
    tone: c,
    trend: d,
    supportingInfo: a,
    actionLabel: n,
    onActionClick: i,
    actionRender: o,
    priority: s,
    fillHeight: u,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11]);
  const p = c === void 0 ? "neutral" : c, m = u === void 0 ? !1 : u, h = m ? "flex h-full w-full flex-col justify-center" : "w-full";
  let b;
  e[12] !== r ? (b = /* @__PURE__ */ g(Rn, { size: "md", as: "h3", truncate: !0, children: r }), e[12] = r, e[13] = b) : b = e[13];
  let v;
  e[14] !== n || e[15] !== o || e[16] !== i || e[17] !== s ? (v = n && (i || o) ? /* @__PURE__ */ g(gt, { render: o, variant: "outline", size: "sm", icon: "arrow-up-right", "aria-label": n, onClick: i }) : s ? /* @__PURE__ */ g(Ge, { name: "priority", size: "sm", tone: cw[s] }) : null, e[14] = n, e[15] = o, e[16] = i, e[17] = s, e[18] = v) : v = e[18];
  let C;
  e[19] !== b || e[20] !== v ? (C = /* @__PURE__ */ g("div", { className: "h-(--spacing-32)", children: /* @__PURE__ */ F(hr, { justify: "between", align: "start", wrap: "nowrap", children: [
    b,
    v
  ] }) }), e[19] = b, e[20] = v, e[21] = C) : C = e[21];
  let y;
  e[22] !== p || e[23] !== f ? (y = /* @__PURE__ */ g(dw, { value: f, tone: p }), e[22] = p, e[23] = f, e[24] = y) : y = e[24];
  let w;
  e[25] !== d ? (w = d ? /* @__PURE__ */ g(a0, { ...d }) : null, e[25] = d, e[26] = w) : w = e[26];
  let R;
  e[27] !== a ? (R = a ? /* @__PURE__ */ g("div", { className: "w-full", children: a }) : null, e[27] = a, e[28] = R) : R = e[28];
  let S;
  e[29] !== y || e[30] !== w || e[31] !== R ? (S = /* @__PURE__ */ F(Kr, { gap: 6, children: [
    y,
    w,
    R
  ] }), e[29] = y, e[30] = w, e[31] = R, e[32] = S) : S = e[32];
  let E;
  e[33] !== S || e[34] !== C ? (E = /* @__PURE__ */ F(Kr, { gap: 12, children: [
    C,
    S
  ] }), e[33] = S, e[34] = C, e[35] = E) : E = e[35];
  let N;
  e[36] !== E || e[37] !== h ? (N = /* @__PURE__ */ g("div", { className: h, children: E }), e[36] = E, e[37] = h, e[38] = N) : N = e[38];
  let I;
  return e[39] !== m || e[40] !== l || e[41] !== N ? (I = /* @__PURE__ */ g(Zr, { fillHeight: m, ...l, children: N }), e[39] = m, e[40] = l, e[41] = N, e[42] = I) : I = e[42], I;
}
function $O(t) {
  const e = W.c(33);
  let n;
  e[0] !== t.chipLabel || e[1] !== t.mpCount || e[2] !== t.variant ? (n = t.variant === "add" ? /* @__PURE__ */ g(fo, { tone: "informative", label: t.chipLabel ?? "Recommended" }) : t.mpCount != null ? /* @__PURE__ */ g(fo, { tone: "neutral", label: t.mpCount === 1 ? "1 MP" : `${t.mpCount} MPs` }) : null, e[0] = t.chipLabel, e[1] = t.mpCount, e[2] = t.variant, e[3] = n) : n = e[3];
  const o = n;
  let r, i, s, l, a, c;
  if (e[4] !== t) {
    const {
      serviceName: w,
      icon: R,
      variant: S,
      chipLabel: E,
      mpCount: N,
      showIcon: I,
      style: T,
      ...k
    } = t;
    s = w, i = R, a = S, c = I, l = T, r = k, e[4] = t, e[5] = r, e[6] = i, e[7] = s, e[8] = l, e[9] = a, e[10] = c;
  } else
    r = e[5], i = e[6], s = e[7], l = e[8], a = e[9], c = e[10];
  const u = a === void 0 ? "default" : a, d = c === void 0 ? !0 : c;
  let f;
  e[11] !== l ? (f = {
    width: "100%",
    ...l
  }, e[11] = l, e[12] = f) : f = e[12];
  let p;
  e[13] !== i ? (p = /* @__PURE__ */ g(Ge, { name: i, size: "sm", tone: "neutral", "aria-hidden": !0 }), e[13] = i, e[14] = p) : p = e[14];
  let m;
  e[15] !== s ? (m = /* @__PURE__ */ g(Rn, { size: "sm", as: "h3", children: s }), e[15] = s, e[16] = m) : m = e[16];
  let h;
  e[17] !== p || e[18] !== m ? (h = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-start gap-(--spacing-4)", children: [
    p,
    m
  ] }), e[17] = p, e[18] = m, e[19] = h) : h = e[19];
  let b;
  e[20] !== h || e[21] !== o ? (b = /* @__PURE__ */ F(hr, { gap: 8, justify: "between", wrap: "wrap", align: "start", children: [
    h,
    o
  ] }), e[20] = h, e[21] = o, e[22] = b) : b = e[22];
  let v;
  e[23] !== u || e[24] !== d ? (v = u === "add" ? /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-center gap-(--spacing-10) border border-dashed border-outline-subtle bg-surface py-(--spacing-6)", children: [
    d ? /* @__PURE__ */ g(Ge, { name: "marketplace", size: "md", tone: "neutral", "aria-hidden": !0 }) : null,
    /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-24) text-text-default", children: "Add" })
  ] }) : null, e[23] = u, e[24] = d, e[25] = v) : v = e[25];
  let C;
  e[26] !== b || e[27] !== v ? (C = /* @__PURE__ */ g("div", { className: "w-full", children: /* @__PURE__ */ F(Kr, { gap: 12, children: [
    b,
    v
  ] }) }), e[26] = b, e[27] = v, e[28] = C) : C = e[28];
  let y;
  return e[29] !== r || e[30] !== f || e[31] !== C ? (y = /* @__PURE__ */ g(Zr, { ...r, padding: "compact", style: f, children: C }), e[29] = r, e[30] = f, e[31] = C, e[32] = y) : y = e[32], y;
}
const fw = ae(["w-full", "flex", "items-start", "justify-between", "gap-(--spacing-24)", "p-(--spacing-12)", "rounded-(--radius-sm)"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
}), pw = {
  neutral: "circle-info",
  informative: "circle-info",
  positive: "circle-check",
  warning: "warning",
  negative: "warning"
};
function nm(t) {
  const e = W.c(33);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    tone: s,
    title: l,
    subtext: i,
    action: n,
    onDismiss: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? "neutral" : s, c = a === "negative", u = !!(n || o), d = c ? "alert" : "note", f = c ? "assertive" : void 0;
  let p;
  e[7] !== a ? (p = oe(fw({
    tone: a
  })), e[7] = a, e[8] = p) : p = e[8];
  const m = pw[a];
  let h;
  e[9] !== m ? (h = /* @__PURE__ */ g(Ge, { name: m, size: "md", tone: "inherit" }), e[9] = m, e[10] = h) : h = e[10];
  let b;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = {
    color: "inherit"
  }, e[11] = b) : b = e[11];
  let v;
  e[12] !== l ? (v = /* @__PURE__ */ g(Rn, { as: "span", size: "sm", style: b, children: l }), e[12] = l, e[13] = v) : v = e[13];
  let C;
  e[14] !== i ? (C = i ? /* @__PURE__ */ g(ln, { as: "span", size: "sm", style: {
    color: "inherit"
  }, children: i }) : null, e[14] = i, e[15] = C) : C = e[15];
  let y;
  e[16] !== v || e[17] !== C ? (y = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8) min-w-0", children: [
    v,
    C
  ] }), e[16] = v, e[17] = C, e[18] = y) : y = e[18];
  let w;
  e[19] !== y || e[20] !== h ? (w = /* @__PURE__ */ F("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    h,
    y
  ] }), e[19] = y, e[20] = h, e[21] = w) : w = e[21];
  let R;
  e[22] !== n || e[23] !== u || e[24] !== o ? (R = u ? /* @__PURE__ */ F("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    o ? /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": "Dismiss alert", variant: "ghost", size: "sm", onClick: o }) : null
  ] }) : null, e[22] = n, e[23] = u, e[24] = o, e[25] = R) : R = e[25];
  let S;
  return e[26] !== r || e[27] !== w || e[28] !== R || e[29] !== d || e[30] !== f || e[31] !== p ? (S = /* @__PURE__ */ F("div", { role: d, "aria-live": f, className: p, ...r, children: [
    w,
    R
  ] }), e[26] = r, e[27] = w, e[28] = R, e[29] = d, e[30] = f, e[31] = p, e[32] = S) : S = e[32], S;
}
function mw(t) {
  const e = W.c(14), {
    stableCount: n,
    watchingCount: o,
    maintenanceCount: r
  } = t, i = n + o + r;
  if (i === 0) {
    let p;
    return e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "h-(--spacing-8) w-full rounded-(--radius-none) bg-surface-inverse-surface/20" }), e[0] = p) : p = e[0], p;
  }
  const s = n / i * 100, l = o / i * 100, a = r / i * 100;
  let c;
  e[1] !== n || e[2] !== s ? (c = n > 0 && /* @__PURE__ */ g("div", { "data-testid": "asset-status-bar-stable", className: "h-full rounded-(--radius-none) bg-datavis-crit-green", style: {
    width: `${s}%`
  } }), e[1] = n, e[2] = s, e[3] = c) : c = e[3];
  let u;
  e[4] !== o || e[5] !== l ? (u = o > 0 && /* @__PURE__ */ g("div", { "data-testid": "asset-status-bar-watching", className: "h-full rounded-(--radius-none) bg-datavis-crit-yellow", style: {
    width: `${l}%`
  } }), e[4] = o, e[5] = l, e[6] = u) : u = e[6];
  let d;
  e[7] !== r || e[8] !== a ? (d = r > 0 && /* @__PURE__ */ g("div", { "data-testid": "asset-status-bar-maintenance", className: "h-full rounded-(--radius-none) bg-datavis-crit-red", style: {
    width: `${a}%`
  } }), e[7] = r, e[8] = a, e[9] = d) : d = e[9];
  let f;
  return e[10] !== c || e[11] !== u || e[12] !== d ? (f = /* @__PURE__ */ F("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "flex h-(--spacing-8) w-full gap-(--spacing-6)", children: [
    c,
    u,
    d
  ] }), e[10] = c, e[11] = u, e[12] = d, e[13] = f) : f = e[13], f;
}
const El = 6, gw = 4;
function hw(t) {
  return gw / (2 * Math.PI * t) * 360;
}
function om(t, e, n, o) {
  const r = (o - 90) * Math.PI / 180;
  return {
    x: t + n * Math.cos(r),
    y: e + n * Math.sin(r)
  };
}
function bw(t, e, n, o, r) {
  const i = om(t, e, n, r), s = om(t, e, n, o), l = r - o > 180 ? 1 : 0;
  return `M ${i.x} ${i.y} A ${n} ${n} 0 ${l} 0 ${s.x} ${s.y}`;
}
const vw = ["Stable", "Watching", "Maintenance Recommended"], yw = ["stroke-datavis-crit-green", "stroke-datavis-crit-yellow", "stroke-datavis-crit-red"];
function xw(t) {
  const e = W.c(51), {
    size: n,
    unit: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  } = t, l = n / 2, a = n / 2, c = (n - El) / 2, u = r + i + s, d = u === 0;
  let f;
  e[0] !== d || e[1] !== u ? (f = d ? "--" : u >= 1e4 ? `${Math.round(u / 1e3)}k` : String(u), e[0] = d, e[1] = u, e[2] = f) : f = e[2];
  const p = f, m = n >= 80 ? "var(--font-size-title-xl)" : "var(--font-size-title-sm)", h = n >= 80 ? "var(--font-size-title-sm)" : "var(--font-size-title-xs)", b = a - 4;
  let v;
  e[3] !== p || e[4] !== m || e[5] !== l || e[6] !== b ? (v = /* @__PURE__ */ g("text", { x: l, y: b, textAnchor: "middle", dominantBaseline: "auto", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: m, className: "fill-text-default", "data-testid": "asset-status-donut-count", children: p }), e[3] = p, e[4] = m, e[5] = l, e[6] = b, e[7] = v) : v = e[7];
  const C = a + 4;
  let y;
  e[8] !== l || e[9] !== C || e[10] !== o || e[11] !== h ? (y = /* @__PURE__ */ g("text", { x: l, y: C, textAnchor: "middle", dominantBaseline: "hanging", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: h, className: "fill-text-subtext", "data-testid": "asset-status-donut-unit", children: o }), e[8] = l, e[9] = C, e[10] = o, e[11] = h, e[12] = y) : y = e[12];
  let w;
  e[13] !== v || e[14] !== y ? (w = /* @__PURE__ */ F(Ht, { children: [
    v,
    y
  ] }), e[13] = v, e[14] = y, e[15] = w) : w = e[15];
  const R = w;
  if (d) {
    let _;
    e[16] !== l || e[17] !== a || e[18] !== c ? (_ = /* @__PURE__ */ g("circle", { cx: l, cy: a, r: c, fill: "none", className: "stroke-surface-inverse-surface/20", strokeWidth: El }), e[16] = l, e[17] = a, e[18] = c, e[19] = _) : _ = e[19];
    let V;
    return e[20] !== R || e[21] !== n || e[22] !== _ ? (V = /* @__PURE__ */ F("svg", { width: n, height: n, role: "img", "aria-label": "No asset status data available", "data-testid": "asset-status-donut", children: [
      _,
      R
    ] }), e[20] = R, e[21] = n, e[22] = _, e[23] = V) : V = e[23], V;
  }
  let S;
  e[24] !== s || e[25] !== r || e[26] !== i ? (S = [r, i, s].map(Sw).filter(ww), e[24] = s, e[25] = r, e[26] = i, e[27] = S) : S = e[27];
  const E = S;
  let N;
  e[28] !== c || e[29] !== E.length ? (N = E.length > 1 ? hw(c) : 0, e[28] = c, e[29] = E.length, e[30] = N) : N = e[30];
  const I = N, k = 360 - E.length * I;
  let P;
  if (e[31] !== k || e[32] !== l || e[33] !== a || e[34] !== I || e[35] !== c || e[36] !== E || e[37] !== u) {
    P = [];
    let _ = 0;
    for (const V of E) {
      const A = V.count / u * k;
      P.push({
        path: bw(l, a, c, _, _ + A),
        strokeClassName: V.strokeClassName,
        label: `${V.label}: ${V.count}`
      }), _ = _ + (A + I);
    }
    e[31] = k, e[32] = l, e[33] = a, e[34] = I, e[35] = c, e[36] = E, e[37] = u, e[38] = P;
  } else
    P = e[38];
  const M = `Asset status: ${r} stable, ${i} watching, ${s} maintenance`;
  let D;
  e[39] !== P || e[40] !== l || e[41] !== a || e[42] !== c || e[43] !== E[0] || e[44] !== E.length ? (D = E.length === 1 ? /* @__PURE__ */ g("circle", { cx: l, cy: a, r: c, fill: "none", className: E[0].strokeClassName, strokeWidth: El, "aria-label": `${E[0].label}: ${E[0].count}`, "data-testid": "asset-status-donut-segment" }) : P.map(Cw), e[39] = P, e[40] = l, e[41] = a, e[42] = c, e[43] = E[0], e[44] = E.length, e[45] = D) : D = e[45];
  let O;
  return e[46] !== R || e[47] !== n || e[48] !== D || e[49] !== M ? (O = /* @__PURE__ */ F("svg", { width: n, height: n, role: "img", "aria-label": M, "data-testid": "asset-status-donut", children: [
    D,
    R
  ] }), e[46] = R, e[47] = n, e[48] = D, e[49] = M, e[50] = O) : O = e[50], O;
}
function Cw(t) {
  return /* @__PURE__ */ g("path", { d: t.path, fill: "none", className: t.strokeClassName, strokeWidth: El, "aria-label": t.label, "data-testid": "asset-status-donut-segment" }, t.label);
}
function ww(t) {
  return t.count > 0;
}
function Sw(t, e) {
  return {
    count: t,
    strokeClassName: yw[e],
    label: vw[e]
  };
}
const Rw = {
  md: "var(--font-size-title-sm)",
  sm: "var(--font-size-title-xs)"
};
function pc(t) {
  const e = W.c(20), {
    size: n,
    icon: o,
    iconColor: r,
    chipTone: i,
    label: s,
    count: l
  } = t;
  let a;
  e[0] !== o ? (a = /* @__PURE__ */ g(Ge, { name: o, size: "xs", tone: "inherit" }), e[0] = o, e[1] = a) : a = e[1];
  let c;
  e[2] !== r || e[3] !== a ? (c = /* @__PURE__ */ g("span", { className: r, "aria-hidden": "true", children: a }), e[2] = r, e[3] = a, e[4] = c) : c = e[4];
  const u = Rw[n];
  let d;
  e[5] !== u ? (d = {
    fontSize: u
  }, e[5] = u, e[6] = d) : d = e[6];
  let f;
  e[7] !== s || e[8] !== d ? (f = /* @__PURE__ */ g("span", { className: "truncate font-(family-name:--font-family-title) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default", style: d, children: s }), e[7] = s, e[8] = d, e[9] = f) : f = e[9];
  let p;
  e[10] !== c || e[11] !== f ? (p = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6) min-w-0", children: [
    c,
    f
  ] }), e[10] = c, e[11] = f, e[12] = p) : p = e[12];
  const m = n === "md" ? o : void 0;
  let h;
  e[13] !== i || e[14] !== l || e[15] !== m ? (h = /* @__PURE__ */ g(fo, { tone: i, icon: m, label: l }), e[13] = i, e[14] = l, e[15] = m, e[16] = h) : h = e[16];
  let b;
  return e[17] !== p || e[18] !== h ? (b = /* @__PURE__ */ F("div", { className: "grid w-full grid-cols-[minmax(0,1fr)_max-content] items-center gap-(--spacing-8)", "data-testid": "asset-status-key-row", children: [
    p,
    h
  ] }), e[17] = p, e[18] = h, e[19] = b) : b = e[19], b;
}
function rm(t) {
  const e = W.c(19), {
    labels: n,
    size: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  } = t;
  let l;
  e[0] !== n ? (l = n === void 0 ? {
    stable: "Stable",
    watching: "Watching",
    maintenance: "Maintenance Recommended"
  } : n, e[0] = n, e[1] = l) : l = e[1];
  const a = l, u = `flex w-full min-w-0 flex-col ${o === "md" ? "gap-(--spacing-6)" : "gap-(--spacing-4)"}`;
  let d;
  e[2] !== a.stable || e[3] !== o || e[4] !== r ? (d = /* @__PURE__ */ g(pc, { size: o, icon: "circle-check", iconColor: "text-datavis-crit-green", chipTone: "positive", label: a.stable, count: r }), e[2] = a.stable, e[3] = o, e[4] = r, e[5] = d) : d = e[5];
  let f;
  e[6] !== a.watching || e[7] !== o || e[8] !== i ? (f = /* @__PURE__ */ g(pc, { size: o, icon: "eye-watching", iconColor: "text-datavis-crit-yellow", chipTone: "warning", label: a.watching, count: i }), e[6] = a.watching, e[7] = o, e[8] = i, e[9] = f) : f = e[9];
  let p;
  e[10] !== a.maintenance || e[11] !== s || e[12] !== o ? (p = /* @__PURE__ */ g(pc, { size: o, icon: "maintenance", iconColor: "text-datavis-crit-red", chipTone: "negative", label: a.maintenance, count: s }), e[10] = a.maintenance, e[11] = s, e[12] = o, e[13] = p) : p = e[13];
  let m;
  return e[14] !== u || e[15] !== d || e[16] !== f || e[17] !== p ? (m = /* @__PURE__ */ F("div", { className: u, "data-testid": "asset-status-key", children: [
    d,
    f,
    p
  ] }), e[14] = u, e[15] = d, e[16] = f, e[17] = p, e[18] = m) : m = e[18], m;
}
const Ew = {
  md: 88,
  sm: 80
};
function Nw({
  stableCount: t,
  watchingCount: e,
  maintenanceCount: n
}) {
  const o = [t < 0 ? "stableCount" : null, e < 0 ? "watchingCount" : null, n < 0 ? "maintenanceCount" : null].filter((r) => r !== null);
  if (o.length > 0)
    throw new RangeError(`AssetStatusCard counts cannot be negative: ${o.join(", ")}`);
}
function kw(t) {
  return t.borderBoxSize[0]?.inlineSize ?? t.contentRect.width;
}
function HO(t) {
  const e = W.c(20), {
    variant: n,
    unit: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s,
    labels: l
  } = t;
  Nw({
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  });
  const a = ut(null), [c, u] = tt("md"), d = n === "donut", f = r + i + s, p = f === 0, m = d ? "p-(--spacing-12)" : "p-(--spacing-20)";
  let h, b;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = () => {
    const R = a.current;
    if (!R || typeof ResizeObserver > "u")
      return;
    const S = (N) => {
      u(N <= 380 ? "sm" : "md");
    };
    S(R.getBoundingClientRect().width);
    const E = new ResizeObserver((N) => {
      const [I] = N;
      I && S(kw(I));
    });
    return E.observe(R), () => {
      E.disconnect();
    };
  }, b = [], e[0] = h, e[1] = b) : (h = e[0], b = e[1]), _t(h, b);
  const v = `flex h-full w-full min-w-0 flex-col gap-(--spacing-16) rounded-(--radius-sm) border border-outline-subtle bg-surface shadow-elevation-1 ${m}`;
  let C;
  e[2] !== d || e[3] !== p || e[4] !== f || e[5] !== o ? (C = !d && /* @__PURE__ */ F("div", { className: "flex items-baseline gap-(--spacing-6)", "data-testid": "asset-status-card-header", children: [
    /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xl) leading-(--font-line-height-28) text-text-default", children: p ? "--" : f }),
    /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-regular) text-(length:--font-size-title-md) leading-(--font-line-height-24) text-text-subtext", children: o })
  ] }), e[2] = d, e[3] = p, e[4] = f, e[5] = o, e[6] = C) : C = e[6];
  let y;
  e[7] !== d || e[8] !== p || e[9] !== l || e[10] !== s || e[11] !== c || e[12] !== r || e[13] !== o || e[14] !== i ? (y = d ? /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ g("div", { className: "shrink-0", children: /* @__PURE__ */ g(xw, { size: Ew[c], unit: o, stableCount: r, watchingCount: i, maintenanceCount: s }) }),
    p ? /* @__PURE__ */ g(nm, { tone: "neutral", title: "No available asset status data. Check back later." }) : /* @__PURE__ */ g(rm, { labels: l, size: c, stableCount: r, watchingCount: i, maintenanceCount: s })
  ] }) : /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ g(mw, { stableCount: r, watchingCount: i, maintenanceCount: s }),
    p ? /* @__PURE__ */ g(nm, { tone: "neutral", title: "No available asset status data. Check back later." }) : /* @__PURE__ */ g(rm, { labels: l, size: c, stableCount: r, watchingCount: i, maintenanceCount: s })
  ] }), e[7] = d, e[8] = p, e[9] = l, e[10] = s, e[11] = c, e[12] = r, e[13] = o, e[14] = i, e[15] = y) : y = e[15];
  let w;
  return e[16] !== v || e[17] !== C || e[18] !== y ? (w = /* @__PURE__ */ F("div", { ref: a, "data-testid": "asset-status-card", className: v, children: [
    C,
    y
  ] }), e[16] = v, e[17] = C, e[18] = y, e[19] = w) : w = e[19], w;
}
const lf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (lf.displayName = "PreviewCardRootContext");
function ks(t) {
  const e = x.useContext(lf);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PreviewCardRootContext is missing. PreviewCard parts must be placed within <PreviewCard.Root>." : et(50));
  return e;
}
const Mw = 600, c0 = 300, Pw = {
  ...us,
  instantType: be((t) => t.instantType),
  hasViewport: be((t) => t.hasViewport)
};
class af extends wr {
  constructor(e) {
    super({
      ...Iw(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new Sr(),
      closeDelayRef: {
        current: c0
      }
    }, Pw);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === At, i = e && o === dr, s = !e && (o === qn || o === vr);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const l = () => {
      const a = {
        open: e
      };
      i ? a.instantType = "focus" : s ? a.instantType = "dismiss" : o === At && (a.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (a.activeTriggerId = c, a.activeTriggerElement = n.trigger ?? null), this.update(a);
    };
    r ? an.flushSync(l) : l();
  };
  static useStore(e, n) {
    const o = It(() => new af(n)).current, r = e ?? o, i = ds({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = i, r;
  }
}
function Iw() {
  return {
    ...cs(),
    instantType: void 0,
    hasViewport: !1
  };
}
function im(t) {
  const {
    open: e,
    defaultOpen: n = !1,
    onOpenChange: o,
    onOpenChangeComplete: r,
    actionsRef: i,
    handle: s,
    triggerId: l,
    defaultTriggerId: a = null,
    children: c
  } = t, u = af.useStore(s?.store, {
    open: n,
    openProp: e,
    activeTriggerId: a,
    triggerIdProp: l
  });
  Nr(() => {
    e === void 0 && u.state.open === !1 && n === !0 && u.update({
      open: !0,
      activeTriggerId: a
    });
  }), u.useControlledProp("openProp", e), u.useControlledProp("triggerIdProp", l), u.useContextCallback("onOpenChange", o), u.useContextCallback("onOpenChangeComplete", r);
  const d = u.useState("open"), f = u.select("floatingRootContext"), p = u.useState("activeTriggerId"), m = u.useState("payload");
  ls(u);
  const {
    forceUnmount: h
  } = as(d, u);
  Ne(() => {
    d && p == null && u.set("payload", void 0);
  }, [u, p, d]);
  const b = x.useCallback(() => {
    u.setOpen(!1, De(os));
  }, [u]);
  x.useImperativeHandle(i, () => ({
    unmount: h,
    close: b
  }), [h, b]);
  const v = Cr(f), {
    getReferenceProps: C,
    getTriggerProps: y,
    getFloatingProps: w
  } = Jn([v]), R = x.useMemo(() => C(), [C]), S = x.useMemo(() => y(), [y]), E = x.useMemo(() => w(), [w]);
  return u.useSyncedValues({
    activeTriggerProps: R,
    inactiveTriggerProps: S,
    popupProps: E
  }), /* @__PURE__ */ g(lf.Provider, {
    value: u,
    children: typeof c == "function" ? c({
      payload: m
    }) : c
  });
}
function Tw(t) {
  return ks(!0) ? /* @__PURE__ */ g(im, {
    ...t
  }) : /* @__PURE__ */ g(rd, {
    children: /* @__PURE__ */ g(im, {
      ...t
    })
  });
}
const cf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (cf.displayName = "PreviewCardPortalContext");
function Ow() {
  const t = x.useContext(cf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Portal> is missing." : et(48));
  return t;
}
const u0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return ks().useState("mounted") || o ? /* @__PURE__ */ g(cf.Provider, {
    value: o,
    children: /* @__PURE__ */ g(ma, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (u0.displayName = "PreviewCardPortal");
const d0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    delay: i,
    closeDelay: s,
    id: l,
    payload: a,
    handle: c,
    style: u,
    ...d
  } = e, f = ks(!0), p = c?.store ?? f;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Trigger> must be either used within a <PreviewCard.Root> component or provided with a handle." : et(89));
  const m = kt(l), h = p.useState("isTriggerActive", m), b = p.useState("isOpenedByTrigger", m), v = p.useState("floatingRootContext"), C = x.useRef(null), y = i ?? Mw, w = s ?? c0, {
    registerTrigger: R,
    isMountedByThisTrigger: S
  } = ss(m, C, p, {
    payload: a
  });
  Ne(() => {
    S && (p.context.closeDelayRef.current = w);
  }, [p, S, w]);
  const E = fs(v, {
    mouseOnly: !0,
    move: !1,
    handleClose: ps(),
    delay: () => ({
      open: y,
      close: w
    }),
    triggerElementRef: C,
    isActiveTrigger: h,
    isClosing: () => p.select("transitionStatus") === "ending"
  }), N = pd(v, {
    delay: y
  }), I = {
    open: b
  }, T = p.useState("triggerProps", S);
  return Le("a", e, {
    state: I,
    ref: [n, R, C],
    props: [E, N.reference, T, {
      id: m
    }, d],
    stateAttributesMapping: br
  });
});
process.env.NODE_ENV !== "production" && (d0.displayName = "PreviewCardTrigger");
const uf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (uf.displayName = "PreviewCardPositionerContext");
function Dw() {
  const t = x.useContext(uf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Popup> and <PreviewCard.Arrow> must be used within the <PreviewCard.Positioner> component" : et(49));
  return t;
}
const f0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = la,
    style: v,
    ...C
  } = e, y = ks(), w = Ow(), R = aa(), S = y.useState("open"), E = y.useState("mounted"), N = y.useState("floatingRootContext"), I = y.useState("instantType"), T = y.useState("transitionStatus"), k = y.useState("hasViewport"), P = oi({
    anchor: i,
    floatingRootContext: N,
    positionMethod: s,
    mounted: E,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h,
    keepMounted: w,
    nodeId: R,
    collisionAvoidance: b,
    adaptiveOrigin: k ? fa : void 0
  }), M = {
    open: S,
    side: P.side,
    align: P.align,
    anchorHidden: P.anchorHidden,
    instant: I
  }, D = si(e, M, {
    styles: P.positionerStyles,
    transitionStatus: T,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !E,
    inert: !S
  });
  return /* @__PURE__ */ g(uf.Provider, {
    value: P,
    children: /* @__PURE__ */ g(od, {
      id: R,
      children: D
    })
  });
});
process.env.NODE_ENV !== "production" && (f0.displayName = "PreviewCardPositioner");
const _w = {
  ...kn,
  ...zt
}, p0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = ks(), {
    side: a,
    align: c
  } = Dw(), u = l.useState("open"), d = l.useState("instantType"), f = l.useState("transitionStatus"), p = l.useState("popupProps"), m = l.useState("floatingRootContext");
  Yt({
    open: u,
    ref: l.context.popupRef,
    onComplete() {
      u && l.context.onOpenChangeComplete?.(!0);
    }
  });
  const h = Ce(() => l.context.closeDelayRef.current);
  return ua(m, {
    closeDelay: h
  }), Le("div", e, {
    state: {
      open: u,
      side: a,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    props: [p, Rr(f), s],
    stateAttributesMapping: _w
  });
});
process.env.NODE_ENV !== "production" && (p0.displayName = "PreviewCardPopup");
const Vw = "z-[var(--z-overlay-popover,180)]", Aw = oe("rounded-(--radius-sm)", "border border-solid border-outline-subtle", "bg-surface-container-lowest", "text-text-default", "shadow-elevation-3", "font-(family-name:--font-family-body)", "origin-(--transform-origin)", "transition-[opacity,transform]", "duration-200", "ease-in-out", "will-change-[opacity,transform]", "[&[data-starting-style]]:scale-95", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:scale-95", "[&[data-ending-style]]:opacity-0");
function Lw(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(Tw, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function Fw(t) {
  const e = W.c(8);
  let n, o, r;
  e[0] !== t ? ({
    render: o,
    delay: r,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? 0 : r;
  let s;
  return e[4] !== i || e[5] !== n || e[6] !== o ? (s = /* @__PURE__ */ g(d0, { render: o, delay: i, ...n }), e[4] = i, e[5] = n, e[6] = o, e[7] = s) : s = e[7], s;
}
function $w(t) {
  const e = W.c(21);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    children: n,
    className: o,
    side: i,
    align: s,
    sideOffset: l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "bottom" : i, c = s === void 0 ? "center" : s, u = l === void 0 ? 8 : l, d = Qt();
  let f;
  e[7] !== o ? (f = oe(Aw, o), e[7] = o, e[8] = f) : f = e[8];
  let p;
  e[9] !== n || e[10] !== f ? (p = /* @__PURE__ */ g(p0, { className: f, children: n }), e[9] = n, e[10] = f, e[11] = p) : p = e[11];
  let m;
  e[12] !== c || e[13] !== r || e[14] !== a || e[15] !== u || e[16] !== p ? (m = /* @__PURE__ */ g(f0, { side: a, align: c, sideOffset: u, className: Vw, ...r, children: p }), e[12] = c, e[13] = r, e[14] = a, e[15] = u, e[16] = p, e[17] = m) : m = e[17];
  let h;
  return e[18] !== d || e[19] !== m ? (h = /* @__PURE__ */ g(u0, { container: d, children: m }), e[18] = d, e[19] = m, e[20] = h) : h = e[20], h;
}
const Hw = {
  operational: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  critical: "bg-datavis-crit-red",
  inactive: "bg-surface-container-high"
}, zw = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], Bw = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
function Ww(t) {
  if (t < 1 || t > 12)
    throw new RangeError(`AssetTimeline requires between 1 and 12 consecutive months. Received ${t}.`);
}
function Uw(t) {
  const e = /* @__PURE__ */ new Date(), n = e.getMonth(), o = e.getFullYear();
  return Array.from({
    length: t
  }, (r, i) => {
    const s = t - i - 1, l = new Date(o, n - s, 1), a = l.getMonth(), c = l.getFullYear();
    return {
      shortLabel: zw[a],
      longLabel: `${Bw[a]} ${c}`,
      key: `${c}-${a}`
    };
  });
}
function m0(t) {
  return t.markerCount ?? t.events?.length ?? 0;
}
function Gw(t) {
  const e = t.reduce((o, r) => (o[r.severity] += 1, o), {
    operational: 0,
    warning: 0,
    critical: 0,
    inactive: 0
  }), n = (o, r) => `${o} ${r} ${o === 1 ? "month" : "months"}`;
  return `Asset timeline: ${n(e.operational, "operational")}, ${n(e.warning, "warning")}, ${n(e.critical, "critical")}, ${n(e.inactive, "inactive")}.`;
}
function sm(t, e) {
  const n = m0(t), o = n === 1 ? "1 event" : `${n} events`;
  return n > 0 ? `${e.longLabel}: ${t.severity}, ${o}` : `${e.longLabel}: ${t.severity}, no events`;
}
function Yw(t) {
  const e = W.c(3), {
    count: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("svg", { "aria-hidden": "true", viewBox: "0 0 8 8", className: "size-(--spacing-8) fill-informative group-focus-visible/asset-timeline-marker:fill-primary-on-primary", children: /* @__PURE__ */ g("path", { d: "M4 8C5.06087 8 6.07828 7.57857 6.82843 6.82843C7.57857 6.07828 8 5.06087 8 4C8 2.93913 7.57857 1.92172 6.82843 1.17157C6.07828 0.421427 5.06087 0 4 0C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4C0 5.06087 0.421427 6.07828 1.17157 6.82843C1.92172 7.57857 2.93913 8 4 8ZM4 2.5C4.39782 2.5 4.77936 2.65804 5.06066 2.93934C5.34196 3.22064 5.5 3.60218 5.5 4C5.5 4.39782 5.34196 4.77936 5.06066 5.06066C4.77936 5.34196 4.39782 5.5 4 5.5C3.60218 5.5 3.22064 5.34196 2.93934 5.06066C2.65804 4.77936 2.5 4.39782 2.5 4C2.5 3.60218 2.65804 3.22064 2.93934 2.93934C3.22064 2.65804 3.60218 2.5 4 2.5Z" }) }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ F("span", { "data-slot": "asset-timeline-marker", className: "inline-flex h-(--spacing-20) min-w-(--spacing-32) items-center justify-center gap-(--spacing-2) rounded-(--radius-xs) border border-outline-subtle bg-surface-container-lowest px-(--spacing-6) font-(family-name:--font-family-label) font-(number:--font-weight-medium) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-default group-hover/asset-timeline-marker:bg-surface-container group-focus-visible/asset-timeline-marker:bg-primary group-focus-visible/asset-timeline-marker:text-primary-on-primary", children: [
    o,
    n
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}
function jw(t) {
  const e = W.c(6), {
    count: n,
    ariaLabel: o,
    onClick: r
  } = t;
  let i;
  e[0] !== n ? (i = /* @__PURE__ */ g(Yw, { count: n }), e[0] = n, e[1] = i) : i = e[1];
  let s;
  return e[2] !== o || e[3] !== r || e[4] !== i ? (s = /* @__PURE__ */ g("button", { type: "button", "aria-label": o, "data-testid": "asset-timeline-event-marker", "data-test-id": "asset-timeline-event-marker", className: "group/asset-timeline-marker cursor-pointer rounded-(--radius-xs) border-0 bg-transparent p-0 outline-none", onClick: r, children: i }), e[2] = o, e[3] = r, e[4] = i, e[5] = s) : s = e[5], s;
}
function Kw(t) {
  const e = W.c(55), {
    month: n,
    meta: o,
    monthIndex: r,
    renderHoverCard: i,
    onMonthClick: s
  } = t, l = m0(n), a = i && n.events?.length ? i : void 0, c = o.shortLabel, u = o.longLabel;
  let d, f, p, m, h, b;
  if (e[0] !== l || e[1] !== a || e[2] !== o || e[3] !== n || e[4] !== r || e[5] !== s) {
    b = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      const y = {
        month: n,
        monthIndex: r,
        monthLabel: c,
        monthLongLabel: u
      }, w = Hw[n.severity];
      let R;
      e[12] !== w ? (R = oe("block h-(--spacing-12) w-full", w), e[12] = w, e[13] = R) : R = e[13];
      let S;
      e[14] !== R ? (S = /* @__PURE__ */ g("span", { "aria-hidden": "true", "data-testid": "asset-timeline-fill", "data-test-id": "asset-timeline-fill", className: R }), e[14] = R, e[15] = S) : S = e[15];
      const E = S;
      let N;
      e[16] !== o.shortLabel ? (N = o.shortLabel.slice(0, 1), e[16] = o.shortLabel, e[17] = N) : N = e[17];
      let I;
      e[18] !== N ? (I = /* @__PURE__ */ g("span", { className: "@min-[48px]/asset-timeline-month:hidden", children: N }), e[18] = N, e[19] = I) : I = e[19];
      let T;
      e[20] !== o.shortLabel ? (T = /* @__PURE__ */ g("span", { className: "hidden @min-[48px]/asset-timeline-month:inline", children: o.shortLabel }), e[20] = o.shortLabel, e[21] = T) : T = e[21];
      let k;
      e[22] !== I || e[23] !== T ? (k = /* @__PURE__ */ F("span", { "aria-hidden": "true", className: "pt-(--spacing-4) font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-20) text-text-subtle", children: [
        I,
        T
      ] }), e[22] = I, e[23] = T, e[24] = k) : k = e[24];
      const P = k, M = l > 0 ? /* @__PURE__ */ g(jw, { count: l, ariaLabel: `${o.longLabel}: ${l} monthly events`, onClick: () => s?.(y) }) : null;
      let D;
      e[25] !== E || e[26] !== a || e[27] !== P || e[28] !== o || e[29] !== n ? (D = a ? /* @__PURE__ */ g(Fw, { delay: 0, closeDelay: 0, render: /* @__PURE__ */ F("button", { type: "button", "aria-label": sm(n, o), className: "group/asset-timeline flex w-full cursor-pointer flex-col items-center rounded-(--radius-xs) border-0 bg-transparent p-0 text-center outline-none", children: [
        E,
        P
      ] }) }) : /* @__PURE__ */ F(Ht, { children: [
        E,
        P
      ] }), e[25] = E, e[26] = a, e[27] = P, e[28] = o, e[29] = n, e[30] = D) : D = e[30];
      const O = D;
      if (!a) {
        let A;
        e[31] !== o || e[32] !== n ? (A = sm(n, o), e[31] = o, e[32] = n, e[33] = A) : A = e[33];
        let L;
        e[34] !== M ? (L = M ? /* @__PURE__ */ g("span", { className: "absolute bottom-(--spacing-40)", children: M }) : null, e[34] = M, e[35] = L) : L = e[35];
        let $;
        e[36] !== L || e[37] !== O ? ($ = /* @__PURE__ */ F("span", { "data-slot": "asset-timeline-month-content", className: "relative flex w-full flex-col items-center pt-(--spacing-24)", children: [
          L,
          O
        ] }), e[36] = L, e[37] = O, e[38] = $) : $ = e[38];
        let Y;
        e[39] !== A || e[40] !== $ ? (Y = /* @__PURE__ */ g("div", { "data-testid": "asset-timeline-month", "data-test-id": "asset-timeline-month", role: "img", "aria-label": A, className: "@container/asset-timeline-month flex w-full min-w-0 flex-col items-center text-center", children: $ }), e[39] = A, e[40] = $, e[41] = Y) : Y = e[41], b = Y;
        break e;
      }
      const _ = {
        ...y,
        month: n
      };
      f = Lw;
      let V;
      e[42] !== M ? (V = M ? /* @__PURE__ */ g("span", { className: "absolute bottom-(--spacing-40)", children: M }) : null, e[42] = M, e[43] = V) : V = e[43], e[44] !== V || e[45] !== O ? (h = /* @__PURE__ */ g("div", { "data-testid": "asset-timeline-month", "data-test-id": "asset-timeline-month", className: "@container/asset-timeline-month flex w-full min-w-0 flex-col items-center text-center", children: /* @__PURE__ */ F("span", { "data-slot": "asset-timeline-month-content", className: "relative flex w-full flex-col items-center pt-(--spacing-24)", children: [
        V,
        O
      ] }) }), e[44] = V, e[45] = O, e[46] = h) : h = e[46], d = $w, p = "w-[280px] overflow-hidden", m = a(_);
    }
    e[0] = l, e[1] = a, e[2] = o, e[3] = n, e[4] = r, e[5] = s, e[6] = d, e[7] = f, e[8] = p, e[9] = m, e[10] = h, e[11] = b;
  } else
    d = e[6], f = e[7], p = e[8], m = e[9], h = e[10], b = e[11];
  if (b !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return b;
  let v;
  e[47] !== d || e[48] !== p || e[49] !== m ? (v = /* @__PURE__ */ g(d, { className: p, children: m }), e[47] = d, e[48] = p, e[49] = m, e[50] = v) : v = e[50];
  let C;
  return e[51] !== f || e[52] !== h || e[53] !== v ? (C = /* @__PURE__ */ F(f, { children: [
    h,
    v
  ] }), e[51] = f, e[52] = h, e[53] = v, e[54] = C) : C = e[54], C;
}
function zO(t) {
  const e = W.c(28);
  let n, o, r, i;
  e[0] !== t ? ({
    months: r,
    ariaLabel: n,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]), Ww(r.length);
  const s = "renderHoverCard" in i ? i.renderHoverCard : void 0, l = "onMonthClick" in i ? i.onMonthClick : void 0;
  let a;
  e[5] !== r.length ? (a = Uw(r.length), e[5] = r.length, e[6] = a) : a = e[6];
  const c = a, u = `repeat(${r.length}, minmax(0, 1fr))`;
  let d;
  e[7] !== u ? (d = {
    gridTemplateColumns: u
  }, e[7] = u, e[8] = d) : d = e[8];
  const f = d;
  let p;
  e[9] !== n || e[10] !== r ? (p = n ?? Gw(r), e[9] = n, e[10] = r, e[11] = p) : p = e[11];
  let m;
  e[12] !== o ? (m = oe("grid w-full min-w-0 items-end gap-x-(--spacing-1)", o), e[12] = o, e[13] = m) : m = e[13];
  let h;
  if (e[14] !== c || e[15] !== r || e[16] !== l || e[17] !== s) {
    let v;
    e[19] !== c || e[20] !== l || e[21] !== s ? (v = (C, y) => /* @__PURE__ */ g(Kw, { month: C, meta: c[y], monthIndex: y, renderHoverCard: s, onMonthClick: l }, c[y].key), e[19] = c, e[20] = l, e[21] = s, e[22] = v) : v = e[22], h = r.map(v), e[14] = c, e[15] = r, e[16] = l, e[17] = s, e[18] = h;
  } else
    h = e[18];
  let b;
  return e[23] !== f || e[24] !== p || e[25] !== m || e[26] !== h ? (b = /* @__PURE__ */ g("section", { "data-testid": "asset-timeline", "data-test-id": "asset-timeline", "aria-label": p, className: m, style: f, children: h }), e[23] = f, e[24] = p, e[25] = m, e[26] = h, e[27] = b) : b = e[27], b;
}
const qw = ae(["w-[min(calc(100vw_-_(var(--spacing-16)_*_2)),var(--modal-size))]", "max-w-(--modal-size)", "min-w-0", "max-h-[calc(100vh_-_var(--spacing-32))]", "flex flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5", "p-(--spacing-20)", "outline-none", "max-[599px]:min-h-[230px]", "max-[599px]:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-[599px]:w-full", "max-[599px]:max-w-none", "max-[599px]:rounded-b-none", "max-[599px]:pb-[calc(var(--spacing-20)_+_env(safe-area-inset-bottom))]"], {
  variants: {
    size: {
      sm: "[--modal-size:320px]",
      md: "[--modal-size:600px]",
      lg: "[--modal-size:1100px]"
    }
  }
}), Zw = ae("shrink-0 mt-(--spacing-20) flex gap-(--spacing-16)", {
  variants: {
    size: {
      sm: ["h-auto", "flex-col-reverse", "items-stretch", "[&>*]:w-full"],
      md: "h-(--spacing-40) items-center justify-end",
      lg: "h-(--spacing-40) items-center justify-end"
    }
  }
}), Xw = ae(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), Qw = ae(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]);
function lm(t) {
  const e = W.c(37), {
    open: n,
    onOpenChange: o,
    title: r,
    description: i,
    dismissible: s,
    size: l,
    children: a,
    footer: c
  } = t, u = s === void 0 ? !0 : s, d = Qt(), f = l ?? "md";
  let p;
  e[0] !== u || e[1] !== o ? (p = (M, D) => {
    if (!u && !M && (D.reason === "escape-key" || D.reason === "outside-press")) {
      D.cancel();
      return;
    }
    o(M);
  }, e[0] = u, e[1] = o, e[2] = p) : p = e[2];
  const m = p, h = !u;
  let b;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ g(Ss, { className: "fixed inset-0 z-50 bg-surface-scrim" }), e[3] = b) : b = e[3];
  let v;
  e[4] !== f ? (v = oe(qw({
    size: f
  })), e[4] = f, e[5] = v) : v = e[5];
  let C;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = oe(Xw()), e[6] = C) : C = e[6];
  let y;
  e[7] !== r ? (y = /* @__PURE__ */ g(Zi, { className: C, children: r }), e[7] = r, e[8] = y) : y = e[8];
  let w;
  e[9] !== u ? (w = u && /* @__PURE__ */ g(qr, { render: /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": "Close", variant: "ghost", size: "sm" }) }), e[9] = u, e[10] = w) : w = e[10];
  let R;
  e[11] !== y || e[12] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-between", children: [
    y,
    w
  ] }), e[11] = y, e[12] = w, e[13] = R) : R = e[13];
  let S;
  e[14] !== i ? (S = i && /* @__PURE__ */ g(qi, { className: oe(Qw()), children: i }), e[14] = i, e[15] = S) : S = e[15];
  let E;
  e[16] !== S || e[17] !== R ? (E = /* @__PURE__ */ F("div", { className: "shrink-0 flex flex-col gap-(--spacing-6)", children: [
    R,
    S
  ] }), e[16] = S, e[17] = R, e[18] = E) : E = e[18];
  let N;
  e[19] !== a ? (N = a && /* @__PURE__ */ g("div", { className: "min-h-0 mt-(--spacing-20) overflow-y-auto", children: a }), e[19] = a, e[20] = N) : N = e[20];
  let I;
  e[21] !== c || e[22] !== f ? (I = c && /* @__PURE__ */ g("div", { className: oe(Zw({
    size: f
  })), children: c }), e[21] = c, e[22] = f, e[23] = I) : I = e[23];
  let T;
  e[24] !== E || e[25] !== N || e[26] !== I || e[27] !== v ? (T = /* @__PURE__ */ g(gi, { className: "fixed inset-0 z-50 flex items-center justify-center max-[599px]:items-end", children: /* @__PURE__ */ F(Rs, { "aria-modal": "true", className: v, children: [
    E,
    N,
    I
  ] }) }), e[24] = E, e[25] = N, e[26] = I, e[27] = v, e[28] = T) : T = e[28];
  let k;
  e[29] !== d || e[30] !== T ? (k = /* @__PURE__ */ F(mi, { container: d, children: [
    b,
    T
  ] }), e[29] = d, e[30] = T, e[31] = k) : k = e[31];
  let P;
  return e[32] !== m || e[33] !== n || e[34] !== k || e[35] !== h ? (P = /* @__PURE__ */ g(Es, { open: n, onOpenChange: m, modal: !0, disablePointerDismissal: h, children: k }), e[32] = m, e[33] = n, e[34] = k, e[35] = h, e[36] = P) : P = e[36], P;
}
const Lr = {
  complete: "complete",
  partial: "partial",
  failed: "failed",
  unknown: "unknown"
}, Oi = {
  complete: "Complete",
  partial: "Partial",
  failed: "Failed",
  unknown: "Unknown"
}, Jw = {
  loadingReleaseInfo: "Loading release info...",
  copyRecord: "Copy record",
  openSsm: "Open SSM",
  openSsmAriaLabel: "Open SSM parameter",
  recordUnavailable: "Record unavailable",
  copyPrefix: "Copy",
  rows: {
    tag: "Tag",
    status: "Status",
    sha: "SHA",
    requestedRef: "Requested ref",
    deployedAt: "Deployed at",
    ssmParameter: "SSM parameter",
    selected: "Selected",
    deployed: "Deployed",
    failed: "Failed",
    terraform: "Terraform",
    api: "API",
    frontend: "Frontend"
  },
  links: {
    githubTag: "GitHub tag",
    githubCommit: "GitHub commit",
    workflowRun: "Workflow run"
  },
  status: Oi,
  values: {
    unknown: "unknown",
    none: "none",
    notSelected: "not selected",
    deployed: "deployed"
  }
}, BO = {
  [Lr.complete]: {
    label: Oi.complete,
    icon: "circle-check",
    iconTone: "positive"
  },
  [Lr.failed]: {
    label: Oi.failed,
    icon: "circle-exclamation",
    iconTone: "negative"
  },
  [Lr.partial]: {
    label: Oi.partial,
    icon: "warning",
    iconTone: "warning"
  },
  [Lr.unknown]: {
    label: Oi.unknown,
    icon: "circle-info",
    iconTone: "neutral"
  }
};
function am(t, e = "unknown") {
  return t ? t.slice(0, 12) : e;
}
function eS(t) {
  return t ?? Lr.unknown;
}
function tS(t, e) {
  return e[t];
}
function nS(t, e) {
  if (!e)
    return "";
  const n = encodeURIComponent(encodeURIComponent(e));
  return `https://${t}.console.aws.amazon.com/systems-manager/parameters/${n}/description?region=${t}`;
}
function oS({
  appName: t,
  environment: e,
  recordParameterName: n,
  commitId: o,
  branchName: r,
  releaseTag: i
}) {
  return {
    app: t,
    environment: e,
    parameterName: n,
    status: Lr.unknown,
    sourceSha: o,
    requestedRef: r,
    releaseTag: i,
    selectedParts: [],
    deployedParts: [],
    failedParts: [],
    parts: {
      terraform: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      api: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      frontend: {
        selected: !1,
        result: "unknown",
        deployed: !1
      }
    }
  };
}
function mc(t, e) {
  return !t || t.length === 0 ? e : t.join(", ");
}
function rS(t, e) {
  if (!t)
    return e;
  const n = new Date(t);
  return Number.isNaN(n.getTime()) ? t : n.toLocaleString();
}
function gc(t, e) {
  return t ? t.selected ? t.deployed ? e.deployed : t.result ?? e.unknown : e.notSelected : e.unknown;
}
const iS = ae([
  "font-(family-name:--font-family-title)",
  "font-(number:--font-weight-medium)",
  "cursor-pointer",
  "select-none",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "rounded-(--radius-sm)",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-(--color-inline-link-focus-ring)",
  "focus-visible:ring-offset-(--spacing-4)",
  // Pressed/active background
  "active:bg-(--color-inline-link-pressed-bg)"
], {
  variants: {
    size: {
      sm: ["text-(length:--font-size-title-sm)", "leading-(--font-line-height-20)"],
      md: ["text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"]
    },
    variant: {
      /**
       * Contextual: triggers a full context change (new page, route, or view).
       * Renders blue; underline appears on hover only.
       */
      contextual: ["text-(--color-inline-link-contextual)", "no-underline", "hover:underline", "underline-offset-4"],
      /**
       * Navigational: reveals information within the current context
       * (drawer, popover, inline expansion). Renders near-black; always underlined.
       */
      navigational: ["text-(--color-inline-link-navigational)", "underline", "underline-offset-4", "hover:text-(--color-inline-link-navigational-hover)"]
    },
    destructive: {
      true: ["text-(--color-text-destructive)", "hover:text-(--color-text-destructive)"]
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none"]
    }
  },
  defaultVariants: {
    size: "md",
    variant: "contextual"
  }
});
function hc(t) {
  const e = W.c(23);
  let n, o, r, i, s, l, a, c, u;
  if (e[0] !== t) {
    const {
      size: p,
      destructive: m,
      disabled: h,
      children: b,
      ...v
    } = t;
    n = b, s = v;
    const C = p === void 0 ? "md" : p, y = m === void 0 ? !1 : m;
    r = h === void 0 ? !1 : h, i = "onClick" in t && t.onClick !== void 0 && !("href" in t && t.href !== void 0), o = iS({
      size: C,
      variant: i ? "navigational" : "contextual",
      destructive: y,
      disabled: r
    });
    const {
      render: w,
      href: R,
      target: S,
      rel: E,
      ...N
    } = i ? {} : s, I = S === "_blank" && !E ? "noopener noreferrer" : E;
    u = Xd, l = "a", a = w, c = en(N, {
      ...R !== void 0 && {
        href: R
      },
      ...S !== void 0 && {
        target: S
      },
      ...I !== void 0 && {
        rel: I
      },
      ...r && {
        href: void 0,
        tabIndex: -1,
        onClick: sS
      },
      "aria-disabled": r || void 0,
      className: o,
      children: n
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9];
  let d;
  e[10] !== l || e[11] !== a || e[12] !== c ? (d = {
    defaultTagName: l,
    render: a,
    props: c
  }, e[10] = l, e[11] = a, e[12] = c, e[13] = d) : d = e[13];
  const f = u(d);
  if (i) {
    const p = s;
    let m, h;
    e[14] !== p ? ({
      onClick: h,
      ...m
    } = p, e[14] = p, e[15] = m, e[16] = h) : (m = e[15], h = e[16]);
    const b = m, v = r ? void 0 : h, C = r || void 0;
    let y;
    return e[17] !== n || e[18] !== o || e[19] !== b || e[20] !== v || e[21] !== C ? (y = /* @__PURE__ */ g("button", { ...b, type: "button", onClick: v, "aria-disabled": C, className: o, children: n }), e[17] = n, e[18] = o, e[19] = b, e[20] = v, e[21] = C, e[22] = y) : y = e[22], y;
  }
  return f;
}
function sS(t) {
  return t.preventDefault();
}
function lS(t) {
  const e = W.c(13), {
    display: n,
    labels: o
  } = t;
  let r;
  e[0] !== n.githubTagUrl || e[1] !== o ? (r = n.githubTagUrl ? /* @__PURE__ */ g(hc, { href: n.githubTagUrl, target: "_blank", rel: "noreferrer", children: o.links.githubTag }) : null, e[0] = n.githubTagUrl, e[1] = o, e[2] = r) : r = e[2];
  let i;
  e[3] !== n.githubCommitUrl || e[4] !== o ? (i = n.githubCommitUrl ? /* @__PURE__ */ g(hc, { href: n.githubCommitUrl, target: "_blank", rel: "noreferrer", children: o.links.githubCommit }) : null, e[3] = n.githubCommitUrl, e[4] = o, e[5] = i) : i = e[5];
  let s;
  e[6] !== n.record.workflowRunUrl || e[7] !== o ? (s = n.record.workflowRunUrl ? /* @__PURE__ */ g(hc, { href: n.record.workflowRunUrl, target: "_blank", rel: "noreferrer", children: o.links.workflowRun }) : null, e[6] = n.record.workflowRunUrl, e[7] = o, e[8] = s) : s = e[8];
  let l;
  return e[9] !== r || e[10] !== i || e[11] !== s ? (l = /* @__PURE__ */ F("div", { className: "flex flex-wrap gap-(--spacing-12)", children: [
    r,
    i,
    s
  ] }), e[9] = r, e[10] = i, e[11] = s, e[12] = l) : l = e[12], l;
}
function On(t) {
  const e = W.c(17), {
    label: n,
    value: o,
    copyValue: r,
    copiedLabel: i,
    copyPrefix: s,
    onCopy: l,
    unknownValue: a,
    noneValue: c
  } = t, u = r ?? o, d = typeof navigator < "u" && !!navigator.clipboard?.writeText, f = !!(u && u !== a && u !== c), p = i === n;
  let m;
  e[0] !== n ? (m = /* @__PURE__ */ g("div", { className: "max-sm:col-span-2", children: /* @__PURE__ */ g(ln, { as: "div", size: "sm", tone: "subtle", children: n }) }), e[0] = n, e[1] = m) : m = e[1];
  const h = o || a;
  let b;
  e[2] !== h ? (b = /* @__PURE__ */ g("code", { className: "min-w-0 truncate rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-4) font-mono text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: h }), e[2] = h, e[3] = b) : b = e[3];
  const v = p ? "check-mark" : "copy-regular", C = `${s} ${n}`, y = !f || !d;
  let w;
  e[4] !== n || e[5] !== l || e[6] !== u ? (w = () => {
    l(u, n);
  }, e[4] = n, e[5] = l, e[6] = u, e[7] = w) : w = e[7];
  let R;
  e[8] !== v || e[9] !== C || e[10] !== y || e[11] !== w ? (R = /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: v, "aria-label": C, disabled: y, onClick: w }), e[8] = v, e[9] = C, e[10] = y, e[11] = w, e[12] = R) : R = e[12];
  let S;
  return e[13] !== m || e[14] !== b || e[15] !== R ? (S = /* @__PURE__ */ F("div", { className: "grid grid-cols-[128px_minmax(0,1fr)_var(--spacing-32)] items-center gap-(--spacing-8) border-b border-outline-subtle py-(--spacing-8) last:border-b-0 max-sm:grid-cols-[1fr_var(--spacing-32)]", children: [
    m,
    b,
    R
  ] }), e[13] = m, e[14] = b, e[15] = R, e[16] = S) : S = e[16], S;
}
function aS(t) {
  const e = W.c(76), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: i
  } = t, s = r.rows.selected;
  let l;
  e[0] !== n.record.selectedParts || e[1] !== r.values.none ? (l = mc(n.record.selectedParts, r.values.none), e[0] = n.record.selectedParts, e[1] = r.values.none, e[2] = l) : l = e[2];
  let a;
  e[3] !== o || e[4] !== r.copyPrefix || e[5] !== r.rows.selected || e[6] !== r.values.none || e[7] !== r.values.unknown || e[8] !== i || e[9] !== l ? (a = /* @__PURE__ */ g(On, { label: s, value: l, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[3] = o, e[4] = r.copyPrefix, e[5] = r.rows.selected, e[6] = r.values.none, e[7] = r.values.unknown, e[8] = i, e[9] = l, e[10] = a) : a = e[10];
  const c = r.rows.deployed;
  let u;
  e[11] !== n.record.deployedParts || e[12] !== r.values.none ? (u = mc(n.record.deployedParts, r.values.none), e[11] = n.record.deployedParts, e[12] = r.values.none, e[13] = u) : u = e[13];
  let d;
  e[14] !== o || e[15] !== r.copyPrefix || e[16] !== r.rows.deployed || e[17] !== r.values.none || e[18] !== r.values.unknown || e[19] !== i || e[20] !== u ? (d = /* @__PURE__ */ g(On, { label: c, value: u, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[14] = o, e[15] = r.copyPrefix, e[16] = r.rows.deployed, e[17] = r.values.none, e[18] = r.values.unknown, e[19] = i, e[20] = u, e[21] = d) : d = e[21];
  const f = r.rows.failed;
  let p;
  e[22] !== n.record.failedParts || e[23] !== r.values.none ? (p = mc(n.record.failedParts, r.values.none), e[22] = n.record.failedParts, e[23] = r.values.none, e[24] = p) : p = e[24];
  let m;
  e[25] !== o || e[26] !== r.copyPrefix || e[27] !== r.rows.failed || e[28] !== r.values.none || e[29] !== r.values.unknown || e[30] !== i || e[31] !== p ? (m = /* @__PURE__ */ g(On, { label: f, value: p, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[25] = o, e[26] = r.copyPrefix, e[27] = r.rows.failed, e[28] = r.values.none, e[29] = r.values.unknown, e[30] = i, e[31] = p, e[32] = m) : m = e[32];
  const h = r.rows.terraform, b = n.record.parts?.terraform;
  let v;
  e[33] !== r.values || e[34] !== b ? (v = gc(b, r.values), e[33] = r.values, e[34] = b, e[35] = v) : v = e[35];
  const C = n.record.parts?.terraform?.sha;
  let y;
  e[36] !== o || e[37] !== r.copyPrefix || e[38] !== r.rows.terraform || e[39] !== r.values.none || e[40] !== r.values.unknown || e[41] !== i || e[42] !== v || e[43] !== C ? (y = /* @__PURE__ */ g(On, { label: h, value: v, copyValue: C, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[36] = o, e[37] = r.copyPrefix, e[38] = r.rows.terraform, e[39] = r.values.none, e[40] = r.values.unknown, e[41] = i, e[42] = v, e[43] = C, e[44] = y) : y = e[44];
  const w = r.rows.api, R = n.record.parts?.api;
  let S;
  e[45] !== r.values || e[46] !== R ? (S = gc(R, r.values), e[45] = r.values, e[46] = R, e[47] = S) : S = e[47];
  const E = n.record.parts?.api?.image ?? n.record.apiImage;
  let N;
  e[48] !== o || e[49] !== r.copyPrefix || e[50] !== r.rows.api || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== i || e[54] !== S || e[55] !== E ? (N = /* @__PURE__ */ g(On, { label: w, value: S, copyValue: E, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[48] = o, e[49] = r.copyPrefix, e[50] = r.rows.api, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = i, e[54] = S, e[55] = E, e[56] = N) : N = e[56];
  const I = r.rows.frontend, T = n.record.parts?.frontend;
  let k;
  e[57] !== r.values || e[58] !== T ? (k = gc(T, r.values), e[57] = r.values, e[58] = T, e[59] = k) : k = e[59];
  const P = n.record.parts?.frontend?.cloudfrontDistributionId ?? n.record.frontendCloudfrontDistributionId;
  let M;
  e[60] !== o || e[61] !== r.copyPrefix || e[62] !== r.rows.frontend || e[63] !== r.values.none || e[64] !== r.values.unknown || e[65] !== i || e[66] !== k || e[67] !== P ? (M = /* @__PURE__ */ g(On, { label: I, value: k, copyValue: P, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[60] = o, e[61] = r.copyPrefix, e[62] = r.rows.frontend, e[63] = r.values.none, e[64] = r.values.unknown, e[65] = i, e[66] = k, e[67] = P, e[68] = M) : M = e[68];
  let D;
  return e[69] !== y || e[70] !== N || e[71] !== M || e[72] !== a || e[73] !== d || e[74] !== m ? (D = /* @__PURE__ */ F("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    a,
    d,
    m,
    y,
    N,
    M
  ] }), e[69] = y, e[70] = N, e[71] = M, e[72] = a, e[73] = d, e[74] = m, e[75] = D) : D = e[75], D;
}
function cS(t) {
  const e = W.c(62), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: i
  } = t;
  let s;
  e[0] !== o || e[1] !== n.displayTag || e[2] !== r.copyPrefix || e[3] !== r.rows.tag || e[4] !== r.values.none || e[5] !== r.values.unknown || e[6] !== i ? (s = /* @__PURE__ */ g(On, { label: r.rows.tag, value: n.displayTag, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[0] = o, e[1] = n.displayTag, e[2] = r.copyPrefix, e[3] = r.rows.tag, e[4] = r.values.none, e[5] = r.values.unknown, e[6] = i, e[7] = s) : s = e[7];
  const l = r.rows.status;
  let a;
  e[8] !== n.status || e[9] !== r.status ? (a = tS(n.status, r.status), e[8] = n.status, e[9] = r.status, e[10] = a) : a = e[10];
  let c;
  e[11] !== o || e[12] !== r.copyPrefix || e[13] !== r.rows.status || e[14] !== r.values.none || e[15] !== r.values.unknown || e[16] !== i || e[17] !== a ? (c = /* @__PURE__ */ g(On, { label: l, value: a, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[11] = o, e[12] = r.copyPrefix, e[13] = r.rows.status, e[14] = r.values.none, e[15] = r.values.unknown, e[16] = i, e[17] = a, e[18] = c) : c = e[18];
  let u;
  e[19] !== o || e[20] !== n.shortSha || e[21] !== n.sourceSha || e[22] !== r.copyPrefix || e[23] !== r.rows.sha || e[24] !== r.values.none || e[25] !== r.values.unknown || e[26] !== i ? (u = /* @__PURE__ */ g(On, { label: r.rows.sha, value: n.shortSha, copyValue: n.sourceSha, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[19] = o, e[20] = n.shortSha, e[21] = n.sourceSha, e[22] = r.copyPrefix, e[23] = r.rows.sha, e[24] = r.values.none, e[25] = r.values.unknown, e[26] = i, e[27] = u) : u = e[27];
  const d = n.record.requestedRef ?? r.values.unknown;
  let f;
  e[28] !== o || e[29] !== r.copyPrefix || e[30] !== r.rows.requestedRef || e[31] !== r.values.none || e[32] !== r.values.unknown || e[33] !== i || e[34] !== d ? (f = /* @__PURE__ */ g(On, { label: r.rows.requestedRef, value: d, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[28] = o, e[29] = r.copyPrefix, e[30] = r.rows.requestedRef, e[31] = r.values.none, e[32] = r.values.unknown, e[33] = i, e[34] = d, e[35] = f) : f = e[35];
  const p = r.rows.deployedAt;
  let m;
  e[36] !== n.record.deployedAt || e[37] !== r.values.unknown ? (m = rS(n.record.deployedAt, r.values.unknown), e[36] = n.record.deployedAt, e[37] = r.values.unknown, e[38] = m) : m = e[38];
  let h;
  e[39] !== o || e[40] !== r.copyPrefix || e[41] !== r.rows.deployedAt || e[42] !== r.values.none || e[43] !== r.values.unknown || e[44] !== i || e[45] !== m ? (h = /* @__PURE__ */ g(On, { label: p, value: m, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[39] = o, e[40] = r.copyPrefix, e[41] = r.rows.deployedAt, e[42] = r.values.none, e[43] = r.values.unknown, e[44] = i, e[45] = m, e[46] = h) : h = e[46];
  let b;
  e[47] !== o || e[48] !== n.parameterName || e[49] !== r.copyPrefix || e[50] !== r.rows.ssmParameter || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== i ? (b = /* @__PURE__ */ g(On, { label: r.rows.ssmParameter, value: n.parameterName, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[47] = o, e[48] = n.parameterName, e[49] = r.copyPrefix, e[50] = r.rows.ssmParameter, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = i, e[54] = b) : b = e[54];
  let v;
  return e[55] !== s || e[56] !== h || e[57] !== b || e[58] !== c || e[59] !== u || e[60] !== f ? (v = /* @__PURE__ */ F("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    s,
    c,
    u,
    f,
    h,
    b
  ] }), e[55] = s, e[56] = h, e[57] = b, e[58] = c, e[59] = u, e[60] = f, e[61] = v) : v = e[61], v;
}
function WO({
  open: t,
  onOpenChange: e,
  appName: n,
  appLabel: o = n,
  labels: r = Jw,
  environment: i = "local",
  branchName: s = "local",
  commitId: l = "local",
  releaseTag: a = "",
  recordParameterName: c = `/assetwatch/deployments/${i}/${n}`,
  record: u,
  isRecordLoading: d = !1,
  isRecordUnavailable: f = !1,
  awsRegion: p = "us-east-2",
  repoFullName: m = "AssetWatch1/fullstack.assetwatch",
  modalTitle: h = `${o} Release Info`,
  modalDescription: b = `Current ${o} release information for this environment.`
}) {
  const [v, C] = tt(null), y = typeof navigator < "u" && !!navigator.clipboard?.writeText;
  async function w(_, V) {
    !_ || !y || (await navigator.clipboard.writeText(_), C(V), window.setTimeout(() => C(null), 1600));
  }
  if (d)
    return /* @__PURE__ */ g(lm, { open: t, onOpenChange: e, title: h, description: b, children: /* @__PURE__ */ F(hr, { gap: 8, children: [
      /* @__PURE__ */ g(Ou, { size: "sm" }),
      /* @__PURE__ */ g(ln, { size: "sm", tone: "subtle", children: r.loadingReleaseInfo })
    ] }) });
  const R = u ?? oS({
    appName: n,
    environment: i,
    recordParameterName: c,
    commitId: l,
    branchName: s,
    releaseTag: a
  }), S = eS(R.status), E = R.releaseTag || a || `${R.environment ?? "local"}-${am(R.sourceSha, r.values.unknown)}`, N = R.sourceSha ?? l, I = am(N, r.values.unknown), T = R.parameterName || c || r.values.unknown, k = nS(p, T), P = JSON.stringify(R, null, 2), M = R.releaseTag ? `https://github.com/${m}/tree/${R.releaseTag}` : "", D = N && N !== "local" ? `https://github.com/${m}/commit/${N}` : "", O = {
    appLabel: o,
    environment: R.environment ?? i,
    status: S,
    displayTag: E,
    sourceSha: N,
    shortSha: I,
    parameterName: T,
    ssmConsoleUrl: k,
    recordJson: P,
    githubTagUrl: M,
    githubCommitUrl: D,
    record: R
  };
  return /* @__PURE__ */ g(lm, { open: t, onOpenChange: e, title: h, description: b, footer: /* @__PURE__ */ F(hr, { gap: 8, children: [
    /* @__PURE__ */ g(An, { variant: "outline", size: "sm", icon: v === "record" ? "check-mark" : "copy-regular", disabled: !y, onClick: () => {
      w(O.recordJson, "record");
    }, children: r.copyRecord }),
    O.ssmConsoleUrl ? /* @__PURE__ */ g(An, { variant: "primary", size: "sm", icon: "arrow-up-right", render: /* @__PURE__ */ g("a", { href: O.ssmConsoleUrl, target: "_blank", rel: "noreferrer", "aria-label": r.openSsmAriaLabel, children: r.openSsm }), children: r.openSsm }) : null
  ] }), children: /* @__PURE__ */ F(Kr, { gap: 16, children: [
    f ? /* @__PURE__ */ g(ln, { size: "sm", tone: "warning", children: r.recordUnavailable }) : null,
    /* @__PURE__ */ g(cS, { display: O, copiedLabel: v, labels: r, onCopy: w }),
    /* @__PURE__ */ g(aS, { display: O, copiedLabel: v, labels: r, onCopy: w }),
    /* @__PURE__ */ g(lS, { display: O, labels: r }),
    /* @__PURE__ */ g("pre", { className: "max-h-[220px] overflow-auto rounded-(--radius-sm) border border-outline-subtle bg-surface-container p-(--spacing-12) text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: O.recordJson })
  ] }) });
}
function uS(t) {
  return t.split(/\s+/).filter(Boolean).slice(0, 2).map((e) => e[0]).join("").toUpperCase();
}
function UO(t) {
  const e = W.c(27), {
    company: n,
    selected: o,
    onSettingsClick: r
  } = t, i = o === void 0 ? !1 : o, {
    collapsed: s,
    closeMobileNavigation: l
  } = i0(), a = n.facilityCount === void 0 ? void 0 : n.facilityCount + (n.facilityCount === 1 ? " facility" : " facilities"), c = `relative flex h-[60px] min-w-0 items-center gap-(--spacing-6) rounded-(--radius-sm) border border-outline-subtle px-(--spacing-10)${i ? " bg-menu-item-selected" : " bg-surface"}${s ? " w-[60px] shrink-0 justify-center" : " w-full"}`, u = n.name;
  let d;
  e[0] !== n.name ? (d = uS(n.name), e[0] = n.name, e[1] = d) : d = e[1];
  let f;
  e[2] !== n.logoUrl || e[3] !== n.name || e[4] !== d ? (f = /* @__PURE__ */ g(Ur, { "aria-label": u, initials: d, src: n.logoUrl, variant: "external" }), e[2] = n.logoUrl, e[3] = n.name, e[4] = d, e[5] = f) : f = e[5];
  let p;
  e[6] !== s || e[7] !== n.name || e[8] !== a || e[9] !== r ? (p = !s && /* @__PURE__ */ F(Ht, { children: [
    /* @__PURE__ */ F("span", { className: "min-w-0 flex-1", children: [
      /* @__PURE__ */ g("span", { className: "block truncate text-(length:--font-size-label-large) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-menu-text-default", children: n.name }),
      a && /* @__PURE__ */ g("span", { className: "block text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-subtle", children: a })
    ] }),
    r && /* @__PURE__ */ g("span", { "aria-hidden": !0, className: "shrink-0", children: /* @__PURE__ */ g(Ge, { name: "settings-cog", size: "sm", tone: "secondary" }) })
  ] }), e[6] = s, e[7] = n.name, e[8] = a, e[9] = r, e[10] = p) : p = e[10];
  let m;
  e[11] !== f || e[12] !== p ? (m = /* @__PURE__ */ F(Ht, { children: [
    f,
    p
  ] }), e[11] = f, e[12] = p, e[13] = m) : m = e[13];
  const h = m;
  if (r) {
    const v = `Open ${n.name} settings`, C = i ? "page" : void 0, y = `${c} cursor-pointer text-left outline-none transition-colors duration-200 ease-in-out ${i ? "hover:bg-menu-item-selected" : "hover:bg-menu-item-hover"} focus-visible:ring-2 focus-visible:ring-menu-focus-ring focus-visible:ring-inset`, w = i || void 0;
    let R;
    e[14] !== l || e[15] !== r ? (R = () => {
      r(), l?.();
    }, e[14] = l, e[15] = r, e[16] = R) : R = e[16];
    let S;
    return e[17] !== h || e[18] !== w || e[19] !== R || e[20] !== v || e[21] !== C || e[22] !== y ? (S = /* @__PURE__ */ g("button", { "aria-label": v, "aria-current": C, className: y, "data-slot": "company-navigation", "data-selected": w, onClick: R, type: "button", children: h }), e[17] = h, e[18] = w, e[19] = R, e[20] = v, e[21] = C, e[22] = y, e[23] = S) : S = e[23], S;
  }
  let b;
  return e[24] !== c || e[25] !== h ? (b = /* @__PURE__ */ g("div", { className: c, "data-slot": "company-navigation", children: h }), e[24] = c, e[25] = h, e[26] = b) : b = e[26], b;
}
const df = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (df.displayName = "ComboboxRootContext");
const ff = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (ff.displayName = "ComboboxFloatingContext");
const pf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (pf.displayName = "ComboboxDerivedItemsContext");
const mf = /* @__PURE__ */ x.createContext("");
process.env.NODE_ENV !== "production" && (mf.displayName = "ComboboxInputValueContext");
function Cn() {
  const t = x.useContext(df);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxRootContext is missing. Combobox parts must be placed within <Combobox.Root>." : et(22));
  return t;
}
function ba() {
  const t = x.useContext(ff);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxFloatingContext is missing. Combobox parts must be placed within <Combobox.Root>." : et(23));
  return t;
}
function Vo() {
  const t = x.useContext(pf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxItemsContext is missing. Combobox parts must be placed within <Combobox.Root>." : et(24));
  return t;
}
function gf() {
  return x.useContext(mf);
}
const g0 = (t, e) => Object.is(t, e);
function mo(t, e, n) {
  return t == null || e == null ? Object.is(t, e) : n(t, e);
}
function h0(t, e, n) {
  return !t || t.length === 0 ? !1 : t.some((o) => o === void 0 ? !1 : mo(e, o, n));
}
function Mo(t, e, n) {
  return !t || t.length === 0 ? -1 : t.findIndex((o) => o === void 0 ? !1 : mo(o, e, n));
}
function b0(t, e, n) {
  return t.filter((o) => !mo(e, o, n));
}
function Ul(t) {
  if (t == null)
    return "";
  if (typeof t == "string")
    return t;
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
}
function hf(t) {
  return t != null && t.length > 0 && typeof t[0] == "object" && t[0] != null && "items" in t[0];
}
function v0(t) {
  if (!Array.isArray(t))
    return t != null && "null" in t;
  const e = t;
  if (hf(e)) {
    for (const n of e)
      for (const o of n.items)
        if (o && o.value == null && o.label != null)
          return !0;
    return !1;
  }
  for (const n of e)
    if (n && n.value == null && n.label != null)
      return !0;
  return !1;
}
function Jt(t, e) {
  if (e && t != null)
    return e(t) ?? "";
  if (t && typeof t == "object") {
    if ("label" in t && t.label != null)
      return String(t.label);
    if ("value" in t)
      return String(t.value);
  }
  return Ul(t);
}
function Un(t, e) {
  return e && t != null ? e(t) ?? "" : t && typeof t == "object" && "value" in t && "label" in t ? Ul(t.value) : Ul(t);
}
function y0(t, e, n) {
  function o() {
    return Jt(t, n);
  }
  if (n && t != null)
    return n(t);
  if (t && typeof t == "object" && "label" in t && t.label != null)
    return t.label;
  if (e && !Array.isArray(e))
    return e[t] ?? o();
  if (Array.isArray(e)) {
    const r = e, i = hf(r) ? r.flatMap((s) => s.items) : r;
    if (t == null || typeof t != "object") {
      const s = i.find((l) => l.value === t);
      return s && s.label != null ? s.label : o();
    }
    if ("value" in t) {
      const s = i.find((l) => l && l.value === t.value);
      if (s && s.label != null)
        return s.label;
    }
  }
  return o();
}
function dS(t, e, n) {
  return t.reduce((o, r, i) => (i > 0 && o.push(", "), o.push(/* @__PURE__ */ g(x.Fragment, {
    children: y0(r, e, n)
  }, i)), o), []);
}
const Te = {
  id: be((t) => t.id),
  labelId: be((t) => t.labelId),
  items: be((t) => t.items),
  selectedValue: be((t) => t.selectedValue),
  hasSelectionChips: be((t) => {
    const e = t.selectedValue;
    return Array.isArray(e) && e.length > 0;
  }),
  hasSelectedValue: be((t) => {
    const {
      selectedValue: e,
      selectionMode: n
    } = t;
    return e == null ? !1 : n === "multiple" && Array.isArray(e) ? e.length > 0 : !0;
  }),
  hasNullItemLabel: be((t, e) => e ? v0(t.items) : !1),
  open: be((t) => t.open),
  mounted: be((t) => t.mounted),
  forceMounted: be((t) => t.forceMounted),
  inline: be((t) => t.inline),
  activeIndex: be((t) => t.activeIndex),
  selectedIndex: be((t) => t.selectedIndex),
  isActive: be((t, e) => t.activeIndex === e),
  isSelected: be((t, e) => {
    const n = t.isItemEqualToValue, o = t.selectedValue;
    return Array.isArray(o) ? o.some((r) => mo(e, r, n)) : mo(e, o, n);
  }),
  transitionStatus: be((t) => t.transitionStatus),
  popupProps: be((t) => t.popupProps),
  inputProps: be((t) => t.inputProps),
  triggerProps: be((t) => t.triggerProps),
  getItemProps: be((t) => t.getItemProps),
  positionerElement: be((t) => t.positionerElement),
  listElement: be((t) => t.listElement),
  triggerElement: be((t) => t.triggerElement),
  inputElement: be((t) => t.inputElement),
  inputGroupElement: be((t) => t.inputGroupElement),
  popupSide: be((t) => t.popupSide),
  openMethod: be((t) => t.openMethod),
  inputInsidePopup: be((t) => t.inputInsidePopup),
  selectionMode: be((t) => t.selectionMode),
  name: be((t) => t.name),
  form: be((t) => t.form),
  disabled: be((t) => t.disabled),
  readOnly: be((t) => t.readOnly),
  required: be((t) => t.required),
  grid: be((t) => t.grid),
  virtualized: be((t) => t.virtualized),
  itemToStringLabel: be((t) => t.itemToStringLabel),
  isItemEqualToValue: be((t) => t.isItemEqualToValue),
  modal: be((t) => t.modal),
  autoHighlight: be((t) => t.autoHighlight),
  submitOnItemClick: be((t) => t.submitOnItemClick)
};
function fS(t, e) {
  return (n, o) => {
    if (n == null)
      return !1;
    const r = Jt(n, e);
    return t.contains(r, o);
  };
}
function pS(t, e, n) {
  return (o, r) => {
    if (o == null)
      return !1;
    if (!r)
      return !0;
    const i = Jt(o, e), s = n != null ? Jt(n, e) : "";
    return s && t.contains(s, r) && s.length === r.length ? !0 : t.contains(i, r);
  };
}
const cm = /* @__PURE__ */ new Map();
function mS(t = {}) {
  const e = {
    usage: "search",
    sensitivity: "base",
    ignorePunctuation: !0,
    ...t
  }, n = `${x0(t.locale)}|${JSON.stringify(e)}`, o = cm.get(n);
  if (o)
    return o;
  const r = new Intl.Collator(t.locale, e), i = {
    contains(s, l, a) {
      if (!l)
        return !0;
      const c = Jt(s, a);
      for (let u = 0; u <= c.length - l.length; u += 1)
        if (r.compare(c.slice(u, u + l.length), l) === 0)
          return !0;
      return !1;
    },
    startsWith(s, l, a) {
      if (!l)
        return !0;
      const c = Jt(s, a);
      return r.compare(c.slice(0, l.length), l) === 0;
    },
    endsWith(s, l, a) {
      if (!l)
        return !0;
      const c = Jt(s, a), u = l.length;
      return c.length >= u && r.compare(c.slice(c.length - u), l) === 0;
    }
  };
  return cm.set(n, i), i;
}
function x0(t) {
  return Array.isArray(t) ? t.map((e) => x0(e)).join(",") : t == null ? "" : String(t);
}
const C0 = mS, w0 = /* @__PURE__ */ Symbol("none"), ir = {
  value: w0,
  index: -1
};
function S0(t) {
  const {
    id: e,
    onOpenChangeComplete: n,
    defaultSelectedValue: o = null,
    selectedValue: r,
    onSelectedValueChange: i,
    defaultInputValue: s,
    inputValue: l,
    open: a,
    defaultOpen: c = !1,
    selectionMode: u = "none",
    onItemHighlighted: d,
    name: f,
    form: p,
    disabled: m = !1,
    readOnly: h = !1,
    required: b = !1,
    inputRef: v,
    grid: C = !1,
    items: y,
    filteredItems: w,
    filter: R,
    openOnInputClick: S = !0,
    autoHighlight: E = !1,
    keepHighlight: N = !1,
    highlightItemOnHover: I = !0,
    loopFocus: T = !0,
    itemToStringLabel: k,
    itemToStringValue: P,
    isItemEqualToValue: M = g0,
    virtualized: D = !1,
    inline: O = !1,
    fillInputOnItemPress: _ = !0,
    modal: V = !1,
    limit: A = -1,
    autoComplete: L = "list",
    formAutoComplete: $,
    locale: Y,
    submitOnItemClick: G = !1
  } = t, {
    clearErrors: j
  } = _o(), {
    setDirty: Z,
    validityData: U,
    shouldValidateOnChange: q,
    setFilled: te,
    name: H,
    disabled: X,
    setTouched: ee,
    setFocused: le,
    validationMode: Q,
    validation: re
  } = tn(), fe = Mr({
    id: e
  }), ne = C0({
    locale: Y
  }), [se, pe] = x.useState(!1), [xe, ce] = x.useState(null), he = x.useRef([]), z = x.useRef([]), J = x.useRef(null), B = x.useRef(null), K = x.useRef(null), ie = x.useRef(null), ge = x.useRef(null), ue = x.useRef(!0), Se = x.useRef(!1), ve = x.useRef(null), de = x.useRef(null), me = x.useRef(null), Re = x.useRef(ir), Ie = x.useRef(null), Pe = x.useRef([]), _e = x.useRef([]), Ye = X || m, qe = H ?? f, $e = u === "multiple", Ee = u === "single", Ve = l !== void 0 || s !== void 0, Me = y !== void 0, He = w !== void 0;
  let ze;
  E === "always" ? ze = "always" : ze = E ? "input-change" : !1;
  const [Oe, wt] = dn({
    controlled: r,
    default: $e ? o ?? Dn : o,
    name: "Combobox",
    state: "selectedValue"
  }), dt = x.useMemo(() => R === null ? () => !0 : R !== void 0 ? R : Ee && !se ? pS(ne, k, Oe) : fS(ne, k), [R, Ee, Oe, se, ne, k]), we = It(() => Ve ? s ?? "" : Ee ? Jt(Oe, k) : "").current, [ke, Ae] = dn({
    controlled: l,
    default: we,
    name: "Combobox",
    state: "inputValue"
  }), [We, it] = dn({
    controlled: a,
    default: c,
    name: "Combobox",
    state: "open"
  }), je = hf(y), ft = xe ?? (ke === "" ? "" : String(ke).trim()), Ze = Ee ? Jt(Oe, k) : "", Ke = Ee && !se && ft !== "" && Ze !== "" && Ze.length === ft.length && ne.contains(Ze, ft), nt = Ke ? "" : ft, st = Me && He && Ke, mt = x.useMemo(() => y ? je ? y.flatMap((Ue) => Ue.items) : y : Dn, [y, je]), ht = x.useMemo(() => {
    if (w && !st)
      return w;
    if (!y)
      return Dn;
    if (je) {
      const Xe = y, vt = [];
      let Et = 0;
      for (const qt of Xe) {
        if (A > -1 && Et >= A)
          break;
        const jt = nt === "" ? qt.items : qt.items.filter((Fs) => dt(Fs, nt, k));
        if (jt.length === 0)
          continue;
        const nr = A > -1 ? A - Et : 1 / 0, Lo = jt.slice(0, nr);
        if (Lo.length > 0) {
          const Fs = {
            ...qt,
            items: Lo
          };
          vt.push(Fs), Et += Lo.length;
        }
      }
      return vt;
    }
    if (nt === "")
      return A > -1 ? mt.slice(0, A) : (
        // The cast here is done as `flatItems` is readonly.
        // valuesRef.current, a mutable ref, can be set to `flatFilteredItems`, which may
        // reference this exact readonly value, creating a mutation risk.
        // However, <Combobox.Item> can never mutate this value as the mutating effect
        // bails early when `items` is provided, and this is only ever returned
        // when `items` is provided due to the early return at the top of this hook.
        mt
      );
    const Ue = [];
    for (const Xe of mt) {
      if (A > -1 && Ue.length >= A)
        break;
      dt(Xe, nt, k) && Ue.push(Xe);
    }
    return Ue;
  }, [w, st, y, je, nt, A, dt, k, mt]), Tt = x.useMemo(() => je ? ht.flatMap((Xe) => Xe.items) : ht, [ht, je]), lt = It(() => new ud({
    id: fe,
    labelId: void 0,
    selectedValue: Oe,
    open: We,
    filter: dt,
    query: ft,
    items: y,
    selectionMode: u,
    listRef: he,
    labelsRef: z,
    popupRef: J,
    emptyRef: ge,
    inputRef: B,
    startDismissRef: K,
    endDismissRef: ie,
    keyboardActiveRef: ue,
    chipsContainerRef: ve,
    clearRef: de,
    valuesRef: Pe,
    allValuesRef: _e,
    selectionEventRef: me,
    name: qe,
    form: p,
    disabled: Ye,
    readOnly: h,
    required: b,
    grid: C,
    isGrouped: je,
    virtualized: D,
    openOnInputClick: S,
    itemToStringLabel: k,
    isItemEqualToValue: M,
    modal: V,
    autoHighlight: ze,
    submitOnItemClick: G,
    hasInputValue: Ve,
    mounted: !1,
    forceMounted: !1,
    transitionStatus: "idle",
    inline: O,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    inputProps: {},
    triggerProps: {},
    positionerElement: null,
    listElement: null,
    triggerElement: null,
    inputElement: null,
    inputGroupElement: null,
    popupSide: null,
    openMethod: null,
    inputInsidePopup: !0,
    onOpenChangeComplete: n || yt,
    // Placeholder callbacks replaced on first render
    setOpen: yt,
    setInputValue: yt,
    setSelectedValue: yt,
    setIndices: yt,
    onItemHighlighted: yt,
    handleSelection: yt,
    getItemProps: () => St,
    forceMount: yt,
    requestSubmit: yt
  })).current, $t = u === "none" ? ke : Oe, to = x.useMemo(() => u === "none" ? $t : Array.isArray(Oe) ? Oe.map((Ue) => Un(Ue, P)) : Un(Oe, P), [$t, P, u, Oe]), bn = Ce(d), Ln = Ce(n), Mn = ye(lt, Te.activeIndex), Pn = ye(lt, Te.selectedIndex), nn = ye(lt, Te.positionerElement), no = ye(lt, Te.listElement), Kt = ye(lt, Te.triggerElement), Fn = ye(lt, Te.inputElement), yi = ye(lt, Te.inputGroupElement), vn = ye(lt, Te.inline), $n = ye(lt, Te.inputInsidePopup), O4 = Ft(Kt), {
    mounted: b1,
    setMounted: D4,
    transitionStatus: Da
  } = Zn(We), {
    openMethod: v1,
    triggerProps: _a
  } = vs(We), _4 = Ce(() => to);
  fi($n ? O4 : B, {
    id: fe,
    value: $t,
    getValue: _4
  });
  const Vs = Ce(() => {
    y ? z.current = Tt.map((Ue) => Jt(Ue, k)) : lt.set("forceMounted", !0);
  }), V4 = x.useRef(Oe);
  Ne(() => {
    Oe !== V4.current && Vs();
  }, [Vs, Oe]);
  const Hn = Ce((Ue) => {
    lt.update(Ue);
    const Xe = Ue.type || "none";
    if (Ue.activeIndex !== void 0)
      if (Ue.activeIndex === null)
        Re.current !== ir && (Re.current = ir, bn(void 0, wi(Xe, void 0, {
          index: -1
        })));
      else {
        const vt = Pe.current[Ue.activeIndex];
        Re.current = {
          value: vt,
          index: Ue.activeIndex
        }, bn(vt, wi(Xe, void 0, {
          index: Ue.activeIndex
        }));
      }
  }), oo = Ce((Ue, Xe) => {
    if (Se.current = Xe.reason === Ho, t.onInputValueChange?.(Ue, Xe), !Xe.isCanceled) {
      if (Xe.reason === _r) {
        const vt = Xe.event, Et = vt.inputType;
        if (vt.type === "compositionend" || Et != null && Et !== "" && Et !== "insertReplacementText") {
          const jt = Ue.trim() !== "";
          jt && pe(!0), Ie.current = {
            hasQuery: jt
          }, jt && ze && lt.state.activeIndex == null && lt.set("activeIndex", 0);
        }
      }
      Ae(Ue);
    }
  }), xi = Ce((Ue, Xe) => {
    if (We !== Ue && (Xe.reason === "escape-key" && Me && Tt.length === 0 && !lt.state.emptyRef.current && Xe.allowPropagation(), t.onOpenChange?.(Ue, Xe), !Xe.isCanceled && (!Ue && se && (Ee ? (vn || ce(ft), ft === "" && pe(!1)) : $e && (vn || $n ? Hn({
      activeIndex: null
    }) : ce(ft), oo("", De(Ho, Xe.event)))), it(Ue), !Ue && $n && (Xe.reason === Io || Xe.reason === ns) && (ee(!0), le(!1), Q === "onBlur")))) {
      const vt = u === "none" ? ke : Oe;
      re.commit(vt);
    }
  }), As = Ce((Ue, Xe) => {
    if (i?.(Ue, Xe), Xe.isCanceled)
      return;
    wt(Ue), (u === "none" && J.current && _ || Ee && !lt.state.inputInsidePopup) && oo(Jt(Ue, k), De(Xe.reason, Xe.event)), Ee && Ue != null && Xe.reason !== _r && se && !vn && ce(ft);
  }), A4 = Ce((Ue, Xe) => {
    let vt = Xe;
    if (vt === void 0) {
      if (Mn === null)
        return;
      vt = Pe.current[Mn];
    }
    const Et = bt(Ue), qt = me.current ?? Ue;
    me.current = null;
    const jt = De(Wo, qt), nr = Et?.closest("a")?.getAttribute("href");
    if (nr) {
      nr.startsWith("#") && xi(!1, jt);
      return;
    }
    if ($e) {
      const Lo = Array.isArray(Oe) ? Oe : [], K4 = h0(Lo, vt, lt.state.isItemEqualToValue) ? b0(Lo, vt, lt.state.isItemEqualToValue) : [...Lo, vt];
      if (As(K4, jt), !(B.current ? B.current.value.trim() !== "" : !1))
        return;
      lt.state.inputInsidePopup ? oo("", De(Ho, jt.event)) : xi(!1, jt);
    } else
      As(vt, jt), xi(!1, jt);
  }), Va = Ce(() => {
    if (!lt.state.submitOnItemClick)
      return;
    const Ue = re.inputRef.current?.form ?? lt.state.inputElement?.form;
    Ue && typeof Ue.requestSubmit == "function" && Ue.requestSubmit();
  }), Aa = Ce(() => {
    if (D4(!1), Ln?.(!1), pe(!1), ce(null), Hn(u === "none" ? {
      activeIndex: null,
      selectedIndex: null
    } : {
      activeIndex: null
    }), $e && B.current && B.current.value !== "" && !Se.current && oo("", De(Ho)), Ee)
      if (lt.state.inputInsidePopup)
        B.current && B.current.value !== "" && oo("", De(Ho));
      else {
        const Ue = Jt(Oe, k);
        B.current && B.current.value !== Ue && oo(Ue, De(Ue === "" ? Ho : Pt));
      }
  }), L4 = x.useMemo(() => vn && nn ? {
    current: nn.closest('[role="dialog"]')
  } : J, [vn, nn]);
  Yt({
    enabled: !t.actionsRef,
    open: We,
    ref: L4,
    onComplete() {
      We || Aa();
    }
  }), x.useImperativeHandle(t.actionsRef, () => ({
    unmount: Aa
  }), [Aa]), Ne(function() {
    if (We || u === "none")
      return;
    const Xe = y ? mt : _e.current;
    if ($e) {
      const vt = Array.isArray(Oe) ? Oe : [], Et = vt[vt.length - 1], qt = Mo(Xe, Et, M);
      Hn({
        selectedIndex: qt === -1 ? null : qt
      });
    } else {
      const vt = Mo(Xe, Oe, M);
      Hn({
        selectedIndex: vt === -1 ? null : vt
      });
    }
  }, [We, Oe, y, u, mt, $e, M, Hn]), Ne(() => {
    y && (Pe.current = Tt, he.current.length = Tt.length);
  }, [y, Tt]), Ne(() => {
    const Ue = Ie.current;
    if (Ue && (Ue.hasQuery ? ze && lt.set("activeIndex", 0) : ze === "always" && lt.set("activeIndex", 0), Ie.current = null), !We && !vn)
      return;
    const vt = Me || He ? Tt : Pe.current, Et = lt.state.activeIndex;
    if (Et == null) {
      if (ze === "always" && vt.length > 0) {
        lt.set("activeIndex", 0);
        return;
      }
      Re.current !== ir && (Re.current = ir, lt.state.onItemHighlighted(void 0, wi(Pt, void 0, {
        index: -1
      })));
      return;
    }
    if (Et >= vt.length) {
      Re.current !== ir && (Re.current = ir, lt.state.onItemHighlighted(void 0, wi(Pt, void 0, {
        index: -1
      }))), lt.set("activeIndex", null);
      return;
    }
    const qt = vt[Et], jt = Re.current.value, nr = jt !== w0 && mo(qt, jt, lt.state.isItemEqualToValue);
    (Re.current.index !== Et || !nr) && (Re.current = {
      value: qt,
      index: Et
    }, lt.state.onItemHighlighted(qt, wi(Pt, void 0, {
      index: Et
    })));
  }, [Mn, ze, He, Me, Tt, vn, We, lt]), Ne(() => {
    if (u === "none") {
      te(String(ke) !== "");
      return;
    }
    te($e ? Array.isArray(Oe) && Oe.length > 0 : Oe != null);
  }, [te, u, ke, Oe, $e]), x.useEffect(() => {
    Me && ze && Tt.length === 0 && Hn({
      activeIndex: null
    });
  }, [Me, ze, Tt.length, Hn]), wo(ft, () => {
    !We || ft === "" || ft === String(we) || pe(!0);
  }), wo(Oe, () => {
    if (u !== "none" && (j(qe), Z(Oe !== U.initialValue), q() ? re.commit(Oe) : re.commit(Oe, !0), Ee && !Ve && !$n)) {
      const Ue = Jt(Oe, k);
      ke !== Ue && oo(Ue, De(Pt));
    }
  }), wo(ke, () => {
    u === "none" && (j(qe), Z(ke !== U.initialValue), q() ? re.commit(ke) : re.commit(ke, !0));
  }), wo(y, () => {
    if (!Ee || Ve || $n || se)
      return;
    const Ue = Jt(Oe, k);
    ke !== Ue && oo(Ue, De(Pt));
  });
  const Ls = fd({
    open: vn ? !0 : We,
    onOpenChange: xi,
    elements: {
      reference: $n ? Kt : Fn,
      floating: nn
    }
  });
  let La, Fa;
  vn || (La = C ? "grid" : "listbox", Fa = We ? "true" : "false");
  const F4 = x.useMemo(() => {
    const Ue = Fn?.tagName === "INPUT", Xe = Fn == null || Ue, vt = Xe || We, Et = Xe ? {
      autoComplete: "off",
      spellCheck: "false",
      autoCorrect: "off",
      autoCapitalize: "none"
    } : {};
    return vt && (Et.role = "combobox", Et["aria-expanded"] = Fa, Et["aria-haspopup"] = La, Et["aria-controls"] = We ? no?.id : void 0, Et["aria-autocomplete"] = L), {
      reference: Et,
      floating: {
        role: "presentation"
      }
    };
  }, [Fn, We, Fa, La, no?.id, L]), $4 = xr(Ls, {
    enabled: !h && !Ye && S,
    event: "mousedown-only",
    toggle: !1,
    // Apply a small delay for touch to let mobile viewport/keyboard positioning settle.
    // This avoids top-bottom flip flickers if the preferred position is "top" when first tapping.
    touchOpenDelay: $n ? 0 : 100,
    reason: $g
  }), H4 = Cr(Ls, {
    enabled: !h && !Ye && !vn,
    outsidePressEvent: {
      mouse: "sloppy",
      // The visual viewport (affected by the mobile software keyboard) can be
      // somewhat small. The user may want to scroll the screen to see more of
      // the popup.
      touch: "intentional"
    },
    // Without a popup, let the Escape key bubble the event up to other popups' handlers.
    bubbles: vn ? !0 : void 0,
    outsidePress(Ue) {
      const Xe = bt(Ue);
      return !Fe(Kt, Xe) && !Fe(de.current, Xe) && !Fe(ve.current, Xe) && !Fe(yi, Xe);
    }
  }), z4 = gd(Ls, {
    enabled: !h && !Ye,
    id: fe,
    listRef: he,
    activeIndex: Mn,
    selectedIndex: Pn,
    virtual: !0,
    loopFocus: T,
    allowEscape: T && !ze,
    focusItemOnOpen: se || u === "none" && !ze ? !1 : "auto",
    focusItemOnHover: I,
    resetOnPointerLeave: !N,
    // `cols` > 1 enables grid navigation.
    // Since <Combobox.Row> infers column sizes (and is required when building a grid),
    // it works correctly even with a value of `2`.
    // Floating UI tests don't require `role="row"` wrappers, so retains the number API.
    cols: C ? 2 : 1,
    orientation: C ? "horizontal" : void 0,
    disabledIndices: Dn,
    onNavigate(Ue, Xe) {
      !Xe && !We || Da === "ending" || Hn(Xe ? {
        activeIndex: Ue,
        type: ue.current ? "keyboard" : "pointer"
      } : {
        activeIndex: Ue
      });
    }
  }), {
    getReferenceProps: $a,
    getFloatingProps: Ha,
    getItemProps: za
  } = Jn([F4, $4, H4, z4]);
  Nr(() => {
    lt.update({
      inline: O,
      popupProps: Ha(),
      inputProps: $a(),
      triggerProps: _a,
      getItemProps: za,
      setOpen: xi,
      setInputValue: oo,
      setSelectedValue: As,
      setIndices: Hn,
      onItemHighlighted: bn,
      handleSelection: A4,
      forceMount: Vs,
      requestSubmit: Va
    });
  }), Ne(() => {
    lt.update({
      id: fe,
      selectedValue: Oe,
      open: We,
      mounted: b1,
      transitionStatus: Da,
      items: y,
      inline: O,
      popupProps: Ha(),
      inputProps: $a(),
      triggerProps: _a,
      openMethod: v1,
      getItemProps: za,
      selectionMode: u,
      name: qe,
      form: p,
      disabled: Ye,
      readOnly: h,
      required: b,
      grid: C,
      isGrouped: je,
      virtualized: D,
      onOpenChangeComplete: Ln,
      openOnInputClick: S,
      itemToStringLabel: k,
      modal: V,
      autoHighlight: ze,
      isItemEqualToValue: M,
      submitOnItemClick: G,
      hasInputValue: Ve,
      requestSubmit: Va
    });
  }, [lt, fe, Oe, We, b1, Da, y, Ha, $a, za, v1, _a, u, qe, Ye, h, b, re, C, je, D, Ln, S, k, V, M, G, Ve, O, Va, ze, p]);
  const B4 = fn(v, re.inputRef), W4 = x.useMemo(() => ({
    query: ft,
    hasItems: Me,
    filteredItems: ht,
    flatFilteredItems: Tt
  }), [ft, Me, ht, Tt]), U4 = x.useMemo(() => Array.isArray($t) ? "" : Un($t, P), [$t, P]), G4 = $e && Array.isArray(Oe) && Oe.length > 0, Ba = $e || u === "none" ? void 0 : qe, Y4 = x.useMemo(() => !$e || !Array.isArray(Oe) || !qe ? null : Oe.map((Ue) => {
    const Xe = Un(Ue, P);
    return /* @__PURE__ */ g("input", {
      type: "hidden",
      form: p,
      name: qe,
      value: Xe
    }, Xe);
  }), [$e, Oe, p, qe, P]), j4 = /* @__PURE__ */ F(x.Fragment, {
    children: [t.children, /* @__PURE__ */ g("input", {
      ...re.getInputValidationProps({
        // Move focus when the hidden input is focused.
        onFocus() {
          if ($n) {
            Kt?.focus();
            return;
          }
          (B.current || Kt)?.focus();
        },
        // Handle browser autofill.
        onChange(Ue) {
          if (Ue.nativeEvent.defaultPrevented)
            return;
          const Xe = Ue.currentTarget.value, vt = De(Pt, Ue.nativeEvent);
          function Et() {
            if ($e)
              return;
            if (u === "none") {
              Z(Xe !== U.initialValue), oo(Xe, vt), q() && re.commit(Xe);
              return;
            }
            const qt = Pe.current.find((jt) => Un(jt, P).toLowerCase() === Xe.toLowerCase() || Jt(jt, k).toLowerCase() === Xe.toLowerCase());
            qt != null && (Z(qt !== U.initialValue), As?.(qt, vt), q() && re.commit(qt));
          }
          y ? Et() : (Vs(), queueMicrotask(Et));
        }
      }),
      id: fe && Ba == null ? `${fe}-hidden-input` : void 0,
      form: p,
      name: Ba,
      autoComplete: $,
      disabled: Ye,
      required: b && !G4,
      readOnly: h,
      value: U4,
      ref: B4,
      style: Ba ? ei : Jo,
      tabIndex: -1,
      "aria-hidden": !0,
      suppressHydrationWarning: !0
    }), Y4]
  });
  return /* @__PURE__ */ g(df.Provider, {
    value: lt,
    children: /* @__PURE__ */ g(ff.Provider, {
      value: Ls,
      children: /* @__PURE__ */ g(pf.Provider, {
        value: W4,
        children: /* @__PURE__ */ g(mf.Provider, {
          value: ke,
          children: j4
        })
      })
    })
  });
}
function bf(t) {
  const {
    multiple: e = !1,
    defaultValue: n,
    value: o,
    onValueChange: r,
    autoComplete: i,
    ...s
  } = t;
  return /* @__PURE__ */ g(S0, {
    ...s,
    selectionMode: e ? "multiple" : "single",
    selectedValue: o,
    defaultSelectedValue: n,
    onSelectedValueChange: r,
    formAutoComplete: i
  });
}
function vf(t, e) {
  return t ?? e;
}
const yf = {
  ...zi,
  ...eo,
  popupSide: (t) => t ? {
    "data-popup-side": t
  } : null,
  listEmpty: (t) => t ? {
    "data-list-empty": ""
  } : null
}, xf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (xf.displayName = "ComboboxChipsContext");
function R0() {
  return x.useContext(xf);
}
const Cf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cf.displayName = "ComboboxPositionerContext");
function wf(t) {
  const e = x.useContext(Cf);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Popup> and <Combobox.Arrow> must be used within the <Combobox.Positioner> component" : et(21));
  return e;
}
const Sf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const o = Cn(), {
    buttonRef: r,
    getButtonProps: i
  } = Bt({
    native: !1
  }), s = fn(n, r), l = Ce((c) => {
    o.state.setOpen(!1, De(Fg, c.nativeEvent, c.currentTarget));
  }), a = i({
    onClick: l
  });
  return /* @__PURE__ */ g("span", {
    ref: s,
    ...a,
    "aria-label": "Dismiss",
    tabIndex: void 0,
    style: ei
  });
});
process.env.NODE_ENV !== "production" && (Sf.displayName = "ComboboxInternalDismissButton");
const Ms = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    id: s,
    style: l,
    ...a
  } = e, {
    state: c,
    disabled: u,
    setTouched: d,
    setFocused: f,
    validationMode: p,
    validation: m
  } = tn(), {
    labelId: h
  } = gn(), b = R0(), C = !!wf(!0), y = Cn(), {
    filteredItems: w
  } = Vo(), R = gf(), S = bs(), E = ye(y, Te.required), N = ye(y, Te.disabled), I = ye(y, Te.readOnly), T = ye(y, Te.name), k = ye(y, Te.form), P = ye(y, Te.selectionMode), M = ye(y, Te.autoHighlight), D = ye(y, Te.inputProps), O = ye(y, Te.triggerProps), _ = ye(y, Te.open), V = ye(y, Te.mounted), A = ye(y, Te.selectedValue), L = ye(y, Te.popupSide), $ = ye(y, Te.positionerElement), Y = ye(y, Te.id), G = ye(y, Te.inline), j = ye(y, Te.modal), Z = !!M, U = V && $ ? L : null, q = u || N || i, te = w.length === 0, H = C || G, X = !H || j, ee = kt(s ?? (H ? void 0 : Y)), le = vf(h, void 0), Q = C ? Vr : c, [re, fe] = x.useState(null), ne = x.useRef(!1), se = x.useRef(null), pe = x.useRef(!1), xe = Ce((B) => {
    const K = C || y.state.inline;
    K && !y.state.hasInputValue && y.state.setInputValue("", De(Pt)), y.update({
      inputElement: B,
      inputInsidePopup: K
    });
  }), ce = C || !m ? a : m.getValidationProps(a), he = {
    ...Q,
    open: _,
    disabled: q,
    readOnly: I,
    popupSide: U,
    listEmpty: te
  };
  function z(B) {
    if (!b)
      return;
    let K;
    const {
      highlightedChipIndex: ie
    } = b, ge = b.chipsRef.current.length;
    if (ie !== void 0) {
      if (B.key === "ArrowLeft")
        B.preventDefault(), ie > 0 ? K = ie - 1 : K = void 0;
      else if (B.key === "ArrowRight")
        B.preventDefault(), ie < ge - 1 ? K = ie + 1 : K = void 0;
      else if (B.key === "Backspace" || B.key === "Delete") {
        B.preventDefault();
        const ue = ie >= A.length - 1 ? A.length - 2 : ie;
        K = ue >= 0 ? ue : void 0, y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: "keyboard"
        });
      }
      return K;
    }
    return B.key === "ArrowLeft" && (B.currentTarget.selectionStart ?? 0) === 0 && A.length > 0 ? (B.preventDefault(), K = ge > 0 ? ge - 1 : void 0) : B.key === "Backspace" && B.currentTarget.value === "" && A.length > 0 && (y.state.setIndices({
      activeIndex: null,
      selectedIndex: null,
      type: "keyboard"
    }), B.preventDefault()), K;
  }
  const J = Le("input", e, {
    state: he,
    ref: [n, y.state.inputRef, xe],
    props: [D, O, {
      type: "text",
      value: e.value ?? re ?? R,
      "aria-readonly": I || void 0,
      "aria-required": E || void 0,
      "aria-labelledby": le,
      disabled: q,
      readOnly: I,
      required: P === "none" ? E : void 0,
      form: k,
      ...P === "none" && T && {
        name: T
      },
      id: ee,
      onFocus() {
        if (f(!0), !G || !pe.current)
          return;
        pe.current = !1;
        const B = se.current;
        B == null || // `valuesRef` can be sparse, so guard against restoring a removed slot.
        !Object.hasOwn(y.state.valuesRef.current, B) || y.state.setIndices({
          activeIndex: B
        });
      },
      onBlur() {
        d(!0), f(!1);
        const B = y.state.activeIndex;
        if (G && B !== null && M !== "always" && (se.current = B, pe.current = !0, y.state.setIndices({
          activeIndex: null
        })), p === "onBlur") {
          const K = P === "none" ? R : A;
          m.commit(K);
        }
      },
      onCompositionStart(B) {
        Bi || (ne.current = !0, fe(B.currentTarget.value));
      },
      onCompositionEnd(B) {
        ne.current = !1;
        const K = B.currentTarget.value;
        fe(null), y.state.setInputValue(K, De(_r, B.nativeEvent));
      },
      onChange(B) {
        const K = B.nativeEvent.inputType, ie = !K || K === "insertReplacementText", ge = ne.current || !ie;
        if (ne.current) {
          const de = B.currentTarget.value;
          fe(de), de === "" && !y.state.openOnInputClick && !y.state.inputInsidePopup && y.state.setOpen(!1, De(Ho, B.nativeEvent));
          const me = de.trim(), Re = Z && me !== "";
          !I && !q && me && ge && (y.state.setOpen(!0, De(_r, B.nativeEvent)), Z || y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          })), _ && y.state.activeIndex !== null && !Re && y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          });
          return;
        }
        y.state.setInputValue(B.currentTarget.value, De(_r, B.nativeEvent));
        const ue = B.currentTarget.value === "", Se = De(Ho, B.nativeEvent);
        ue && !y.state.inputInsidePopup && (P === "single" && y.state.setSelectedValue(null, Se), y.state.openOnInputClick || y.state.setOpen(!1, Se));
        const ve = B.currentTarget.value.trim();
        !I && !q && ve && ge && (y.state.setOpen(!0, De(_r, B.nativeEvent)), Z || y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        })), _ && y.state.activeIndex !== null && !Z && y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        });
      },
      onKeyDown(B) {
        if (q || I || B.ctrlKey || B.shiftKey || B.altKey || B.metaKey)
          return;
        y.state.keyboardActiveRef.current = !0;
        const K = B.currentTarget, ie = K.scrollWidth - K.clientWidth, ge = S === "rtl";
        if (B.key === "Home") {
          Lt(B);
          const ve = _1 && ge ? K.value.length : 0;
          K.setSelectionRange(ve, ve), K.scrollLeft = 0;
          return;
        }
        if (B.key === "End") {
          Lt(B);
          const ve = _1 && ge ? 0 : K.value.length;
          K.setSelectionRange(ve, ve), K.scrollLeft = ge ? -ie : ie;
          return;
        }
        if (!V && B.key === "Escape") {
          const ve = P === "multiple" && Array.isArray(A) ? A.length === 0 : A === null, de = De(vr, B.nativeEvent), me = P === "multiple" ? [] : null;
          y.state.setInputValue("", de), y.state.setSelectedValue(me, de), !ve && !y.state.inline && !de.isPropagationAllowed && B.stopPropagation();
          return;
        }
        if (b && B.key === "Backspace" && K.value === "" && b.highlightedChipIndex === void 0 && Array.isArray(A) && A.length > 0) {
          const ve = b.chipsRef.current.length, de = ve > 0 ? ve - 1 : A.length - 1, me = A.filter((Re, Ie) => Ie !== de);
          y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          }), y.state.setSelectedValue(me, De(Pt, B.nativeEvent));
          return;
        }
        const ue = b?.highlightedChipIndex !== void 0, Se = z(B);
        if (b?.setHighlightedChipIndex(Se), Se !== void 0 ? b?.chipsRef.current[Se]?.focus() : ue && y.state.inputRef.current?.focus(), B.which !== 229 && B.key === "Enter" && _) {
          const ve = y.state.activeIndex, de = B.nativeEvent;
          if (ve === null) {
            if (G)
              return;
            y.state.setOpen(!1, De(Pt, de));
            return;
          }
          Lt(B);
          const me = y.state.listRef.current[ve];
          me && (y.state.selectionEventRef.current = de, me.click(), y.state.selectionEventRef.current = null);
        }
      },
      onPointerMove() {
        y.state.keyboardActiveRef.current = !1;
      },
      onPointerDown() {
        y.state.keyboardActiveRef.current = !1;
      }
    }, ce],
    stateAttributesMapping: yf
  });
  return /* @__PURE__ */ F(x.Fragment, {
    children: [_ && X && /* @__PURE__ */ g(Sf, {
      ref: y.state.startDismissRef
    }), J]
  });
});
process.env.NODE_ENV !== "production" && (Ms.displayName = "ComboboxInput");
function E0(t, e, n, o, r) {
  if (t.baseUIHandlerPrevented || o)
    return;
  const i = bt(t.nativeEvent), s = pt(i) ? i : null;
  s !== t.currentTarget && (r?.(s) || nh(s)) || (t.preventDefault(), !n && (e.state.inputRef.current?.focus(), e.state.openOnInputClick && e.state.setOpen(!0, De($g, t.nativeEvent))));
}
const va = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = tn(), a = Cn(), {
    filteredItems: c
  } = Vo(), u = ye(a, Te.open), d = ye(a, Te.mounted), f = ye(a, Te.popupSide), p = ye(a, Te.positionerElement), m = ye(a, Te.disabled), h = ye(a, Te.readOnly), b = ye(a, Te.hasSelectedValue), v = ye(a, Te.selectionMode), C = d && p ? f : null, y = m, w = c.length === 0, S = {
    ...l,
    open: u,
    disabled: y,
    readOnly: h,
    popupSide: C,
    listEmpty: w,
    placeholder: v === "none" ? !1 : !b
  }, E = Ce((N) => {
    a.set("inputGroupElement", N);
  });
  return Le("div", e, {
    ref: [n, E],
    props: [{
      role: "group",
      onMouseDown(N) {
        E0(N, a, y, h, (I) => Fe(a.state.chipsContainerRef.current, I));
      }
    }, s],
    state: S,
    stateAttributesMapping: yf
  });
});
process.env.NODE_ENV !== "production" && (va.displayName = "ComboboxInputGroup");
const rl = 2, ya = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    nativeButton: i = !0,
    disabled: s = !1,
    id: l,
    style: a,
    ...c
  } = e, {
    state: u,
    disabled: d,
    setTouched: f,
    setFocused: p,
    validationMode: m,
    validation: h
  } = tn(), {
    labelId: b
  } = gn(), v = Cn(), {
    filteredItems: C
  } = Vo(), y = ye(v, Te.selectionMode), w = ye(v, Te.disabled), R = ye(v, Te.readOnly), S = ye(v, Te.required), E = ye(v, Te.mounted), N = ye(v, Te.popupSide), I = ye(v, Te.positionerElement), T = ye(v, Te.listElement), k = ye(v, Te.triggerProps), P = ye(v, Te.triggerElement), M = ye(v, Te.inputInsidePopup), D = ye(v, Te.id), O = ye(v, Te.labelId), _ = ye(v, Te.open), V = ye(v, Te.selectedValue), A = ye(v, Te.activeIndex), L = ye(v, Te.selectedIndex), $ = ye(v, Te.hasSelectedValue), Y = ba(), G = gf(), j = Dt(), Z = d || w || s, U = C.length === 0, q = E && I ? N : null;
  Mr({
    id: M ? l : void 0
  });
  const te = M ? l ?? D : l, H = vf(b, O), X = x.useRef("");
  function ee(ce) {
    X.current = ce.pointerType;
  }
  const le = Y.useState("domReferenceElement");
  x.useEffect(() => {
    M && P && P !== le && Y.set("domReferenceElement", P);
  }, [P, le, Y, M]);
  const {
    reference: Q
  } = bd(Y, {
    enabled: !_ && !R && !w && y === "single",
    listRef: v.state.labelsRef,
    activeIndex: A,
    selectedIndex: L,
    onMatch(ce) {
      const he = v.state.valuesRef.current[ce];
      he !== void 0 && v.state.setSelectedValue(he, De("none"));
    }
  }), {
    reference: re
  } = xr(Y, {
    enabled: !R && !w,
    event: "mousedown"
  }), {
    buttonRef: fe,
    getButtonProps: ne
  } = Bt({
    native: i,
    disabled: Z
  }), se = {
    ...u,
    open: _,
    disabled: Z,
    popupSide: q,
    listEmpty: U,
    placeholder: y === "none" ? !1 : !$
  }, pe = Ce((ce) => {
    v.set("triggerElement", ce);
  });
  return Le("button", e, {
    ref: [n, fe, pe],
    state: se,
    props: [k, re, Q, {
      id: te,
      tabIndex: M ? 0 : -1,
      role: M ? "combobox" : void 0,
      "aria-expanded": _ ? "true" : "false",
      "aria-haspopup": M ? "dialog" : "listbox",
      "aria-controls": _ ? T?.id : void 0,
      "aria-required": M && S || void 0,
      "aria-labelledby": H,
      onPointerDown: ee,
      onPointerEnter: ee,
      onFocus() {
        p(!0), !(Z || R) && j.start(0, v.state.forceMount);
      },
      onBlur(ce) {
        if (!Fe(I, ce.relatedTarget) && (f(!0), p(!1), m === "onBlur")) {
          const he = y === "none" ? G : V;
          h.commit(he);
        }
      },
      onMouseDown(ce) {
        if (Z || R || (M || Y.set("domReferenceElement", ce.currentTarget), v.state.forceMount(), X.current !== "touch" && (v.state.inputRef.current?.focus(), M || ce.preventDefault()), _))
          return;
        const he = Je(ce.currentTarget);
        function z(J) {
          if (!P)
            return;
          const B = bt(J), K = v.state.positionerElement, ie = v.state.listElement;
          if (Fe(P, B) || Fe(K, B) || Fe(ie, B) || B === P)
            return;
          const ge = Rd(P), ue = J.clientX >= ge.left - rl && J.clientX <= ge.right + rl, Se = J.clientY >= ge.top - rl && J.clientY <= ge.bottom + rl;
          ue && Se || v.state.setOpen(!1, De("cancel-open", J));
        }
        M && he.addEventListener("mouseup", z, {
          once: !0
        });
      },
      onKeyDown(ce) {
        Z || R || (ce.key === "ArrowDown" || ce.key === "ArrowUp") && (Lt(ce), v.state.setOpen(!0, De(Fr, ce.nativeEvent)), v.state.inputRef.current?.focus());
      }
    }, h ? h.getValidationProps(c) : c, ne],
    stateAttributesMapping: yf
  });
});
process.env.NODE_ENV !== "production" && (ya.displayName = "ComboboxTrigger");
const Rf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Rf.displayName = "GroupCollectionContext");
function gS() {
  return x.useContext(Rf);
}
function hS(t) {
  const {
    children: e,
    items: n
  } = t, o = x.useMemo(() => ({
    items: n
  }), [n]);
  return /* @__PURE__ */ g(Rf.Provider, {
    value: o,
    children: e
  });
}
function N0(t) {
  const {
    children: e
  } = t, {
    filteredItems: n
  } = Vo(), o = gS(), r = o ? o.items : n;
  return r ? /* @__PURE__ */ g(x.Fragment, {
    children: r.map(e)
  }) : null;
}
const Ps = /* @__PURE__ */ x.forwardRef(function(e, n) {
  var o;
  const {
    render: r,
    className: i,
    style: s,
    children: l,
    ...a
  } = e, c = Cn(), u = ba(), d = !!wf(!0), {
    filteredItems: f,
    hasItems: p
  } = Vo(), m = ye(c, Te.selectionMode), h = ye(c, Te.grid), b = ye(c, Te.popupProps), v = ye(c, Te.virtualized), C = m === "multiple", y = f.length === 0, w = Ce((T) => {
    c.set("positionerElement", T);
  }), R = Ce((T) => {
    c.set("listElement", T);
  }), S = x.useMemo(() => typeof l == "function" ? o || (o = /* @__PURE__ */ g(N0, {
    children: l
  })) : l, [l]), E = {
    empty: y
  }, N = u.useState("floatingId"), I = Le("div", e, {
    state: E,
    ref: [n, R, d ? null : w],
    props: [b, {
      children: S,
      tabIndex: -1,
      id: N,
      role: h ? "grid" : "listbox",
      "aria-multiselectable": C ? "true" : void 0,
      onKeyDown(T) {
        if (!(c.state.disabled || c.state.readOnly) && T.key === "Enter") {
          const k = c.state.activeIndex;
          if (k == null)
            return;
          Lt(T);
          const P = T.nativeEvent, M = c.state.listRef.current[k];
          M && (c.state.selectionEventRef.current = P, M.click(), c.state.selectionEventRef.current = null);
        }
      },
      onKeyDownCapture() {
        c.state.keyboardActiveRef.current = !0;
      },
      onPointerMoveCapture() {
        c.state.keyboardActiveRef.current = !1;
      }
    }, a]
  });
  return v ? I : /* @__PURE__ */ g(ri, {
    elementsRef: c.state.listRef,
    labelsRef: p ? void 0 : c.state.labelsRef,
    children: I
  });
});
process.env.NODE_ENV !== "production" && (Ps.displayName = "ComboboxList");
const bS = "⁠", vS = 200;
function yS(t) {
  const e = t.ownerDocument.createTreeWalker(t, NodeFilter.SHOW_TEXT);
  let n = null;
  for (; e.nextNode(); ) {
    const o = e.currentNode;
    o.nodeValue !== "" && (n = o);
  }
  return n;
}
function xS() {
  const t = Dt(), e = x.useRef(null);
  return x.useEffect(() => {
    if ($u)
      return;
    const n = e.current;
    if (n == null)
      return;
    const o = yS(n);
    if (o == null)
      return;
    const r = o.nodeValue ?? "", i = `${r}${bS}`;
    return o.nodeValue = i, t.start(vS, () => {
      o.nodeValue === i && (o.nodeValue = r);
    }), () => {
      t.clear(), o.nodeValue === i && (o.nodeValue = r);
    };
  }, [e, t]), e;
}
const Ef = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ef.displayName = "ComboboxPortalContext");
function CS() {
  const t = x.useContext(Ef);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Portal> is missing." : et(20));
  return t;
}
const xa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, i = Cn(), s = ye(i, Te.mounted), l = ye(i, Te.forceMounted);
  return s || o || l ? /* @__PURE__ */ g(Ef.Provider, {
    value: o,
    children: /* @__PURE__ */ g(ti, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (xa.displayName = "ComboboxPortal");
const Ca = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = Qu,
    style: v,
    ...C
  } = e, y = Cn(), {
    filteredItems: w
  } = Vo(), R = ba(), S = CS(), E = ye(y, Te.modal), N = ye(y, Te.open), I = ye(y, Te.mounted), T = ye(y, Te.openMethod), k = ye(y, Te.positionerElement), P = ye(y, Te.triggerElement), M = ye(y, Te.inputElement), D = ye(y, Te.inputGroupElement), O = ye(y, Te.inputInsidePopup), _ = ye(y, Te.transitionStatus), V = w.length === 0, L = oi({
    anchor: i ?? (O ? P : D ?? M),
    floatingRootContext: R,
    positionMethod: s,
    mounted: I,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h,
    keepMounted: S,
    collisionAvoidance: b,
    lazyFlip: !0
  });
  pa(N && E, T === "touch", k, P);
  const $ = {
    open: N,
    side: L.side,
    align: L.align,
    anchorHidden: L.anchorHidden,
    empty: V
  };
  Ne(() => {
    y.set("popupSide", L.side);
  }, [y, L.side]);
  const Y = Ce((j) => {
    y.set("positionerElement", j);
  }), G = si(e, $, {
    styles: L.positionerStyles,
    transitionStatus: _,
    props: C,
    refs: [n, Y],
    hidden: !I,
    inert: !N
  });
  return /* @__PURE__ */ F(Cf.Provider, {
    value: L,
    children: [I && E && /* @__PURE__ */ g(ii, {
      inert: Er(!N),
      cutout: D ?? M ?? P
    }), G]
  });
});
process.env.NODE_ENV !== "production" && (Ca.displayName = "ComboboxPositioner");
const wS = {
  ...kn,
  ...zt
}, wa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    initialFocus: s,
    finalFocus: l,
    ...a
  } = e, c = Cn(), u = wf(), d = ba(), {
    filteredItems: f
  } = Vo(), p = ye(c, Te.mounted), m = ye(c, Te.open), h = ye(c, Te.openMethod), b = ye(c, Te.transitionStatus), v = ye(c, Te.inputInsidePopup), C = ye(c, Te.inputElement), y = ye(c, Te.modal), w = f.length === 0;
  Yt({
    open: m,
    ref: c.state.popupRef,
    onComplete() {
      m && c.state.onOpenChangeComplete(!0);
    }
  });
  const R = {
    open: m,
    side: u.side,
    align: u.align,
    anchorHidden: u.anchorHidden,
    transitionStatus: b,
    empty: w
  }, S = Le("div", e, {
    state: R,
    ref: [n, c.state.popupRef],
    props: [{
      role: v ? "dialog" : "presentation",
      tabIndex: -1,
      onFocus(k) {
        const P = bt(k.nativeEvent);
        h !== "touch" && (Fe(c.state.listElement, P) || P === k.currentTarget) && c.state.inputRef.current?.focus();
      }
    }, Rr(b), a],
    stateAttributesMapping: wS
  }), N = s === void 0 ? v ? (k) => k === "touch" ? c.state.popupRef.current : C : !1 : s;
  let I;
  l != null ? I = l : I = v ? void 0 : !1;
  const T = !v || y;
  return /* @__PURE__ */ g(ni, {
    context: d,
    disabled: !p,
    modal: T,
    openInteractionType: h,
    initialFocus: N,
    returnFocus: I,
    getInsideElements: () => [c.state.startDismissRef.current, c.state.endDismissRef.current],
    children: /* @__PURE__ */ F(x.Fragment, {
      children: [S, T && /* @__PURE__ */ g(Sf, {
        ref: c.state.endDismissRef
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (wa.displayName = "ComboboxPopup");
const Nf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Nf.displayName = "ComboboxGroupContext");
function SS() {
  const t = x.useContext(Nf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxGroupContext is missing. ComboboxGroup parts must be placed within <Combobox.Group>." : et(18));
  return t;
}
const k0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    items: s,
    ...l
  } = e, [a, c] = x.useState(), u = x.useMemo(() => ({
    labelId: a,
    setLabelId: c,
    items: s
  }), [a, c, s]), d = Le("div", e, {
    ref: n,
    props: [{
      role: "group",
      "aria-labelledby": a
    }, l]
  }), f = /* @__PURE__ */ g(Nf.Provider, {
    value: u,
    children: d
  });
  return s ? /* @__PURE__ */ g(hS, {
    items: s,
    children: f
  }) : f;
});
process.env.NODE_ENV !== "production" && (k0.displayName = "ComboboxGroup");
const M0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    setLabelId: a
  } = SS(), c = kt(s);
  return Ne(() => (a(c), () => {
    a(void 0);
  }), [c, a]), Le("div", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (M0.displayName = "ComboboxGroupLabel");
const P0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (P0.displayName = "ComboboxItemContext");
const kf = /* @__PURE__ */ x.createContext(!1);
process.env.NODE_ENV !== "production" && (kf.displayName = "ComboboxRowContext");
function RS() {
  return x.useContext(kf);
}
const Is = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i = null,
    index: s,
    disabled: l = !1,
    nativeButton: a = !1,
    style: c,
    ...u
  } = e, d = x.useRef(!1), f = x.useRef(null), p = Oo({
    index: s,
    textRef: f,
    indexGuessBehavior: Bu.GuessFromOrder
  }), m = Cn(), h = RS(), {
    flatFilteredItems: b,
    hasItems: v
  } = Vo(), C = ye(m, Te.open), y = ye(m, Te.selectionMode), w = ye(m, Te.readOnly), R = ye(m, Te.virtualized), S = ye(m, Te.isItemEqualToValue), E = y !== "none", N = s ?? (R ? Mo(b, i, S) : p.index), I = p.index !== -1, T = ye(m, Te.id), k = ye(m, Te.isActive, N), P = ye(m, Te.isSelected, i), M = ye(m, Te.getItemProps), D = x.useRef(null), O = T != null && I ? `${T}-${N}` : void 0, _ = P && E;
  Ne(() => {
    if (!(I && (R || s != null)))
      return;
    const q = m.state.listRef.current;
    return q[N] = D.current, () => {
      delete q[N];
    };
  }, [I, R, N, s, m]), Ne(() => {
    if (!I || v)
      return;
    const U = m.state.valuesRef.current;
    return U[N] = i, y !== "none" && m.state.allValuesRef.current.push(i), () => {
      delete U[N];
    };
  }, [I, v, N, i, m, y]), Ne(() => {
    if (!C) {
      d.current = !1;
      return;
    }
    if (!I || v)
      return;
    const U = m.state.selectedValue, q = Array.isArray(U) ? U[U.length - 1] : U;
    mo(i, q, S) && m.set("selectedIndex", N);
  }, [I, v, C, m, N, i, S]);
  const V = {
    disabled: l,
    selected: _,
    highlighted: k
  }, A = M({
    active: k,
    selected: _
  });
  A.id = void 0, A.onFocus = void 0;
  const {
    getButtonProps: L,
    buttonRef: $
  } = Bt({
    disabled: l,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  });
  function Y(U) {
    function q() {
      m.state.handleSelection(U, i);
    }
    m.state.submitOnItemClick ? (an.flushSync(q), m.state.requestSubmit()) : q();
  }
  const G = {
    id: O,
    role: h ? "gridcell" : "option",
    "aria-selected": E ? _ : void 0,
    // Focusable items steal focus from the input upon mouseup.
    // Warn if the user renders a natively focusable element like `<button>`,
    // as it should be a `<div>` instead.
    tabIndex: void 0,
    onPointerDownCapture(U) {
      d.current = !0, U.preventDefault();
    },
    onMouseDown(U) {
      U.preventDefault();
    },
    onClick(U) {
      l || w || Y(U.nativeEvent);
    },
    onMouseUp(U) {
      const q = d.current;
      d.current = !1, !(l || w || U.button !== 0 || q || !k) && Y(U.nativeEvent);
    }
  }, j = Le("div", e, {
    ref: [$, n, p.ref, D],
    state: V,
    props: [A, G, u, L]
  }), Z = x.useMemo(() => ({
    selected: _,
    textRef: f
  }), [_, f]);
  return /* @__PURE__ */ g(P0.Provider, {
    value: Z,
    children: j
  });
}));
process.env.NODE_ENV !== "production" && (Is.displayName = "ComboboxItem");
const I0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Cn(), a = ye(l, Te.open), c = ye(l, Te.hasSelectionChips), [u, d] = x.useState(void 0);
  a && u !== void 0 && d(void 0);
  const f = x.useRef([]), p = Le("div", e, {
    ref: [n, l.state.chipsContainerRef],
    // NVDA enters browse mode instead of staying in focus mode when navigating with
    // arrow keys inside a container unless it has a toolbar role.
    props: [c ? {
      role: "toolbar"
    } : St, {
      onMouseDown(h) {
        E0(h, l, l.state.disabled, l.state.readOnly);
      }
    }, s]
  }), m = x.useMemo(() => ({
    highlightedChipIndex: u,
    setHighlightedChipIndex: d,
    chipsRef: f
  }), [u, d, f]);
  return /* @__PURE__ */ g(xf.Provider, {
    value: m,
    children: /* @__PURE__ */ g(ri, {
      elementsRef: f,
      children: p
    })
  });
});
process.env.NODE_ENV !== "production" && (I0.displayName = "ComboboxChips");
const Mf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Mf.displayName = "ComboboxChipContext");
function ES() {
  const t = x.useContext(Mf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "useComboboxChipContext must be used within a ComboboxChip" : et(17));
  return t;
}
const T0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Cn(), {
    setHighlightedChipIndex: a,
    chipsRef: c
  } = R0(), u = ye(l, Te.disabled), d = ye(l, Te.readOnly), f = ye(l, Te.selectedValue), {
    ref: p,
    index: m
  } = Oo();
  function h(y) {
    let w = m;
    if (y.key === "ArrowLeft")
      y.preventDefault(), m > 0 ? w = m - 1 : w = void 0;
    else if (y.key === "ArrowRight")
      y.preventDefault(), m < c.current.length - 1 ? w = m + 1 : w = void 0;
    else if (y.key === "Backspace" || y.key === "Delete") {
      const R = m >= f.length - 1 ? f.length - 2 : m;
      w = R >= 0 ? R : void 0, Lt(y), l.state.setIndices({
        activeIndex: null,
        selectedIndex: null,
        type: "keyboard"
      }), l.state.setSelectedValue(f.filter((S, E) => E !== m), De(Pt, y.nativeEvent));
    } else y.key === "Enter" || y.key === " " ? (Lt(y), w = void 0) : y.key === "ArrowDown" || y.key === "ArrowUp" ? (Lt(y), l.state.setOpen(!0, De(Fr, y.nativeEvent)), w = void 0) : (
      // Check for printable characters (letters, numbers, symbols)
      y.key.length === 1 && !y.ctrlKey && !y.metaKey && !y.altKey && (w = void 0)
    );
    return w;
  }
  const v = Le("div", e, {
    ref: [n, p],
    state: {
      disabled: u
    },
    props: [{
      tabIndex: -1,
      "aria-disabled": u || void 0,
      "aria-readonly": d || void 0,
      onKeyDown(y) {
        if (u || d)
          return;
        const w = h(y);
        an.flushSync(() => {
          a(w);
        }), w === void 0 ? l.state.inputRef.current?.focus() : c.current[w]?.focus();
      }
    }, s]
  }), C = x.useMemo(() => ({
    index: m
  }), [m]);
  return /* @__PURE__ */ g(Mf.Provider, {
    value: C,
    children: v
  });
});
process.env.NODE_ENV !== "production" && (T0.displayName = "ComboboxChip");
const O0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    style: l,
    ...a
  } = e, c = Cn(), {
    index: u
  } = ES(), d = ye(c, Te.disabled), f = ye(c, Te.readOnly), p = ye(c, Te.selectedValue), m = ye(c, Te.isItemEqualToValue), h = d || i, {
    buttonRef: b,
    getButtonProps: v
  } = Bt({
    native: s,
    disabled: h || f,
    focusableWhenDisabled: !0
  }), C = {
    disabled: h
  };
  function y(S) {
    const E = c.state.activeIndex;
    if (E == null)
      return;
    const N = Mo(c.state.valuesRef.current, S, m);
    N !== -1 && E === N && c.state.setIndices({
      activeIndex: null,
      type: c.state.keyboardActiveRef.current ? "keyboard" : "pointer"
    });
  }
  function w(S) {
    const E = De(t8, S.nativeEvent), N = p[u];
    return y(N), c.state.setSelectedValue(p.filter((I, T) => T !== u), E), c.state.inputRef.current?.focus(), E;
  }
  return Le("button", e, {
    ref: [n, b],
    state: C,
    props: [{
      tabIndex: -1,
      onMouseDown(S) {
        S.preventDefault();
      },
      onClick(S) {
        if (h || f)
          return;
        w(S).isPropagationAllowed || S.stopPropagation();
      },
      onKeyDown(S) {
        h || f || (S.key === "Enter" || S.key === " ") && (w(S).isPropagationAllowed || Lt(S));
      }
    }, a, v]
  });
});
process.env.NODE_ENV !== "production" && (O0.displayName = "ComboboxChipRemove");
const D0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Le("div", e, {
    ref: n,
    props: [{
      role: "row"
    }, s]
  });
  return /* @__PURE__ */ g(kf.Provider, {
    value: !0,
    children: l
  });
});
process.env.NODE_ENV !== "production" && (D0.displayName = "ComboboxRow");
const Pf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    children: s,
    ...l
  } = e, {
    filteredItems: a
  } = Vo(), c = Cn(), u = xS(), d = a.length === 0 ? s : null;
  return Le("div", e, {
    ref: [n, c.state.emptyRef, u],
    props: [{
      children: d,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": !0
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (Pf.displayName = "ComboboxEmpty");
const NS = {
  ...zt,
  ...br
}, If = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    keepMounted: l = !1,
    style: a,
    ...c
  } = e, {
    disabled: u
  } = tn(), d = Cn(), f = ye(d, Te.selectionMode), p = ye(d, Te.disabled), m = ye(d, Te.readOnly), h = ye(d, Te.open), b = ye(d, Te.selectedValue), v = ye(d, Te.hasSelectionChips), C = gf();
  let y = !1;
  f === "none" ? y = C !== "" : f === "single" ? y = b != null : y = v;
  const w = u || p || i, {
    buttonRef: R,
    getButtonProps: S
  } = Bt({
    native: s,
    disabled: w
  }), {
    mounted: E,
    transitionStatus: N,
    setMounted: I
  } = Zn(y), T = {
    disabled: w,
    open: h,
    transitionStatus: N
  };
  Yt({
    open: y,
    ref: d.state.clearRef,
    onComplete() {
      y || I(!1);
    }
  });
  const k = Le("button", e, {
    state: T,
    ref: [n, R, d.state.clearRef],
    props: [{
      tabIndex: -1,
      children: "x",
      // Avoid stealing focus from the input.
      onMouseDown(M) {
        M.preventDefault();
      },
      onClick(M) {
        if (w || m)
          return;
        const D = d.state.keyboardActiveRef;
        d.state.setInputValue("", De(O1, M.nativeEvent)), f !== "none" ? (d.state.setSelectedValue(Array.isArray(b) ? [] : null, De(O1, M.nativeEvent)), d.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: D.current ? "keyboard" : "pointer"
        })) : d.state.setIndices({
          activeIndex: null,
          type: D.current ? "keyboard" : "pointer"
        }), d.state.inputRef.current?.focus();
      }
    }, c, S],
    stateAttributesMapping: NS
  });
  return l || E ? k : null;
});
process.env.NODE_ENV !== "production" && (If.displayName = "ComboboxClear");
const kS = ae([
  "flex",
  "items-center",
  "justify-between",
  "gap-(--spacing-4)",
  "w-full",
  "rounded-(--radius-sm)",
  "border",
  "border-solid",
  "border-input-default-outline",
  "bg-input-default-background",
  "text-input-text-default",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "cursor-pointer",
  "data-[disabled]:cursor-not-allowed",
  "[&_svg]:pointer-events-none",
  "[&_svg]:shrink-0",
  // Hover (only when not open)
  "[&:not([data-popup-open])]:hover:bg-input-hover-background",
  "[&:not([data-popup-open])]:hover:border-input-hover-outline",
  // Active/open
  "data-[popup-open]:border-input-active-outline",
  // Pressed
  "active:border-input-pressed-outline",
  // Focus ring (keyboard)
  "focus-visible:ring-2",
  "focus-visible:ring-input-focus-ring",
  "focus-visible:ring-offset-1"
], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
});
function _0(t) {
  const e = W.c(114), {
    id: n,
    options: o,
    value: r,
    onChange: i,
    defaultValue: s,
    placeholder: l,
    size: a,
    label: c,
    tooltip: u,
    required: d,
    description: f,
    error: p,
    disabled: m,
    reserveSubtextSpace: h,
    name: b,
    "data-testid": v,
    renderValue: C,
    renderOption: y,
    popupWidth: w
  } = t, R = a === void 0 ? "md" : a, S = h === void 0 ? !0 : h, E = w === void 0 ? "anchor" : w, N = Qt(), I = !!p, k = S || I || !!f, P = r !== void 0, [M, D] = tt(s ?? null), [O, _] = tt(!1), [V, A] = tt(""), L = P ? r : M;
  let $, Y, G, j, Z, U, q, te, H, X, ee, le, Q, re, fe, ne, se, pe, xe, ce, he, z;
  if (e[0] !== L || e[1] !== m || e[2] !== I || e[3] !== V || e[4] !== P || e[5] !== O || e[6] !== c || e[7] !== b || e[8] !== i || e[9] !== o || e[10] !== l || e[11] !== C || e[12] !== d || e[13] !== R || e[14] !== u) {
    let Me;
    e[37] !== L ? (Me = (wt) => wt.value === L, e[37] = L, e[38] = Me) : Me = e[38];
    const He = o.find(Me);
    let ze;
    e[39] !== L || e[40] !== P || e[41] !== i || e[42] !== d ? (ze = function(dt, we) {
      const Ae = we.reason === "item-press" && !d && L !== null && dt?.value === L ? null : dt?.value ?? null;
      i?.(Ae, we), !P && !we.isCanceled && D(Ae);
    }, e[39] = L, e[40] = P, e[41] = i, e[42] = d, e[43] = ze) : ze = e[43];
    const Oe = ze;
    G = Pr, Q = I, re = m, fe = "flex flex-col w-full", e[44] !== c || e[45] !== d || e[46] !== u ? (ne = c && /* @__PURE__ */ g(pi, { label: c, required: d, tooltip: u }), e[44] = c, e[45] = d, e[46] = u, e[47] = ne) : ne = e[47], Y = bf, xe = He ?? null, ce = Oe, he = m, z = d, j = b, Z = !1, U = o, q = TS, te = IS, H = PS, X = O ? V : He?.label ?? "", ee = A, e[48] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (le = (wt) => {
      _(wt), wt && A("");
    }, e[48] = le) : le = e[48], $ = va, e[49] !== m || e[50] !== I || e[51] !== R ? (se = oe(kS({
      size: R
    }), "relative", m && "opacity-50 cursor-not-allowed", I && ["border-input-error-outline", "[&:not([data-popup-open])]:hover:border-input-error-outline"]), e[49] = m, e[50] = I, e[51] = R, e[52] = se) : se = e[52], pe = !O && /* @__PURE__ */ g("span", { className: "pointer-events-none absolute inset-y-0 left-(--spacing-10) right-(--spacing-32) flex min-w-0 items-center text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20)", children: C ? C(He) : He ? /* @__PURE__ */ g("span", { className: "truncate", children: He.label }) : /* @__PURE__ */ g("span", { className: "truncate text-input-text-placeholder", children: l }) }), e[0] = L, e[1] = m, e[2] = I, e[3] = V, e[4] = P, e[5] = O, e[6] = c, e[7] = b, e[8] = i, e[9] = o, e[10] = l, e[11] = C, e[12] = d, e[13] = R, e[14] = u, e[15] = $, e[16] = Y, e[17] = G, e[18] = j, e[19] = Z, e[20] = U, e[21] = q, e[22] = te, e[23] = H, e[24] = X, e[25] = ee, e[26] = le, e[27] = Q, e[28] = re, e[29] = fe, e[30] = ne, e[31] = se, e[32] = pe, e[33] = xe, e[34] = ce, e[35] = he, e[36] = z;
  } else
    $ = e[15], Y = e[16], G = e[17], j = e[18], Z = e[19], U = e[20], q = e[21], te = e[22], H = e[23], X = e[24], ee = e[25], le = e[26], Q = e[27], re = e[28], fe = e[29], ne = e[30], se = e[31], pe = e[32], xe = e[33], ce = e[34], he = e[35], z = e[36];
  const J = c || n ? void 0 : l ?? "Select option", B = d || void 0, K = !O && "text-transparent caret-transparent";
  let ie;
  e[53] !== K ? (ie = oe("min-w-0 flex-1 bg-transparent outline-none text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-text-default placeholder:text-input-text-placeholder", K), e[53] = K, e[54] = ie) : ie = e[54];
  const ge = O ? "Search" : void 0;
  let ue;
  e[55] !== v || e[56] !== n || e[57] !== J || e[58] !== B || e[59] !== ie || e[60] !== ge ? (ue = /* @__PURE__ */ g(Ms, { id: n, "data-testid": v, "aria-label": J, "aria-required": B, className: ie, placeholder: ge, onFocus: MS }), e[55] = v, e[56] = n, e[57] = J, e[58] = B, e[59] = ie, e[60] = ge, e[61] = ue) : ue = e[61];
  let Se;
  e[62] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Se = /* @__PURE__ */ g(ya, { "aria-label": "Open options", className: "inline-flex shrink-0 text-input-text-default outline-none", children: /* @__PURE__ */ g(Ge, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[62] = Se) : Se = e[62];
  let ve;
  e[63] !== $ || e[64] !== ue || e[65] !== se || e[66] !== pe ? (ve = /* @__PURE__ */ F($, { className: se, children: [
    pe,
    ue,
    Se
  ] }), e[63] = $, e[64] = ue, e[65] = se, e[66] = pe, e[67] = ve) : ve = e[67];
  const de = E === "content" ? "w-auto min-w-(--anchor-width) max-w-[calc(100vw-var(--spacing-16))]" : "w-(--anchor-width)";
  let me;
  e[68] !== de ? (me = oe("z-[var(--z-overlay-popover,180)]", de), e[68] = de, e[69] = me) : me = e[69];
  let Re;
  e[70] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Re = ys({
    size: "auto"
  }), e[70] = Re) : Re = e[70];
  let Ie;
  e[71] !== L || e[72] !== y ? (Ie = /* @__PURE__ */ g(Ps, { className: "flex flex-col outline-none", children: (Me) => /* @__PURE__ */ F(Is, { value: Me, disabled: Me.disabled, className: Ko({}), children: [
    Me.icon && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ g(Ge, { name: Me.icon, size: "xs", tone: "inherit" }) }),
    /* @__PURE__ */ g(Ki, { checked: Me.value === L, children: y ? y(Me) : Me.label })
  ] }, Me.value) }), e[71] = L, e[72] = y, e[73] = Ie) : Ie = e[73];
  let Pe;
  e[74] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Pe = /* @__PURE__ */ g(Pf, { className: "[&:empty]:p-0 px-(--spacing-10) py-(--spacing-8) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: "No results available" }), e[74] = Pe) : Pe = e[74];
  let _e;
  e[75] !== Ie ? (_e = /* @__PURE__ */ F(wa, { className: Re, children: [
    Ie,
    Pe
  ] }), e[75] = Ie, e[76] = _e) : _e = e[76];
  let Ye;
  e[77] !== me || e[78] !== _e ? (Ye = /* @__PURE__ */ g(Ca, { sideOffset: 4, className: me, children: _e }), e[77] = me, e[78] = _e, e[79] = Ye) : Ye = e[79];
  let qe;
  e[80] !== N || e[81] !== Ye ? (qe = /* @__PURE__ */ g(xa, { container: N, children: Ye }), e[80] = N, e[81] = Ye, e[82] = qe) : qe = e[82];
  let $e;
  e[83] !== Y || e[84] !== j || e[85] !== Z || e[86] !== U || e[87] !== q || e[88] !== te || e[89] !== H || e[90] !== X || e[91] !== ee || e[92] !== le || e[93] !== ve || e[94] !== qe || e[95] !== xe || e[96] !== ce || e[97] !== he || e[98] !== z ? ($e = /* @__PURE__ */ F(Y, { value: xe, onValueChange: ce, disabled: he, required: z, name: j, modal: Z, items: U, isItemEqualToValue: q, itemToStringLabel: te, itemToStringValue: H, inputValue: X, onInputValueChange: ee, onOpenChange: le, children: [
    ve,
    qe
  ] }), e[83] = Y, e[84] = j, e[85] = Z, e[86] = U, e[87] = q, e[88] = te, e[89] = H, e[90] = X, e[91] = ee, e[92] = le, e[93] = ve, e[94] = qe, e[95] = xe, e[96] = ce, e[97] = he, e[98] = z, e[99] = $e) : $e = e[99];
  let Ee;
  e[100] !== f || e[101] !== p || e[102] !== I || e[103] !== S || e[104] !== k ? (Ee = k && /* @__PURE__ */ g("div", { "data-testid": "select-subtext-row", className: oe("mt-(--spacing-4)", S && "min-h-(--spacing-20)"), children: I ? /* @__PURE__ */ g(Ir, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: p }) : f ? /* @__PURE__ */ g(di, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: f }) : null }), e[100] = f, e[101] = p, e[102] = I, e[103] = S, e[104] = k, e[105] = Ee) : Ee = e[105];
  let Ve;
  return e[106] !== G || e[107] !== Q || e[108] !== re || e[109] !== fe || e[110] !== ne || e[111] !== $e || e[112] !== Ee ? (Ve = /* @__PURE__ */ F(G, { invalid: Q, disabled: re, className: fe, children: [
    ne,
    $e,
    Ee
  ] }), e[106] = G, e[107] = Q, e[108] = re, e[109] = fe, e[110] = ne, e[111] = $e, e[112] = Ee, e[113] = Ve) : Ve = e[113], Ve;
}
function MS(t) {
  return t.currentTarget.select();
}
function PS(t) {
  return t.value;
}
function IS(t) {
  return t.label;
}
function TS(t, e) {
  return t.value === e.value;
}
function um(t) {
  if (t)
    return {
      ...t,
      tone: t.tone === "neutral" ? "activity" : t.tone
    };
}
function Li(t) {
  return t.replace(/^\s*(?:\([^)]*\)\s*[-–—]?\s*)+/, "").split(/\s+/).filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();
}
function OS(t) {
  const e = W.c(36), {
    facilities: n,
    selectedFacilityId: o,
    onFacilitySelect: r,
    onFacilityChange: i,
    activeItemId: s,
    facilitySubNavItems: l,
    collapsed: a
  } = t;
  let c;
  e[0] !== n ? (c = function(p) {
    return n.find((m) => m.id === p);
  }, e[0] = n, e[1] = c) : c = e[1];
  const u = c;
  let d;
  if (e[2] !== s || e[3] !== a || e[4] !== n || e[5] !== l || e[6] !== u || e[7] !== i || e[8] !== r || e[9] !== o) {
    const f = u(o), p = f ? l?.(f) ?? [] : [];
    let m;
    e[11] !== a || e[12] !== n.length ? (m = a ? /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "flex h-(--spacing-40) items-center", children: /* @__PURE__ */ g("span", { className: "w-full border-t border-outline-subtle" }) }) : /* @__PURE__ */ F("span", { className: "flex h-(--spacing-40) items-center whitespace-nowrap px-(--spacing-10) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-text-subtle", children: [
      "FACILITIES (",
      n.length,
      ")"
    ] }), e[11] = a, e[12] = n.length, e[13] = m) : m = e[13];
    const h = a ? "flex w-full justify-center" : void 0, b = a ? "w-[60px] shrink-0" : void 0;
    let v;
    e[14] !== n ? (v = n.map(DS), e[14] = n, e[15] = v) : v = e[15];
    let C;
    e[16] !== a || e[17] !== u ? (C = (N) => N ? /* @__PURE__ */ F("span", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
      /* @__PURE__ */ g(Ur, { initials: Li(N.label), size: "xs", src: u(N.value)?.avatarUrl, variant: "external" }),
      !a && /* @__PURE__ */ g("span", { className: "truncate", children: N.label })
    ] }) : null, e[16] = a, e[17] = u, e[18] = C) : C = e[18];
    let y;
    e[19] !== u ? (y = (N) => /* @__PURE__ */ F("span", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
      /* @__PURE__ */ g(Ur, { initials: Li(N.label), size: "xs", src: u(N.value)?.avatarUrl, variant: "external" }),
      /* @__PURE__ */ g("span", { className: "truncate", children: N.label })
    ] }), e[19] = u, e[20] = y) : y = e[20];
    let w;
    e[21] !== i || e[22] !== r ? (w = (N) => {
      N && (r ?? i)(N);
    }, e[21] = i, e[22] = r, e[23] = w) : w = e[23];
    let R;
    e[24] !== o || e[25] !== v || e[26] !== C || e[27] !== y || e[28] !== w ? (R = /* @__PURE__ */ g(_0, { options: v, required: !0, popupWidth: "content", reserveSubtextSpace: !1, size: "md", value: o, renderValue: C, renderOption: y, onChange: w }), e[24] = o, e[25] = v, e[26] = C, e[27] = y, e[28] = w, e[29] = R) : R = e[29];
    let S;
    e[30] !== R || e[31] !== b ? (S = /* @__PURE__ */ g("div", { className: b, children: R }), e[30] = R, e[31] = b, e[32] = S) : S = e[32];
    let E;
    e[33] !== S || e[34] !== h ? (E = /* @__PURE__ */ g("div", { className: h, children: S }), e[33] = S, e[34] = h, e[35] = E) : E = e[35], d = /* @__PURE__ */ F("section", { "aria-label": `Facilities (${n.length})`, children: [
      m,
      E,
      f && p.length > 0 && /* @__PURE__ */ g("div", { className: "mt-(--spacing-4) flex flex-col gap-(--spacing-4)", children: p.map((N) => /* @__PURE__ */ g(Rl, { itemId: N.id, label: N.label, badge: N.badge, leading: N.icon ? {
        type: "icon",
        name: N.icon
      } : void 0, href: N.render ? void 0 : N.href ?? "#", render: N.render, onClick: (I) => {
        i(f.id), N.onClick?.(I);
      }, selected: f.id === o && N.id === s, variant: "item" }, N.id)) })
    ] }), e[2] = s, e[3] = a, e[4] = n, e[5] = l, e[6] = u, e[7] = i, e[8] = r, e[9] = o, e[10] = d;
  } else
    d = e[10];
  return d;
}
function DS(t) {
  return {
    value: t.id,
    label: t.name
  };
}
function GO(t) {
  const e = W.c(85), {
    facilities: n,
    selectedFacilityId: o,
    onFacilitySelect: r,
    onFacilityChange: i,
    activeItemId: s,
    facilitySubNavItems: l,
    expandedFacilityId: a,
    initialExpandedFacilityId: c,
    onExpandedFacilityChange: u
  } = t, {
    collapsed: d
  } = i0(), [f, p] = tt(c), m = "expandedFacilityId" in t, h = m ? a : f, b = ut(!1), v = ut(o);
  let C;
  e[0] !== m || e[1] !== u ? (C = function(M) {
    m || p(M), u?.(M);
  }, e[0] = m, e[1] = u, e[2] = C) : C = e[2];
  const y = C;
  let w, R;
  if (e[3] !== h || e[4] !== n || e[5] !== m || e[6] !== u || e[7] !== o ? (w = () => {
    if (m || n.length < 2 || n.length > 5)
      return;
    const P = !b.current;
    b.current = !0;
    const M = v.current !== o;
    v.current = o, (P && h === void 0 || M || h !== void 0 && !n.some((D) => D.id === h)) && (m || p(o), u?.(o));
  }, R = [h, n, m, u, o], e[3] = h, e[4] = n, e[5] = m, e[6] = u, e[7] = o, e[8] = w, e[9] = R) : (w = e[8], R = e[9]), _t(w, R), n.length === 0)
    return null;
  if (n.length === 1) {
    const P = n[0];
    let M, D, O, _, V, A, L, $, Y;
    if (e[10] !== s || e[11] !== l || e[12] !== P || e[13] !== i || e[14] !== o) {
      const Z = l?.(P) ?? [];
      let U;
      e[24] !== P.alertBadge ? (U = um(P.alertBadge), e[24] = P.alertBadge, e[25] = U) : U = e[25];
      const q = U;
      D = P.name, M = em, O = !1, _ = P.id, V = P.name, A = q;
      let te;
      e[26] !== s ? (te = (ee) => ee.id === s, e[26] = s, e[27] = te) : te = e[27], L = Z.some(te);
      let H;
      e[28] !== P.name ? (H = Li(P.name), e[28] = P.name, e[29] = H) : H = e[29], e[30] !== P.avatarUrl || e[31] !== H ? ($ = {
        type: "avatar",
        initials: H,
        src: P.avatarUrl
      }, e[30] = P.avatarUrl, e[31] = H, e[32] = $) : $ = e[32];
      let X;
      e[33] !== s || e[34] !== P.id || e[35] !== i || e[36] !== o ? (X = (ee) => /* @__PURE__ */ g(Rl, { itemId: ee.id, label: ee.label, badge: ee.badge, leading: ee.icon ? {
        type: "icon",
        name: ee.icon
      } : void 0, href: ee.render ? void 0 : ee.href ?? "#", render: ee.render, onClick: (le) => {
        i(P.id), ee.onClick?.(le);
      }, selected: P.id === o && ee.id === s, variant: "item" }, ee.id), e[33] = s, e[34] = P.id, e[35] = i, e[36] = o, e[37] = X) : X = e[37], Y = Z.map(X), e[10] = s, e[11] = l, e[12] = P, e[13] = i, e[14] = o, e[15] = M, e[16] = D, e[17] = O, e[18] = _, e[19] = V, e[20] = A, e[21] = L, e[22] = $, e[23] = Y;
    } else
      M = e[15], D = e[16], O = e[17], _ = e[18], V = e[19], A = e[20], L = e[21], $ = e[22], Y = e[23];
    let G;
    e[38] !== M || e[39] !== O || e[40] !== _ || e[41] !== V || e[42] !== A || e[43] !== L || e[44] !== $ || e[45] !== Y ? (G = /* @__PURE__ */ g(M, { collapsible: O, itemId: _, label: V, badge: A, hasSelectedChild: L, leading: $, children: Y }), e[38] = M, e[39] = O, e[40] = _, e[41] = V, e[42] = A, e[43] = L, e[44] = $, e[45] = Y, e[46] = G) : G = e[46];
    let j;
    return e[47] !== D || e[48] !== G ? (j = /* @__PURE__ */ g("section", { "aria-label": D, children: G }), e[47] = D, e[48] = G, e[49] = j) : j = e[49], j;
  }
  if (n.length > 5) {
    let P;
    return e[50] !== s || e[51] !== d || e[52] !== n || e[53] !== l || e[54] !== i || e[55] !== r || e[56] !== o ? (P = /* @__PURE__ */ g(OS, { facilities: n, selectedFacilityId: o, onFacilitySelect: r, onFacilityChange: i, activeItemId: s, facilitySubNavItems: l, collapsed: d }), e[50] = s, e[51] = d, e[52] = n, e[53] = l, e[54] = i, e[55] = r, e[56] = o, e[57] = P) : P = e[57], P;
  }
  const S = `Facilities (${n.length})`;
  let E;
  e[58] !== d || e[59] !== n.length ? (E = !d && /* @__PURE__ */ F("span", { className: "flex h-(--spacing-40) items-center whitespace-nowrap px-(--spacing-10) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-text-subtle", children: [
    "FACILITIES (",
    n.length,
    ")"
  ] }), e[58] = d, e[59] = n.length, e[60] = E) : E = e[60];
  let N;
  e[61] !== d ? (N = d && /* @__PURE__ */ g("div", { "aria-hidden": !0, className: "flex h-(--spacing-40) items-center", children: /* @__PURE__ */ g("span", { className: "w-full border-t border-outline-subtle" }) }), e[61] = d, e[62] = N) : N = e[62];
  let I;
  if (e[63] !== s || e[64] !== h || e[65] !== n || e[66] !== l || e[67] !== i || e[68] !== o || e[69] !== y) {
    let P;
    e[71] !== s || e[72] !== h || e[73] !== l || e[74] !== i || e[75] !== o || e[76] !== y ? (P = (M) => {
      const D = l?.(M) ?? [], O = um(M.alertBadge), _ = M.id === o && D.some((A) => A.id === s), V = M.id === h;
      return D.length ? /* @__PURE__ */ g(em, { itemId: M.id, label: M.name, badge: O, leading: {
        type: "avatar",
        initials: Li(M.name),
        src: M.avatarUrl
      }, hasSelectedChild: _, open: V, onOpenChange: (A) => {
        const L = A ? M.id : void 0;
        y(L);
      }, children: D.map((A) => /* @__PURE__ */ g(Rl, { itemId: A.id, label: A.label, badge: A.badge, leading: A.icon ? {
        type: "icon",
        name: A.icon
      } : void 0, href: A.render ? void 0 : A.href ?? "#", render: A.render, onClick: (L) => {
        i(M.id), A.onClick?.(L);
      }, selected: M.id === o && A.id === s, variant: "subItem" }, A.id)) }, M.id) : /* @__PURE__ */ g(Rl, { itemId: M.id, label: M.name, leading: {
        type: "avatar",
        initials: Li(M.name),
        src: M.avatarUrl
      }, href: "#", badge: O, selected: M.id === o, onClick: (A) => {
        A.preventDefault(), i(M.id);
      } }, M.id);
    }, e[71] = s, e[72] = h, e[73] = l, e[74] = i, e[75] = o, e[76] = y, e[77] = P) : P = e[77], I = n.map(P), e[63] = s, e[64] = h, e[65] = n, e[66] = l, e[67] = i, e[68] = o, e[69] = y, e[70] = I;
  } else
    I = e[70];
  let T;
  e[78] !== I ? (T = /* @__PURE__ */ g("div", { className: "flex flex-col gap-(--spacing-4)", children: I }), e[78] = I, e[79] = T) : T = e[79];
  let k;
  return e[80] !== S || e[81] !== E || e[82] !== N || e[83] !== T ? (k = /* @__PURE__ */ F("section", { "aria-label": S, className: "flex flex-col gap-(--spacing-4)", children: [
    E,
    N,
    T
  ] }), e[80] = S, e[81] = E, e[82] = N, e[83] = T, e[84] = k) : k = e[84], k;
}
const V0 = go(void 0);
function _S(t) {
  return t === "light" || t === "dark" || t === "system";
}
function dm() {
  return typeof window > "u" || !window.matchMedia ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function VS(t, e) {
  if (typeof window > "u")
    return e;
  try {
    const n = localStorage.getItem(t);
    return _S(n) ? n : e;
  } catch {
    return e;
  }
}
function AS(t) {
  const e = W.c(21), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t, i = o === void 0 ? "system" : o, s = r === void 0 ? "assetwatch-ui-theme" : r;
  let l;
  e[0] !== i || e[1] !== s ? (l = () => VS(s, i), e[0] = i, e[1] = s, e[2] = l) : l = e[2];
  const [a, c] = tt(l), [u, d] = tt(dm), f = a === "system" ? u : a;
  let p, m;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = () => {
    if (!window.matchMedia)
      return;
    const E = window.matchMedia("(prefers-color-scheme: dark)"), N = () => d(dm());
    return E.addEventListener("change", N), () => E.removeEventListener("change", N);
  }, m = [], e[3] = p, e[4] = m) : (p = e[3], m = e[4]), _t(p, m);
  let h, b;
  e[5] !== f ? (h = () => {
    const E = window.document.documentElement;
    E.classList.remove("light", "dark"), E.classList.add(f);
  }, b = [f], e[5] = f, e[6] = h, e[7] = b) : (h = e[6], b = e[7]), _t(h, b);
  let v;
  e[8] !== s ? (v = (E) => {
    localStorage.setItem(s, E), c(E);
  }, e[8] = s, e[9] = v) : v = e[9];
  const C = v;
  let y;
  e[10] !== f || e[11] !== C ? (y = () => {
    C(f === "light" ? "dark" : "light");
  }, e[10] = f, e[11] = C, e[12] = y) : y = e[12];
  const w = y;
  let R;
  e[13] !== f || e[14] !== C || e[15] !== a || e[16] !== w ? (R = {
    theme: a,
    resolvedTheme: f,
    setTheme: C,
    toggleTheme: w
  }, e[13] = f, e[14] = C, e[15] = a, e[16] = w, e[17] = R) : R = e[17];
  let S;
  return e[18] !== n || e[19] !== R ? (S = /* @__PURE__ */ g(V0.Provider, { value: R, children: n }), e[18] = n, e[19] = R, e[20] = S) : S = e[20], S;
}
function LS() {
  const t = ag(V0);
  if (t === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return t;
}
const YO = {
  openMenuAriaLabel: "Open account menu",
  engineeringOnly: "Engineering Only",
  appearance: "Theme",
  matchBrowser: "Match Browser",
  light: "Light",
  dark: "Dark",
  currentArtifact: "Current artifact",
  signOut: "Sign out"
}, FS = [{
  value: "system",
  label: "matchBrowser"
}, {
  value: "light",
  label: "light"
}, {
  value: "dark",
  label: "dark"
}];
function jO(t) {
  const e = W.c(19), {
    additionalContent: n,
    labels: o,
    engineeringOnly: r,
    engineeringContent: i,
    onOpenArtifact: s,
    onSignOut: l
  } = t, a = r === void 0 ? !1 : r, {
    theme: c,
    setTheme: u
  } = LS();
  let d;
  e[0] !== o.openMenuAriaLabel ? (d = /* @__PURE__ */ g(Yo, { render: /* @__PURE__ */ g(gt, { "aria-label": o.openMenuAriaLabel, icon: "user", size: "md", variant: "outline" }) }), e[0] = o.openMenuAriaLabel, e[1] = d) : d = e[1];
  let f;
  e[2] !== o.signOut || e[3] !== l ? (f = /* @__PURE__ */ g(fr, { "data-testid": "nav-sign-out", leadingIcon: "logout-exit", onClick: l, tone: "destructive", children: o.signOut }), e[2] = o.signOut, e[3] = l, e[4] = f) : f = e[4];
  let p;
  e[5] !== i || e[6] !== a || e[7] !== o || e[8] !== s || e[9] !== u || e[10] !== c ? (p = a ? /* @__PURE__ */ F(Ht, { children: [
    /* @__PURE__ */ g(su, { children: o.engineeringOnly }),
    /* @__PURE__ */ g(fr, { leadingIcon: "settings-cog", submenu: /* @__PURE__ */ F(Md, { value: c, onValueChange: (b) => u(b), children: [
      /* @__PURE__ */ g(su, { children: o.appearance }),
      FS.map((b) => {
        const {
          value: v,
          label: C
        } = b;
        return /* @__PURE__ */ g(Pd, { value: v, children: o[C] }, v);
      })
    ] }), children: o.appearance }),
    s ? /* @__PURE__ */ g(fr, { leadingIcon: "document", onClick: s, children: o.currentArtifact }) : null,
    i
  ] }) : null, e[5] = i, e[6] = a, e[7] = o, e[8] = s, e[9] = u, e[10] = c, e[11] = p) : p = e[11];
  let m;
  e[12] !== n || e[13] !== f || e[14] !== p ? (m = /* @__PURE__ */ F(kr, { align: "end", size: "sm", children: [
    n,
    f,
    p
  ] }), e[12] = n, e[13] = f, e[14] = p, e[15] = m) : m = e[15];
  let h;
  return e[16] !== d || e[17] !== m ? (h = /* @__PURE__ */ F(kd, { children: [
    d,
    m
  ] }), e[16] = d, e[17] = m, e[18] = h) : h = e[18], h;
}
const $S = ae(["rounded-(--radius-sm)", "border border-outline-subtle", "bg-surface-container-lowest", "flex flex-col"], {
  variants: {
    padding: {
      compact: "py-(--spacing-12) px-(--spacing-6)",
      standard: "p-(--spacing-12)"
    },
    elevated: {
      true: "shadow-elevation-1",
      false: null
    }
  },
  defaultVariants: {
    padding: "standard",
    elevated: !1
  }
}), HS = ae(["w-full", "flex flex-col", "[overflow:clip]", "rounded-(--radius-sm)", "border-[0.5px] border-outline-subtle", "bg-surface-container-low", "text-text-default"], {
  variants: {
    padding: {
      none: "p-0",
      compact: "p-(--spacing-8) gap-(--spacing-8)"
    }
  },
  defaultVariants: {
    padding: "compact"
  }
}), zS = ae(["min-w-0 truncate", "font-(family-name:--font-family-title)", "text-(length:--font-size-title-md)", "font-medium", "leading-(--line-height-24)", "text-text-default"]), BS = ae(["w-full min-w-0", "flex gap-(--spacing-24) items-start overflow-hidden"]);
function A0(t) {
  const e = W.c(14);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    className: o,
    padding: i,
    elevated: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  let l;
  e[6] !== o || e[7] !== r || e[8] !== i ? (l = oe($S({
    padding: i,
    elevated: r
  }), o), e[6] = o, e[7] = r, e[8] = i, e[9] = l) : l = e[9];
  let a;
  return e[10] !== n || e[11] !== s || e[12] !== l ? (a = /* @__PURE__ */ g("div", { className: l, ...s, "data-slot": "content-container-root", children: n }), e[10] = n, e[11] = s, e[12] = l, e[13] = a) : a = e[13], a;
}
function L0(t) {
  const e = W.c(12);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    className: o,
    padding: r,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  let s;
  e[5] !== o || e[6] !== r ? (s = oe(HS({
    padding: r
  }), o), e[5] = o, e[6] = r, e[7] = s) : s = e[7];
  let l;
  return e[8] !== n || e[9] !== i || e[10] !== s ? (l = /* @__PURE__ */ g("div", { className: s, ...i, "data-slot": "content-container-body", children: n }), e[8] = n, e[9] = i, e[10] = s, e[11] = l) : l = e[11], l;
}
function F0(t) {
  const e = W.c(10);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== o ? (i = oe("w-full", o), e[4] = o, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ g("div", { className: i, ...r, "data-slot": "content-container-footer", children: n }), e[6] = n, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
function WS(t) {
  const e = W.c(20), {
    main: n,
    start: o,
    titleAccessory: r,
    actions: i,
    summary: s
  } = t;
  let l;
  e[0] !== o ? (l = o && /* @__PURE__ */ g("div", { "data-slot": "content-container-start-accessory", className: "flex shrink-0 items-center", children: o }), e[0] = o, e[1] = l) : l = e[1];
  let a;
  e[2] !== r ? (a = r && /* @__PURE__ */ g("div", { "data-slot": "content-container-title-accessory", className: "flex shrink-0 items-center", children: r }), e[2] = r, e[3] = a) : a = e[3];
  let c;
  e[4] !== n || e[5] !== a ? (c = /* @__PURE__ */ F("div", { "data-slot": "content-container-main", className: "flex flex-1 min-w-0 items-center gap-(--spacing-8)", children: [
    n,
    a
  ] }), e[4] = n, e[5] = a, e[6] = c) : c = e[6];
  let u;
  e[7] !== l || e[8] !== c ? (u = /* @__PURE__ */ F("div", { "data-slot": "content-container-header-left", className: "flex flex-1 gap-(--spacing-8) items-center min-w-0", children: [
    l,
    c
  ] }), e[7] = l, e[8] = c, e[9] = u) : u = e[9];
  let d;
  e[10] !== i ? (d = i && /* @__PURE__ */ g("div", { "data-slot": "content-container-actions", className: "flex shrink-0 gap-(--spacing-8) items-center justify-end", children: i }), e[10] = i, e[11] = d) : d = e[11];
  let f;
  e[12] !== u || e[13] !== d ? (f = /* @__PURE__ */ F("div", { "data-slot": "content-container-header", className: "flex items-center gap-(--spacing-8) w-full", children: [
    u,
    d
  ] }), e[12] = u, e[13] = d, e[14] = f) : f = e[14];
  let p;
  e[15] !== s ? (p = s && /* @__PURE__ */ g("div", { "data-slot": "content-container-summary", className: BS(), children: s }), e[15] = s, e[16] = p) : p = e[16];
  let m;
  return e[17] !== f || e[18] !== p ? (m = /* @__PURE__ */ F("div", { "data-slot": "content-container-header-wrapper", className: "flex flex-col gap-(--spacing-8) w-full", children: [
    f,
    p
  ] }), e[17] = f, e[18] = p, e[19] = m) : m = e[19], m;
}
function $0(t) {
  const e = W.c(10);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== o ? (i = oe(zS(), o), e[4] = o, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ g("span", { className: i, ...r, children: n }), e[6] = n, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
const US = ae(["hover:bg-surface-container-low", "cursor-pointer", "transition-colors duration-200 ease-in-out", "has-[:focus-visible]:[outline-width:var(--spacing-2)]", "has-[:focus-visible]:outline-solid", "has-[:focus-visible]:outline-tertiary-tertiary", "has-[:focus-visible]:[outline-offset:3px]", "data-[disabled]:opacity-50", "data-[disabled]:cursor-default"]), GS = ae(["w-full", "flex items-center gap-(--spacing-8)", "cursor-pointer", "min-h-(--spacing-24)", "text-left", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), YS = ae(["group", "flex size-(--spacing-32) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "cursor-pointer", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), jS = ae(["w-full", "min-w-0", "overflow-hidden", "h-(--collapsible-panel-height)", "[&[data-starting-style]]:h-0", "[&[data-ending-style]]:h-0", "mt-(--spacing-12)", "[&[data-starting-style]]:mt-0", "[&[data-ending-style]]:mt-0", "transition-[height,margin-top] duration-150 ease-in-out", "motion-reduce:transition-none"]), KS = ["[data-accordion-panel-content]", "[data-accordion-ignore-shell-click]", "button", "a", "input", "label", "select", "textarea", "[role='button']", "[role='link']", "[role='menuitem']", "[role='option']", "[role='switch']", "[role='checkbox']", "[role='radio']"].join(",");
function qS(t) {
  return t instanceof Element ? t.closest(KS) === null : !1;
}
function KO(t) {
  const e = W.c(66);
  let n, o, r, i, s, l, a, c, u, d, f, p;
  e[0] !== t ? ({
    open: a,
    defaultOpen: r,
    onOpenChange: l,
    title: f,
    startAccessory: u,
    titleAccessory: p,
    actions: n,
    summary: d,
    children: o,
    footer: s,
    disabled: i,
    ...c
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  let m;
  e[13] !== r ? (m = () => r ?? !1, e[13] = r, e[14] = m) : m = e[14];
  const [h, b] = tt(m), v = a !== void 0, C = v ? a : h;
  let y;
  e[15] !== v || e[16] !== l ? (y = function(H) {
    v || b(H), l?.(H);
  }, e[15] = v, e[16] = l, e[17] = y) : y = e[17];
  const w = y;
  let R;
  e[18] !== i || e[19] !== C || e[20] !== w ? (R = function(H) {
    i || !qS(H.target) || w(!C);
  }, e[18] = i, e[19] = C, e[20] = w, e[21] = R) : R = e[21];
  const S = R, E = i ? "" : void 0;
  let N;
  e[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = US(), e[22] = N) : N = e[22];
  let I;
  e[23] !== u ? (I = u && /* @__PURE__ */ g("div", { className: "flex shrink-0 items-center", children: u }), e[23] = u, e[24] = I) : I = e[24];
  let T;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = GS(), e[25] = T) : T = e[25];
  let k;
  e[26] !== f ? (k = /* @__PURE__ */ g("h3", { className: "flex min-w-0 flex-1 m-0", children: /* @__PURE__ */ g(Bl, { className: T, onClick: XS, children: /* @__PURE__ */ g($0, { className: "flex-1", children: f }) }) }), e[26] = f, e[27] = k) : k = e[27];
  let P;
  e[28] !== p ? (P = p && /* @__PURE__ */ g("div", { className: "flex shrink-0 items-center", children: p }), e[28] = p, e[29] = P) : P = e[29];
  let M;
  e[30] !== k || e[31] !== P ? (M = /* @__PURE__ */ F("div", { className: "flex flex-1 min-w-0 items-center gap-(--spacing-8)", children: [
    k,
    P
  ] }), e[30] = k, e[31] = P, e[32] = M) : M = e[32];
  let D;
  e[33] !== n ? (D = n && /* @__PURE__ */ g("div", { "data-accordion-ignore-shell-click": "", className: "flex shrink-0 items-center", children: n }), e[33] = n, e[34] = D) : D = e[34];
  let O;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (O = YS(), e[35] = O) : O = e[35];
  let _;
  e[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ g("span", { className: "flex group-data-[panel-open]:hidden", children: /* @__PURE__ */ g(Ge, { name: "chevron-down", size: "md", tone: "secondary" }) }), e[36] = _) : _ = e[36];
  let V;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ F(Bl, { "aria-label": "Toggle accordion", "data-slot": "accordion-chevron-trigger", className: O, onClick: ZS, children: [
    _,
    /* @__PURE__ */ g("span", { className: "hidden group-data-[panel-open]:flex", children: /* @__PURE__ */ g(Ge, { name: "chevron-up", size: "md", tone: "secondary" }) })
  ] }), e[37] = V) : V = e[37];
  let A;
  e[38] !== M || e[39] !== D || e[40] !== I ? (A = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-8) w-full", children: [
    I,
    M,
    D,
    V
  ] }), e[38] = M, e[39] = D, e[40] = I, e[41] = A) : A = e[41];
  let L;
  e[42] !== d ? (L = d && /* @__PURE__ */ g("div", { className: "w-full min-w-0", children: d }), e[42] = d, e[43] = L) : L = e[43];
  let $;
  e[44] !== A || e[45] !== L ? ($ = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8) w-full", children: [
    A,
    L
  ] }), e[44] = A, e[45] = L, e[46] = $) : $ = e[46];
  let Y;
  e[47] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = jS(), e[47] = Y) : Y = e[47];
  let G;
  e[48] !== o ? (G = /* @__PURE__ */ g(L0, { children: o }), e[48] = o, e[49] = G) : G = e[49];
  let j;
  e[50] !== s ? (j = s && /* @__PURE__ */ g(F0, { children: s }), e[50] = s, e[51] = j) : j = e[51];
  let Z;
  e[52] !== G || e[53] !== j ? (Z = /* @__PURE__ */ g(Zd, { className: Y, children: /* @__PURE__ */ F("div", { "data-accordion-panel-content": "", className: "flex flex-col gap-(--spacing-4) cursor-default", children: [
    G,
    j
  ] }) }), e[52] = G, e[53] = j, e[54] = Z) : Z = e[54];
  let U;
  e[55] !== S || e[56] !== $ || e[57] !== Z || e[58] !== E ? (U = /* @__PURE__ */ F(A0, { padding: "standard", "data-disabled": E, className: N, onClick: S, children: [
    $,
    Z
  ] }), e[55] = S, e[56] = $, e[57] = Z, e[58] = E, e[59] = U) : U = e[59];
  let q;
  return e[60] !== i || e[61] !== C || e[62] !== c || e[63] !== w || e[64] !== U ? (q = /* @__PURE__ */ g(qd, { ...c, open: C, onOpenChange: w, disabled: i, className: "group", children: U }), e[60] = i, e[61] = C, e[62] = c, e[63] = w, e[64] = U, e[65] = q) : q = e[65], q;
}
function ZS(t) {
  return t.stopPropagation();
}
function XS(t) {
  return t.stopPropagation();
}
const QS = ae(["flex", "w-full", "items-center", "justify-between", "px-(--spacing-24)", "py-(--spacing-16)", "rounded-(--radius-sm)", "relative", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-px", "after:bg-outline-subtle"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function qO(t) {
  const e = W.c(35);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    icon: r,
    tone: l,
    title: a,
    description: o,
    action: n,
    onDismiss: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "neutral" : l, u = c === "negative", d = u ? "alert" : "status", f = u ? "assertive" : "polite";
  let p;
  e[8] !== c ? (p = oe(QS({
    tone: c
  })), e[8] = c, e[9] = p) : p = e[9];
  let m;
  e[10] !== r ? (m = /* @__PURE__ */ g(Ge, { name: r, size: "md", tone: "inherit" }), e[10] = r, e[11] = m) : m = e[11];
  let h;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = {
    color: "inherit"
  }, e[12] = h) : h = e[12];
  let b;
  e[13] !== a ? (b = /* @__PURE__ */ g(Rn, { as: "span", size: "md", style: h, children: a }), e[13] = a, e[14] = b) : b = e[14];
  let v;
  e[15] !== o ? (v = o ? /* @__PURE__ */ g(ln, { as: "span", size: "md", style: {
    color: "inherit"
  }, children: o }) : null, e[15] = o, e[16] = v) : v = e[16];
  let C;
  e[17] !== b || e[18] !== v ? (C = /* @__PURE__ */ F("div", { className: "min-w-0 flex flex-col gap-(--spacing-8)", children: [
    b,
    v
  ] }), e[17] = b, e[18] = v, e[19] = C) : C = e[19];
  let y;
  e[20] !== m || e[21] !== C ? (y = /* @__PURE__ */ F("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    m,
    C
  ] }), e[20] = m, e[21] = C, e[22] = y) : y = e[22];
  let w;
  e[23] !== i ? (w = /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": "Dismiss banner", variant: "ghost", size: "sm", onClick: i }), e[23] = i, e[24] = w) : w = e[24];
  let R;
  e[25] !== n || e[26] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    w
  ] }), e[25] = n, e[26] = w, e[27] = R) : R = e[27];
  let S;
  return e[28] !== s || e[29] !== y || e[30] !== R || e[31] !== d || e[32] !== f || e[33] !== p ? (S = /* @__PURE__ */ F("div", { role: d, "aria-live": f, className: p, ...s, children: [
    y,
    R
  ] }), e[28] = s, e[29] = y, e[30] = R, e[31] = d, e[32] = f, e[33] = p, e[34] = S) : S = e[34], S;
}
function ZO(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("nav", { "aria-label": "Breadcrumb", "data-slot": "breadcrumb", className: "w-full min-w-0", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function XO({
  children: t,
  ref: e,
  ...n
}) {
  const o = ut(null), r = ut(null), i = ut(() => {
  }), [s, l] = tt(!1), a = ql.toArray(t), c = a.filter(H0), u = a.filter(tR), d = nR(t), f = c.length > 2 && a.length === c.length + u.length;
  i.current = function() {
    const b = o.current, v = r.current;
    if (!f || !b || !v) {
      l(!1);
      return;
    }
    const C = b.getBoundingClientRect().width, y = v.getBoundingClientRect().width;
    l(C > 0 && y > C);
  };
  function p(h) {
    o.current = h, typeof e == "function" ? e(h) : e && (e.current = h);
  }
  Po(() => {
    i.current();
  }), Po(() => {
    const h = o.current;
    if (!h || typeof ResizeObserver > "u")
      return;
    const b = new ResizeObserver(() => {
      i.current();
    });
    return b.observe(h), () => {
      b.disconnect();
    };
  }, []);
  const m = s && f ? [c[0], fm(u[0], "breadcrumb-overflow-leading-separator"), /* @__PURE__ */ g(oR, { items: c.slice(1, -1) }, "breadcrumb-overflow"), fm(u[0], "breadcrumb-overflow-trailing-separator"), c.at(-1)] : t;
  return /* @__PURE__ */ F(Ht, { children: [
    /* @__PURE__ */ g("ol", { ...n, ref: p, "data-slot": "breadcrumb-list", "data-collapsed": s && f ? "" : void 0, className: "flex w-full min-w-0 flex-nowrap items-center gap-(--spacing-8) overflow-hidden p-(--spacing-8) text-(length:--font-size-body-md) leading-(--line-height-20)", children: m }),
    f && /* @__PURE__ */ g("ol", { ref: r, "aria-hidden": "true", inert: !0, "data-slot": "breadcrumb-list-measurement", className: "pointer-events-none invisible absolute flex w-max flex-nowrap items-center gap-(--spacing-8) p-(--spacing-8) text-(length:--font-size-body-md) leading-(--line-height-20)", children: d })
  ] });
}
function JS(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("li", { "data-slot": "breadcrumb-item", className: "inline-flex min-w-0 items-center", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function eR(t) {
  const e = W.c(10);
  let n, o, r, i;
  if (e[0] !== t) {
    const {
      render: l,
      ...a
    } = t;
    i = Xd, n = "a", o = l;
    let c;
    e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = ["text-breadcrumb-text-inactive", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "no-underline", "block", "min-w-0", "max-w-full", "truncate", "whitespace-nowrap", "cursor-pointer", "transition-[color,text-decoration-color]", "hover:underline", "hover:[text-decoration-skip-ink:none]", "active:text-breadcrumb-text-inactive-pressed", "active:underline", "active:[text-decoration-skip-ink:none]", "active:[text-decoration-style:solid]", "outline-none", "focus-visible:[outline:var(--spacing-2)_solid_var(--color-breadcrumb-focus-ring)]", "focus-visible:outline-offset-[3px]", "rounded-(--radius-sm)"], e[5] = c) : c = e[5], r = en(a, {
      className: c.join(" ")
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4];
  let s;
  return e[6] !== n || e[7] !== o || e[8] !== r ? (s = {
    defaultTagName: n,
    render: o,
    props: r
  }, e[6] = n, e[7] = o, e[8] = r, e[9] = s) : s = e[9], i(s);
}
function QO(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("span", { "data-slot": "breadcrumb-page", "aria-current": "page", className: "block min-w-0 max-w-full truncate text-breadcrumb-text-active font-family-body font-semibold", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function H0(t) {
  return Zl(t) && t.type === JS;
}
function tR(t) {
  return Zl(t) && t.type === B0;
}
function z0(t) {
  return Zl(t) && t.type === eR;
}
function fm(t, e) {
  return t ? Hc(t, {
    key: e
  }) : /* @__PURE__ */ g(B0, {}, e);
}
function nR(t) {
  return ql.map(t, (e) => !H0(e) || !z0(e.props.children) ? e : Hc(e, {
    children: Hc(e.props.children, {
      tabIndex: -1
    })
  }));
}
function oR(t) {
  const e = W.c(10), {
    items: n
  } = t, [o, r] = tt(!1), i = n.length, s = `Show ${i} hidden breadcrumb ${i === 1 ? "level" : "levels"}`;
  let l;
  e[0] !== s ? (l = /* @__PURE__ */ g(Yo, { render: /* @__PURE__ */ g(gt, { "aria-label": s, icon: "ellipsis-dots-horiz", size: "sm", variant: "ghost" }) }), e[0] = s, e[1] = l) : l = e[1];
  let a;
  e[2] !== n ? (a = n.map(rR), e[2] = n, e[3] = a) : a = e[3];
  let c;
  e[4] !== a ? (c = /* @__PURE__ */ g(kr, { align: "start", size: "sm", children: a }), e[4] = a, e[5] = c) : c = e[5];
  let u;
  return e[6] !== o || e[7] !== l || e[8] !== c ? (u = /* @__PURE__ */ g("li", { "data-slot": "breadcrumb-overflow", className: "inline-flex shrink-0", children: /* @__PURE__ */ F(kd, { modal: !1, open: o, onOpenChange: r, children: [
    l,
    c
  ] }) }), e[6] = o, e[7] = l, e[8] = c, e[9] = u) : u = e[9], u;
}
function rR(t, e) {
  return /* @__PURE__ */ g(iR, { item: t }, t.key ?? e);
}
function iR(t) {
  const e = W.c(4), {
    item: n
  } = t, o = n.props.children;
  if (z0(o)) {
    let i;
    return e[0] !== o ? (i = /* @__PURE__ */ g(fr, { render: o, children: o.props.children }), e[0] = o, e[1] = i) : i = e[1], i;
  }
  let r;
  return e[2] !== o ? (r = /* @__PURE__ */ g(fr, { disabled: !0, children: o }), e[2] = o, e[3] = r) : r = e[3], r;
}
function B0(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("li", { "data-slot": "breadcrumb-separator", "aria-hidden": "true", className: "text-breadcrumb-separator font-family-label font-medium shrink-0 select-none", ...t, children: "/" }), e[0] = t, e[1] = n) : n = e[1], n;
}
function JO(t) {
  const e = W.c(16), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    actions: i,
    summary: s,
    children: l,
    footer: a
  } = t;
  let c;
  e[0] !== n ? (c = /* @__PURE__ */ g("h3", { className: "flex min-w-0 m-0", children: /* @__PURE__ */ g($0, { children: n }) }), e[0] = n, e[1] = c) : c = e[1];
  let u;
  e[2] !== i || e[3] !== o || e[4] !== s || e[5] !== c || e[6] !== r ? (u = /* @__PURE__ */ g(WS, { main: c, start: o, titleAccessory: r, actions: i, summary: s }), e[2] = i, e[3] = o, e[4] = s, e[5] = c, e[6] = r, e[7] = u) : u = e[7];
  let d;
  e[8] !== l ? (d = /* @__PURE__ */ g(L0, { padding: "none", className: "min-h-(--spacing-80)", children: l }), e[8] = l, e[9] = d) : d = e[9];
  let f;
  e[10] !== a ? (f = a && /* @__PURE__ */ g(F0, { "data-card-container-slot": "footer", children: a }), e[10] = a, e[11] = f) : f = e[11];
  let p;
  return e[12] !== u || e[13] !== d || e[14] !== f ? (p = /* @__PURE__ */ g(A0, { elevated: !0, padding: "standard", children: /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-12) w-full", children: [
    u,
    d,
    f
  ] }) }), e[12] = u, e[13] = d, e[14] = f, e[15] = p) : p = e[15], p;
}
const sR = 2, lR = 32, aR = 3;
function cR(t) {
  return !x.isValidElement(t) || t.type !== b2 ? t : x.cloneElement(t, {
    selected: t.props.selected ?? !1
  });
}
function W0(t) {
  return t.clientWidth || t.getBoundingClientRect().width;
}
function uR(t) {
  return Math.max(t.scrollWidth, t.getBoundingClientRect().width);
}
function dR(t) {
  const e = lR * sR;
  return Math.max(0, t - e);
}
function fR(t, e) {
  const n = W0(t), o = Array.from(e.children).filter((i) => i instanceof HTMLElement);
  if (n <= 0 || o.length === 0) return o.length;
  let r = 0;
  for (const i of o) {
    const s = i.offsetWidth || i.getBoundingClientRect().width;
    if (s <= 0) return o.length;
    if (i.offsetLeft + s > n) break;
    r += 1;
  }
  return Math.max(1, r);
}
function eD({
  children: t,
  ...e
}) {
  const n = x.useRef(null), o = x.useRef(null), r = x.useRef(null), i = x.useRef(() => {
  }), [s, l] = x.useState(!1), [a, c] = x.useState(0), [u, d] = x.useState(Number.POSITIVE_INFINITY), f = x.Children.toArray(t), p = f.length, m = p > 0 ? a % p : 0, h = f.map((y, w) => ({
    child: cR(y),
    key: w
  })), b = s ? [...h.slice(m), ...h.slice(0, m)] : h;
  i.current = () => {
    const y = n.current, w = o.current, R = r.current;
    if (!y || !w || !R) return;
    const S = W0(y), E = uR(R), N = dR(S), I = E > S, T = p >= aR && E > N, k = p > 1 && S > 0 && (I || T);
    l(k), d(k ? fR(w, R) : p), k || c(0);
  }, x.useLayoutEffect(() => {
    i.current();
  }), x.useLayoutEffect(() => {
    const y = n.current, w = o.current, R = r.current;
    if (!y || !w || !R || typeof ResizeObserver > "u")
      return;
    const S = new ResizeObserver(() => {
      i.current();
    });
    return S.observe(y), S.observe(w), S.observe(R), () => S.disconnect();
  }, []);
  const v = () => {
    p !== 0 && c((y) => (y + 1) % p);
  };
  return /* @__PURE__ */ F("div", { ...e, ref: n, "data-slot": "carousel", className: s ? "flex w-full items-center" : "flex w-full items-center gap-(--spacing-10)", children: [
    s && /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "chevron-left", "aria-label": "Previous Images", onClick: () => {
      p !== 0 && c((y) => (y - 1 + p) % p);
    } }),
    /* @__PURE__ */ g("div", { ref: o, "data-slot": "carousel-viewport", className: s ? "min-w-0 flex-1 overflow-hidden" : "min-w-0 max-w-full overflow-hidden", children: /* @__PURE__ */ g("div", { ref: r, "data-slot": "carousel-track", className: "relative flex w-max items-center gap-(--spacing-10) p-(--spacing-4)", children: b.map(({
      child: y,
      key: w
    }, R) => {
      const S = s && R >= u;
      return /* @__PURE__ */ g("div", { "data-slot": "carousel-item", className: "shrink-0", inert: S ? !0 : void 0, "aria-hidden": S || void 0, children: y }, w);
    }) }) }),
    s && /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "chevron-right", "aria-label": "Next Images", onClick: v })
  ] });
}
function tD(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(Pv, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
async function pR(t, e) {
  if (navigator.clipboard?.write && typeof ClipboardItem < "u")
    try {
      await navigator.clipboard.write([new ClipboardItem({
        "text/html": new Blob([e], {
          type: "text/html"
        }),
        "text/plain": new Blob([t], {
          type: "text/plain"
        })
      })]);
      return;
    } catch {
    }
  if (!navigator.clipboard?.writeText)
    throw new Error("Clipboard API is unavailable.");
  await navigator.clipboard.writeText(t);
}
function nD({
  content: t,
  onCopy: e,
  onCopyError: n,
  copyLabel: o = "Copy message",
  copiedLabel: r = "Copied message",
  ...i
}) {
  const [s, l] = tt("default"), a = ut(null);
  _t(() => () => {
    a.current !== null && clearTimeout(a.current);
  }, []);
  async function c() {
    try {
      if (t.html)
        await pR(t.text, t.html);
      else {
        if (!navigator.clipboard?.writeText)
          throw new Error("Clipboard API is unavailable.");
        await navigator.clipboard.writeText(t.text);
      }
    } catch (d) {
      l("error"), n?.(d);
      return;
    }
    l("copied"), a.current !== null && clearTimeout(a.current), a.current = setTimeout(() => l("default"), 3e3), e?.();
  }
  const u = s === "copied";
  return /* @__PURE__ */ g(gt, { "data-slot": "chat-copy-button", "data-copy-state": s, icon: u ? "check-mark" : "copy-regular", "aria-label": u ? r : o, variant: "ghost", size: "sm", onClick: c, ...i });
}
let pm = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.indeterminate = "data-indeterminate", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
function mR(t) {
  return x.useMemo(() => ({
    checked(e) {
      return t.indeterminate ? {} : e ? {
        [pm.checked]: ""
      } : {
        [pm.unchecked]: ""
      };
    },
    ...eo
  }), [t.indeterminate]);
}
const U0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (U0.displayName = "CheckboxRootContext");
const gR = "data-parent", G0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: i = !1,
    "aria-labelledby": s,
    disabled: l = !1,
    form: a,
    id: c,
    indeterminate: u = !1,
    inputRef: d,
    name: f,
    onCheckedChange: p,
    parent: m = !1,
    readOnly: h = !1,
    render: b,
    required: v = !1,
    uncheckedValue: C,
    value: y,
    nativeButton: w = !1,
    style: R,
    ...S
  } = e, {
    clearErrors: E
  } = _o(), {
    disabled: N,
    name: I,
    setDirty: T,
    setFilled: k,
    setFocused: P,
    setTouched: M,
    state: D,
    validationMode: O,
    validityData: _,
    shouldValidateOnChange: V,
    validation: A
  } = tn(), L = k2(), {
    labelId: $,
    controlId: Y,
    registerControlId: G,
    getDescriptionProps: j
  } = gn(), Z = Ky(), U = Z?.parent, q = U && Z.allValues, te = N || L.disabled || Z?.disabled || l, H = I ?? f, X = y ?? H, ee = kt(), le = kt();
  let Q = Y;
  q ? Q = m ? le : `${U.id}-${X}` : c && (Q = c);
  let re = {};
  q && (m ? re = Z.parent.getParentProps() : X && (re = Z.parent.getChildProps(X)));
  const fe = Ce(p), {
    checked: ne = o,
    indeterminate: se = u,
    onCheckedChange: pe,
    ...xe
  } = re, ce = Z?.value, he = Z?.setValue, z = Z?.defaultValue, J = x.useRef(null), B = It(() => /* @__PURE__ */ Symbol("checkbox-control")), K = x.useRef(!1), {
    getButtonProps: ie,
    buttonRef: ge
  } = Bt({
    disabled: te,
    native: w
  }), ue = Z?.validation ?? A, [Se, ve] = dn({
    controlled: X && ce && !m ? ce.includes(X) : ne,
    default: X && z && !m ? z.includes(X) : i,
    name: "Checkbox",
    state: "checked"
  });
  Ne(() => {
    G !== yt && (K.current = !0, G(B.current, Q));
  }, [Q, Z, G, m, B]), x.useEffect(() => {
    const Ee = B.current;
    return () => {
      !K.current || G === yt || (K.current = !1, G(Ee, void 0));
    };
  }, [G, B]), fi(J, {
    enabled: !Z,
    id: ee,
    value: Se
  });
  const de = x.useRef(null), me = fn(d, de, ue.inputRef), Re = Ud(s, $, de, !w, Q ?? void 0);
  Ne(() => {
    de.current && (de.current.indeterminate = se, Se && k(!0));
  }, [Se, se, k]), wo(Se, () => {
    Z && !m || (E(H), k(Se), T(Se !== _.initialValue), V() ? ue.commit(Se) : ue.commit(Se, !0));
  });
  const Ie = en(
    {
      checked: Se,
      disabled: te,
      form: a,
      // parent checkboxes unset `name` to be excluded from form submission
      name: m ? void 0 : H,
      // Set `id` to stop Chrome warning about an unassociated input.
      // When using a native button, the `id` is applied to the button instead.
      id: w ? void 0 : Q ?? void 0,
      required: v,
      ref: me,
      style: H ? ei : Jo,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      onChange(Ee) {
        if (Ee.nativeEvent.defaultPrevented)
          return;
        if (h) {
          Ee.preventDefault();
          return;
        }
        const Ve = Ee.currentTarget.checked, Me = De(Pt, Ee.nativeEvent);
        if (pe?.(Ve, Me), fe(Ve, Me), !Me.isCanceled && (ve(Ve), X && ce && he && !m && !q)) {
          const He = Ve ? [...ce, X] : ce.filter((ze) => ze !== X);
          he(He, Me);
        }
      },
      onFocus() {
        J.current?.focus();
      }
    },
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    y !== void 0 ? {
      value: (Z ? Se && y : y) || ""
    } : St,
    j,
    Z ? ue.getValidationProps : ue.getInputValidationProps
  ), Pe = q ? !!ne : Se, _e = q && se || u;
  x.useEffect(() => {
    if (!U || !X)
      return;
    const Ee = U.disabledStatesRef.current;
    return Ee.set(X, te), () => {
      Ee.delete(X);
    };
  }, [U, te, X]);
  const Ye = x.useMemo(() => ({
    ...D,
    checked: Pe,
    disabled: te,
    readOnly: h,
    required: v,
    indeterminate: _e
  }), [D, Pe, te, h, v, _e]), qe = mR(Ye), $e = Le("span", e, {
    state: Ye,
    ref: [ge, J, n, Z?.registerControlRef],
    props: [{
      id: w ? Q ?? void 0 : ee,
      role: "checkbox",
      "aria-checked": se ? "mixed" : Se,
      "aria-readonly": h || void 0,
      "aria-required": v || void 0,
      "aria-labelledby": Re,
      [gR]: m ? "" : void 0,
      onFocus() {
        P(!0);
      },
      onBlur() {
        const Ee = de.current;
        Ee && (M(!0), P(!1), O === "onBlur" && ue.commit(Z ? ce : Ee.checked));
      },
      onClick(Ee) {
        h || te || (Ee.preventDefault(), de.current?.dispatchEvent(new PointerEvent("click", {
          bubbles: !0,
          shiftKey: Ee.shiftKey,
          ctrlKey: Ee.ctrlKey,
          altKey: Ee.altKey,
          metaKey: Ee.metaKey
        })));
      }
    }, j, ue.getValidationProps, S, xe, ie],
    stateAttributesMapping: qe
  });
  return /* @__PURE__ */ F(U0.Provider, {
    value: Ye,
    children: [$e, !Se && !Z && H && !m && C !== void 0 && /* @__PURE__ */ g("input", {
      type: "hidden",
      form: a,
      name: H,
      value: C
    }), /* @__PURE__ */ g("input", {
      ...Ie,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (G0.displayName = "CheckboxRoot");
const Gl = {
  sm: "rounded-[2px]",
  md: "rounded-(--radius-sm)"
}, mm = {
  sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
  // Snap md to whole pixels to avoid SVG crossfade shimmer from 19.2px subpixel rasterization.
  md: ["w-[20px]", "h-[20px]"]
}, hR = ae([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "group/checkbox",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1px]",
  "focus-visible:ring-checkbox-focus-ring",
  "cursor-[inherit]",
  // touch target — before:inset per size to maintain WCAG 44×44px minimum
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", Gl.sm, "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", Gl.md, "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), bR = ae(["absolute", "left-1/2", "top-1/2", "z-10", "inline-flex", "-translate-x-1/2", "-translate-y-1/2", "items-center", "justify-center", "overflow-hidden", "transition-[background-color]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "group-data-[checked]/checkbox:bg-checkbox-filled-default-background", "group-data-[indeterminate]/checkbox:bg-checkbox-filled-default-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-data-[error]/checkbox:bg-error", "group-data-[disabled]/checkbox:bg-checkbox-filled-disabled-background"], {
  variants: {
    size: {
      sm: [Gl.sm, ...mm.sm],
      md: [Gl.md, ...mm.md]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), vR = ae(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-outline-hover-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), yR = ae(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-outline-pressed-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), xR = ae(["absolute", "inset-0", "h-full", "w-full", "text-checkbox-outline-default-border", "group-[:not([data-error]):not([data-disabled]):hover]/checkbox:text-checkbox-outline-hover-border", "group-[:not([data-error]):not([data-disabled]):active]/checkbox:text-checkbox-outline-pressed-border", "group-data-[error]/checkbox:text-error", "group-data-[disabled]/checkbox:text-checkbox-filled-disabled-background", "group-data-[checked]/checkbox:opacity-0", "group-data-[indeterminate]/checkbox:opacity-0", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), CR = ae(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[checked]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), wR = ae(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[indeterminate]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]);
function SR(t) {
  const e = W.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("path", { d: "M13.7143 1.14286C14.3464 1.14286 14.8571 1.65357 14.8571 2.28571V13.7143C14.8571 14.3464 14.3464 14.8571 13.7143 14.8571H2.28571C1.65357 14.8571 1.14286 14.3464 1.14286 13.7143V2.28571C1.14286 1.65357 1.65357 1.14286 2.28571 1.14286H13.7143ZM2.28571 0C1.025 0 0 1.025 0 2.28571V13.7143C0 14.975 1.025 16 2.28571 16H13.7143C14.975 16 16 14.975 16 13.7143V2.28571C16 1.025 14.975 0 13.7143 0H2.28571Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function RR(t) {
  const e = W.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function ER(t) {
  const e = W.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ g("path", { d: "M3 7V9H13V7H3Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
const gm = ae(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), NR = ae(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), kR = ae([], {
  variants: {
    size: {
      sm: [],
      md: []
    },
    labelLeft: {
      true: [],
      false: []
    }
  },
  compoundVariants: [{
    labelLeft: !1,
    size: "sm",
    className: "pl-[calc(var(--icon-sm)+var(--spacing-8))]"
  }, {
    labelLeft: !1,
    size: "md",
    className: "pl-[calc(var(--icon-md)+var(--spacing-8))]"
  }],
  defaultVariants: {
    size: "sm",
    labelLeft: !1
  }
});
function MR(t) {
  const e = W.c(69);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    error: r,
    label: s,
    description: n,
    labelLeft: l,
    size: c,
    indeterminate: i,
    disabled: o,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = Xt();
  let d;
  e[9] !== n || e[10] !== u || e[11] !== a ? (d = [a["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[9] = n, e[10] = u, e[11] = a, e[12] = d) : d = e[12];
  const f = d, p = o ? "cursor-not-allowed" : "cursor-pointer";
  let m;
  e[13] !== p ? (m = oe("inline-flex flex-col gap-(--spacing-4)", p), e[13] = p, e[14] = m) : m = e[14];
  let h;
  e[15] !== o || e[16] !== u || e[17] !== s || e[18] !== l ? (h = l && s && /* @__PURE__ */ g("span", { id: `${u}-label`, className: oe(gm(), o && "opacity-50"), children: s }), e[15] = o, e[16] = u, e[17] = s, e[18] = l, e[19] = h) : h = e[19];
  const b = s ? void 0 : a["aria-label"], v = s ? `${u}-label` : void 0, C = r || void 0, y = r ? "" : void 0;
  let w;
  e[20] !== c ? (w = oe(hR({
    size: c
  })), e[20] = c, e[21] = w) : w = e[21];
  let R;
  e[22] !== c ? (R = oe(vR({
    size: c
  })), e[22] = c, e[23] = R) : R = e[23];
  let S;
  e[24] !== R ? (S = /* @__PURE__ */ g("span", { className: R }), e[24] = R, e[25] = S) : S = e[25];
  let E;
  e[26] !== c ? (E = oe(yR({
    size: c
  })), e[26] = c, e[27] = E) : E = e[27];
  let N;
  e[28] !== E ? (N = /* @__PURE__ */ g("span", { className: E }), e[28] = E, e[29] = N) : N = e[29];
  let I;
  e[30] !== c ? (I = oe(bR({
    size: c
  })), e[30] = c, e[31] = I) : I = e[31];
  let T;
  e[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ g(SR, { className: oe(xR()) }), e[32] = T) : T = e[32];
  let k;
  e[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = /* @__PURE__ */ g(RR, { className: oe(CR()) }), e[33] = k) : k = e[33];
  let P;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ g(ER, { className: oe(wR()) }), e[34] = P) : P = e[34];
  let M;
  e[35] !== I ? (M = /* @__PURE__ */ F("span", { className: I, children: [
    T,
    k,
    P
  ] }), e[35] = I, e[36] = M) : M = e[36];
  let D;
  e[37] !== f || e[38] !== o || e[39] !== i || e[40] !== a || e[41] !== S || e[42] !== N || e[43] !== M || e[44] !== b || e[45] !== v || e[46] !== C || e[47] !== y || e[48] !== w ? (D = /* @__PURE__ */ F(G0, { ...a, indeterminate: i, disabled: o, "aria-label": b, "aria-labelledby": v, "aria-describedby": f, "aria-invalid": C, "data-error": y, className: w, children: [
    S,
    N,
    M
  ] }), e[37] = f, e[38] = o, e[39] = i, e[40] = a, e[41] = S, e[42] = N, e[43] = M, e[44] = b, e[45] = v, e[46] = C, e[47] = y, e[48] = w, e[49] = D) : D = e[49];
  let O;
  e[50] !== o || e[51] !== u || e[52] !== s || e[53] !== l ? (O = !l && s && /* @__PURE__ */ g("span", { id: `${u}-label`, className: oe(gm(), o && "opacity-50"), children: s }), e[50] = o, e[51] = u, e[52] = s, e[53] = l, e[54] = O) : O = e[54];
  let _;
  e[55] !== D || e[56] !== O || e[57] !== h ? (_ = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    h,
    D,
    O
  ] }), e[55] = D, e[56] = O, e[57] = h, e[58] = _) : _ = e[58];
  let V;
  e[59] !== n || e[60] !== o || e[61] !== u || e[62] !== l || e[63] !== c ? (V = n && /* @__PURE__ */ g("span", { id: `${u}-description`, className: oe(NR(), o && "opacity-50", kR({
    size: c,
    labelLeft: l
  })), children: n }), e[59] = n, e[60] = o, e[61] = u, e[62] = l, e[63] = c, e[64] = V) : V = e[64];
  let A;
  return e[65] !== _ || e[66] !== V || e[67] !== m ? (A = /* @__PURE__ */ F("label", { className: m, children: [
    _,
    V
  ] }), e[65] = _, e[66] = V, e[67] = m, e[68] = A) : A = e[68], A;
}
const Tf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Tf.displayName = "PopoverRootContext");
function Ts(t) {
  const e = x.useContext(Tf);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : et(47));
  return e;
}
function PR() {
  return {
    ...cs(),
    disabled: !1,
    modal: !1,
    focusManagerModal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    nested: !1,
    openOnHover: !1,
    closeDelay: 0,
    hasViewport: !1
  };
}
const IR = {
  ...us,
  disabled: be((t) => t.disabled),
  instantType: be((t) => t.instantType),
  openMethod: be((t) => t.openMethod),
  openChangeReason: be((t) => t.openChangeReason),
  modal: be((t) => t.modal),
  focusManagerModal: be((t) => t.focusManagerModal),
  stickIfOpen: be((t) => t.stickIfOpen),
  titleElementId: be((t) => t.titleElementId),
  descriptionElementId: be((t) => t.descriptionElementId),
  openOnHover: be((t) => t.openOnHover),
  closeDelay: be((t) => t.closeDelay),
  hasViewport: be((t) => t.hasViewport)
};
class Of extends wr {
  constructor(e) {
    const n = {
      ...PR(),
      ...e
    };
    n.open && e?.mounted === void 0 && (n.mounted = !0), super(n, {
      popupRef: /* @__PURE__ */ x.createRef(),
      backdropRef: /* @__PURE__ */ x.createRef(),
      internalBackdropRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerFocusTargetRef: /* @__PURE__ */ x.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ x.createRef(),
      stickIfOpenTimeout: new xn(),
      triggerElements: new Sr()
    }, IR);
  }
  setOpen = (e, n) => {
    const o = n.reason === At, r = n.reason === qn && n.event.detail === 0, i = !e && (n.reason === vr || n.reason == null);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const s = () => {
      const l = {
        open: e,
        openChangeReason: n.reason
      }, a = n.trigger?.id ?? null;
      (a || e) && (l.activeTriggerId = a, l.activeTriggerElement = n.trigger ?? null), this.update(l);
    };
    o ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(yh, () => {
      this.set("stickIfOpen", !1);
    }), an.flushSync(s)) : s(), r || i ? this.set("instantType", r ? "click" : "dismiss") : n.reason === Io ? this.set("instantType", "focus") : this.set("instantType", void 0);
  };
  static useStore(e, n) {
    const o = It(() => new Of(n)).current, r = e ?? o;
    return Qr(o.disposeEffect), r;
  }
  disposeEffect = () => this.context.stickIfOpenTimeout.disposeEffect();
}
function hm({
  props: t
}) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    modal: s = !1,
    handle: l,
    triggerId: a,
    defaultTriggerId: c = null
  } = t, u = Of.useStore(l?.store, {
    modal: s,
    open: o,
    openProp: n,
    activeTriggerId: c,
    triggerIdProp: a
  });
  Nr(() => {
    n === void 0 && u.state.open === !1 && o === !0 && u.update({
      open: !0,
      activeTriggerId: c
    });
  }), u.useControlledProp("openProp", n), u.useControlledProp("triggerIdProp", a);
  const d = u.useState("open"), f = u.useState("payload");
  u.useContextCallback("onOpenChange", r), u.useContextCallback("onOpenChangeComplete", i);
  const {
    openMethod: p,
    triggerProps: m
  } = vs(d);
  ls(u);
  const {
    forceUnmount: h
  } = as(d, u, () => {
    u.update({
      stickIfOpen: !0,
      openChangeReason: null
    });
  });
  x.useEffect(() => {
    d || u.context.stickIfOpenTimeout.clear();
  }, [u, d]);
  const b = x.useCallback(() => {
    u.setOpen(!1, De(os));
  }, [u]);
  x.useImperativeHandle(t.actionsRef, () => ({
    unmount: h,
    close: b
  }), [h, b]);
  const v = ds({
    popupStore: u,
    onOpenChange: u.setOpen
  }), C = Cr(v, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: s === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), y = hd(v), {
    getReferenceProps: w,
    getFloatingProps: R,
    getTriggerProps: S
  } = Jn([C, y]), E = x.useMemo(() => w(m), [w, m]), N = x.useMemo(() => S(m), [S, m]), I = x.useMemo(() => R(), [R]);
  u.useSyncedValues({
    modal: s,
    openMethod: p,
    activeTriggerProps: E,
    inactiveTriggerProps: N,
    popupProps: I,
    floatingRootContext: v,
    nested: bo() != null
  });
  const T = x.useMemo(() => ({
    store: u
  }), [u]);
  return /* @__PURE__ */ g(Tf.Provider, {
    value: T,
    children: typeof e == "function" ? e({
      payload: f
    }) : e
  });
}
function Df(t) {
  return Ts(!0) ? /* @__PURE__ */ g(hm, {
    props: t
  }) : /* @__PURE__ */ g(rd, {
    children: /* @__PURE__ */ g(hm, {
      props: t
    })
  });
}
const TR = 300, Sa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    handle: l,
    payload: a,
    openOnHover: c = !1,
    delay: u = TR,
    closeDelay: d = 0,
    id: f,
    style: p,
    ...m
  } = e, h = Ts(!0), b = l?.store ?? h?.store;
  if (!b)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : et(74));
  const v = kt(f), C = b.useState("isTriggerActive", v), y = b.useState("floatingRootContext"), w = b.useState("isOpenedByTrigger", v), R = x.useRef(null), {
    registerTrigger: S,
    isMountedByThisTrigger: E
  } = ss(v, R, b, {
    payload: a,
    disabled: i,
    openOnHover: c,
    closeDelay: d
  }), N = b.useState("openChangeReason"), I = b.useState("stickIfOpen"), T = b.useState("openMethod"), k = b.useState("focusManagerModal"), P = fs(y, {
    enabled: y != null && c && (T !== "touch" || N !== qn),
    mouseOnly: !0,
    move: !1,
    handleClose: ps(),
    restMs: u,
    delay: {
      close: d
    },
    triggerElementRef: R,
    isActiveTrigger: C,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), M = xr(y, {
    enabled: y != null,
    stickIfOpen: I
  }), D = Jn([M]), O = b.useState("triggerProps", E), _ = {
    disabled: i,
    open: w
  }, {
    getButtonProps: V,
    buttonRef: A
  } = Bt({
    disabled: i,
    native: s
  }), L = x.useMemo(() => ({
    open(Z) {
      return Z && N === qn ? zi.open(Z) : br.open(Z);
    }
  }), [N]), $ = Le("button", e, {
    state: _,
    ref: [A, n, S, R],
    props: [D.getReferenceProps(), P, O, {
      [Xu]: "",
      id: v
    }, m, V],
    stateAttributesMapping: L
  }), {
    preFocusGuardRef: Y,
    handlePreFocusGuardFocus: G,
    handleFocusTargetFocus: j
  } = r2(b, R);
  return C && !k ? /* @__PURE__ */ F(x.Fragment, {
    children: [/* @__PURE__ */ g(Vn, {
      ref: Y,
      onFocus: G
    }), /* @__PURE__ */ g(x.Fragment, {
      children: $
    }, v), /* @__PURE__ */ g(Vn, {
      ref: b.context.triggerFocusTargetRef,
      onFocus: j
    })]
  }) : /* @__PURE__ */ g(x.Fragment, {
    children: $
  }, v);
});
process.env.NODE_ENV !== "production" && (Sa.displayName = "PopoverTrigger");
const _f = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (_f.displayName = "PopoverPortalContext");
function OR() {
  const t = x.useContext(_f);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : et(45));
  return t;
}
const Ra = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = Ts();
  return i.useState("mounted") || o ? /* @__PURE__ */ g(_f.Provider, {
    value: o,
    children: /* @__PURE__ */ g(ti, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Ra.displayName = "PopoverPortal");
const Vf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Vf.displayName = "PopoverPositionerContext");
function DR() {
  const t = x.useContext(Vf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : et(46));
  return t;
}
const Ea = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = la,
    style: v,
    ...C
  } = e, {
    store: y
  } = Ts(), w = OR(), R = aa(), S = y.useState("floatingRootContext"), E = y.useState("mounted"), N = y.useState("open"), I = y.useState("openChangeReason"), T = y.useState("activeTriggerElement"), k = y.useState("modal"), P = y.useState("openMethod"), M = y.useState("positionerElement"), D = y.useState("instantType"), O = y.useState("transitionStatus"), _ = y.useState("hasViewport"), V = x.useRef(null), A = Ql(M, !1, !1), L = oi({
    anchor: i,
    floatingRootContext: S,
    positionMethod: s,
    mounted: E,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h,
    keepMounted: w,
    nodeId: R,
    collisionAvoidance: b,
    adaptiveOrigin: _ ? fa : void 0
  }), $ = S.useState("domReferenceElement");
  Ne(() => {
    const Z = $, U = V.current;
    if (Z && (V.current = Z), U && Z && Z !== U) {
      y.set("instantType", void 0);
      const q = new AbortController();
      return A(() => {
        y.set("instantType", "trigger-change");
      }, q.signal), () => {
        q.abort();
      };
    }
  }, [$, A, y]);
  const Y = {
    open: N,
    side: L.side,
    align: L.align,
    anchorHidden: L.anchorHidden,
    instant: D
  };
  pa(N && k === !0 && I !== At, P === "touch", M, T);
  const G = x.useCallback((Z) => {
    y.set("positionerElement", Z);
  }, [y]), j = si(e, Y, {
    styles: L.positionerStyles,
    transitionStatus: O,
    props: C,
    refs: [n, G],
    hidden: !E,
    inert: !N
  });
  return /* @__PURE__ */ F(Vf.Provider, {
    value: L,
    children: [E && k === !0 && I !== At && /* @__PURE__ */ g(ii, {
      ref: y.context.internalBackdropRef,
      inert: Er(!N),
      cutout: T
    }), /* @__PURE__ */ g(od, {
      id: R,
      children: j
    })]
  });
});
process.env.NODE_ENV !== "production" && (Ea.displayName = "PopoverPositioner");
const Y0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Y0.displayName = "ClosePartContext");
function _R() {
  const [t, e] = x.useState(0), n = Ce(() => (e((r) => r + 1), () => {
    e((r) => Math.max(0, r - 1));
  }));
  return {
    context: x.useMemo(() => ({
      register: n
    }), [n]),
    hasClosePart: t > 0
  };
}
function VR(t) {
  const {
    value: e,
    children: n
  } = t;
  return /* @__PURE__ */ g(Y0.Provider, {
    value: e,
    children: n
  });
}
const AR = {
  ...kn,
  ...zt
}, Na = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    initialFocus: i,
    finalFocus: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = Ts(), u = DR(), d = vd() != null, {
    context: f,
    hasClosePart: p
  } = _R(), m = c.useState("open"), h = c.useState("openMethod"), b = c.useState("instantType"), v = c.useState("transitionStatus"), C = c.useState("popupProps"), y = c.useState("titleElementId"), w = c.useState("descriptionElementId"), R = c.useState("modal"), S = c.useState("mounted"), E = c.useState("openChangeReason"), N = c.useState("activeTriggerElement"), I = c.useState("floatingRootContext");
  Yt({
    open: m,
    ref: c.context.popupRef,
    onComplete() {
      m && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const T = c.useState("disabled"), k = c.useState("openOnHover"), P = c.useState("closeDelay");
  ua(I, {
    enabled: k && !T,
    closeDelay: P
  });
  function M(L) {
    return L === "touch" ? c.context.popupRef.current : !0;
  }
  const D = i === void 0 ? M : i, O = {
    open: m,
    side: u.side,
    align: u.align,
    instant: b,
    transitionStatus: v
  }, _ = R !== !1 && p;
  c.useSyncedValue("focusManagerModal", _);
  const V = x.useCallback((L) => {
    c.set("popupElement", L);
  }, [c]), A = Le("div", e, {
    state: O,
    ref: [n, c.context.popupRef, V],
    props: [C, {
      "aria-labelledby": y,
      "aria-describedby": w,
      onKeyDown(L) {
        d && hs.has(L.key) && L.stopPropagation();
      }
    }, Rr(v), a],
    stateAttributesMapping: AR
  });
  return /* @__PURE__ */ g(ni, {
    context: I,
    openInteractionType: h,
    modal: _,
    disabled: !S || E === At,
    initialFocus: D,
    returnFocus: s,
    restoreFocus: "popup",
    previousFocusableElement: xt(N) ? N : void 0,
    nextFocusableElement: c.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: c.context.beforeContentFocusGuardRef,
    children: /* @__PURE__ */ g(VR, {
      value: f,
      children: A
    })
  });
});
process.env.NODE_ENV !== "production" && (Na.displayName = "PopoverPopup");
const Af = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Af.displayName = "SelectRootContext");
const Lf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Lf.displayName = "SelectFloatingContext");
function Ao() {
  const t = x.useContext(Af);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectRootContext is missing. Select parts must be placed within <Select.Root>." : et(60));
  return t;
}
function j0() {
  const t = x.useContext(Lf);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectFloatingContext is missing. Select parts must be placed within <Select.Root>." : et(61));
  return t;
}
const ct = {
  id: be((t) => t.id),
  labelId: be((t) => t.labelId),
  modal: be((t) => t.modal),
  multiple: be((t) => t.multiple),
  items: be((t) => t.items),
  itemToStringLabel: be((t) => t.itemToStringLabel),
  itemToStringValue: be((t) => t.itemToStringValue),
  isItemEqualToValue: be((t) => t.isItemEqualToValue),
  value: be((t) => t.value),
  hasSelectedValue: be((t) => {
    const {
      value: e,
      multiple: n,
      itemToStringValue: o
    } = t;
    return e == null ? !1 : n && Array.isArray(e) ? e.length > 0 : Un(e, o) !== "";
  }),
  hasNullItemLabel: be((t, e) => e ? v0(t.items) : !1),
  open: be((t) => t.open),
  mounted: be((t) => t.mounted),
  forceMount: be((t) => t.forceMount),
  transitionStatus: be((t) => t.transitionStatus),
  openMethod: be((t) => t.openMethod),
  activeIndex: be((t) => t.activeIndex),
  selectedIndex: be((t) => t.selectedIndex),
  isActive: be((t, e) => t.activeIndex === e),
  isSelected: be((t, e, n) => {
    const o = t.isItemEqualToValue, r = t.value;
    return t.multiple ? Array.isArray(r) && r.some((i) => mo(n, i, o)) : t.selectedIndex === e && t.selectedIndex !== null ? !0 : mo(n, r, o);
  }),
  isSelectedByFocus: be((t, e) => t.selectedIndex === e),
  popupProps: be((t) => t.popupProps),
  triggerProps: be((t) => t.triggerProps),
  triggerElement: be((t) => t.triggerElement),
  positionerElement: be((t) => t.positionerElement),
  listElement: be((t) => t.listElement),
  scrollUpArrowVisible: be((t) => t.scrollUpArrowVisible),
  scrollDownArrowVisible: be((t) => t.scrollDownArrowVisible),
  hasScrollArrows: be((t) => t.hasScrollArrows)
}, xo = 1;
function K0(t, e) {
  return Math.max(0, t - e);
}
function LR(t, e) {
  if (e <= 0)
    return 0;
  const n = Wt(t, 0, e), o = n, r = e - n, i = o <= xo, s = r <= xo;
  return i && s ? o <= r ? 0 : e : i ? 0 : s ? e : n;
}
function FR(t) {
  const {
    id: e,
    value: n,
    defaultValue: o = null,
    onValueChange: r,
    open: i,
    defaultOpen: s = !1,
    onOpenChange: l,
    name: a,
    form: c,
    autoComplete: u,
    disabled: d = !1,
    readOnly: f = !1,
    required: p = !1,
    modal: m = !0,
    actionsRef: h,
    inputRef: b,
    onOpenChangeComplete: v,
    items: C,
    multiple: y = !1,
    itemToStringLabel: w,
    itemToStringValue: R,
    isItemEqualToValue: S = g0,
    highlightItemOnHover: E = !0,
    children: N
  } = t, {
    clearErrors: I
  } = _o(), {
    setDirty: T,
    setTouched: k,
    setFocused: P,
    shouldValidateOnChange: M,
    validityData: D,
    setFilled: O,
    name: _,
    disabled: V,
    validation: A,
    validationMode: L
  } = tn(), $ = Mr({
    id: e
  }), Y = V || d, G = _ ?? a, [j, Z] = dn({
    controlled: n,
    default: y ? o ?? Dn : o,
    name: "Select",
    state: "value"
  }), [U, q] = dn({
    controlled: i,
    default: s,
    name: "Select",
    state: "open"
  }), te = x.useRef([]), H = x.useRef([]), X = x.useRef(null), ee = x.useRef(null), le = x.useRef(0), Q = x.useRef(null), re = x.useRef([]), fe = x.useRef(!1), ne = x.useRef(!1), se = x.useRef(null), pe = x.useRef({
    allowSelectedMouseUp: !1,
    allowUnselectedMouseUp: !1
  }), xe = x.useRef(!1), {
    mounted: ce,
    setMounted: he,
    transitionStatus: z
  } = Zn(U), {
    openMethod: J,
    triggerProps: B
  } = vs(U), K = It(() => new ud({
    id: $,
    labelId: void 0,
    modal: m,
    multiple: y,
    itemToStringLabel: w,
    itemToStringValue: R,
    isItemEqualToValue: S,
    value: j,
    open: U,
    mounted: ce,
    transitionStatus: z,
    items: C,
    forceMount: !1,
    openMethod: null,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    triggerProps: {},
    triggerElement: null,
    positionerElement: null,
    listElement: null,
    scrollUpArrowVisible: !1,
    scrollDownArrowVisible: !1,
    hasScrollArrows: !1
  })).current, ie = ye(K, ct.activeIndex), ge = ye(K, ct.selectedIndex), ue = ye(K, ct.triggerElement), Se = ye(K, ct.positionerElement), ve = l7(J), de = J ?? ve, me = x.useMemo(() => y && Array.isArray(j) && j.length === 0 ? "" : Un(j, R), [y, j, R]), Re = x.useMemo(() => y && Array.isArray(j) ? j.map((Ze) => Un(Ze, R)) : Un(j, R), [y, j, R]), Ie = Ft(K.state.triggerElement), Pe = Ce(() => Re);
  fi(Ie, {
    id: $,
    value: j,
    getValue: Pe
  });
  const _e = x.useRef(j);
  Ne(() => {
    j !== _e.current && K.set("forceMount", !0);
  }, [K, j]), Ne(() => {
    O(y ? Array.isArray(j) && j.length > 0 : j != null);
  }, [y, j, O]), Ne(function() {
    if (U)
      return;
    const Ke = re.current;
    if (y) {
      const st = Array.isArray(j) ? j : [];
      if (st.length === 0) {
        K.set("selectedIndex", null);
        return;
      }
      const mt = st[st.length - 1], ht = Mo(Ke, mt, S);
      K.set("selectedIndex", ht === -1 ? null : ht);
      return;
    }
    const nt = Mo(Ke, j, S);
    K.set("selectedIndex", nt === -1 ? null : nt);
  }, [y, U, j, re, S, K]), wo(j, () => {
    I(G), T(j !== D.initialValue), M() ? A.commit(j) : A.commit(j, !0);
  });
  const Ye = Ce((Ze, Ke) => {
    if (l?.(Ze, Ke), !Ke.isCanceled && (q(Ze), !Ze && (Ke.reason === Io || Ke.reason === ns) && (k(!0), P(!1), L === "onBlur" && A.commit(j)), !Ze && K.state.activeIndex !== null)) {
      const nt = te.current[K.state.activeIndex];
      queueMicrotask(() => {
        nt?.setAttribute("tabindex", "-1");
      });
    }
  }), qe = Ce(() => {
    he(!1), K.update({
      activeIndex: null,
      openMethod: null
    }), v?.(!1);
  });
  Yt({
    enabled: !h,
    open: U,
    ref: X,
    onComplete() {
      U || qe();
    }
  }), x.useImperativeHandle(h, () => ({
    unmount: qe
  }), [qe]);
  const $e = Ce((Ze, Ke) => {
    r?.(Ze, Ke), !Ke.isCanceled && Z(Ze);
  }), Ee = Ce(() => {
    const Ze = K.state.listElement || X.current;
    if (!Ze)
      return;
    const Ke = K0(Ze.scrollHeight, Ze.clientHeight), nt = LR(Ze.scrollTop, Ke), st = nt > 0, mt = nt < Ke;
    K.state.scrollUpArrowVisible !== st && K.set("scrollUpArrowVisible", st), K.state.scrollDownArrowVisible !== mt && K.set("scrollDownArrowVisible", mt);
  }), Ve = fd({
    open: U,
    onOpenChange: Ye,
    elements: {
      reference: ue,
      floating: Se
    }
  }), Me = xr(Ve, {
    enabled: !f && !Y,
    event: "mousedown"
  }), He = Cr(Ve, {
    bubbles: !1
  }), ze = gd(Ve, {
    enabled: !f && !Y,
    listRef: te,
    activeIndex: ie,
    selectedIndex: ge,
    disabledIndices: Dn,
    onNavigate(Ze) {
      Ze === null && !U || K.set("activeIndex", Ze);
    },
    focusItemOnHover: E
  }), Oe = bd(Ve, {
    enabled: !f && !Y && (U || !y),
    listRef: H,
    activeIndex: ie,
    selectedIndex: ge,
    onMatch(Ze) {
      U ? K.set("activeIndex", Ze) : $e(re.current[Ze], De("none"));
    },
    onTypingChange(Ze) {
      fe.current = Ze;
    }
  }), {
    getReferenceProps: wt,
    getFloatingProps: dt,
    getItemProps: we
  } = Jn([Me, He, ze, Oe]), ke = x.useMemo(() => en(wt(), B, $ ? {
    id: $
  } : St), [wt, B, $]);
  Nr(() => {
    K.update({
      popupProps: dt(),
      triggerProps: ke
    });
  }), Ne(() => {
    K.update({
      id: $,
      modal: m,
      multiple: y,
      value: j,
      open: U,
      mounted: ce,
      transitionStatus: z,
      popupProps: dt(),
      triggerProps: ke,
      items: C,
      itemToStringLabel: w,
      itemToStringValue: R,
      isItemEqualToValue: S,
      openMethod: de
    });
  }, [K, $, m, y, j, U, ce, z, dt, ke, C, w, R, S, de]);
  const Ae = x.useMemo(() => ({
    store: K,
    name: G,
    required: p,
    disabled: Y,
    readOnly: f,
    multiple: y,
    highlightItemOnHover: E,
    setValue: $e,
    setOpen: Ye,
    listRef: te,
    popupRef: X,
    scrollHandlerRef: ee,
    handleScrollArrowVisibility: Ee,
    scrollArrowsMountedCountRef: le,
    getItemProps: we,
    events: Ve.context.events,
    valueRef: Q,
    valuesRef: re,
    labelsRef: H,
    typingRef: fe,
    selectionRef: pe,
    selectedItemTextRef: se,
    validation: A,
    onOpenChangeComplete: v,
    keyboardActiveRef: ne,
    alignItemWithTriggerActiveRef: xe,
    initialValueRef: _e
  }), [K, G, p, Y, f, y, E, $e, Ye, we, Ve.context.events, A, v, Ee]), We = fn(b, A.inputRef), it = y && Array.isArray(j) && j.length > 0, je = y ? void 0 : G, ft = x.useMemo(() => !y || !Array.isArray(j) || !G ? null : j.map((Ze) => {
    const Ke = Un(Ze, R);
    return /* @__PURE__ */ g("input", {
      type: "hidden",
      form: c,
      name: G,
      value: Ke
    }, Ke);
  }), [y, j, c, G, R]);
  return /* @__PURE__ */ g(Af.Provider, {
    value: Ae,
    children: /* @__PURE__ */ F(Lf.Provider, {
      value: Ve,
      children: [N, /* @__PURE__ */ g("input", {
        ...A.getInputValidationProps({
          onFocus() {
            K.state.triggerElement?.focus({
              // Supported in Chrome from 144 (January 2026)
              focusVisible: !0
            });
          },
          // Handle browser autofill.
          onChange(Ze) {
            if (Ze.nativeEvent.defaultPrevented)
              return;
            const Ke = Ze.currentTarget.value, nt = De(Pt, Ze.nativeEvent);
            function st() {
              if (y)
                return;
              const mt = re.current.find((ht) => Un(ht, R).toLowerCase() === Ke.toLowerCase() || Jt(ht, w).toLowerCase() === Ke.toLowerCase());
              mt != null && (T(mt !== D.initialValue), $e(mt, nt), M() && A.commit(mt));
            }
            K.set("forceMount", !0), queueMicrotask(st);
          }
        }),
        id: $ && je == null ? `${$}-hidden-input` : void 0,
        form: c,
        name: je,
        autoComplete: u,
        value: me,
        disabled: Y,
        required: p && !it,
        readOnly: f,
        ref: We,
        style: G ? ei : Jo,
        tabIndex: -1,
        "aria-hidden": !0,
        suppressHydrationWarning: !0
      }), ft]
    })
  });
}
const il = 2, $R = 400, bm = 200, HR = {
  ...zi,
  ...eo,
  value: () => null
}, q0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    disabled: s = !1,
    nativeButton: l = !0,
    style: a,
    ...c
  } = e, {
    setTouched: u,
    setFocused: d,
    validationMode: f,
    state: p,
    disabled: m
  } = tn(), {
    labelId: h
  } = gn(), {
    store: b,
    setOpen: v,
    selectionRef: C,
    validation: y,
    readOnly: w,
    required: R,
    alignItemWithTriggerActiveRef: S,
    disabled: E,
    keyboardActiveRef: N
  } = Ao(), I = m || E || s, T = ye(b, ct.open), k = ye(b, ct.value), P = ye(b, ct.triggerProps), M = ye(b, ct.positionerElement), D = ye(b, ct.listElement), O = ye(b, ct.id), _ = ye(b, ct.labelId), V = ye(b, ct.hasSelectedValue), A = !V && T, L = ye(b, ct.hasNullItemLabel, A), $ = i ?? O, Y = vf(h, _);
  Mr({
    id: $
  });
  const G = Ft(M), j = x.useRef(null), {
    getButtonProps: Z,
    buttonRef: U
  } = Bt({
    disabled: I,
    native: l
  }), q = Ce((ne) => {
    b.set("triggerElement", ne);
  }), te = fn(n, j, U, q), H = Dt(), X = Dt(), ee = Dt(), le = Dt();
  x.useEffect(() => {
    if (T)
      return !(V || L) ? ee.start($R, () => {
        C.current.allowUnselectedMouseUp = !0, C.current.allowSelectedMouseUp = !0;
      }) : le.start(bm, () => {
        C.current.allowUnselectedMouseUp = !0, ee.start(bm, () => {
          C.current.allowSelectedMouseUp = !0;
        });
      }), () => {
        ee.clear(), le.clear();
      };
    C.current = {
      allowSelectedMouseUp: !1,
      allowUnselectedMouseUp: !1
    }, X.clear();
  }, [T, V, L, C, X, ee, le]);
  const Q = x.useMemo(() => D?.id ?? Wi(M)?.id, [D, M]), re = en(P, {
    id: $,
    role: "combobox",
    "aria-expanded": T ? "true" : "false",
    "aria-haspopup": "listbox",
    "aria-controls": T ? Q : void 0,
    "aria-labelledby": Y,
    "aria-readonly": w || void 0,
    "aria-required": R || void 0,
    tabIndex: I ? -1 : 0,
    ref: te,
    onFocus(ne) {
      d(!0), T && S.current && v(!1, De(Pt, ne.nativeEvent)), H.start(0, () => {
        b.set("forceMount", !0);
      });
    },
    onBlur(ne) {
      Fe(M, ne.relatedTarget) || (u(!0), d(!1), f === "onBlur" && y.commit(k));
    },
    onPointerMove() {
      N.current = !1;
    },
    onKeyDown() {
      N.current = !0;
    },
    onMouseDown(ne) {
      if (T)
        return;
      const se = Je(ne.currentTarget);
      function pe(xe) {
        if (!j.current)
          return;
        const ce = xe.target;
        if (Fe(j.current, ce) || Fe(G.current, ce) || ce === j.current)
          return;
        const he = Rd(j.current);
        xe.clientX >= he.left - il && xe.clientX <= he.right + il && xe.clientY >= he.top - il && xe.clientY <= he.bottom + il || v(!1, De(Hg, xe));
      }
      X.start(0, () => {
        se.addEventListener("mouseup", pe, {
          once: !0
        });
      });
    }
  }, y.getValidationProps, c, Z);
  re.role = "combobox";
  const fe = {
    ...p,
    open: T,
    disabled: I,
    value: k,
    readOnly: w,
    placeholder: !V
  };
  return Le("button", e, {
    ref: [n, j],
    state: fe,
    stateAttributesMapping: HR,
    props: re
  });
});
process.env.NODE_ENV !== "production" && (q0.displayName = "SelectTrigger");
const zR = {
  value: () => null
}, Z0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: i,
    placeholder: s,
    style: l,
    ...a
  } = e, {
    store: c,
    valueRef: u
  } = Ao(), d = ye(c, ct.value), f = ye(c, ct.items), p = ye(c, ct.itemToStringLabel), m = ye(c, ct.hasSelectedValue), h = !m && s != null && i == null, b = ye(c, ct.hasNullItemLabel, h), v = {
    value: d,
    placeholder: !m
  };
  let C = null;
  return typeof i == "function" ? C = i(d) : i != null ? C = i : !m && s != null && !b ? C = s : Array.isArray(d) ? C = dS(d, f, p) : C = y0(d, f, p), Le("span", e, {
    state: v,
    ref: [n, u],
    props: [{
      children: C
    }, a],
    stateAttributesMapping: zR
  });
});
process.env.NODE_ENV !== "production" && (Z0.displayName = "SelectValue");
const X0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, {
    store: l
  } = Ao(), c = {
    open: ye(l, ct.open)
  };
  return Le("span", e, {
    state: c,
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: "▼"
    }, s],
    stateAttributesMapping: br
  });
});
process.env.NODE_ENV !== "production" && (X0.displayName = "SelectIcon");
const Q0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Q0.displayName = "SelectPortalContext");
const J0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    store: o
  } = Ao(), r = ye(o, ct.mounted), i = ye(o, ct.forceMount);
  return r || i ? /* @__PURE__ */ g(Q0.Provider, {
    value: !0,
    children: /* @__PURE__ */ g(ti, {
      ref: n,
      ...e
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (J0.displayName = "SelectPortal");
const Ff = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ff.displayName = "SelectPositionerContext");
function eb() {
  const t = x.useContext(Ff);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectPositionerContext is missing. SelectPositioner parts must be placed within <Select.Positioner>." : et(59));
  return t;
}
function Yl(t, e) {
  t && Object.assign(t.style, e);
}
const tb = {
  position: "relative",
  maxHeight: "100%",
  overflowX: "hidden",
  overflowY: "auto"
}, BR = {
  position: "fixed"
}, nb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: i,
    render: s,
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f,
    arrowPadding: p = 5,
    sticky: m = !1,
    disableAnchorTracking: h,
    alignItemWithTrigger: b = !0,
    collisionAvoidance: v = Qu,
    style: C,
    ...y
  } = e, {
    store: w,
    listRef: R,
    labelsRef: S,
    alignItemWithTriggerActiveRef: E,
    selectedItemTextRef: N,
    valuesRef: I,
    initialValueRef: T,
    popupRef: k,
    setValue: P
  } = Ao(), M = j0(), D = ye(w, ct.open), O = ye(w, ct.mounted), _ = ye(w, ct.modal), V = ye(w, ct.value), A = ye(w, ct.openMethod), L = ye(w, ct.positionerElement), $ = ye(w, ct.triggerElement), Y = ye(w, ct.isItemEqualToValue), G = ye(w, ct.transitionStatus), j = x.useRef(null), Z = x.useRef(null), [U, q] = x.useState(b), te = O && U && A !== "touch";
  !O && U !== b && q(b), Ne(() => {
    O || (ct.scrollUpArrowVisible(w.state) && w.set("scrollUpArrowVisible", !1), ct.scrollDownArrowVisible(w.state) && w.set("scrollDownArrowVisible", !1));
  }, [w, O]), x.useImperativeHandle(E, () => te), pa((te || _) && D, A === "touch", L, $);
  const H = oi({
    anchor: o,
    floatingRootContext: M,
    positionMethod: r,
    mounted: O,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: m,
    disableAnchorTracking: h ?? te,
    collisionAvoidance: v,
    keepMounted: !0
  }), X = te ? "none" : H.side, ee = te ? BR : H.positionerStyles, le = {
    open: D,
    side: X,
    align: H.align,
    anchorHidden: H.anchorHidden
  }, Q = Ce((pe) => {
    w.set("positionerElement", pe);
  }), re = si(e, le, {
    styles: ee,
    transitionStatus: G,
    props: y,
    refs: [n, Q],
    hidden: !O,
    inert: !D
  }), fe = x.useRef(0), ne = Ce((pe) => {
    if (pe.size === 0 && fe.current === 0 || I.current.length === 0)
      return;
    const xe = fe.current;
    if (fe.current = pe.size, pe.size === xe)
      return;
    const ce = De(Pt);
    if (xe !== 0 && !w.state.multiple && V !== null && Mo(I.current, V, Y) === -1) {
      const z = T.current, B = z != null && Mo(I.current, z, Y) !== -1 ? z : null;
      P(B, ce), B === null && (w.set("selectedIndex", null), N.current = null);
    }
    if (xe !== 0 && w.state.multiple && Array.isArray(V)) {
      const he = (J) => Mo(I.current, J, Y) !== -1, z = V.filter((J) => he(J));
      (z.length !== V.length || z.some((J) => !h0(V, J, Y))) && (P(z, ce), z.length === 0 && (w.set("selectedIndex", null), N.current = null));
    }
    if (D && te) {
      w.update({
        scrollUpArrowVisible: !1,
        scrollDownArrowVisible: !1
      });
      const he = {
        height: ""
      };
      Yl(L, he), Yl(k.current, he);
    }
  }), se = x.useMemo(() => ({
    ...H,
    side: X,
    alignItemWithTriggerActive: te,
    setControlledAlignItemWithTrigger: q,
    scrollUpArrowRef: j,
    scrollDownArrowRef: Z
  }), [H, X, te, q]);
  return /* @__PURE__ */ g(ri, {
    elementsRef: R,
    labelsRef: S,
    onMapChange: ne,
    children: /* @__PURE__ */ F(Ff.Provider, {
      value: se,
      children: [O && _ && /* @__PURE__ */ g(ii, {
        inert: Er(!D),
        cutout: $
      }), re]
    })
  });
});
process.env.NODE_ENV !== "production" && (nb.displayName = "SelectPositioner");
const sl = "base-ui-disable-scrollbar", jl = {
  className: sl,
  getElement(t) {
    return /* @__PURE__ */ g("style", {
      nonce: t,
      href: sl,
      precedence: "base-ui:low",
      children: `.${sl}{scrollbar-width:none}.${sl}::-webkit-scrollbar{display:none}`
    });
  }
};
process.env.NODE_ENV !== "production" && (jl.getElement.displayName = "styleDisableScrollbar.getElement");
const ob = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (ob.displayName = "CSPContext");
const WR = {
  disableStyleElements: !1
};
function UR() {
  return x.useContext(ob) ?? WR;
}
const GR = {
  ...kn,
  ...zt
}, rb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    finalFocus: s,
    ...l
  } = e, {
    store: a,
    popupRef: c,
    onOpenChangeComplete: u,
    setOpen: d,
    valueRef: f,
    selectedItemTextRef: p,
    keyboardActiveRef: m,
    multiple: h,
    handleScrollArrowVisibility: b,
    scrollHandlerRef: v,
    listRef: C,
    highlightItemOnHover: y
  } = Ao(), {
    side: w,
    align: R,
    alignItemWithTriggerActive: S,
    isPositioned: E,
    setControlledAlignItemWithTrigger: N,
    scrollDownArrowRef: I,
    scrollUpArrowRef: T
  } = eb(), k = vd() != null, P = j0(), M = bs(), {
    nonce: D,
    disableStyleElements: O
  } = UR(), _ = ye(a, ct.id), V = ye(a, ct.open), A = ye(a, ct.mounted), L = ye(a, ct.popupProps), $ = ye(a, ct.transitionStatus), Y = ye(a, ct.triggerElement), G = ye(a, ct.positionerElement), j = ye(a, ct.listElement), Z = x.useRef(!1), U = x.useRef(!1), q = x.useRef({}), te = Jr(), H = Ce((Q) => {
    if (!G || !c.current || !U.current)
      return;
    if (Z.current || !S) {
      b();
      return;
    }
    const re = G.style.top === "0px", fe = G.style.bottom === "0px";
    if (!re && !fe) {
      b();
      return;
    }
    const ne = ym(G), se = Di(G.getBoundingClientRect().height, "y", ne), pe = Je(G), xe = getComputedStyle(G), ce = parseFloat(xe.marginTop), he = parseFloat(xe.marginBottom), z = vm(getComputedStyle(c.current)), J = Math.min(pe.documentElement.clientHeight - ce - he, z), B = Q.scrollTop, K = ll(Q);
    let ie = 0, ge = null, ue = !1, Se = !1;
    const ve = (Ie) => {
      G.style.height = `${Ie}px`;
    }, de = (Ie, Pe) => {
      const _e = Wt(Ie, 0, J - se);
      _e > 0 && ve(se + _e), Q.scrollTop = Pe, J - (se + _e) <= xo && (Z.current = !0), b();
    }, me = re ? K - B : B, Re = Math.min(se + me, J);
    if (ie = Re, me <= xo) {
      de(me, re ? K : 0);
      return;
    }
    if (J - Re > xo)
      re ? Se = !0 : ge = 0;
    else if (ue = !0, fe && B < K) {
      const Ie = se + me - J;
      ge = B - (me - Ie);
    }
    if (ie = Math.ceil(ie), ie !== 0 && ve(ie), Se || ge != null) {
      const Ie = ll(Q), Pe = Se ? Ie : Wt(ge, 0, Ie);
      Math.abs(Q.scrollTop - Pe) > xo && (Q.scrollTop = Pe);
    }
    (ue || ie >= J - xo) && (Z.current = !0), b();
  });
  x.useImperativeHandle(v, () => H, [H]), Yt({
    open: V,
    ref: c,
    onComplete() {
      V && u?.(!0);
    }
  });
  const X = {
    open: V,
    transitionStatus: $,
    side: w,
    align: R
  };
  Ne(() => {
    !G || !c.current || Object.keys(q.current).length || (q.current = {
      top: G.style.top || "0",
      left: G.style.left || "0",
      right: G.style.right,
      height: G.style.height,
      bottom: G.style.bottom,
      minHeight: G.style.minHeight,
      maxHeight: G.style.maxHeight,
      marginTop: G.style.marginTop,
      marginBottom: G.style.marginBottom
    });
  }, [c, G]), Ne(() => {
    V || S || (U.current = !1, Z.current = !1, Yl(G, q.current));
  }, [V, S, G, c]), Ne(() => {
    const Q = c.current;
    if (!V || !Y || !G || !Q || S && !E || a.state.transitionStatus === "ending")
      return;
    if (!S) {
      U.current = !0, te.request(b), Q.style.removeProperty("--transform-origin");
      return;
    }
    const re = YR(Q);
    Q.style.removeProperty("--transform-origin");
    try {
      const fe = p.current, ne = f.current, se = getComputedStyle(G), pe = getComputedStyle(Q), xe = Je(Y), ce = Ct(G), he = ym(Y), z = al(Y.getBoundingClientRect(), he), J = al(G.getBoundingClientRect(), he), B = z.height, K = j || Q, ie = K.scrollHeight, ge = parseFloat(pe.borderBottomWidth), ue = parseFloat(se.marginTop) || 10, Se = parseFloat(se.marginBottom) || 10, ve = parseFloat(se.minHeight) || 100, de = vm(pe), me = 5, Re = 5, Ie = 20, Pe = xe.documentElement.clientHeight - ue - Se, _e = xe.documentElement.clientWidth, Ye = Pe - z.bottom + B;
      let qe, $e = M === "rtl" ? z.right - J.width : z.left, Ee = 0;
      if (fe && ne) {
        const We = al(ne.getBoundingClientRect(), he);
        qe = al(fe.getBoundingClientRect(), he), $e = J.left + (M === "rtl" ? We.right - qe.right : We.left - qe.left);
        const it = We.top - z.top + We.height / 2;
        Ee = qe.top - J.top + qe.height / 2 - it;
      }
      const Ve = Ye + Ee + Se + ge;
      let Me = Math.min(Pe, Ve);
      const He = Pe - ue - Se, ze = Ve - Me, Oe = _e - Re;
      G.style.left = `${Wt($e, me, Oe - J.width)}px`, G.style.height = `${Me}px`, G.style.maxHeight = "auto", G.style.marginTop = `${ue}px`, G.style.marginBottom = `${Se}px`, Q.style.height = "100%";
      const wt = ll(K), dt = ze >= wt - xo;
      dt && (Me = Math.min(Pe, J.height) - (ze - wt));
      const we = z.top < Ie || z.bottom > Pe - Ie || Math.ceil(Me) + xo < Math.min(ie, ve), ke = (ce.visualViewport?.scale ?? 1) !== 1 && Fu;
      if (we || ke) {
        U.current = !0, Yl(G, q.current), N(!1);
        return;
      }
      const Ae = Math.max(ve, Me);
      if (dt) {
        const We = Math.max(0, Pe - Ve);
        G.style.top = J.height >= He ? "0" : `${We}px`, G.style.height = `${Me}px`, K.scrollTop = ll(K);
      } else
        G.style.bottom = "0", K.scrollTop = ze;
      if (qe) {
        const We = J.top, it = J.height, je = qe.top + qe.height / 2, ft = it > 0 ? (je - We) / it * 100 : 50, Ze = Wt(ft, 0, 100);
        Q.style.setProperty("--transform-origin", `50% ${Ze}%`);
      }
      (Ae === Pe || Me >= de) && (Z.current = !0), b(), y && a.state.selectedIndex === null && a.state.activeIndex === null && C.current[0] != null && a.set("activeIndex", 0), U.current = !0;
    } finally {
      re();
    }
  }, [a, V, G, Y, f, p, c, b, S, N, te, I, T, j, C, y, M, E]), x.useEffect(() => {
    if (!S || !G || !V)
      return;
    const Q = Ct(G);
    function re(fe) {
      d(!1, De(i8, fe));
    }
    return at(Q, "resize", re);
  }, [d, S, G, V]);
  const ee = {
    ...j ? {
      role: "presentation",
      "aria-orientation": void 0
    } : {
      role: "listbox",
      "aria-multiselectable": h || void 0,
      id: `${_}-list`
    },
    onKeyDown(Q) {
      m.current = !0, k && hs.has(Q.key) && Q.stopPropagation();
    },
    onMouseMove() {
      m.current = !1;
    },
    onScroll(Q) {
      j || H(Q.currentTarget);
    },
    ...S && {
      style: j ? {
        height: "100%"
      } : tb
    }
  }, le = Le("div", e, {
    ref: [n, c],
    state: X,
    stateAttributesMapping: GR,
    props: [L, ee, Rr($), {
      className: !j && S ? jl.className : void 0
    }, l]
  });
  return /* @__PURE__ */ F(x.Fragment, {
    children: [!O && jl.getElement(D), /* @__PURE__ */ g(ni, {
      context: P,
      modal: !1,
      disabled: !A,
      returnFocus: s,
      restoreFocus: !0,
      children: le
    })]
  });
});
process.env.NODE_ENV !== "production" && (rb.displayName = "SelectPopup");
function vm(t) {
  const e = t.maxHeight || "";
  return e.endsWith("px") && parseFloat(e) || 1 / 0;
}
function ll(t) {
  return K0(t.scrollHeight, t.clientHeight);
}
function ym(t) {
  return Ih.getScale(t);
}
function Di(t, e, n) {
  return t / n[e];
}
function al(t, e) {
  return Ui({
    x: Di(t.x, "x", e),
    y: Di(t.y, "y", e),
    width: Di(t.width, "x", e),
    height: Di(t.height, "y", e)
  });
}
const xm = [["transform", "none"], ["scale", "1"], ["translate", "0 0"]];
function YR(t) {
  const {
    style: e
  } = t, n = {};
  for (const [o, r] of xm)
    n[o] = e.getPropertyValue(o), e.setProperty(o, r, "important");
  return () => {
    for (const [o] of xm) {
      const r = n[o];
      r ? e.setProperty(o, r) : e.removeProperty(o);
    }
  };
}
const ib = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, {
    store: l,
    scrollHandlerRef: a
  } = Ao(), {
    alignItemWithTriggerActive: c
  } = eb(), u = ye(l, ct.hasScrollArrows), d = ye(l, ct.openMethod), f = ye(l, ct.multiple), m = {
    id: `${ye(l, ct.id)}-list`,
    role: "listbox",
    "aria-multiselectable": f || void 0,
    onScroll(b) {
      a.current?.(b.currentTarget);
    },
    ...c && {
      style: tb
    },
    className: u && d !== "touch" ? jl.className : void 0
  }, h = Ce((b) => {
    l.set("listElement", b);
  });
  return Le("div", e, {
    ref: [n, h],
    props: [m, s]
  });
});
process.env.NODE_ENV !== "production" && (ib.displayName = "SelectList");
const $f = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && ($f.displayName = "SelectItemContext");
function Hf() {
  const t = x.useContext($f);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectItemContext is missing. SelectItem parts must be placed within <Select.Item>." : et(57));
  return t;
}
const sb = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i = null,
    label: s,
    disabled: l = !1,
    nativeButton: a = !1,
    style: c,
    ...u
  } = e, d = x.useRef(null), f = Oo({
    label: s,
    textRef: d,
    indexGuessBehavior: Bu.GuessFromOrder
  }), {
    store: p,
    getItemProps: m,
    setOpen: h,
    setValue: b,
    selectionRef: v,
    typingRef: C,
    valuesRef: y,
    multiple: w,
    selectedItemTextRef: R
  } = Ao(), S = ye(p, ct.isActive, f.index), E = ye(p, ct.isSelected, f.index, i), N = ye(p, ct.isSelectedByFocus, f.index), I = ye(p, ct.isItemEqualToValue), T = f.index, k = T !== -1, P = x.useRef(null), M = Ft(T);
  Ne(() => {
    if (!k)
      return;
    const U = y.current;
    return U[T] = i, () => {
      delete U[T];
    };
  }, [k, T, i, y]), Ne(() => {
    if (!k)
      return;
    const U = p.state.value;
    let q = U;
    w && Array.isArray(U) && U.length > 0 && (q = U[U.length - 1]), q !== void 0 && mo(i, q, I) && (p.set("selectedIndex", T), d.current && (R.current = d.current));
  }, [k, T, w, I, p, i, R]);
  const D = {
    disabled: l,
    selected: E,
    highlighted: S
  }, O = m({
    active: S,
    selected: E
  });
  O.id = void 0;
  const _ = x.useRef(null), V = x.useRef("mouse"), A = x.useRef(!1), {
    getButtonProps: L,
    buttonRef: $
  } = Bt({
    disabled: l,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  });
  function Y(U) {
    const q = p.state.value;
    if (w) {
      const te = Array.isArray(q) ? q : [], H = E ? b0(te, i, I) : [...te, i];
      b(H, De(Wo, U));
    } else
      b(i, De(Wo, U)), h(!1, De(Wo, U));
  }
  const G = {
    role: "option",
    "aria-selected": E,
    tabIndex: S ? 0 : -1,
    onTouchStart() {
      v.current = {
        allowSelectedMouseUp: !1,
        allowUnselectedMouseUp: !1
      };
    },
    onKeyDown(U) {
      _.current = U.key, p.set("activeIndex", T), U.key === " " && C.current && U.preventDefault();
    },
    onClick(U) {
      A.current = !1, !(U.type === "keydown" && _.current === null) && (l || U.type === "keydown" && _.current === " " && C.current || V.current !== "touch" && !S || (_.current = null, Y(U.nativeEvent)));
    },
    onPointerEnter(U) {
      V.current = U.pointerType;
    },
    onPointerDown(U) {
      V.current = U.pointerType, A.current = !0;
    },
    onMouseUp() {
      if (l)
        return;
      if (A.current) {
        A.current = !1;
        return;
      }
      const U = !v.current.allowSelectedMouseUp && E, q = !v.current.allowUnselectedMouseUp && !E;
      U || q || V.current !== "touch" && !S || P.current?.click();
    }
  }, j = Le("div", e, {
    ref: [$, n, f.ref, P],
    state: D,
    props: [O, G, u, L]
  }), Z = x.useMemo(() => ({
    selected: E,
    indexRef: M,
    textRef: d,
    selectedByFocus: N,
    hasRegistered: k
  }), [E, M, d, N, k]);
  return /* @__PURE__ */ g($f.Provider, {
    value: Z,
    children: j
  });
}));
process.env.NODE_ENV !== "production" && (sb.displayName = "SelectItem");
const lb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const o = e.keepMounted ?? !1, {
    selected: r
  } = Hf();
  return o || r ? /* @__PURE__ */ g(ab, {
    ...e,
    ref: n
  }) : null;
});
process.env.NODE_ENV !== "production" && (lb.displayName = "SelectItemIndicator");
const ab = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef((t, e) => {
  const {
    render: n,
    className: o,
    style: r,
    keepMounted: i,
    ...s
  } = t, {
    selected: l
  } = Hf(), a = x.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = Zn(l), f = Le("span", t, {
    ref: [e, a],
    state: {
      selected: l,
      transitionStatus: c
    },
    props: [{
      "aria-hidden": !0,
      children: "✔️"
    }, s],
    stateAttributesMapping: zt
  });
  return Yt({
    open: l,
    ref: a,
    onComplete() {
      l || u(!1);
    }
  }), f;
}));
process.env.NODE_ENV !== "production" && (ab.displayName = "Inner");
const cb = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    indexRef: o,
    textRef: r,
    selectedByFocus: i,
    hasRegistered: s
  } = Hf(), {
    selectedItemTextRef: l
  } = Ao(), {
    className: a,
    render: c,
    style: u,
    ...d
  } = e, f = x.useCallback((m) => {
    if (!m || !s)
      return;
    const h = l.current === null || !l.current.isConnected;
    (i || h && o.current === 0) && (l.current = m);
  }, [l, o, i, s]);
  return Le("div", e, {
    ref: [f, n, r],
    props: d
  });
}));
process.env.NODE_ENV !== "production" && (cb.displayName = "SelectItemText");
function jR(t, e, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: t,
    timeZoneName: n
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const KR = {}, _i = {};
function ur(t, e) {
  try {
    const o = (KR[t] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: t,
      timeZoneName: "longOffset"
    }).format)(e).split("GMT")[1];
    return o in _i ? _i[o] : Cm(o, o.split(":"));
  } catch {
    if (t in _i) return _i[t];
    const n = t?.match(qR);
    return n ? Cm(t, n.slice(1)) : NaN;
  }
}
const qR = /([+-]\d\d):?(\d\d)?/;
function Cm(t, e) {
  const n = +(e[0] || 0), o = +(e[1] || 0), r = +(e[2] || 0) / 60;
  return _i[t] = n * 60 + o > 0 ? n * 60 + o + r : n * 60 - o - r;
}
class so extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(ur(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), ub(this), fu(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new so(...n, e) : new so(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new so(+this, e);
  }
  getTimezoneOffset() {
    const e = -ur(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), fu(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new so(+new Date(e), this.timeZone);
  }
  //#endregion
}
const wm = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!wm.test(t)) return;
  const e = t.replace(wm, "$1UTC");
  so.prototype[e] && (t.startsWith("get") ? so.prototype[t] = function() {
    return this.internal[e]();
  } : (so.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), ZR(this), +this;
  }, so.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), fu(this), +this;
  }));
});
function fu(t) {
  t.internal.setTime(+t), t.internal.setUTCSeconds(t.internal.getUTCSeconds() - Math.round(-ur(t.timeZone, t) * 60));
}
function ZR(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), ub(t);
}
function ub(t) {
  const e = ur(t.timeZone, t), n = e > 0 ? Math.floor(e) : Math.ceil(e), o = /* @__PURE__ */ new Date(+t);
  o.setUTCHours(o.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+o)).getTimezoneOffset(), s = r - i, l = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  s && l && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + s);
  const a = r - n;
  a && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + a);
  const c = /* @__PURE__ */ new Date(+t);
  c.setUTCSeconds(0);
  const u = r > 0 ? c.getSeconds() : (c.getSeconds() - 60) % 60, d = Math.round(-(ur(t.timeZone, t) * 60)) % 60;
  (d || u) && (t.internal.setUTCSeconds(t.internal.getUTCSeconds() + d), Date.prototype.setUTCSeconds.call(t, Date.prototype.getUTCSeconds.call(t) + d + u));
  const f = ur(t.timeZone, t), p = f > 0 ? Math.floor(f) : Math.ceil(f), h = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - p, b = p !== n, v = h - a;
  if (b && v) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + v);
    const C = ur(t.timeZone, t), y = C > 0 ? Math.floor(C) : Math.ceil(C), w = p - y;
    w && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + w), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + w));
  }
}
class sn extends so {
  //#region static
  static tz(e, ...n) {
    return n.length ? new sn(...n, e) : new sn(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, o] = this.tzComponents(), r = `${e}${n}:${o}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, o, r] = this.internal.toUTCString().split(" ");
    return `${e?.slice(0, -1)} ${o} ${n} ${r}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, o, r] = this.tzComponents();
    return `${e} GMT${n}${o}${r} (${jR(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", o = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), r = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, o, r];
  }
  //#endregion
  withTimeZone(e) {
    return new sn(+this, e);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new sn(+new Date(e), this.timeZone);
  }
  //#endregion
}
const db = 6048e5, XR = 864e5, Sm = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Gt(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Sm in t ? t[Sm](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Mt(t, e) {
  return Gt(e || t, t);
}
function fb(t, e, n) {
  const o = Mt(t, n?.in);
  return isNaN(e) ? Gt(t, NaN) : (e && o.setDate(o.getDate() + e), o);
}
function pb(t, e, n) {
  const o = Mt(t, n?.in);
  if (isNaN(e)) return Gt(t, NaN);
  if (!e)
    return o;
  const r = o.getDate(), i = Gt(t, o.getTime());
  i.setMonth(o.getMonth() + e + 1, 0);
  const s = i.getDate();
  return r >= s ? i : (o.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), o);
}
let QR = {};
function Os() {
  return QR;
}
function Xr(t, e) {
  const n = Os(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = Mt(t, e?.in), i = r.getDay(), s = (i < o ? 7 : 0) + i - o;
  return r.setDate(r.getDate() - s), r.setHours(0, 0, 0, 0), r;
}
function Xi(t, e) {
  return Xr(t, { ...e, weekStartsOn: 1 });
}
function mb(t, e) {
  const n = Mt(t, e?.in), o = n.getFullYear(), r = Gt(n, 0);
  r.setFullYear(o + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = Xi(r), s = Gt(n, 0);
  s.setFullYear(o, 0, 4), s.setHours(0, 0, 0, 0);
  const l = Xi(s);
  return n.getTime() >= i.getTime() ? o + 1 : n.getTime() >= l.getTime() ? o : o - 1;
}
function Rm(t) {
  const e = Mt(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function hi(t, ...e) {
  const n = Gt.bind(
    null,
    e.find((o) => typeof o == "object")
  );
  return e.map(n);
}
function Qi(t, e) {
  const n = Mt(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function zf(t, e, n) {
  const [o, r] = hi(
    n?.in,
    t,
    e
  ), i = Qi(o), s = Qi(r), l = +i - Rm(i), a = +s - Rm(s);
  return Math.round((l - a) / XR);
}
function JR(t, e) {
  const n = mb(t, e), o = Gt(t, 0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), Xi(o);
}
function eE(t, e, n) {
  return fb(t, e * 7, n);
}
function tE(t, e, n) {
  return pb(t, e * 12, n);
}
function nE(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Gt.bind(null, r));
    const i = Mt(r, o);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), Gt(o, n || NaN);
}
function oE(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Gt.bind(null, r));
    const i = Mt(r, o);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), Gt(o, n || NaN);
}
function rE(t, e, n) {
  const [o, r] = hi(
    n?.in,
    t,
    e
  );
  return +Qi(o) == +Qi(r);
}
function gb(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function iE(t) {
  return !(!gb(t) && typeof t != "number" || isNaN(+Mt(t)));
}
function hb(t, e, n) {
  const [o, r] = hi(
    n?.in,
    t,
    e
  ), i = o.getFullYear() - r.getFullYear(), s = o.getMonth() - r.getMonth();
  return i * 12 + s;
}
function sE(t, e) {
  const n = Mt(t, e?.in), o = n.getMonth();
  return n.setFullYear(n.getFullYear(), o + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function bb(t, e) {
  const [n, o] = hi(t, e.start, e.end);
  return { start: n, end: o };
}
function lE(t, e) {
  const { start: n, end: o } = bb(e?.in, t);
  let r = +n > +o;
  const i = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setDate(1);
  let l = 1;
  const a = [];
  for (; +s <= i; )
    a.push(Gt(n, s)), s.setMonth(s.getMonth() + l);
  return r ? a.reverse() : a;
}
function aE(t, e) {
  const n = Mt(t, e?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function cE(t, e) {
  const n = Mt(t, e?.in), o = n.getFullYear();
  return n.setFullYear(o + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function vb(t, e) {
  const n = Mt(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function uE(t, e) {
  const { start: n, end: o } = bb(e?.in, t);
  let r = +n > +o;
  const i = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setMonth(0, 1);
  let l = 1;
  const a = [];
  for (; +s <= i; )
    a.push(Gt(n, s)), s.setFullYear(s.getFullYear() + l);
  return r ? a.reverse() : a;
}
function yb(t, e) {
  const n = Os(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = Mt(t, e?.in), i = r.getDay(), s = (i < o ? -7 : 0) + 6 - (i - o);
  return r.setDate(r.getDate() + s), r.setHours(23, 59, 59, 999), r;
}
function dE(t, e) {
  return yb(t, { ...e, weekStartsOn: 1 });
}
const fE = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, pE = (t, e, n) => {
  let o;
  const r = fE[t];
  return typeof r == "string" ? o = r : e === 1 ? o = r.one : o = r.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function bc(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const mE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, gE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, hE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, bE = {
  date: bc({
    formats: mE,
    defaultWidth: "full"
  }),
  time: bc({
    formats: gE,
    defaultWidth: "full"
  }),
  dateTime: bc({
    formats: hE,
    defaultWidth: "full"
  })
}, vE = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, yE = (t, e, n, o) => vE[t];
function Ei(t) {
  return (e, n) => {
    const o = n?.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, l = n?.width ? String(n.width) : s;
      r = t.formattingValues[l] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, l = n?.width ? String(n.width) : t.defaultWidth;
      r = t.values[l] || t.values[s];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[i];
  };
}
const xE = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, CE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, wE = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, SE = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, RE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, EE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, NE = (t, e) => {
  const n = Number(t), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, kE = {
  ordinalNumber: NE,
  era: Ei({
    values: xE,
    defaultWidth: "wide"
  }),
  quarter: Ei({
    values: CE,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: Ei({
    values: wE,
    defaultWidth: "wide"
  }),
  day: Ei({
    values: SE,
    defaultWidth: "wide"
  }),
  dayPeriod: Ei({
    values: RE,
    defaultWidth: "wide",
    formattingValues: EE,
    defaultFormattingWidth: "wide"
  })
};
function Ni(t) {
  return (e, n = {}) => {
    const o = n.width, r = o && t.matchPatterns[o] || t.matchPatterns[t.defaultMatchWidth], i = e.match(r);
    if (!i)
      return null;
    const s = i[0], l = o && t.parsePatterns[o] || t.parsePatterns[t.defaultParseWidth], a = Array.isArray(l) ? PE(l, (d) => d.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      ME(l, (d) => d.test(s))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(a) : a, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(s.length);
    return { value: c, rest: u };
  };
}
function ME(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function PE(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function IE(t) {
  return (e, n = {}) => {
    const o = e.match(t.matchPattern);
    if (!o) return null;
    const r = o[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let s = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const l = e.slice(r.length);
    return { value: s, rest: l };
  };
}
const TE = /^(\d+)(th|st|nd|rd)?/i, OE = /\d+/i, DE = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, _E = {
  any: [/^b/i, /^(a|c)/i]
}, VE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, AE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, LE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, FE = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, $E = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, HE = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, zE = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, BE = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, WE = {
  ordinalNumber: IE({
    matchPattern: TE,
    parsePattern: OE,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Ni({
    matchPatterns: DE,
    defaultMatchWidth: "wide",
    parsePatterns: _E,
    defaultParseWidth: "any"
  }),
  quarter: Ni({
    matchPatterns: VE,
    defaultMatchWidth: "wide",
    parsePatterns: AE,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Ni({
    matchPatterns: LE,
    defaultMatchWidth: "wide",
    parsePatterns: FE,
    defaultParseWidth: "any"
  }),
  day: Ni({
    matchPatterns: $E,
    defaultMatchWidth: "wide",
    parsePatterns: HE,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ni({
    matchPatterns: zE,
    defaultMatchWidth: "any",
    parsePatterns: BE,
    defaultParseWidth: "any"
  })
}, Dr = {
  code: "en-US",
  formatDistance: pE,
  formatLong: bE,
  formatRelative: yE,
  localize: kE,
  match: WE,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function UE(t, e) {
  const n = Mt(t, e?.in);
  return zf(n, vb(n)) + 1;
}
function Bf(t, e) {
  const n = Mt(t, e?.in), o = +Xi(n) - +JR(n);
  return Math.round(o / db) + 1;
}
function xb(t, e) {
  const n = Mt(t, e?.in), o = n.getFullYear(), r = Os(), i = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = Gt(e?.in || t, 0);
  s.setFullYear(o + 1, 0, i), s.setHours(0, 0, 0, 0);
  const l = Xr(s, e), a = Gt(e?.in || t, 0);
  a.setFullYear(o, 0, i), a.setHours(0, 0, 0, 0);
  const c = Xr(a, e);
  return +n >= +l ? o + 1 : +n >= +c ? o : o - 1;
}
function GE(t, e) {
  const n = Os(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = xb(t, e), i = Gt(e?.in || t, 0);
  return i.setFullYear(r, 0, o), i.setHours(0, 0, 0, 0), Xr(i, e);
}
function Wf(t, e) {
  const n = Mt(t, e?.in), o = +Xr(n, e) - +GE(n, e);
  return Math.round(o / db) + 1;
}
function Rt(t, e) {
  const n = t < 0 ? "-" : "", o = Math.abs(t).toString().padStart(e, "0");
  return n + o;
}
const Fo = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), o = n > 0 ? n : 1 - n;
    return Rt(e === "yy" ? o % 100 : o, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : Rt(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Rt(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Rt(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Rt(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Rt(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Rt(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, o = t.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return Rt(r, e.length);
  }
}, Tr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Em = {
  // Era
  G: function(t, e, n) {
    const o = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const o = t.getFullYear(), r = o > 0 ? o : 1 - o;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return Fo.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, o) {
    const r = xb(t, o), i = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const s = i % 100;
      return Rt(s, 2);
    }
    return e === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Rt(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = mb(t);
    return Rt(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return Rt(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return Rt(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return Rt(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Fo.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return Rt(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, o) {
    const r = Wf(t, o);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : Rt(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const o = Bf(t);
    return e === "Io" ? n.ordinalNumber(o, { unit: "week" }) : Rt(o, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Fo.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const o = UE(t);
    return e === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : Rt(o, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const o = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, o) {
    const r = t.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Rt(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, o) {
    const r = t.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Rt(i, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const o = t.getDay(), r = o === 0 ? 7 : o;
    switch (e) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return Rt(r, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o === 12 ? r = Tr.noon : o === 0 ? r = Tr.midnight : r = o / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o >= 17 ? r = Tr.evening : o >= 12 ? r = Tr.afternoon : o >= 4 ? r = Tr.morning : r = Tr.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let o = t.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return Fo.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Fo.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const o = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : Rt(o, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let o = t.getHours();
    return o === 0 && (o = 24), e === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : Rt(o, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Fo.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Fo.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Fo.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const o = t.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return km(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return lr(o);
      // Hours and minutes with `:` delimiter
      default:
        return lr(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return km(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return lr(o);
      // Hours and minutes with `:` delimiter
      default:
        return lr(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Nm(o, ":");
      default:
        return "GMT" + lr(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Nm(o, ":");
      default:
        return "GMT" + lr(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const o = Math.trunc(+t / 1e3);
    return Rt(o, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return Rt(+t, e.length);
  }
};
function Nm(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = Math.trunc(o / 60), i = o % 60;
  return i === 0 ? n + String(r) : n + String(r) + e + Rt(i, 2);
}
function km(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Rt(Math.abs(t) / 60, 2) : lr(t, e);
}
function lr(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = Rt(Math.trunc(o / 60), 2), i = Rt(o % 60, 2);
  return n + r + e + i;
}
const Mm = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    default:
      return e.date({ width: "full" });
  }
}, Cb = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    default:
      return e.time({ width: "full" });
  }
}, YE = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], o = n[1], r = n[2];
  if (!r)
    return Mm(t, e);
  let i;
  switch (o) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Mm(o, e)).replace("{{time}}", Cb(r, e));
}, jE = {
  p: Cb,
  P: YE
}, KE = /^D+$/, qE = /^Y+$/, ZE = ["D", "DD", "YY", "YYYY"];
function XE(t) {
  return KE.test(t);
}
function QE(t) {
  return qE.test(t);
}
function JE(t, e, n) {
  const o = eN(t, e, n);
  if (console.warn(o), ZE.includes(t)) throw new RangeError(o);
}
function eN(t, e, n) {
  const o = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const tN = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, nN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, oN = /^'([^]*?)'?$/, rN = /''/g, iN = /[a-zA-Z]/;
function Vi(t, e, n) {
  const o = Os(), r = n?.locale ?? o.locale ?? Dr, i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, s = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, l = Mt(t, n?.in);
  if (!iE(l))
    throw new RangeError("Invalid time value");
  let a = e.match(nN).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const f = jE[d];
      return f(u, r.formatLong);
    }
    return u;
  }).join("").match(tN).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: sN(u) };
    if (Em[d])
      return { isToken: !0, value: u };
    if (d.match(iN))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  r.localize.preprocessor && (a = r.localize.preprocessor(l, a));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: r
  };
  return a.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (!n?.useAdditionalWeekYearTokens && QE(d) || !n?.useAdditionalDayOfYearTokens && XE(d)) && JE(d, e, String(t));
    const f = Em[d[0]];
    return f(l, d, r.localize, c);
  }).join("");
}
function sN(t) {
  const e = t.match(oN);
  return e ? e[1].replace(rN, "'") : t;
}
function lN(t, e) {
  const n = Mt(t, e?.in), o = n.getFullYear(), r = n.getMonth(), i = Gt(n, 0);
  return i.setFullYear(o, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function aN(t, e) {
  return Mt(t, e?.in).getMonth();
}
function cN(t, e) {
  return Mt(t, e?.in).getFullYear();
}
function uN(t, e) {
  return +Mt(t) > +Mt(e);
}
function dN(t, e) {
  return +Mt(t) < +Mt(e);
}
function fN(t, e, n) {
  const [o, r] = hi(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear() && o.getMonth() === r.getMonth();
}
function pN(t, e, n) {
  const [o, r] = hi(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear();
}
function mN(t, e, n) {
  const o = Mt(t, n?.in), r = o.getFullYear(), i = o.getDate(), s = Gt(t, 0);
  s.setFullYear(r, e, 15), s.setHours(0, 0, 0, 0);
  const l = lN(s);
  return o.setMonth(e, Math.min(i, l)), o;
}
function gN(t, e, n) {
  const o = Mt(t, n?.in);
  return isNaN(+o) ? Gt(t, NaN) : (o.setFullYear(e), o);
}
const Pm = 5, hN = 4;
function bN(t, e) {
  const n = e.startOfMonth(t), o = n.getDay() > 0 ? n.getDay() : 7, r = e.addDays(t, -o + 1), i = e.addDays(r, Pm * 7 - 1);
  return e.getMonth(t) === e.getMonth(i) ? Pm : hN;
}
function wb(t, e) {
  const n = e.startOfMonth(t), o = n.getDay();
  return o === 1 ? n : o === 0 ? e.addDays(n, -6) : e.addDays(n, -1 * (o - 1));
}
function vN(t, e) {
  const n = wb(t, e), o = bN(t, e);
  return e.addDays(n, o * 7 - 1);
}
const Sb = {
  ...Dr,
  labels: {
    labelDayButton: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, l) => Vi(s, l, { locale: Dr, ...n });
      let i = r(t, "PPPP");
      return e.today && (i = `Today, ${i}`), e.selected && (i = `${i}, selected`), i;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (t) => `Week ${t}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, i) => Vi(r, i, { locale: Dr, ...e }), o(t, "LLLL yyyy");
    },
    labelGridcell: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, l) => Vi(s, l, { locale: Dr, ...n });
      let i = r(t, "PPPP");
      return e?.today && (i = `Today, ${i}`), i;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, i) => Vi(r, i, { locale: Dr, ...e }), o(t, "cccc");
    }
  }
};
class En {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(e, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? sn.tz(this.options.timeZone) : new this.Date(), this.newDate = (o, r, i) => this.overrides?.newDate ? this.overrides.newDate(o, r, i) : this.options.timeZone ? new sn(o, r, i, this.options.timeZone) : new Date(o, r, i), this.addDays = (o, r) => this.overrides?.addDays ? this.overrides.addDays(o, r) : fb(o, r), this.addMonths = (o, r) => this.overrides?.addMonths ? this.overrides.addMonths(o, r) : pb(o, r), this.addWeeks = (o, r) => this.overrides?.addWeeks ? this.overrides.addWeeks(o, r) : eE(o, r), this.addYears = (o, r) => this.overrides?.addYears ? this.overrides.addYears(o, r) : tE(o, r), this.differenceInCalendarDays = (o, r) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(o, r) : zf(o, r), this.differenceInCalendarMonths = (o, r) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(o, r) : hb(o, r), this.eachMonthOfInterval = (o) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(o) : lE(o), this.eachYearOfInterval = (o) => {
      const r = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(o) : uE(o), i = new Set(r.map((l) => this.getYear(l)));
      if (i.size === r.length)
        return r;
      const s = [];
      return i.forEach((l) => {
        s.push(new Date(l, 0, 1));
      }), s;
    }, this.endOfBroadcastWeek = (o) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(o) : vN(o, this), this.endOfISOWeek = (o) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(o) : dE(o), this.endOfMonth = (o) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(o) : sE(o), this.endOfWeek = (o, r) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(o, r) : yb(o, this.options), this.endOfYear = (o) => this.overrides?.endOfYear ? this.overrides.endOfYear(o) : cE(o), this.format = (o, r, i) => {
      const s = this.overrides?.format ? this.overrides.format(o, r, this.options) : Vi(o, r, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(s) : s;
    }, this.getISOWeek = (o) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(o) : Bf(o), this.getMonth = (o, r) => this.overrides?.getMonth ? this.overrides.getMonth(o, this.options) : aN(o, this.options), this.getYear = (o, r) => this.overrides?.getYear ? this.overrides.getYear(o, this.options) : cN(o, this.options), this.getWeek = (o, r) => this.overrides?.getWeek ? this.overrides.getWeek(o, this.options) : Wf(o, this.options), this.isAfter = (o, r) => this.overrides?.isAfter ? this.overrides.isAfter(o, r) : uN(o, r), this.isBefore = (o, r) => this.overrides?.isBefore ? this.overrides.isBefore(o, r) : dN(o, r), this.isDate = (o) => this.overrides?.isDate ? this.overrides.isDate(o) : gb(o), this.isSameDay = (o, r) => this.overrides?.isSameDay ? this.overrides.isSameDay(o, r) : rE(o, r), this.isSameMonth = (o, r) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(o, r) : fN(o, r), this.isSameYear = (o, r) => this.overrides?.isSameYear ? this.overrides.isSameYear(o, r) : pN(o, r), this.max = (o) => this.overrides?.max ? this.overrides.max(o) : nE(o), this.min = (o) => this.overrides?.min ? this.overrides.min(o) : oE(o), this.setMonth = (o, r) => this.overrides?.setMonth ? this.overrides.setMonth(o, r) : mN(o, r), this.setYear = (o, r) => this.overrides?.setYear ? this.overrides.setYear(o, r) : gN(o, r), this.startOfBroadcastWeek = (o, r) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(o, this) : wb(o, this), this.startOfDay = (o) => this.overrides?.startOfDay ? this.overrides.startOfDay(o) : Qi(o), this.startOfISOWeek = (o) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(o) : Xi(o), this.startOfMonth = (o) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(o) : aE(o), this.startOfWeek = (o, r) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(o, this.options) : Xr(o, this.options), this.startOfYear = (o) => this.overrides?.startOfYear ? this.overrides.startOfYear(o) : vb(o), this.options = { locale: Sb, ...e }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), o = {};
    for (let r = 0; r < 10; r++)
      o[r.toString()] = n.format(r);
    return o;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(e) {
    const n = this.getDigitMap();
    return e.replace(/\d/g, (o) => n[o] || o);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const e = this.options.locale?.code;
    return e && En.yearFirstLocales.has(e) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(e) {
    const { locale: n, timeZone: o, numerals: r } = this.options, i = n?.code;
    if (i && En.yearFirstLocales.has(i))
      try {
        return new Intl.DateTimeFormat(i, {
          month: "long",
          year: "numeric",
          timeZone: o,
          numberingSystem: r
        }).format(e);
      } catch {
      }
    const s = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(e, s);
  }
}
En.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const vo = new En();
class Rb {
  constructor(e, n, o = vo) {
    this.date = e, this.displayMonth = n, this.outside = !!(n && !o.isSameMonth(e, n)), this.dateLib = o, this.isoDate = o.format(e, "yyyy-MM-dd"), this.displayMonthId = o.format(n, "yyyy-MM"), this.dateMonthId = o.format(e, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class yN {
  constructor(e, n) {
    this.date = e, this.weeks = n;
  }
}
class xN {
  constructor(e, n) {
    this.days = n, this.weekNumber = e;
  }
}
function CN(t) {
  return Be.createElement("button", { ...t });
}
function wN(t) {
  return Be.createElement("span", { ...t });
}
function SN(t) {
  const { size: e = 24, orientation: n = "left", className: o } = t;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    Be.createElement(
      "svg",
      { className: o, width: e, height: e, viewBox: "0 0 24 24" },
      n === "up" && Be.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && Be.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && Be.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && Be.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function RN(t) {
  const { day: e, modifiers: n, ...o } = t;
  return Be.createElement("td", { ...o });
}
function EN(t) {
  const { day: e, modifiers: n, ...o } = t, r = Be.useRef(null);
  return Be.useEffect(() => {
    n.focused && r.current?.focus();
  }, [n.focused]), Be.createElement("button", { ref: r, ...o });
}
var Qe;
(function(t) {
  t.Root = "root", t.Chevron = "chevron", t.Day = "day", t.DayButton = "day_button", t.CaptionLabel = "caption_label", t.Dropdowns = "dropdowns", t.Dropdown = "dropdown", t.DropdownRoot = "dropdown_root", t.Footer = "footer", t.MonthGrid = "month_grid", t.MonthCaption = "month_caption", t.MonthsDropdown = "months_dropdown", t.Month = "month", t.Months = "months", t.Nav = "nav", t.NextMonthButton = "button_next", t.PreviousMonthButton = "button_previous", t.Week = "week", t.Weeks = "weeks", t.Weekday = "weekday", t.Weekdays = "weekdays", t.WeekNumber = "week_number", t.WeekNumberHeader = "week_number_header", t.YearsDropdown = "years_dropdown";
})(Qe || (Qe = {}));
var Ot;
(function(t) {
  t.disabled = "disabled", t.hidden = "hidden", t.outside = "outside", t.focused = "focused", t.today = "today";
})(Ot || (Ot = {}));
var Gn;
(function(t) {
  t.range_end = "range_end", t.range_middle = "range_middle", t.range_start = "range_start", t.selected = "selected";
})(Gn || (Gn = {}));
var wn;
(function(t) {
  t.weeks_before_enter = "weeks_before_enter", t.weeks_before_exit = "weeks_before_exit", t.weeks_after_enter = "weeks_after_enter", t.weeks_after_exit = "weeks_after_exit", t.caption_after_enter = "caption_after_enter", t.caption_after_exit = "caption_after_exit", t.caption_before_enter = "caption_before_enter", t.caption_before_exit = "caption_before_exit";
})(wn || (wn = {}));
function NN(t) {
  const { options: e, className: n, components: o, classNames: r, ...i } = t, s = [r[Qe.Dropdown], n].join(" "), l = e?.find(({ value: a }) => a === i.value);
  return Be.createElement(
    "span",
    { "data-disabled": i.disabled, className: r[Qe.DropdownRoot] },
    Be.createElement(o.Select, { className: s, ...i }, e?.map(({ value: a, label: c, disabled: u }) => Be.createElement(o.Option, { key: a, value: a, disabled: u }, c))),
    Be.createElement(
      "span",
      { className: r[Qe.CaptionLabel], "aria-hidden": !0 },
      l?.label,
      Be.createElement(o.Chevron, { orientation: "down", size: 18, className: r[Qe.Chevron] })
    )
  );
}
function kN(t) {
  return Be.createElement("div", { ...t });
}
function MN(t) {
  return Be.createElement("div", { ...t });
}
function PN(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return Be.createElement("div", { ...o }, t.children);
}
function IN(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return Be.createElement("div", { ...o });
}
function TN(t) {
  return Be.createElement("table", { ...t });
}
function ON(t) {
  return Be.createElement("div", { ...t });
}
const Eb = go(void 0);
function bi() {
  const t = ag(Eb);
  if (t === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return t;
}
function DN(t) {
  const { components: e } = bi();
  return Be.createElement(e.Dropdown, { ...t });
}
function _N(t) {
  const { onPreviousClick: e, onNextClick: n, previousMonth: o, nextMonth: r, ...i } = t, { components: s, classNames: l, labels: { labelPrevious: a, labelNext: c } } = bi(), u = In((f) => {
    r && n?.(f);
  }, [r, n]), d = In((f) => {
    o && e?.(f);
  }, [o, e]);
  return Be.createElement(
    "nav",
    { ...i },
    Be.createElement(
      s.PreviousMonthButton,
      { type: "button", className: l[Qe.PreviousMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": a(o), onClick: d },
      Be.createElement(s.Chevron, { disabled: o ? void 0 : !0, className: l[Qe.Chevron], orientation: "left" })
    ),
    Be.createElement(
      s.NextMonthButton,
      { type: "button", className: l[Qe.NextMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: u },
      Be.createElement(s.Chevron, { disabled: r ? void 0 : !0, orientation: "right", className: l[Qe.Chevron] })
    )
  );
}
function VN(t) {
  const { components: e } = bi();
  return Be.createElement(e.Button, { ...t });
}
function AN(t) {
  return Be.createElement("option", { ...t });
}
function LN(t) {
  const { components: e } = bi();
  return Be.createElement(e.Button, { ...t });
}
function FN(t) {
  const { rootRef: e, ...n } = t;
  return Be.createElement("div", { ...n, ref: e });
}
function $N(t) {
  return Be.createElement("select", { ...t });
}
function HN(t) {
  const { week: e, ...n } = t;
  return Be.createElement("tr", { ...n });
}
function zN(t) {
  return Be.createElement("th", { ...t });
}
function BN(t) {
  return Be.createElement(
    "thead",
    { "aria-hidden": !0 },
    Be.createElement("tr", { ...t })
  );
}
function WN(t) {
  const { week: e, ...n } = t;
  return Be.createElement("th", { ...n });
}
function UN(t) {
  return Be.createElement("th", { ...t });
}
function GN(t) {
  return Be.createElement("tbody", { ...t });
}
function YN(t) {
  const { components: e } = bi();
  return Be.createElement(e.Dropdown, { ...t });
}
const jN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: CN,
  CaptionLabel: wN,
  Chevron: SN,
  Day: RN,
  DayButton: EN,
  Dropdown: NN,
  DropdownNav: kN,
  Footer: MN,
  Month: PN,
  MonthCaption: IN,
  MonthGrid: TN,
  Months: ON,
  MonthsDropdown: DN,
  Nav: _N,
  NextMonthButton: VN,
  Option: AN,
  PreviousMonthButton: LN,
  Root: FN,
  Select: $N,
  Week: HN,
  WeekNumber: WN,
  WeekNumberHeader: UN,
  Weekday: zN,
  Weekdays: BN,
  Weeks: GN,
  YearsDropdown: YN
}, Symbol.toStringTag, { value: "Module" }));
function Ro(t, e, n = !1, o = vo) {
  let { from: r, to: i } = t;
  const { differenceInCalendarDays: s, isSameDay: l } = o;
  return r && i ? (s(i, r) < 0 && ([r, i] = [i, r]), s(e, r) >= (n ? 1 : 0) && s(i, e) >= (n ? 1 : 0)) : !n && i ? l(i, e) : !n && r ? l(r, e) : !1;
}
function Uf(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function ka(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function Gf(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function Yf(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function Nb(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function kb(t, e) {
  return Array.isArray(t) && t.every(e.isDate);
}
function Eo(t, e, n = vo) {
  const o = Array.isArray(e) ? e : [e], { isSameDay: r, differenceInCalendarDays: i, isAfter: s } = n;
  return o.some((l) => {
    if (typeof l == "boolean")
      return l;
    if (n.isDate(l))
      return r(t, l);
    if (kb(l, n))
      return l.some((a) => r(t, a));
    if (ka(l))
      return Ro(l, t, !1, n);
    if (Nb(l))
      return Array.isArray(l.dayOfWeek) ? l.dayOfWeek.includes(t.getDay()) : l.dayOfWeek === t.getDay();
    if (Uf(l)) {
      const a = i(l.before, t), c = i(l.after, t), u = a > 0, d = c < 0;
      return s(l.before, l.after) ? d && u : u || d;
    }
    return Gf(l) ? i(t, l.after) > 0 : Yf(l) ? i(l.before, t) > 0 : typeof l == "function" ? l(t) : !1;
  });
}
function KN(t, e, n, o, r) {
  const { disabled: i, hidden: s, modifiers: l, showOutsideDays: a, broadcastCalendar: c, today: u = r.today() } = e, { isSameDay: d, isSameMonth: f, startOfMonth: p, isBefore: m, endOfMonth: h, isAfter: b } = r, v = n && p(n), C = o && h(o), y = {
    [Ot.focused]: [],
    [Ot.outside]: [],
    [Ot.disabled]: [],
    [Ot.hidden]: [],
    [Ot.today]: []
  }, w = {};
  for (const R of t) {
    const { date: S, displayMonth: E } = R, N = !!(E && !f(S, E)), I = !!(v && m(S, v)), T = !!(C && b(S, C)), k = !!(i && Eo(S, i, r)), P = !!(s && Eo(S, s, r)) || I || T || // Broadcast calendar will show outside days as default
    !c && !a && N || c && a === !1 && N, M = d(S, u);
    N && y.outside.push(R), k && y.disabled.push(R), P && y.hidden.push(R), M && y.today.push(R), l && Object.keys(l).forEach((D) => {
      const O = l?.[D];
      O && Eo(S, O, r) && (w[D] ? w[D].push(R) : w[D] = [R]);
    });
  }
  return (R) => {
    const S = {
      [Ot.focused]: !1,
      [Ot.disabled]: !1,
      [Ot.hidden]: !1,
      [Ot.outside]: !1,
      [Ot.today]: !1
    }, E = {};
    for (const N in y) {
      const I = y[N];
      S[N] = I.some((T) => T === R);
    }
    for (const N in w)
      E[N] = w[N].some((I) => I === R);
    return {
      ...S,
      // custom modifiers should override all the previous ones
      ...E
    };
  };
}
function qN(t, e, n = {}) {
  return Object.entries(t).filter(([, r]) => r === !0).reduce((r, [i]) => (n[i] ? r.push(n[i]) : e[Ot[i]] ? r.push(e[Ot[i]]) : e[Gn[i]] && r.push(e[Gn[i]]), r), [e[Qe.Day]]);
}
function ZN(t) {
  return {
    ...jN,
    ...t
  };
}
function XN(t) {
  const e = {
    "data-mode": t.mode ?? void 0,
    "data-required": "required" in t ? t.required : void 0,
    "data-multiple-months": t.numberOfMonths && t.numberOfMonths > 1 || void 0,
    "data-week-numbers": t.showWeekNumber || void 0,
    "data-broadcast-calendar": t.broadcastCalendar || void 0,
    "data-nav-layout": t.navLayout || void 0
  };
  return Object.entries(t).forEach(([n, o]) => {
    n.startsWith("data-") && (e[n] = o);
  }), e;
}
function QN() {
  const t = {};
  for (const e in Qe)
    t[Qe[e]] = `rdp-${Qe[e]}`;
  for (const e in Ot)
    t[Ot[e]] = `rdp-${Ot[e]}`;
  for (const e in Gn)
    t[Gn[e]] = `rdp-${Gn[e]}`;
  for (const e in wn)
    t[wn[e]] = `rdp-${wn[e]}`;
  return t;
}
function Mb(t, e, n) {
  return (n ?? new En(e)).formatMonthYear(t);
}
const JN = Mb;
function ek(t, e, n) {
  return (n ?? new En(e)).format(t, "d");
}
function tk(t, e = vo) {
  return e.format(t, "LLLL");
}
function nk(t, e, n) {
  return (n ?? new En(e)).format(t, "cccccc");
}
function ok(t, e = vo) {
  return t < 10 ? e.formatNumber(`0${t.toLocaleString()}`) : e.formatNumber(`${t.toLocaleString()}`);
}
function rk() {
  return "";
}
function Pb(t, e = vo) {
  return e.format(t, "yyyy");
}
const ik = Pb, sk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Mb,
  formatDay: ek,
  formatMonthCaption: JN,
  formatMonthDropdown: tk,
  formatWeekNumber: ok,
  formatWeekNumberHeader: rk,
  formatWeekdayName: nk,
  formatYearCaption: ik,
  formatYearDropdown: Pb
}, Symbol.toStringTag, { value: "Module" }));
function lk(t) {
  return t?.formatMonthCaption && !t.formatCaption && (t.formatCaption = t.formatMonthCaption), t?.formatYearCaption && !t.formatYearDropdown && (t.formatYearDropdown = t.formatYearCaption), {
    ...sk,
    ...t
  };
}
function jf(t, e, n, o) {
  let r = (o ?? new En(n)).format(t, "PPPP");
  return e.today && (r = `Today, ${r}`), e.selected && (r = `${r}, selected`), r;
}
const ak = jf;
function Kf(t, e, n) {
  return (n ?? new En(e)).formatMonthYear(t);
}
const ck = Kf;
function Ib(t, e, n, o) {
  let r = (o ?? new En(n)).format(t, "PPPP");
  return e?.today && (r = `Today, ${r}`), r;
}
function Tb(t) {
  return "Choose the Month";
}
function Ob() {
  return "";
}
const uk = "Go to the Next Month";
function Db(t, e) {
  return uk;
}
function _b(t) {
  return "Go to the Previous Month";
}
function Vb(t, e, n) {
  return (n ?? new En(e)).format(t, "cccc");
}
function Ab(t, e) {
  return `Week ${t}`;
}
function Lb(t) {
  return "Week Number";
}
function Fb(t) {
  return "Choose the Year";
}
const dk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: ck,
  labelDay: ak,
  labelDayButton: jf,
  labelGrid: Kf,
  labelGridcell: Ib,
  labelMonthDropdown: Tb,
  labelNav: Ob,
  labelNext: Db,
  labelPrevious: _b,
  labelWeekNumber: Ab,
  labelWeekNumberHeader: Lb,
  labelWeekday: Vb,
  labelYearDropdown: Fb
}, Symbol.toStringTag, { value: "Module" })), Bn = (t, e, n) => e || (n ? typeof n == "function" ? n : (...o) => n : t);
function fk(t, e) {
  const n = e.locale?.labels ?? {};
  return {
    ...dk,
    ...t ?? {},
    labelDayButton: Bn(jf, t?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: Bn(Tb, t?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: Bn(Db, t?.labelNext, n.labelNext),
    labelPrevious: Bn(_b, t?.labelPrevious, n.labelPrevious),
    labelWeekNumber: Bn(Ab, t?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: Bn(Fb, t?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: Bn(Kf, t?.labelGrid, n.labelGrid),
    labelGridcell: Bn(Ib, t?.labelGridcell, n.labelGridcell),
    labelNav: Bn(Ob, t?.labelNav, n.labelNav),
    labelWeekNumberHeader: Bn(Lb, t?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: Bn(Vb, t?.labelWeekday, n.labelWeekday)
  };
}
function pk(t, e, n, o, r) {
  const { startOfMonth: i, startOfYear: s, endOfYear: l, eachMonthOfInterval: a, getMonth: c } = r;
  return a({
    start: s(t),
    end: l(t)
  }).map((f) => {
    const p = o.formatMonthDropdown(f, r), m = c(f), h = e && f < i(e) || n && f > i(n) || !1;
    return { value: m, label: p, disabled: h };
  });
}
function mk(t, e = {}, n = {}) {
  let o = { ...e?.[Qe.Day] };
  return Object.entries(t).filter(([, r]) => r === !0).forEach(([r]) => {
    o = {
      ...o,
      ...n?.[r]
    };
  }), o;
}
function gk(t, e, n, o) {
  const r = o ?? t.today(), i = n ? t.startOfBroadcastWeek(r, t) : e ? t.startOfISOWeek(r) : t.startOfWeek(r), s = [];
  for (let l = 0; l < 7; l++) {
    const a = t.addDays(i, l);
    s.push(a);
  }
  return s;
}
function hk(t, e, n, o, r = !1) {
  if (!t || !e)
    return;
  const { startOfYear: i, endOfYear: s, eachYearOfInterval: l, getYear: a } = o, c = i(t), u = s(e), d = l({ start: c, end: u });
  return r && d.reverse(), d.map((f) => {
    const p = n.formatYearDropdown(f, o);
    return {
      value: a(f),
      label: p,
      disabled: !1
    };
  });
}
function bk(t, e = {}) {
  const { weekStartsOn: n, locale: o } = e, r = n ?? o?.options?.weekStartsOn ?? 0, i = (l) => {
    const a = typeof l == "number" || typeof l == "string" ? new Date(l) : l;
    return new sn(a.getFullYear(), a.getMonth(), a.getDate(), 12, 0, 0, t);
  }, s = (l) => {
    const a = i(l);
    return new Date(a.getFullYear(), a.getMonth(), a.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => i(sn.tz(t)),
    newDate: (l, a, c) => new sn(l, a, c, 12, 0, 0, t),
    startOfDay: (l) => i(l),
    startOfWeek: (l, a) => {
      const c = i(l), u = a?.weekStartsOn ?? r, d = (c.getDay() - u + 7) % 7;
      return c.setDate(c.getDate() - d), c;
    },
    startOfISOWeek: (l) => {
      const a = i(l), c = (a.getDay() - 1 + 7) % 7;
      return a.setDate(a.getDate() - c), a;
    },
    startOfMonth: (l) => {
      const a = i(l);
      return a.setDate(1), a;
    },
    startOfYear: (l) => {
      const a = i(l);
      return a.setMonth(0, 1), a;
    },
    endOfWeek: (l, a) => {
      const c = i(l), f = (((a?.weekStartsOn ?? r) + 6) % 7 - c.getDay() + 7) % 7;
      return c.setDate(c.getDate() + f), c;
    },
    endOfISOWeek: (l) => {
      const a = i(l), c = (7 - a.getDay()) % 7;
      return a.setDate(a.getDate() + c), a;
    },
    endOfMonth: (l) => {
      const a = i(l);
      return a.setMonth(a.getMonth() + 1, 0), a;
    },
    endOfYear: (l) => {
      const a = i(l);
      return a.setMonth(11, 31), a;
    },
    eachMonthOfInterval: (l) => {
      const a = i(l.start), c = i(l.end), u = [], d = new sn(a.getFullYear(), a.getMonth(), 1, 12, 0, 0, t), f = c.getFullYear() * 12 + c.getMonth();
      for (; d.getFullYear() * 12 + d.getMonth() <= f; )
        u.push(new sn(d, t)), d.setMonth(d.getMonth() + 1, 1);
      return u;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (l, a) => {
      const c = i(l);
      return c.setDate(c.getDate() + a), c;
    },
    addWeeks: (l, a) => {
      const c = i(l);
      return c.setDate(c.getDate() + a * 7), c;
    },
    addMonths: (l, a) => {
      const c = i(l);
      return c.setMonth(c.getMonth() + a), c;
    },
    addYears: (l, a) => {
      const c = i(l);
      return c.setFullYear(c.getFullYear() + a), c;
    },
    eachYearOfInterval: (l) => {
      const a = i(l.start), c = i(l.end), u = [], d = new sn(a.getFullYear(), 0, 1, 12, 0, 0, t);
      for (; d.getFullYear() <= c.getFullYear(); )
        u.push(new sn(d, t)), d.setFullYear(d.getFullYear() + 1, 0, 1);
      return u;
    },
    getWeek: (l, a) => {
      const c = s(l);
      return Wf(c, {
        weekStartsOn: a?.weekStartsOn ?? r,
        firstWeekContainsDate: a?.firstWeekContainsDate ?? o?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (l) => {
      const a = s(l);
      return Bf(a);
    },
    differenceInCalendarDays: (l, a) => {
      const c = s(l), u = s(a);
      return zf(c, u);
    },
    differenceInCalendarMonths: (l, a) => {
      const c = s(l), u = s(a);
      return hb(c, u);
    }
  };
}
const Ds = (t) => t instanceof HTMLElement ? t : null, vc = (t) => [
  ...t.querySelectorAll("[data-animated-month]") ?? []
], vk = (t) => Ds(t.querySelector("[data-animated-month]")), yc = (t) => Ds(t.querySelector("[data-animated-caption]")), xc = (t) => Ds(t.querySelector("[data-animated-weeks]")), yk = (t) => Ds(t.querySelector("[data-animated-nav]")), xk = (t) => Ds(t.querySelector("[data-animated-weekdays]"));
function Ck(t, e, { classNames: n, months: o, focused: r, dateLib: i }) {
  const s = ut(null), l = ut(o), a = ut(!1);
  Po(() => {
    const c = l.current;
    if (l.current = o, !e || !t.current || // safety check because the ref can be set to anything by consumers
    !(t.current instanceof HTMLElement) || // validation required for the animation to work as expected
    o.length === 0 || c.length === 0 || o.length !== c.length)
      return;
    const u = i.isSameMonth(o[0].date, c[0].date), d = i.isAfter(o[0].date, c[0].date), f = d ? n[wn.caption_after_enter] : n[wn.caption_before_enter], p = d ? n[wn.weeks_after_enter] : n[wn.weeks_before_enter], m = s.current, h = t.current.cloneNode(!0);
    if (h instanceof HTMLElement ? (vc(h).forEach((y) => {
      if (!(y instanceof HTMLElement))
        return;
      const w = vk(y);
      w && y.contains(w) && y.removeChild(w);
      const R = yc(y);
      R && R.classList.remove(f);
      const S = xc(y);
      S && S.classList.remove(p);
    }), s.current = h) : s.current = null, a.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    r)
      return;
    const b = m instanceof HTMLElement ? vc(m) : [], v = vc(t.current);
    if (v?.every((C) => C instanceof HTMLElement) && b && b.every((C) => C instanceof HTMLElement)) {
      a.current = !0, t.current.style.isolation = "isolate";
      const C = yk(t.current);
      C && (C.style.zIndex = "1"), v.forEach((y, w) => {
        const R = b[w];
        if (!R)
          return;
        y.style.position = "relative", y.style.overflow = "hidden";
        const S = yc(y);
        S && S.classList.add(f);
        const E = xc(y);
        E && E.classList.add(p);
        const N = () => {
          a.current = !1, t.current && (t.current.style.isolation = ""), C && (C.style.zIndex = ""), S && S.classList.remove(f), E && E.classList.remove(p), y.style.position = "", y.style.overflow = "", y.contains(R) && y.removeChild(R);
        };
        R.style.pointerEvents = "none", R.style.position = "absolute", R.style.overflow = "hidden", R.setAttribute("aria-hidden", "true");
        const I = xk(R);
        I && (I.style.opacity = "0");
        const T = yc(R);
        T && (T.classList.add(d ? n[wn.caption_before_exit] : n[wn.caption_after_exit]), T.addEventListener("animationend", N));
        const k = xc(R);
        k && k.classList.add(d ? n[wn.weeks_before_exit] : n[wn.weeks_after_exit]), y.insertBefore(R, y.firstChild);
      });
    }
  });
}
function wk(t, e, n, o) {
  const r = t[0], i = t[t.length - 1], { ISOWeek: s, fixedWeeks: l, broadcastCalendar: a } = n ?? {}, { addDays: c, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: p, endOfMonth: m, endOfWeek: h, isAfter: b, startOfBroadcastWeek: v, startOfISOWeek: C, startOfWeek: y } = o, w = a ? v(r, o) : s ? C(r) : y(r), R = a ? f(i) : s ? p(m(i)) : h(m(i)), S = e && (a ? f(e) : s ? p(e) : h(e)), E = S && b(R, S) ? S : R, N = u(E, w), I = d(i, r) + 1, T = [];
  for (let M = 0; M <= N; M++) {
    const D = c(w, M);
    T.push(D);
  }
  const P = (a ? 35 : 42) * I;
  if (l && T.length < P) {
    const M = P - T.length;
    for (let D = 0; D < M; D++) {
      const O = c(T[T.length - 1], 1);
      T.push(O);
    }
  }
  return T;
}
function Sk(t) {
  const e = [];
  return t.reduce((n, o) => {
    const r = o.weeks.reduce((i, s) => i.concat(s.days.slice()), e.slice());
    return n.concat(r.slice());
  }, e.slice());
}
function Rk(t, e, n, o) {
  const { numberOfMonths: r = 1 } = n, i = [];
  for (let s = 0; s < r; s++) {
    const l = o.addMonths(t, s);
    if (e && l > e)
      break;
    i.push(l);
  }
  return i;
}
function Im(t, e, n, o) {
  const { month: r, defaultMonth: i, today: s = o.today(), numberOfMonths: l = 1 } = t;
  let a = r || i || s;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = o;
  if (n && c(n, a) < l - 1) {
    const f = -1 * (l - 1);
    a = u(n, f);
  }
  return e && c(a, e) < 0 && (a = e), d(a);
}
function Ek(t, e, n, o) {
  const { addDays: r, endOfBroadcastWeek: i, endOfISOWeek: s, endOfMonth: l, endOfWeek: a, getISOWeek: c, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: p } = o, m = t.reduce((h, b) => {
    const v = n.broadcastCalendar ? d(b, o) : n.ISOWeek ? f(b) : p(b), C = n.broadcastCalendar ? i(b) : n.ISOWeek ? s(l(b)) : a(l(b)), y = e.filter((E) => E >= v && E <= C), w = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && y.length < w) {
      const E = e.filter((N) => {
        const I = w - y.length;
        return N > C && N <= r(C, I);
      });
      y.push(...E);
    }
    const R = y.reduce((E, N) => {
      const I = n.ISOWeek ? c(N) : u(N), T = E.find((P) => P.weekNumber === I), k = new Rb(N, b, o);
      return T ? T.days.push(k) : E.push(new xN(I, [k])), E;
    }, []), S = new yN(b, R);
    return h.push(S), h;
  }, []);
  return n.reverseMonths ? m.reverse() : m;
}
function Nk(t, e) {
  let { startMonth: n, endMonth: o } = t;
  const { startOfYear: r, startOfDay: i, startOfMonth: s, endOfMonth: l, addYears: a, endOfYear: c, newDate: u, today: d } = e, { fromYear: f, toYear: p, fromMonth: m, toMonth: h } = t;
  !n && m && (n = m), !n && f && (n = e.newDate(f, 0, 1)), !o && h && (o = h), !o && p && (o = u(p, 11, 31));
  const b = t.captionLayout === "dropdown" || t.captionLayout === "dropdown-years";
  return n ? n = s(n) : f ? n = u(f, 0, 1) : !n && b && (n = r(a(t.today ?? d(), -100))), o ? o = l(o) : p ? o = u(p, 11, 31) : !o && b && (o = c(t.today ?? d())), [
    n && i(n),
    o && i(o)
  ];
}
function kk(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: i = 1 } = n, { startOfMonth: s, addMonths: l, differenceInCalendarMonths: a } = o, c = r ? i : 1, u = s(t);
  if (!e)
    return l(u, c);
  if (!(a(e, t) < i))
    return l(u, c);
}
function Mk(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: i } = n, { startOfMonth: s, addMonths: l, differenceInCalendarMonths: a } = o, c = r ? i ?? 1 : 1, u = s(t);
  if (!e)
    return l(u, -c);
  if (!(a(u, e) <= 0))
    return l(u, -c);
}
function Pk(t) {
  const e = [];
  return t.reduce((n, o) => n.concat(o.weeks.slice()), e.slice());
}
function Ma(t, e) {
  const [n, o] = tt(t);
  return [e === void 0 ? n : e, o];
}
function Ik(t, e) {
  const [n, o] = Nk(t, e), { startOfMonth: r, endOfMonth: i } = e, s = Im(t, n, o, e), [l, a] = Ma(
    s,
    // initialMonth is always computed from props.month if provided
    t.month ? s : void 0
  );
  _t(() => {
    const w = Im(t, n, o, e);
    a(w);
  }, [t.timeZone]);
  const { months: c, weeks: u, days: d, previousMonth: f, nextMonth: p } = gl(() => {
    const w = Rk(l, o, { numberOfMonths: t.numberOfMonths }, e), R = wk(w, t.endMonth ? i(t.endMonth) : void 0, {
      ISOWeek: t.ISOWeek,
      fixedWeeks: t.fixedWeeks,
      broadcastCalendar: t.broadcastCalendar
    }, e), S = Ek(w, R, {
      broadcastCalendar: t.broadcastCalendar,
      fixedWeeks: t.fixedWeeks,
      ISOWeek: t.ISOWeek,
      reverseMonths: t.reverseMonths
    }, e), E = Pk(S), N = Sk(S), I = Mk(l, n, t, e), T = kk(l, o, t, e);
    return {
      months: S,
      weeks: E,
      days: N,
      previousMonth: I,
      nextMonth: T
    };
  }, [
    e,
    l.getTime(),
    o?.getTime(),
    n?.getTime(),
    t.disableNavigation,
    t.broadcastCalendar,
    t.endMonth?.getTime(),
    t.fixedWeeks,
    t.ISOWeek,
    t.numberOfMonths,
    t.pagedNavigation,
    t.reverseMonths
  ]), { disableNavigation: m, onMonthChange: h } = t, b = (w) => u.some((R) => R.days.some((S) => S.isEqualTo(w))), v = (w) => {
    if (m)
      return;
    let R = r(w);
    n && R < r(n) && (R = r(n)), o && R > r(o) && (R = r(o)), a(R), h?.(R);
  };
  return {
    months: c,
    weeks: u,
    days: d,
    navStart: n,
    navEnd: o,
    previousMonth: f,
    nextMonth: p,
    goToMonth: v,
    goToDay: (w) => {
      b(w) || v(w.date);
    }
  };
}
var io;
(function(t) {
  t[t.Today = 0] = "Today", t[t.Selected = 1] = "Selected", t[t.LastFocused = 2] = "LastFocused", t[t.FocusedModifier = 3] = "FocusedModifier";
})(io || (io = {}));
function Tm(t) {
  return !t[Ot.disabled] && !t[Ot.hidden] && !t[Ot.outside];
}
function Tk(t, e, n, o) {
  let r, i = -1;
  for (const s of t) {
    const l = e(s);
    Tm(l) && (l[Ot.focused] && i < io.FocusedModifier ? (r = s, i = io.FocusedModifier) : o?.isEqualTo(s) && i < io.LastFocused ? (r = s, i = io.LastFocused) : n(s.date) && i < io.Selected ? (r = s, i = io.Selected) : l[Ot.today] && i < io.Today && (r = s, i = io.Today));
  }
  return r || (r = t.find((s) => Tm(e(s)))), r;
}
function Ok(t, e, n, o, r, i, s) {
  const { ISOWeek: l, broadcastCalendar: a } = i, { addDays: c, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: p, endOfISOWeek: m, endOfWeek: h, max: b, min: v, startOfBroadcastWeek: C, startOfISOWeek: y, startOfWeek: w } = s;
  let S = {
    day: c,
    week: d,
    month: u,
    year: f,
    startOfWeek: (E) => a ? C(E, s) : l ? y(E) : w(E),
    endOfWeek: (E) => a ? p(E) : l ? m(E) : h(E)
  }[t](n, e === "after" ? 1 : -1);
  return e === "before" && o ? S = b([o, S]) : e === "after" && r && (S = v([r, S])), S;
}
function $b(t, e, n, o, r, i, s, l = 0) {
  if (l > 365)
    return;
  const a = Ok(t, e, n.date, o, r, i, s), c = !!(i.disabled && Eo(a, i.disabled, s)), u = !!(i.hidden && Eo(a, i.hidden, s)), d = a, f = new Rb(a, d, s);
  return !c && !u ? f : $b(t, e, f, o, r, i, s, l + 1);
}
function Dk(t, e, n, o, r) {
  const { autoFocus: i } = t, [s, l] = tt(), a = Tk(e.days, n, o || (() => !1), s), [c, u] = tt(i ? a : void 0);
  return {
    isFocusTarget: (h) => !!a?.isEqualTo(h),
    setFocused: u,
    focused: c,
    blur: () => {
      l(c), u(void 0);
    },
    moveFocus: (h, b) => {
      if (!c)
        return;
      const v = $b(h, b, c, e.navStart, e.navEnd, t, r);
      v && (t.disableNavigation && !e.days.some((y) => y.isEqualTo(v)) || (e.goToDay(v), u(v)));
    }
  };
}
function _k(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [i, s] = Ma(n, r ? n : void 0), l = r ? n : i, { isSameDay: a } = e, c = (p) => l?.some((m) => a(m, p)) ?? !1, { min: u, max: d } = t;
  return {
    selected: l,
    select: (p, m, h) => {
      let b = [...l ?? []];
      if (c(p)) {
        if (l?.length === u || o && l?.length === 1)
          return;
        b = l?.filter((v) => !a(v, p));
      } else
        l?.length === d ? b = [p] : b = [...b, p];
      return r || s(b), r?.(b, p, m, h), b;
    },
    isSelected: c
  };
}
function Vk(t, e, n = 0, o = 0, r = !1, i = vo) {
  const { from: s, to: l } = e || {}, { isSameDay: a, isAfter: c, isBefore: u } = i;
  let d;
  if (!s && !l)
    d = { from: t, to: n > 0 ? void 0 : t };
  else if (s && !l)
    a(s, t) ? n === 0 ? d = { from: s, to: t } : r ? d = { from: s, to: void 0 } : d = void 0 : u(t, s) ? d = { from: t, to: s } : d = { from: s, to: t };
  else if (s && l)
    if (a(s, t) && a(l, t))
      r ? d = { from: s, to: l } : d = void 0;
    else if (a(s, t))
      d = { from: s, to: n > 0 ? void 0 : t };
    else if (a(l, t))
      d = { from: t, to: n > 0 ? void 0 : t };
    else if (u(t, s))
      d = { from: t, to: l };
    else if (c(t, s))
      d = { from: s, to: t };
    else if (c(t, l))
      d = { from: s, to: t };
    else
      throw new Error("Invalid range");
  if (d?.from && d?.to) {
    const f = i.differenceInCalendarDays(d.to, d.from);
    o > 0 && f > o ? d = { from: t, to: void 0 } : n > 1 && f < n && (d = { from: t, to: void 0 });
  }
  return d;
}
function Ak(t, e, n = vo) {
  const o = Array.isArray(e) ? e : [e];
  let r = t.from;
  const i = n.differenceInCalendarDays(t.to, t.from), s = Math.min(i, 6);
  for (let l = 0; l <= s; l++) {
    if (o.includes(r.getDay()))
      return !0;
    r = n.addDays(r, 1);
  }
  return !1;
}
function Om(t, e, n = vo) {
  return Ro(t, e.from, !1, n) || Ro(t, e.to, !1, n) || Ro(e, t.from, !1, n) || Ro(e, t.to, !1, n);
}
function Lk(t, e, n = vo) {
  const o = Array.isArray(e) ? e : [e];
  if (o.filter((l) => typeof l != "function").some((l) => typeof l == "boolean" ? l : n.isDate(l) ? Ro(t, l, !1, n) : kb(l, n) ? l.some((a) => Ro(t, a, !1, n)) : ka(l) ? l.from && l.to ? Om(t, { from: l.from, to: l.to }, n) : !1 : Nb(l) ? Ak(t, l.dayOfWeek, n) : Uf(l) ? n.isAfter(l.before, l.after) ? Om(t, {
    from: n.addDays(l.after, 1),
    to: n.addDays(l.before, -1)
  }, n) : Eo(t.from, l, n) || Eo(t.to, l, n) : Gf(l) || Yf(l) ? Eo(t.from, l, n) || Eo(t.to, l, n) : !1))
    return !0;
  const s = o.filter((l) => typeof l == "function");
  if (s.length) {
    let l = t.from;
    const a = n.differenceInCalendarDays(t.to, t.from);
    for (let c = 0; c <= a; c++) {
      if (s.some((u) => u(l)))
        return !0;
      l = n.addDays(l, 1);
    }
  }
  return !1;
}
function Fk(t, e) {
  const { disabled: n, excludeDisabled: o, resetOnSelect: r, selected: i, required: s, onSelect: l } = t, [a, c] = Ma(i, l ? i : void 0), u = l ? i : a;
  return {
    selected: u,
    select: (p, m, h) => {
      const { min: b, max: v } = t;
      let C;
      if (p) {
        const y = u?.from, w = u?.to, R = !!y && !!w, S = !!y && !!w && e.isSameDay(y, w) && e.isSameDay(p, y);
        r && (R || !u?.from) ? !s && S ? C = void 0 : C = { from: p, to: void 0 } : C = Vk(p, u, b, v, s, e);
      }
      return o && n && C?.from && C.to && Lk({ from: C.from, to: C.to }, n, e) && (C.from = p, C.to = void 0), l || c(C), l?.(C, p, m, h), C;
    },
    isSelected: (p) => u && Ro(u, p, !1, e)
  };
}
function $k(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [i, s] = Ma(n, r ? n : void 0), l = r ? n : i, { isSameDay: a } = e;
  return {
    selected: l,
    select: (d, f, p) => {
      let m = d;
      return !o && l && l && a(d, l) && (m = void 0), r || s(m), r?.(m, d, f, p), m;
    },
    isSelected: (d) => l ? a(l, d) : !1
  };
}
function Hk(t, e) {
  const n = $k(t, e), o = _k(t, e), r = Fk(t, e);
  switch (t.mode) {
    case "single":
      return n;
    case "multiple":
      return o;
    case "range":
      return r;
    default:
      return;
  }
}
function Tn(t, e) {
  return t instanceof sn && t.timeZone === e ? t : new sn(t, e);
}
function Or(t, e, n) {
  return Tn(t, e);
}
function Dm(t, e, n) {
  return typeof t == "boolean" || typeof t == "function" ? t : t instanceof Date ? Or(t, e) : Array.isArray(t) ? t.map((o) => o instanceof Date ? Or(o, e) : o) : ka(t) ? {
    ...t,
    from: t.from ? Tn(t.from, e) : t.from,
    to: t.to ? Tn(t.to, e) : t.to
  } : Uf(t) ? {
    before: Or(t.before, e),
    after: Or(t.after, e)
  } : Gf(t) ? {
    after: Or(t.after, e)
  } : Yf(t) ? {
    before: Or(t.before, e)
  } : t;
}
function Cc(t, e, n) {
  return t && (Array.isArray(t) ? t.map((o) => Dm(o, e)) : Dm(t, e));
}
function zk(t) {
  let e = t;
  const n = e.timeZone;
  if (n && (e = {
    ...t,
    timeZone: n
  }, e.today && (e.today = Tn(e.today, n)), e.month && (e.month = Tn(e.month, n)), e.defaultMonth && (e.defaultMonth = Tn(e.defaultMonth, n)), e.startMonth && (e.startMonth = Tn(e.startMonth, n)), e.endMonth && (e.endMonth = Tn(e.endMonth, n)), e.mode === "single" && e.selected ? e.selected = Tn(e.selected, n) : e.mode === "multiple" && e.selected ? e.selected = e.selected?.map((Ee) => Tn(Ee, n)) : e.mode === "range" && e.selected && (e.selected = {
    from: e.selected.from ? Tn(e.selected.from, n) : e.selected.from,
    to: e.selected.to ? Tn(e.selected.to, n) : e.selected.to
  }), e.disabled !== void 0 && (e.disabled = Cc(e.disabled, n)), e.hidden !== void 0 && (e.hidden = Cc(e.hidden, n)), e.modifiers)) {
    const Ee = {};
    Object.keys(e.modifiers).forEach((Ve) => {
      Ee[Ve] = Cc(e.modifiers?.[Ve], n);
    }), e.modifiers = Ee;
  }
  const { components: o, formatters: r, labels: i, dateLib: s, locale: l, classNames: a } = gl(() => {
    const Ee = { ...Sb, ...e.locale }, Ve = e.broadcastCalendar ? 1 : e.weekStartsOn, Me = e.noonSafe && e.timeZone ? bk(e.timeZone, {
      weekStartsOn: Ve,
      locale: Ee
    }) : void 0, He = e.dateLib && Me ? { ...Me, ...e.dateLib } : e.dateLib ?? Me, ze = new En({
      locale: Ee,
      weekStartsOn: Ve,
      firstWeekContainsDate: e.firstWeekContainsDate,
      useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
      timeZone: e.timeZone,
      numerals: e.numerals
    }, He);
    return {
      dateLib: ze,
      components: ZN(e.components),
      formatters: lk(e.formatters),
      labels: fk(e.labels, ze.options),
      locale: Ee,
      classNames: { ...QN(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.noonSafe,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]);
  e.today || (e = { ...e, today: s.today() });
  const { captionLayout: c, mode: u, navLayout: d, numberOfMonths: f = 1, onDayBlur: p, onDayClick: m, onDayFocus: h, onDayKeyDown: b, onDayMouseEnter: v, onDayMouseLeave: C, onNextClick: y, onPrevClick: w, showWeekNumber: R, styles: S } = e, { formatCaption: E, formatDay: N, formatMonthDropdown: I, formatWeekNumber: T, formatWeekNumberHeader: k, formatWeekdayName: P, formatYearDropdown: M } = r, D = Ik(e, s), { days: O, months: _, navStart: V, navEnd: A, previousMonth: L, nextMonth: $, goToMonth: Y } = D, G = KN(O, e, V, A, s), { isSelected: j, select: Z, selected: U } = Hk(e, s) ?? {}, { blur: q, focused: te, isFocusTarget: H, moveFocus: X, setFocused: ee } = Dk(e, D, G, j ?? (() => !1), s), { labelDayButton: le, labelGridcell: Q, labelGrid: re, labelMonthDropdown: fe, labelNav: ne, labelPrevious: se, labelNext: pe, labelWeekday: xe, labelWeekNumber: ce, labelWeekNumberHeader: he, labelYearDropdown: z } = i, J = gl(() => gk(s, e.ISOWeek, e.broadcastCalendar, e.today), [s, e.ISOWeek, e.broadcastCalendar, e.today]), B = u !== void 0 || m !== void 0, K = In(() => {
    L && (Y(L), w?.(L));
  }, [L, Y, w]), ie = In(() => {
    $ && (Y($), y?.($));
  }, [Y, $, y]), ge = In((Ee, Ve) => (Me) => {
    Me.preventDefault(), Me.stopPropagation(), ee(Ee), !Ve.disabled && (Z?.(Ee.date, Ve, Me), m?.(Ee.date, Ve, Me));
  }, [Z, m, ee]), ue = In((Ee, Ve) => (Me) => {
    ee(Ee), h?.(Ee.date, Ve, Me);
  }, [h, ee]), Se = In((Ee, Ve) => (Me) => {
    q(), p?.(Ee.date, Ve, Me);
  }, [q, p]), ve = In((Ee, Ve) => (Me) => {
    const He = {
      ArrowLeft: [
        Me.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        Me.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [Me.shiftKey ? "year" : "week", "after"],
      ArrowUp: [Me.shiftKey ? "year" : "week", "before"],
      PageUp: [Me.shiftKey ? "year" : "month", "before"],
      PageDown: [Me.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (He[Me.key]) {
      Me.preventDefault(), Me.stopPropagation();
      const [ze, Oe] = He[Me.key];
      X(ze, Oe);
    }
    b?.(Ee.date, Ve, Me);
  }, [X, b, e.dir]), de = In((Ee, Ve) => (Me) => {
    v?.(Ee.date, Ve, Me);
  }, [v]), me = In((Ee, Ve) => (Me) => {
    C?.(Ee.date, Ve, Me);
  }, [C]), Re = In((Ee) => (Ve) => {
    const Me = Number(Ve.target.value), He = s.setMonth(s.startOfMonth(Ee), Me);
    Y(He);
  }, [s, Y]), Ie = In((Ee) => (Ve) => {
    const Me = Number(Ve.target.value), He = s.setYear(s.startOfMonth(Ee), Me);
    Y(He);
  }, [s, Y]), { className: Pe, style: _e } = gl(() => ({
    className: [a[Qe.Root], e.className].filter(Boolean).join(" "),
    style: { ...S?.[Qe.Root], ...e.style }
  }), [a, e.className, e.style, S]), Ye = XN(e), qe = ut(null);
  Ck(qe, !!e.animate, {
    classNames: a,
    months: _,
    focused: te,
    dateLib: s
  });
  const $e = {
    dayPickerProps: e,
    selected: U,
    select: Z,
    isSelected: j,
    months: _,
    nextMonth: $,
    previousMonth: L,
    goToMonth: Y,
    getModifiers: G,
    components: o,
    classNames: a,
    styles: S,
    labels: i,
    formatters: r
  };
  return Be.createElement(
    Eb.Provider,
    { value: $e },
    Be.createElement(
      o.Root,
      { rootRef: e.animate ? qe : void 0, className: Pe, style: _e, dir: e.dir, id: e.id, lang: e.lang ?? l.code, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], "aria-labelledby": e["aria-labelledby"], ...Ye },
      Be.createElement(
        o.Months,
        { className: a[Qe.Months], style: S?.[Qe.Months] },
        !e.hideNavigation && !d && Be.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[Qe.Nav], style: S?.[Qe.Nav], "aria-label": ne(), onPreviousClick: K, onNextClick: ie, previousMonth: L, nextMonth: $ }),
        _.map((Ee, Ve) => Be.createElement(
          o.Month,
          {
            "data-animated-month": e.animate ? "true" : void 0,
            className: a[Qe.Month],
            style: S?.[Qe.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: Ve,
            displayIndex: Ve,
            calendarMonth: Ee
          },
          d === "around" && !e.hideNavigation && Ve === 0 && Be.createElement(
            o.PreviousMonthButton,
            { type: "button", className: a[Qe.PreviousMonthButton], tabIndex: L ? void 0 : -1, "aria-disabled": L ? void 0 : !0, "aria-label": se(L), onClick: K, "data-animated-button": e.animate ? "true" : void 0 },
            Be.createElement(o.Chevron, { disabled: L ? void 0 : !0, className: a[Qe.Chevron], orientation: e.dir === "rtl" ? "right" : "left" })
          ),
          Be.createElement(o.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: a[Qe.MonthCaption], style: S?.[Qe.MonthCaption], calendarMonth: Ee, displayIndex: Ve }, c?.startsWith("dropdown") ? Be.createElement(
            o.DropdownNav,
            { className: a[Qe.Dropdowns], style: S?.[Qe.Dropdowns] },
            (() => {
              const Me = c === "dropdown" || c === "dropdown-months" ? Be.createElement(o.MonthsDropdown, { key: "month", className: a[Qe.MonthsDropdown], "aria-label": fe(), classNames: a, components: o, disabled: !!e.disableNavigation, onChange: Re(Ee.date), options: pk(Ee.date, V, A, r, s), style: S?.[Qe.Dropdown], value: s.getMonth(Ee.date) }) : Be.createElement("span", { key: "month" }, I(Ee.date, s)), He = c === "dropdown" || c === "dropdown-years" ? Be.createElement(o.YearsDropdown, { key: "year", className: a[Qe.YearsDropdown], "aria-label": z(s.options), classNames: a, components: o, disabled: !!e.disableNavigation, onChange: Ie(Ee.date), options: hk(V, A, r, s, !!e.reverseYears), style: S?.[Qe.Dropdown], value: s.getYear(Ee.date) }) : Be.createElement("span", { key: "year" }, M(Ee.date, s));
              return s.getMonthYearOrder() === "year-first" ? [He, Me] : [Me, He];
            })(),
            Be.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, E(Ee.date, s.options, s))
          ) : Be.createElement(o.CaptionLabel, { className: a[Qe.CaptionLabel], role: "status", "aria-live": "polite" }, E(Ee.date, s.options, s))),
          d === "around" && !e.hideNavigation && Ve === f - 1 && Be.createElement(
            o.NextMonthButton,
            { type: "button", className: a[Qe.NextMonthButton], tabIndex: $ ? void 0 : -1, "aria-disabled": $ ? void 0 : !0, "aria-label": pe($), onClick: ie, "data-animated-button": e.animate ? "true" : void 0 },
            Be.createElement(o.Chevron, { disabled: $ ? void 0 : !0, className: a[Qe.Chevron], orientation: e.dir === "rtl" ? "left" : "right" })
          ),
          Ve === f - 1 && d === "after" && !e.hideNavigation && Be.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[Qe.Nav], style: S?.[Qe.Nav], "aria-label": ne(), onPreviousClick: K, onNextClick: ie, previousMonth: L, nextMonth: $ }),
          Be.createElement(
            o.MonthGrid,
            { role: "grid", "aria-multiselectable": u === "multiple" || u === "range", "aria-label": re(Ee.date, s.options, s) || void 0, className: a[Qe.MonthGrid], style: S?.[Qe.MonthGrid] },
            !e.hideWeekdays && Be.createElement(
              o.Weekdays,
              { "data-animated-weekdays": e.animate ? "true" : void 0, className: a[Qe.Weekdays], style: S?.[Qe.Weekdays] },
              R && Be.createElement(o.WeekNumberHeader, { "aria-label": he(s.options), className: a[Qe.WeekNumberHeader], style: S?.[Qe.WeekNumberHeader], scope: "col" }, k()),
              J.map((Me) => Be.createElement(o.Weekday, { "aria-label": xe(Me, s.options, s), className: a[Qe.Weekday], key: String(Me), style: S?.[Qe.Weekday], scope: "col" }, P(Me, s.options, s)))
            ),
            Be.createElement(o.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: a[Qe.Weeks], style: S?.[Qe.Weeks] }, Ee.weeks.map((Me) => Be.createElement(
              o.Week,
              { className: a[Qe.Week], key: Me.weekNumber, style: S?.[Qe.Week], week: Me },
              R && Be.createElement(o.WeekNumber, { week: Me, style: S?.[Qe.WeekNumber], "aria-label": ce(Me.weekNumber, {
                locale: l
              }), className: a[Qe.WeekNumber], scope: "row", role: "rowheader" }, T(Me.weekNumber, s)),
              Me.days.map((He) => {
                const { date: ze } = He, Oe = G(He);
                if (Oe[Ot.focused] = !Oe.hidden && !!te?.isEqualTo(He), Oe[Gn.selected] = j?.(ze) || Oe.selected, ka(U)) {
                  const { from: ke, to: Ae } = U;
                  Oe[Gn.range_start] = !!(ke && Ae && s.isSameDay(ze, ke)), Oe[Gn.range_end] = !!(ke && Ae && s.isSameDay(ze, Ae)), Oe[Gn.range_middle] = Ro(U, ze, !0, s);
                }
                const wt = mk(Oe, S, e.modifiersStyles), dt = qN(Oe, a, e.modifiersClassNames), we = !B && !Oe.hidden ? Q(ze, Oe, s.options, s) : void 0;
                return Be.createElement(o.Day, { key: `${He.isoDate}_${He.displayMonthId}`, day: He, modifiers: Oe, className: dt.join(" "), style: wt, role: "gridcell", "aria-selected": Oe.selected || void 0, "aria-label": we, "data-day": He.isoDate, "data-month": He.outside ? He.dateMonthId : void 0, "data-selected": Oe.selected || void 0, "data-disabled": Oe.disabled || void 0, "data-hidden": Oe.hidden || void 0, "data-outside": He.outside || void 0, "data-focused": Oe.focused || void 0, "data-today": Oe.today || void 0 }, !Oe.hidden && B ? Be.createElement(o.DayButton, { className: a[Qe.DayButton], style: S?.[Qe.DayButton], type: "button", day: He, modifiers: Oe, disabled: !Oe.focused && Oe.disabled || void 0, "aria-disabled": Oe.focused && Oe.disabled || void 0, tabIndex: H(He) ? 0 : -1, "aria-label": le(ze, Oe, s.options, s), onClick: ge(He, Oe), onBlur: Se(He, Oe), onFocus: ue(He, Oe), onKeyDown: ve(He, Oe), onMouseEnter: de(He, Oe), onMouseLeave: me(He, Oe) }, N(ze, s.options, s)) : !Oe.hidden && N(He.date, s.options, s));
              })
            )))
          )
        ))
      ),
      e.footer && Be.createElement(o.Footer, { className: a[Qe.Footer], style: S?.[Qe.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
function Bk(t) {
  const e = W.c(18), {
    children: n,
    positionerClassName: o,
    popupClassName: r,
    listClassName: i
  } = t, s = Qt();
  let l;
  e[0] !== o ? (l = oe("z-[var(--z-overlay-popover,180)]", o), e[0] = o, e[1] = l) : l = e[1];
  let a;
  e[2] !== r ? (a = ys({
    size: "auto",
    className: r
  }), e[2] = r, e[3] = a) : a = e[3];
  let c;
  e[4] !== i ? (c = oe("flex flex-col", i), e[4] = i, e[5] = c) : c = e[5];
  let u;
  e[6] !== n || e[7] !== c ? (u = /* @__PURE__ */ g(ib, { className: c, children: n }), e[6] = n, e[7] = c, e[8] = u) : u = e[8];
  let d;
  e[9] !== a || e[10] !== u ? (d = /* @__PURE__ */ g(rb, { className: a, children: u }), e[9] = a, e[10] = u, e[11] = d) : d = e[11];
  let f;
  e[12] !== l || e[13] !== d ? (f = /* @__PURE__ */ g(nb, { sideOffset: 4, alignItemWithTrigger: !1, className: l, children: d }), e[12] = l, e[13] = d, e[14] = f) : f = e[14];
  let p;
  return e[15] !== s || e[16] !== f ? (p = /* @__PURE__ */ g(J0, { container: s, children: f }), e[15] = s, e[16] = f, e[17] = p) : p = e[17], p;
}
function Wk(t) {
  const e = W.c(11), {
    value: n,
    disabled: o,
    icon: r,
    children: i
  } = t;
  let s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = Ko({}), e[0] = s) : s = e[0];
  let l;
  e[1] !== r ? (l = r && /* @__PURE__ */ g("span", { className: "shrink-0 text-menu-icon-default inline-flex", children: /* @__PURE__ */ g(Ge, { name: r, size: "xs", tone: "inherit" }) }), e[1] = r, e[2] = l) : l = e[2];
  let a;
  e[3] !== i ? (a = /* @__PURE__ */ g(cb, { className: "flex-1 min-w-0", children: i }), e[3] = i, e[4] = a) : a = e[4];
  let c;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g(lb, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(Ge, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[5] = c) : c = e[5];
  let u;
  return e[6] !== o || e[7] !== l || e[8] !== a || e[9] !== n ? (u = /* @__PURE__ */ F(sb, { value: n, disabled: o, className: s, children: [
    l,
    a,
    c
  ] }), e[6] = o, e[7] = l, e[8] = a, e[9] = n, e[10] = u) : u = e[10], u;
}
function Uk(t) {
  const e = W.c(2), {
    size: n
  } = t, o = n === void 0 ? "xs" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ g("span", { className: "transition-transform duration-200 [[data-popup-open]_&]:rotate-180 inline-flex", children: /* @__PURE__ */ g(Ge, { name: "chevron-down", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
function Gk(t) {
  const e = W.c(26), {
    value: n,
    onChange: o,
    options: r,
    disabled: i,
    "aria-label": s
  } = t;
  let l;
  e[0] !== r || e[1] !== n ? (l = r?.find((R) => R.value === Number(n)), e[0] = r, e[1] = n, e[2] = l) : l = e[2];
  const a = l;
  let c;
  e[3] !== o ? (c = function(S) {
    S !== null && o?.({
      target: {
        value: String(S)
      },
      currentTarget: {
        value: String(S)
      }
    });
  }, e[3] = o, e[4] = c) : c = e[4];
  const u = c, d = a?.value ?? null;
  let f;
  e[5] !== r ? (f = r ?? [], e[5] = r, e[6] = f) : f = e[6];
  let p;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = oe("flex items-center gap-(--spacing-2)", "cursor-pointer rounded-(--radius-xs) outline-none", "focus-visible:ring-2 focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50"), e[7] = p) : p = e[7];
  const m = a?.label ?? "";
  let h;
  e[8] !== m ? (h = /* @__PURE__ */ g(Z0, { className: "text-(length:--font-size-title-md) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default select-none", children: m }), e[8] = m, e[9] = h) : h = e[9];
  let b;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ g(X0, { className: "text-icon-main", children: /* @__PURE__ */ g(Uk, { size: "sm" }) }), e[10] = b) : b = e[10];
  let v;
  e[11] !== s || e[12] !== i || e[13] !== h ? (v = /* @__PURE__ */ F(q0, { disabled: i, "aria-label": s, className: p, children: [
    h,
    b
  ] }), e[11] = s, e[12] = i, e[13] = h, e[14] = v) : v = e[14];
  let C;
  e[15] !== r ? (C = r?.map(Yk), e[15] = r, e[16] = C) : C = e[16];
  let y;
  e[17] !== C ? (y = /* @__PURE__ */ g(Bk, { listClassName: "max-h-[368px] overflow-y-auto", children: C }), e[17] = C, e[18] = y) : y = e[18];
  let w;
  return e[19] !== i || e[20] !== u || e[21] !== y || e[22] !== d || e[23] !== f || e[24] !== v ? (w = /* @__PURE__ */ F(FR, { value: d, onValueChange: u, disabled: i, items: f, children: [
    v,
    y
  ] }), e[19] = i, e[20] = u, e[21] = y, e[22] = d, e[23] = f, e[24] = v, e[25] = w) : w = e[25], w;
}
function Yk(t) {
  return /* @__PURE__ */ g(Wk, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function jk(t) {
  const e = W.c(18), {
    children: n
  } = t, {
    goToMonth: o,
    nextMonth: r,
    previousMonth: i,
    dayPickerProps: s
  } = bi(), l = s.disabled === !0, a = l || !i;
  let c;
  e[0] !== o || e[1] !== i ? (c = () => i && o(i), e[0] = o, e[1] = i, e[2] = c) : c = e[2];
  let u;
  e[3] !== a || e[4] !== c ? (u = /* @__PURE__ */ g(gt, { icon: "chevron-left", variant: "ghost", size: "md", "aria-label": "Previous month", disabled: a, onClick: c }), e[3] = a, e[4] = c, e[5] = u) : u = e[5];
  let d;
  e[6] !== n ? (d = /* @__PURE__ */ g("div", { className: "flex items-center gap-[26px]", children: n }), e[6] = n, e[7] = d) : d = e[7];
  const f = l || !r;
  let p;
  e[8] !== o || e[9] !== r ? (p = () => r && o(r), e[8] = o, e[9] = r, e[10] = p) : p = e[10];
  let m;
  e[11] !== f || e[12] !== p ? (m = /* @__PURE__ */ g(gt, { icon: "chevron-right", variant: "ghost", size: "md", "aria-label": "Next month", disabled: f, onClick: p }), e[11] = f, e[12] = p, e[13] = m) : m = e[13];
  let h;
  return e[14] !== u || e[15] !== d || e[16] !== m ? (h = /* @__PURE__ */ F("div", { className: "flex items-center justify-between pt-(--spacing-8) px-(--spacing-12)", children: [
    u,
    d,
    m
  ] }), e[14] = u, e[15] = d, e[16] = m, e[17] = h) : h = e[17], h;
}
function Kk(t) {
  const e = W.c(12), {
    value: n,
    onValueChange: o,
    disabled: r
  } = t, i = r === void 0 ? !1 : r, s = n ?? void 0, l = n ?? void 0;
  let a;
  e[0] !== o ? (a = (h) => o(h ?? null), e[0] = o, e[1] = a) : a = e[1];
  let c, u;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = new Date(2e3, 0), u = new Date(2099, 11), e[2] = c, e[3] = u) : (c = e[2], u = e[3]);
  let d, f, p;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = {
    formatMonthDropdown: qk
  }, f = {
    root: "w-[328px] bg-surface rounded-(--radius-sm) shadow-elevation-3 flex flex-col gap-(--spacing-4)",
    months: "flex flex-col",
    month: "flex flex-col gap-(--spacing-4)",
    month_caption: "",
    nav: "hidden",
    dropdowns: "flex items-center gap-[26px]",
    dropdown_root: "",
    dropdown: "",
    caption_label: "",
    month_grid: "w-full border-collapse",
    weeks: "flex flex-col gap-(--spacing-8) px-(--spacing-2) pb-(--spacing-16)",
    week: "flex gap-[11px] items-center justify-center",
    weekdays: "flex gap-[11px] items-center justify-center px-(--spacing-2) pt-(--spacing-8) pb-(--spacing-12) border-t border-outline-subtle",
    weekday: "size-(--font-line-height-36) flex items-center justify-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) text-text-subtle",
    day: "size-(--font-line-height-36) flex items-center justify-center rounded-full text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-text-default cursor-pointer transition-colors duration-200 ease-in-out [&:not([data-selected])]:hover:bg-surface-hover [&:not([data-selected])]:active:bg-surface-pressed",
    day_button: "size-full flex items-center justify-center outline-none rounded-full focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring",
    selected: "bg-primary [&>button]:text-primary-on-primary",
    today: "font-(number:--font-weight-semibold)",
    outside: "text-text-subtle",
    disabled: "text-text-disabled pointer-events-none opacity-50",
    hidden: "invisible"
  }, p = {
    MonthCaption: jk,
    Dropdown: Gk
  }, e[4] = d, e[5] = f, e[6] = p) : (d = e[4], f = e[5], p = e[6]);
  let m;
  return e[7] !== i || e[8] !== s || e[9] !== l || e[10] !== a ? (m = /* @__PURE__ */ g(zk, { mode: "single", selected: s, defaultMonth: l, onSelect: a, disabled: i, captionLayout: "dropdown", startMonth: c, endMonth: u, showOutsideDays: !0, formatters: d, classNames: f, components: p }), e[7] = i, e[8] = s, e[9] = l, e[10] = a, e[11] = m) : m = e[11], m;
}
function qk(t) {
  return t.toLocaleString("en-US", {
    month: "short"
  });
}
const Zk = /^(\d{2})\/(\d{2})\/(\d{4})$/;
function _m(t) {
  const e = t.match(Zk);
  if (!e) return null;
  const [, n, o, r] = e, i = new Date(Number(r), Number(n) - 1, Number(o));
  return i.getFullYear() !== Number(r) || i.getMonth() !== Number(n) - 1 || i.getDate() !== Number(o) ? null : i;
}
function wc(t) {
  const e = String(t.getMonth() + 1).padStart(2, "0"), n = String(t.getDate()).padStart(2, "0"), o = t.getFullYear();
  return `${e}/${n}/${o}`;
}
const Xk = ae(["flex", "items-center", "justify-between", "gap-(--spacing-4)", "w-[176px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function oD(t) {
  const e = W.c(73), {
    value: n,
    onValueChange: o,
    label: r,
    size: i,
    required: s,
    description: l,
    tooltip: a,
    error: c,
    disabled: u
  } = t, d = i === void 0 ? "md" : i, f = u === void 0 ? !1 : u, p = Qt(), [m, h] = tt(!1);
  let b;
  e[0] !== n ? (b = n ? wc(n) : "", e[0] = n, e[1] = b) : b = e[1];
  const [v, C] = tt(b), y = ut(null), w = ut(null), R = Xt(), S = Xt(), E = !!c;
  let N, I;
  e[2] !== n ? (N = () => {
    C((xe) => {
      const ce = _m(xe);
      return (n === null ? xe === "" : ce !== null && ce.getFullYear() === n.getFullYear() && ce.getMonth() === n.getMonth() && ce.getDate() === n.getDate()) ? xe : n ? wc(n) : "";
    });
  }, I = [n], e[2] = n, e[3] = N, e[4] = I) : (N = e[3], I = e[4]), _t(N, I);
  let T;
  e[5] !== o ? (T = function(ce) {
    const he = ce.target.value;
    C(he);
    const z = _m(he);
    z ? o(z) : he === "" && o(null);
  }, e[5] = o, e[6] = T) : T = e[6];
  const k = T;
  let P;
  e[7] !== o ? (P = function(ce) {
    o(ce), C(ce ? wc(ce) : ""), h(!1);
  }, e[7] = o, e[8] = P) : P = e[8];
  const M = P;
  let D;
  e[9] !== o ? (D = function() {
    o(null), C(""), h(!1), w.current?.focus();
  }, e[9] = o, e[10] = D) : D = e[10];
  const O = D, _ = v, V = f && "pointer-events-none";
  let A;
  e[11] !== V ? (A = oe("flex flex-col w-fit", V), e[11] = V, e[12] = A) : A = e[12];
  let L;
  e[13] !== R || e[14] !== r || e[15] !== s || e[16] !== a ? (L = r && /* @__PURE__ */ g(pi, { htmlFor: R, label: r, required: s, tooltip: a }), e[13] = R, e[14] = r, e[15] = s, e[16] = a, e[17] = L) : L = e[17];
  let $;
  e[18] !== f || e[19] !== E || e[20] !== d ? ($ = oe(Xk({
    size: d,
    hasError: E
  }), f && "opacity-50"), e[18] = f, e[19] = E, e[20] = d, e[21] = $) : $ = e[21];
  const Y = s || void 0, G = E || void 0, j = l || c ? S : void 0, Z = E && "text-input-error-text";
  let U;
  e[22] !== Z ? (U = oe("flex-1 min-w-0 outline-none bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-text-subtle", Z), e[22] = Z, e[23] = U) : U = e[23];
  let q;
  e[24] !== f || e[25] !== _ || e[26] !== k || e[27] !== R || e[28] !== s || e[29] !== Y || e[30] !== G || e[31] !== j || e[32] !== U ? (q = /* @__PURE__ */ g("input", { id: R, ref: w, type: "text", value: _, onChange: k, placeholder: "MM/DD/YYYY", disabled: f, required: s, "aria-required": Y, "aria-invalid": G, "aria-describedby": j, className: U }), e[24] = f, e[25] = _, e[26] = k, e[27] = R, e[28] = s, e[29] = Y, e[30] = G, e[31] = j, e[32] = U, e[33] = q) : q = e[33];
  let te;
  e[34] !== f || e[35] !== O || e[36] !== n ? (te = n !== null && !f && /* @__PURE__ */ g("button", { type: "button", "aria-label": "Clear date", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", onMouseDown: Qk, onClick: O, children: /* @__PURE__ */ g(Ge, { name: "x-close", size: "xs", tone: "inherit" }) }), e[34] = f, e[35] = O, e[36] = n, e[37] = te) : te = e[37];
  let H;
  e[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (H = /* @__PURE__ */ g(Ge, { name: "calendar", size: "xs", tone: "inherit" }), e[38] = H) : H = e[38];
  let X;
  e[39] !== f ? (X = /* @__PURE__ */ g(Sa, { render: /* @__PURE__ */ g("button", { type: "button", "aria-label": "Open calendar", disabled: f, className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-main hover:text-icon-main disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: H }) }), e[39] = f, e[40] = X) : X = e[40];
  let ee;
  e[41] !== te || e[42] !== X ? (ee = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    te,
    X
  ] }), e[41] = te, e[42] = X, e[43] = ee) : ee = e[43];
  let le;
  e[44] !== $ || e[45] !== q || e[46] !== ee ? (le = /* @__PURE__ */ F("div", { ref: y, className: $, children: [
    q,
    ee
  ] }), e[44] = $, e[45] = q, e[46] = ee, e[47] = le) : le = e[47];
  let Q;
  e[48] !== f || e[49] !== M || e[50] !== n ? (Q = /* @__PURE__ */ g(Ea, { anchor: y, side: "bottom", align: "start", sideOffset: 4, children: /* @__PURE__ */ g(Na, { children: /* @__PURE__ */ g(Kk, { value: n, onValueChange: M, disabled: f }) }) }), e[48] = f, e[49] = M, e[50] = n, e[51] = Q) : Q = e[51];
  let re;
  e[52] !== p || e[53] !== Q ? (re = /* @__PURE__ */ g(Ra, { container: p, children: Q }), e[52] = p, e[53] = Q, e[54] = re) : re = e[54];
  let fe;
  e[55] !== m || e[56] !== le || e[57] !== re ? (fe = /* @__PURE__ */ F(Df, { open: m, onOpenChange: h, modal: !1, children: [
    le,
    re
  ] }), e[55] = m, e[56] = le, e[57] = re, e[58] = fe) : fe = e[58];
  let ne;
  e[59] !== l || e[60] !== S || e[61] !== c || e[62] !== E ? (ne = E ? /* @__PURE__ */ g(Ir, { match: !0, id: S, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: c }) : l ? /* @__PURE__ */ g(di, { id: S, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: l }) : null, e[59] = l, e[60] = S, e[61] = c, e[62] = E, e[63] = ne) : ne = e[63];
  let se;
  e[64] !== ne ? (se = /* @__PURE__ */ g("div", { "data-testid": "date-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: ne }), e[64] = ne, e[65] = se) : se = e[65];
  let pe;
  return e[66] !== f || e[67] !== E || e[68] !== A || e[69] !== L || e[70] !== fe || e[71] !== se ? (pe = /* @__PURE__ */ F(Pr, { invalid: E, disabled: f, className: A, children: [
    L,
    fe,
    se
  ] }), e[66] = f, e[67] = E, e[68] = A, e[69] = L, e[70] = fe, e[71] = se, e[72] = pe) : pe = e[72], pe;
}
function Qk(t) {
  return t.preventDefault();
}
const cl = 8, Vm = 20, Jk = 16, eM = 20;
function Hb(t) {
  return {
    offsetX: t ? t.offsetLeft : Jk,
    offsetY: t ? t.offsetTop : eM,
    width: t?.offsetWidth || Vm,
    height: t?.offsetHeight || Vm
  };
}
function tM(t, e) {
  const n = -e.offsetX, o = -e.offsetY, r = window.innerWidth - e.offsetX - e.width, i = window.innerHeight - e.offsetY - e.height;
  return {
    x: Math.max(n, Math.min(t.x, r)),
    y: Math.max(o, Math.min(t.y, i))
  };
}
function nM(t) {
  const e = W.c(24), {
    dragHandleRef: n,
    position: o,
    onPositionChange: r,
    disabled: i
  } = t, s = i === void 0 ? !1 : i, l = x.useRef(!1), [a, c] = x.useState(!1);
  let u;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    pointerX: 0,
    pointerY: 0,
    elementX: 0,
    elementY: 0
  }, e[0] = u) : u = e[0];
  const d = x.useRef(u);
  let f;
  e[1] !== n ? (f = (k) => tM(k, Hb(n.current)), e[1] = n, e[2] = f) : f = e[2];
  const p = f;
  let m;
  e[3] !== s || e[4] !== o ? (m = (k) => {
    s || k.pointerType === "mouse" && k.button !== 0 || (k.currentTarget.setPointerCapture?.(k.pointerId), l.current = !0, c(!0), d.current = {
      pointerX: k.clientX,
      pointerY: k.clientY,
      elementX: o.x,
      elementY: o.y
    });
  }, e[3] = s, e[4] = o, e[5] = m) : m = e[5];
  const h = m;
  let b;
  e[6] !== p || e[7] !== r ? (b = (k) => {
    if (!l.current)
      return;
    const P = k.clientX - d.current.pointerX, M = k.clientY - d.current.pointerY;
    r(p({
      x: d.current.elementX + P,
      y: d.current.elementY + M
    }));
  }, e[6] = p, e[7] = r, e[8] = b) : b = e[8];
  const v = b;
  let C;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = () => l.current ? (l.current = !1, c(!1), !0) : !1, e[9] = C) : C = e[9];
  const y = C;
  let w;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = (k) => {
    y() && k.currentTarget.releasePointerCapture?.(k.pointerId);
  }, e[10] = w) : w = e[10];
  const R = w;
  let S;
  e[11] !== p || e[12] !== s || e[13] !== r || e[14] !== o ? (S = (k) => {
    if (s || k.target !== k.currentTarget)
      return;
    let P = 0, M = 0;
    if (k.key === "ArrowLeft")
      P = -cl;
    else if (k.key === "ArrowRight")
      P = cl;
    else if (k.key === "ArrowUp")
      M = -cl;
    else if (k.key === "ArrowDown")
      M = cl;
    else
      return;
    k.preventDefault(), r(p({
      x: o.x + P,
      y: o.y + M
    }));
  }, e[11] = p, e[12] = s, e[13] = r, e[14] = o, e[15] = S) : S = e[15];
  const E = S;
  let N;
  e[16] !== E || e[17] !== h || e[18] !== v ? (N = {
    onPointerDown: h,
    onPointerMove: v,
    onPointerUp: R,
    onPointerCancel: y,
    onLostPointerCapture: y,
    onKeyDown: E,
    tabIndex: 0,
    "aria-label": "Drag to reposition",
    "data-slot": "dialog-drag-handle"
  }, e[16] = E, e[17] = h, e[18] = v, e[19] = N) : N = e[19];
  const I = N;
  let T;
  return e[20] !== n || e[21] !== a || e[22] !== I ? (T = {
    dragHandleRef: n,
    isDragging: a,
    dragHandleProps: I
  }, e[20] = n, e[21] = a, e[22] = I, e[23] = T) : T = e[23], T;
}
const Am = 550, Lm = 400, oM = 16, rM = ae(["fixed", "inset-0", "z-50"], {
  variants: {
    expanded: {
      true: ["pointer-events-none", "flex", "items-center", "justify-center", "p-(--spacing-16)"],
      false: "pointer-events-none"
    }
  }
}), iM = ae(["flex", "flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5"], {
  variants: {
    expanded: {
      true: ["pointer-events-auto", "w-[min(1263px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(1136px,calc(100vh_-_var(--spacing-32)))]", "outline-none"],
      false: ["pointer-events-auto", "fixed", "z-50", "h-[min(400px,100vh)]", "w-[min(550px,100vw)]"]
    }
  }
}), sM = ae(["shrink-0", "bg-surface-container-lowest", "px-(--spacing-24)", "py-(--spacing-16)", "shadow-elevation-1"]), lM = ae(["flex", "shrink-0", "flex-col", "gap-(--spacing-6)", "p-(--spacing-16)"]), Fm = ae(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-bold)", "leading-(--font-line-height-28)", "text-text-default"]), $m = ae(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), aM = ae(["mt-(--spacing-4)", "flex", "size-(--spacing-20)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "select-none", "outline-none", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"]), cM = ae(["min-h-0", "flex-1"], {
  variants: {
    expanded: {
      true: "flex",
      false: ["overflow-y-auto", "p-(--spacing-16)"]
    }
  }
}), uM = ae([], {
  variants: {
    expanded: {
      true: ["min-w-0", "flex-1", "overflow-y-auto", "p-(--spacing-16)"],
      false: "contents"
    }
  }
}), Hm = ae(["flex", "min-h-(--spacing-40)", "shrink-0", "items-center", "gap-(--spacing-16)", "px-(--spacing-16)", "pb-(--spacing-16)"]);
function zb() {
  return typeof window > "u" ? {
    width: Am,
    height: Lm
  } : {
    width: Math.min(Am, window.innerWidth),
    height: Math.min(Lm, window.innerHeight)
  };
}
function ul(t, e = zb()) {
  return typeof window > "u" ? t : {
    x: Math.max(0, Math.min(t.x, window.innerWidth - e.width)),
    y: Math.max(0, Math.min(t.y, window.innerHeight - e.height))
  };
}
function zm(t, e) {
  if (typeof window > "u") return t;
  const n = Hb(e);
  return {
    x: Math.max(-n.offsetX, Math.min(t.x, window.innerWidth - n.offsetX - n.width)),
    y: Math.max(-n.offsetY, Math.min(t.y, window.innerHeight - n.offsetY - n.height))
  };
}
function dM(t) {
  if (typeof window > "u") return {
    x: 0,
    y: 0
  };
  const {
    innerWidth: e,
    innerHeight: n
  } = window, o = zb(), r = Math.min(oM, e, n), i = e - o.width - r, s = n - o.height - r;
  switch (t) {
    case "top-start":
      return ul({
        x: r,
        y: r
      }, o);
    case "top-end":
      return ul({
        x: i,
        y: r
      }, o);
    case "bottom-start":
      return ul({
        x: r,
        y: s
      }, o);
    case "bottom-end":
      return ul({
        x: i,
        y: s
      }, o);
  }
}
function rD({
  open: t,
  onOpenChange: e,
  expanded: n = !1,
  onExpandedChange: o,
  initialPlacement: r = "bottom-end",
  position: i,
  onPositionChange: s,
  heading: l,
  description: a,
  headerAccessory: c,
  expandedAside: u,
  children: d,
  floatingFooter: f,
  expandedFooter: p
}) {
  const m = Qt(), h = !!n, b = i !== void 0, [v, C] = x.useState(() => dM(r)), y = i ?? v, w = x.useRef(null), R = (T) => {
    b || C(T), s?.(T);
  }, S = t && !h ? zm(y, w.current) : y, {
    isDragging: E,
    dragHandleProps: N
  } = nM({
    dragHandleRef: w,
    position: S,
    onPositionChange: R,
    disabled: h
  });
  return x.useEffect(() => {
    if (!t || h || typeof window > "u") return;
    const T = () => {
      const k = zm({
        x: y.x,
        y: y.y
      }, w.current);
      (k.x !== y.x || k.y !== y.y) && (b || C(k), s?.(k));
    };
    return T(), window.addEventListener("resize", T), () => window.removeEventListener("resize", T);
  }, [y.x, y.y, b, h, s, t]), /* @__PURE__ */ g(Es, { open: t, onOpenChange: (T, k) => {
    const P = k?.reason === "outside-press" || k?.reason === "focus-out";
    if (!h && !T && P) {
      k.cancel();
      return;
    }
    e(T);
  }, modal: h, disablePointerDismissal: !h, children: /* @__PURE__ */ F(mi, { container: m, children: [
    h && /* @__PURE__ */ g(Ss, { "data-slot": "dialog-scrim", className: "fixed inset-0 z-50 bg-surface-scrim" }),
    /* @__PURE__ */ g(gi, { className: oe(rM({
      expanded: h
    })), children: /* @__PURE__ */ F(Rs, { "aria-modal": h ? "true" : void 0, "data-slot": h ? "dialog-expanded" : "dialog", initialFocus: h ? void 0 : () => w.current, className: oe(iM({
      expanded: h
    })), style: h ? void 0 : {
      left: S.x,
      top: S.y
    }, children: [
      h ? /* @__PURE__ */ F("div", { "data-slot": "dialog-expanded-header", className: oe(sM()), children: [
        /* @__PURE__ */ F("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-16)", children: [
            /* @__PURE__ */ g(Zi, { className: oe(Fm(), "whitespace-nowrap"), children: l }),
            c && /* @__PURE__ */ g("div", { className: "flex min-w-0 items-center gap-(--spacing-16)", children: c })
          ] }),
          /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-16)", children: [
            o && /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Collapse", onClick: () => o(!1) }),
            /* @__PURE__ */ g(qr, { render: /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
          ] })
        ] }),
        a && /* @__PURE__ */ g(qi, { className: oe($m(), "mt-(--spacing-6)"), children: a })
      ] }) : /* @__PURE__ */ g("div", { className: oe(lM()), children: /* @__PURE__ */ F("div", { className: "flex items-start justify-between gap-(--spacing-6)", children: [
        /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 gap-(--spacing-8)", children: [
          /* @__PURE__ */ g("button", { type: "button", ref: w, ...N, className: oe(aM(), E ? "cursor-grabbing" : "cursor-grab"), children: /* @__PURE__ */ g(Ge, { name: "drag", size: "sm", tone: "secondary" }) }),
          /* @__PURE__ */ F("div", { className: "min-w-0 flex-1", children: [
            /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-8)", children: [
              /* @__PURE__ */ g(Zi, { className: oe(Fm(), "min-w-0"), children: l }),
              c && /* @__PURE__ */ g("span", { className: "shrink-0", children: c })
            ] }),
            a && /* @__PURE__ */ g(qi, { className: oe($m(), "mt-(--spacing-4)"), children: a })
          ] })
        ] }),
        /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-4)", children: [
          o && /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Expand", onClick: () => o(!0) }),
          /* @__PURE__ */ g(qr, { render: /* @__PURE__ */ g(gt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
        ] })
      ] }) }),
      /* @__PURE__ */ F("div", { className: oe(cM({
        expanded: h
      })), children: [
        h && u && /* @__PURE__ */ F(Ht, { children: [
          /* @__PURE__ */ g("div", { className: "min-w-0 basis-1/2 overflow-y-auto p-(--spacing-16)", children: u }),
          /* @__PURE__ */ g(mr, { orientation: "vertical" })
        ] }),
        /* @__PURE__ */ g("div", { className: oe(uM({
          expanded: h
        })), children: d }, "body")
      ] }),
      h ? p && /* @__PURE__ */ g("div", { className: oe(Hm()), children: p }) : f && /* @__PURE__ */ g("div", { className: oe(Hm()), children: f })
    ] }) })
  ] }) });
}
const fM = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "h6"
};
function pM() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { "data-slot": "empty-state-pattern", "aria-hidden": "true", viewBox: "0 0 336 336", fill: "none", className: "pointer-events-none absolute top-1/2 left-1/2 size-[336px] max-w-none -translate-x-1/2 -translate-y-1/2 text-outline-subtle", children: /* @__PURE__ */ F("g", { stroke: "currentColor", children: [
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "167.5", strokeOpacity: "0" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "143.5", strokeOpacity: "0.04" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "119.5", strokeOpacity: "0.24" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "95.5", strokeOpacity: "0.48" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "71.5", strokeOpacity: "0.67" }),
    /* @__PURE__ */ g("circle", { cx: "168", cy: "168", r: "47.5", strokeOpacity: "0.88" })
  ] }) }), t[0] = e) : e = t[0], e;
}
function iD(t) {
  const e = W.c(19), {
    icon: n,
    title: o,
    description: r,
    actions: i,
    headingLevel: s
  } = t, a = fM[s === void 0 ? 2 : s];
  let c;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ g(pM, {}), e[0] = c) : c = e[0];
  let u;
  e[1] !== n ? (u = /* @__PURE__ */ F("div", { className: "relative flex size-[48px] items-center justify-center", children: [
    c,
    /* @__PURE__ */ g("div", { className: "relative z-10", children: /* @__PURE__ */ g(Ge, { name: n, size: "md", "aria-hidden": !0 }) })
  ] }), e[1] = n, e[2] = u) : u = e[2];
  let d;
  e[3] !== a || e[4] !== o ? (d = /* @__PURE__ */ g(a, { className: "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-lg) font-(number:--font-weight-bold) leading-(--font-line-height-24) text-text-default", children: o }), e[3] = a, e[4] = o, e[5] = d) : d = e[5];
  let f;
  e[6] !== r ? (f = r ? /* @__PURE__ */ g("p", { className: "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-sm) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-subtle", children: r }) : null, e[6] = r, e[7] = f) : f = e[7];
  let p;
  e[8] !== d || e[9] !== f ? (p = /* @__PURE__ */ F("div", { className: "flex w-full flex-col gap-(--spacing-6)", children: [
    d,
    f
  ] }), e[8] = d, e[9] = f, e[10] = p) : p = e[10];
  let m;
  e[11] !== i ? (m = i ? /* @__PURE__ */ g("div", { className: "mt-(--spacing-32) flex flex-wrap justify-center gap-x-(--spacing-10) gap-y-(--spacing-10)", children: i }) : null, e[11] = i, e[12] = m) : m = e[12];
  let h;
  e[13] !== p || e[14] !== m ? (h = /* @__PURE__ */ F("div", { className: "relative mt-(--spacing-20) flex w-full max-w-[500px] flex-col items-center px-(--spacing-32) text-center", children: [
    p,
    m
  ] }), e[13] = p, e[14] = m, e[15] = h) : h = e[15];
  let b;
  return e[16] !== u || e[17] !== h ? (b = /* @__PURE__ */ F("section", { "data-slot": "empty-state", className: "relative mx-auto flex w-full max-w-[856px] flex-col items-center overflow-hidden bg-surface py-(--spacing-128)", children: [
    u,
    h
  ] }), e[16] = u, e[17] = h, e[18] = b) : b = e[18], b;
}
const qf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (qf.displayName = "TabsRootContext");
function Zf() {
  const t = x.useContext(qf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : et(64));
  return t;
}
let mM = /* @__PURE__ */ (function(t) {
  return t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t;
})({});
const Xf = {
  tabActivationDirection: (t) => ({
    [mM.activationDirection]: t
  })
}, Qf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    defaultValue: r = 0,
    onValueChange: i,
    orientation: s = "horizontal",
    render: l,
    value: a,
    style: c,
    ...u
  } = e, d = Object.hasOwn(e, "defaultValue"), f = x.useRef([]), [p, m] = x.useState(() => /* @__PURE__ */ new Map()), [h, b] = dn({
    controlled: a,
    default: r,
    name: "Tabs",
    state: "value"
  }), v = a !== void 0, [C, y] = x.useState(() => /* @__PURE__ */ new Map()), w = x.useCallback((j) => {
    if (j === void 0)
      return null;
    for (const [Z, U] of C.entries())
      if (U != null && j === (U.value ?? U.index))
        return Z;
    return null;
  }, [C]), [R, S] = x.useState(() => ({
    previousValue: h,
    tabActivationDirection: "none"
  })), {
    previousValue: E,
    tabActivationDirection: N
  } = R;
  let I = N, T = !1;
  E !== h && (I = Bm(E, h, s, C), T = E != null && h != null && w(h) == null);
  const k = T ? E : h, P = E !== k || N !== I;
  Ne(() => {
    P && S({
      previousValue: k,
      tabActivationDirection: I
    });
  }, [k, P, I]);
  const M = Ce((j, Z) => {
    const U = Bm(h, j, s, C);
    Z.activationDirection = U, i?.(j, Z), !Z.isCanceled && b(j);
  }), D = Ce((j, Z) => {
    m((U) => {
      if (U.get(j) === Z)
        return U;
      const q = new Map(U);
      return q.set(j, Z), q;
    });
  }), O = Ce((j, Z) => {
    m((U) => {
      if (!U.has(j) || U.get(j) !== Z)
        return U;
      const q = new Map(U);
      return q.delete(j), q;
    });
  }), _ = x.useCallback((j) => p.get(j), [p]), V = x.useCallback((j) => {
    for (const Z of C.values())
      if (j === Z?.value)
        return Z?.id;
  }, [C]), A = x.useMemo(() => ({
    getTabElementBySelectedValue: w,
    getTabIdByPanelValue: V,
    getTabPanelIdByValue: _,
    onValueChange: M,
    orientation: s,
    registerMountedTabPanel: D,
    setTabMap: y,
    unregisterMountedTabPanel: O,
    tabActivationDirection: I,
    value: h
  }), [w, V, _, M, s, D, y, O, I, h]), L = x.useMemo(() => {
    for (const j of C.values())
      if (j != null && j.value === h)
        return j;
  }, [C, h]), $ = x.useMemo(() => {
    for (const j of C.values())
      if (j != null && !j.disabled)
        return j.value;
  }, [C]);
  Ne(() => {
    if (v || C.size === 0)
      return;
    const j = L?.disabled, Z = L == null && h !== null;
    if (d && j && h === r || !j && !Z)
      return;
    const q = $ ?? null;
    h !== q && (b(q), S((te) => te.tabActivationDirection === "none" ? te : {
      ...te,
      tabActivationDirection: "none"
    }));
  }, [r, $, d, v, L, b, C, h]);
  const G = Le("div", e, {
    state: {
      orientation: s,
      tabActivationDirection: I
    },
    ref: n,
    props: u,
    stateAttributesMapping: Xf
  });
  return /* @__PURE__ */ g(qf.Provider, {
    value: A,
    children: /* @__PURE__ */ g(ri, {
      elementsRef: f,
      children: G
    })
  });
});
process.env.NODE_ENV !== "production" && (Qf.displayName = "TabsRoot");
function Bm(t, e, n, o) {
  if (t == null || e == null)
    return "none";
  let r = null, i = null;
  for (const [a, c] of o.entries()) {
    if (c == null)
      continue;
    const u = c.value ?? c.index;
    if (t === u && (r = a), e === u && (i = a), r != null && i != null)
      break;
  }
  if (r == null || i == null)
    return r !== i && (typeof t == "number" || typeof t == "string") && typeof t == typeof e ? n === "horizontal" ? e > t ? "right" : "left" : e > t ? "down" : "up" : "none";
  const s = r.getBoundingClientRect(), l = i.getBoundingClientRect();
  if (n === "horizontal") {
    if (l.left < s.left)
      return "left";
    if (l.left > s.left)
      return "right";
  } else {
    if (l.top < s.top)
      return "up";
    if (l.top > s.top)
      return "down";
  }
  return "none";
}
const Jf = "data-composite-item-active", e1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (e1.displayName = "TabsListContext");
function gM() {
  const t = x.useContext(e1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : et(65));
  return t;
}
const t1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    disabled: r = !1,
    render: i,
    value: s,
    id: l,
    nativeButton: a = !0,
    style: c,
    ...u
  } = e, {
    value: d,
    getTabPanelIdByValue: f,
    orientation: p
  } = Zf(), {
    activateOnFocus: m,
    highlightedTabIndex: h,
    onTabActivation: b,
    registerTabResizeObserverElement: v,
    setHighlightedTabIndex: C,
    tabsListElement: y
  } = gM(), w = kt(l), R = x.useMemo(() => ({
    disabled: r,
    id: w,
    value: s
  }), [r, w, s]), {
    compositeProps: S,
    compositeRef: E,
    index: N
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = n2({
    metadata: R
  }), I = s === d, T = x.useRef(!1), k = x.useRef(null);
  x.useEffect(() => {
    const G = k.current;
    if (G)
      return v(G);
  }, [v]), Ne(() => {
    if (T.current) {
      T.current = !1;
      return;
    }
    if (!(I && N > -1 && h !== N))
      return;
    const G = y;
    if (G != null) {
      const j = Ut(Je(G));
      if (j && Fe(G, j))
        return;
    }
    r || C(N);
  }, [I, N, h, C, r, y]);
  const {
    getButtonProps: P,
    buttonRef: M
  } = Bt({
    disabled: r,
    native: a,
    focusableWhenDisabled: !0
  }), D = f(s), O = x.useRef(!1), _ = x.useRef(!1);
  function V(G) {
    I || r || b(s, De(Pt, G.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function A(G) {
    I || (N > -1 && !r && C(N), !r && m && (!O.current || // keyboard or touch focus
    O.current && _.current) && b(s, De(Pt, G.nativeEvent, void 0, {
      activationDirection: "none"
    })));
  }
  function L(G) {
    if (I || r)
      return;
    O.current = !0;
    function j() {
      O.current = !1, _.current = !1;
    }
    (!G.button || G.button === 0) && (_.current = !0, Je(G.currentTarget).addEventListener("pointerup", j, {
      once: !0
    }));
  }
  return Le("button", e, {
    state: {
      disabled: r,
      active: I,
      orientation: p
    },
    ref: [n, M, E, k],
    props: [S, {
      role: "tab",
      "aria-controls": D,
      "aria-selected": I,
      id: w,
      onClick: V,
      onFocus: A,
      onPointerDown: L,
      [Jf]: I ? "" : void 0,
      onKeyDownCapture() {
        T.current = !0;
      }
    }, u, P]
  });
});
process.env.NODE_ENV !== "production" && (t1.displayName = "TabsTab");
let hM = (function(t) {
  return t.index = "data-index", t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t.hidden = "data-hidden", t[t.startingStyle = Kn.startingStyle] = "startingStyle", t[t.endingStyle = Kn.endingStyle] = "endingStyle", t;
})({});
const bM = {
  ...Xf,
  ...zt
}, Bb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    value: r,
    render: i,
    keepMounted: s = !1,
    style: l,
    ...a
  } = e, {
    value: c,
    getTabIdByPanelValue: u,
    orientation: d,
    tabActivationDirection: f,
    registerMountedTabPanel: p,
    unregisterMountedTabPanel: m
  } = Zf(), h = kt(), b = x.useMemo(() => ({
    id: h,
    value: r
  }), [h, r]), {
    ref: v,
    index: C
  } = Oo({
    metadata: b
  }), y = r === c, {
    mounted: w,
    transitionStatus: R,
    setMounted: S
  } = Zn(y), E = !w, N = u(r), I = {
    hidden: E,
    orientation: d,
    tabActivationDirection: f,
    transitionStatus: R
  }, T = x.useRef(null), k = Le("div", e, {
    state: I,
    ref: [n, v, T],
    props: [{
      "aria-labelledby": N,
      hidden: E,
      id: h,
      role: "tabpanel",
      tabIndex: y ? 0 : -1,
      inert: Er(!y),
      [hM.index]: C
    }, a],
    stateAttributesMapping: bM
  });
  return Yt({
    open: y,
    ref: T,
    onComplete() {
      y || S(!1);
    }
  }), Ne(() => {
    if (!(E && !s) && h != null)
      return p(r, h), () => {
        m(r, h);
      };
  }, [E, s, r, h, p, m]), s || w ? k : null;
});
process.env.NODE_ENV !== "production" && (Bb.displayName = "TabsPanel");
const vM = [];
function yM(t) {
  const {
    itemSizes: e,
    cols: n = 1,
    loopFocus: o = !0,
    onLoop: r,
    dense: i = !1,
    orientation: s = "both",
    direction: l,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    rootRef: u,
    enableHomeAndEndKeys: d = !1,
    stopEventPropagation: f = !1,
    disabledIndices: p,
    modifierKeys: m = vM
  } = t, [h, b] = x.useState(0), v = n > 1, C = x.useRef(null), y = fn(C, u), w = x.useRef([]), R = x.useRef(!1), S = a ?? h, E = Ce((k, P = !1) => {
    if ((c ?? b)(k), P) {
      const M = w.current[k];
      hp(C.current, M, l, s);
    }
  }), N = Ce((k) => {
    if (k.size === 0 || R.current)
      return;
    R.current = !0;
    const P = Array.from(k.keys()), M = P.find((O) => O?.hasAttribute(Jf)) ?? null, D = M ? P.indexOf(M) : -1;
    D !== -1 && E(D), hp(C.current, M, l, s);
  }), I = Ce((k, P, M) => r ? r?.(k, P, M, w) : M), T = x.useMemo(() => ({
    "aria-orientation": s === "both" ? void 0 : s,
    ref: y,
    onFocus(k) {
      const P = C.current, M = bt(k.nativeEvent);
      !P || M == null || !gp(M) || M.setSelectionRange(0, M.value.length ?? 0);
    },
    onKeyDown(k) {
      const P = d ? T6 : Bh;
      if (!P.has(k.key) || xM(k, m) || !C.current)
        return;
      const D = l === "rtl", O = D ? ji : Br, _ = {
        horizontal: O,
        vertical: cr,
        both: O
      }[s], V = D ? Br : ji, A = {
        horizontal: V,
        vertical: zr,
        both: V
      }[s], L = bt(k.nativeEvent);
      if (L != null && gp(L) && !s2(L)) {
        const q = L.selectionStart, te = L.selectionEnd, H = L.value ?? "";
        if (q == null || k.shiftKey || q !== te || k.key !== A && q < H.length || k.key !== _ && q > 0)
          return;
      }
      let $ = S;
      const Y = vl(w, p), G = tu(w, p);
      if (v) {
        const q = e || Array.from({
          length: w.current.length
        }, () => ({
          width: 1,
          height: 1
        })), te = ih(q, n, i), H = te.findIndex((ee) => ee != null && !No(w.current, ee, p)), X = te.reduce((ee, le, Q) => le != null && !No(w.current, le, p) ? Q : ee, -1);
        $ = te[rh(te.map((ee) => ee != null ? w.current[ee] : null), {
          event: k,
          orientation: s,
          loopFocus: o,
          onLoop: I,
          cols: n,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: lh([...p || w.current.map((ee, le) => No(w.current, le) ? le : void 0), void 0], te),
          minIndex: H,
          maxIndex: X,
          prevIndex: sh(
            S > G ? Y : S,
            q,
            te,
            n,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            k.key === cr ? "bl" : k.key === Br ? "tr" : "tl"
          ),
          rtl: D
        })];
      }
      const j = {
        horizontal: [O],
        vertical: [cr],
        both: [O, cr]
      }[s], Z = {
        horizontal: [V],
        vertical: [zr],
        both: [V, zr]
      }[s], U = v ? P : {
        horizontal: d ? P6 : Hh,
        vertical: d ? I6 : zh,
        both: P
      }[s];
      d && (k.key === ms ? $ = Y : k.key === gs && ($ = G)), $ === S && (j.includes(k.key) || Z.includes(k.key)) && (o && $ === G && j.includes(k.key) ? ($ = Y, r && ($ = r(k, S, $, w))) : o && $ === Y && Z.includes(k.key) ? ($ = G, r && ($ = r(k, S, $, w))) : $ = rn(w.current, {
        startingIndex: $,
        decrement: Z.includes(k.key),
        disabledIndices: p
      })), $ !== S && !Gi(w.current, $) && (f && k.stopPropagation(), U.has(k.key) && k.preventDefault(), E($, !0), queueMicrotask(() => {
        w.current[$]?.focus();
      }));
    }
  }), [n, i, l, p, w, d, S, v, e, o, r, I, y, m, E, s, f]);
  return x.useMemo(() => ({
    props: T,
    highlightedIndex: S,
    onHighlightedIndexChange: E,
    elementsRef: w,
    disabledIndices: p,
    onMapChange: N,
    relayKeyboardEvent: T.onKeyDown
  }), [T, S, E, w, p, N]);
}
function xM(t, e) {
  for (const n of V6.values())
    if (!e.includes(n) && t.getModifierState(n))
      return !0;
  return !1;
}
function Wb(t) {
  const {
    render: e,
    className: n,
    style: o,
    refs: r = Dn,
    props: i = Dn,
    state: s = St,
    stateAttributesMapping: l,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    orientation: u,
    dense: d,
    itemSizes: f,
    loopFocus: p,
    onLoop: m,
    cols: h,
    enableHomeAndEndKeys: b,
    onMapChange: v,
    stopEventPropagation: C = !0,
    rootRef: y,
    disabledIndices: w,
    modifierKeys: R,
    highlightItemOnHover: S = !1,
    tag: E = "div",
    ...N
  } = t, I = bs(), {
    props: T,
    highlightedIndex: k,
    onHighlightedIndexChange: P,
    elementsRef: M,
    onMapChange: D,
    relayKeyboardEvent: O
  } = yM({
    itemSizes: f,
    cols: h,
    loopFocus: p,
    onLoop: m,
    dense: d,
    orientation: u,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    rootRef: y,
    stopEventPropagation: C,
    enableHomeAndEndKeys: b,
    direction: I,
    disabledIndices: w,
    modifierKeys: R
  }), _ = Le(E, t, {
    state: s,
    ref: r,
    props: [T, ...i, N],
    stateAttributesMapping: l
  }), V = x.useMemo(() => ({
    highlightedIndex: k,
    onHighlightedIndexChange: P,
    highlightItemOnHover: S,
    relayKeyboardEvent: O
  }), [k, P, S, O]);
  return /* @__PURE__ */ g(Iu.Provider, {
    value: V,
    children: /* @__PURE__ */ g(ri, {
      elementsRef: M,
      onMapChange: (A) => {
        v?.(A), D(A);
      },
      children: _
    })
  });
}
const n1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    activateOnFocus: o = !1,
    className: r,
    loopFocus: i = !0,
    render: s,
    style: l,
    ...a
  } = e, {
    onValueChange: c,
    orientation: u,
    value: d,
    setTabMap: f,
    tabActivationDirection: p
  } = Zf(), [m, h] = x.useState(0), [b, v] = x.useState(null), C = x.useRef(/* @__PURE__ */ new Set()), y = x.useRef(/* @__PURE__ */ new Set()), w = x.useRef(null), R = Ce(() => {
    C.current.forEach((P) => {
      P();
    });
  });
  x.useEffect(() => {
    if (typeof ResizeObserver > "u")
      return;
    const P = new ResizeObserver(() => {
      C.current.size && R();
    });
    return w.current = P, b && P.observe(b), y.current.forEach((M) => {
      P.observe(M);
    }), () => {
      P.disconnect(), w.current = null;
    };
  }, [b, R]);
  const S = Ce((P) => (C.current.add(P), () => {
    C.current.delete(P);
  })), E = Ce((P) => (y.current.add(P), w.current?.observe(P), () => {
    y.current.delete(P), w.current?.unobserve(P);
  })), N = Ce((P, M) => {
    P !== d && c(P, M);
  }), I = {
    orientation: u,
    tabActivationDirection: p
  }, T = {
    "aria-orientation": u === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, k = x.useMemo(() => ({
    activateOnFocus: o,
    highlightedTabIndex: m,
    registerIndicatorUpdateListener: S,
    registerTabResizeObserverElement: E,
    onTabActivation: N,
    setHighlightedTabIndex: h,
    tabsListElement: b
  }), [o, m, S, E, N, h, b]);
  return /* @__PURE__ */ g(e1.Provider, {
    value: k,
    children: /* @__PURE__ */ g(Wb, {
      render: s,
      className: r,
      style: l,
      state: I,
      refs: [n, v],
      props: [T, a],
      stateAttributesMapping: Xf,
      highlightedIndex: m,
      enableHomeAndEndKeys: !0,
      loopFocus: i,
      orientation: u,
      onHighlightedIndexChange: h,
      onMapChange: f,
      disabledIndices: Dn
    })
  });
});
process.env.NODE_ENV !== "production" && (n1.displayName = "TabsList");
function CM(t) {
  const e = W.c(8), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t;
  let i;
  e[0] !== o ? (i = o ?? [], e[0] = o, e[1] = i) : i = e[1];
  const [s, l] = tt(i), a = n !== void 0, c = a ? n : s;
  let u;
  e[2] !== a || e[3] !== r ? (u = function(m) {
    a || l(m), r?.(m);
  }, e[2] = a, e[3] = r, e[4] = u) : u = e[4];
  const d = u;
  let f;
  return e[5] !== c || e[6] !== d ? (f = [c, d], e[5] = c, e[6] = d, e[7] = f) : f = e[7], f;
}
function Ub(t) {
  const e = W.c(6), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t, [i, s] = tt(o ?? null), l = n !== void 0, a = l ? n : i;
  let c;
  e[0] !== l || e[1] !== r ? (c = function(p) {
    l || s(p), r?.(p);
  }, e[0] = l, e[1] = r, e[2] = c) : c = e[2];
  const u = c;
  let d;
  return e[3] !== a || e[4] !== u ? (d = [a, u], e[3] = a, e[4] = u, e[5] = d) : d = e[5], d;
}
const wM = ae(["inline-flex", "h-(--spacing-32)", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-button-outline-default-text", "outline-none", "transition-colors", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "hover:border-button-outline-hover-border", "hover:bg-button-outline-hover-background", "active:border-button-outline-pressed-border", "active:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-[3px]", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:cursor-not-allowed", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    fullWidth: {
      true: "w-full",
      false: ""
    }
  },
  defaultVariants: {
    fullWidth: !1
  }
});
function Pa(t) {
  const e = W.c(31);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    children: n,
    leadingIcon: r,
    trailingIcon: u,
    showChevron: s,
    open: l,
    mouseDown: a,
    fullWidth: c,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = s === void 0 ? !1 : s, f = l === void 0 ? !1 : l, p = a === void 0 ? !1 : a, m = c === void 0 ? !1 : c;
  let h;
  e[10] !== o || e[11] !== m ? (h = oe(wM({
    fullWidth: m
  }), o), e[10] = o, e[11] = m, e[12] = h) : h = e[12];
  const b = p ? "" : void 0, v = d ? f : i["aria-expanded"];
  let C;
  e[13] !== r ? (C = r && /* @__PURE__ */ g(Ge, { name: r, size: "xs", tone: "inherit" }), e[13] = r, e[14] = C) : C = e[14];
  let y;
  e[15] !== n ? (y = /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: n }), e[15] = n, e[16] = y) : y = e[16];
  let w;
  e[17] !== u ? (w = u && /* @__PURE__ */ g(Ge, { name: u, size: "xs", tone: "inherit" }), e[17] = u, e[18] = w) : w = e[18];
  let R;
  e[19] !== f || e[20] !== d ? (R = d && /* @__PURE__ */ g("span", { "data-open": f ? "" : void 0, className: "inline-flex transition-transform duration-200 data-[open]:rotate-180", children: /* @__PURE__ */ g(Ge, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[19] = f, e[20] = d, e[21] = R) : R = e[21];
  let S;
  return e[22] !== i || e[23] !== w || e[24] !== R || e[25] !== h || e[26] !== b || e[27] !== v || e[28] !== C || e[29] !== y ? (S = /* @__PURE__ */ F(Xn, { className: h, ...i, "data-mouse-down": b, "aria-expanded": v, children: [
    C,
    y,
    w,
    R
  ] }), e[22] = i, e[23] = w, e[24] = R, e[25] = h, e[26] = b, e[27] = v, e[28] = C, e[29] = y, e[30] = S) : S = e[30], S;
}
function sD(t) {
  const e = W.c(43), {
    children: n,
    title: o,
    triggerLabel: r,
    align: i,
    open: s,
    defaultOpen: l,
    onOpenChange: a,
    onApply: c,
    onClearAll: u,
    disabled: d
  } = t, f = o === void 0 ? "Filters" : o, p = i === void 0 ? "start" : i, m = Qt(), [h, b] = tt(l ?? !1), {
    mouseDown: v,
    triggerMouseDownProps: C
  } = Cs(), y = s !== void 0, w = y ? s : h;
  let R;
  e[0] !== y || e[1] !== a ? (R = function(G) {
    y || b(G), a?.(G);
  }, e[0] = y, e[1] = a, e[2] = R) : R = e[2];
  const S = R;
  let E;
  e[3] !== S ? (E = function() {
    S(!1);
  }, e[3] = S, e[4] = E) : E = e[4];
  const N = E;
  let I;
  e[5] !== d || e[6] !== v || e[7] !== f || e[8] !== r || e[9] !== C ? (I = /* @__PURE__ */ g(Sa, { render: r !== void 0 ? /* @__PURE__ */ g(Pa, { trailingIcon: "filter", disabled: d, mouseDown: v, ...C, children: r }) : /* @__PURE__ */ g(gt, { variant: "outline", size: "sm", icon: "filter", "aria-label": f, disabled: d, ...C }) }), e[5] = d, e[6] = v, e[7] = f, e[8] = r, e[9] = C, e[10] = I) : I = e[10];
  let T;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = oe("flex", "w-[500px]", "max-w-[calc(100vw-var(--spacing-32))]", "max-h-[calc(100vh-var(--spacing-32))]", "flex-col", "gap-(--spacing-20)", "overflow-y-auto", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface", "p-(--spacing-20)", "shadow-elevation-3", "outline-none"), e[11] = T) : T = e[11];
  let k;
  e[12] !== f ? (k = /* @__PURE__ */ g("h2", { className: "font-(family-name:--font-family-title) text-(length:--font-size-title-lg) font-(number:--font-weight-bold) leading-(--font-line-height-28) text-text-default", children: f }), e[12] = f, e[13] = k) : k = e[13];
  let P;
  e[14] !== u ? (P = u && /* @__PURE__ */ g(An, { variant: "ghost", size: "sm", onClick: u, children: "Clear All" }), e[14] = u, e[15] = P) : P = e[15];
  let M;
  e[16] !== k || e[17] !== P ? (M = /* @__PURE__ */ F("div", { className: "flex items-center justify-between gap-(--spacing-16)", children: [
    k,
    P
  ] }), e[16] = k, e[17] = P, e[18] = M) : M = e[18];
  let D;
  e[19] !== n || e[20] !== N ? (D = typeof n == "function" ? n({
    close: N
  }) : n, e[19] = n, e[20] = N, e[21] = D) : D = e[21];
  let O;
  e[22] !== D ? (O = /* @__PURE__ */ g("div", { className: "flex flex-col gap-(--spacing-16)", children: D }), e[22] = D, e[23] = O) : O = e[23];
  let _;
  e[24] !== N || e[25] !== c ? (_ = /* @__PURE__ */ g("div", { className: "flex justify-end", children: /* @__PURE__ */ g(An, { size: "sm", onClick: () => {
    c?.(), N();
  }, children: "Apply filters" }) }), e[24] = N, e[25] = c, e[26] = _) : _ = e[26];
  let V;
  e[27] !== O || e[28] !== _ || e[29] !== M || e[30] !== f ? (V = /* @__PURE__ */ F(Na, { role: "dialog", "aria-label": f, className: T, children: [
    M,
    O,
    _
  ] }), e[27] = O, e[28] = _, e[29] = M, e[30] = f, e[31] = V) : V = e[31];
  let A;
  e[32] !== p || e[33] !== V ? (A = /* @__PURE__ */ g(Ea, { side: "bottom", align: p, sideOffset: 4, children: V }), e[32] = p, e[33] = V, e[34] = A) : A = e[34];
  let L;
  e[35] !== m || e[36] !== A ? (L = /* @__PURE__ */ g(Ra, { container: m, children: A }), e[35] = m, e[36] = A, e[37] = L) : L = e[37];
  let $;
  return e[38] !== w || e[39] !== S || e[40] !== L || e[41] !== I ? ($ = /* @__PURE__ */ F(Df, { open: w, onOpenChange: S, modal: !1, children: [
    I,
    L
  ] }), e[38] = w, e[39] = S, e[40] = L, e[41] = I, e[42] = $) : $ = e[42], $;
}
function lD(t) {
  const e = W.c(27), {
    label: n,
    options: o,
    value: r,
    defaultValue: i,
    onChange: s,
    align: l,
    disabled: a
  } = t, c = l === void 0 ? "start" : l;
  let u;
  e[0] !== i || e[1] !== s || e[2] !== r ? (u = {
    value: r,
    defaultValue: i,
    onChange: s
  }, e[0] = i, e[1] = s, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = CM(u), [p, m] = tt(!1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = Cs();
  let v;
  e[4] !== d || e[5] !== f ? (v = function(N, I) {
    f(I ? [...d, N] : d.filter((T) => T !== N));
  }, e[4] = d, e[5] = f, e[6] = v) : v = e[6];
  const C = v;
  let y;
  e[7] !== a || e[8] !== n || e[9] !== h || e[10] !== p || e[11] !== b ? (y = /* @__PURE__ */ g(Yo, { render: /* @__PURE__ */ g(Pa, { showChevron: !0, open: p, disabled: a, mouseDown: h, ...b, children: n }) }), e[7] = a, e[8] = n, e[9] = h, e[10] = p, e[11] = b, e[12] = y) : y = e[12];
  let w;
  if (e[13] !== C || e[14] !== o || e[15] !== d) {
    let E;
    e[17] !== C || e[18] !== d ? (E = (N) => /* @__PURE__ */ g(g7, { checked: d.includes(N.value), disabled: N.disabled, closeOnClick: !1, onCheckedChange: (I) => {
      C(N.value, I);
    }, children: N.label }, N.value), e[17] = C, e[18] = d, e[19] = E) : E = e[19], w = o.map(E), e[13] = C, e[14] = o, e[15] = d, e[16] = w;
  } else
    w = e[16];
  let R;
  e[20] !== c || e[21] !== w ? (R = /* @__PURE__ */ g(kr, { size: "auto", align: c, children: w }), e[20] = c, e[21] = w, e[22] = R) : R = e[22];
  let S;
  return e[23] !== p || e[24] !== y || e[25] !== R ? (S = /* @__PURE__ */ F(li, { open: p, onOpenChange: m, children: [
    y,
    R
  ] }), e[23] = p, e[24] = y, e[25] = R, e[26] = S) : S = e[26], S;
}
function aD(t) {
  const e = W.c(29), {
    options: n,
    value: o,
    defaultValue: r,
    onChange: i,
    placeholder: s,
    align: l,
    disabled: a
  } = t, c = s === void 0 ? "Date Range" : s, u = l === void 0 ? "start" : l;
  let d;
  e[0] !== r || e[1] !== i || e[2] !== o ? (d = {
    value: o,
    defaultValue: r,
    onChange: i
  }, e[0] = r, e[1] = i, e[2] = o, e[3] = d) : d = e[3];
  const [f, p] = Ub(d), [m, h] = tt(!1), {
    mouseDown: b,
    triggerMouseDownProps: v
  } = Cs();
  let C;
  e[4] !== n || e[5] !== c || e[6] !== f ? (C = n.find((k) => k.value === f)?.label ?? c, e[4] = n, e[5] = c, e[6] = f, e[7] = C) : C = e[7];
  const y = C;
  let w;
  e[8] !== a || e[9] !== b || e[10] !== m || e[11] !== y || e[12] !== v ? (w = /* @__PURE__ */ g(Yo, { render: /* @__PURE__ */ g(Pa, { leadingIcon: "calendar", showChevron: !0, open: m, mouseDown: b, disabled: a, ...v, children: y }) }), e[8] = a, e[9] = b, e[10] = m, e[11] = y, e[12] = v, e[13] = w) : w = e[13];
  const R = f ?? "";
  let S;
  e[14] !== p ? (S = (k) => {
    p(k), h(!1);
  }, e[14] = p, e[15] = S) : S = e[15];
  let E;
  e[16] !== n ? (E = n.map(SM), e[16] = n, e[17] = E) : E = e[17];
  let N;
  e[18] !== R || e[19] !== S || e[20] !== E ? (N = /* @__PURE__ */ g(Md, { value: R, onValueChange: S, children: E }), e[18] = R, e[19] = S, e[20] = E, e[21] = N) : N = e[21];
  let I;
  e[22] !== u || e[23] !== N ? (I = /* @__PURE__ */ g(kr, { size: "trigger", align: u, children: N }), e[22] = u, e[23] = N, e[24] = I) : I = e[24];
  let T;
  return e[25] !== m || e[26] !== I || e[27] !== w ? (T = /* @__PURE__ */ F(li, { open: m, onOpenChange: h, children: [
    w,
    I
  ] }), e[25] = m, e[26] = I, e[27] = w, e[28] = T) : T = e[28], T;
}
function SM(t) {
  return /* @__PURE__ */ g(Pd, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function cD(t) {
  const e = W.c(33), {
    prefix: n,
    options: o,
    value: r,
    defaultValue: i,
    onChange: s,
    align: l,
    disabled: a
  } = t, c = l === void 0 ? "start" : l;
  let u;
  e[0] !== i || e[1] !== s || e[2] !== r ? (u = {
    value: r,
    defaultValue: i,
    onChange: s
  }, e[0] = i, e[1] = s, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = Ub(u), [p, m] = tt(!1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = Cs();
  let v;
  e[4] !== o || e[5] !== d ? (v = o.find((P) => P.value === d)?.label ?? "", e[4] = o, e[5] = d, e[6] = v) : v = e[6];
  const C = v;
  let y;
  e[7] !== n ? (y = /* @__PURE__ */ g("span", { className: "text-text-subtle", children: n }), e[7] = n, e[8] = y) : y = e[8];
  let w;
  e[9] !== C ? (w = C && /* @__PURE__ */ F(Ht, { children: [
    " ",
    /* @__PURE__ */ g("span", { children: C })
  ] }), e[9] = C, e[10] = w) : w = e[10];
  let R;
  e[11] !== a || e[12] !== h || e[13] !== p || e[14] !== y || e[15] !== w || e[16] !== b ? (R = /* @__PURE__ */ g(Yo, { render: /* @__PURE__ */ F(Pa, { showChevron: !0, open: p, disabled: a, mouseDown: h, ...b, children: [
    y,
    w
  ] }) }), e[11] = a, e[12] = h, e[13] = p, e[14] = y, e[15] = w, e[16] = b, e[17] = R) : R = e[17];
  const S = d ?? "";
  let E;
  e[18] !== f ? (E = (P) => {
    f(P), m(!1);
  }, e[18] = f, e[19] = E) : E = e[19];
  let N;
  e[20] !== o ? (N = o.map(RM), e[20] = o, e[21] = N) : N = e[21];
  let I;
  e[22] !== S || e[23] !== E || e[24] !== N ? (I = /* @__PURE__ */ g(Md, { value: S, onValueChange: E, children: N }), e[22] = S, e[23] = E, e[24] = N, e[25] = I) : I = e[25];
  let T;
  e[26] !== c || e[27] !== I ? (T = /* @__PURE__ */ g(kr, { size: "trigger", align: c, children: I }), e[26] = c, e[27] = I, e[28] = T) : T = e[28];
  let k;
  return e[29] !== p || e[30] !== T || e[31] !== R ? (k = /* @__PURE__ */ F(li, { open: p, onOpenChange: m, children: [
    R,
    T
  ] }), e[29] = p, e[30] = T, e[31] = R, e[32] = k) : k = e[32], k;
}
function RM(t) {
  return /* @__PURE__ */ g(Pd, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function uD(t) {
  const e = W.c(13), {
    filters: n,
    onRemove: o,
    onClearAll: r,
    label: i
  } = t, s = i === void 0 ? "Filters:" : i;
  if (n.length === 0)
    return null;
  let l;
  e[0] !== s ? (l = /* @__PURE__ */ g("span", { className: "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtle", children: s }), e[0] = s, e[1] = l) : l = e[1];
  let a;
  if (e[2] !== n || e[3] !== o) {
    let d;
    e[5] !== o ? (d = (f) => /* @__PURE__ */ g(H5, { label: f.label, removeAriaLabel: f.removeAriaLabel, onClose: () => o(f.id) }, f.id), e[5] = o, e[6] = d) : d = e[6], a = n.map(d), e[2] = n, e[3] = o, e[4] = a;
  } else
    a = e[4];
  let c;
  e[7] !== r ? (c = /* @__PURE__ */ g(An, { variant: "ghost", size: "sm", onClick: r, children: "Clear All" }), e[7] = r, e[8] = c) : c = e[8];
  let u;
  return e[9] !== l || e[10] !== a || e[11] !== c ? (u = /* @__PURE__ */ F("div", { "aria-live": "polite", className: "flex flex-wrap items-center gap-(--spacing-8)", children: [
    l,
    a,
    c
  ] }), e[9] = l, e[10] = a, e[11] = c, e[12] = u) : u = e[12], u;
}
function dD(t) {
  const e = W.c(13), {
    items: n,
    value: o,
    defaultValue: r,
    onValueChange: i,
    "aria-label": s
  } = t, l = s === void 0 ? "Filter views" : s;
  let a;
  e[0] !== i ? (a = (p) => i?.(p), e[0] = i, e[1] = a) : a = e[1];
  let c;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = oe("inline-flex", "flex-wrap", "max-w-full", "items-center", "gap-[2px]", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface-container-high", "p-[2px]", "max-[599px]:gap-(--spacing-4)", "max-[599px]:p-(--spacing-4)"), e[2] = c) : c = e[2];
  let u;
  e[3] !== n ? (u = n.map(EM), e[3] = n, e[4] = u) : u = e[4];
  let d;
  e[5] !== l || e[6] !== u ? (d = /* @__PURE__ */ g(n1, { "aria-label": l, className: c, children: u }), e[5] = l, e[6] = u, e[7] = d) : d = e[7];
  let f;
  return e[8] !== r || e[9] !== a || e[10] !== d || e[11] !== o ? (f = /* @__PURE__ */ g(Qf, { value: o, defaultValue: r, onValueChange: a, children: d }), e[8] = r, e[9] = a, e[10] = d, e[11] = o, e[12] = f) : f = e[12], f;
}
function EM(t) {
  return /* @__PURE__ */ F(t1, { value: t.value, disabled: t.disabled, "aria-label": t.count === void 0 ? t.label : `${t.label} ${t.count}`, className: oe("relative", "group", "inline-flex", "h-[28px]", "min-w-0", "items-center", "justify-center", "gap-(--spacing-6)", "rounded-(--radius-xs)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-text-subtle", "outline-none", "transition-[background-color,box-shadow]", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "focus-visible:[outline:2px_solid_hsl(var(--button-focus-ring))]", "focus-visible:[outline-offset:2px]", "data-[active]:bg-surface-container-lowest", "data-[active]:text-text-default", "data-[active]:shadow-elevation-1", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "max-[599px]:before:absolute", "max-[599px]:before:left-0", "max-[599px]:before:top-1/2", "max-[599px]:before:h-[44px]", "max-[599px]:before:min-w-[44px]", "max-[599px]:before:w-full", "max-[599px]:before:-translate-y-1/2", "max-[599px]:before:content-['']"), children: [
    /* @__PURE__ */ g("span", { className: "truncate", children: t.label }),
    t.count !== void 0 && /* @__PURE__ */ g("span", { className: "text-text-disabled group-data-[active]:text-text-subtle", children: t.count })
  ] }, t.value);
}
const Wm = oe("border", "border-outline-subtle", "rounded-(--radius-sm)", "flex", "flex-col");
function fD(t) {
  const e = W.c(24);
  let n, o, r;
  e[0] !== t ? ({
    as: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? "form" : r;
  let s, l, a, c;
  if (e[4] !== n) {
    const b = x.Children.toArray(n);
    s = b.find(Gb);
    const v = b.filter(NM);
    c = "overflow-hidden p-(--spacing-20)", l = "flex flex-col gap-(--spacing-20) w-full", a = x.Children.map(v, (C, y) => /* @__PURE__ */ F(Ht, { children: [
      C,
      y < v.length - 1 && /* @__PURE__ */ g(mr, { variant: "middle-inset" })
    ] })), e[4] = n, e[5] = s, e[6] = l, e[7] = a, e[8] = c;
  } else
    s = e[5], l = e[6], a = e[7], c = e[8];
  let u;
  e[9] !== l || e[10] !== a ? (u = /* @__PURE__ */ g("div", { className: l, children: a }), e[9] = l, e[10] = a, e[11] = u) : u = e[11];
  let d;
  e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ g("div", { className: c, children: u }), e[12] = c, e[13] = u, e[14] = d) : d = e[14];
  let f;
  e[15] !== s || e[16] !== d ? (f = /* @__PURE__ */ F(Ht, { children: [
    d,
    s
  ] }), e[15] = s, e[16] = d, e[17] = f) : f = e[17];
  const p = f;
  if (i === "div") {
    const b = o;
    let v;
    return e[18] !== p || e[19] !== b ? (v = /* @__PURE__ */ g("div", { className: Wm, ...b, children: p }), e[18] = p, e[19] = b, e[20] = v) : v = e[20], v;
  }
  const m = o;
  let h;
  return e[21] !== p || e[22] !== m ? (h = /* @__PURE__ */ g("form", { className: Wm, ...m, children: p }), e[21] = p, e[22] = m, e[23] = h) : h = e[23], h;
}
function NM(t) {
  return !Gb(t);
}
function Gb(t) {
  return x.isValidElement(t) && t.type === IM;
}
const kM = ae(["font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "text-text-default", "tracking-(--font-letter-spacing-default)", "shrink-0"], {
  variants: {
    variant: {
      main: ["text-(length:--font-size-title-xl)", "leading-(--font-line-height-28)"],
      subsection: ["text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"]
    }
  }
}), MM = ae(["font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-text-subtext", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]);
function pD(t) {
  const e = W.c(30), {
    variant: n,
    title: o,
    description: r,
    titleAccessory: i,
    actions: s,
    children: l
  } = t, a = n === "main" ? "h2" : "h3", c = x.useId(), u = r != null, d = u ? `${c}-description` : void 0;
  let f;
  e[0] !== o ? (f = /* @__PURE__ */ g("legend", { className: "sr-only", children: o }), e[0] = o, e[1] = f) : f = e[1];
  let p;
  e[2] !== n ? (p = kM({
    variant: n
  }), e[2] = n, e[3] = p) : p = e[3];
  let m;
  e[4] !== a || e[5] !== p || e[6] !== o ? (m = /* @__PURE__ */ g(a, { className: p, children: o }), e[4] = a, e[5] = p, e[6] = o, e[7] = m) : m = e[7];
  const h = i != null && i;
  let b;
  e[8] !== m || e[9] !== h ? (b = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6)", children: [
    m,
    h
  ] }), e[8] = m, e[9] = h, e[10] = b) : b = e[10];
  let v;
  e[11] !== r || e[12] !== u || e[13] !== c ? (v = u && /* @__PURE__ */ g("p", { id: `${c}-description`, className: oe(MM(), "mt-(--spacing-6)"), children: r }), e[11] = r, e[12] = u, e[13] = c, e[14] = v) : v = e[14];
  let C;
  e[15] !== b || e[16] !== v ? (C = /* @__PURE__ */ F("div", { className: "flex-1 min-w-0", children: [
    b,
    v
  ] }), e[15] = b, e[16] = v, e[17] = C) : C = e[17];
  let y;
  e[18] !== s ? (y = s != null && /* @__PURE__ */ g("div", { className: "shrink-0", children: s }), e[18] = s, e[19] = y) : y = e[19];
  let w;
  e[20] !== C || e[21] !== y ? (w = /* @__PURE__ */ F("div", { className: "flex items-start gap-(--spacing-12)", children: [
    C,
    y
  ] }), e[20] = C, e[21] = y, e[22] = w) : w = e[22];
  let R;
  e[23] !== l ? (R = l != null && /* @__PURE__ */ g("div", { className: "mt-(--spacing-16) flex flex-col", children: l }), e[23] = l, e[24] = R) : R = e[24];
  let S;
  return e[25] !== d || e[26] !== w || e[27] !== R || e[28] !== f ? (S = /* @__PURE__ */ F("fieldset", { "aria-describedby": d, className: "border-0 p-0 m-0 min-w-0", children: [
    f,
    w,
    R
  ] }), e[25] = d, e[26] = w, e[27] = R, e[28] = f, e[29] = S) : S = e[29], S;
}
const PM = oe("font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-20)", "text-text-default", "text-(length:--font-size-label-lg)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap", "shrink-0");
function mD(t) {
  const e = W.c(10), {
    columns: n
  } = t, [o, r] = n, i = n.length === 2 ? "justify-between" : "justify-center";
  let s;
  e[0] !== i ? (s = oe("flex w-[212px] items-start p-0", i), e[0] = i, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = /* @__PURE__ */ g(Um, { column: o }), e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== r ? (a = r != null && /* @__PURE__ */ g(Um, { column: r }), e[4] = r, e[5] = a) : a = e[5];
  let c;
  return e[6] !== s || e[7] !== l || e[8] !== a ? (c = /* @__PURE__ */ F("div", { className: s, children: [
    l,
    a
  ] }), e[6] = s, e[7] = l, e[8] = a, e[9] = c) : c = e[9], c;
}
function Um(t) {
  const e = W.c(7), {
    column: n
  } = t;
  let o;
  e[0] !== n.icon ? (o = n.icon != null && /* @__PURE__ */ g(Ge, { name: n.icon, size: "sm", "aria-hidden": !0 }), e[0] = n.icon, e[1] = o) : o = e[1];
  let r;
  e[2] !== n.label ? (r = /* @__PURE__ */ g("span", { className: PM, children: n.label }), e[2] = n.label, e[3] = r) : r = e[3];
  let i;
  return e[4] !== o || e[5] !== r ? (i = /* @__PURE__ */ F("div", { className: "flex flex-1 items-center justify-end gap-(--spacing-8) min-w-0 overflow-hidden", children: [
    o,
    r
  ] }), e[4] = o, e[5] = r, e[6] = i) : i = e[6], i;
}
function IM(t) {
  const e = W.c(18);
  let n, o, r;
  e[0] !== t ? ({
    leading: o,
    actions: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "pointer-events-none h-[58px] w-full shrink-0 bg-gradient-to-b from-surface-0 to-surface mb-[-12px]" }), e[4] = i) : i = e[4];
  const s = o != null && n != null ? "sm:justify-between" : n != null ? "sm:justify-end" : "sm:justify-start";
  let l;
  e[5] !== s ? (l = oe("flex flex-col items-stretch gap-(--spacing-16) overflow-hidden border-t border-outline-subtle bg-surface p-(--spacing-16) shrink-0 rounded-b-(--radius-sm) sm:flex-row sm:items-center", s), e[5] = s, e[6] = l) : l = e[6];
  let a;
  e[7] !== o ? (a = o != null && /* @__PURE__ */ g("div", { className: "min-w-0 w-full sm:flex-1", children: o }), e[7] = o, e[8] = a) : a = e[8];
  let c;
  e[9] !== n ? (c = n != null && /* @__PURE__ */ g("div", { className: "flex flex-wrap items-center justify-end gap-(--spacing-16) self-end sm:flex-nowrap sm:self-auto sm:shrink-0", children: n }), e[9] = n, e[10] = c) : c = e[10];
  let u;
  e[11] !== l || e[12] !== a || e[13] !== c ? (u = /* @__PURE__ */ F("div", { className: l, children: [
    a,
    c
  ] }), e[11] = l, e[12] = a, e[13] = c, e[14] = u) : u = e[14];
  let d;
  return e[15] !== r || e[16] !== u ? (d = /* @__PURE__ */ F("footer", { role: "none", className: "sticky bottom-0 flex flex-col", ...r, children: [
    i,
    u
  ] }), e[15] = r, e[16] = u, e[17] = d) : d = e[17], d;
}
const TM = ae(["fixed", "inset-0", "z-50", "bg-surface-scrim", "data-[starting-style]:opacity-0", "data-[ending-style]:opacity-0", "transition-opacity", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), OM = ae(["pointer-events-none", "fixed", "inset-0", "flex", "flex-col", "gap-(--spacing-10)", "px-(--spacing-24)", "pt-(--spacing-20)", "pb-(--spacing-32)", "outline-none"]), DM = ae(["pointer-events-auto", "max-h-full", "max-w-full", "rounded-(--radius-sm)", "object-contain", "opacity-100", "transition-opacity", "duration-200", "ease-in-out", "starting:opacity-0", "motion-reduce:transition-none"]);
function gD(t) {
  const e = W.c(42), {
    open: n,
    onOpenChange: o,
    images: r,
    index: i,
    onIndexChange: s,
    "aria-label": l
  } = t, a = l === void 0 ? "Image viewer" : l, c = Qt(), u = r[i], d = r.length > 0;
  let f;
  e[0] !== d || e[1] !== r.length || e[2] !== i || e[3] !== s ? (f = () => {
    d && s((i - 1 + r.length) % r.length);
  }, e[0] = d, e[1] = r.length, e[2] = i, e[3] = s, e[4] = f) : f = e[4];
  const p = f;
  let m;
  e[5] !== d || e[6] !== r.length || e[7] !== i || e[8] !== s ? (m = () => {
    d && s((i + 1) % r.length);
  }, e[5] = d, e[6] = r.length, e[7] = i, e[8] = s, e[9] = m) : m = e[9];
  const h = m;
  let b;
  e[10] !== h || e[11] !== p ? (b = (O) => {
    O.altKey || O.ctrlKey || O.metaKey || (O.key === "ArrowLeft" && (O.preventDefault(), p()), O.key === "ArrowRight" && (O.preventDefault(), h()));
  }, e[10] = h, e[11] = p, e[12] = b) : b = e[12];
  const v = b;
  let C;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ g(Ss, { "data-slot": "lightbox-scrim", className: oe(TM()) }), e[13] = C) : C = e[13];
  let y;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = oe(OM()), e[14] = y) : y = e[14];
  let w;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ g("div", { className: "pointer-events-auto self-end", children: /* @__PURE__ */ g(qr, { render: /* @__PURE__ */ g(gt, { icon: "x-close", "aria-label": "Close", variant: "outline", size: "md" }) }) }), e[15] = w) : w = e[15];
  const R = !d;
  let S;
  e[16] !== p || e[17] !== R ? (S = /* @__PURE__ */ g("div", { className: "pointer-events-auto shrink-0", children: /* @__PURE__ */ g(gt, { icon: "arrow-left", "aria-label": "Previous image", variant: "outline", size: "md", disabled: R, onClick: p }) }), e[16] = p, e[17] = R, e[18] = S) : S = e[18];
  let E;
  e[19] !== u || e[20] !== i ? (E = u && /* @__PURE__ */ g("img", { src: u.src, alt: u.alt, className: oe(DM()) }, `${i}-${u.src}`), e[19] = u, e[20] = i, e[21] = E) : E = e[21];
  let N;
  e[22] !== E ? (N = /* @__PURE__ */ g("div", { "data-slot": "lightbox-image-container", className: "flex min-w-0 flex-1 self-stretch items-center justify-center", children: E }), e[22] = E, e[23] = N) : N = e[23];
  const I = !d;
  let T;
  e[24] !== h || e[25] !== I ? (T = /* @__PURE__ */ g("div", { className: "pointer-events-auto shrink-0", children: /* @__PURE__ */ g(gt, { icon: "arrow-right-regular", "aria-label": "Next image", variant: "outline", size: "md", disabled: I, onClick: h }) }), e[24] = h, e[25] = I, e[26] = T) : T = e[26];
  let k;
  e[27] !== N || e[28] !== T || e[29] !== S ? (k = /* @__PURE__ */ F("div", { className: "flex min-h-0 flex-1 items-center gap-(--spacing-24)", children: [
    S,
    N,
    T
  ] }), e[27] = N, e[28] = T, e[29] = S, e[30] = k) : k = e[30];
  let P;
  e[31] !== a || e[32] !== v || e[33] !== k ? (P = /* @__PURE__ */ g(gi, { className: "pointer-events-none fixed inset-0 z-50", children: /* @__PURE__ */ F(Rs, { "aria-label": a, "aria-modal": "true", "data-slot": "lightbox", className: y, onKeyDown: v, children: [
    w,
    k
  ] }) }), e[31] = a, e[32] = v, e[33] = k, e[34] = P) : P = e[34];
  let M;
  e[35] !== c || e[36] !== P ? (M = /* @__PURE__ */ F(mi, { container: c, children: [
    C,
    P
  ] }), e[35] = c, e[36] = P, e[37] = M) : M = e[37];
  let D;
  return e[38] !== o || e[39] !== n || e[40] !== M ? (D = /* @__PURE__ */ g(Es, { open: n, onOpenChange: o, modal: !0, children: M }), e[38] = o, e[39] = n, e[40] = M, e[41] = D) : D = e[41], D;
}
const _M = oe("group relative flex min-h-[140px] w-full flex-col items-stretch justify-center overflow-hidden", "min-w-0 flex-1", "border-0 border-b border-solid border-b-outline-subtle", "bg-surface", "p-(--spacing-16)", "text-left", "transition-colors duration-200 ease-in-out", "after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-(--spacing-4)", "after:bg-primary after:opacity-0 after:transition-opacity after:duration-200 after:ease-in-out after:content-['']", "data-[state=active]:bg-primary/8 data-[state=active]:after:opacity-100", "cursor-pointer", "hover:bg-surface-hover", "active:bg-surface-pressed", "focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-button-focus-ring", "disabled:pointer-events-none disabled:opacity-50");
function hD(t) {
  const e = W.c(9);
  let n, o, r;
  e[0] !== t ? ({
    active: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? !1 : r, s = i ? "active" : "default";
  let l;
  return e[4] !== i || e[5] !== n || e[6] !== o || e[7] !== s ? (l = /* @__PURE__ */ g(Xn, { type: "button", "data-slot": "list-card", "data-state": s, "aria-pressed": i, className: _M, ...o, children: n }), e[4] = i, e[5] = n, e[6] = o, e[7] = s, e[8] = l) : l = e[8], l;
}
const VM = ae([
  "flex",
  "items-center",
  "gap-(--spacing-4)",
  "w-full",
  "rounded-(--radius-sm)",
  "border",
  "border-solid",
  "border-input-default-outline",
  "bg-input-default-background",
  "text-input-text-default",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "cursor-pointer",
  "[&_svg]:shrink-0",
  // Hover (only when not open)
  "[&:not([data-popup-open])]:hover:bg-input-hover-background",
  "[&:not([data-popup-open])]:hover:border-input-hover-outline",
  // Active/open
  "data-[popup-open]:border-input-active-outline",
  // Pressed
  "active:border-input-pressed-outline",
  // Focus ring (keyboard)
  "focus-visible:ring-2",
  "focus-visible:ring-input-focus-ring",
  "focus-visible:ring-offset-1"
], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Gm = ["inline-flex", "items-center", "gap-(--spacing-4)", "h-(--spacing-24)", "bg-chip-neutral-container", "text-chip-neutral-label", "rounded-(--radius-sm)", "px-(--spacing-6)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-20)", "font-(number:--font-weight-medium)", "whitespace-nowrap", "overflow-hidden", "max-w-full", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"];
function Ym(t, e) {
  return t.find((n) => n.value === e)?.label ?? e;
}
function AM(t, e) {
  return e.flatMap((n) => {
    const o = t.find((r) => r.value === n);
    return o ? [o] : [];
  });
}
function bD(t) {
  const e = W.c(93), {
    options: n,
    value: o,
    onChange: r,
    defaultValue: i,
    placeholder: s,
    size: l,
    label: a,
    tooltip: c,
    required: u,
    description: d,
    error: f,
    disabled: p,
    name: m,
    reserveSubtextSpace: h
  } = t, b = l === void 0 ? "md" : l, v = h === void 0 ? !0 : h, C = Qt(), y = ut(null), w = !!f, S = v || w || !!d, E = o !== void 0;
  let N;
  e[0] !== i ? (N = i ?? [], e[0] = i, e[1] = N) : N = e[1];
  const [I, T] = tt(N), [k, P] = tt(!1), M = E ? o : I;
  let D;
  e[2] !== M || e[3] !== n ? (D = AM(n, M), e[2] = M, e[3] = n, e[4] = D) : D = e[4];
  const O = D;
  let _;
  e[5] !== M ? (_ = {
    items: M
  }, e[5] = M, e[6] = _) : _ = e[6];
  const {
    containerRef: V,
    measuringContainerRef: A,
    itemRefs: L,
    overflowRefs: $,
    visibleItems: Y,
    overflowCount: G
  } = y2(_);
  let j;
  e[7] !== E || e[8] !== r ? (j = function(me) {
    const Re = me.map(BM);
    E || T(Re), r?.(Re);
  }, e[7] = E, e[8] = r, e[9] = j) : j = e[9];
  const Z = j;
  let U;
  e[10] !== a || e[11] !== u || e[12] !== c ? (U = a && /* @__PURE__ */ g(pi, { label: a, required: u, tooltip: c }), e[10] = a, e[11] = u, e[12] = c, e[13] = U) : U = e[13];
  let q;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (q = (de, me) => {
    if (!de && me.reason === "item-press") {
      me.cancel();
      return;
    }
    P(de);
  }, e[14] = q) : q = e[14];
  let te;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (te = /* @__PURE__ */ g("div", {}), e[15] = te) : te = e[15];
  let H;
  e[16] !== p || e[17] !== w || e[18] !== b ? (H = oe(VM({
    size: b
  }), p ? "opacity-50 cursor-not-allowed" : "cursor-pointer", w && ["border-input-error-outline", "[&:not([data-popup-open])]:hover:border-input-error-outline"]), e[16] = p, e[17] = w, e[18] = b, e[19] = H) : H = e[19];
  const X = u || void 0;
  let ee;
  e[20] !== M.length || e[21] !== p || e[22] !== n || e[23] !== G || e[24] !== Y ? (ee = M.length > 0 && /* @__PURE__ */ F(Ht, { children: [
    Y.map((de) => /* @__PURE__ */ F(T0, { className: oe(Gm), children: [
      /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: Ym(n, de) }),
      !p && /* @__PURE__ */ g(O0, { className: "inline-flex shrink-0 cursor-pointer items-center text-icon-secondary rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", "aria-label": "Remove", onMouseDown: FM, children: /* @__PURE__ */ g(Ge, { name: "x-close", size: "xs", tone: "inherit" }) })
    ] }, de)),
    G > 0 && /* @__PURE__ */ g(fo, { label: `+${G}`, tone: "neutral" })
  ] }), e[20] = M.length, e[21] = p, e[22] = n, e[23] = G, e[24] = Y, e[25] = ee) : ee = e[25];
  const le = a ? `Search ${a}` : "Search options", Q = M.length === 0 ? s : void 0;
  let re;
  e[26] !== p || e[27] !== le || e[28] !== Q ? (re = /* @__PURE__ */ g(Ms, { "aria-label": le, className: "min-w-0 flex-1 bg-transparent outline-none text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-text-default placeholder:text-input-text-placeholder", disabled: p, placeholder: Q }), e[26] = p, e[27] = le, e[28] = Q, e[29] = re) : re = e[29];
  let fe;
  e[30] !== V || e[31] !== ee || e[32] !== re ? (fe = /* @__PURE__ */ F(I0, { ref: V, "data-multi-select-chips": "", className: "flex flex-1 min-w-0 items-center gap-(--spacing-4) cursor-[inherit]", children: [
    ee,
    re
  ] }), e[30] = V, e[31] = ee, e[32] = re, e[33] = fe) : fe = e[33];
  let ne;
  e[34] !== p ? (ne = !p && /* @__PURE__ */ g(If, { className: "shrink-0 inline-flex items-center text-icon-secondary", "aria-label": "Clear all", onMouseDown: LM, children: /* @__PURE__ */ g(Ge, { name: "x-close", size: "xs", tone: "inherit" }) }), e[34] = p, e[35] = ne) : ne = e[35];
  let se;
  e[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (se = /* @__PURE__ */ g("span", { className: "shrink-0 text-input-text-default inline-flex transition-transform duration-200 [[data-popup-open]_&]:rotate-180 pointer-events-none", children: /* @__PURE__ */ g(Ge, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[36] = se) : se = e[36];
  let pe;
  e[37] !== H || e[38] !== X || e[39] !== fe || e[40] !== ne ? (pe = /* @__PURE__ */ F(ya, { ref: y, render: te, nativeButton: !1, className: H, "aria-required": X, children: [
    fe,
    ne,
    se
  ] }), e[37] = H, e[38] = X, e[39] = fe, e[40] = ne, e[41] = pe) : pe = e[41];
  let xe;
  e[42] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (xe = ys({
    size: "auto"
  }), e[42] = xe) : xe = e[42];
  let ce;
  e[43] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ce = (de) => {
    de.key === "Escape" && P(!1);
  }, e[43] = ce) : ce = e[43];
  let he;
  e[44] !== M ? (he = /* @__PURE__ */ g(Ps, { className: "flex flex-col outline-none", onKeyDownCapture: ce, children: (de) => {
    const me = M.includes(de.value);
    return /* @__PURE__ */ g(Is, { value: de, disabled: de.disabled, className: Ko({}), children: /* @__PURE__ */ g(Ki, { checked: me, checkbox: !0, children: de.label }) }, de.value);
  } }), e[44] = M, e[45] = he) : he = e[45];
  let z;
  e[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (z = /* @__PURE__ */ g(Pf, { className: "[&:empty]:p-0 px-(--spacing-10) py-(--spacing-8) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: "No results available" }), e[46] = z) : z = e[46];
  let J;
  e[47] !== he ? (J = /* @__PURE__ */ g(Ca, { anchor: y, align: "start", sideOffset: 4, className: "z-[var(--z-overlay-popover,180)] w-(--anchor-width)", children: /* @__PURE__ */ F(wa, { className: xe, children: [
    he,
    z
  ] }) }), e[47] = he, e[48] = J) : J = e[48];
  let B;
  e[49] !== C || e[50] !== J ? (B = /* @__PURE__ */ g(xa, { container: C, children: J }), e[49] = C, e[50] = J, e[51] = B) : B = e[51];
  let K;
  if (e[52] !== L || e[53] !== M || e[54] !== p || e[55] !== n) {
    let de;
    e[57] !== L || e[58] !== p || e[59] !== n ? (de = (me, Re) => /* @__PURE__ */ g("span", { ref: (Ie) => {
      L.current[Re] = Ie;
    }, "data-label": Ym(n, me), "data-multi-select-measure": "chip", "data-multi-select-measure-index": Re, className: oe(Gm, "max-w-none before:content-[attr(data-label)]"), children: !p && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 items-center text-icon-secondary", children: /* @__PURE__ */ g(Ge, { name: "x-close", size: "xs", tone: "inherit" }) }) }, `chip-measure-${me}`), e[57] = L, e[58] = p, e[59] = n, e[60] = de) : de = e[60], K = M.map(de), e[52] = L, e[53] = M, e[54] = p, e[55] = n, e[56] = K;
  } else
    K = e[56];
  let ie;
  if (e[61] !== M || e[62] !== $) {
    let de;
    e[64] !== $ ? (de = (me, Re) => {
      const Ie = Re + 1;
      return /* @__PURE__ */ g("span", { ref: (Pe) => {
        $.current[Ie] = Pe;
      }, "data-label": `+${Ie}`, "data-multi-select-measure": "overflow", "data-multi-select-measure-count": Ie, className: "inline-flex items-center justify-center max-w-none gap-(--spacing-4) h-(--spacing-24) rounded-(--radius-sm) overflow-hidden font-(family-name:--font-family-label) text-(length:--font-size-label-medium) leading-(--font-line-height-20) font-(--font-weight-medium) whitespace-nowrap bg-chip-neutral-container text-chip-neutral-label px-(--spacing-6) py-(--spacing-4) before:content-[attr(data-label)]" }, `overflow-measure-${Ie}`);
    }, e[64] = $, e[65] = de) : de = e[65], ie = M.slice(1).map(de), e[61] = M, e[62] = $, e[63] = ie;
  } else
    ie = e[63];
  let ge;
  e[66] !== A || e[67] !== K || e[68] !== ie ? (ge = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ F("div", { ref: A, className: "inline-flex w-max items-center gap-(--spacing-4)", children: [
    K,
    ie
  ] }) }), e[66] = A, e[67] = K, e[68] = ie, e[69] = ge) : ge = e[69];
  let ue;
  e[70] !== p || e[71] !== Z || e[72] !== k || e[73] !== m || e[74] !== n || e[75] !== u || e[76] !== O || e[77] !== pe || e[78] !== B || e[79] !== ge ? (ue = /* @__PURE__ */ F(bf, { multiple: !0, value: O, onValueChange: Z, disabled: p, required: u, name: m, modal: !1, open: k, onOpenChange: q, items: n, isItemEqualToValue: zM, itemToStringLabel: HM, itemToStringValue: $M, children: [
    pe,
    B,
    ge
  ] }), e[70] = p, e[71] = Z, e[72] = k, e[73] = m, e[74] = n, e[75] = u, e[76] = O, e[77] = pe, e[78] = B, e[79] = ge, e[80] = ue) : ue = e[80];
  let Se;
  e[81] !== d || e[82] !== f || e[83] !== w || e[84] !== v || e[85] !== S ? (Se = S && /* @__PURE__ */ g("div", { "data-testid": "multi-select-subtext-row", className: oe("mt-(--spacing-4)", v && "min-h-(--spacing-20)"), children: w ? /* @__PURE__ */ g(Ir, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: f }) : d ? /* @__PURE__ */ g(di, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: d }) : null }), e[81] = d, e[82] = f, e[83] = w, e[84] = v, e[85] = S, e[86] = Se) : Se = e[86];
  let ve;
  return e[87] !== p || e[88] !== w || e[89] !== ue || e[90] !== Se || e[91] !== U ? (ve = /* @__PURE__ */ F(Pr, { invalid: w, disabled: p, className: "relative flex flex-col w-full", children: [
    U,
    ue,
    Se
  ] }), e[87] = p, e[88] = w, e[89] = ue, e[90] = Se, e[91] = U, e[92] = ve) : ve = e[92], ve;
}
function LM(t) {
  return t.stopPropagation();
}
function FM(t) {
  return t.stopPropagation();
}
function $M(t) {
  return t.value;
}
function HM(t) {
  return t.label;
}
function zM(t, e) {
  return t.value === e.value;
}
function BM(t) {
  return t.value;
}
const WM = [10, 25, 50, 100];
function Zo(t, e) {
  return Number.isFinite(t) && t > 0 ? Math.floor(t) : e;
}
function vi(t, e) {
  const n = Zo(e, 1), o = Zo(t, 1);
  return Math.min(Math.max(o, 1), n);
}
function Yb(t, e) {
  const n = Zo(e, 1), o = vi(t, n);
  return n === 1 ? "none" : o === 1 ? "right" : o === n ? "left" : "both";
}
function UM(t, e) {
  const n = Zo(e, 1), o = vi(t, n);
  return n <= 4 ? Array.from({
    length: n
  }, (r, i) => ({
    type: "page",
    page: i + 1
  })) : o <= 3 ? [{
    type: "page",
    page: 1
  }, {
    type: "page",
    page: 2
  }, {
    type: "page",
    page: 3
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }] : o >= n - 2 ? [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: n - 2
  }, {
    type: "page",
    page: n - 1
  }, {
    type: "page",
    page: n
  }] : [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: o - 1
  }, {
    type: "page",
    page: o
  }, {
    type: "page",
    page: o + 1
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }];
}
function GM({
  currentPage: t,
  rowsPerPage: e,
  totalItems: n,
  totalPages: o
}) {
  const r = Math.max(0, Math.floor(n));
  if (r === 0)
    return "0 - 0 of 0";
  const i = Zo(e, r), s = vi(t, o), l = (s - 1) * i + 1, a = Math.min(s * i, r);
  return `${l} - ${a} of ${r}`;
}
function YM(t, e) {
  return e ? `Page ${t}, current page` : `Go to page ${t}`;
}
function Kl(t) {
  const e = W.c(11), {
    direction: n,
    disabled: o,
    mobile: r,
    onClick: i
  } = t, s = r === void 0 ? !1 : r, l = n === "previous", a = l ? "Previous page" : "Next page", c = s ? "size-[44px]" : "size-(--spacing-32)", u = o ? "cursor-default text-icon-disabled" : "cursor-pointer text-surface-on-surface hover:bg-surface-hover active:bg-surface-pressed";
  let d;
  e[0] !== c || e[1] !== u ? (d = oe("inline-flex shrink-0 items-center justify-center rounded-(--radius-sm) border-0 bg-transparent p-0 outline-none transition-colors duration-200 ease-in-out", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", c, u), e[0] = c, e[1] = u, e[2] = d) : d = e[2];
  const f = l ? "chevron-left" : "chevron-right";
  let p;
  e[3] !== f ? (p = /* @__PURE__ */ g(Ge, { name: f, size: "xs", tone: "inherit" }), e[3] = f, e[4] = p) : p = e[4];
  let m;
  return e[5] !== o || e[6] !== i || e[7] !== a || e[8] !== d || e[9] !== p ? (m = /* @__PURE__ */ g("button", { type: "button", "aria-label": a, disabled: o, onClick: i, className: d, children: p }), e[5] = o, e[6] = i, e[7] = a, e[8] = d, e[9] = p, e[10] = m) : m = e[10], m;
}
function jm(t) {
  const e = W.c(26), {
    currentPage: n,
    totalPages: o,
    onPageChange: r,
    showPageIndicator: i
  } = t, s = i === void 0 ? !1 : i;
  let l, a, c;
  e[0] !== n || e[1] !== o ? (a = Zo(o, 1), l = vi(n, a), c = Yb(l, a), e[0] = n, e[1] = o, e[2] = l, e[3] = a, e[4] = c) : (l = e[2], a = e[3], c = e[4]);
  const u = c, d = u === "both" || u === "left", f = u === "both" || u === "right", p = !d;
  let m;
  e[5] !== r || e[6] !== l ? (m = () => r(l - 1), e[5] = r, e[6] = l, e[7] = m) : m = e[7];
  let h;
  e[8] !== p || e[9] !== m ? (h = /* @__PURE__ */ g(Kl, { direction: "previous", disabled: p, onClick: m }), e[8] = p, e[9] = m, e[10] = h) : h = e[10];
  let b;
  e[11] !== r || e[12] !== l || e[13] !== a || e[14] !== s ? (b = s && /* @__PURE__ */ g(jM, { currentPage: l, totalPages: a, onPageChange: r }), e[11] = r, e[12] = l, e[13] = a, e[14] = s, e[15] = b) : b = e[15];
  const v = !f;
  let C;
  e[16] !== r || e[17] !== l ? (C = () => r(l + 1), e[16] = r, e[17] = l, e[18] = C) : C = e[18];
  let y;
  e[19] !== v || e[20] !== C ? (y = /* @__PURE__ */ g(Kl, { direction: "next", disabled: v, onClick: C }), e[19] = v, e[20] = C, e[21] = y) : y = e[21];
  let w;
  return e[22] !== h || e[23] !== b || e[24] !== y ? (w = /* @__PURE__ */ F("div", { className: "flex items-center justify-center gap-(--spacing-12)", children: [
    h,
    b,
    y
  ] }), e[22] = h, e[23] = b, e[24] = y, e[25] = w) : w = e[25], w;
}
function jM(t) {
  const e = W.c(9), {
    currentPage: n,
    totalPages: o,
    onPageChange: r
  } = t;
  let i;
  if (e[0] !== n || e[1] !== r || e[2] !== o) {
    let l;
    e[4] !== n || e[5] !== r ? (l = (a) => {
      if (a.type === "ellipsis")
        return /* @__PURE__ */ g(KM, {}, a.key);
      const c = a.page === n;
      return /* @__PURE__ */ g("button", { type: "button", "aria-label": YM(a.page, c), "aria-current": c ? "page" : void 0, onClick: () => r(a.page), className: oe("inline-flex min-w-(--spacing-20) items-center justify-center rounded-(--radius-sm) px-(--spacing-6) py-(--spacing-2)", "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20)", "outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", c ? "bg-primary text-primary-on-primary" : "cursor-pointer text-text-subtle hover:bg-surface-hover active:bg-surface-pressed"), children: a.page }, a.page);
    }, e[4] = n, e[5] = r, e[6] = l) : l = e[6], i = UM(n, o).map(l), e[0] = n, e[1] = r, e[2] = o, e[3] = i;
  } else
    i = e[3];
  let s;
  return e[7] !== i ? (s = /* @__PURE__ */ g("div", { className: "flex items-center justify-center gap-(--spacing-10)", children: i }), e[7] = i, e[8] = s) : s = e[8], s;
}
function KM() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("span", { className: "select-none whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-default", children: "..." }), t[0] = e) : e = t[0], e;
}
function qM(t) {
  const e = W.c(16), {
    selectId: n,
    rowsPerPage: o,
    rowsPerPageOptions: r,
    disabled: i,
    onRowsPerPageChange: s,
    onPageChange: l
  } = t, a = i === void 0 ? !1 : i;
  let c;
  e[0] !== n ? (c = /* @__PURE__ */ g("label", { htmlFor: n, className: "whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: "Rows per page" }), e[0] = n, e[1] = c) : c = e[1];
  const u = String(o);
  let d;
  e[2] !== r ? (d = r.map(ZM), e[2] = r, e[3] = d) : d = e[3];
  let f;
  e[4] !== l || e[5] !== s ? (f = (h) => {
    h != null && (s(Number(h)), l(1));
  }, e[4] = l, e[5] = s, e[6] = f) : f = e[6];
  let p;
  e[7] !== a || e[8] !== n || e[9] !== u || e[10] !== d || e[11] !== f ? (p = /* @__PURE__ */ g("div", { className: "h-(--spacing-32) w-(--spacing-80) shrink-0", children: /* @__PURE__ */ g(_0, { id: n, size: "sm", value: u, disabled: a, reserveSubtextSpace: !1, options: d, onChange: f }) }), e[7] = a, e[8] = n, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : p = e[12];
  let m;
  return e[13] !== c || e[14] !== p ? (m = /* @__PURE__ */ F("div", { className: "flex h-(--spacing-40) w-[188px] shrink-0 items-center justify-between gap-(--spacing-12)", children: [
    c,
    p
  ] }), e[13] = c, e[14] = p, e[15] = m) : m = e[15], m;
}
function ZM(t) {
  return {
    value: String(t),
    label: String(t)
  };
}
function XM(t) {
  const e = W.c(22), {
    rangeLabel: n,
    currentPage: o,
    totalPages: r,
    onPageChange: i
  } = t;
  let s, l;
  if (e[0] !== o || e[1] !== r) {
    const y = Zo(r, 1);
    s = vi(o, y), l = Yb(s, y), e[0] = o, e[1] = r, e[2] = s, e[3] = l;
  } else
    s = e[2], l = e[3];
  const a = l, c = a === "both" || a === "left", u = a === "both" || a === "right", d = !c;
  let f;
  e[4] !== i || e[5] !== s ? (f = () => i(s - 1), e[4] = i, e[5] = s, e[6] = f) : f = e[6];
  let p;
  e[7] !== d || e[8] !== f ? (p = /* @__PURE__ */ g(Kl, { direction: "previous", mobile: !0, disabled: d, onClick: f }), e[7] = d, e[8] = f, e[9] = p) : p = e[9];
  let m;
  e[10] !== n ? (m = /* @__PURE__ */ g("span", { className: "min-w-0 truncate px-(--spacing-12) text-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: n }), e[10] = n, e[11] = m) : m = e[11];
  const h = !u;
  let b;
  e[12] !== i || e[13] !== s ? (b = () => i(s + 1), e[12] = i, e[13] = s, e[14] = b) : b = e[14];
  let v;
  e[15] !== h || e[16] !== b ? (v = /* @__PURE__ */ g(Kl, { direction: "next", mobile: !0, disabled: h, onClick: b }), e[15] = h, e[16] = b, e[17] = v) : v = e[17];
  let C;
  return e[18] !== p || e[19] !== m || e[20] !== v ? (C = /* @__PURE__ */ F("div", { className: "flex h-[44px] w-full items-center justify-between px-(--spacing-16) sm:hidden", children: [
    p,
    m,
    v
  ] }), e[18] = p, e[19] = m, e[20] = v, e[21] = C) : C = e[21], C;
}
function QM(t) {
  const e = W.c(28), {
    currentPage: n,
    totalPages: o,
    totalItems: r,
    rowsPerPage: i,
    onPageChange: s
  } = t, l = Xt();
  let a, c, u, d;
  e[0] !== n || e[1] !== i || e[2] !== r || e[3] !== o ? (u = Zo(o, 1), c = vi(n, u), a = r <= 0, d = GM({
    currentPage: c,
    rowsPerPage: i,
    totalItems: r,
    totalPages: u
  }), e[0] = n, e[1] = i, e[2] = r, e[3] = o, e[4] = a, e[5] = c, e[6] = u, e[7] = d) : (a = e[4], c = e[5], u = e[6], d = e[7]);
  const f = d;
  let p;
  e[8] !== s || e[9] !== f || e[10] !== c || e[11] !== u ? (p = /* @__PURE__ */ g(XM, { rangeLabel: f, currentPage: c, totalPages: u, onPageChange: s }), e[8] = s, e[9] = f, e[10] = c, e[11] = u, e[12] = p) : p = e[12];
  let m;
  e[13] !== s || e[14] !== t.contextLabel || e[15] !== t.onRowsPerPageChange || e[16] !== t.rowsPerPageOptions || e[17] !== t.variant || e[18] !== f || e[19] !== i || e[20] !== a || e[21] !== l || e[22] !== c || e[23] !== u ? (m = t.variant === "simplified" ? /* @__PURE__ */ F("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) sm:flex", children: [
    /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: t.contextLabel }),
    /* @__PURE__ */ g("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ g(jm, { currentPage: c, totalPages: u, onPageChange: s, showPageIndicator: !0 }) }),
    /* @__PURE__ */ g("div", { className: "h-(--spacing-40) flex-1" })
  ] }) : /* @__PURE__ */ F("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) sm:flex", children: [
    /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: f }),
    /* @__PURE__ */ g("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ g(jm, { currentPage: c, totalPages: u, onPageChange: s, showPageIndicator: !0 }) }),
    /* @__PURE__ */ g("div", { className: "flex flex-1 justify-end", children: /* @__PURE__ */ g(qM, { selectId: l, rowsPerPage: i, rowsPerPageOptions: t.rowsPerPageOptions ?? WM, disabled: a, onRowsPerPageChange: t.onRowsPerPageChange, onPageChange: s }) })
  ] }), e[13] = s, e[14] = t.contextLabel, e[15] = t.onRowsPerPageChange, e[16] = t.rowsPerPageOptions, e[17] = t.variant, e[18] = f, e[19] = i, e[20] = a, e[21] = l, e[22] = c, e[23] = u, e[24] = m) : m = e[24];
  let h;
  return e[25] !== p || e[26] !== m ? (h = /* @__PURE__ */ F("nav", { "aria-label": "Table pagination", className: "w-full", children: [
    p,
    m
  ] }), e[25] = p, e[26] = m, e[27] = h) : h = e[27], h;
}
function vD(t) {
  const e = W.c(4), {
    open: n,
    onOpenChange: o,
    children: r
  } = t;
  let i;
  return e[0] !== r || e[1] !== o || e[2] !== n ? (i = /* @__PURE__ */ g(Df, { open: n, onOpenChange: o, modal: !1, children: r }), e[0] = r, e[1] = o, e[2] = n, e[3] = i) : i = e[3], i;
}
function yD(t) {
  const e = W.c(2), {
    render: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g(Sa, { render: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function xD(t) {
  const e = W.c(10), {
    children: n,
    side: o,
    align: r,
    sideOffset: i
  } = t, s = o === void 0 ? "bottom" : o, l = r === void 0 ? "start" : r, a = i === void 0 ? 4 : i, c = Qt();
  let u;
  e[0] !== n ? (u = /* @__PURE__ */ g(Na, { children: n }), e[0] = n, e[1] = u) : u = e[1];
  let d;
  e[2] !== l || e[3] !== s || e[4] !== a || e[5] !== u ? (d = /* @__PURE__ */ g(Ea, { side: s, align: l, sideOffset: a, children: u }), e[2] = l, e[3] = s, e[4] = a, e[5] = u, e[6] = d) : d = e[6];
  let f;
  return e[7] !== c || e[8] !== d ? (f = /* @__PURE__ */ g(Ra, { container: c, children: d }), e[7] = c, e[8] = d, e[9] = f) : f = e[9], f;
}
const Km = /* @__PURE__ */ new Map();
function JM(t, e) {
  const n = JSON.stringify({
    locale: t,
    options: e
  }), o = Km.get(n);
  if (o)
    return o;
  const r = new Intl.NumberFormat(t, e);
  return Km.set(n, r), r;
}
function qm(t, e, n) {
  return t == null ? "" : JM(e, n).format(t);
}
function eP(t, e, n) {
  return t == null ? "" : n ? qm(t, e, n) : qm(t / 100, e, {
    style: "percent"
  });
}
const o1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (o1.displayName = "ProgressRootContext");
function jb() {
  const t = x.useContext(o1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ProgressRootContext is missing. Progress parts must be placed within <Progress.Root>." : et(51));
  return t;
}
let Sc = /* @__PURE__ */ (function(t) {
  return t.complete = "data-complete", t.indeterminate = "data-indeterminate", t.progressing = "data-progressing", t;
})({});
const r1 = {
  status(t) {
    return t === "progressing" ? {
      [Sc.progressing]: ""
    } : t === "complete" ? {
      [Sc.complete]: ""
    } : t === "indeterminate" ? {
      [Sc.indeterminate]: ""
    } : null;
  }
};
function tP(t, e) {
  return e == null ? "indeterminate progress" : t || `${e}%`;
}
const i1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    format: o,
    getAriaValueText: r = tP,
    locale: i,
    max: s = 100,
    min: l = 0,
    value: a,
    render: c,
    className: u,
    children: d,
    style: f,
    ...p
  } = e, [m, h] = x.useState(), b = Ft(o);
  let v = "indeterminate";
  Number.isFinite(a) && (v = a === s ? "complete" : "progressing");
  const C = eP(a, i, b.current), y = x.useMemo(() => ({
    status: v
  }), [v]), w = {
    "aria-labelledby": m,
    "aria-valuemax": s,
    "aria-valuemin": l,
    "aria-valuenow": a ?? void 0,
    "aria-valuetext": r(C, a),
    role: "progressbar",
    children: /* @__PURE__ */ F(x.Fragment, {
      children: [d, /* @__PURE__ */ g("span", {
        role: "presentation",
        style: Jo,
        children: "x"
      })]
    })
  }, R = x.useMemo(() => ({
    formattedValue: C,
    max: s,
    min: l,
    setLabelId: h,
    state: y,
    status: v,
    value: a
  }), [C, s, l, h, y, v, a]), S = Le("div", e, {
    state: y,
    ref: n,
    props: [w, p],
    stateAttributesMapping: r1
  });
  return /* @__PURE__ */ g(o1.Provider, {
    value: R,
    children: S
  });
});
process.env.NODE_ENV !== "production" && (i1.displayName = "ProgressRoot");
const Kb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = jb();
  return Le("div", e, {
    state: l,
    ref: n,
    props: s,
    stateAttributesMapping: r1
  });
});
process.env.NODE_ENV !== "production" && (Kb.displayName = "ProgressTrack");
function nP(t, e, n) {
  return (t - e) * 100 / (n - e);
}
const qb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    max: l,
    min: a,
    value: c,
    state: u
  } = jb(), d = Number.isFinite(c) && c !== null ? nP(c, a, l) : null, f = x.useCallback(() => d == null ? {} : {
    insetInlineStart: 0,
    height: "inherit",
    width: `${d}%`
  }, [d]);
  return Le("div", e, {
    state: u,
    ref: n,
    props: [{
      style: f()
    }, s],
    stateAttributesMapping: r1
  });
});
process.env.NODE_ENV !== "production" && (qb.displayName = "ProgressIndicator");
const oP = {
  sm: "2px",
  md: "4px",
  lg: "8px"
}, rP = {
  brand: "bg-primary",
  positive: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  negative: "bg-datavis-crit-red"
};
function CD(t) {
  const e = W.c(22);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    value: l,
    size: i,
    tone: s,
    "aria-label": n,
    "aria-labelledby": o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "md" : i, c = s === void 0 ? "brand" : s;
  let u;
  e[7] !== l ? (u = Number.isFinite(l) ? Math.min(100, Math.max(0, l)) : 0, e[7] = l, e[8] = u) : u = e[8];
  const d = u, f = oP[a];
  let p;
  e[9] !== f ? (p = {
    height: f
  }, e[9] = f, e[10] = p) : p = e[10];
  const m = `absolute ${rP[c]}`;
  let h;
  e[11] !== m ? (h = /* @__PURE__ */ g(qb, { className: m }), e[11] = m, e[12] = h) : h = e[12];
  let b;
  e[13] !== p || e[14] !== h ? (b = /* @__PURE__ */ g(Kb, { className: "relative w-full overflow-hidden bg-[hsl(var(--surface-inverse-surface)/0.2)]", style: p, children: h }), e[13] = p, e[14] = h, e[15] = b) : b = e[15];
  let v;
  return e[16] !== n || e[17] !== o || e[18] !== d || e[19] !== r || e[20] !== b ? (v = /* @__PURE__ */ g(i1, { ...r, value: d, "aria-label": n, "aria-labelledby": o, children: b }), e[16] = n, e[17] = o, e[18] = d, e[19] = r, e[20] = b, e[21] = v) : v = e[21], v;
}
const iP = {
  sm: {
    diameter: 16,
    stroke: 3
  },
  md: {
    diameter: 36,
    stroke: 5
  },
  lg: {
    diameter: 56,
    stroke: 7
  }
}, sP = {
  brand: "stroke-primary",
  positive: "stroke-datavis-crit-green",
  warning: "stroke-datavis-crit-yellow",
  negative: "stroke-datavis-crit-red"
};
function wD(t) {
  const e = W.c(40);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    value: a,
    size: s,
    tone: l,
    "aria-label": n,
    "aria-labelledby": o,
    style: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? "md" : s, u = l === void 0 ? "brand" : l;
  let d;
  e[8] !== a ? (d = Number.isFinite(a) ? Math.min(100, Math.max(0, a)) : 0, e[8] = a, e[9] = d) : d = e[9];
  const f = d, {
    diameter: p,
    stroke: m
  } = iP[c], h = (p - m) / 2, b = 2 * Math.PI * h, v = b * (1 - f / 100), C = p / 2;
  let y;
  e[10] !== p ? (y = {
    display: "inline-flex",
    width: p,
    height: p
  }, e[10] = p, e[11] = y) : y = e[11];
  const w = y;
  let R;
  e[12] !== w || e[13] !== i ? (R = typeof i == "function" ? (_) => ({
    ...i(_),
    ...w
  }) : {
    ...i,
    ...w
  }, e[12] = w, e[13] = i, e[14] = R) : R = e[14];
  const S = R, E = `0 0 ${p} ${p}`;
  let N;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = {
    stroke: "hsl(var(--surface-inverse-surface) / 0.2)"
  }, e[15] = N) : N = e[15];
  let I;
  e[16] !== C || e[17] !== h || e[18] !== m ? (I = /* @__PURE__ */ g("circle", { cx: C, cy: C, r: h, strokeWidth: m, strokeLinecap: "butt", style: N }), e[16] = C, e[17] = h, e[18] = m, e[19] = I) : I = e[19];
  const T = `${b} ${b}`, k = sP[u];
  let P;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = {
    transform: "rotate(-90deg)",
    transformOrigin: "50% 50%"
  }, e[20] = P) : P = e[20];
  let M;
  e[21] !== C || e[22] !== v || e[23] !== h || e[24] !== m || e[25] !== k || e[26] !== T ? (M = /* @__PURE__ */ g("circle", { cx: C, cy: C, r: h, strokeWidth: m, strokeLinecap: "butt", strokeDasharray: T, strokeDashoffset: v, className: k, style: P }), e[21] = C, e[22] = v, e[23] = h, e[24] = m, e[25] = k, e[26] = T, e[27] = M) : M = e[27];
  let D;
  e[28] !== p || e[29] !== M || e[30] !== E || e[31] !== I ? (D = /* @__PURE__ */ F("svg", { width: p, height: p, viewBox: E, fill: "none", "aria-hidden": "true", children: [
    I,
    M
  ] }), e[28] = p, e[29] = M, e[30] = E, e[31] = I, e[32] = D) : D = e[32];
  let O;
  return e[33] !== n || e[34] !== o || e[35] !== f || e[36] !== r || e[37] !== S || e[38] !== D ? (O = /* @__PURE__ */ g(i1, { ...r, value: f, "aria-label": n, "aria-labelledby": o, style: S, children: D }), e[33] = n, e[34] = o, e[35] = f, e[36] = r, e[37] = S, e[38] = D, e[39] = O) : O = e[39], O;
}
let Zm = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const pu = {
  checked(t) {
    return t ? {
      [Zm.checked]: ""
    } : {
      [Zm.unchecked]: ""
    };
  },
  ...zt,
  ...eo
}, s1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (s1.displayName = "RadioGroupContext");
function lP() {
  return x.useContext(s1);
}
const l1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (l1.displayName = "RadioRootContext");
function aP() {
  const t = x.useContext(l1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: RadioRootContext is missing. Radio parts must be placed within <Radio.Root>." : et(52));
  return t;
}
const Zb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    readOnly: s = !1,
    required: l = !1,
    "aria-labelledby": a,
    value: c,
    inputRef: u,
    nativeButton: d = !1,
    id: f,
    style: p,
    ...m
  } = e, h = lP(), {
    disabled: b,
    readOnly: v,
    required: C,
    form: y,
    checkedValue: w,
    touched: R = !1,
    validation: S,
    name: E
  } = h ?? {}, N = h?.setCheckedValue ?? yt, I = h?.setTouched ?? yt, T = h?.registerControlRef ?? yt, k = h?.registerInputRef ?? yt, {
    setDirty: P,
    validityData: M,
    setTouched: D,
    setFilled: O,
    state: _,
    disabled: V
  } = tn(), A = k2(), {
    labelId: L,
    getDescriptionProps: $
  } = gn(), Y = V || A.disabled || b || i, G = v || s, j = C || l, Z = y, U = h ? w === c : c === "", q = x.useMemo(() => Ul(c), [c]), te = x.useRef(null), H = x.useRef(null), X = Ce((ie) => {
    ie && T(ie, Y);
  }), ee = fn(u, H, k);
  Ne(() => {
    H.current?.checked && O(!0);
  }, [O]), Ne(() => {
    if (H.current) {
      if (Y && U) {
        k(null);
        return;
      }
      te.current && T(te.current, Y), k(H.current);
    }
  }, [U, Y, T, k]);
  const le = kt(), Q = Mr({
    id: f,
    implicit: !1,
    controlRef: te
  }), re = d ? void 0 : Q, fe = Ud(a, L, H, !d, re), ne = {
    role: "radio",
    "aria-checked": U,
    "aria-required": j || void 0,
    "aria-readonly": G || void 0,
    "aria-labelledby": fe,
    [Jf]: U ? "" : void 0,
    id: d ? Q : le,
    onKeyDown(ie) {
      ie.key === "Enter" && ie.preventDefault();
    },
    onClick(ie) {
      ie.defaultPrevented || Y || G || (ie.preventDefault(), H.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: ie.shiftKey,
        ctrlKey: ie.ctrlKey,
        altKey: ie.altKey,
        metaKey: ie.metaKey
      })));
    },
    onFocus(ie) {
      ie.defaultPrevented || Y || G || !R || (H.current?.click(), I(!1));
    }
  }, {
    getButtonProps: se,
    buttonRef: pe
  } = Bt({
    disabled: Y,
    native: d
  }), xe = {
    type: "radio",
    ref: ee,
    form: Z,
    id: re,
    name: E,
    tabIndex: -1,
    style: E ? ei : Jo,
    "aria-hidden": !0,
    ...c !== void 0 ? {
      value: q
    } : St,
    disabled: Y,
    checked: U,
    required: j,
    readOnly: G,
    onChange(ie) {
      if (ie.nativeEvent.defaultPrevented || Y || G || c === void 0)
        return;
      const ge = De(Pt, ie.nativeEvent);
      ge.isCanceled || (D(!0), P(c !== M.initialValue), O(!0), N(c, ge));
    },
    onFocus() {
      te.current?.focus();
    }
  }, ce = x.useMemo(() => ({
    ..._,
    required: j,
    disabled: Y,
    readOnly: G,
    checked: U
  }), [_, Y, G, U, j]), he = ce, z = h !== void 0, J = [n, te, pe, X], B = [ne, $, S?.getValidationProps ?? St, m, se], K = Le("span", e, {
    enabled: !z,
    state: ce,
    ref: J,
    props: B,
    stateAttributesMapping: pu
  });
  return /* @__PURE__ */ F(l1.Provider, {
    value: he,
    children: [z ? /* @__PURE__ */ g(Ed, {
      tag: "span",
      render: o,
      className: r,
      style: p,
      state: ce,
      refs: J,
      props: B,
      stateAttributesMapping: pu
    }) : K, /* @__PURE__ */ g("input", {
      ...xe,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (Zb.displayName = "RadioRoot");
const Xb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    keepMounted: s = !1,
    ...l
  } = e, a = aP(), c = a.checked, {
    mounted: u,
    transitionStatus: d,
    setMounted: f
  } = Zn(c), p = {
    ...a,
    transitionStatus: d
  }, m = x.useRef(null), h = s || u, b = Le("span", e, {
    ref: [n, m],
    state: p,
    props: l,
    stateAttributesMapping: pu
  });
  return Yt({
    open: c,
    ref: m,
    onComplete() {
      c || f(!1);
    }
  }), h ? b : null;
});
process.env.NODE_ENV !== "production" && (Xb.displayName = "RadioIndicator");
const cP = [Wh], Qb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i,
    readOnly: s,
    required: l,
    onValueChange: a,
    value: c,
    defaultValue: u,
    form: d,
    name: f,
    inputRef: p,
    id: m,
    style: h,
    ...b
  } = e, {
    setTouched: v,
    setFocused: C,
    shouldValidateOnChange: y,
    validationMode: w,
    name: R,
    disabled: S,
    state: E,
    validation: N,
    setDirty: I,
    setFilled: T,
    validityData: k
  } = tn(), {
    labelId: P
  } = gn(), {
    clearErrors: M
  } = _o(), D = C2(!0), O = S || i, _ = R ?? f, V = kt(m), [A, L] = dn({
    controlled: c,
    default: u,
    name: "RadioGroup",
    state: "value"
  }), $ = Ce(a), Y = Ce((ne, se) => {
    $(ne, se), !se.isCanceled && L(ne);
  }), G = x.useRef(null), j = x.useRef(null), Z = x.useRef(null);
  function U(ne) {
    let se;
    return p && (typeof p == "function" ? se = p(ne) : p.current = ne), j.current = ne, N.inputRef.current = ne, se;
  }
  const q = Ce((ne, se = !1) => {
    if (ne) {
      if (se) {
        G.current === ne && (G.current = null);
        return;
      }
      G.current == null && (G.current = ne);
    }
  }), te = Ce((ne) => {
    if (!ne || ne.disabled)
      return;
    Z.current || (Z.current = ne);
    const se = j.current;
    if (ne.checked || se == null || se.disabled)
      return U(ne);
  }), H = Ce(() => A ?? null);
  fi(G, {
    id: V,
    value: A,
    getValue: H
  }), wo(A, () => {
    M(_), I(A !== k.initialValue), T(A != null), y() ? N.commit(A) : N.commit(A, !0);
    const ne = Z.current;
    A == null && ne && !ne.disabled && U(ne);
  });
  const [X, ee] = x.useState(!1), le = b["aria-labelledby"] ?? P ?? D?.legendId, Q = {
    ...E,
    disabled: O ?? !1,
    required: l ?? !1,
    readOnly: s ?? !1
  }, re = x.useMemo(() => ({
    ...E,
    checkedValue: A,
    disabled: O,
    form: d,
    validation: N,
    name: _,
    onValueChange: $,
    readOnly: s,
    registerControlRef: q,
    registerInputRef: te,
    required: l,
    setCheckedValue: Y,
    setTouched: ee,
    touched: X
  }), [A, O, d, N, E, _, $, s, q, te, l, Y, ee, X]), fe = {
    role: "radiogroup",
    "aria-required": l || void 0,
    "aria-disabled": O || void 0,
    "aria-readonly": s || void 0,
    "aria-labelledby": le,
    onFocus() {
      C(!0);
    },
    onBlur(ne) {
      Fe(ne.currentTarget, ne.relatedTarget) || (v(!0), C(!1), w === "onBlur" && N.commit(A));
    },
    onKeyDownCapture(ne) {
      ne.key.startsWith("Arrow") && (v(!0), ee(!0), C(!0));
    }
  };
  return /* @__PURE__ */ g(s1.Provider, {
    value: re,
    children: /* @__PURE__ */ g(Wb, {
      render: o,
      className: r,
      style: h,
      state: Q,
      props: [fe, N.getValidationProps, b],
      refs: [n],
      stateAttributesMapping: eo,
      enableHomeAndEndKeys: !1,
      modifierKeys: cP
    })
  });
});
process.env.NODE_ENV !== "production" && (Qb.displayName = "RadioGroup");
function uP() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ g("path", { d: "M15 8C15 4.13438 11.8656 1 8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8ZM0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
function dP() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ g("path", { d: "M8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16ZM8 1.5C4.40937 1.5 1.5 4.40937 1.5 8C1.5 11.5906 4.40937 14.5 8 14.5C11.5906 14.5 14.5 11.5906 14.5 8C14.5 4.40937 11.5906 1.5 8 1.5ZM8 11C6.34375 11 5 9.65625 5 8C5 6.34375 6.34375 5 8 5C9.65625 5 11 6.34375 11 8C11 9.65625 9.65625 11 8 11Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const Jb = go({}), fP = ae([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "rounded-full",
  "group",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1.5px]",
  "focus-visible:ring-radio-focus-ring",
  "cursor-[inherit]",
  // coarse touch target
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), pP = ae(["absolute", "inset-0", "rounded-full", "flex", "items-center", "justify-center", "[[data-checked]_&]:hidden", "group-hover:bg-radio-outline-hover-background", "group-active:bg-radio-outline-pressed-background"]), mP = ae(["flex", "items-center", "justify-center", "text-radio-outline-default-border", "group-hover:text-radio-outline-hover-border", "group-active:text-radio-outline-pressed-border", "[[data-disabled]_&]:text-radio-outline-disabled-border", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), gP = ae(["flex", "items-center", "justify-center", "text-radio-filled-default-background", "group-hover:text-radio-filled-hover-background", "group-active:text-radio-filled-pressed-background", "[[data-disabled]_&]:text-radio-filled-disabled-background", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), e4 = ae(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), hP = ae(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), bP = ae(["flex", "flex-col", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), vP = ae([], {
  variants: {
    size: {
      sm: ["pl-[calc(var(--icon-sm)+var(--spacing-8))]"],
      md: ["pl-[calc(var(--icon-md)+var(--spacing-8))]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
function SD(t) {
  const e = W.c(28);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    label: i,
    error: r,
    disabled: o,
    size: l,
    children: n,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = l === void 0 ? "sm" : l, c = Xt();
  let u;
  e[7] !== o || e[8] !== r || e[9] !== a ? (u = {
    error: r,
    disabled: o,
    size: a
  }, e[7] = o, e[8] = r, e[9] = a, e[10] = u) : u = e[10];
  let d;
  e[11] !== c || e[12] !== i ? (d = i && /* @__PURE__ */ g("span", { id: `${c}-label`, className: e4(), children: i }), e[11] = c, e[12] = i, e[13] = d) : d = e[13];
  const f = i ? `${c}-label` : s["aria-labelledby"], p = s["aria-label"], m = r || void 0, h = o || void 0;
  let b;
  e[14] !== n || e[15] !== o || e[16] !== s || e[17] !== f || e[18] !== p || e[19] !== m || e[20] !== h ? (b = /* @__PURE__ */ g(Qb, { ...s, disabled: o, "aria-labelledby": f, "aria-label": p, "aria-invalid": m, "aria-disabled": h, className: "flex flex-col gap-(--spacing-8)", children: n }), e[14] = n, e[15] = o, e[16] = s, e[17] = f, e[18] = p, e[19] = m, e[20] = h, e[21] = b) : b = e[21];
  let v;
  e[22] !== d || e[23] !== b ? (v = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8)", children: [
    d,
    b
  ] }), e[22] = d, e[23] = b, e[24] = v) : v = e[24];
  let C;
  return e[25] !== u || e[26] !== v ? (C = /* @__PURE__ */ g(Jb, { value: u, children: v }), e[25] = u, e[26] = v, e[27] = C) : C = e[27], C;
}
function RD(t) {
  const e = W.c(53);
  let n, o, r, i;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const {
    error: s,
    disabled: l,
    size: a
  } = mn(Jb), c = l || o, u = Xt();
  let d;
  e[5] !== n || e[6] !== u || e[7] !== i ? (d = [i["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[5] = n, e[6] = u, e[7] = i, e[8] = d) : d = e[8];
  const f = d;
  let p;
  e[9] !== c ? (p = bP({
    disabled: c
  }), e[9] = c, e[10] = p) : p = e[10];
  const m = r ? void 0 : i["aria-label"], h = r ? `${u}-label` : void 0, b = s ? "" : void 0;
  let v;
  e[11] !== i ? (v = (O) => {
    i.onKeyDown?.(O), !O.defaultPrevented && O.key === " " && (O.preventDefault(), O.currentTarget.click());
  }, e[11] = i, e[12] = v) : v = e[12];
  let C;
  e[13] !== a ? (C = oe(fP({
    size: a
  })), e[13] = a, e[14] = C) : C = e[14];
  let y;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = pP(), e[15] = y) : y = e[15];
  let w;
  e[16] !== a ? (w = mP({
    size: a
  }), e[16] = a, e[17] = w) : w = e[17];
  let R;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (R = /* @__PURE__ */ g(uP, {}), e[18] = R) : R = e[18];
  let S;
  e[19] !== w ? (S = /* @__PURE__ */ g("span", { className: y, children: /* @__PURE__ */ g("span", { className: w, children: R }) }), e[19] = w, e[20] = S) : S = e[20];
  let E;
  e[21] !== a ? (E = gP({
    size: a
  }), e[21] = a, e[22] = E) : E = e[22];
  let N;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ g(dP, {}), e[23] = N) : N = e[23];
  let I;
  e[24] !== E ? (I = /* @__PURE__ */ g(Xb, { className: E, children: N }), e[24] = E, e[25] = I) : I = e[25];
  let T;
  e[26] !== f || e[27] !== c || e[28] !== i || e[29] !== S || e[30] !== I || e[31] !== m || e[32] !== h || e[33] !== b || e[34] !== v || e[35] !== C ? (T = /* @__PURE__ */ F(Zb, { ...i, disabled: c, "aria-label": m, "aria-labelledby": h, "aria-describedby": f, "data-error": b, onKeyDown: v, className: C, children: [
    S,
    I
  ] }), e[26] = f, e[27] = c, e[28] = i, e[29] = S, e[30] = I, e[31] = m, e[32] = h, e[33] = b, e[34] = v, e[35] = C, e[36] = T) : T = e[36];
  let k;
  e[37] !== u || e[38] !== c || e[39] !== r ? (k = r && /* @__PURE__ */ g("span", { id: `${u}-label`, className: oe(e4(), c && "opacity-[0.54]"), children: r }), e[37] = u, e[38] = c, e[39] = r, e[40] = k) : k = e[40];
  let P;
  e[41] !== T || e[42] !== k ? (P = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    T,
    k
  ] }), e[41] = T, e[42] = k, e[43] = P) : P = e[43];
  let M;
  e[44] !== n || e[45] !== u || e[46] !== c || e[47] !== a ? (M = n && /* @__PURE__ */ g("span", { id: `${u}-description`, className: oe(hP(), c && "opacity-[0.54]", vP({
    size: a
  })), children: n }), e[44] = n, e[45] = u, e[46] = c, e[47] = a, e[48] = M) : M = e[48];
  let D;
  return e[49] !== P || e[50] !== M || e[51] !== p ? (D = /* @__PURE__ */ F("label", { className: p, children: [
    P,
    M
  ] }), e[49] = P, e[50] = M, e[51] = p, e[52] = D) : D = e[52], D;
}
const yP = ae(["flex", "w-full", "items-center", "justify-between", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "shadow-elevation-1", "transition-colors", "duration-200", "ease-in-out", "[&:has(input:focus)]:border-input-active-outline", "hover:bg-input-hover-background", "hover:border-input-hover-outline", "active:border-input-pressed-outline", "[&:has(input:disabled)]:cursor-not-allowed", "[&:has(input:disabled)]:opacity-50"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), t4 = ae(["min-w-0", "flex-1", "border-0", "bg-transparent", "p-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-input-text-default", "outline-none", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed", "[&::-webkit-search-cancel-button]:appearance-none"]);
function n4(t) {
  const e = W.c(7), {
    children: n,
    size: o,
    trailing: r
  } = t, i = o === void 0 ? "md" : o;
  let s;
  e[0] !== i ? (s = oe(yP({
    size: i
  })), e[0] = i, e[1] = s) : s = e[1];
  let l;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-input-text-placeholder", children: /* @__PURE__ */ g(Ge, { name: "search", size: "sm", tone: "inherit" }) }), e[2] = l) : l = e[2];
  let a;
  return e[3] !== n || e[4] !== s || e[5] !== r ? (a = /* @__PURE__ */ F("div", { className: s, children: [
    l,
    n,
    r
  ] }), e[3] = n, e[4] = s, e[5] = r, e[6] = a) : a = e[6], a;
}
function o4(t, e) {
  const n = W.c(10), o = ut(void 0), r = ut(t);
  let i, s;
  n[0] !== t ? (i = () => {
    r.current = t;
  }, s = [t], n[0] = t, n[1] = i, n[2] = s) : (i = n[1], s = n[2]), _t(i, s);
  let l;
  n[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = function() {
    o.current !== void 0 && (window.clearTimeout(o.current), o.current = void 0);
  }, n[3] = l) : l = n[3];
  const a = l;
  let c;
  n[4] !== e ? (c = function(h, b) {
    const v = b === void 0 ? !1 : b;
    if (a(), !!r.current) {
      if (v || e === 0) {
        r.current(h);
        return;
      }
      o.current = window.setTimeout(() => {
        o.current = void 0, r.current?.(h);
      }, e);
    }
  }, n[4] = e, n[5] = c) : c = n[5];
  const u = c;
  let d, f;
  n[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = () => () => {
    o.current !== void 0 && window.clearTimeout(o.current);
  }, f = [], n[6] = d, n[7] = f) : (d = n[6], f = n[7]), _t(d, f);
  let p;
  return n[8] !== u ? (p = {
    cancelSearch: a,
    emitSearch: u
  }, n[8] = u, n[9] = p) : p = n[9], p;
}
function ED(t) {
  const e = W.c(33), {
    "aria-label": n,
    value: o,
    defaultValue: r,
    onChange: i,
    onSearch: s,
    placeholder: l,
    clearable: a,
    debounceMs: c,
    size: u,
    disabled: d,
    autoFocus: f
  } = t, p = r === void 0 ? "" : r, m = l === void 0 ? "Search" : l, h = a === void 0 ? !0 : a, b = c === void 0 ? 300 : c, v = u === void 0 ? "md" : u, [C, y] = tt(p), {
    emitSearch: w
  } = o4(s, b), R = o !== void 0, S = R ? o : C;
  let E;
  e[0] !== f ? (E = f ? {
    autoFocus: !0
  } : void 0, e[0] = f, e[1] = E) : E = e[1];
  const N = E;
  let I;
  e[2] !== w || e[3] !== R || e[4] !== i ? (I = function($) {
    R || y($), i?.($), w($);
  }, e[2] = w, e[3] = R, e[4] = i, e[5] = I) : I = e[5];
  const T = I;
  let k;
  e[6] !== w || e[7] !== R || e[8] !== i ? (k = function() {
    R || y(""), i?.(""), w("", !0);
  }, e[6] = w, e[7] = R, e[8] = i, e[9] = k) : k = e[9];
  const P = k;
  let M;
  e[10] !== P || e[11] !== h || e[12] !== d || e[13] !== S ? (M = h && S.length > 0 ? /* @__PURE__ */ g(gt, { "aria-label": "Clear search", disabled: d, icon: "x-close", onClick: P, size: "sm", type: "button", variant: "ghost" }) : void 0, e[10] = P, e[11] = h, e[12] = d, e[13] = S, e[14] = M) : M = e[14];
  let D;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = oe(t4()), e[15] = D) : D = e[15];
  let O;
  e[16] !== T ? (O = (L) => T(L.target.value), e[16] = T, e[17] = O) : O = e[17];
  let _;
  e[18] !== P || e[19] !== S ? (_ = (L) => {
    L.key === "Escape" && S.length > 0 && (L.preventDefault(), P());
  }, e[18] = P, e[19] = S, e[20] = _) : _ = e[20];
  let V;
  e[21] !== n || e[22] !== N || e[23] !== d || e[24] !== S || e[25] !== m || e[26] !== O || e[27] !== _ ? (V = /* @__PURE__ */ g("input", { "aria-label": n, className: D, disabled: d, onChange: O, onKeyDown: _, placeholder: m, type: "search", value: S, ...N }), e[21] = n, e[22] = N, e[23] = d, e[24] = S, e[25] = m, e[26] = O, e[27] = _, e[28] = V) : V = e[28];
  let A;
  return e[29] !== v || e[30] !== V || e[31] !== M ? (A = /* @__PURE__ */ g(n4, { size: v, trailing: M, children: V }), e[29] = v, e[30] = V, e[31] = M, e[32] = A) : A = e[32], A;
}
function xP(t) {
  const {
    openOnInputClick: e = !1,
    value: n,
    defaultValue: o,
    onValueChange: r,
    mode: i = "list",
    itemToStringValue: s,
    ...l
  } = t, a = i === "inline" || i === "both", c = i === "inline" || i === "none", u = n !== void 0, [d, f] = x.useState(o ?? ""), [p, m] = x.useState("");
  x.useEffect(() => {
    u && m("");
  }, [n, u]);
  let h;
  a && p !== "" ? h = p : u ? h = n ?? "" : h = d;
  const b = Ce((S, E) => {
    m(""), u || f(S), r?.(S, E);
  }), v = C0(), C = x.useMemo(() => l.filter !== void 0 ? l.filter : v.contains, [l.filter, v]), y = String(u ? n : d).trim(), w = x.useMemo(() => i !== "both" ? c ? null : C : C === null ? null : (S, E, N) => C(S, y, N), [C, i, y, c]), R = Ce((S, E) => {
    t.onItemHighlighted?.(S, E), E.reason !== o8 && (a ? S == null ? m("") : m(Jt(S, s)) : m(""));
  });
  return /* @__PURE__ */ g(S0, {
    ...l,
    itemToStringLabel: s,
    openOnInputClick: e,
    selectionMode: "none",
    fillInputOnItemPress: !0,
    filter: w,
    autoComplete: i,
    inputValue: h,
    defaultInputValue: o,
    onInputValueChange: b,
    onItemHighlighted: R
  });
}
const CP = va, wP = Is, SP = ae(["w-[min(540px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(640px,calc(100vh_-_var(--spacing-40)))]", "flex", "flex-col", "gap-(--spacing-10)", "outline-none", "[outline:none]", "focus:outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out", "max-[599px]:h-dvh", "max-[599px]:w-screen", "max-[599px]:max-h-none", "max-[599px]:gap-0", "max-[599px]:bg-surface"]), RP = ae(["fixed", "inset-0", "z-50", "bg-surface/40", "backdrop-blur-search-overlay", "data-[starting-style]:opacity-0", "data-[ending-style]:opacity-0", "transition-opacity", "duration-100", "ease-in-out"]), EP = ae(["min-h-0", "max-h-[min(520px,calc(100vh_-_160px))]", "overflow-y-auto", "overscroll-contain", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none", "rounded-(--radius-sm)", "bg-surface-container-lowest", "py-(--spacing-20)", "px-(--spacing-10)", "shadow-elevation-3", "max-[599px]:max-h-none", "max-[599px]:flex-1", "max-[599px]:rounded-none", "max-[599px]:shadow-none"]), NP = ae(["contents", "max-[599px]:flex", "max-[599px]:h-[68px]", "max-[599px]:shrink-0", "max-[599px]:items-center", "max-[599px]:gap-(--spacing-8)", "max-[599px]:border-b", "max-[599px]:border-outline-subtle", "max-[599px]:px-(--spacing-16)"]), kP = ae(["hidden", "max-[599px]:flex", "max-[599px]:min-h-[44px]", "max-[599px]:items-center"]), MP = ae(["contents", "max-[599px]:flex", "max-[599px]:min-h-[44px]", "max-[599px]:min-w-0", "max-[599px]:flex-1", "max-[599px]:items-center"]), PP = ae(["flex", "flex-col", "gap-(--spacing-16)", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none"]), IP = ae(["flex", "flex-col", "gap-(--spacing-4)"]), TP = ae(["relative", "z-10", "flex", "h-(--spacing-24)", "items-center", "justify-between", "gap-(--spacing-8)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle"]), OP = ae(["flex", "h-[45px]", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "bg-transparent", "py-(--spacing-4)", "pl-(--spacing-10)", "pr-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-24)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50"]), DP = ae(["inline-flex", "h-(--spacing-32)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-button-outline-default-text", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), _P = ae(["inline-flex", "size-(--spacing-32)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border", "border-solid", "border-transparent", "bg-transparent", "text-button-ghost-default-text", "outline-none", "cursor-pointer", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background"]);
function VP(t) {
  return t.map((e) => ({
    value: e.label,
    items: e.items.map((n) => ({
      ...n,
      groupLabel: e.label
    }))
  }));
}
function AP(t) {
  return t.every((e) => e.items.length === 0);
}
function Rc(t, e) {
  return t.find((n) => n.label === e);
}
function Ec(t) {
  return `${t.groupLabel}:${t.id}`;
}
const LP = {
  meta: "⌘",
  ctrl: "Ctrl",
  alt: "Alt",
  shift: "Shift"
};
function ND(t) {
  const e = W.c(76), {
    open: n,
    onOpenChange: o,
    query: r,
    onQueryChange: i,
    onSearch: s,
    debounceMs: l,
    groups: a,
    placeholder: c,
    hotkey: u,
    showDividers: d,
    emptyLabel: f,
    disabled: p,
    "aria-label": m,
    onItemSelect: h,
    onItemRemove: b
  } = t, v = l === void 0 ? 300 : l, C = c === void 0 ? "Search" : c, y = d === void 0 ? !0 : d, w = f === void 0 ? "No results found." : f, R = m === void 0 ? "Search" : m, S = Qt(), E = Xt(), {
    cancelSearch: N,
    emitSearch: I
  } = o4(s, v), T = a.filter(HP), k = VP(T), P = AP(T), M = !!u && r.length === 0, D = k.at(-1)?.value, [O, _] = tt();
  let V;
  e[0] !== O ? (V = (Ie) => Ec(Ie) === O, e[0] = O, e[1] = V) : V = e[1];
  const A = k.flatMap($P).find(V);
  let L;
  e[2] !== N || e[3] !== a || e[4] !== h ? (L = function(Pe, _e) {
    if (Pe.target instanceof Element && Pe.target.closest("[data-search-remove]"))
      return;
    const Ye = Rc(a, _e.groupLabel);
    !Ye || _e.disabled || (N(), h(_e, Ye));
  }, e[2] = N, e[3] = a, e[4] = h, e[5] = L) : L = e[5];
  const $ = L;
  let Y;
  e[6] !== I || e[7] !== i ? (Y = function(Pe) {
    i(Pe), I(Pe);
  }, e[6] = I, e[7] = i, e[8] = Y) : Y = e[8];
  const G = Y;
  let j;
  e[9] !== N || e[10] !== o ? (j = function(Pe) {
    Pe || N(), o(Pe);
  }, e[9] = N, e[10] = o, e[11] = j) : j = e[11];
  const Z = j;
  let U;
  e[12] !== a || e[13] !== b ? (U = function(Pe) {
    const _e = Rc(a, Pe.groupLabel);
    !_e || Pe.disabled || b?.(Pe, _e);
  }, e[12] = a, e[13] = b, e[14] = U) : U = e[14];
  const q = U;
  let te;
  e[15] !== _ ? (te = function(Pe) {
    const _e = Pe ? Ec(Pe) : void 0;
    _((Ye) => Ye === _e ? Ye : _e);
  }, e[15] = _, e[16] = te) : te = e[16];
  const H = te;
  let X;
  e[17] !== q ? (X = function(Pe, _e) {
    Pe.preventDefault(), Pe.stopPropagation(), q(_e);
  }, e[17] = q, e[18] = X) : X = e[18];
  const ee = X;
  let le;
  e[19] !== q || e[20] !== A || e[21] !== r ? (le = function(Pe) {
    !A?.removable || A.disabled || !(Pe.key === "Delete" || Pe.key === "Backspace" && r.length === 0) || (Pe.preventDefault(), Pe.stopPropagation(), q(A));
  }, e[19] = q, e[20] = A, e[21] = r, e[22] = le) : le = e[22];
  const Q = le;
  let re;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (re = function(Pe) {
    if (!Pe.removable)
      return;
    const _e = Pe.chip ? `, ${Pe.chip}` : "", Ye = Pe.removeAriaLabel ? `${Pe.removeAriaLabel}. Press Delete.` : "Press Delete to remove.";
    return `${Pe.label}${_e}. ${Ye}`;
  }, e[23] = re) : re = e[23];
  const fe = re;
  let ne;
  e[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ne = /* @__PURE__ */ g(Ss, { className: oe(RP()) }), e[24] = ne) : ne = e[24];
  let se;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (se = oe(SP()), e[25] = se) : se = e[25];
  let pe, xe;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (pe = oe(NP()), xe = oe(kP()), e[26] = pe, e[27] = xe) : (pe = e[26], xe = e[27]);
  let ce;
  e[28] !== Z ? (ce = /* @__PURE__ */ g("div", { className: xe, children: /* @__PURE__ */ g(gt, { "aria-label": "Back", icon: "chevron-left", variant: "ghost", onClick: () => Z(!1) }) }), e[28] = Z, e[29] = ce) : ce = e[29];
  let he;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (he = oe(MP()), e[30] = he) : he = e[30];
  let z;
  e[31] !== u || e[32] !== M ? (z = M && u ? /* @__PURE__ */ g(H2, { "aria-hidden": "true", modifier: u.modifier ? LP[u.modifier] : void 0, children: u.key }) : void 0, e[31] = u, e[32] = M, e[33] = z) : z = e[33];
  let J;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (J = oe(t4()), e[34] = J) : J = e[34];
  let B;
  e[35] !== p || e[36] !== Q || e[37] !== E || e[38] !== C ? (B = /* @__PURE__ */ g(Ms, { id: E, placeholder: C, disabled: p, className: J, onKeyDown: Q }), e[35] = p, e[36] = Q, e[37] = E, e[38] = C, e[39] = B) : B = e[39];
  let K;
  e[40] !== z || e[41] !== B ? (K = /* @__PURE__ */ g(CP, { children: /* @__PURE__ */ g(n4, { trailing: z, children: B }) }), e[40] = z, e[41] = B, e[42] = K) : K = e[42];
  let ie;
  e[43] !== E || e[44] !== K ? (ie = /* @__PURE__ */ g("label", { className: he, htmlFor: E, children: K }), e[43] = E, e[44] = K, e[45] = ie) : ie = e[45];
  let ge;
  e[46] !== ce || e[47] !== ie ? (ge = /* @__PURE__ */ F("div", { className: pe, children: [
    ce,
    ie
  ] }), e[46] = ce, e[47] = ie, e[48] = ge) : ge = e[48];
  let ue;
  e[49] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ue = oe(EP()), e[49] = ue) : ue = e[49];
  let Se;
  e[50] !== w || e[51] !== a || e[52] !== $ || e[53] !== ee || e[54] !== P || e[55] !== D || e[56] !== y ? (Se = /* @__PURE__ */ g("div", { className: ue, children: P ? /* @__PURE__ */ g("div", { className: "flex h-(--spacing-40) items-center px-(--spacing-10) font-(family-name:--font-family-body) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: w }) : /* @__PURE__ */ g(Ps, { className: oe(PP()), children: (Ie) => {
    const Pe = Rc(a, Ie.value);
    return /* @__PURE__ */ F(q4, { children: [
      /* @__PURE__ */ F(k0, { items: Ie.items, className: oe(IP()), children: [
        /* @__PURE__ */ F(M0, { className: oe(TP(), Pe?.action && "pr-(--spacing-4)"), children: [
          /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 truncate", children: Ie.value }),
          Pe?.action && /* @__PURE__ */ F(Xn, { className: oe(DP()), "aria-label": Pe.action["aria-label"], onClick: Pe.action.onClick, children: [
            Pe.action.label,
            /* @__PURE__ */ g(Ge, { name: "x-close", size: "xs", tone: "inherit" })
          ] })
        ] }),
        /* @__PURE__ */ g(N0, { children: (_e) => /* @__PURE__ */ F(wP, { value: _e, disabled: _e.disabled, className: oe(OP()), "aria-label": fe(_e), onClick: (Ye) => $(Ye, _e), children: [
          /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
            /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 flex-col", children: [
              /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: _e.label }),
              _e.subLabel && /* @__PURE__ */ g("span", { className: "min-w-0 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-xsmall) font-(number:--font-weight-semibold) leading-(--font-line-height-16) text-menu-text-subtle uppercase", children: _e.subLabel })
            ] }),
            _e.chip && /* @__PURE__ */ g(fo, { label: _e.chip, tone: "neutral" })
          ] }),
          _e.removable && /* @__PURE__ */ g("span", { "aria-hidden": "true", className: oe(_P()), "data-search-remove": "", "data-testid": `search-remove-${_e.id}`, onPointerDown: (Ye) => ee(Ye, _e), children: /* @__PURE__ */ g(Ge, { name: "x-close", size: "sm", tone: "inherit" }) })
        ] }, Ec(_e)) })
      ] }),
      y && Ie.value !== D && /* @__PURE__ */ g(mr, { variant: "middle-inset" })
    ] }, Ie.value);
  } }) }), e[50] = w, e[51] = a, e[52] = $, e[53] = ee, e[54] = P, e[55] = D, e[56] = y, e[57] = Se) : Se = e[57];
  let ve;
  e[58] !== k || e[59] !== p || e[60] !== H || e[61] !== G || e[62] !== r || e[63] !== ge || e[64] !== Se ? (ve = /* @__PURE__ */ F(xP, { open: !0, inline: !0, mode: "none", items: k, itemToStringValue: FP, value: r, onValueChange: G, onItemHighlighted: H, disabled: p, children: [
    ge,
    Se
  ] }), e[58] = k, e[59] = p, e[60] = H, e[61] = G, e[62] = r, e[63] = ge, e[64] = Se, e[65] = ve) : ve = e[65];
  let de;
  e[66] !== R || e[67] !== ve ? (de = /* @__PURE__ */ g(gi, { className: "fixed inset-0 z-50 flex items-start justify-center px-(--spacing-16) pt-[12vh] max-[599px]:items-stretch max-[599px]:p-0", children: /* @__PURE__ */ g(Rs, { "aria-label": R, className: se, children: ve }) }), e[66] = R, e[67] = ve, e[68] = de) : de = e[68];
  let me;
  e[69] !== S || e[70] !== de ? (me = /* @__PURE__ */ F(mi, { container: S, children: [
    ne,
    de
  ] }), e[69] = S, e[70] = de, e[71] = me) : me = e[71];
  let Re;
  return e[72] !== Z || e[73] !== n || e[74] !== me ? (Re = /* @__PURE__ */ g(Es, { open: n, onOpenChange: Z, modal: !0, children: me }), e[72] = Z, e[73] = n, e[74] = me, e[75] = Re) : Re = e[75], Re;
}
function FP(t) {
  return t.label;
}
function $P(t) {
  return t.items;
}
function HP(t) {
  return t.items.length > 0;
}
function zP(t) {
  if (!(t instanceof HTMLElement)) return !1;
  const e = t.tagName.toLowerCase();
  return e === "input" || e === "textarea" || e === "select" || t.isContentEditable;
}
function BP(t, e) {
  if (!e.includes("+"))
    return !t.metaKey && !t.ctrlKey && !t.altKey && !t.shiftKey && t.key.toLowerCase() === e.toLowerCase();
  const [n, o] = e.toLowerCase().split("+");
  return !n || !o ? !1 : !!(n === "mod" ? t.metaKey || t.ctrlKey : n === "meta" ? t.metaKey : n === "ctrl" ? t.ctrlKey : n === "alt" ? t.altKey : n === "shift" && t.shiftKey) && t.key.toLowerCase() === o;
}
function kD(t) {
  const e = W.c(5), {
    key: n,
    enabled: o,
    onOpen: r
  } = t, i = o === void 0 ? !0 : o;
  let s, l;
  e[0] !== i || e[1] !== n || e[2] !== r ? (s = () => {
    if (!i)
      return;
    const a = function(u) {
      zP(u.target) || BP(u, n) && (u.preventDefault(), r());
    };
    return document.addEventListener("keydown", a), () => document.removeEventListener("keydown", a);
  }, l = [i, n, r], e[0] = i, e[1] = n, e[2] = r, e[3] = s, e[4] = l) : (s = e[3], l = e[4]), _t(s, l);
}
const WP = ae(["aw-skeleton", "relative", "block", "overflow-hidden", "bg-surface-container"], {
  variants: {
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    }
  },
  defaultVariants: {
    radius: "sm"
  }
});
function MD(t) {
  const e = W.c(25);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    radius: s,
    width: a,
    height: o,
    className: n,
    style: i,
    "aria-hidden": l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? "sm" : s, u = l === void 0 ? !0 : l;
  let d;
  e[8] !== a ? (d = a !== void 0 ? {
    width: a
  } : void 0, e[8] = a, e[9] = d) : d = e[9];
  let f;
  e[10] !== o ? (f = o !== void 0 ? {
    height: o
  } : void 0, e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== i || e[13] !== d || e[14] !== f ? (p = {
    ...i,
    ...d,
    ...f
  }, e[12] = i, e[13] = d, e[14] = f, e[15] = p) : p = e[15];
  const m = p;
  let h;
  e[16] !== n || e[17] !== c ? (h = oe(WP({
    radius: c
  }), n), e[16] = n, e[17] = c, e[18] = h) : h = e[18];
  let b;
  return e[19] !== u || e[20] !== r || e[21] !== c || e[22] !== m || e[23] !== h ? (b = /* @__PURE__ */ g("div", { ...r, "data-slot": "skeleton", "data-radius": c, "aria-hidden": u, className: h, style: m }), e[19] = u, e[20] = r, e[21] = c, e[22] = m, e[23] = h, e[24] = b) : b = e[24], b;
}
const UP = 5, GP = 200;
function YP(t, e, n) {
  const o = [...t], [r] = o.splice(e, 1);
  return o.splice(n, 0, r), o;
}
function ki(t, e, n) {
  return `${t}, position ${e + 1} of ${n}`;
}
function Nc(t, e, n) {
  const o = [...t.tops], r = t.ids.map((l, a) => a), [i] = r.splice(e, 1);
  r.splice(n, 0, i);
  let s = t.tops[0] ?? 0;
  return r.forEach((l, a) => {
    o[l] = s, s += t.heights[l] + (t.gaps[a] ?? 0);
  }), o;
}
function kc(t, e, n) {
  const r = {
    ArrowUp: (i) => i - 1,
    ArrowDown: (i) => i + 1,
    Home: () => 0,
    End: (i, s) => s
  }[t];
  return r ? Math.max(0, Math.min(n, r(e, n))) : void 0;
}
function jP({
  items: t,
  getItemId: e,
  getItemLabel: n,
  onReorder: o,
  onDragEnd: r
}) {
  const [i, s] = x.useState(null), [l, a] = x.useState(!1), [c, u] = x.useState(""), d = x.useId(), f = x.useRef(/* @__PURE__ */ new Map()), p = x.useRef(null), m = x.useRef(null), h = x.useRef(/* @__PURE__ */ new Map()), b = x.useRef(null), v = x.useRef(null), C = x.useRef(null), y = x.useRef(null), w = x.useRef([]), R = x.useRef({
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  });
  R.current = {
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  };
  function S(H, X) {
    X ? f.current.set(H, X) : f.current.delete(H);
  }
  function E(H) {
    const X = h.current.get(H);
    if (X) return X;
    const ee = (le) => S(H, le);
    return h.current.set(H, ee), ee;
  }
  function N(H) {
    const {
      items: X,
      getItemId: ee,
      getItemLabel: le
    } = R.current, Q = X.find((re) => ee(re) === H);
    return Q ? le(Q) : "";
  }
  function I(H) {
    v.current = H, s(H);
  }
  function T(H) {
    typeof document > "u" || (document.body.style.cursor = "grabbing", document.body.style.userSelect = "none");
  }
  function k() {
    if (typeof document > "u") return;
    const H = C.current;
    H && (document.body.style.cursor = H.previousBodyCursor, document.body.style.userSelect = H.previousBodyUserSelect);
  }
  function P() {
    p.current?.abort(), p.current = null, m.current?.abort(), m.current = null, y.current && (clearTimeout(y.current), y.current = null), b.current = null, k(), C.current = null, I(null);
  }
  function M() {
    for (const H of w.current)
      cancelAnimationFrame(H);
    w.current = [];
  }
  function D() {
    M();
    const H = requestAnimationFrame(() => {
      const X = requestAnimationFrame(() => {
        w.current = [], a(!1);
      });
      w.current = [X];
    });
    w.current = [H];
  }
  function O(H, X) {
    y.current && (clearTimeout(y.current), y.current = null), p.current?.abort(), p.current = null, b.current = null;
    const ee = v.current;
    if (!ee) {
      P();
      return;
    }
    I({
      ...ee,
      delta: H,
      settling: !0
    }), y.current = setTimeout(() => {
      a(!0), X?.(), P(), D();
    }, GP);
  }
  function _() {
    const H = v.current;
    if (!H) {
      P();
      return;
    }
    if (H.settling) return;
    const X = C.current;
    if (!X) {
      P();
      return;
    }
    m.current?.abort(), m.current = null;
    const le = Nc(X, H.fromIndex, H.overIndex)[H.fromIndex] - X.tops[H.fromIndex];
    O(le, () => {
      const {
        items: Q,
        getItemId: re,
        onReorder: fe,
        onDragEnd: ne
      } = R.current;
      if (u(`Dropped ${ki(N(H.id), H.overIndex, Q.length)}`), H.overIndex === H.fromIndex) return;
      const se = Q.findIndex((he) => re(he) === H.id), pe = X.ids[H.overIndex], xe = Q.findIndex((he) => re(he) === pe);
      if (se < 0 || xe < 0 || se === xe) return;
      const ce = YP(Q, se, xe);
      fe(ce), ne?.(ce);
    });
  }
  function V() {
    const H = v.current;
    if (!H) {
      P();
      return;
    }
    H.settling || (u(`Reordering cancelled. ${ki(N(H.id), H.fromIndex, R.current.items.length)}`), I({
      ...H,
      delta: 0,
      overIndex: H.fromIndex
    }), O(0));
  }
  function A(H, X, ee = !0) {
    const {
      items: le,
      getItemId: Q
    } = R.current, re = le.findIndex((he) => Q(he) === H);
    if (re < 0) return;
    const fe = le.map((he) => Q(he)), ne = fe.map((he) => f.current.get(he)?.getBoundingClientRect()), se = ne.map((he) => he ? he.top + he.height / 2 : 0), pe = ne.map((he, z) => {
      const J = ne[z + 1];
      return he && J ? J.top - (he.top + he.height) : 0;
    }), xe = ne.map((he) => he?.height ?? 0), ce = ne.map((he) => he?.top ?? 0);
    C.current = {
      centers: se,
      gaps: pe,
      heights: xe,
      ids: fe,
      previousBodyCursor: typeof document > "u" ? "" : document.body.style.cursor,
      previousBodyUserSelect: typeof document > "u" ? "" : document.body.style.userSelect,
      startY: X,
      tops: ce
    }, ee && T(), I({
      id: H,
      fromIndex: re,
      overIndex: re,
      delta: 0,
      settling: !1
    }), u(`Picked up ${ki(N(H), re, le.length)}`);
  }
  function L(H) {
    const ee = f.current.get(H)?.getBoundingClientRect();
    A(H, ee ? ee.top + ee.height / 2 : 0, !1), Z(H);
  }
  function $(H) {
    const X = v.current, ee = C.current;
    if (!X || X.settling || !ee) return;
    const le = H - ee.startY, Q = ee.centers[X.fromIndex] + le;
    let re = 0, fe = Number.POSITIVE_INFINITY;
    for (let ne = 0; ne < ee.centers.length; ne++) {
      const se = Math.abs(Q - ee.centers[ne]);
      se < fe && (fe = se, re = ne);
    }
    re !== X.overIndex && u(ki(N(X.id), re, R.current.items.length)), I({
      ...X,
      delta: le,
      overIndex: re
    });
  }
  function Y(H) {
    const X = v.current, ee = C.current;
    if (!X || X.settling || !ee) return;
    H !== X.overIndex && u(ki(N(X.id), H, R.current.items.length));
    const le = Nc(ee, X.fromIndex, H);
    I({
      ...X,
      delta: le[X.fromIndex] - ee.tops[X.fromIndex],
      overIndex: H
    });
  }
  function G(H, X) {
    if (H.pointerType === "mouse" && H.button !== 0 || v.current || b.current) return;
    H.currentTarget.setPointerCapture?.(H.pointerId), b.current = {
      id: X,
      x: H.clientX,
      y: H.clientY
    };
    const ee = new AbortController();
    p.current = ee;
    const {
      signal: le
    } = ee;
    window.addEventListener("pointermove", (Q) => {
      const re = b.current;
      if (re && !v.current) {
        if (Math.hypot(Q.clientX - re.x, Q.clientY - re.y) < UP)
          return;
        A(re.id, re.y);
      }
      v.current && (Q.preventDefault(), $(Q.clientY));
    }, {
      signal: le
    }), window.addEventListener("pointerup", _, {
      signal: le
    }), window.addEventListener("pointercancel", V, {
      signal: le
    }), window.addEventListener("blur", V, {
      signal: le
    }), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && V();
    }, {
      signal: le
    }), window.addEventListener("keydown", (Q) => {
      Q.key === "Escape" && (Q.preventDefault(), V());
    }, {
      signal: le
    });
  }
  function j(H, X) {
    const ee = v.current;
    if (ee?.id !== X) return;
    if (H.key === "Tab") {
      V();
      return;
    }
    if (H.key === " " || H.key === "Enter") {
      H.preventDefault(), _();
      return;
    }
    if (H.key === "Escape") {
      H.preventDefault(), V();
      return;
    }
    const le = kc(H.key, ee.overIndex, R.current.items.length - 1);
    le !== void 0 && (H.preventDefault(), Y(le));
  }
  function Z(H) {
    if (m.current?.abort(), typeof document > "u") return;
    const X = new AbortController();
    m.current = X;
    const {
      signal: ee
    } = X;
    document.addEventListener("keydown", (le) => j(le, H), {
      signal: ee
    }), document.addEventListener("focusin", (le) => {
      if (v.current?.id !== H) return;
      const re = le.target, fe = f.current.get(H)?.querySelector('[data-slot="sortable-handle"]');
      re instanceof Node && fe?.contains(re) || V();
    }, {
      signal: ee
    });
  }
  function U(H, X) {
    const ee = v.current;
    if (H.key === " " || H.key === "Enter") {
      if (H.preventDefault(), H.stopPropagation(), ee?.id === X) {
        _();
        return;
      }
      ee || L(X);
      return;
    }
    if (H.key === "Escape" && ee?.id === X) {
      H.preventDefault(), H.stopPropagation(), V();
      return;
    }
    const {
      items: le
    } = R.current, Q = le.length - 1;
    if (ee?.id === X) {
      const re = kc(H.key, ee.overIndex, Q);
      if (re === void 0) return;
      H.preventDefault(), H.stopPropagation(), Y(re);
      return;
    }
    kc(H.key, 0, Q) !== void 0 && (H.preventDefault(), H.stopPropagation());
  }
  function q(H, X) {
    return {
      "aria-label": `Reorder ${X}`,
      "aria-describedby": d,
      "aria-pressed": i?.id === H,
      "data-slot": "sortable-handle",
      role: "button",
      tabIndex: 0,
      onPointerDown: (ee) => G(ee, H),
      onKeyDown: (ee) => U(ee, H),
      onClick: (ee) => ee.stopPropagation()
    };
  }
  function te(H, X) {
    if (!i) return;
    if (H === i.id) return `translateY(${i.delta}px)`;
    const ee = C.current;
    if (!ee) return;
    const {
      fromIndex: le,
      overIndex: Q
    } = i, fe = Nc(ee, le, Q)[X] - ee.tops[X];
    return fe === 0 ? void 0 : `translateY(${fe}px)`;
  }
  return x.useEffect(() => () => {
    p.current?.abort(), p.current = null, y.current && (clearTimeout(y.current), y.current = null), m.current?.abort(), m.current = null;
    for (const X of w.current)
      cancelAnimationFrame(X);
    w.current = [], b.current = null;
    const H = C.current;
    typeof document < "u" && H && (document.body.style.cursor = H.previousBodyCursor, document.body.style.userSelect = H.previousBodyUserSelect), C.current = null;
  }, []), {
    draggingId: i?.id ?? null,
    settling: i?.settling ?? !1,
    committing: l,
    getRowRef: E,
    getHandleProps: q,
    getItemTransform: te,
    announcement: c,
    instructionsId: d
  };
}
const KP = ae(["relative", "transition-transform duration-200 ease-out", "motion-reduce:transition-none"]), qP = ae(["flex size-(--spacing-20) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "text-text-subtext", "cursor-grab touch-none", "active:cursor-grabbing", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), ZP = ae(["flex w-full items-stretch", "data-[dragging]:shadow-elevation-1"]);
function PD(t) {
  const e = W.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = oe(ZP(), n), e[3] = n, e[4] = r) : r = e[4];
  let i;
  return e[5] !== o || e[6] !== r ? (i = /* @__PURE__ */ g("div", { "data-slot": "sortable-list-item", className: r, ...o }), e[5] = o, e[6] = r, e[7] = i) : i = e[7], i;
}
function XP(t) {
  const e = W.c(7);
  let n, o;
  if (e[0] !== t ? ({
    visible: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]), !(o === void 0 ? !0 : o))
    return null;
  let i, s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = qP(), s = /* @__PURE__ */ g(Ge, { name: "grip-drag", size: "md", tone: "secondary", "aria-hidden": !0 }), e[3] = i, e[4] = s) : (i = e[3], s = e[4]);
  let l;
  return e[5] !== n ? (l = /* @__PURE__ */ g("div", { className: "flex w-(--spacing-40) shrink-0 items-center justify-center", children: /* @__PURE__ */ g("button", { ...n, type: "button", className: i, children: s }) }), e[5] = n, e[6] = l) : l = e[6], l;
}
function QP(t) {
  const e = W.c(36), {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: i,
    onDragEnd: s,
    className: l,
    children: a
  } = t;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== n || e[3] !== s || e[4] !== i ? (c = {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: i,
    onDragEnd: s
  }, e[0] = o, e[1] = r, e[2] = n, e[3] = s, e[4] = i, e[5] = c) : c = e[5];
  const {
    draggingId: u,
    settling: d,
    committing: f,
    getRowRef: p,
    getHandleProps: m,
    getItemTransform: h,
    announcement: b,
    instructionsId: v
  } = jP(c);
  let C;
  if (e[6] !== a || e[7] !== f || e[8] !== u || e[9] !== m || e[10] !== o || e[11] !== r || e[12] !== h || e[13] !== p || e[14] !== n || e[15] !== d) {
    let S;
    e[17] !== a || e[18] !== f || e[19] !== u || e[20] !== m || e[21] !== o || e[22] !== r || e[23] !== h || e[24] !== p || e[25] !== d ? (S = (E, N) => {
      const I = o(E), T = r(E), k = u === I, P = m(I, T), M = /* @__PURE__ */ g(XP, { ...P });
      return /* @__PURE__ */ g("div", { ref: p(I), "data-slot": "sortable-item", "data-dragging": k ? "" : void 0, style: {
        transform: h(I, N)
      }, className: oe(KP(), f && "transition-none", k && "z-10", k && !d && "transition-none"), children: a(E, {
        handle: M,
        handleProps: P,
        isDragging: k
      }) }, I);
    }, e[17] = a, e[18] = f, e[19] = u, e[20] = m, e[21] = o, e[22] = r, e[23] = h, e[24] = p, e[25] = d, e[26] = S) : S = e[26], C = n.map(S), e[6] = a, e[7] = f, e[8] = u, e[9] = m, e[10] = o, e[11] = r, e[12] = h, e[13] = p, e[14] = n, e[15] = d, e[16] = C;
  } else
    C = e[16];
  let y;
  e[27] !== v ? (y = /* @__PURE__ */ g("span", { id: v, className: "sr-only", children: "Press Space or Enter to pick up, arrow keys to move, Space or Enter to drop, or Escape to cancel." }), e[27] = v, e[28] = y) : y = e[28];
  let w;
  e[29] !== b ? (w = /* @__PURE__ */ g("span", { "aria-live": "polite", "aria-atomic": "true", className: "sr-only", children: b }), e[29] = b, e[30] = w) : w = e[30];
  let R;
  return e[31] !== l || e[32] !== C || e[33] !== y || e[34] !== w ? (R = /* @__PURE__ */ F("div", { "data-slot": "sortable-list", className: l, children: [
    C,
    y,
    w
  ] }), e[31] = l, e[32] = C, e[33] = y, e[34] = w, e[35] = R) : R = e[35], R;
}
const ID = QP, a1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (a1.displayName = "SwitchRootContext");
function JP() {
  const t = x.useContext(a1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SwitchRootContext is missing. Switch parts must be placed within <Switch.Root>." : et(63));
  return t;
}
let Xm = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const r4 = {
  ...eo,
  checked(t) {
    return t ? {
      [Xm.checked]: ""
    } : {
      [Xm.unchecked]: ""
    };
  }
}, i4 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: i,
    "aria-labelledby": s,
    form: l,
    id: a,
    inputRef: c,
    name: u,
    nativeButton: d = !1,
    onCheckedChange: f,
    readOnly: p = !1,
    required: m = !1,
    disabled: h = !1,
    render: b,
    uncheckedValue: v,
    value: C,
    style: y,
    ...w
  } = e, {
    clearErrors: R
  } = _o(), {
    state: S,
    setTouched: E,
    setDirty: N,
    validityData: I,
    setFilled: T,
    setFocused: k,
    shouldValidateOnChange: P,
    validationMode: M,
    disabled: D,
    name: O,
    validation: _
  } = tn(), {
    labelId: V
  } = gn(), A = D || h, L = O ?? u, $ = Ce(f), Y = x.useRef(null), G = fn(Y, c, _.inputRef), j = x.useRef(null), Z = kt(), U = Mr({
    id: a,
    implicit: !1,
    controlRef: j
  }), q = d ? void 0 : U, [te, H] = dn({
    controlled: o,
    default: !!i,
    name: "Switch",
    state: "checked"
  });
  fi(j, {
    id: Z,
    value: te
  }), Ne(() => {
    Y.current && T(Y.current.checked);
  }, [Y, T]), wo(te, () => {
    R(L), N(te !== I.initialValue), T(te), P() ? _.commit(te) : _.commit(te, !0);
  });
  const {
    getButtonProps: X,
    buttonRef: ee
  } = Bt({
    disabled: A,
    native: d
  }), le = Ud(s, V, Y, !d, q), Q = {
    id: d ? U : Z,
    role: "switch",
    "aria-checked": te,
    "aria-readonly": p || void 0,
    "aria-required": m || void 0,
    "aria-labelledby": le,
    onFocus() {
      A || k(!0);
    },
    onBlur() {
      const se = Y.current;
      !se || A || (E(!0), k(!1), M === "onBlur" && _.commit(se.checked));
    },
    onClick(se) {
      p || A || (se.preventDefault(), Y.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: se.shiftKey,
        ctrlKey: se.ctrlKey,
        altKey: se.altKey,
        metaKey: se.metaKey
      })));
    }
  }, re = x.useMemo(() => en(
    {
      checked: te,
      disabled: A,
      form: l,
      id: q,
      name: L,
      required: m,
      style: L ? ei : Jo,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      ref: G,
      onChange(se) {
        if (se.nativeEvent.defaultPrevented)
          return;
        if (p) {
          se.preventDefault();
          return;
        }
        const pe = se.currentTarget.checked, xe = De(Pt, se.nativeEvent);
        $?.(pe, xe), !xe.isCanceled && H(pe);
      },
      onFocus() {
        j.current?.focus();
      }
    },
    _.getInputValidationProps,
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    C !== void 0 ? {
      value: C
    } : St
  ), [te, A, l, G, q, L, $, p, m, H, _, C]), fe = x.useMemo(() => ({
    ...S,
    checked: te,
    disabled: A,
    readOnly: p,
    required: m
  }), [S, te, A, p, m]), ne = Le("span", e, {
    state: fe,
    ref: [n, j, ee],
    props: [Q, _.getValidationProps, w, X],
    stateAttributesMapping: r4
  });
  return /* @__PURE__ */ F(a1.Provider, {
    value: fe,
    children: [ne, !te && L && v !== void 0 && /* @__PURE__ */ g("input", {
      type: "hidden",
      form: l,
      name: L,
      value: v
    }), /* @__PURE__ */ g("input", {
      ...re,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (i4.displayName = "SwitchRoot");
const s4 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = tn(), a = JP(), c = {
    ...l,
    ...a
  };
  return Le("span", e, {
    state: c,
    ref: n,
    stateAttributesMapping: r4,
    props: s
  });
});
process.env.NODE_ENV !== "production" && (s4.displayName = "SwitchThumb");
const eI = ae(["inline-flex", "items-start", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["opacity-[0.54]", "cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), tI = ae(["relative", "shrink-0", "w-[44px]", "h-(--spacing-24)", "rounded-full", "bg-surface-container-highest", "data-[checked]:bg-primary", "transition-colors", "duration-200", "ease-in-out", "motion-reduce:transition-none", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-2", "focus-visible:ring-tertiary-tertiary", "cursor-[inherit]", "[@media(pointer:coarse)]:before:content-['']", "[@media(pointer:coarse)]:before:absolute", "[@media(pointer:coarse)]:before:inset-x-0", "[@media(pointer:coarse)]:before:inset-y-[-12px]"]), nI = ae(["absolute", "top-(--spacing-2)", "w-(--spacing-20)", "h-(--spacing-20)", "rounded-full", "bg-surface-container-lowest", "shadow-elevation-1", "translate-x-(--spacing-2)", "data-[checked]:translate-x-[22px]", "transition-transform", "duration-150", "ease-in-out", "motion-reduce:transition-none"]), oI = ae(["text-text-default", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), rI = ae(["text-text-subtle", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-small)", "leading-(--font-line-height-16)"]);
function TD(t) {
  const e = W.c(25);
  let n, o, r, i, s;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: s,
    id: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = s === void 0 ? !1 : s, a = Xt(), c = o ?? a;
  let u;
  e[6] !== l ? (u = oe(eI({
    disabled: l
  })), e[6] = l, e[7] = u) : u = e[7];
  const d = r ? `${c}-label` : void 0, f = n ? `${c}-description` : void 0;
  let p;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = tI(), e[8] = p) : p = e[8];
  let m;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (m = /* @__PURE__ */ g(s4, { className: nI() }), e[9] = m) : m = e[9];
  let h;
  e[10] !== l || e[11] !== i || e[12] !== c || e[13] !== d || e[14] !== f ? (h = /* @__PURE__ */ g(i4, { ...i, id: c, disabled: l, "aria-labelledby": d, "aria-describedby": f, className: p, children: m }), e[10] = l, e[11] = i, e[12] = c, e[13] = d, e[14] = f, e[15] = h) : h = e[15];
  let b;
  e[16] !== n || e[17] !== r || e[18] !== c ? (b = (r || n) && /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-4)", children: [
    r && /* @__PURE__ */ g("span", { id: `${c}-label`, className: oI(), children: r }),
    n && /* @__PURE__ */ g("span", { id: `${c}-description`, className: rI(), children: n })
  ] }), e[16] = n, e[17] = r, e[18] = c, e[19] = b) : b = e[19];
  let v;
  return e[20] !== c || e[21] !== u || e[22] !== h || e[23] !== b ? (v = /* @__PURE__ */ F("label", { htmlFor: c, className: u, children: [
    h,
    b
  ] }), e[20] = c, e[21] = u, e[22] = h, e[23] = b, e[24] = v) : v = e[24], v;
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Bo(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Nn(t, e) {
  return (n) => {
    e.setState((o) => ({
      ...o,
      [t]: Bo(n, o[t])
    }));
  };
}
function Ia(t) {
  return t instanceof Function;
}
function iI(t) {
  return Array.isArray(t) && t.every((e) => typeof e == "number");
}
function sI(t, e) {
  const n = [], o = (r) => {
    r.forEach((i) => {
      n.push(i);
      const s = e(i);
      s != null && s.length && o(s);
    });
  };
  return o(t), n;
}
function ot(t, e, n) {
  let o = [], r;
  return (i) => {
    let s;
    n.key && n.debug && (s = Date.now());
    const l = t(i);
    if (!(l.length !== o.length || l.some((u, d) => o[d] !== u)))
      return r;
    o = l;
    let c;
    if (n.key && n.debug && (c = Date.now()), r = e(...l), n == null || n.onChange == null || n.onChange(r), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - s) * 100) / 100, d = Math.round((Date.now() - c) * 100) / 100, f = d / 16, p = (m, h) => {
        for (m = String(m); m.length < h; )
          m = " " + m;
        return m;
      };
      console.info(`%c⏱ ${p(d, 5)} /${p(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * f, 120))}deg 100% 31%);`, n?.key);
    }
    return r;
  };
}
function rt(t, e, n, o) {
  return {
    debug: () => {
      var r;
      return (r = t?.debugAll) != null ? r : t[e];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: o
  };
}
function lI(t, e, n, o) {
  const r = () => {
    var s;
    return (s = i.getValue()) != null ? s : t.options.renderFallbackValue;
  }, i = {
    id: `${e.id}_${n.id}`,
    row: e,
    column: n,
    getValue: () => e.getValue(o),
    renderValue: r,
    getContext: ot(() => [t, n, e, i], (s, l, a, c) => ({
      table: s,
      column: l,
      row: a,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), rt(t.options, "debugCells", "cell.getContext"))
  };
  return t._features.forEach((s) => {
    s.createCell == null || s.createCell(i, n, e, t);
  }, {}), i;
}
function aI(t, e, n, o) {
  var r, i;
  const l = {
    ...t._getDefaultColumnDef(),
    ...e
  }, a = l.accessorKey;
  let c = (r = (i = l.id) != null ? i : a ? typeof String.prototype.replaceAll == "function" ? a.replaceAll(".", "_") : a.replace(/\./g, "_") : void 0) != null ? r : typeof l.header == "string" ? l.header : void 0, u;
  if (l.accessorFn ? u = l.accessorFn : a && (a.includes(".") ? u = (f) => {
    let p = f;
    for (const h of a.split(".")) {
      var m;
      p = (m = p) == null ? void 0 : m[h], process.env.NODE_ENV !== "production" && p === void 0 && console.warn(`"${h}" in deeply nested key "${a}" returned undefined.`);
    }
    return p;
  } : u = (f) => f[l.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(c)}`,
    accessorFn: u,
    parent: o,
    depth: n,
    columnDef: l,
    columns: [],
    getFlatColumns: ot(() => [!0], () => {
      var f;
      return [d, ...(f = d.columns) == null ? void 0 : f.flatMap((p) => p.getFlatColumns())];
    }, rt(t.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: ot(() => [t._getOrderColumnsFn()], (f) => {
      var p;
      if ((p = d.columns) != null && p.length) {
        let m = d.columns.flatMap((h) => h.getLeafColumns());
        return f(m);
      }
      return [d];
    }, rt(t.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const f of t._features)
    f.createColumn == null || f.createColumn(d, t);
  return d;
}
const on = "debugHeaders";
function Qm(t, e, n) {
  var o;
  let i = {
    id: (o = n.id) != null ? o : e.id,
    column: e,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const s = [], l = (a) => {
        a.subHeaders && a.subHeaders.length && a.subHeaders.map(l), s.push(a);
      };
      return l(i), s;
    },
    getContext: () => ({
      table: t,
      header: i,
      column: e
    })
  };
  return t._features.forEach((s) => {
    s.createHeader == null || s.createHeader(i, t);
  }), i;
}
const cI = {
  createTable: (t) => {
    t.getHeaderGroups = ot(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => {
      var i, s;
      const l = (i = o?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? i : [], a = (s = r?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? s : [], c = n.filter((d) => !(o != null && o.includes(d.id)) && !(r != null && r.includes(d.id)));
      return dl(e, [...l, ...c, ...a], t);
    }, rt(t.options, on, "getHeaderGroups")), t.getCenterHeaderGroups = ot(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => (n = n.filter((i) => !(o != null && o.includes(i.id)) && !(r != null && r.includes(i.id))), dl(e, n, t, "center")), rt(t.options, on, "getCenterHeaderGroups")), t.getLeftHeaderGroups = ot(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left], (e, n, o) => {
      var r;
      const i = (r = o?.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? r : [];
      return dl(e, i, t, "left");
    }, rt(t.options, on, "getLeftHeaderGroups")), t.getRightHeaderGroups = ot(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.right], (e, n, o) => {
      var r;
      const i = (r = o?.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? r : [];
      return dl(e, i, t, "right");
    }, rt(t.options, on, "getRightHeaderGroups")), t.getFooterGroups = ot(() => [t.getHeaderGroups()], (e) => [...e].reverse(), rt(t.options, on, "getFooterGroups")), t.getLeftFooterGroups = ot(() => [t.getLeftHeaderGroups()], (e) => [...e].reverse(), rt(t.options, on, "getLeftFooterGroups")), t.getCenterFooterGroups = ot(() => [t.getCenterHeaderGroups()], (e) => [...e].reverse(), rt(t.options, on, "getCenterFooterGroups")), t.getRightFooterGroups = ot(() => [t.getRightHeaderGroups()], (e) => [...e].reverse(), rt(t.options, on, "getRightFooterGroups")), t.getFlatHeaders = ot(() => [t.getHeaderGroups()], (e) => e.map((n) => n.headers).flat(), rt(t.options, on, "getFlatHeaders")), t.getLeftFlatHeaders = ot(() => [t.getLeftHeaderGroups()], (e) => e.map((n) => n.headers).flat(), rt(t.options, on, "getLeftFlatHeaders")), t.getCenterFlatHeaders = ot(() => [t.getCenterHeaderGroups()], (e) => e.map((n) => n.headers).flat(), rt(t.options, on, "getCenterFlatHeaders")), t.getRightFlatHeaders = ot(() => [t.getRightHeaderGroups()], (e) => e.map((n) => n.headers).flat(), rt(t.options, on, "getRightFlatHeaders")), t.getCenterLeafHeaders = ot(() => [t.getCenterFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), rt(t.options, on, "getCenterLeafHeaders")), t.getLeftLeafHeaders = ot(() => [t.getLeftFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), rt(t.options, on, "getLeftLeafHeaders")), t.getRightLeafHeaders = ot(() => [t.getRightFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), rt(t.options, on, "getRightLeafHeaders")), t.getLeafHeaders = ot(() => [t.getLeftHeaderGroups(), t.getCenterHeaderGroups(), t.getRightHeaderGroups()], (e, n, o) => {
      var r, i, s, l, a, c;
      return [...(r = (i = e[0]) == null ? void 0 : i.headers) != null ? r : [], ...(s = (l = n[0]) == null ? void 0 : l.headers) != null ? s : [], ...(a = (c = o[0]) == null ? void 0 : c.headers) != null ? a : []].map((u) => u.getLeafHeaders()).flat();
    }, rt(t.options, on, "getLeafHeaders"));
  }
};
function dl(t, e, n, o) {
  var r, i;
  let s = 0;
  const l = function(f, p) {
    p === void 0 && (p = 1), s = Math.max(s, p), f.filter((m) => m.getIsVisible()).forEach((m) => {
      var h;
      (h = m.columns) != null && h.length && l(m.columns, p + 1);
    }, 0);
  };
  l(t);
  let a = [];
  const c = (f, p) => {
    const m = {
      depth: p,
      id: [o, `${p}`].filter(Boolean).join("_"),
      headers: []
    }, h = [];
    f.forEach((b) => {
      const v = [...h].reverse()[0], C = b.column.depth === m.depth;
      let y, w = !1;
      if (C && b.column.parent ? y = b.column.parent : (y = b.column, w = !0), v && v?.column === y)
        v.subHeaders.push(b);
      else {
        const R = Qm(n, y, {
          id: [o, p, y.id, b?.id].filter(Boolean).join("_"),
          isPlaceholder: w,
          placeholderId: w ? `${h.filter((S) => S.column === y).length}` : void 0,
          depth: p,
          index: h.length
        });
        R.subHeaders.push(b), h.push(R);
      }
      m.headers.push(b), b.headerGroup = m;
    }), a.push(m), p > 0 && c(h, p - 1);
  }, u = e.map((f, p) => Qm(n, f, {
    depth: s,
    index: p
  }));
  c(u, s - 1), a.reverse();
  const d = (f) => f.filter((m) => m.column.getIsVisible()).map((m) => {
    let h = 0, b = 0, v = [0];
    m.subHeaders && m.subHeaders.length ? (v = [], d(m.subHeaders).forEach((y) => {
      let {
        colSpan: w,
        rowSpan: R
      } = y;
      h += w, v.push(R);
    })) : h = 1;
    const C = Math.min(...v);
    return b = b + C, m.colSpan = h, m.rowSpan = b, {
      colSpan: h,
      rowSpan: b
    };
  });
  return d((r = (i = a[0]) == null ? void 0 : i.headers) != null ? r : []), a;
}
const uI = (t, e, n, o, r, i, s) => {
  let l = {
    id: e,
    index: o,
    original: n,
    depth: r,
    parentId: s,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (a) => {
      if (l._valuesCache.hasOwnProperty(a))
        return l._valuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return l._valuesCache[a] = c.accessorFn(l.original, o), l._valuesCache[a];
    },
    getUniqueValues: (a) => {
      if (l._uniqueValuesCache.hasOwnProperty(a))
        return l._uniqueValuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (l._uniqueValuesCache[a] = c.columnDef.getUniqueValues(l.original, o), l._uniqueValuesCache[a]) : (l._uniqueValuesCache[a] = [l.getValue(a)], l._uniqueValuesCache[a]);
    },
    renderValue: (a) => {
      var c;
      return (c = l.getValue(a)) != null ? c : t.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => sI(l.subRows, (a) => a.subRows),
    getParentRow: () => l.parentId ? t.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let a = [], c = l;
      for (; ; ) {
        const u = c.getParentRow();
        if (!u) break;
        a.push(u), c = u;
      }
      return a.reverse();
    },
    getAllCells: ot(() => [t.getAllLeafColumns()], (a) => a.map((c) => lI(t, l, c, c.id)), rt(t.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: ot(() => [l.getAllCells()], (a) => a.reduce((c, u) => (c[u.column.id] = u, c), {}), rt(t.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let a = 0; a < t._features.length; a++) {
    const c = t._features[a];
    c == null || c.createRow == null || c.createRow(l, t);
  }
  return l;
}, dI = {
  createColumn: (t, e) => {
    t._getFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, t.id), t.getFacetedRowModel = () => t._getFacetedRowModel ? t._getFacetedRowModel() : e.getPreFilteredRowModel(), t._getFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, t.id), t.getFacetedUniqueValues = () => t._getFacetedUniqueValues ? t._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, t.id), t.getFacetedMinMaxValues = () => {
      if (t._getFacetedMinMaxValues)
        return t._getFacetedMinMaxValues();
    };
  }
}, l4 = (t, e, n) => {
  var o, r;
  const i = n == null || (o = n.toString()) == null ? void 0 : o.toLowerCase();
  return !!(!((r = t.getValue(e)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(i));
};
l4.autoRemove = (t) => jn(t);
const a4 = (t, e, n) => {
  var o;
  return !!(!((o = t.getValue(e)) == null || (o = o.toString()) == null) && o.includes(n));
};
a4.autoRemove = (t) => jn(t);
const c4 = (t, e, n) => {
  var o;
  return ((o = t.getValue(e)) == null || (o = o.toString()) == null ? void 0 : o.toLowerCase()) === n?.toLowerCase();
};
c4.autoRemove = (t) => jn(t);
const u4 = (t, e, n) => {
  var o;
  return (o = t.getValue(e)) == null ? void 0 : o.includes(n);
};
u4.autoRemove = (t) => jn(t);
const d4 = (t, e, n) => !n.some((o) => {
  var r;
  return !((r = t.getValue(e)) != null && r.includes(o));
});
d4.autoRemove = (t) => jn(t) || !(t != null && t.length);
const f4 = (t, e, n) => n.some((o) => {
  var r;
  return (r = t.getValue(e)) == null ? void 0 : r.includes(o);
});
f4.autoRemove = (t) => jn(t) || !(t != null && t.length);
const p4 = (t, e, n) => t.getValue(e) === n;
p4.autoRemove = (t) => jn(t);
const m4 = (t, e, n) => t.getValue(e) == n;
m4.autoRemove = (t) => jn(t);
const c1 = (t, e, n) => {
  let [o, r] = n;
  const i = t.getValue(e);
  return i >= o && i <= r;
};
c1.resolveFilterValue = (t) => {
  let [e, n] = t, o = typeof e != "number" ? parseFloat(e) : e, r = typeof n != "number" ? parseFloat(n) : n, i = e === null || Number.isNaN(o) ? -1 / 0 : o, s = n === null || Number.isNaN(r) ? 1 / 0 : r;
  if (i > s) {
    const l = i;
    i = s, s = l;
  }
  return [i, s];
};
c1.autoRemove = (t) => jn(t) || jn(t[0]) && jn(t[1]);
const Co = {
  includesString: l4,
  includesStringSensitive: a4,
  equalsString: c4,
  arrIncludes: u4,
  arrIncludesAll: d4,
  arrIncludesSome: f4,
  equals: p4,
  weakEquals: m4,
  inNumberRange: c1
};
function jn(t) {
  return t == null || t === "";
}
const fI = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (t) => ({
    columnFilters: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnFiltersChange: Nn("columnFilters", t),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (t, e) => {
    t.getAutoFilterFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      return typeof o == "string" ? Co.includesString : typeof o == "number" ? Co.inNumberRange : typeof o == "boolean" || o !== null && typeof o == "object" ? Co.equals : Array.isArray(o) ? Co.arrIncludes : Co.weakEquals;
    }, t.getFilterFn = () => {
      var n, o;
      return Ia(t.columnDef.filterFn) ? t.columnDef.filterFn : t.columnDef.filterFn === "auto" ? t.getAutoFilterFn() : (
        // @ts-ignore
        (n = (o = e.options.filterFns) == null ? void 0 : o[t.columnDef.filterFn]) != null ? n : Co[t.columnDef.filterFn]
      );
    }, t.getCanFilter = () => {
      var n, o, r;
      return ((n = t.columnDef.enableColumnFilter) != null ? n : !0) && ((o = e.options.enableColumnFilters) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && !!t.accessorFn;
    }, t.getIsFiltered = () => t.getFilterIndex() > -1, t.getFilterValue = () => {
      var n;
      return (n = e.getState().columnFilters) == null || (n = n.find((o) => o.id === t.id)) == null ? void 0 : n.value;
    }, t.getFilterIndex = () => {
      var n, o;
      return (n = (o = e.getState().columnFilters) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.setFilterValue = (n) => {
      e.setColumnFilters((o) => {
        const r = t.getFilterFn(), i = o?.find((u) => u.id === t.id), s = Bo(n, i ? i.value : void 0);
        if (Jm(r, s, t)) {
          var l;
          return (l = o?.filter((u) => u.id !== t.id)) != null ? l : [];
        }
        const a = {
          id: t.id,
          value: s
        };
        if (i) {
          var c;
          return (c = o?.map((u) => u.id === t.id ? a : u)) != null ? c : [];
        }
        return o != null && o.length ? [...o, a] : [a];
      });
    };
  },
  createRow: (t, e) => {
    t.columnFilters = {}, t.columnFiltersMeta = {};
  },
  createTable: (t) => {
    t.setColumnFilters = (e) => {
      const n = t.getAllLeafColumns(), o = (r) => {
        var i;
        return (i = Bo(e, r)) == null ? void 0 : i.filter((s) => {
          const l = n.find((a) => a.id === s.id);
          if (l) {
            const a = l.getFilterFn();
            if (Jm(a, s.value, l))
              return !1;
          }
          return !0;
        });
      };
      t.options.onColumnFiltersChange == null || t.options.onColumnFiltersChange(o);
    }, t.resetColumnFilters = (e) => {
      var n, o;
      t.setColumnFilters(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.columnFilters) != null ? n : []);
    }, t.getPreFilteredRowModel = () => t.getCoreRowModel(), t.getFilteredRowModel = () => (!t._getFilteredRowModel && t.options.getFilteredRowModel && (t._getFilteredRowModel = t.options.getFilteredRowModel(t)), t.options.manualFiltering || !t._getFilteredRowModel ? t.getPreFilteredRowModel() : t._getFilteredRowModel());
  }
};
function Jm(t, e, n) {
  return (t && t.autoRemove ? t.autoRemove(e, n) : !1) || typeof e > "u" || typeof e == "string" && !e;
}
const pI = (t, e, n) => n.reduce((o, r) => {
  const i = r.getValue(t);
  return o + (typeof i == "number" ? i : 0);
}, 0), mI = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(t);
    i != null && (o > i || o === void 0 && i >= i) && (o = i);
  }), o;
}, gI = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(t);
    i != null && (o < i || o === void 0 && i >= i) && (o = i);
  }), o;
}, hI = (t, e, n) => {
  let o, r;
  return n.forEach((i) => {
    const s = i.getValue(t);
    s != null && (o === void 0 ? s >= s && (o = r = s) : (o > s && (o = s), r < s && (r = s)));
  }), [o, r];
}, bI = (t, e) => {
  let n = 0, o = 0;
  if (e.forEach((r) => {
    let i = r.getValue(t);
    i != null && (i = +i) >= i && (++n, o += i);
  }), n) return o / n;
}, vI = (t, e) => {
  if (!e.length)
    return;
  const n = e.map((i) => i.getValue(t));
  if (!iI(n))
    return;
  if (n.length === 1)
    return n[0];
  const o = Math.floor(n.length / 2), r = n.sort((i, s) => i - s);
  return n.length % 2 !== 0 ? r[o] : (r[o - 1] + r[o]) / 2;
}, yI = (t, e) => Array.from(new Set(e.map((n) => n.getValue(t))).values()), xI = (t, e) => new Set(e.map((n) => n.getValue(t))).size, CI = (t, e) => e.length, Mc = {
  sum: pI,
  min: mI,
  max: gI,
  extent: hI,
  mean: bI,
  median: vI,
  unique: yI,
  uniqueCount: xI,
  count: CI
}, wI = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (t) => {
      var e, n;
      return (e = (n = t.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? e : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (t) => ({
    grouping: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGroupingChange: Nn("grouping", t),
    groupedColumnMode: "reorder"
  }),
  createColumn: (t, e) => {
    t.toggleGrouping = () => {
      e.setGrouping((n) => n != null && n.includes(t.id) ? n.filter((o) => o !== t.id) : [...n ?? [], t.id]);
    }, t.getCanGroup = () => {
      var n, o;
      return ((n = t.columnDef.enableGrouping) != null ? n : !0) && ((o = e.options.enableGrouping) != null ? o : !0) && (!!t.accessorFn || !!t.columnDef.getGroupingValue);
    }, t.getIsGrouped = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.includes(t.id);
    }, t.getGroupedIndex = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.indexOf(t.id);
    }, t.getToggleGroupingHandler = () => {
      const n = t.getCanGroup();
      return () => {
        n && t.toggleGrouping();
      };
    }, t.getAutoAggregationFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      if (typeof o == "number")
        return Mc.sum;
      if (Object.prototype.toString.call(o) === "[object Date]")
        return Mc.extent;
    }, t.getAggregationFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return Ia(t.columnDef.aggregationFn) ? t.columnDef.aggregationFn : t.columnDef.aggregationFn === "auto" ? t.getAutoAggregationFn() : (n = (o = e.options.aggregationFns) == null ? void 0 : o[t.columnDef.aggregationFn]) != null ? n : Mc[t.columnDef.aggregationFn];
    };
  },
  createTable: (t) => {
    t.setGrouping = (e) => t.options.onGroupingChange == null ? void 0 : t.options.onGroupingChange(e), t.resetGrouping = (e) => {
      var n, o;
      t.setGrouping(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.grouping) != null ? n : []);
    }, t.getPreGroupedRowModel = () => t.getFilteredRowModel(), t.getGroupedRowModel = () => (!t._getGroupedRowModel && t.options.getGroupedRowModel && (t._getGroupedRowModel = t.options.getGroupedRowModel(t)), t.options.manualGrouping || !t._getGroupedRowModel ? t.getPreGroupedRowModel() : t._getGroupedRowModel());
  },
  createRow: (t, e) => {
    t.getIsGrouped = () => !!t.groupingColumnId, t.getGroupingValue = (n) => {
      if (t._groupingValuesCache.hasOwnProperty(n))
        return t._groupingValuesCache[n];
      const o = e.getColumn(n);
      return o != null && o.columnDef.getGroupingValue ? (t._groupingValuesCache[n] = o.columnDef.getGroupingValue(t.original), t._groupingValuesCache[n]) : t.getValue(n);
    }, t._groupingValuesCache = {};
  },
  createCell: (t, e, n, o) => {
    t.getIsGrouped = () => e.getIsGrouped() && e.id === n.groupingColumnId, t.getIsPlaceholder = () => !t.getIsGrouped() && e.getIsGrouped(), t.getIsAggregated = () => {
      var r;
      return !t.getIsGrouped() && !t.getIsPlaceholder() && !!((r = n.subRows) != null && r.length);
    };
  }
};
function SI(t, e, n) {
  if (!(e != null && e.length) || !n)
    return t;
  const o = t.filter((i) => !e.includes(i.id));
  return n === "remove" ? o : [...e.map((i) => t.find((s) => s.id === i)).filter(Boolean), ...o];
}
const RI = {
  getInitialState: (t) => ({
    columnOrder: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnOrderChange: Nn("columnOrder", t)
  }),
  createColumn: (t, e) => {
    t.getIndex = ot((n) => [Fi(e, n)], (n) => n.findIndex((o) => o.id === t.id), rt(e.options, "debugColumns", "getIndex")), t.getIsFirstColumn = (n) => {
      var o;
      return ((o = Fi(e, n)[0]) == null ? void 0 : o.id) === t.id;
    }, t.getIsLastColumn = (n) => {
      var o;
      const r = Fi(e, n);
      return ((o = r[r.length - 1]) == null ? void 0 : o.id) === t.id;
    };
  },
  createTable: (t) => {
    t.setColumnOrder = (e) => t.options.onColumnOrderChange == null ? void 0 : t.options.onColumnOrderChange(e), t.resetColumnOrder = (e) => {
      var n;
      t.setColumnOrder(e ? [] : (n = t.initialState.columnOrder) != null ? n : []);
    }, t._getOrderColumnsFn = ot(() => [t.getState().columnOrder, t.getState().grouping, t.options.groupedColumnMode], (e, n, o) => (r) => {
      let i = [];
      if (!(e != null && e.length))
        i = r;
      else {
        const s = [...e], l = [...r];
        for (; l.length && s.length; ) {
          const a = s.shift(), c = l.findIndex((u) => u.id === a);
          c > -1 && i.push(l.splice(c, 1)[0]);
        }
        i = [...i, ...l];
      }
      return SI(i, n, o);
    }, rt(t.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Pc = () => ({
  left: [],
  right: []
}), EI = {
  getInitialState: (t) => ({
    columnPinning: Pc(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnPinningChange: Nn("columnPinning", t)
  }),
  createColumn: (t, e) => {
    t.pin = (n) => {
      const o = t.getLeafColumns().map((r) => r.id).filter(Boolean);
      e.setColumnPinning((r) => {
        var i, s;
        if (n === "right") {
          var l, a;
          return {
            left: ((l = r?.left) != null ? l : []).filter((d) => !(o != null && o.includes(d))),
            right: [...((a = r?.right) != null ? a : []).filter((d) => !(o != null && o.includes(d))), ...o]
          };
        }
        if (n === "left") {
          var c, u;
          return {
            left: [...((c = r?.left) != null ? c : []).filter((d) => !(o != null && o.includes(d))), ...o],
            right: ((u = r?.right) != null ? u : []).filter((d) => !(o != null && o.includes(d)))
          };
        }
        return {
          left: ((i = r?.left) != null ? i : []).filter((d) => !(o != null && o.includes(d))),
          right: ((s = r?.right) != null ? s : []).filter((d) => !(o != null && o.includes(d)))
        };
      });
    }, t.getCanPin = () => t.getLeafColumns().some((o) => {
      var r, i, s;
      return ((r = o.columnDef.enablePinning) != null ? r : !0) && ((i = (s = e.options.enableColumnPinning) != null ? s : e.options.enablePinning) != null ? i : !0);
    }), t.getIsPinned = () => {
      const n = t.getLeafColumns().map((l) => l.id), {
        left: o,
        right: r
      } = e.getState().columnPinning, i = n.some((l) => o?.includes(l)), s = n.some((l) => r?.includes(l));
      return i ? "left" : s ? "right" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      return r ? (n = (o = e.getState().columnPinning) == null || (o = o[r]) == null ? void 0 : o.indexOf(t.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (t, e) => {
    t.getCenterVisibleCells = ot(() => [t._getAllVisibleCells(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, o, r) => {
      const i = [...o ?? [], ...r ?? []];
      return n.filter((s) => !i.includes(s.column.id));
    }, rt(e.options, "debugRows", "getCenterVisibleCells")), t.getLeftVisibleCells = ot(() => [t._getAllVisibleCells(), e.getState().columnPinning.left], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), rt(e.options, "debugRows", "getLeftVisibleCells")), t.getRightVisibleCells = ot(() => [t._getAllVisibleCells(), e.getState().columnPinning.right], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), rt(e.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (t) => {
    t.setColumnPinning = (e) => t.options.onColumnPinningChange == null ? void 0 : t.options.onColumnPinningChange(e), t.resetColumnPinning = (e) => {
      var n, o;
      return t.setColumnPinning(e ? Pc() : (n = (o = t.initialState) == null ? void 0 : o.columnPinning) != null ? n : Pc());
    }, t.getIsSomeColumnsPinned = (e) => {
      var n;
      const o = t.getState().columnPinning;
      if (!e) {
        var r, i;
        return !!((r = o.left) != null && r.length || (i = o.right) != null && i.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t.getLeftLeafColumns = ot(() => [t.getAllLeafColumns(), t.getState().columnPinning.left], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), rt(t.options, "debugColumns", "getLeftLeafColumns")), t.getRightLeafColumns = ot(() => [t.getAllLeafColumns(), t.getState().columnPinning.right], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), rt(t.options, "debugColumns", "getRightLeafColumns")), t.getCenterLeafColumns = ot(() => [t.getAllLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o) => {
      const r = [...n ?? [], ...o ?? []];
      return e.filter((i) => !r.includes(i.id));
    }, rt(t.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function NI(t) {
  return t || (typeof document < "u" ? document : null);
}
const fl = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Ic = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), kI = {
  getDefaultColumnDef: () => fl,
  getInitialState: (t) => ({
    columnSizing: {},
    columnSizingInfo: Ic(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: Nn("columnSizing", t),
    onColumnSizingInfoChange: Nn("columnSizingInfo", t)
  }),
  createColumn: (t, e) => {
    t.getSize = () => {
      var n, o, r;
      const i = e.getState().columnSizing[t.id];
      return Math.min(Math.max((n = t.columnDef.minSize) != null ? n : fl.minSize, (o = i ?? t.columnDef.size) != null ? o : fl.size), (r = t.columnDef.maxSize) != null ? r : fl.maxSize);
    }, t.getStart = ot((n) => [n, Fi(e, n), e.getState().columnSizing], (n, o) => o.slice(0, t.getIndex(n)).reduce((r, i) => r + i.getSize(), 0), rt(e.options, "debugColumns", "getStart")), t.getAfter = ot((n) => [n, Fi(e, n), e.getState().columnSizing], (n, o) => o.slice(t.getIndex(n) + 1).reduce((r, i) => r + i.getSize(), 0), rt(e.options, "debugColumns", "getAfter")), t.resetSize = () => {
      e.setColumnSizing((n) => {
        let {
          [t.id]: o,
          ...r
        } = n;
        return r;
      });
    }, t.getCanResize = () => {
      var n, o;
      return ((n = t.columnDef.enableResizing) != null ? n : !0) && ((o = e.options.enableColumnResizing) != null ? o : !0);
    }, t.getIsResizing = () => e.getState().columnSizingInfo.isResizingColumn === t.id;
  },
  createHeader: (t, e) => {
    t.getSize = () => {
      let n = 0;
      const o = (r) => {
        if (r.subHeaders.length)
          r.subHeaders.forEach(o);
        else {
          var i;
          n += (i = r.column.getSize()) != null ? i : 0;
        }
      };
      return o(t), n;
    }, t.getStart = () => {
      if (t.index > 0) {
        const n = t.headerGroup.headers[t.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, t.getResizeHandler = (n) => {
      const o = e.getColumn(t.column.id), r = o?.getCanResize();
      return (i) => {
        if (!o || !r || (i.persist == null || i.persist(), Tc(i) && i.touches && i.touches.length > 1))
          return;
        const s = t.getSize(), l = t ? t.getLeafHeaders().map((v) => [v.column.id, v.column.getSize()]) : [[o.id, o.getSize()]], a = Tc(i) ? Math.round(i.touches[0].clientX) : i.clientX, c = {}, u = (v, C) => {
          typeof C == "number" && (e.setColumnSizingInfo((y) => {
            var w, R;
            const S = e.options.columnResizeDirection === "rtl" ? -1 : 1, E = (C - ((w = y?.startOffset) != null ? w : 0)) * S, N = Math.max(E / ((R = y?.startSize) != null ? R : 0), -0.999999);
            return y.columnSizingStart.forEach((I) => {
              let [T, k] = I;
              c[T] = Math.round(Math.max(k + k * N, 0) * 100) / 100;
            }), {
              ...y,
              deltaOffset: E,
              deltaPercentage: N
            };
          }), (e.options.columnResizeMode === "onChange" || v === "end") && e.setColumnSizing((y) => ({
            ...y,
            ...c
          })));
        }, d = (v) => u("move", v), f = (v) => {
          u("end", v), e.setColumnSizingInfo((C) => ({
            ...C,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, p = NI(n), m = {
          moveHandler: (v) => d(v.clientX),
          upHandler: (v) => {
            p?.removeEventListener("mousemove", m.moveHandler), p?.removeEventListener("mouseup", m.upHandler), f(v.clientX);
          }
        }, h = {
          moveHandler: (v) => (v.cancelable && (v.preventDefault(), v.stopPropagation()), d(v.touches[0].clientX), !1),
          upHandler: (v) => {
            var C;
            p?.removeEventListener("touchmove", h.moveHandler), p?.removeEventListener("touchend", h.upHandler), v.cancelable && (v.preventDefault(), v.stopPropagation()), f((C = v.touches[0]) == null ? void 0 : C.clientX);
          }
        }, b = MI() ? {
          passive: !1
        } : !1;
        Tc(i) ? (p?.addEventListener("touchmove", h.moveHandler, b), p?.addEventListener("touchend", h.upHandler, b)) : (p?.addEventListener("mousemove", m.moveHandler, b), p?.addEventListener("mouseup", m.upHandler, b)), e.setColumnSizingInfo((v) => ({
          ...v,
          startOffset: a,
          startSize: s,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: l,
          isResizingColumn: o.id
        }));
      };
    };
  },
  createTable: (t) => {
    t.setColumnSizing = (e) => t.options.onColumnSizingChange == null ? void 0 : t.options.onColumnSizingChange(e), t.setColumnSizingInfo = (e) => t.options.onColumnSizingInfoChange == null ? void 0 : t.options.onColumnSizingInfoChange(e), t.resetColumnSizing = (e) => {
      var n;
      t.setColumnSizing(e ? {} : (n = t.initialState.columnSizing) != null ? n : {});
    }, t.resetHeaderSizeInfo = (e) => {
      var n;
      t.setColumnSizingInfo(e ? Ic() : (n = t.initialState.columnSizingInfo) != null ? n : Ic());
    }, t.getTotalSize = () => {
      var e, n;
      return (e = (n = t.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getLeftTotalSize = () => {
      var e, n;
      return (e = (n = t.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getCenterTotalSize = () => {
      var e, n;
      return (e = (n = t.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getRightTotalSize = () => {
      var e, n;
      return (e = (n = t.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    };
  }
};
let pl = null;
function MI() {
  if (typeof pl == "boolean") return pl;
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, e), window.removeEventListener("test", n);
  } catch {
    t = !1;
  }
  return pl = t, pl;
}
function Tc(t) {
  return t.type === "touchstart";
}
const PI = {
  getInitialState: (t) => ({
    columnVisibility: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnVisibilityChange: Nn("columnVisibility", t)
  }),
  createColumn: (t, e) => {
    t.toggleVisibility = (n) => {
      t.getCanHide() && e.setColumnVisibility((o) => ({
        ...o,
        [t.id]: n ?? !t.getIsVisible()
      }));
    }, t.getIsVisible = () => {
      var n, o;
      const r = t.columns;
      return (n = r.length ? r.some((i) => i.getIsVisible()) : (o = e.getState().columnVisibility) == null ? void 0 : o[t.id]) != null ? n : !0;
    }, t.getCanHide = () => {
      var n, o;
      return ((n = t.columnDef.enableHiding) != null ? n : !0) && ((o = e.options.enableHiding) != null ? o : !0);
    }, t.getToggleVisibilityHandler = () => (n) => {
      t.toggleVisibility == null || t.toggleVisibility(n.target.checked);
    };
  },
  createRow: (t, e) => {
    t._getAllVisibleCells = ot(() => [t.getAllCells(), e.getState().columnVisibility], (n) => n.filter((o) => o.column.getIsVisible()), rt(e.options, "debugRows", "_getAllVisibleCells")), t.getVisibleCells = ot(() => [t.getLeftVisibleCells(), t.getCenterVisibleCells(), t.getRightVisibleCells()], (n, o, r) => [...n, ...o, ...r], rt(e.options, "debugRows", "getVisibleCells"));
  },
  createTable: (t) => {
    const e = (n, o) => ot(() => [o(), o().filter((r) => r.getIsVisible()).map((r) => r.id).join("_")], (r) => r.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), rt(t.options, "debugColumns", n));
    t.getVisibleFlatColumns = e("getVisibleFlatColumns", () => t.getAllFlatColumns()), t.getVisibleLeafColumns = e("getVisibleLeafColumns", () => t.getAllLeafColumns()), t.getLeftVisibleLeafColumns = e("getLeftVisibleLeafColumns", () => t.getLeftLeafColumns()), t.getRightVisibleLeafColumns = e("getRightVisibleLeafColumns", () => t.getRightLeafColumns()), t.getCenterVisibleLeafColumns = e("getCenterVisibleLeafColumns", () => t.getCenterLeafColumns()), t.setColumnVisibility = (n) => t.options.onColumnVisibilityChange == null ? void 0 : t.options.onColumnVisibilityChange(n), t.resetColumnVisibility = (n) => {
      var o;
      t.setColumnVisibility(n ? {} : (o = t.initialState.columnVisibility) != null ? o : {});
    }, t.toggleAllColumnsVisible = (n) => {
      var o;
      n = (o = n) != null ? o : !t.getIsAllColumnsVisible(), t.setColumnVisibility(t.getAllLeafColumns().reduce((r, i) => ({
        ...r,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, t.getIsAllColumnsVisible = () => !t.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), t.getIsSomeColumnsVisible = () => t.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), t.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var o;
      t.toggleAllColumnsVisible((o = n.target) == null ? void 0 : o.checked);
    };
  }
};
function Fi(t, e) {
  return e ? e === "center" ? t.getCenterVisibleLeafColumns() : e === "left" ? t.getLeftVisibleLeafColumns() : t.getRightVisibleLeafColumns() : t.getVisibleLeafColumns();
}
const II = {
  createTable: (t) => {
    t._getGlobalFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, "__global__"), t.getGlobalFacetedRowModel = () => t.options.manualFiltering || !t._getGlobalFacetedRowModel ? t.getPreFilteredRowModel() : t._getGlobalFacetedRowModel(), t._getGlobalFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, "__global__"), t.getGlobalFacetedUniqueValues = () => t._getGlobalFacetedUniqueValues ? t._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getGlobalFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, "__global__"), t.getGlobalFacetedMinMaxValues = () => {
      if (t._getGlobalFacetedMinMaxValues)
        return t._getGlobalFacetedMinMaxValues();
    };
  }
}, TI = {
  getInitialState: (t) => ({
    globalFilter: void 0,
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGlobalFilterChange: Nn("globalFilter", t),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (e) => {
      var n;
      const o = (n = t.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[e.id]) == null ? void 0 : n.getValue();
      return typeof o == "string" || typeof o == "number";
    }
  }),
  createColumn: (t, e) => {
    t.getCanGlobalFilter = () => {
      var n, o, r, i;
      return ((n = t.columnDef.enableGlobalFilter) != null ? n : !0) && ((o = e.options.enableGlobalFilter) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && ((i = e.options.getColumnCanGlobalFilter == null ? void 0 : e.options.getColumnCanGlobalFilter(t)) != null ? i : !0) && !!t.accessorFn;
    };
  },
  createTable: (t) => {
    t.getGlobalAutoFilterFn = () => Co.includesString, t.getGlobalFilterFn = () => {
      var e, n;
      const {
        globalFilterFn: o
      } = t.options;
      return Ia(o) ? o : o === "auto" ? t.getGlobalAutoFilterFn() : (e = (n = t.options.filterFns) == null ? void 0 : n[o]) != null ? e : Co[o];
    }, t.setGlobalFilter = (e) => {
      t.options.onGlobalFilterChange == null || t.options.onGlobalFilterChange(e);
    }, t.resetGlobalFilter = (e) => {
      t.setGlobalFilter(e ? void 0 : t.initialState.globalFilter);
    };
  }
}, OI = {
  getInitialState: (t) => ({
    expanded: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onExpandedChange: Nn("expanded", t),
    paginateExpandedRows: !0
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetExpanded = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetExpanded) != null ? o : !t.options.manualExpanding) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetExpanded(), n = !1;
        });
      }
    }, t.setExpanded = (o) => t.options.onExpandedChange == null ? void 0 : t.options.onExpandedChange(o), t.toggleAllRowsExpanded = (o) => {
      o ?? !t.getIsAllRowsExpanded() ? t.setExpanded(!0) : t.setExpanded({});
    }, t.resetExpanded = (o) => {
      var r, i;
      t.setExpanded(o ? {} : (r = (i = t.initialState) == null ? void 0 : i.expanded) != null ? r : {});
    }, t.getCanSomeRowsExpand = () => t.getPrePaginationRowModel().flatRows.some((o) => o.getCanExpand()), t.getToggleAllRowsExpandedHandler = () => (o) => {
      o.persist == null || o.persist(), t.toggleAllRowsExpanded();
    }, t.getIsSomeRowsExpanded = () => {
      const o = t.getState().expanded;
      return o === !0 || Object.values(o).some(Boolean);
    }, t.getIsAllRowsExpanded = () => {
      const o = t.getState().expanded;
      return typeof o == "boolean" ? o === !0 : !(!Object.keys(o).length || t.getRowModel().flatRows.some((r) => !r.getIsExpanded()));
    }, t.getExpandedDepth = () => {
      let o = 0;
      return (t.getState().expanded === !0 ? Object.keys(t.getRowModel().rowsById) : Object.keys(t.getState().expanded)).forEach((i) => {
        const s = i.split(".");
        o = Math.max(o, s.length);
      }), o;
    }, t.getPreExpandedRowModel = () => t.getSortedRowModel(), t.getExpandedRowModel = () => (!t._getExpandedRowModel && t.options.getExpandedRowModel && (t._getExpandedRowModel = t.options.getExpandedRowModel(t)), t.options.manualExpanding || !t._getExpandedRowModel ? t.getPreExpandedRowModel() : t._getExpandedRowModel());
  },
  createRow: (t, e) => {
    t.toggleExpanded = (n) => {
      e.setExpanded((o) => {
        var r;
        const i = o === !0 ? !0 : !!(o != null && o[t.id]);
        let s = {};
        if (o === !0 ? Object.keys(e.getRowModel().rowsById).forEach((l) => {
          s[l] = !0;
        }) : s = o, n = (r = n) != null ? r : !i, !i && n)
          return {
            ...s,
            [t.id]: !0
          };
        if (i && !n) {
          const {
            [t.id]: l,
            ...a
          } = s;
          return a;
        }
        return o;
      });
    }, t.getIsExpanded = () => {
      var n;
      const o = e.getState().expanded;
      return !!((n = e.options.getIsRowExpanded == null ? void 0 : e.options.getIsRowExpanded(t)) != null ? n : o === !0 || o?.[t.id]);
    }, t.getCanExpand = () => {
      var n, o, r;
      return (n = e.options.getRowCanExpand == null ? void 0 : e.options.getRowCanExpand(t)) != null ? n : ((o = e.options.enableExpanding) != null ? o : !0) && !!((r = t.subRows) != null && r.length);
    }, t.getIsAllParentsExpanded = () => {
      let n = !0, o = t;
      for (; n && o.parentId; )
        o = e.getRow(o.parentId, !0), n = o.getIsExpanded();
      return n;
    }, t.getToggleExpandedHandler = () => {
      const n = t.getCanExpand();
      return () => {
        n && t.toggleExpanded();
      };
    };
  }
}, mu = 0, gu = 10, Oc = () => ({
  pageIndex: mu,
  pageSize: gu
}), DI = {
  getInitialState: (t) => ({
    ...t,
    pagination: {
      ...Oc(),
      ...t?.pagination
    }
  }),
  getDefaultOptions: (t) => ({
    onPaginationChange: Nn("pagination", t)
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetPageIndex = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetPageIndex) != null ? o : !t.options.manualPagination) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetPageIndex(), n = !1;
        });
      }
    }, t.setPagination = (o) => {
      const r = (i) => Bo(o, i);
      return t.options.onPaginationChange == null ? void 0 : t.options.onPaginationChange(r);
    }, t.resetPagination = (o) => {
      var r;
      t.setPagination(o ? Oc() : (r = t.initialState.pagination) != null ? r : Oc());
    }, t.setPageIndex = (o) => {
      t.setPagination((r) => {
        let i = Bo(o, r.pageIndex);
        const s = typeof t.options.pageCount > "u" || t.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : t.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, s)), {
          ...r,
          pageIndex: i
        };
      });
    }, t.resetPageIndex = (o) => {
      var r, i;
      t.setPageIndex(o ? mu : (r = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? r : mu);
    }, t.resetPageSize = (o) => {
      var r, i;
      t.setPageSize(o ? gu : (r = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? r : gu);
    }, t.setPageSize = (o) => {
      t.setPagination((r) => {
        const i = Math.max(1, Bo(o, r.pageSize)), s = r.pageSize * r.pageIndex, l = Math.floor(s / i);
        return {
          ...r,
          pageIndex: l,
          pageSize: i
        };
      });
    }, t.setPageCount = (o) => t.setPagination((r) => {
      var i;
      let s = Bo(o, (i = t.options.pageCount) != null ? i : -1);
      return typeof s == "number" && (s = Math.max(-1, s)), {
        ...r,
        pageCount: s
      };
    }), t.getPageOptions = ot(() => [t.getPageCount()], (o) => {
      let r = [];
      return o && o > 0 && (r = [...new Array(o)].fill(null).map((i, s) => s)), r;
    }, rt(t.options, "debugTable", "getPageOptions")), t.getCanPreviousPage = () => t.getState().pagination.pageIndex > 0, t.getCanNextPage = () => {
      const {
        pageIndex: o
      } = t.getState().pagination, r = t.getPageCount();
      return r === -1 ? !0 : r === 0 ? !1 : o < r - 1;
    }, t.previousPage = () => t.setPageIndex((o) => o - 1), t.nextPage = () => t.setPageIndex((o) => o + 1), t.firstPage = () => t.setPageIndex(0), t.lastPage = () => t.setPageIndex(t.getPageCount() - 1), t.getPrePaginationRowModel = () => t.getExpandedRowModel(), t.getPaginationRowModel = () => (!t._getPaginationRowModel && t.options.getPaginationRowModel && (t._getPaginationRowModel = t.options.getPaginationRowModel(t)), t.options.manualPagination || !t._getPaginationRowModel ? t.getPrePaginationRowModel() : t._getPaginationRowModel()), t.getPageCount = () => {
      var o;
      return (o = t.options.pageCount) != null ? o : Math.ceil(t.getRowCount() / t.getState().pagination.pageSize);
    }, t.getRowCount = () => {
      var o;
      return (o = t.options.rowCount) != null ? o : t.getPrePaginationRowModel().rows.length;
    };
  }
}, Dc = () => ({
  top: [],
  bottom: []
}), _I = {
  getInitialState: (t) => ({
    rowPinning: Dc(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowPinningChange: Nn("rowPinning", t)
  }),
  createRow: (t, e) => {
    t.pin = (n, o, r) => {
      const i = o ? t.getLeafRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], s = r ? t.getParentRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], l = /* @__PURE__ */ new Set([...s, t.id, ...i]);
      e.setRowPinning((a) => {
        var c, u;
        if (n === "bottom") {
          var d, f;
          return {
            top: ((d = a?.top) != null ? d : []).filter((h) => !(l != null && l.has(h))),
            bottom: [...((f = a?.bottom) != null ? f : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)]
          };
        }
        if (n === "top") {
          var p, m;
          return {
            top: [...((p = a?.top) != null ? p : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)],
            bottom: ((m = a?.bottom) != null ? m : []).filter((h) => !(l != null && l.has(h)))
          };
        }
        return {
          top: ((c = a?.top) != null ? c : []).filter((h) => !(l != null && l.has(h))),
          bottom: ((u = a?.bottom) != null ? u : []).filter((h) => !(l != null && l.has(h)))
        };
      });
    }, t.getCanPin = () => {
      var n;
      const {
        enableRowPinning: o,
        enablePinning: r
      } = e.options;
      return typeof o == "function" ? o(t) : (n = o ?? r) != null ? n : !0;
    }, t.getIsPinned = () => {
      const n = [t.id], {
        top: o,
        bottom: r
      } = e.getState().rowPinning, i = n.some((l) => o?.includes(l)), s = n.some((l) => r?.includes(l));
      return i ? "top" : s ? "bottom" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      if (!r) return -1;
      const i = (n = r === "top" ? e.getTopRows() : e.getBottomRows()) == null ? void 0 : n.map((s) => {
        let {
          id: l
        } = s;
        return l;
      });
      return (o = i?.indexOf(t.id)) != null ? o : -1;
    };
  },
  createTable: (t) => {
    t.setRowPinning = (e) => t.options.onRowPinningChange == null ? void 0 : t.options.onRowPinningChange(e), t.resetRowPinning = (e) => {
      var n, o;
      return t.setRowPinning(e ? Dc() : (n = (o = t.initialState) == null ? void 0 : o.rowPinning) != null ? n : Dc());
    }, t.getIsSomeRowsPinned = (e) => {
      var n;
      const o = t.getState().rowPinning;
      if (!e) {
        var r, i;
        return !!((r = o.top) != null && r.length || (i = o.bottom) != null && i.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t._getPinnedRows = (e, n, o) => {
      var r;
      return ((r = t.options.keepPinnedRows) == null || r ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((s) => {
          const l = t.getRow(s, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((s) => e.find((l) => l.id === s))
      )).filter(Boolean).map((s) => ({
        ...s,
        position: o
      }));
    }, t.getTopRows = ot(() => [t.getRowModel().rows, t.getState().rowPinning.top], (e, n) => t._getPinnedRows(e, n, "top"), rt(t.options, "debugRows", "getTopRows")), t.getBottomRows = ot(() => [t.getRowModel().rows, t.getState().rowPinning.bottom], (e, n) => t._getPinnedRows(e, n, "bottom"), rt(t.options, "debugRows", "getBottomRows")), t.getCenterRows = ot(() => [t.getRowModel().rows, t.getState().rowPinning.top, t.getState().rowPinning.bottom], (e, n, o) => {
      const r = /* @__PURE__ */ new Set([...n ?? [], ...o ?? []]);
      return e.filter((i) => !r.has(i.id));
    }, rt(t.options, "debugRows", "getCenterRows"));
  }
}, VI = {
  getInitialState: (t) => ({
    rowSelection: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowSelectionChange: Nn("rowSelection", t),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (t) => {
    t.setRowSelection = (e) => t.options.onRowSelectionChange == null ? void 0 : t.options.onRowSelectionChange(e), t.resetRowSelection = (e) => {
      var n;
      return t.setRowSelection(e ? {} : (n = t.initialState.rowSelection) != null ? n : {});
    }, t.toggleAllRowsSelected = (e) => {
      t.setRowSelection((n) => {
        e = typeof e < "u" ? e : !t.getIsAllRowsSelected();
        const o = {
          ...n
        }, r = t.getPreGroupedRowModel().flatRows;
        return e ? r.forEach((i) => {
          i.getCanSelect() && (o[i.id] = !0);
        }) : r.forEach((i) => {
          delete o[i.id];
        }), o;
      });
    }, t.toggleAllPageRowsSelected = (e) => t.setRowSelection((n) => {
      const o = typeof e < "u" ? e : !t.getIsAllPageRowsSelected(), r = {
        ...n
      };
      return t.getRowModel().rows.forEach((i) => {
        hu(r, i.id, o, !0, t);
      }), r;
    }), t.getPreSelectedRowModel = () => t.getCoreRowModel(), t.getSelectedRowModel = ot(() => [t.getState().rowSelection, t.getCoreRowModel()], (e, n) => Object.keys(e).length ? _c(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, rt(t.options, "debugTable", "getSelectedRowModel")), t.getFilteredSelectedRowModel = ot(() => [t.getState().rowSelection, t.getFilteredRowModel()], (e, n) => Object.keys(e).length ? _c(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, rt(t.options, "debugTable", "getFilteredSelectedRowModel")), t.getGroupedSelectedRowModel = ot(() => [t.getState().rowSelection, t.getSortedRowModel()], (e, n) => Object.keys(e).length ? _c(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, rt(t.options, "debugTable", "getGroupedSelectedRowModel")), t.getIsAllRowsSelected = () => {
      const e = t.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = t.getState();
      let o = !!(e.length && Object.keys(n).length);
      return o && e.some((r) => r.getCanSelect() && !n[r.id]) && (o = !1), o;
    }, t.getIsAllPageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows.filter((r) => r.getCanSelect()), {
        rowSelection: n
      } = t.getState();
      let o = !!e.length;
      return o && e.some((r) => !n[r.id]) && (o = !1), o;
    }, t.getIsSomeRowsSelected = () => {
      var e;
      const n = Object.keys((e = t.getState().rowSelection) != null ? e : {}).length;
      return n > 0 && n < t.getFilteredRowModel().flatRows.length;
    }, t.getIsSomePageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows;
      return t.getIsAllPageRowsSelected() ? !1 : e.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, t.getToggleAllRowsSelectedHandler = () => (e) => {
      t.toggleAllRowsSelected(e.target.checked);
    }, t.getToggleAllPageRowsSelectedHandler = () => (e) => {
      t.toggleAllPageRowsSelected(e.target.checked);
    };
  },
  createRow: (t, e) => {
    t.toggleSelected = (n, o) => {
      const r = t.getIsSelected();
      e.setRowSelection((i) => {
        var s;
        if (n = typeof n < "u" ? n : !r, t.getCanSelect() && r === n)
          return i;
        const l = {
          ...i
        };
        return hu(l, t.id, n, (s = o?.selectChildren) != null ? s : !0, e), l;
      });
    }, t.getIsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return u1(t, n);
    }, t.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return bu(t, n) === "some";
    }, t.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return bu(t, n) === "all";
    }, t.getCanSelect = () => {
      var n;
      return typeof e.options.enableRowSelection == "function" ? e.options.enableRowSelection(t) : (n = e.options.enableRowSelection) != null ? n : !0;
    }, t.getCanSelectSubRows = () => {
      var n;
      return typeof e.options.enableSubRowSelection == "function" ? e.options.enableSubRowSelection(t) : (n = e.options.enableSubRowSelection) != null ? n : !0;
    }, t.getCanMultiSelect = () => {
      var n;
      return typeof e.options.enableMultiRowSelection == "function" ? e.options.enableMultiRowSelection(t) : (n = e.options.enableMultiRowSelection) != null ? n : !0;
    }, t.getToggleSelectedHandler = () => {
      const n = t.getCanSelect();
      return (o) => {
        var r;
        n && t.toggleSelected((r = o.target) == null ? void 0 : r.checked);
      };
    };
  }
}, hu = (t, e, n, o, r) => {
  var i;
  const s = r.getRow(e, !0);
  n ? (s.getCanMultiSelect() || Object.keys(t).forEach((l) => delete t[l]), s.getCanSelect() && (t[e] = !0)) : delete t[e], o && (i = s.subRows) != null && i.length && s.getCanSelectSubRows() && s.subRows.forEach((l) => hu(t, l.id, n, o, r));
};
function _c(t, e) {
  const n = t.getState().rowSelection, o = [], r = {}, i = function(s, l) {
    return s.map((a) => {
      var c;
      const u = u1(a, n);
      if (u && (o.push(a), r[a.id] = a), (c = a.subRows) != null && c.length && (a = {
        ...a,
        subRows: i(a.subRows)
      }), u)
        return a;
    }).filter(Boolean);
  };
  return {
    rows: i(e.rows),
    flatRows: o,
    rowsById: r
  };
}
function u1(t, e) {
  var n;
  return (n = e[t.id]) != null ? n : !1;
}
function bu(t, e, n) {
  var o;
  if (!((o = t.subRows) != null && o.length)) return !1;
  let r = !0, i = !1;
  return t.subRows.forEach((s) => {
    if (!(i && !r) && (s.getCanSelect() && (u1(s, e) ? i = !0 : r = !1), s.subRows && s.subRows.length)) {
      const l = bu(s, e);
      l === "all" ? i = !0 : (l === "some" && (i = !0), r = !1);
    }
  }), r ? "all" : i ? "some" : !1;
}
const vu = /([0-9]+)/gm, AI = (t, e, n) => g4(Xo(t.getValue(n)).toLowerCase(), Xo(e.getValue(n)).toLowerCase()), LI = (t, e, n) => g4(Xo(t.getValue(n)), Xo(e.getValue(n))), FI = (t, e, n) => d1(Xo(t.getValue(n)).toLowerCase(), Xo(e.getValue(n)).toLowerCase()), $I = (t, e, n) => d1(Xo(t.getValue(n)), Xo(e.getValue(n))), HI = (t, e, n) => {
  const o = t.getValue(n), r = e.getValue(n);
  return o > r ? 1 : o < r ? -1 : 0;
}, zI = (t, e, n) => d1(t.getValue(n), e.getValue(n));
function d1(t, e) {
  return t === e ? 0 : t > e ? 1 : -1;
}
function Xo(t) {
  return typeof t == "number" ? isNaN(t) || t === 1 / 0 || t === -1 / 0 ? "" : String(t) : typeof t == "string" ? t : "";
}
function g4(t, e) {
  const n = t.split(vu).filter(Boolean), o = e.split(vu).filter(Boolean);
  for (; n.length && o.length; ) {
    const r = n.shift(), i = o.shift(), s = parseInt(r, 10), l = parseInt(i, 10), a = [s, l].sort();
    if (isNaN(a[0])) {
      if (r > i)
        return 1;
      if (i > r)
        return -1;
      continue;
    }
    if (isNaN(a[1]))
      return isNaN(s) ? -1 : 1;
    if (s > l)
      return 1;
    if (l > s)
      return -1;
  }
  return n.length - o.length;
}
const Mi = {
  alphanumeric: AI,
  alphanumericCaseSensitive: LI,
  text: FI,
  textCaseSensitive: $I,
  datetime: HI,
  basic: zI
}, BI = {
  getInitialState: (t) => ({
    sorting: [],
    ...t
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (t) => ({
    onSortingChange: Nn("sorting", t),
    isMultiSortEvent: (e) => e.shiftKey
  }),
  createColumn: (t, e) => {
    t.getAutoSortingFn = () => {
      const n = e.getFilteredRowModel().flatRows.slice(10);
      let o = !1;
      for (const r of n) {
        const i = r?.getValue(t.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return Mi.datetime;
        if (typeof i == "string" && (o = !0, i.split(vu).length > 1))
          return Mi.alphanumeric;
      }
      return o ? Mi.text : Mi.basic;
    }, t.getAutoSortDir = () => {
      const n = e.getFilteredRowModel().flatRows[0];
      return typeof n?.getValue(t.id) == "string" ? "asc" : "desc";
    }, t.getSortingFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return Ia(t.columnDef.sortingFn) ? t.columnDef.sortingFn : t.columnDef.sortingFn === "auto" ? t.getAutoSortingFn() : (n = (o = e.options.sortingFns) == null ? void 0 : o[t.columnDef.sortingFn]) != null ? n : Mi[t.columnDef.sortingFn];
    }, t.toggleSorting = (n, o) => {
      const r = t.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      e.setSorting((s) => {
        const l = s?.find((p) => p.id === t.id), a = s?.findIndex((p) => p.id === t.id);
        let c = [], u, d = i ? n : r === "desc";
        if (s != null && s.length && t.getCanMultiSort() && o ? l ? u = "toggle" : u = "add" : s != null && s.length && a !== s.length - 1 ? u = "replace" : l ? u = "toggle" : u = "replace", u === "toggle" && (i || r || (u = "remove")), u === "add") {
          var f;
          c = [...s, {
            id: t.id,
            desc: d
          }], c.splice(0, c.length - ((f = e.options.maxMultiSortColCount) != null ? f : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? c = s.map((p) => p.id === t.id ? {
          ...p,
          desc: d
        } : p) : u === "remove" ? c = s.filter((p) => p.id !== t.id) : c = [{
          id: t.id,
          desc: d
        }];
        return c;
      });
    }, t.getFirstSortDir = () => {
      var n, o;
      return ((n = (o = t.columnDef.sortDescFirst) != null ? o : e.options.sortDescFirst) != null ? n : t.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, t.getNextSortingOrder = (n) => {
      var o, r;
      const i = t.getFirstSortDir(), s = t.getIsSorted();
      return s ? s !== i && ((o = e.options.enableSortingRemoval) == null || o) && // If enableSortRemove, enable in general
      (!(n && (r = e.options.enableMultiRemove) != null) || r) ? !1 : s === "desc" ? "asc" : "desc" : i;
    }, t.getCanSort = () => {
      var n, o;
      return ((n = t.columnDef.enableSorting) != null ? n : !0) && ((o = e.options.enableSorting) != null ? o : !0) && !!t.accessorFn;
    }, t.getCanMultiSort = () => {
      var n, o;
      return (n = (o = t.columnDef.enableMultiSort) != null ? o : e.options.enableMultiSort) != null ? n : !!t.accessorFn;
    }, t.getIsSorted = () => {
      var n;
      const o = (n = e.getState().sorting) == null ? void 0 : n.find((r) => r.id === t.id);
      return o ? o.desc ? "desc" : "asc" : !1;
    }, t.getSortIndex = () => {
      var n, o;
      return (n = (o = e.getState().sorting) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.clearSorting = () => {
      e.setSorting((n) => n != null && n.length ? n.filter((o) => o.id !== t.id) : []);
    }, t.getToggleSortingHandler = () => {
      const n = t.getCanSort();
      return (o) => {
        n && (o.persist == null || o.persist(), t.toggleSorting == null || t.toggleSorting(void 0, t.getCanMultiSort() ? e.options.isMultiSortEvent == null ? void 0 : e.options.isMultiSortEvent(o) : !1));
      };
    };
  },
  createTable: (t) => {
    t.setSorting = (e) => t.options.onSortingChange == null ? void 0 : t.options.onSortingChange(e), t.resetSorting = (e) => {
      var n, o;
      t.setSorting(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.sorting) != null ? n : []);
    }, t.getPreSortedRowModel = () => t.getGroupedRowModel(), t.getSortedRowModel = () => (!t._getSortedRowModel && t.options.getSortedRowModel && (t._getSortedRowModel = t.options.getSortedRowModel(t)), t.options.manualSorting || !t._getSortedRowModel ? t.getPreSortedRowModel() : t._getSortedRowModel());
  }
}, WI = [
  cI,
  PI,
  RI,
  EI,
  dI,
  fI,
  II,
  //depends on ColumnFaceting
  TI,
  //depends on ColumnFiltering
  BI,
  wI,
  //depends on RowSorting
  OI,
  DI,
  _I,
  VI,
  kI
];
function UI(t) {
  var e, n;
  process.env.NODE_ENV !== "production" && (t.debugAll || t.debugTable) && console.info("Creating Table Instance...");
  const o = [...WI, ...(e = t._features) != null ? e : []];
  let r = {
    _features: o
  };
  const i = r._features.reduce((f, p) => Object.assign(f, p.getDefaultOptions == null ? void 0 : p.getDefaultOptions(r)), {}), s = (f) => r.options.mergeOptions ? r.options.mergeOptions(i, f) : {
    ...i,
    ...f
  };
  let a = {
    ...{},
    ...(n = t.initialState) != null ? n : {}
  };
  r._features.forEach((f) => {
    var p;
    a = (p = f.getInitialState == null ? void 0 : f.getInitialState(a)) != null ? p : a;
  });
  const c = [];
  let u = !1;
  const d = {
    _features: o,
    options: {
      ...i,
      ...t
    },
    initialState: a,
    _queue: (f) => {
      c.push(f), u || (u = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        u = !1;
      }).catch((p) => setTimeout(() => {
        throw p;
      })));
    },
    reset: () => {
      r.setState(r.initialState);
    },
    setOptions: (f) => {
      const p = Bo(f, r.options);
      r.options = s(p);
    },
    getState: () => r.options.state,
    setState: (f) => {
      r.options.onStateChange == null || r.options.onStateChange(f);
    },
    _getRowId: (f, p, m) => {
      var h;
      return (h = r.options.getRowId == null ? void 0 : r.options.getRowId(f, p, m)) != null ? h : `${m ? [m.id, p].join(".") : p}`;
    },
    getCoreRowModel: () => (r._getCoreRowModel || (r._getCoreRowModel = r.options.getCoreRowModel(r)), r._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => r.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (f, p) => {
      let m = (p ? r.getPrePaginationRowModel() : r.getRowModel()).rowsById[f];
      if (!m && (m = r.getCoreRowModel().rowsById[f], !m))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${f}`) : new Error();
      return m;
    },
    _getDefaultColumnDef: ot(() => [r.options.defaultColumn], (f) => {
      var p;
      return f = (p = f) != null ? p : {}, {
        header: (m) => {
          const h = m.header.column.columnDef;
          return h.accessorKey ? h.accessorKey : h.accessorFn ? h.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (m) => {
          var h, b;
          return (h = (b = m.renderValue()) == null || b.toString == null ? void 0 : b.toString()) != null ? h : null;
        },
        ...r._features.reduce((m, h) => Object.assign(m, h.getDefaultColumnDef == null ? void 0 : h.getDefaultColumnDef()), {}),
        ...f
      };
    }, rt(t, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => r.options.columns,
    getAllColumns: ot(() => [r._getColumnDefs()], (f) => {
      const p = function(m, h, b) {
        return b === void 0 && (b = 0), m.map((v) => {
          const C = aI(r, v, b, h), y = v;
          return C.columns = y.columns ? p(y.columns, C, b + 1) : [], C;
        });
      };
      return p(f);
    }, rt(t, "debugColumns", "getAllColumns")),
    getAllFlatColumns: ot(() => [r.getAllColumns()], (f) => f.flatMap((p) => p.getFlatColumns()), rt(t, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: ot(() => [r.getAllFlatColumns()], (f) => f.reduce((p, m) => (p[m.id] = m, p), {}), rt(t, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: ot(() => [r.getAllColumns(), r._getOrderColumnsFn()], (f, p) => {
      let m = f.flatMap((h) => h.getLeafColumns());
      return p(m);
    }, rt(t, "debugColumns", "getAllLeafColumns")),
    getColumn: (f) => {
      const p = r._getAllFlatColumnsById()[f];
      return process.env.NODE_ENV !== "production" && !p && console.error(`[Table] Column with id '${f}' does not exist.`), p;
    }
  };
  Object.assign(r, d);
  for (let f = 0; f < r._features.length; f++) {
    const p = r._features[f];
    p == null || p.createTable == null || p.createTable(r);
  }
  return r;
}
function GI() {
  return (t) => ot(() => [t.options.data], (e) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, o = function(r, i, s) {
      i === void 0 && (i = 0);
      const l = [];
      for (let c = 0; c < r.length; c++) {
        const u = uI(t, t._getRowId(r[c], c, s), r[c], c, i, void 0, s?.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, l.push(u), t.options.getSubRows) {
          var a;
          u.originalSubRows = t.options.getSubRows(r[c], c), (a = u.originalSubRows) != null && a.length && (u.subRows = o(u.originalSubRows, i + 1, u));
        }
      }
      return l;
    };
    return n.rows = o(e), n;
  }, rt(t.options, "debugTable", "getRowModel", () => t._autoResetPageIndex()));
}
function YI(t) {
  const e = [], n = (o) => {
    var r;
    e.push(o), (r = o.subRows) != null && r.length && o.getIsExpanded() && o.subRows.forEach(n);
  };
  return t.rows.forEach(n), {
    rows: e,
    flatRows: t.flatRows,
    rowsById: t.rowsById
  };
}
function jI(t) {
  return (e) => ot(() => [e.getState().pagination, e.getPrePaginationRowModel(), e.options.paginateExpandedRows ? void 0 : e.getState().expanded], (n, o) => {
    if (!o.rows.length)
      return o;
    const {
      pageSize: r,
      pageIndex: i
    } = n;
    let {
      rows: s,
      flatRows: l,
      rowsById: a
    } = o;
    const c = r * i, u = c + r;
    s = s.slice(c, u);
    let d;
    e.options.paginateExpandedRows ? d = {
      rows: s,
      flatRows: l,
      rowsById: a
    } : d = YI({
      rows: s,
      flatRows: l,
      rowsById: a
    }), d.flatRows = [];
    const f = (p) => {
      d.flatRows.push(p), p.subRows.length && p.subRows.forEach(f);
    };
    return d.rows.forEach(f), d;
  }, rt(e.options, "debugTable", "getPaginationRowModel"));
}
function KI() {
  return (t) => ot(() => [t.getState().sorting, t.getPreSortedRowModel()], (e, n) => {
    if (!n.rows.length || !(e != null && e.length))
      return n;
    const o = t.getState().sorting, r = [], i = o.filter((a) => {
      var c;
      return (c = t.getColumn(a.id)) == null ? void 0 : c.getCanSort();
    }), s = {};
    i.forEach((a) => {
      const c = t.getColumn(a.id);
      c && (s[a.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const l = (a) => {
      const c = a.map((u) => ({
        ...u
      }));
      return c.sort((u, d) => {
        for (let p = 0; p < i.length; p += 1) {
          var f;
          const m = i[p], h = s[m.id], b = h.sortUndefined, v = (f = m?.desc) != null ? f : !1;
          let C = 0;
          if (b) {
            const y = u.getValue(m.id), w = d.getValue(m.id), R = y === void 0, S = w === void 0;
            if (R || S) {
              if (b === "first") return R ? -1 : 1;
              if (b === "last") return R ? 1 : -1;
              C = R && S ? 0 : R ? b : -b;
            }
          }
          if (C === 0 && (C = h.sortingFn(u, d, m.id)), C !== 0)
            return v && (C *= -1), h.invertSorting && (C *= -1), C;
        }
        return u.index - d.index;
      }), c.forEach((u) => {
        var d;
        r.push(u), (d = u.subRows) != null && d.length && (u.subRows = l(u.subRows));
      }), c;
    };
    return {
      rows: l(n.rows),
      flatRows: r,
      rowsById: n.rowsById
    };
  }, rt(t.options, "debugTable", "getSortedRowModel", () => t._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function eg(t, e) {
  return t ? qI(t) ? /* @__PURE__ */ x.createElement(t, e) : t : null;
}
function qI(t) {
  return ZI(t) || typeof t == "function" || XI(t);
}
function ZI(t) {
  return typeof t == "function" && (() => {
    const e = Object.getPrototypeOf(t);
    return e.prototype && e.prototype.isReactComponent;
  })();
}
function XI(t) {
  return typeof t == "object" && typeof t.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(t.$$typeof.description);
}
function QI(t) {
  const e = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...t
  }, [n] = x.useState(() => ({
    current: UI(e)
  })), [o, r] = x.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...t,
    state: {
      ...o,
      ...t.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (s) => {
      r(s), t.onStateChange == null || t.onStateChange(s);
    }
  })), n.current;
}
const JI = {
  starting: "169px",
  text: "170px",
  doubleLine: "250px",
  chip: "90px",
  chipText: "250px",
  currency: "130px",
  icon: "52px",
  button: "191px",
  toggle: "207px",
  dropdown: "182px",
  input: "var(--table-input-cell-width)",
  calendar: "208px",
  expand: "80px",
  endingSpacer: "8px"
}, eT = ae(["w-full", "caption-bottom", "border-collapse", "bg-table-row-light-surface", "text-text-default", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "@max-[480px]/data-table:[--table-input-cell-width:167px]", "@max-[480px]/data-table:[--table-row-height:56px]"], {
  variants: {
    size: {
      sm: ["[--table-input-cell-width:167px]", "[--table-row-height:56px]"],
      md: ["[--table-input-cell-width:167px]", "[--table-row-height:68px]"],
      lg: ["[--table-input-cell-width:208px]", "[--table-row-height:84px]"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), tT = ae(["relative", "border-b", "border-table-outline", "transition-[box-shadow]", "duration-200", "ease-in-out", "data-[interactive]:cursor-pointer", "data-[selected]:bg-table-row-select"], {
  variants: {
    section: {
      header: ["h-(--spacing-40)"],
      body: ["h-(--table-row-height)", "hover:z-[1]", "hover:shadow-elevation-2"]
    }
  },
  defaultVariants: {
    section: "body"
  }
}), nT = ae(["[&>td:first-child]:relative", "[&>td:first-child]:before:pointer-events-none", "[&>td:first-child]:before:absolute", "[&>td:first-child]:before:inset-y-0", "[&>td:first-child]:before:left-0", "[&>td:first-child]:before:w-(--spacing-4)", "[&>td:first-child]:before:content-['']"], {
  variants: {
    tone: {
      brand: "[&>td:first-child]:before:bg-primary",
      positive: "[&>td:first-child]:before:bg-positive",
      warning: "[&>td:first-child]:before:bg-accessibility-warning",
      negative: "[&>td:first-child]:before:bg-negative",
      informative: "[&>td:first-child]:before:bg-informative"
    }
  }
}), h4 = ae([], {
  variants: {
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right"
    }
  },
  defaultVariants: {
    align: "left"
  }
}), oT = ae(["h-(--spacing-40)", "whitespace-nowrap", "border-b", "border-table-outline", "bg-table-header-surface", "py-0", "align-middle", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-16)", "text-table-header-text"], {
  variants: {
    variant: {
      default: ["px-(--spacing-16)"],
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      spacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), rT = ae(["h-(--table-row-height)", "min-w-0", "px-(--spacing-16)", "py-0", "align-middle", "text-text-default"], {
  variants: {
    variant: {
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      text: null,
      doubleLine: null,
      chip: null,
      chipText: null,
      currency: ["font-(family-name:--font-family-label)"],
      icon: ["px-(--spacing-16)", "text-center"],
      button: null,
      toggle: null,
      dropdown: null,
      input: null,
      calendar: null,
      expand: ["px-(--spacing-16)", "text-center"],
      endingSpacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "text"
  }
});
function b4(t, e) {
  return t !== void 0 ? typeof t == "number" ? `${t}px` : t : e ? JI[e] : void 0;
}
function v4(t, e) {
  return e ? {
    ...t,
    width: e,
    minWidth: e
  } : t;
}
function y4(t) {
  if (t === "compact") return "@max-[480px]/data-table:hidden";
  if (t === "comfortable") return "@max-[768px]/data-table:hidden";
  if (t === "expanded") return "@max-[1024px]/data-table:hidden";
  if (t === "wide") return "@max-[1280px]/data-table:hidden";
}
function iT(t) {
  const e = W.c(11);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    style: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? "md" : r;
  let s;
  e[4] !== i ? (s = eT({
    size: i
  }), e[4] = i, e[5] = s) : s = e[5];
  let l;
  return e[6] !== n || e[7] !== i || e[8] !== o || e[9] !== s ? (l = /* @__PURE__ */ g("table", { "data-slot": "table", "data-size": i, className: s, style: o, ...n }), e[6] = n, e[7] = i, e[8] = o, e[9] = s, e[10] = l) : l = e[10], l;
}
function sT(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("thead", { "data-slot": "table-header", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function lT(t) {
  const e = W.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ g("tbody", { "data-slot": "table-body", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Vc(t) {
  const e = W.c(17);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    accentTone: n,
    selected: s,
    interactive: l,
    section: i,
    children: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? !1 : s, c = l === void 0 ? !1 : l, u = a ? "" : void 0, d = c ? "" : void 0, f = a || void 0;
  let p;
  e[7] !== n || e[8] !== i ? (p = oe(tT({
    section: i
  }), i !== "header" && n && nT({
    tone: n
  })), e[7] = n, e[8] = i, e[9] = p) : p = e[9];
  let m;
  return e[10] !== o || e[11] !== r || e[12] !== u || e[13] !== d || e[14] !== f || e[15] !== p ? (m = /* @__PURE__ */ g("tr", { "data-slot": "table-row", "data-selected": u, "data-interactive": d, "aria-selected": f, className: p, ...r, children: o }), e[10] = o, e[11] = r, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = m) : m = e[16], m;
}
function aT(t) {
  return t || "none";
}
function tg(t, e) {
  return t ? t === e ? "text-primary" : "text-icon-disabled" : "text-icon-main";
}
function cT(t) {
  const e = W.c(13), {
    direction: n
  } = t;
  let o;
  e[0] !== n ? (o = oe("absolute left-(--spacing-2) top-[3px] inline-flex", tg(n, "ascending")), e[0] = n, e[1] = o) : o = e[1];
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ g(Ge, { name: "chevron-up", size: "xs", tone: "inherit" }), e[2] = r) : r = e[2];
  let i;
  e[3] !== o ? (i = /* @__PURE__ */ g("span", { className: o, children: r }), e[3] = o, e[4] = i) : i = e[4];
  let s;
  e[5] !== n ? (s = oe("absolute left-(--spacing-2) top-[9px] inline-flex", tg(n, "descending")), e[5] = n, e[6] = s) : s = e[6];
  let l;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ g(Ge, { name: "chevron-down", size: "xs", tone: "inherit" }), e[7] = l) : l = e[7];
  let a;
  e[8] !== s ? (a = /* @__PURE__ */ g("span", { className: s, children: l }), e[8] = s, e[9] = a) : a = e[9];
  let c;
  return e[10] !== i || e[11] !== a ? (c = /* @__PURE__ */ F("span", { "aria-hidden": "true", className: "relative block h-[28px] w-(--spacing-20) shrink-0", children: [
    i,
    a
  ] }), e[10] = i, e[11] = a, e[12] = c) : c = e[12], c;
}
function uT(t) {
  const e = W.c(72);
  let n, o, r, i, s, l, a, c, u, d, f, p;
  e[0] !== t ? ({
    align: n,
    children: o,
    leadingCheckbox: i,
    sortable: c,
    sortDirection: u,
    tooltip: d,
    hideBelow: r,
    variant: f,
    width: p,
    style: a,
    onSort: s,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  const m = c === void 0 ? !1 : c, h = u === void 0 ? !1 : u;
  let b, v, C, y, w;
  if (e[13] !== n || e[14] !== o || e[15] !== r || e[16] !== i || e[17] !== s || e[18] !== h || e[19] !== m || e[20] !== a || e[21] !== d || e[22] !== f || e[23] !== p) {
    const S = b4(p);
    let E;
    e[29] !== d ? (E = d ? /* @__PURE__ */ g(qo, { label: d, showArrow: !1, children: /* @__PURE__ */ g("button", { type: "button", className: "inline-flex shrink-0 items-center border-0 bg-transparent p-0 text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", "aria-label": d, children: /* @__PURE__ */ g(Ge, { name: "circle-info", size: "xs", tone: "inherit" }) }) }) : null, e[29] = d, e[30] = E) : E = e[30];
    const N = E, I = n === "right" && "justify-end", T = n === "center" && "justify-center";
    let k;
    e[31] !== I || e[32] !== T ? (k = oe("flex min-w-0 items-center gap-(--spacing-8)", I, T), e[31] = I, e[32] = T, e[33] = k) : k = e[33];
    let P;
    e[34] !== o ? (P = /* @__PURE__ */ g("span", { className: "min-w-0 truncate", children: o }), e[34] = o, e[35] = P) : P = e[35];
    let M;
    e[36] !== h || e[37] !== m ? (M = m && /* @__PURE__ */ g(cT, { direction: h }), e[36] = h, e[37] = m, e[38] = M) : M = e[38];
    let D;
    e[39] !== k || e[40] !== P || e[41] !== M ? (D = /* @__PURE__ */ F("span", { className: k, children: [
      P,
      M
    ] }), e[39] = k, e[40] = P, e[41] = M, e[42] = D) : D = e[42];
    const O = D, _ = n === "right" && "justify-end", V = n === "center" && "justify-center";
    let A;
    e[43] !== _ || e[44] !== V ? (A = oe("flex min-w-0 items-center gap-(--spacing-12)", _, V), e[43] = _, e[44] = V, e[45] = A) : A = e[45];
    let L;
    e[46] !== i ? (L = i && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0", children: i }), e[46] = i, e[47] = L) : L = e[47];
    let $;
    e[48] !== n || e[49] !== O || e[50] !== s || e[51] !== m ? ($ = m ? /* @__PURE__ */ g("button", { type: "button", onClick: s, className: oe("flex h-full min-w-0 items-center bg-transparent p-0 text-inherit", "border-0 outline-none cursor-pointer", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", n === "right" && "justify-end", n === "center" && "justify-center"), children: O }) : O, e[48] = n, e[49] = O, e[50] = s, e[51] = m, e[52] = $) : $ = e[52];
    let Y;
    e[53] !== A || e[54] !== L || e[55] !== $ || e[56] !== N ? (Y = /* @__PURE__ */ F("span", { className: A, children: [
      L,
      $,
      N
    ] }), e[53] = A, e[54] = L, e[55] = $, e[56] = N, e[57] = Y) : Y = e[57], b = Y, v = "table-head", e[58] !== h || e[59] !== m ? (C = m ? aT(h) : void 0, e[58] = h, e[59] = m, e[60] = C) : C = e[60], e[61] !== n || e[62] !== r || e[63] !== f ? (y = oe(oT({
      variant: f
    }), h4({
      align: n
    }), y4(r)), e[61] = n, e[62] = r, e[63] = f, e[64] = y) : y = e[64], w = v4(a, S), e[13] = n, e[14] = o, e[15] = r, e[16] = i, e[17] = s, e[18] = h, e[19] = m, e[20] = a, e[21] = d, e[22] = f, e[23] = p, e[24] = b, e[25] = v, e[26] = C, e[27] = y, e[28] = w;
  } else
    b = e[24], v = e[25], C = e[26], y = e[27], w = e[28];
  let R;
  return e[65] !== b || e[66] !== l || e[67] !== v || e[68] !== C || e[69] !== y || e[70] !== w ? (R = /* @__PURE__ */ g("th", { "data-slot": v, "aria-sort": C, className: y, style: w, ...l, children: b }), e[65] = b, e[66] = l, e[67] = v, e[68] = C, e[69] = y, e[70] = w, e[71] = R) : R = e[71], R;
}
function dT(t) {
  const e = W.c(31);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    align: n,
    variant: a,
    hideBelow: r,
    width: c,
    style: s,
    children: o,
    emptyFallback: l,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = l === void 0 ? "--" : l, d = a ?? "text";
  let f, p, m, h, b;
  if (e[9] !== n || e[10] !== o || e[11] !== r || e[12] !== d || e[13] !== s || e[14] !== c) {
    const y = b4(c, d);
    f = o == null || typeof o == "string" && o.trim() === "", p = "table-cell", m = d, e[20] !== n || e[21] !== r || e[22] !== d ? (h = oe(rT({
      variant: d
    }), h4({
      align: n
    }), y4(r)), e[20] = n, e[21] = r, e[22] = d, e[23] = h) : h = e[23], b = v4(s, y), e[9] = n, e[10] = o, e[11] = r, e[12] = d, e[13] = s, e[14] = c, e[15] = f, e[16] = p, e[17] = m, e[18] = h, e[19] = b;
  } else
    f = e[15], p = e[16], m = e[17], h = e[18], b = e[19];
  const v = d === "endingSpacer" ? null : f ? u : o;
  let C;
  return e[24] !== i || e[25] !== p || e[26] !== m || e[27] !== h || e[28] !== b || e[29] !== v ? (C = /* @__PURE__ */ g("td", { "data-slot": p, "data-variant": m, className: h, style: b, ...i, children: v }), e[24] = i, e[25] = p, e[26] = m, e[27] = h, e[28] = b, e[29] = v, e[30] = C) : C = e[30], C;
}
function x4(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("div", { className: "flex min-w-0 flex-col gap-(--spacing-2)", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function f1(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-medium) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function p1(t) {
  const e = W.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ g("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-small) font-(number:--font-weight-regular) leading-(--font-line-height-16) text-text-subtext", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function fT(t) {
  const e = W.c(15), {
    status: n,
    checkbox: o,
    thumbnail: r,
    avatar: i,
    icon: s,
    primary: l,
    secondary: a,
    chip: c
  } = t;
  let u;
  e[0] !== l ? (u = /* @__PURE__ */ g(f1, { children: l }), e[0] = l, e[1] = u) : u = e[1];
  let d;
  e[2] !== c || e[3] !== a ? (d = (a || c) && /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-4) pt-(--spacing-4)", children: [
    a && /* @__PURE__ */ g(p1, { children: a }),
    c && /* @__PURE__ */ g("span", { className: "shrink-0", children: c })
  ] }), e[2] = c, e[3] = a, e[4] = d) : d = e[4];
  let f;
  e[5] !== u || e[6] !== d ? (f = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-col justify-center", children: [
    u,
    d
  ] }), e[5] = u, e[6] = d, e[7] = f) : f = e[7];
  let p;
  return e[8] !== i || e[9] !== o || e[10] !== s || e[11] !== n || e[12] !== f || e[13] !== r ? (p = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    n,
    o,
    r,
    i,
    s,
    f
  ] }), e[8] = i, e[9] = o, e[10] = s, e[11] = n, e[12] = f, e[13] = r, e[14] = p) : p = e[14], p;
}
function pT(t) {
  const e = W.c(15), {
    leadingIcon: n,
    main: o,
    supporting: r,
    trailingIcon: i
  } = t;
  let s;
  e[0] !== n ? (s = n && /* @__PURE__ */ g("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = /* @__PURE__ */ g(f1, { children: o }), e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== r ? (a = r && /* @__PURE__ */ g(p1, { children: r }), e[4] = r, e[5] = a) : a = e[5];
  let c;
  e[6] !== l || e[7] !== a ? (c = /* @__PURE__ */ F(x4, { children: [
    l,
    a
  ] }), e[6] = l, e[7] = a, e[8] = c) : c = e[8];
  let u;
  e[9] !== i ? (u = i && /* @__PURE__ */ g("span", { className: "shrink-0", children: i }), e[9] = i, e[10] = u) : u = e[10];
  let d;
  return e[11] !== s || e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    s,
    c,
    u
  ] }), e[11] = s, e[12] = c, e[13] = u, e[14] = d) : d = e[14], d;
}
function mT(t) {
  const e = W.c(7), {
    chip: n,
    secondary: o
  } = t;
  let r;
  e[0] !== n ? (r = /* @__PURE__ */ g("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = r) : r = e[1];
  let i;
  e[2] !== o ? (i = o && /* @__PURE__ */ g("span", { className: "min-w-0 truncate text-text-subtext", children: o }), e[2] = o, e[3] = i) : i = e[3];
  let s;
  return e[4] !== r || e[5] !== i ? (s = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    r,
    i
  ] }), e[4] = r, e[5] = i, e[6] = s) : s = e[6], s;
}
const ng = Object.assign(dT, {
  ChipText: mT,
  Primary: f1,
  Secondary: p1,
  Stack: x4,
  Starting: fT,
  Text: pT
});
function gT(t) {
  return t === "asc" ? "ascending" : t === "desc" ? "descending" : !1;
}
function hT() {
  return import.meta.env?.DEV ?? !1;
}
function OD({
  ariaLabel: t,
  columns: e,
  data: n,
  size: o = "md",
  getRowId: r,
  sorting: i,
  onSortingChange: s,
  manualSorting: l = !1,
  rowSelection: a,
  onRowSelectionChange: c,
  enableRowSelection: u,
  getRowAccentTone: d,
  pagination: f,
  manualPagination: p = !1,
  emptyMessage: m = "No results.",
  variant: h = "fullWidth"
}) {
  const b = u ?? !!(a || c), v = {
    ...i !== void 0 ? {
      sorting: i
    } : {},
    ...a !== void 0 ? {
      rowSelection: a
    } : {},
    ...f !== void 0 ? {
      pagination: {
        pageIndex: Math.max(0, f.currentPage - 1),
        pageSize: f.rowsPerPage
      }
    } : {}
  }, C = QI({
    data: n,
    columns: e,
    defaultColumn: {
      enableSorting: !1
    },
    getRowId: r,
    state: v,
    enableRowSelection: b,
    onSortingChange: s,
    onRowSelectionChange: c,
    manualSorting: l,
    manualPagination: p,
    getCoreRowModel: GI(),
    ...l ? {} : {
      getSortedRowModel: KI()
    },
    ...f !== void 0 && !p ? {
      getPaginationRowModel: jI()
    } : {},
    ...f !== void 0 ? {
      pageCount: f.totalPages
    } : {}
  }), y = C.getVisibleLeafColumns(), w = y[0], R = w?.columnDef.meta;
  return hT() && w && R?.cellVariant !== "starting" && console.warn("DataTable expects the first visible column to use meta.cellVariant = 'starting' to match the table design-system contract."), /* @__PURE__ */ F("div", { "data-slot": "data-table", "data-variant": h, className: oe("@container/data-table w-full", h === "card" && ["overflow-hidden", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"]), children: [
    /* @__PURE__ */ g("div", { "data-slot": "data-table-scroll", className: "w-full overflow-x-auto bg-table-row-light-surface pb-(--spacing-8)", children: /* @__PURE__ */ F(iT, { size: o, "aria-label": t, children: [
      /* @__PURE__ */ g(sT, { children: C.getHeaderGroups().map((S) => /* @__PURE__ */ g(Vc, { section: "header", children: S.headers.map((E) => {
        const N = E.column.columnDef.meta, I = E.column.getCanSort(), T = E.column.getToggleSortingHandler(), k = N?.cellVariant === "starting", P = E.column.id === w?.id, M = b && k && P && !E.isPlaceholder, D = C.getIsAllPageRowsSelected(), O = C.getIsSomePageRowsSelected();
        return /* @__PURE__ */ g(uT, { colSpan: E.colSpan, scope: "col", align: N?.headerAlign ?? N?.align, variant: k ? "starting" : void 0, width: N?.width, tooltip: N?.tooltip, hideBelow: N?.hideBelow, leadingCheckbox: M ? /* @__PURE__ */ g(MR, { "aria-label": "Select all visible rows", checked: D, indeterminate: O && !D, onCheckedChange: (_) => C.toggleAllPageRowsSelected(!!_) }) : void 0, sortable: I, sortDirection: gT(E.column.getIsSorted()), onSort: I && T ? (_) => T(_) : void 0, children: E.isPlaceholder ? null : eg(E.column.columnDef.header, E.getContext()) }, E.id);
      }) }, S.id)) }),
      /* @__PURE__ */ g(lT, { children: C.getRowModel().rows.length > 0 ? C.getRowModel().rows.map((S) => /* @__PURE__ */ g(Vc, { accentTone: d?.(S.original), selected: S.getIsSelected(), children: S.getVisibleCells().map((E) => {
        const N = E.column.columnDef.meta;
        return /* @__PURE__ */ g(ng, { variant: N?.cellVariant, align: N?.align, width: N?.width, hideBelow: N?.hideBelow, "data-hide-below": N?.hideBelow, children: eg(E.column.columnDef.cell, E.getContext()) }, E.id);
      }) }, S.id)) : /* @__PURE__ */ g(Vc, { children: /* @__PURE__ */ g(ng, { colSpan: y.length, emptyFallback: null, children: /* @__PURE__ */ g("div", { className: "flex h-(--table-row-height) items-center justify-center text-text-subtext", children: m }) }) }) })
    ] }) }),
    f && /* @__PURE__ */ g("div", { "data-slot": "data-table-pagination", className: oe(h === "card" && "bg-table-row-light-surface"), children: /* @__PURE__ */ g(QM, { ...f }) })
  ] });
}
const bT = ["flex", "flex-row", "items-center", "border-b", "border-outline-variant"].join(" ");
function DD({
  children: t,
  inset: e = !1,
  ...n
}) {
  const {
    onScroll: o,
    ref: r,
    ...i
  } = n, s = ut(null), l = ut(() => {
  }), [a, c] = tt(!1), [u, d] = tt(!1);
  l.current = function() {
    const h = s.current;
    if (!h) {
      c(!1), d(!1);
      return;
    }
    const b = h.scrollWidth > h.clientWidth;
    c(b && h.scrollLeft > 0), d(b && h.scrollLeft + h.clientWidth < h.scrollWidth - 1);
  };
  function f(m) {
    s.current = m, typeof r == "function" ? r(m) : r && (r.current = m);
  }
  Po(() => {
    l.current();
  }), Po(() => {
    const m = s.current;
    if (!m || typeof ResizeObserver > "u")
      return;
    const h = new ResizeObserver(() => {
      l.current();
    });
    h.observe(m);
    for (const v of m.children)
      h.observe(v);
    const b = new MutationObserver(() => {
      for (const v of m.children)
        h.observe(v);
      l.current();
    });
    return b.observe(m, {
      childList: !0
    }), () => {
      h.disconnect(), b.disconnect();
    };
  }, []);
  function p(m) {
    l.current(), o?.(m);
  }
  return /* @__PURE__ */ F("div", { className: "relative", children: [
    /* @__PURE__ */ g(n1, { ...i, ref: f, onScroll: p, className: oe(bT, "overflow-x-auto", e && "px-(--spacing-24)"), children: t }),
    a && /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-slot": "tabs-overflow-gradient-left", className: "pointer-events-none absolute inset-y-0 left-0 z-10 w-[24px] bg-linear-to-r from-surface to-transparent" }),
    u && /* @__PURE__ */ g("div", { "aria-hidden": "true", "data-slot": "tabs-overflow-gradient-right", className: "pointer-events-none absolute inset-y-0 right-0 z-10 w-[24px] bg-linear-to-l from-surface to-transparent" })
  ] });
}
const vT = [
  // Layout
  "inline-flex",
  "flex-row",
  "items-center",
  "gap-(--spacing-8)",
  "px-(--spacing-12)",
  "py-(--spacing-6)",
  "rounded-tl-(--radius-sm)",
  "rounded-tr-(--radius-sm)",
  // Typography base
  "font-(family-name:--font-family-body)",
  "text-(length:--font-size-body-large)",
  "leading-(--font-line-height-24)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "outline-none",
  "cursor-pointer",
  "select-none",
  "relative",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Hover state (pointer devices only, not on disabled)
  "not-data-[disabled]:hover:bg-surface-hover",
  // Pressed state
  "not-data-[disabled]:active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-button-focus-ring",
  // Disabled state
  "data-[disabled]:opacity-50",
  "data-[disabled]:pointer-events-none",
  "data-[disabled]:cursor-default"
].join(" "), yT = ["text-text-subtext", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-(--spacing-2)", "after:translate-y-px", "after:bg-transparent", "after:transition-colors", "after:duration-200", "after:ease-in-out", "group", "data-[active]:text-text-default", "data-[active]:after:bg-primary"].join(" ");
function _D(t) {
  const e = W.c(18);
  let n, o, r, i;
  e[0] !== t ? ({
    icon: r,
    chipLabel: o,
    children: n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = oe(vT, yT), e[5] = s) : s = e[5];
  let l;
  e[6] !== r ? (l = r && /* @__PURE__ */ g(Ge, { name: r, size: "sm", tone: "inherit" }), e[6] = r, e[7] = l) : l = e[7];
  const a = typeof n == "string" ? n : void 0;
  let c;
  e[8] !== n || e[9] !== a ? (c = /* @__PURE__ */ g("span", { "data-text": a, className: "relative flex flex-col items-center group-data-[active]:font-semibold before:content-[attr(data-text)] before:font-semibold before:invisible before:h-0 before:overflow-hidden before:pointer-events-none", children: n }), e[8] = n, e[9] = a, e[10] = c) : c = e[10];
  let u;
  e[11] !== o ? (u = o != null && /* @__PURE__ */ g(fo, { tone: "neutral", label: o, "aria-hidden": !0 }), e[11] = o, e[12] = u) : u = e[12];
  let d;
  return e[13] !== i || e[14] !== l || e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ F(t1, { className: s, ...i, children: [
    l,
    c,
    u
  ] }), e[13] = i, e[14] = l, e[15] = c, e[16] = u, e[17] = d) : d = e[17], d;
}
function VD(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(Bb, { className: "outline-none", ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function AD(t) {
  const e = W.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ g(Qf, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
const xT = ae("text-surface-on-surface", {
  variants: {
    tone: {
      base: ["bg-surface-container-lowest"],
      muted: ["bg-surface-container-low"],
      neutral: ["bg-surface-container"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    },
    padding: {
      none: "p-0",
      dense: "px-(--spacing-8) py-(--spacing-10)",
      compact: "p-(--spacing-12)",
      comfortable: "px-(--spacing-20) py-(--spacing-16)"
    },
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    },
    aspect: {
      auto: null,
      square: "aspect-square"
    },
    centered: {
      true: "grid place-items-center",
      false: null
    },
    width: {
      auto: null,
      content: "w-fit",
      full: "w-full"
    }
  },
  defaultVariants: {
    tone: "base",
    padding: "comfortable",
    radius: "sm",
    aspect: "auto",
    centered: !1,
    width: "auto"
  }
});
function LD(t) {
  const e = W.c(28);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    tone: r,
    padding: i,
    radius: s,
    aspect: l,
    centered: a,
    width: c,
    hasBorder: u,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = r === void 0 ? "base" : r, f = i === void 0 ? "comfortable" : i, p = s === void 0 ? "sm" : s, m = l === void 0 ? "auto" : l, h = a === void 0 ? !1 : a, b = c === void 0 ? "auto" : c, v = u === void 0 ? !1 : u, C = h || void 0;
  let y;
  e[10] !== m || e[11] !== h || e[12] !== v || e[13] !== f || e[14] !== p || e[15] !== d || e[16] !== b ? (y = oe(xT({
    tone: d,
    padding: f,
    radius: p,
    aspect: m,
    centered: h,
    width: b
  }), v && "border border-outline-subtle", "shadow-elevation-1"), e[10] = m, e[11] = h, e[12] = v, e[13] = f, e[14] = p, e[15] = d, e[16] = b, e[17] = y) : y = e[17];
  let w;
  return e[18] !== m || e[19] !== n || e[20] !== f || e[21] !== o || e[22] !== p || e[23] !== C || e[24] !== y || e[25] !== d || e[26] !== b ? (w = /* @__PURE__ */ g("div", { "data-slot": "tile", "data-tone": d, "data-padding": f, "data-radius": p, "data-aspect": m, "data-centered": C, "data-width": b, className: y, ...o, children: n }), e[18] = m, e[19] = n, e[20] = f, e[21] = o, e[22] = p, e[23] = C, e[24] = y, e[25] = d, e[26] = b, e[27] = w) : w = e[27], w;
}
function C4(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM";
  return `${e === 0 ? 12 : e > 12 ? e - 12 : e}:${String(n).padStart(2, "0")} ${o}`;
}
function _s(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM", r = e === 0 ? 12 : e > 12 ? e - 12 : e;
  return {
    hour: String(r).padStart(2, "0"),
    minute: String(n).padStart(2, "0"),
    period: o
  };
}
function CT(t) {
  const e = Number(t.hour);
  let n = t.period === "PM" ? e + 12 : e;
  return t.period === "AM" && e === 12 && (n = 0), t.period === "PM" && e === 12 && (n = 12), `${String(n).padStart(2, "0")}:${t.minute}`;
}
function og(t) {
  const e = t.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!e) return null;
  let n = parseInt(e[1], 10);
  const o = parseInt(e[2], 10), r = e[3].toUpperCase();
  return n < 1 || n > 12 || o < 0 || o > 59 ? null : (r === "AM" ? n === 12 && (n = 0) : n !== 12 && (n += 12), `${String(n).padStart(2, "0")}:${String(o).padStart(2, "0")}`);
}
function wT(t, e, n) {
  const o = [];
  for (let r = 0; r < 1440; r += t) {
    const i = Math.floor(r / 60), s = r % 60, l = `${String(i).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    e && l < e || n && l > n || o.push({
      value: l,
      label: C4(l)
    });
  }
  return o;
}
function ST(t, e) {
  const n = /* @__PURE__ */ new Set();
  return t.forEach((o) => {
    const r = _s(o.value);
    n.add(r[e]);
  }), [...n];
}
function RT(t, e) {
  const n = _s(t.value);
  return n.hour === e.hour && n.minute === e.minute && n.period === e.period;
}
function ET({
  options: t,
  currentParts: e,
  column: n,
  partValue: o
}) {
  const r = {
    ...e,
    [n]: o
  }, i = t.find((s) => RT(s, r));
  return i ? i.value : t.find((s) => _s(s.value)[n] === o)?.value ?? t[0]?.value ?? CT(r);
}
function NT(t, e) {
  return _s(t?.value ?? e[0]?.value ?? "00:00");
}
function Ac({
  options: t,
  currentParts: e,
  column: n
}) {
  return ST(t, n).map((o) => ({
    kind: n,
    value: `${n}-${o}`,
    label: o,
    partValue: o,
    nextValue: ET({
      options: t,
      currentParts: e,
      column: n,
      partValue: o
    })
  }));
}
const kT = ae(["flex", "items-center", "gap-(--spacing-4)", "w-[228px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function w4(t, e) {
  return e[t.kind] === t.partValue;
}
function MT(t, e) {
  return t.kind === "time" && e.kind === "time" ? t.value === e.value : t.kind !== "time" && e.kind === "time" ? w4(t, _s(e.value)) : t.value === e.value;
}
function Lc(t) {
  const e = W.c(19), {
    option: n,
    selectedParts: o
  } = t;
  let r, i, s, l, a;
  e[0] !== n || e[1] !== o ? (i = w4(n, o), r = Is, s = n, l = `${n.kind} ${n.label}`, a = oe(Ko({}), "justify-center px-(--spacing-8)", i && "bg-menu-item-selected"), e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = s, e[5] = l, e[6] = a) : (r = e[2], i = e[3], s = e[4], l = e[5], a = e[6]);
  let c;
  e[7] !== n.label ? (c = /* @__PURE__ */ g("span", { className: "min-w-0 flex-1 text-center", children: n.label }), e[7] = n.label, e[8] = c) : c = e[8];
  let u;
  e[9] !== n.kind || e[10] !== i ? (u = i && n.kind === "period" && /* @__PURE__ */ g("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ g(Ge, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[9] = n.kind, e[10] = i, e[11] = u) : u = e[11];
  let d;
  return e[12] !== r || e[13] !== s || e[14] !== l || e[15] !== a || e[16] !== c || e[17] !== u ? (d = /* @__PURE__ */ F(r, { value: s, "aria-label": l, className: a, children: [
    c,
    u
  ] }), e[12] = r, e[13] = s, e[14] = l, e[15] = a, e[16] = c, e[17] = u, e[18] = d) : d = e[18], d;
}
function Fc() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("div", { "aria-hidden": "true", className: "h-[36px]" }), t[0] = e) : e = t[0], e;
}
function FD(t) {
  const e = W.c(83), {
    value: n,
    onValueChange: o,
    id: r,
    label: i,
    placeholder: s,
    size: l,
    required: a,
    description: c,
    tooltip: u,
    error: d,
    disabled: f,
    minuteStep: p,
    minTime: m,
    maxTime: h,
    name: b,
    "data-testid": v
  } = t, C = s === void 0 ? "--:--" : s, y = l === void 0 ? "md" : l, w = f === void 0 ? !1 : f, R = p === void 0 ? 15 : p, S = Qt(), [E, N] = tt(!1), I = Xt(), T = r ?? I, k = Xt(), P = !!d;
  let M, D, O, _;
  if (e[0] !== h || e[1] !== m || e[2] !== R || e[3] !== n) {
    M = wT(R, m, h), D = n ? {
      ...M.find((ve) => ve.value === n) ?? {
        value: n,
        label: C4(n)
      },
      kind: "time"
    } : null, O = NT(D, M);
    const ue = {
      hour: Ac({
        options: M,
        currentParts: O,
        column: "hour"
      }),
      minute: Ac({
        options: M,
        currentParts: O,
        column: "minute"
      }),
      period: Ac({
        options: M,
        currentParts: O,
        column: "period"
      })
    }, Se = Math.max(ue.hour.length, ue.minute.length, ue.period.length);
    _ = Array.from({
      length: Se
    }, (ve, de) => ({
      hour: ue.hour[de],
      minute: ue.minute[de],
      period: ue.period[de]
    })), e[0] = h, e[1] = m, e[2] = R, e[3] = n, e[4] = M, e[5] = D, e[6] = O, e[7] = _;
  } else
    M = e[4], D = e[5], O = e[6], _ = e[7];
  const V = _;
  let A;
  e[8] !== M || e[9] !== o || e[10] !== n ? (A = function(Se) {
    const ve = og(Se.currentTarget.value);
    ve !== null && ve !== n && M.some((de) => de.value === ve) && o(ve);
  }, e[8] = M, e[9] = o, e[10] = n, e[11] = A) : A = e[11];
  const L = A;
  let $;
  e[12] !== M || e[13] !== o || e[14] !== n ? ($ = function(Se) {
    const ve = Se.currentTarget.value.trim();
    if (ve === "") {
      n !== null && o(null);
      return;
    }
    const de = og(ve);
    de !== null && de !== n && M.some((me) => me.value === de) && o(de);
  }, e[12] = M, e[13] = o, e[14] = n, e[15] = $) : $ = e[15];
  const Y = $;
  let G;
  e[16] !== o ? (G = function(Se) {
    if (Se === null) {
      o(null);
      return;
    }
    o(Se.kind === "time" ? Se.value : Se.nextValue);
  }, e[16] = o, e[17] = G) : G = e[17];
  const j = G, Z = w && "pointer-events-none";
  let U;
  e[18] !== Z ? (U = oe("flex flex-col w-fit", Z), e[18] = Z, e[19] = U) : U = e[19];
  let q;
  e[20] !== T || e[21] !== i || e[22] !== a || e[23] !== u ? (q = i && /* @__PURE__ */ g(pi, { htmlFor: T, label: i, required: a, tooltip: u }), e[20] = T, e[21] = i, e[22] = a, e[23] = u, e[24] = q) : q = e[24];
  let te;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (te = (ue, Se) => {
    N(!ue && Se.reason === "item-press" ? !0 : ue);
  }, e[25] = te) : te = e[25];
  let H;
  e[26] !== w || e[27] !== P || e[28] !== y ? (H = oe(kT({
    size: y,
    hasError: P
  }), w && "opacity-50"), e[26] = w, e[27] = P, e[28] = y, e[29] = H) : H = e[29];
  const X = i ? void 0 : "Choose time", ee = a || void 0, le = P || void 0, Q = c || d ? k : void 0, re = P && "text-input-error-text";
  let fe;
  e[30] !== re ? (fe = oe("flex-1", "min-w-0", "outline-none", "bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-input-text-placeholder", re), e[30] = re, e[31] = fe) : fe = e[31];
  let ne;
  e[32] !== v || e[33] !== Y || e[34] !== L || e[35] !== T || e[36] !== C || e[37] !== X || e[38] !== ee || e[39] !== le || e[40] !== Q || e[41] !== fe ? (ne = /* @__PURE__ */ g(Ms, { id: T, "data-testid": v, placeholder: C, "aria-autocomplete": "list", "aria-label": X, "aria-required": ee, "aria-invalid": le, "aria-describedby": Q, onChange: L, onBlur: Y, className: fe }), e[32] = v, e[33] = Y, e[34] = L, e[35] = T, e[36] = C, e[37] = X, e[38] = ee, e[39] = le, e[40] = Q, e[41] = fe, e[42] = ne) : ne = e[42];
  let se;
  e[43] !== w || e[44] !== D ? (se = D !== null && !w && /* @__PURE__ */ g(If, { "aria-label": "Clear time", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: /* @__PURE__ */ g(Ge, { name: "x-close", size: "xs", tone: "inherit" }) }), e[43] = w, e[44] = D, e[45] = se) : se = e[45];
  let pe;
  e[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (pe = /* @__PURE__ */ g(ya, { "aria-label": "Open time picker", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: /* @__PURE__ */ g(Ge, { name: "clock-seven", size: "xs", tone: "secondary" }) }), e[46] = pe) : pe = e[46];
  let xe;
  e[47] !== se ? (xe = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    se,
    pe
  ] }), e[47] = se, e[48] = xe) : xe = e[48];
  let ce;
  e[49] !== H || e[50] !== ne || e[51] !== xe ? (ce = /* @__PURE__ */ F(va, { className: H, children: [
    ne,
    xe
  ] }), e[49] = H, e[50] = ne, e[51] = xe, e[52] = ce) : ce = e[52];
  let he;
  e[53] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (he = ys({
    size: "auto",
    className: "w-[228px]"
  }), e[53] = he) : he = e[53];
  let z;
  e[54] !== V || e[55] !== O ? (z = /* @__PURE__ */ g(Ca, { sideOffset: 4, className: "w-(--anchor-width)", children: /* @__PURE__ */ g(wa, { className: he, children: /* @__PURE__ */ g(Ps, { "aria-label": "Select a time", className: "flex flex-col gap-(--spacing-2) outline-none", children: V.map((ue) => /* @__PURE__ */ F(D0, { className: "grid grid-cols-3 gap-(--spacing-2)", children: [
    ue.hour ? /* @__PURE__ */ g(Lc, { option: ue.hour, selectedParts: O }) : /* @__PURE__ */ g(Fc, {}),
    ue.minute ? /* @__PURE__ */ g(Lc, { option: ue.minute, selectedParts: O }) : /* @__PURE__ */ g(Fc, {}),
    ue.period ? /* @__PURE__ */ g(Lc, { option: ue.period, selectedParts: O }) : /* @__PURE__ */ g(Fc, {})
  ] }, [ue.hour?.value ?? "empty-hour", ue.minute?.value ?? "empty-minute", ue.period?.value ?? "empty-period"].join("-"))) }) }) }), e[54] = V, e[55] = O, e[56] = z) : z = e[56];
  let J;
  e[57] !== S || e[58] !== z ? (J = /* @__PURE__ */ g(xa, { container: S, children: z }), e[57] = S, e[58] = z, e[59] = J) : J = e[59];
  let B;
  e[60] !== w || e[61] !== j || e[62] !== b || e[63] !== E || e[64] !== a || e[65] !== D || e[66] !== ce || e[67] !== J ? (B = /* @__PURE__ */ F(bf, { open: E, onOpenChange: te, value: D, onValueChange: j, isItemEqualToValue: MT, itemToStringLabel: IT, itemToStringValue: PT, disabled: w, required: a, name: b, grid: !0, filter: null, autoComplete: "none", children: [
    ce,
    J
  ] }), e[60] = w, e[61] = j, e[62] = b, e[63] = E, e[64] = a, e[65] = D, e[66] = ce, e[67] = J, e[68] = B) : B = e[68];
  let K;
  e[69] !== c || e[70] !== k || e[71] !== d || e[72] !== P ? (K = P ? /* @__PURE__ */ g(Ir, { match: !0, id: k, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-error-text", children: d }) : c ? /* @__PURE__ */ g(di, { id: k, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting", children: c }) : null, e[69] = c, e[70] = k, e[71] = d, e[72] = P, e[73] = K) : K = e[73];
  let ie;
  e[74] !== K ? (ie = /* @__PURE__ */ g("div", { "data-testid": "time-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: K }), e[74] = K, e[75] = ie) : ie = e[75];
  let ge;
  return e[76] !== w || e[77] !== P || e[78] !== U || e[79] !== q || e[80] !== B || e[81] !== ie ? (ge = /* @__PURE__ */ F(Pr, { invalid: P, disabled: w, className: U, children: [
    q,
    B,
    ie
  ] }), e[76] = w, e[77] = P, e[78] = U, e[79] = q, e[80] = B, e[81] = ie, e[82] = ge) : ge = e[82], ge;
}
function PT(t) {
  return t.kind === "time" ? t.value : t.nextValue;
}
function IT(t) {
  return t.label;
}
const Ta = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ta.displayName = "ToastContext");
function m1() {
  const t = x.useContext(Ta);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : et(73));
  return t;
}
let rg = 0;
function S4(t) {
  return rg += 1, `${t}-${Math.random().toString(36).slice(2, 6)}-${rg}`;
}
function $c(t, e) {
  if (typeof t == "string")
    return {
      description: t
    };
  if (typeof t == "function") {
    const n = t(e);
    return typeof n == "string" ? {
      description: n
    } : n;
  }
  return t;
}
const ml = r6((t) => t.toasts, (t) => {
  const e = /* @__PURE__ */ new Map();
  let n = 0, o = 0;
  return t.forEach((r, i) => {
    const s = r.transitionStatus === "ending";
    e.set(r.id, {
      value: r,
      domIndex: i,
      visibleIndex: s ? -1 : n,
      offsetY: o
    }), o += r.height || 0, s || (n += 1);
  }), e;
}), ro = {
  toasts: be((t) => t.toasts),
  isEmpty: be((t) => t.toasts.length === 0),
  toast: be(ml, (t, e) => t.get(e)?.value),
  toastIndex: be(ml, (t, e) => t.get(e)?.domIndex ?? -1),
  toastOffsetY: be(ml, (t, e) => t.get(e)?.offsetY ?? 0),
  toastVisibleIndex: be(ml, (t, e) => t.get(e)?.visibleIndex ?? -1),
  hovering: be((t) => t.hovering),
  focused: be((t) => t.focused),
  expanded: be((t) => t.hovering || t.focused),
  expandedOrOutOfFocus: be((t) => t.hovering || t.focused || !t.isWindowFocused),
  prevFocusElement: be((t) => t.prevFocusElement)
};
class TT extends wr {
  timers = /* @__PURE__ */ new Map();
  areTimersPaused = !1;
  constructor(e) {
    super(e, {}, ro);
  }
  setFocused(e) {
    this.set("focused", e);
  }
  setHovering(e) {
    this.set("hovering", e);
  }
  setIsWindowFocused(e) {
    this.set("isWindowFocused", e);
  }
  setPrevFocusElement(e) {
    this.set("prevFocusElement", e);
  }
  setViewport = (e) => {
    this.set("viewport", e);
  };
  disposeEffect = () => () => {
    this.timers.forEach((e) => {
      e.timeout?.clear();
    }), this.timers.clear();
  };
  removeToast(e, n = {}) {
    const o = ro.toastIndex(this.state, e);
    if (o === -1)
      return;
    const r = this.state.toasts[o];
    n.skipOnRemove || r?.onRemove?.();
    const i = [...this.state.toasts];
    i.splice(o, 1), this.setToasts(i);
  }
  addToast = (e) => {
    const {
      timeout: n,
      limit: o
    } = this.state, r = e.id || S4("toast");
    if (e.id) {
      const c = ro.toast(this.state, e.id);
      if (c)
        if (c.transitionStatus === "ending")
          this.removeToast(e.id, {
            skipOnRemove: !0
          });
        else {
          const {
            id: u,
            transitionStatus: d,
            ...f
          } = e;
          return this.updateToastInternal(e.id, f, {
            resetTimer: !0,
            markUpdated: !0
          }), e.id;
        }
    }
    const i = {
      ...e,
      id: r,
      updateKey: 0,
      transitionStatus: "starting"
    }, s = [i, ...this.state.toasts], l = s.filter((c) => c.transitionStatus !== "ending");
    if (l.length > o) {
      const c = l.length - o, u = l.slice(-c), d = new Set(u.map((f) => f.id));
      this.setToasts(s.map((f) => {
        const p = d.has(f.id);
        return f.limited !== p ? {
          ...f,
          limited: p
        } : f;
      }));
    } else
      this.setToasts(s.map((c) => c.limited ? {
        ...c,
        limited: !1
      } : c));
    const a = i.timeout ?? n;
    return i.type !== "loading" && a > 0 && this.scheduleTimer(r, a, () => this.closeToast(r)), ro.expandedOrOutOfFocus(this.state) && this.pauseTimers(), r;
  };
  updateToast = (e, n) => {
    this.updateToastInternal(e, n, {
      markUpdated: !0
    });
  };
  updateToastInternal = (e, n, o = {}) => {
    const {
      timeout: r,
      toasts: i
    } = this.state, s = ro.toast(this.state, e) ?? null;
    if (!s || s.transitionStatus === "ending")
      return;
    const l = {
      ...s,
      ...n,
      ...o.markUpdated && {
        updateKey: (s.updateKey ?? 0) + 1
      }
    };
    this.setToasts(i.map((h) => h.id === e ? l : h));
    const a = l.timeout ?? r, c = s?.timeout ?? r, u = Object.hasOwn(n, "timeout"), d = l.transitionStatus !== "ending" && l.type !== "loading" && a > 0, f = this.timers.has(e), p = c !== a, m = s?.type === "loading";
    if (!d && f) {
      this.timers.get(e)?.timeout?.clear(), this.timers.delete(e);
      return;
    }
    if (d && (!f || p || u || m || o.resetTimer)) {
      const h = this.timers.get(e);
      h && (h.timeout?.clear(), this.timers.delete(e)), this.scheduleTimer(e, a, () => this.closeToast(e)), ro.expandedOrOutOfFocus(this.state) && this.pauseTimers();
    }
  };
  closeToast = (e) => {
    const n = e === void 0, {
      limit: o,
      toasts: r
    } = this.state;
    let i;
    if (n)
      i = r, this.timers.forEach((c) => {
        c.timeout?.clear();
      }), this.timers.clear();
    else {
      const c = ro.toast(this.state, e);
      if (!c)
        return;
      i = [c];
      const u = this.timers.get(e);
      u?.timeout && (u.timeout.clear(), this.timers.delete(e));
    }
    let s = 0;
    const a = {
      toasts: r.map((c) => {
        if (n || c.id === e)
          return {
            ...c,
            transitionStatus: "ending",
            height: 0
          };
        if (c.transitionStatus === "ending")
          return c;
        const u = s >= o;
        return s += 1, c.limited !== u ? {
          ...c,
          limited: u
        } : c;
      })
    };
    (n || r.length === 1) && (a.hovering = !1, a.focused = !1), this.update(a), i.forEach((c) => {
      c.transitionStatus !== "ending" && c.onClose?.();
    }), this.handleFocusManagement(e);
  };
  promiseToast = (e, n) => {
    const o = $c(n.loading), r = this.addToast({
      ...o,
      type: "loading"
    }), i = e.then((s) => {
      const l = $c(n.success, s);
      return this.updateToast(r, {
        ...l,
        type: "success",
        timeout: l.timeout
      }), s;
    }).catch((s) => {
      const l = $c(n.error, s);
      return this.updateToast(r, {
        ...l,
        type: "error",
        timeout: l.timeout
      }), Promise.reject(s);
    });
    return {}.hasOwnProperty.call(n, "setPromise") && n.setPromise(i), i;
  };
  pauseTimers() {
    this.areTimersPaused || (this.areTimersPaused = !0, this.timers.forEach((e) => {
      if (e.timeout) {
        e.timeout.clear();
        const n = Date.now() - e.start, o = e.delay - n;
        e.remaining = o > 0 ? o : 0;
      }
    }));
  }
  resumeTimers() {
    this.areTimersPaused && (this.areTimersPaused = !1, this.timers.forEach((e, n) => {
      e.remaining = e.remaining > 0 ? e.remaining : e.delay, e.timeout ??= xn.create(), e.timeout.start(e.remaining, () => {
        this.timers.delete(n), e.callback();
      }), e.start = Date.now();
    }));
  }
  restoreFocusToPrevElement() {
    this.state.prevFocusElement?.focus({
      preventScroll: !0
    });
  }
  handleDocumentPointerDown = (e) => {
    if (e.pointerType !== "touch")
      return;
    const n = bt(e);
    Fe(this.state.viewport, n) || (this.resumeTimers(), this.update({
      hovering: !1,
      focused: !1
    }));
  };
  scheduleTimer(e, n, o) {
    const r = Date.now(), i = !ro.expandedOrOutOfFocus(this.state), s = i ? xn.create() : void 0;
    s?.start(n, () => {
      this.timers.delete(e), o();
    }), this.timers.set(e, {
      timeout: s,
      start: i ? r : 0,
      delay: n,
      remaining: n,
      callback: o
    });
  }
  setToasts(e) {
    const n = {
      toasts: e
    };
    e.length === 0 && (n.hovering = !1, n.focused = !1), this.update(n);
  }
  handleFocusManagement(e) {
    const n = Ut(Je(this.state.viewport));
    if (!this.state.viewport || !Fe(this.state.viewport, n) || !_l(n))
      return;
    if (e === void 0) {
      this.restoreFocusToPrevElement();
      return;
    }
    const o = ro.toasts(this.state), r = ro.toastIndex(this.state, e);
    let i = null, s = r + 1;
    for (; s < o.length; ) {
      if (o[s].transitionStatus !== "ending") {
        i = o[s];
        break;
      }
      s += 1;
    }
    if (!i)
      for (s = r - 1; s >= 0; ) {
        if (o[s].transitionStatus !== "ending") {
          i = o[s];
          break;
        }
        s -= 1;
      }
    i ? i.ref?.current?.focus() : this.restoreFocusToPrevElement();
  }
}
const g1 = function(e) {
  const {
    children: n,
    timeout: o = 5e3,
    limit: r = 3,
    toastManager: i
  } = e, s = It(() => new TT({
    timeout: o,
    limit: r,
    viewport: null,
    toasts: [],
    hovering: !1,
    focused: !1,
    isWindowFocused: !0,
    prevFocusElement: null
  })).current;
  return Qr(s.disposeEffect), x.useEffect(function() {
    return i ? i[" subscribe"](({
      action: c,
      options: u
    }) => {
      const d = u.id;
      c === "promise" && u.promise ? s.promiseToast(u.promise, u) : c === "update" && d ? s.updateToast(d, u) : c === "close" ? s.closeToast(d) : s.addToast(u);
    }) : void 0;
  }, [s, o, i]), s.useSyncedValues({
    timeout: o,
    limit: r
  }), /* @__PURE__ */ g(Ta.Provider, {
    value: s,
    children: n
  });
};
process.env.NODE_ENV !== "production" && (g1.displayName = "ToastProvider");
let OT = /* @__PURE__ */ (function(t) {
  return t.frontmostHeight = "--toast-frontmost-height", t;
})({});
const R4 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    children: s,
    ...l
  } = e, a = m1(), c = Dt(), u = x.useRef(!1), d = x.useRef(!1), f = x.useRef(!1), p = a.useState("isEmpty"), m = a.useState("toasts"), h = a.useState("focused"), b = a.useState("expanded"), v = a.useState("prevFocusElement"), C = m[0]?.height ?? 0, y = x.useMemo(() => m.some((V) => V.transitionStatus === "ending"), [m]);
  x.useEffect(() => {
    const V = a.state.viewport;
    if (!V)
      return;
    function A($) {
      p || $.key === "F6" && bt($) !== V && ($.preventDefault(), a.setPrevFocusElement(Ut(Je(V))), V?.focus({
        preventScroll: !0
      }), a.pauseTimers(), a.setFocused(!0));
    }
    const L = Ct(V);
    return at(L, "keydown", A);
  }, [a, p]), x.useEffect(() => {
    const V = a.state.viewport;
    if (!V || p)
      return;
    const A = Ct(V);
    function L(Y) {
      bt(Y) === A && (a.setIsWindowFocused(!1), a.pauseTimers());
    }
    function $(Y) {
      if (Y.relatedTarget)
        return;
      const G = bt(Y), j = Ut(Je(V));
      (G === A || !Fe(V, G) || !_l(j)) && a.resumeTimers(), c.start(0, () => a.setIsWindowFocused(!0));
    }
    return Yn(at(A, "blur", L, !0), at(A, "focus", $, !0));
  }, [
    a,
    c,
    // `store.state.viewport` isn't available on the first render,
    // since the portal node hasn't yet been created.
    // By adding this dependency, we ensure the window listeners
    // are added when toasts have been created, once the ref is available.
    p
  ]), x.useEffect(() => {
    const V = a.state.viewport;
    if (!V || p)
      return;
    const A = Je(V);
    return at(A, "pointerdown", a.handleDocumentPointerDown, !0);
  }, [p, a]);
  function w(V) {
    const A = a.state.viewport;
    A && (u.current = !0, V.relatedTarget === A ? m[0]?.ref?.current?.focus() : a.restoreFocusToPrevElement());
  }
  function R(V) {
    V.key === "Tab" && V.shiftKey && bt(V.nativeEvent) === a.state.viewport && (V.preventDefault(), a.restoreFocusToPrevElement(), a.resumeTimers());
  }
  function S() {
    const V = a.state.toasts.some((A) => A.transitionStatus === "ending");
    !a.state.isWindowFocused || V || f.current || !d.current || (a.resumeTimers(), a.setHovering(!1), d.current = !1);
  }
  x.useEffect(S, [y, a]);
  function E() {
    a.pauseTimers(), a.setHovering(!0), d.current = !1;
  }
  function N() {
    y || f.current ? d.current = !0 : (a.resumeTimers(), a.setHovering(!1));
  }
  function I(V) {
    V.pointerType === "touch" && (f.current = !0);
  }
  function T(V) {
    V.pointerType === "touch" && (f.current = !1, S());
  }
  function k() {
    if (u.current) {
      u.current = !1;
      return;
    }
    h || _l(Ut(Je(a.state.viewport))) && (a.setFocused(!0), a.pauseTimers());
  }
  function P(V) {
    !h || Fe(a.state.viewport, V.relatedTarget) || (a.setFocused(!1), a.resumeTimers());
  }
  const M = {
    tabIndex: -1,
    role: "region",
    "aria-live": "polite",
    "aria-atomic": !1,
    "aria-relevant": "additions text",
    "aria-label": "Notifications",
    onMouseEnter: E,
    onMouseMove: E,
    onMouseLeave: N,
    onFocus: k,
    onBlur: P,
    onKeyDown: R,
    onClick: k,
    onPointerDown: I,
    onPointerUp: T,
    onPointerCancel: T
  }, D = {
    expanded: b
  }, O = Le("div", e, {
    ref: [n, a.setViewport],
    state: D,
    props: [M, {
      style: {
        [OT.frontmostHeight]: C ? `${C}px` : void 0
      }
    }, l, {
      children: /* @__PURE__ */ F(x.Fragment, {
        children: [!p && v && /* @__PURE__ */ g(Vn, {
          onFocus: w
        }), s, !p && v && /* @__PURE__ */ g(Vn, {
          onFocus: w
        })]
      })
    }]
  }), _ = x.useMemo(() => m.filter((V) => V.priority === "high"), [m]);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [!p && v && /* @__PURE__ */ g(Vn, {
      onFocus: w
    }), O, !h && _.length > 0 && /* @__PURE__ */ g("div", {
      style: Jo,
      children: _.map((V) => /* @__PURE__ */ F("div", {
        role: "alert",
        "aria-atomic": !0,
        children: [/* @__PURE__ */ g("div", {
          children: V.title
        }), /* @__PURE__ */ g("div", {
          children: V.description
        })]
      }, V.id))
    })]
  });
});
process.env.NODE_ENV !== "production" && (R4.displayName = "ToastViewport");
const h1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (h1.displayName = "ToastRootContext");
function Oa() {
  const t = x.useContext(h1);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToastRootContext is missing. Toast parts must be used within <Toast.Root>." : et(66));
  return t;
}
let sr = /* @__PURE__ */ (function(t) {
  return t.index = "--toast-index", t.offsetY = "--toast-offset-y", t.height = "--toast-height", t.swipeMovementX = "--toast-swipe-movement-x", t.swipeMovementY = "--toast-swipe-movement-y", t;
})({});
const DT = {
  ...zt,
  swipeDirection(t) {
    return t ? {
      "data-swipe-direction": t
    } : null;
  }
}, Pi = 40, _T = 10, $o = 0.5, VT = 1, AT = `${xh},${B8}`;
function ig(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function LT(t) {
  const n = Ct(t).getComputedStyle(t).transform;
  let o = 0, r = 0, i = 1;
  if (n && n !== "none") {
    const s = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (s) {
      const l = s[1].split(", ").map(parseFloat);
      l.length === 6 ? (o = l[4], r = l[5], i = Math.sqrt(l[0] * l[0] + l[1] * l[1])) : l.length === 16 && (o = l[12], r = l[13], i = l[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: i
  };
}
const E4 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    toast: o,
    render: r,
    className: i,
    swipeDirection: s = ["down", "right"],
    style: l,
    ...a
  } = e, c = o.positionerProps?.anchor !== void 0;
  let u = [];
  c || (u = Array.isArray(s) ? s : [s]);
  const d = u.length > 0, f = m1(), [p, m] = x.useState(void 0), [h, b] = x.useState(!1), [v, C] = x.useState(!1), [y, w] = x.useState(!1), [R, S] = x.useState({
    x: 0,
    y: 0
  }), [E, N] = x.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [I, T] = x.useState(), [k, P] = x.useState(), [M, D] = x.useState(null), O = x.useRef(null), _ = x.useRef({
    x: 0,
    y: 0
  }), V = x.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), A = x.useRef(void 0), L = x.useRef(0), $ = x.useRef(!1), Y = x.useRef({
    x: 0,
    y: 0
  }), G = x.useRef(!1), j = f.useState("toastIndex", o.id), Z = f.useState("toastVisibleIndex", o.id), U = f.useState("toastOffsetY", o.id), q = f.useState("focused"), te = f.useState("expanded");
  Yt({
    open: o.transitionStatus !== "ending",
    ref: O,
    onComplete() {
      o.transitionStatus === "ending" && f.removeToast(o.id);
    }
  });
  const H = Ce((z = !1) => {
    const J = O.current;
    if (!J)
      return;
    const B = J.style.height;
    J.style.height = "auto";
    const K = J.offsetHeight;
    J.style.height = B;
    function ie() {
      f.updateToastInternal(o.id, {
        ref: O,
        height: K,
        ...o.transitionStatus === "starting" ? {
          transitionStatus: void 0
        } : {}
      });
    }
    z ? an.flushSync(ie) : ie();
  });
  Ne(H, [H]);
  function X(z, J) {
    let B = z, K = J;
    return !u.includes("left") && !u.includes("right") ? B = z > 0 ? z ** $o : -(Math.abs(z) ** $o) : (!u.includes("right") && z > 0 && (B = z ** $o), !u.includes("left") && z < 0 && (B = -(Math.abs(z) ** $o))), !u.includes("up") && !u.includes("down") ? K = J > 0 ? J ** $o : -(Math.abs(J) ** $o) : (!u.includes("down") && J > 0 && (K = J ** $o), !u.includes("up") && J < 0 && (K = -(Math.abs(J) ** $o))), {
      x: B,
      y: K
    };
  }
  function ee(z) {
    if (z.button !== 0)
      return;
    z.pointerType === "touch" && f.pauseTimers();
    const J = bt(z.nativeEvent);
    if (!(J && J.closest(`button,a,input,textarea,[role="button"],${AT}`))) {
      if ($.current = !1, A.current = void 0, L.current = 0, _.current = {
        x: z.clientX,
        y: z.clientY
      }, Y.current = _.current, O.current) {
        const K = LT(O.current);
        V.current = K, N(K), S({
          x: K.x,
          y: K.y
        });
      }
      f.setHovering(!0), b(!0), C(!1), D(null), G.current = !0, O.current?.setPointerCapture(z.pointerId);
    }
  }
  function le(z) {
    if (!h)
      return;
    z.preventDefault(), G.current && (_.current = {
      x: z.clientX,
      y: z.clientY
    }, G.current = !1);
    const {
      clientY: J,
      clientX: B,
      movementX: K,
      movementY: ie
    } = z;
    (ie < 0 && J > Y.current.y || ie > 0 && J < Y.current.y) && (Y.current = {
      x: Y.current.x,
      y: J
    }), (K < 0 && B > Y.current.x || K > 0 && B < Y.current.x) && (Y.current = {
      x: B,
      y: Y.current.y
    });
    const ge = B - _.current.x, ue = J - _.current.y, Se = J - Y.current.y, ve = B - Y.current.x;
    if (!v && Math.sqrt(ge * ge + ue * ue) >= VT && (C(!0), M === null)) {
      const _e = u.includes("left") || u.includes("right"), Ye = u.includes("up") || u.includes("down");
      if (_e && Ye) {
        const qe = Math.abs(ge), $e = Math.abs(ue);
        D(qe > $e ? "horizontal" : "vertical");
      }
    }
    let de;
    if (!A.current)
      M === "vertical" ? ue > 0 ? de = "down" : ue < 0 && (de = "up") : M === "horizontal" ? ge > 0 ? de = "right" : ge < 0 && (de = "left") : Math.abs(ge) >= Math.abs(ue) ? de = ge > 0 ? "right" : "left" : de = ue > 0 ? "down" : "up", de && u.includes(de) && (A.current = de, L.current = ig(de, ge, ue), m(de));
    else {
      const Pe = A.current, _e = ig(Pe, ve, Se);
      _e > Pi ? ($.current = !1, m(Pe)) : !(u.includes("left") && u.includes("right")) && !(u.includes("up") && u.includes("down")) && L.current - _e >= _T && ($.current = !0);
    }
    const me = X(ge, ue);
    let Re = V.current.x, Ie = V.current.y;
    M === "horizontal" ? (u.includes("left") || u.includes("right")) && (Re += me.x) : (M === "vertical" || (u.includes("left") || u.includes("right")) && (Re += me.x), (u.includes("up") || u.includes("down")) && (Ie += me.y)), S({
      x: Re,
      y: Ie
    });
  }
  function Q(z) {
    if (!h)
      return;
    if (b(!1), C(!1), D(null), O.current?.releasePointerCapture(z.pointerId), $.current) {
      S({
        x: E.x,
        y: E.y
      }), m(void 0);
      return;
    }
    let J = !1;
    const B = R.x - E.x, K = R.y - E.y;
    let ie;
    for (const ge of u) {
      switch (ge) {
        case "right":
          B > Pi && (J = !0, ie = "right");
          break;
        case "left":
          B < -Pi && (J = !0, ie = "left");
          break;
        case "down":
          K > Pi && (J = !0, ie = "down");
          break;
        case "up":
          K < -Pi && (J = !0, ie = "up");
          break;
      }
      if (J)
        break;
    }
    J ? (m(ie), w(!0), f.closeToast(o.id)) : (S({
      x: E.x,
      y: E.y
    }), m(void 0));
  }
  function re() {
    h && (b(!1), C(!1), D(null), S({
      x: E.x,
      y: E.y
    }), m(void 0));
  }
  function fe(z) {
    if (z.key === "Escape") {
      if (!O.current || !Fe(O.current, Ut(Je(O.current))))
        return;
      f.closeToast(o.id);
    }
  }
  x.useEffect(() => {
    if (!d)
      return;
    const z = O.current;
    if (!z)
      return;
    function J(B) {
      Fe(z, bt(B)) && B.preventDefault();
    }
    return at(z, "touchmove", J, {
      passive: !1
    });
  }, [d]);
  function ne() {
    if (!h && R.x === E.x && R.y === E.y && !y)
      return {
        [sr.swipeMovementX]: "0px",
        [sr.swipeMovementY]: "0px"
      };
    const z = R.x - E.x, J = R.y - E.y;
    return {
      transition: h ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: h ? `translateX(${R.x}px) translateY(${R.y}px) scale(${E.scale})` : void 0,
      [sr.swipeMovementX]: `${z}px`,
      [sr.swipeMovementY]: `${J}px`
    };
  }
  const se = o.priority === "high", pe = {
    role: se ? "alertdialog" : "dialog",
    tabIndex: 0,
    "aria-modal": !1,
    "aria-labelledby": I,
    "aria-describedby": k,
    "aria-hidden": se && !q ? !0 : void 0,
    onPointerDown: d ? ee : void 0,
    onPointerMove: d ? le : void 0,
    onPointerUp: d ? Q : void 0,
    onPointerCancel: d ? re : void 0,
    onKeyDown: fe,
    inert: Er(o.limited),
    style: {
      ...ne(),
      [sr.index]: o.transitionStatus === "ending" ? j : Z,
      [sr.offsetY]: `${U}px`,
      [sr.height]: o.height ? `${o.height}px` : void 0
    }
  }, xe = x.useMemo(() => ({
    rootRef: O,
    toast: o,
    titleId: I,
    setTitleId: T,
    descriptionId: k,
    setDescriptionId: P,
    swiping: h,
    swipeDirection: p,
    recalculateHeight: H,
    index: j,
    visibleIndex: Z,
    expanded: te
  }), [o, I, k, h, p, H, j, Z, te]), ce = {
    transitionStatus: o.transitionStatus,
    expanded: te,
    limited: o.limited || !1,
    type: o.type,
    swiping: xe.swiping,
    swipeDirection: xe.swipeDirection
  }, he = Le("div", e, {
    ref: [n, xe.rootRef],
    state: ce,
    stateAttributesMapping: DT,
    props: [pe, a]
  });
  return /* @__PURE__ */ g(h1.Provider, {
    value: xe,
    children: he
  });
});
process.env.NODE_ENV !== "production" && (E4.displayName = "ToastRoot");
const N4 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    visibleIndex: l,
    expanded: a,
    recalculateHeight: c
  } = Oa(), u = x.useRef(null);
  Ne(() => {
    const m = u.current;
    if (!m || (c(), typeof ResizeObserver != "function" || typeof MutationObserver != "function"))
      return;
    const h = new ResizeObserver(() => c(!0)), b = new MutationObserver(() => c(!0));
    return h.observe(m), b.observe(m, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      h.disconnect(), b.disconnect();
    };
  }, [c]);
  const d = l > 0;
  return Le("div", e, {
    ref: [n, u],
    state: {
      expanded: a,
      behind: d
    },
    props: s
  });
});
process.env.NODE_ENV !== "production" && (N4.displayName = "ToastContent");
const k4 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    children: l,
    ...a
  } = e, {
    toast: c,
    setDescriptionId: u
  } = Oa(), d = l ?? c.description, f = !!d, p = Do(s);
  Ne(() => {
    if (f)
      return u(p), () => {
        u(void 0);
      };
  }, [f, p, u]);
  const m = {
    type: c.type
  }, h = Le("p", e, {
    ref: n,
    state: m,
    props: {
      ...a,
      id: p,
      children: d
    }
  });
  return f ? h : null;
});
process.env.NODE_ENV !== "production" && (k4.displayName = "ToastDescription");
const yu = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    disabled: s,
    nativeButton: l = !0,
    ...a
  } = e, c = m1(), {
    toast: u
  } = Oa(), d = c.useState("expanded"), [f, p] = x.useState(!1), {
    getButtonProps: m,
    buttonRef: h
  } = Bt({
    disabled: s,
    native: l
  }), b = {
    type: u.type
  };
  return Le("button", e, {
    ref: [n, h],
    state: b,
    props: [{
      "aria-hidden": !d && !f,
      onClick() {
        c.closeToast(u.id);
      },
      onFocus() {
        p(!0);
      },
      onBlur() {
        p(!1);
      }
    }, a, m]
  });
});
process.env.NODE_ENV !== "production" && (yu.displayName = "ToastClose");
const xu = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    disabled: s,
    nativeButton: l = !0,
    ...a
  } = e, {
    toast: c
  } = Oa(), u = c.actionProps?.children ?? a.children, d = !!u, {
    getButtonProps: f,
    buttonRef: p
  } = Bt({
    disabled: s,
    native: l
  }), m = {
    type: c.type
  }, h = Le("button", e, {
    ref: [n, p],
    state: m,
    props: [a, c.actionProps, f, {
      children: u
    }]
  });
  return d ? h : null;
});
process.env.NODE_ENV !== "production" && (xu.displayName = "ToastAction");
const FT = ma;
function $T() {
  const t = x.useContext(Ta);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : et(73));
  const e = t.useState("toasts");
  return x.useMemo(() => ({
    toasts: e,
    add: t.addToast,
    close: t.closeToast,
    update: t.updateToast,
    promise: t.promiseToast
  }), [e, t]);
}
function HT() {
  const t = /* @__PURE__ */ new Set();
  function e(n) {
    t.forEach((o) => o(n));
  }
  return {
    // This should be private aside from ToastProvider needing to access it.
    // https://x.com/drosenwasser/status/1816947740032872664
    " subscribe": function(o) {
      return t.add(o), () => {
        t.delete(o);
      };
    },
    add(n) {
      const o = n.id || S4("toast"), r = {
        ...n,
        id: o,
        transitionStatus: "starting"
      };
      return e({
        action: "add",
        options: r
      }), o;
    },
    close(n) {
      e({
        action: "close",
        options: {
          id: n
        }
      });
    },
    update(n, o) {
      e({
        action: "update",
        options: {
          ...o,
          id: n
        }
      });
    },
    promise(n, o) {
      let r = n;
      return e({
        action: "promise",
        options: {
          ...o,
          promise: n,
          setPromise(i) {
            r = i;
          }
        }
      }), r;
    }
  };
}
const zT = ae(["rounded-(--radius-sm)", "outline-none", "transition-[opacity,transform,height]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "shadow-elevation-3", "[&[data-starting-style]]:translate-y-2", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:translate-y-2", "[&[data-ending-style]]:opacity-0", "[&[data-limited]]:pointer-events-none", "[&[data-limited]]:opacity-0"], {
  variants: {
    variant: {
      default: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      error: ["bg-error", "text-error-on-error"]
    },
    placement: {
      static: ["relative", "w-full", "max-w-[344px]"],
      viewport: ["w-full"]
    }
  },
  defaultVariants: {
    variant: "default",
    placement: "static"
  }
}), BT = ae(["flex", "min-h-[48px]", "w-full", "items-center", "pl-(--spacing-10)"], {
  variants: {
    hasClose: {
      true: "pr-(--spacing-4)",
      false: "pr-(--spacing-8)"
    },
    layout: {
      inline: "gap-(--spacing-10)",
      "inline-action": "gap-(--spacing-4)",
      stacked: "items-start gap-(--spacing-10)"
    }
  },
  defaultVariants: {
    hasClose: !1,
    layout: "inline"
  }
}), WT = ae(["m-0", "min-w-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-current", "overflow-hidden", "[display:-webkit-box]", "[-webkit-box-orient:vertical]", "[-webkit-line-clamp:2]"]), UT = ae("min-w-0 flex-1 py-(--spacing-10)", {
  variants: {
    layout: {
      inline: "block",
      "inline-action": "block",
      stacked: "flex flex-col items-stretch gap-(--spacing-4)"
    }
  },
  defaultVariants: {
    layout: "inline"
  }
}), GT = ae("shrink-0 py-(--spacing-10)", {
  variants: {
    variant: {
      default: "text-primary-inverse-primary",
      error: "text-error-on-error"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), YT = ae(["inline-flex", "h-(--spacing-40)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "whitespace-nowrap", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-12)", "py-0", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-large)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-primary-inverse-primary", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), jT = ae(["inline-flex", "size-[48px]", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-surface-inverse-on-surface", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), KT = oe("fixed", "[left:0]", "[right:0]", "mx-auto", "bottom-(--spacing-24)", "z-[var(--z-toast,400)]", "h-(--toast-frontmost-height)", "w-[min(344px,calc(100vw_-_var(--spacing-32)))]"), qT = 10;
function sg({
  children: t,
  variant: e,
  disabled: n = !1,
  ...o
}) {
  return /* @__PURE__ */ g(Xn, { className: oe(YT({
    variant: e
  })), disabled: n, "aria-disabled": n || void 0, tabIndex: n ? -1 : void 0, ...o, children: t });
}
function lg({
  variant: t,
  disabled: e = !1,
  "aria-label": n = "Dismiss notification",
  ...o
}) {
  return /* @__PURE__ */ g(Xn, { className: oe(jT({
    variant: t
  })), disabled: e, "aria-disabled": e || void 0, "aria-label": n, tabIndex: e ? -1 : void 0, ...o, children: /* @__PURE__ */ g(Ge, { name: "x-close", size: "sm", tone: "inherit" }) });
}
const M4 = HT();
function ZT(t) {
  return t === "error" ? "error" : "default";
}
const XT = {
  add(t, e = {}) {
    const {
      variant: n = "default",
      action: o,
      icon: r = !1,
      onDismiss: i,
      timeout: s
    } = e;
    return M4.add({
      description: t,
      type: n,
      priority: n === "error" ? "high" : "low",
      ...s !== void 0 && {
        timeout: s
      },
      data: {
        action: o,
        icon: r,
        onDismiss: i
      }
    });
  },
  error(t, e = {}) {
    return XT.add(t, {
      ...e,
      variant: "error"
    });
  }
};
function P4(t) {
  const e = W.c(73);
  let n, o, r, i;
  e[0] !== t ? ({
    toast: i,
    onActionComplete: n,
    placement: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "static" : r;
  let l, a, c, u, d, f, p, m, h, b, v, C, y, w, R, S, E;
  if (e[5] !== n || e[6] !== s || e[7] !== o || e[8] !== i) {
    E = ZT(i.type), c = i.data?.action;
    const _ = i.data?.icon ?? !1, V = !!i.data?.onDismiss;
    f = c && c.label.length >= qT ? "stacked" : c ? "inline-action" : "inline", p = f === "stacked" && V, m = V && !p;
    let A;
    e[26] !== c || e[27] !== n ? (A = function() {
      c?.onClick(), n?.();
    }, e[26] = c, e[27] = n, e[28] = A) : A = e[28], u = A;
    let L;
    e[29] !== i.data ? (L = function() {
      i.data?.onDismiss?.();
    }, e[29] = i.data, e[30] = L) : L = e[30], d = L, a = E4, v = i, e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = ["down", "right"], e[31] = C) : C = e[31], y = E === "error" ? "alert" : "status", w = E === "error" ? "assertive" : "polite", R = oe(zT({
      variant: E,
      placement: s
    })), S = o, l = N4, e[32] !== f || e[33] !== V ? (h = oe(BT({
      hasClose: V,
      layout: f
    })), e[32] = f, e[33] = V, e[34] = h) : h = e[34], b = _ && /* @__PURE__ */ g("span", { "data-slot": "toast-leading-icon", className: oe(GT({
      variant: E
    })), children: /* @__PURE__ */ g(Ge, { name: E === "error" ? "circle-exclamation" : "circle-check-regular", size: "md", tone: "inherit" }) }), e[5] = n, e[6] = s, e[7] = o, e[8] = i, e[9] = l, e[10] = a, e[11] = c, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = m, e[17] = h, e[18] = b, e[19] = v, e[20] = C, e[21] = y, e[22] = w, e[23] = R, e[24] = S, e[25] = E;
  } else
    l = e[9], a = e[10], c = e[11], u = e[12], d = e[13], f = e[14], p = e[15], m = e[16], h = e[17], b = e[18], v = e[19], C = e[20], y = e[21], w = e[22], R = e[23], S = e[24], E = e[25];
  let N;
  e[35] !== f ? (N = oe(UT({
    layout: f
  })), e[35] = f, e[36] = N) : N = e[36];
  let I;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (I = /* @__PURE__ */ g(k4, { className: oe(WT()) }), e[37] = I) : I = e[37];
  let T;
  e[38] !== c || e[39] !== u || e[40] !== d || e[41] !== f || e[42] !== p || e[43] !== E ? (T = c && f === "stacked" && /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-end", children: [
    /* @__PURE__ */ g(xu, { render: /* @__PURE__ */ g(sg, { variant: E, onClick: u }), children: c.label }),
    p && /* @__PURE__ */ g(yu, { render: /* @__PURE__ */ g(lg, { variant: E, "aria-hidden": void 0, onClick: d }) })
  ] }), e[38] = c, e[39] = u, e[40] = d, e[41] = f, e[42] = p, e[43] = E, e[44] = T) : T = e[44];
  let k;
  e[45] !== N || e[46] !== T ? (k = /* @__PURE__ */ F("div", { className: N, children: [
    I,
    T
  ] }), e[45] = N, e[46] = T, e[47] = k) : k = e[47];
  let P;
  e[48] !== c || e[49] !== u || e[50] !== f || e[51] !== E ? (P = c && f === "inline-action" && /* @__PURE__ */ g(xu, { render: /* @__PURE__ */ g(sg, { variant: E, onClick: u }), children: c.label }), e[48] = c, e[49] = u, e[50] = f, e[51] = E, e[52] = P) : P = e[52];
  let M;
  e[53] !== d || e[54] !== m || e[55] !== E ? (M = m && /* @__PURE__ */ g(yu, { render: /* @__PURE__ */ g(lg, { variant: E, "aria-hidden": void 0, onClick: d }) }), e[53] = d, e[54] = m, e[55] = E, e[56] = M) : M = e[56];
  let D;
  e[57] !== l || e[58] !== k || e[59] !== P || e[60] !== M || e[61] !== h || e[62] !== b ? (D = /* @__PURE__ */ F(l, { className: h, children: [
    b,
    k,
    P,
    M
  ] }), e[57] = l, e[58] = k, e[59] = P, e[60] = M, e[61] = h, e[62] = b, e[63] = D) : D = e[63];
  let O;
  return e[64] !== a || e[65] !== D || e[66] !== v || e[67] !== C || e[68] !== y || e[69] !== w || e[70] !== R || e[71] !== S ? (O = /* @__PURE__ */ g(a, { toast: v, swipeDirection: C, role: y, "aria-live": w, className: R, ...S, children: D }), e[64] = a, e[65] = D, e[66] = v, e[67] = C, e[68] = y, e[69] = w, e[70] = R, e[71] = S, e[72] = O) : O = e[72], O;
}
function $D(t) {
  const e = W.c(20);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    variant: l,
    description: o,
    action: n,
    icon: r,
    onDismiss: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = Xt(), c = l ?? "default", u = l === "error" ? "high" : "low";
  let d;
  e[7] !== n || e[8] !== r || e[9] !== i ? (d = {
    action: n,
    icon: r,
    onDismiss: i
  }, e[7] = n, e[8] = r, e[9] = i, e[10] = d) : d = e[10];
  let f;
  e[11] !== o || e[12] !== a || e[13] !== c || e[14] !== u || e[15] !== d ? (f = {
    id: a,
    description: o,
    type: c,
    priority: u,
    data: d
  }, e[11] = o, e[12] = a, e[13] = c, e[14] = u, e[15] = d, e[16] = f) : f = e[16];
  let p;
  return e[17] !== s || e[18] !== f ? (p = /* @__PURE__ */ g(g1, { timeout: 0, limit: 1, children: /* @__PURE__ */ g(P4, { toast: f, ...s }) }), e[17] = s, e[18] = f, e[19] = p) : p = e[19], p;
}
function QT() {
  const t = W.c(7), e = $T(), n = Qt();
  let o;
  t[0] !== e ? (o = e.toasts.map((s) => /* @__PURE__ */ g(P4, { onActionComplete: () => e.close(s.id), toast: s, placement: "viewport" }, s.id)), t[0] = e, t[1] = o) : o = t[1];
  let r;
  t[2] !== o ? (r = /* @__PURE__ */ g(R4, { className: KT, children: o }), t[2] = o, t[3] = r) : r = t[3];
  let i;
  return t[4] !== n || t[5] !== r ? (i = /* @__PURE__ */ g(FT, { container: n, children: r }), t[4] = n, t[5] = r, t[6] = i) : i = t[6], i;
}
const I4 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (I4.displayName = "ToggleGroupContext");
function JT(t = !0) {
  const e = x.useContext(I4);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToggleGroupContext is missing. ToggleGroup parts must be placed within <ToggleGroup>." : et(7));
  return e;
}
const T4 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    defaultPressed: r = !1,
    disabled: i = !1,
    form: s,
    // never participates in form validation
    onPressedChange: l,
    pressed: a,
    render: c,
    type: u,
    // cannot change button type
    value: d,
    nativeButton: f = !0,
    style: p,
    ...m
  } = e, h = kt(d || void 0), b = JT(), v = b?.value ?? [], C = b ? void 0 : r, y = (i || b?.disabled) ?? !1;
  process.env.NODE_ENV !== "production" && Ne(() => {
    b && d === void 0 && b.isValueInitialized && jo("A `<Toggle>` component rendered in a `<ToggleGroup>` has no explicit `value` prop.", "This will cause issues between the Toggle Group and Toggle values.", "Provide the `<Toggle>` with a `value` prop matching the `<ToggleGroup>` values prop type.");
  }, [b, d, b?.isValueInitialized]);
  const [w, R] = dn({
    controlled: b ? h !== void 0 && v.indexOf(h) > -1 : a,
    default: C,
    name: "Toggle",
    state: "pressed"
  }), S = Ce((M, D) => {
    h && b?.setGroupValue?.(h, M, D), l?.(M, D);
  }), {
    getButtonProps: E,
    buttonRef: N
  } = Bt({
    disabled: y,
    native: f
  }), I = {
    disabled: y,
    pressed: w
  }, T = [N, n], k = [{
    "aria-pressed": w,
    onClick(M) {
      const D = !w, O = De(Pt, M.nativeEvent);
      S(D, O), !O.isCanceled && R(D);
    }
  }, m, E], P = Le("button", e, {
    enabled: !b,
    state: I,
    ref: T,
    props: k
  });
  return b ? /* @__PURE__ */ g(Ed, {
    tag: "button",
    render: c,
    className: o,
    style: p,
    state: I,
    refs: T,
    props: k
  }) : P;
});
process.env.NODE_ENV !== "production" && (T4.displayName = "Toggle");
const eO = ae(["inline-flex", "items-center", "justify-center", "overflow-hidden", "whitespace-nowrap", "shrink-0", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"], {
  variants: {
    variant: {
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[pressed]:border-2", "data-[pressed]:border-primary", "data-[pressed]:text-primary"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "data-[pressed]:text-primary"]
    }
  },
  defaultVariants: {
    variant: "outline"
  }
});
function HD(t) {
  const e = W.c(23);
  let n, o, r, i, s;
  e[0] !== t ? ({
    icon: n,
    label: o,
    variant: i,
    disabled: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "outline" : i, a = s === void 0 ? !1 : s;
  let c;
  e[6] !== a || e[7] !== o || e[8] !== l ? (c = oe(eO({
    variant: l
  }), o ? "h-(--spacing-32) px-(--spacing-12)" : "size-(--spacing-32)", a && "opacity-40 pointer-events-none cursor-not-allowed"), e[6] = a, e[7] = o, e[8] = l, e[9] = c) : c = e[9];
  const u = a || void 0, d = a ? -1 : void 0;
  let f;
  e[10] !== o ? (f = o && /* @__PURE__ */ g("span", { className: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap", children: o }), e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== n ? (p = /* @__PURE__ */ g(Ge, { name: n, size: "xs", tone: "inherit" }), e[12] = n, e[13] = p) : p = e[13];
  let m;
  return e[14] !== a || e[15] !== r || e[16] !== c || e[17] !== u || e[18] !== d || e[19] !== f || e[20] !== p || e[21] !== l ? (m = /* @__PURE__ */ F(T4, { "data-slot": "toggle", "data-variant": l, className: c, disabled: a, "aria-disabled": u, tabIndex: d, ...r, children: [
    f,
    p
  ] }), e[14] = a, e[15] = r, e[16] = c, e[17] = u, e[18] = d, e[19] = f, e[20] = p, e[21] = l, e[22] = m) : m = e[22], m;
}
const tO = {
  photo: {
    icon: "image-regular",
    accept: "image/png,image/jpeg",
    acceptedFormatsLabel: "PNG, JPG",
    buttonLabel: "Select Image"
  },
  file: {
    icon: "upload",
    accept: "application/pdf,text/plain",
    acceptedFormatsLabel: "PDF, TXT",
    buttonLabel: "Select File"
  }
};
function zD(t) {
  const e = W.c(45);
  let n, o, r, i, s, l, a, c, u, d, f;
  e[0] !== t ? ({
    variant: c,
    accept: n,
    acceptedFormatsLabel: o,
    maxSizeLabel: u,
    multiple: d,
    disabled: f,
    buttonLabel: r,
    guidanceLabel: s,
    onFilesSelected: l,
    className: i,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11]);
  const p = c === void 0 ? "photo" : c, m = u === void 0 ? "5 MB" : u, h = d === void 0 ? !1 : d, b = f === void 0 ? !1 : f, v = Xt(), C = Xt(), y = ut(null), w = tO[p], R = o ?? w.acceptedFormatsLabel, S = r ?? w.buttonLabel, E = n ?? w.accept, N = s ?? `Upload ${R} up to ${m}`;
  let I;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (I = function() {
    y.current?.click();
  }, e[12] = I) : I = e[12];
  const T = I;
  let k;
  e[13] !== l ? (k = function(Z) {
    const U = Array.from(Z.currentTarget.files ?? []);
    U.length > 0 && l?.(U), Z.currentTarget.value = "";
  }, e[13] = l, e[14] = k) : k = e[14];
  const P = k, M = b || void 0, D = b && "opacity-50";
  let O;
  e[15] !== i || e[16] !== D ? (O = oe("flex", "w-[480px]", "max-w-full", "relative", "flex-col", "items-center", "justify-center", "gap-(--spacing-24)", "rounded-(--radius-sm)", "bg-surface-container-lowest", "px-(--spacing-16)", "py-(--spacing-24)", D, i), e[15] = i, e[16] = D, e[17] = O) : O = e[17];
  let _;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ g(nO, {}), e[18] = _) : _ = e[18];
  let V;
  e[19] !== w.icon ? (V = /* @__PURE__ */ g("span", { "data-slot": "upload-icon", className: "text-text-subtext", children: /* @__PURE__ */ g(Ge, { name: w.icon, size: "lg", tone: "inherit", "aria-hidden": !0 }) }), e[19] = w.icon, e[20] = V) : V = e[20];
  let A;
  e[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (A = oe("m-0", "text-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"), e[21] = A) : A = e[21];
  let L;
  e[22] !== C || e[23] !== N ? (L = /* @__PURE__ */ g("p", { id: C, className: A, children: N }), e[22] = C, e[23] = N, e[24] = L) : L = e[24];
  let $;
  e[25] !== b || e[26] !== C || e[27] !== S ? ($ = /* @__PURE__ */ g(An, { variant: "outline", size: "md", disabled: b, onClick: T, type: "button", "aria-describedby": C, children: S }), e[25] = b, e[26] = C, e[27] = S, e[28] = $) : $ = e[28];
  let Y;
  e[29] !== b || e[30] !== P || e[31] !== v || e[32] !== h || e[33] !== E || e[34] !== S ? (Y = /* @__PURE__ */ g("input", { ref: y, id: v, className: "sr-only", type: "file", accept: E, multiple: h, disabled: b, tabIndex: -1, "aria-label": S, onChange: P }), e[29] = b, e[30] = P, e[31] = v, e[32] = h, e[33] = E, e[34] = S, e[35] = Y) : Y = e[35];
  let G;
  return e[36] !== a || e[37] !== V || e[38] !== L || e[39] !== $ || e[40] !== Y || e[41] !== M || e[42] !== O || e[43] !== p ? (G = /* @__PURE__ */ F("div", { "data-slot": "upload", "data-variant": p, "data-disabled": M, className: O, ...a, children: [
    _,
    V,
    L,
    $,
    Y
  ] }), e[36] = a, e[37] = V, e[38] = L, e[39] = $, e[40] = Y, e[41] = M, e[42] = O, e[43] = p, e[44] = G) : G = e[44], G;
}
function nO() {
  const t = W.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ g("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", preserveAspectRatio: "none", viewBox: "0 0 480 188", children: /* @__PURE__ */ g("rect", { className: "stroke-outline-subtle", x: "0.5", y: "0.5", width: "479", height: "187", rx: "4", strokeDasharray: "8 6", strokeLinecap: "butt", strokeWidth: "1", vectorEffect: "non-scaling-stroke" }) }), t[0] = e) : e = t[0], e;
}
function BD(t) {
  const e = W.c(13), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t, [i, s] = tt(null), [l, a] = tt(null);
  let c;
  e[0] !== l || e[1] !== i ? (c = {
    blockingLayerHost: l,
    portalHost: i
  }, e[0] = l, e[1] = i, e[2] = c) : c = e[2];
  let u, d, f;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ g("div", { "data-slot": "assetwatch-ui-portal-host", ref: s }), d = /* @__PURE__ */ g("div", { "data-slot": "assetwatch-ui-blocking-layer-host", ref: a }), f = /* @__PURE__ */ g(QT, {}), e[3] = u, e[4] = d, e[5] = f) : (u = e[3], d = e[4], f = e[5]);
  let p;
  e[6] !== n || e[7] !== o || e[8] !== r ? (p = /* @__PURE__ */ g(c2, { delay: 300, timeout: 400, children: /* @__PURE__ */ g(g1, { toastManager: M4, timeout: 5e3, limit: 1, children: /* @__PURE__ */ F(AS, { defaultTheme: o, storageKey: r, children: [
    n,
    u,
    d,
    f
  ] }) }) }), e[6] = n, e[7] = o, e[8] = r, e[9] = p) : p = e[9];
  let m;
  return e[10] !== c || e[11] !== p ? (m = /* @__PURE__ */ g(Nd, { value: c, children: p }), e[10] = c, e[11] = p, e[12] = m) : m = e[12], m;
}
export {
  KO as Accordion,
  AO as ActionItemCard,
  wu as AiSparkles,
  nm as Alert,
  B5 as AnchorLink,
  W5 as AnchorNav,
  yO as AppShell,
  xO as AppShellContent,
  CO as AppShellMobileNavigationTrigger,
  dO as AssetAlertChat,
  HO as AssetStatusCard,
  zO as AssetTimeline,
  qv as AssetWatchLogo,
  BD as AssetWatchUiProvider,
  Qy as AssistantChatComposer,
  mO as AssistantChatFeedback,
  sc as AssistantChatHeader,
  VO as AssistantChatPanel,
  BC as AssistantChatSidebar,
  _O as AssistantChatTemplatePicker,
  Ur as Avatar,
  lu as Badge,
  qO as Banner,
  gO as BlockingActionOverlay,
  ZO as Breadcrumb,
  JS as BreadcrumbItem,
  eR as BreadcrumbLink,
  XO as BreadcrumbList,
  QO as BreadcrumbPage,
  B0 as BreadcrumbSeparator,
  An as Button,
  aO as Caption,
  Zr as Card,
  KC as CardBorderFill,
  JO as CardContainer,
  DO as CardGroup,
  OO as CardImageSlot,
  eD as Carousel,
  tD as ChatActionButton,
  Zc as ChatBubble,
  nD as ChatCopyButton,
  Kc as ChatMessage,
  Tg as ChatMessageAvatar,
  qc as ChatMessageContent,
  P1 as ChatMessageFooter,
  Lv as ChatMessageGroup,
  Og as ChatMessageHeader,
  Rp as ChatPanel,
  kp as ChatPanelBody,
  yy as ChatPanelFooter,
  fO as ChatPanelHeader,
  Np as ChatPanelMain,
  vy as ChatPanelSidebar,
  Ep as ChatPanelSidebarHeader,
  Dg as ChatScroller,
  Vg as ChatScrollerContent,
  bl as ChatScrollerItem,
  Ag as ChatScrollerJumpToLatest,
  _g as ChatScrollerViewport,
  Fv as ChatStatus,
  Vy as ChatTextarea,
  MR as Checkbox,
  fo as Chip,
  wD as CircularProgress,
  UO as CompanyNavigation,
  bO as Container,
  YO as DEFAULT_PROFILE_MENU_LABELS,
  OD as DataTable,
  oD as DatePicker,
  aD as DateRangeFilter,
  rD as Dialog,
  cO as Display,
  mr as Divider,
  wC as Drawer,
  RO as DrawerBody,
  SC as DrawerClose,
  RC as DrawerContent,
  EO as DrawerFooter,
  SO as DrawerHeader,
  wO as DrawerTrigger,
  iD as EmptyState,
  GO as FacilityNavigation,
  sD as FilterPanel,
  fD as Form,
  mD as FormActionColumnHeader,
  IM as FormFooter,
  pD as FormSection,
  hO as FullPageLoading,
  hr as Group,
  uO as Headline,
  Lw as HoverCard,
  $w as HoverCardContent,
  Fw as HoverCardTrigger,
  Ge as Icon,
  gt as IconButton,
  hc as InlineLink,
  ex as Input,
  LO as InsightCard,
  H2 as Kbd,
  uo as Label,
  gD as Lightbox,
  hD as ListCard,
  kd as Menu,
  S7 as MenuButton,
  g7 as MenuCheckboxItem,
  fr as MenuItem,
  kr as MenuPopup,
  Md as MenuRadioGroup,
  Pd as MenuRadioItem,
  su as MenuSubHeader,
  Yo as MenuTrigger,
  FO as MetricCard,
  lm as Modal,
  bD as MultiSelect,
  QM as Pagination,
  vD as Popover,
  xD as PopoverContent,
  yD as PopoverTrigger,
  jO as ProfileMenu,
  CD as Progress,
  Lr as RELEASE_STATUS,
  Oi as RELEASE_STATUS_LABEL,
  RD as Radio,
  SD as RadioGroup,
  WO as ReleaseInfoModal,
  BO as STATUS_DISPLAY,
  ED as SearchInput,
  ND as SearchSpotlight,
  dD as SegmentedFilter,
  _0 as Select,
  uD as SelectedFilters,
  $O as ServiceCard,
  NO as Sidebar,
  kO as SidebarFooter,
  em as SidebarGroup,
  Rl as SidebarItem,
  cu as SidebarToggle,
  lD as SingleFilter,
  MD as Skeleton,
  cD as SortGroupFilter,
  ID as SortableList,
  XP as SortableListHandle,
  PD as SortableListItem,
  Kr as Stack,
  TD as Switch,
  iT as Table,
  lT as TableBody,
  ng as TableCell,
  f1 as TableCellPrimary,
  p1 as TableCellSecondary,
  x4 as TableCellStack,
  mT as TableChipTextCellContent,
  uT as TableHead,
  sT as TableHeader,
  Vc as TableRow,
  fT as TableStartingCellContent,
  pT as TableTextCellContent,
  AD as Tabs,
  VD as TabsContent,
  DD as TabsList,
  _D as TabsTrigger,
  au as Tag,
  ln as Text,
  pO as Textarea,
  b2 as Thumbnail,
  LD as Tile,
  FD as TimePicker,
  Rn as Title,
  $D as Toast,
  HD as Toggle,
  qo as Tooltip,
  qy as TooltipIcon,
  MO as TopBar,
  TO as TopBarActions,
  IO as TopBarContent,
  PO as TopBarLeading,
  a0 as Trend,
  xy as TypingIndicator,
  zD as Upload,
  XT as toast,
  U5 as useAnchorNav,
  vO as useAppShell,
  y2 as useOverflowItems,
  kD as useSearchHotkey,
  i0 as useSidebar,
  LS as useTheme
};
//# sourceMappingURL=index.js.map
